webpackJsonp([0],{

/***/ 10:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return TOGGLE_SIDEBAR_ON; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return TOGGLE_SIDEBAR_OFF; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return TOGGLE_SEARCHBAR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return TOGGLE_HEADER_OVERFLOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return RESET_OVERLAY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return SHOW_LOGIN_MODAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return HIDE_LOGIN_MODAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return SHOW_CONFIRM_MODAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return HIDE_CONFIRM_MODAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return SHOW_GLOBAL_LOADING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return HIDE_GLOBAL_LOADING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return SHOW_REPLY_MODAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return HIDE_REPLY_MODAL; });
/* unused harmony export SHOW_NAME_SUGGEST */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return SHOW_REPLY_MODAL_LOADER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return HIDE_REPLY_MODAL_LOADER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return SHOW_REPLY_MODAL_ATTACHMENT_LOADER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return HIDE_REPLY_MODAL_ATTACHMENT_LOADER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return SHOW_USER_MODAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return HIDE_USER_MODAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return SHOW_SHARE_MODAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return HIDE_SHARE_MODAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return OPEN_IOS_KEYBOARD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CLOSE_IOS_KEYBOARD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return OPEN_ANNOUNCEMENTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CLOSE_ANNOUNCEMENTS; });
/* harmony export (immutable) */ __webpack_exports__["M"] = resetOverlay;
/* harmony export (immutable) */ __webpack_exports__["X"] = toggleHeaderOverflow;
/* harmony export (immutable) */ __webpack_exports__["Y"] = toggleSearchBar;
/* harmony export (immutable) */ __webpack_exports__["W"] = sidebarOn;
/* harmony export (immutable) */ __webpack_exports__["V"] = sidebarOff;
/* harmony export (immutable) */ __webpack_exports__["P"] = showLoginModal;
/* harmony export (immutable) */ __webpack_exports__["E"] = hideLoginModal;
/* harmony export (immutable) */ __webpack_exports__["N"] = showConfirmModal;
/* harmony export (immutable) */ __webpack_exports__["C"] = hideConfirmModal;
/* harmony export (immutable) */ __webpack_exports__["B"] = displayNotification;
/* harmony export (immutable) */ __webpack_exports__["O"] = showGlobalLoading;
/* harmony export (immutable) */ __webpack_exports__["D"] = hideGlobalLoading;
/* harmony export (immutable) */ __webpack_exports__["Q"] = showReplyModal;
/* harmony export (immutable) */ __webpack_exports__["F"] = hideReplyModal;
/* harmony export (immutable) */ __webpack_exports__["S"] = showReplyModalLoader;
/* harmony export (immutable) */ __webpack_exports__["H"] = hideReplyModalLoader;
/* harmony export (immutable) */ __webpack_exports__["R"] = showReplyModalAttachmentLoader;
/* harmony export (immutable) */ __webpack_exports__["G"] = hideReplyModalAttachmentLoader;
/* harmony export (immutable) */ __webpack_exports__["U"] = showUserModal;
/* harmony export (immutable) */ __webpack_exports__["J"] = hideUserModal;
/* harmony export (immutable) */ __webpack_exports__["T"] = showShareModal;
/* harmony export (immutable) */ __webpack_exports__["I"] = hideShareModal;
/* harmony export (immutable) */ __webpack_exports__["L"] = openIOSKeyboard;
/* harmony export (immutable) */ __webpack_exports__["A"] = closeIOSKeyboard;
/* harmony export (immutable) */ __webpack_exports__["K"] = openAnnouncements;
/* harmony export (immutable) */ __webpack_exports__["z"] = closeAnnouncements;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_s_alert__ = __webpack_require__(310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_s_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_s_alert__);
var TOGGLE_SIDEBAR_ON = 'TOGGLE_SIDEBAR_ON';
var TOGGLE_SIDEBAR_OFF = 'TOGGLE_SIDEBAR_OFF';
var TOGGLE_SEARCHBAR = 'TOGGLE_SEARCHBAR';
var TOGGLE_HEADER_OVERFLOW = 'TOGGLE_HEADER_OVERFLOW';
var RESET_OVERLAY = 'RESET_OVERLAY';
var SHOW_LOGIN_MODAL = 'SHOW_LOGIN_MODAL';
var HIDE_LOGIN_MODAL = 'HIDE_LOGIN_MODAL';
var SHOW_CONFIRM_MODAL = 'SHOW_CONFIRM_MODAL';
var HIDE_CONFIRM_MODAL = 'HIDE_CONFIRM_MODAL';
var SHOW_GLOBAL_LOADING = 'SHOW_GLOBAL_LOADING';
var HIDE_GLOBAL_LOADING = 'HIDE_GLOBAL_LOADING';
var SHOW_REPLY_MODAL = 'SHOW_REPLY_MODAL';
var HIDE_REPLY_MODAL = 'HIDE_REPLY_MODAL';
var SHOW_NAME_SUGGEST = 'SHOW_NAME_SUGGEST';
var SHOW_REPLY_MODAL_LOADER = 'SHOW_REPLY_MODAL_LOADER';
var HIDE_REPLY_MODAL_LOADER = 'HIDE_REPLY_MODAL_LOADER';
var SHOW_REPLY_MODAL_ATTACHMENT_LOADER = 'SHOW_REPLY_MODAL_ATTACHMENT_LOADER';
var HIDE_REPLY_MODAL_ATTACHMENT_LOADER = 'HIDE_REPLY_MODAL_ATTACHMENT_LOADER';
var SHOW_USER_MODAL = 'SHOW_USER_MODAL';
var HIDE_USER_MODAL = 'HIDE_USER_MODAL';
var SHOW_SHARE_MODAL = 'SHOW_SHARE_MODAL';
var HIDE_SHARE_MODAL = 'HIDE_SHARE_MODAL';
var OPEN_IOS_KEYBOARD = 'OPEN_IOS_KEYBOARD';
var CLOSE_IOS_KEYBOARD = 'CLOSE_IOS_KEYBOARD';
var OPEN_ANNOUNCEMENTS = 'OPEN_ANNOUNCEMENTS';
var CLOSE_ANNOUNCEMENTS = 'CLOSE_ANNOUNCEMENTS';



function resetOverlay() {
	return {
		type: RESET_OVERLAY
	};
}

function toggleHeaderOverflow() {
	return {
		type: TOGGLE_HEADER_OVERFLOW
	};
}

function toggleSearchBar() {
	return {
		type: TOGGLE_SEARCHBAR
	};
}

function sidebarOn() {
	return {
		type: TOGGLE_SIDEBAR_ON
	};
}

function sidebarOff() {
	return {
		type: TOGGLE_SIDEBAR_OFF
	};
}

function showLoginModal() {
	return {
		type: SHOW_LOGIN_MODAL
	};
}

function hideLoginModal() {
	return {
		type: HIDE_LOGIN_MODAL
	};
}

function showConfirmModal(header, text, action) {
	return {
		type: SHOW_CONFIRM_MODAL,
		header: header,
		text: text,
		action: action
	};
}

function hideConfirmModal() {
	return {
		type: HIDE_CONFIRM_MODAL
	};
}

function displayNotification(type, message) {
	var conf = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

	if (conf.force) {
		__WEBPACK_IMPORTED_MODULE_0_react_s_alert___default.a.closeAll();
	}

	var notificationId = '',
	    configuration = Object.assign({}, conf);

	switch (type) {
		case 'reset':
			__WEBPACK_IMPORTED_MODULE_0_react_s_alert___default.a.closeAll();
			break;
		case 'hide':
			if (configuration.id) {
				__WEBPACK_IMPORTED_MODULE_0_react_s_alert___default.a.close(configuration.id);
			}
			break;
		case 'success':
			notificationId = __WEBPACK_IMPORTED_MODULE_0_react_s_alert___default.a.success(message, configuration);
			break;
		case 'info':
			notificationId = __WEBPACK_IMPORTED_MODULE_0_react_s_alert___default.a.info(message, configuration);
			break;
		case 'warning':
			notificationId = __WEBPACK_IMPORTED_MODULE_0_react_s_alert___default.a.warning(message, configuration);
			break;
		case 'error':
			notificationId = __WEBPACK_IMPORTED_MODULE_0_react_s_alert___default.a.error(message, configuration);
			break;
		case 'notices':
			notificationId = __WEBPACK_IMPORTED_MODULE_0_react_s_alert___default.a.info(message, configuration);
			break;
		default:
			break;
	}

	return notificationId;
}

function showGlobalLoading(text) {
	return {
		type: SHOW_GLOBAL_LOADING,
		text: text
	};
}

function hideGlobalLoading() {
	return {
		type: HIDE_GLOBAL_LOADING,
		text: false
	};
}

function showReplyModal(options) {
	return {
		type: SHOW_REPLY_MODAL,
		options: options
	};
}

function hideReplyModal() {
	return {
		type: HIDE_REPLY_MODAL
	};
}

function showReplyModalLoader() {
	return {
		type: SHOW_REPLY_MODAL_LOADER
	};
}

function hideReplyModalLoader() {
	return {
		type: HIDE_REPLY_MODAL_LOADER
	};
}

function showReplyModalAttachmentLoader() {
	return {
		type: SHOW_REPLY_MODAL_ATTACHMENT_LOADER
	};
}

function hideReplyModalAttachmentLoader() {
	return {
		type: HIDE_REPLY_MODAL_ATTACHMENT_LOADER
	};
}

function showUserModal(path, user) {
	return {
		type: SHOW_USER_MODAL,
		path: path,
		user: user
	};
}

function hideUserModal() {
	return {
		type: HIDE_USER_MODAL,
		path: [],
		user: {}
	};
}

function showShareModal() {
	return {
		type: SHOW_SHARE_MODAL
	};
}

function hideShareModal() {
	return {
		type: HIDE_SHARE_MODAL
	};
}

function openIOSKeyboard() {
	return {
		type: OPEN_IOS_KEYBOARD
	};
}
function closeIOSKeyboard() {
	return {
		type: CLOSE_IOS_KEYBOARD
	};
}

function openAnnouncements() {
	return {
		type: OPEN_ANNOUNCEMENTS
	};
}

function closeAnnouncements() {
	return {
		type: CLOSE_ANNOUNCEMENTS
	};
}

/***/ }),

/***/ 104:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = fetchSearch;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_Actions_MetaActions__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_Actions_InfiniteScrollActions__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_Actions_GlobalMetaActions__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_Actions_adsActions__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_Actions_UserSettingsActions__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_Actions_responseNormalizer__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_Common_actions_SearchResultActions__ = __webpack_require__(222);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_7_Common_actions_SearchResultActions__["c"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_7_Common_actions_SearchResultActions__["d"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_7_Common_actions_SearchResultActions__["h"]; });













function fetchSearch(searchRequest) {
	var cacheBust = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

	return function (dispatch, getState) {
		var action = '';
		switch (searchRequest.id) {
			case 'fav':
				action = 'fav';
				break;
			case 'participated':
			case 'part':
				action = 'participated';
				break;
			case 'updated':
			case 'unread':
				action = 'updated';
				break;
			case 'latest':
			case 'new':
				action = 'latest';
				break;
		}

		searchRequest.loadingBehavior = Object(__WEBPACK_IMPORTED_MODULE_2_Actions_InfiniteScrollActions__["e" /* getLoadingBehavior */])(getState, action, "search", searchRequest.page, searchRequest.forceRefresh);

		if (Object(__WEBPACK_IMPORTED_MODULE_2_Actions_InfiniteScrollActions__["g" /* shouldNotUpdateState */])(getState, searchRequest)) {
			dispatch(Object(__WEBPACK_IMPORTED_MODULE_2_Actions_InfiniteScrollActions__["i" /* updatePagesResult */])(searchRequest.page || 1));
			return null;
		}

		dispatch(Object(__WEBPACK_IMPORTED_MODULE_7_Common_actions_SearchResultActions__["g" /* requestSearch */])(searchRequest));

		var state = getState();
		var url = state.topifyPresets.forumSite.url;

		var showPosts = searchRequest.showposts ? '&showposts=' + searchRequest.showposts : '',
		    searchForum = searchRequest.forumId ? '&sf=' + searchRequest.forumId : '',
		    searchId = searchRequest.searchId ? '&searchid=' + searchRequest.searchId : '',
		    searchQuery = searchRequest.searchQuery ? '&sq=' + searchRequest.searchQuery : '',
		    id = searchRequest.id ? '&id=' + searchRequest.id : '',
		    userID = state.ustate.id ? state.ustate.id : 0,
		    reqType = searchRequest.id === 'fav' ? 'fav' : 'search',
		    showTopics = searchRequest.showtopics ? '&showtopics=' + searchRequest.showtopics : '';

		// Avoid Cache if cacheBust is required
		var fetchConfig = dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_Actions_GlobalMetaActions__["e" /* getFetchConfig */])(cacheBust)),
		    cacheBustQueryString = '&_=' + (cacheBust ? cacheBust : Object(__WEBPACK_IMPORTED_MODULE_1_Actions_MetaActions__["a" /* getCacheBuster */])(getState) || 0),
		    lb = Object(__WEBPACK_IMPORTED_MODULE_5_Actions_UserSettingsActions__["f" /* mapLoadingBehaviour */])(state.ui.userSettings.loadingBehavior),
		    page_size = dispatch(Object(__WEBPACK_IMPORTED_MODULE_5_Actions_UserSettingsActions__["d" /* getPageSize */])()),
		    search_query_url = url + '?v=3.0&ajax=1&uid=' + userID + '&req=' + reqType + id + showPosts + showTopics + searchId + searchForum + searchQuery + '&pagesize=' + page_size + '&page=' + searchRequest.page + '&lb=' + lb + cacheBustQueryString;

		return fetch(search_query_url, fetchConfig).then(function (response) {
			if (!response.ok) {
				try {
					response.json().then(function (json) {
						Object(__WEBPACK_IMPORTED_MODULE_3_Actions_GlobalMetaActions__["j" /* setGlobalNotification */])(dispatch, json, response);
					});
				} catch (e) {
					Object(__WEBPACK_IMPORTED_MODULE_3_Actions_GlobalMetaActions__["j" /* setGlobalNotification */])(dispatch, {}, response);
				}

				dispatch(Object(__WEBPACK_IMPORTED_MODULE_7_Common_actions_SearchResultActions__["e" /* failedSearch */])(searchRequest, 'Bad response from server'));
				dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_Actions_GlobalMetaActions__["b" /* backInHistory */])());
			} else {
				response.json().then(function (json) {
					Object(__WEBPACK_IMPORTED_MODULE_3_Actions_GlobalMetaActions__["j" /* setGlobalNotification */])(dispatch, json, { ok: true });

					if (searchRequest.forumId !== null) {
						// Record the Google Analytics event and for the forum.
						dispatch(Object(__WEBPACK_IMPORTED_MODULE_4_Actions_adsActions__["A" /* trackGAEvent */])(true, 'searchForum', 'userAction', 'consumption'));
					}

					var searchData = json.search && json.search.data.length > 0 ? json.search.data[0] : false,
					    other = Object.assign({}, {
						page: searchRequest.page,
						searchId: searchData ? parseInt(searchData.id) : 0,
						query: {
							searchQuery: (searchData ? searchData.query : null) || searchRequest.searchQuery,
							showposts: searchData && searchData.showposts ? searchData.showposts : 0,
							forumId: searchData && searchData.searchForum || null,
							action: reqType === 'fav' ? reqType : searchData && searchData.action || null,
							showtopics: searchRequest.showtopics || null
						}
					}, json.search ? json.search.meta : json.following.meta);

					var result = Object(__WEBPACK_IMPORTED_MODULE_6_Actions_responseNormalizer__["a" /* responseNormalizer */])(json, searchRequest.page, other);

					if (result.commonwords === null) {
						result.commonwords = [];
					}

					// Preventing error on breadcrumb
					if (json.search && json.search.meta.path === null) {
						json.search.meta.path = [];
					}

					dispatch(Object(__WEBPACK_IMPORTED_MODULE_6_Actions_responseNormalizer__["b" /* updateUstate */])(json, result));

					var action = json.search && json.search.data && json.search.data.length > 0 ? json.search.data[0].action : searchRequest.id;

					switch (action) {
						case 'fav':
							dispatch(Object(__WEBPACK_IMPORTED_MODULE_1_Actions_MetaActions__["b" /* receiveGlobalMeta */])(state.meta, "Subscribed", state.topifyPresets.forumSite.f_title));
							break;
						case 'participated':
						case 'part':
							dispatch(Object(__WEBPACK_IMPORTED_MODULE_1_Actions_MetaActions__["b" /* receiveGlobalMeta */])(state.meta, "Participated", state.topifyPresets.forumSite.f_title));
							break;
						case 'updated':
						case 'unread':
							dispatch(Object(__WEBPACK_IMPORTED_MODULE_1_Actions_MetaActions__["b" /* receiveGlobalMeta */])(state.meta, "Topics With New Posts", state.topifyPresets.forumSite.f_title));
							break;
						case 'latest':
						case 'new':
							dispatch(Object(__WEBPACK_IMPORTED_MODULE_1_Actions_MetaActions__["b" /* receiveGlobalMeta */])(state.meta, "Active Topics", state.topifyPresets.forumSite.f_title));
							break;
						default:
							result.query.action = 'search';
							dispatch(Object(__WEBPACK_IMPORTED_MODULE_1_Actions_MetaActions__["b" /* receiveGlobalMeta */])(json.search.meta, "Search Results"));
					}

					dispatch(Object(__WEBPACK_IMPORTED_MODULE_2_Actions_InfiniteScrollActions__["d" /* fetchSuccess */])(action, "search", searchRequest.page, result.totalPages, searchRequest.loadingBehavior));
					dispatch(Object(__WEBPACK_IMPORTED_MODULE_7_Common_actions_SearchResultActions__["f" /* receiveSearch */])(searchRequest, result));
				});
			}
		}).then(function () {
			Object(__WEBPACK_IMPORTED_MODULE_3_Actions_GlobalMetaActions__["k" /* setLastGlobalAction */])('search', searchRequest);
		}).catch(function (error) {
			Object(__WEBPACK_IMPORTED_MODULE_3_Actions_GlobalMetaActions__["j" /* setGlobalNotification */])(dispatch, {}, error);
			dispatch(Object(__WEBPACK_IMPORTED_MODULE_7_Common_actions_SearchResultActions__["e" /* failedSearch */])(searchRequest, 'Bad response from server'));
			dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_Actions_GlobalMetaActions__["b" /* backInHistory */])());
		});
	};
}

/***/ }),

/***/ 105:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return WIDGET_FETCH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return WIDGET_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return WIDGET_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return WIDGET_RESET_ALL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return WIDGET_DELETE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return WIDGET_REFRESH; });
/* unused harmony export requestWidget */
/* unused harmony export receiveWidget */
/* unused harmony export failedWidget */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return resetWidgets; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return deleteWidget; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return refreshWidget; });
/* harmony export (immutable) */ __webpack_exports__["h"] = fetchWidget;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_Actions_adsActions__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_Actions_GlobalMetaActions__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_Actions_MetaActions__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_Actions_UserSettingsActions__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_Actions_responseNormalizer__ = __webpack_require__(64);


var WIDGET_FETCH = 'WIDGET_FETCH';
var WIDGET_SUCCESS = 'WIDGET_SUCCESS';
var WIDGET_FAILURE = 'WIDGET_FAILURE';
var WIDGET_RESET_ALL = 'WIDGET_RESET_ALL';
var WIDGET_DELETE = 'WIDGET_DELETE';
var WIDGET_REFRESH = 'WIDGET_REFRESH';







var requestWidget = function requestWidget(name) {
	return {
		type: WIDGET_FETCH,
		name: name
	};
};

var receiveWidget = function receiveWidget(name, data) {
	return {
		type: WIDGET_SUCCESS,
		name: name,
		data: data
	};
};

var failedWidget = function failedWidget(name, error) {
	return {
		type: WIDGET_FAILURE,
		name: name,
		error: error
	};
};

var resetWidgets = function resetWidgets() {
	return {
		type: WIDGET_RESET_ALL
	};
};

var deleteWidget = function deleteWidget(name) {
	return {
		type: WIDGET_DELETE,
		name: name
	};
};

var refreshWidget = function refreshWidget() {
	var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

	return {
		type: WIDGET_REFRESH,
		name: name
	};
};

/* Request Functions */
function fetchWidget(request, widgetName, type) {
	var cacheBust = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

	return function (dispatch, getState) {
		// start Fetch
		dispatch(requestWidget(widgetName));

		var state = getState(),
		    forumSiteUrl = state.topifyPresets.forumSite.url;

		var userID = state.ustate.id ? state.ustate.id : 0,
		    fetchConfig = dispatch(Object(__WEBPACK_IMPORTED_MODULE_2_Actions_GlobalMetaActions__["e" /* getFetchConfig */])(true)),
		    cacheBustQueryString = '&_=' + (cacheBust ? cacheBust : Object(__WEBPACK_IMPORTED_MODULE_3_Actions_MetaActions__["a" /* getCacheBuster */])(getState) || 0),
		    lb = Object(__WEBPACK_IMPORTED_MODULE_4_Actions_UserSettingsActions__["f" /* mapLoadingBehaviour */])(state.ui.userSettings.loadingBehavior),
		    page_size = request.pageSize ? request.pageSize : dispatch(Object(__WEBPACK_IMPORTED_MODULE_4_Actions_UserSettingsActions__["d" /* getPageSize */])());

		var id = '',
		    url = forumSiteUrl;

		switch (type) {
			case 'activeTopics':
			case 'popularTopics':
				var sort = type === 'popularTopics' ? '&sortby=views&sortorder=desc' : '';
				url += '?v=3.0&ajax=1&uid=' + userID + '&req=search&id=new' + sort + '&pagesize=' + page_size + '&page=' + request.page + '&lb=' + lb + cacheBustQueryString;
				break;

			default:
				// save data to State
				setTimeout(function () {
					dispatch(receiveWidget(widgetName, {}));
				}, 300);
				return true;
		}

		return fetch(url, fetchConfig).then(function (response) {
			if (!response.ok) {
				try {
					response.json().then(function (json) {
						Object(__WEBPACK_IMPORTED_MODULE_2_Actions_GlobalMetaActions__["j" /* setGlobalNotification */])(dispatch, json, response);
					}).catch(function () {
						Object(__WEBPACK_IMPORTED_MODULE_2_Actions_GlobalMetaActions__["j" /* setGlobalNotification */])(dispatch, {}, response);
					});
				} catch (e) {
					Object(__WEBPACK_IMPORTED_MODULE_2_Actions_GlobalMetaActions__["j" /* setGlobalNotification */])(dispatch, {}, response);
				}
				dispatch(failedWidget(widgetName, 'Bad response from server'));
			} else {
				response.json().then(function (json) {
					Object(__WEBPACK_IMPORTED_MODULE_2_Actions_GlobalMetaActions__["j" /* setGlobalNotification */])(dispatch, json, { ok: true });

					// Record the Google Analytics event
					dispatch(Object(__WEBPACK_IMPORTED_MODULE_1_Actions_adsActions__["A" /* trackGAEvent */])(false, 'widget_' + type, 'userAction', 'consumption'));

					var responseData = json.search && json.search.data.length > 0 ? json.search.data[0] : false,
					    other = {
						page: request.page,
						itemId: responseData ? parseInt(responseData.id) : 0,
						otherParams: {
							searchQuery: responseData ? responseData.query || request.searchQuery : null,
							showposts: responseData && responseData.showposts ? responseData.showposts : 0,
							forumId: responseData && responseData.searchForum || null,
							action: responseData && responseData.action || null,
							showtopics: request.showtopics || null
						}
					};

					var result = Object(__WEBPACK_IMPORTED_MODULE_5_Actions_responseNormalizer__["a" /* responseNormalizer */])(json, request.page, other);

					dispatch(Object(__WEBPACK_IMPORTED_MODULE_5_Actions_responseNormalizer__["b" /* updateUstate */])(json, result));

					// save data to State
					dispatch(receiveWidget(widgetName, result));
				});
			}
		}).catch(function (error) {
			Object(__WEBPACK_IMPORTED_MODULE_2_Actions_GlobalMetaActions__["j" /* setGlobalNotification */])(dispatch, {}, error);
			dispatch(failedWidget(widgetName, 'Bad response from server'));
		});
	};
}

/***/ }),

/***/ 117:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return FORUM_FETCH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return FORUM_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FORUM_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return FORUM_RESET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return FORUM_FOLLOWING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return THREAD_FOLLOWING; });
/* unused harmony export FORUM_REQUEST_EPIC */
/* harmony export (immutable) */ __webpack_exports__["i"] = requestForum;
/* harmony export (immutable) */ __webpack_exports__["h"] = receiveForum;
/* harmony export (immutable) */ __webpack_exports__["g"] = failedForum;
/* harmony export (immutable) */ __webpack_exports__["j"] = resetForum;
/* harmony export (immutable) */ __webpack_exports__["k"] = updateForumFollow;
/* harmony export (immutable) */ __webpack_exports__["l"] = updateThreadFollow;
/* unused harmony export requestForumEpic */
var FORUM_FETCH = 'FORUM_FETCH';
var FORUM_SUCCESS = 'FORUM_SUCCESS';
var FORUM_FAILURE = 'FORUM_FAILURE';
var FORUM_RESET = 'FORUM_RESET';

var FORUM_FOLLOWING = 'FORUM_FOLLOWING';
var THREAD_FOLLOWING = 'THREAD_FOLLOWING';

var FORUM_REQUEST_EPIC = 'FORUM_REQUEST_EPIC';

function requestForum(forum) {
	return {
		type: FORUM_FETCH,
		forum: forum
	};
}

function receiveForum(forum, data) {
	return {
		type: FORUM_SUCCESS,
		forum: forum,
		data: data
	};
}

function failedForum(forum, error) {
	return {
		type: FORUM_FAILURE,
		forum: forum,
		error: error
	};
}

function resetForum() {
	return {
		type: FORUM_RESET
	};
}

function updateForumFollow(forumId, follow) {
	// singular, used only in src
	return {
		type: FORUM_FOLLOWING,
		forumId: forumId,
		follow: follow
	};
}

function updateThreadFollow(threadId, follow) {
	return {
		type: THREAD_FOLLOWING,
		threadId: threadId,
		follow: follow
	};
}

function requestForumEpic(forumParams) {
	return {
		type: FORUM_REQUEST_EPIC,
		forumParams: forumParams
	};
}

/***/ }),

/***/ 118:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return PORTALPAGE_FETCH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return PORTALPAGE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PORTALPAGE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return PORTALPAGE_RESET; });
/* unused harmony export requestPortalPage */
/* unused harmony export receivePortalPage */
/* unused harmony export failedPortalPage */
/* harmony export (immutable) */ __webpack_exports__["f"] = resetPortalPage;
/* harmony export (immutable) */ __webpack_exports__["e"] = fetchPortalPage;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_router_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_Actions_MetaActions__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_Actions_InfiniteScrollActions__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_Actions_GlobalMetaActions__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_Actions_responseNormalizer__ = __webpack_require__(64);








var PORTALPAGE_FETCH = 'PORTALPAGE_FETCH';
var PORTALPAGE_SUCCESS = 'PORTALPAGE_SUCCESS';
var PORTALPAGE_FAILURE = 'PORTALPAGE_FAILURE';
var PORTALPAGE_RESET = 'PORTALPAGE_RESET';

function requestPortalPage(page) {
	return {
		type: PORTALPAGE_FETCH,
		page: page
	};
}

function receivePortalPage(page, data) {
	return {
		type: PORTALPAGE_SUCCESS,
		page: page,
		data: data
	};
}

function failedPortalPage(page, error) {
	return {
		type: PORTALPAGE_FAILURE,
		page: page,
		error: error
	};
}

function resetPortalPage() {
	return {
		type: PORTALPAGE_RESET
	};
}

function fetchPortalPage(pageRequest) {
	var cacheBust = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;


	return function (dispatch, getState) {
		pageRequest.loadingBehavior = Object(__WEBPACK_IMPORTED_MODULE_3_Actions_InfiniteScrollActions__["e" /* getLoadingBehavior */])(getState, pageRequest.pagename, "portalpage", 1, true);

		dispatch(requestPortalPage(pageRequest));

		var state = getState();
		var url = state.topifyPresets.forumSite.url;

		// Avoid Cache if cacheBust is required
		var fetchConfig = dispatch(Object(__WEBPACK_IMPORTED_MODULE_4_Actions_GlobalMetaActions__["e" /* getFetchConfig */])(cacheBust)),
		    cacheBustQueryString = '&_=' + (cacheBust ? cacheBust : Object(__WEBPACK_IMPORTED_MODULE_2_Actions_MetaActions__["a" /* getCacheBuster */])(getState) || 0);

		return fetch(url + ('?v=3.0&ajax=1&uid=0&req=portal&pagename=' + pageRequest.pagename + cacheBustQueryString), fetchConfig).then(function (response) {
			if (!response.ok) {
				Object(__WEBPACK_IMPORTED_MODULE_4_Actions_GlobalMetaActions__["j" /* setGlobalNotification */])(dispatch, {}, response);

				dispatch(failedPortalPage(pageRequest, 'Bad response from server'));
				dispatch(Object(__WEBPACK_IMPORTED_MODULE_4_Actions_GlobalMetaActions__["b" /* backInHistory */])());
			} else {
				response.json().then(function (json) {
					Object(__WEBPACK_IMPORTED_MODULE_4_Actions_GlobalMetaActions__["j" /* setGlobalNotification */])(dispatch, json, { ok: true });

					var other = Object.assign({}, json.portal ? json.portal.meta : {});

					var result = Object(__WEBPACK_IMPORTED_MODULE_5_Actions_responseNormalizer__["a" /* responseNormalizer */])(json, false, other);

					var forumTitle = state.topifyPresets.forumSite.f_title;

					if (json.portal) {
						dispatch(Object(__WEBPACK_IMPORTED_MODULE_2_Actions_MetaActions__["b" /* receiveGlobalMeta */])(json.portal.meta, json.portal.meta.title, forumTitle));
					} else {
						dispatch(Object(__WEBPACK_IMPORTED_MODULE_2_Actions_MetaActions__["b" /* receiveGlobalMeta */])(null, forumTitle));
					}

					dispatch(Object(__WEBPACK_IMPORTED_MODULE_5_Actions_responseNormalizer__["b" /* updateUstate */])(json, result));

					dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_Actions_InfiniteScrollActions__["d" /* fetchSuccess */])(pageRequest.pagename, "portalpage", 1, 1, pageRequest.loadingBehavior));
					dispatch(receivePortalPage(pageRequest, result));
				});
			}
		}).then(function () {
			Object(__WEBPACK_IMPORTED_MODULE_4_Actions_GlobalMetaActions__["k" /* setLastGlobalAction */])('portalpage', pageRequest);
		}).catch(function (error) {
			Object(__WEBPACK_IMPORTED_MODULE_4_Actions_GlobalMetaActions__["j" /* setGlobalNotification */])(dispatch, {}, error);
			dispatch(failedPortalPage(pageRequest, 'Bad response from server'));
			dispatch(Object(__WEBPACK_IMPORTED_MODULE_4_Actions_GlobalMetaActions__["b" /* backInHistory */])());
		});
	};
}

/***/ }),

/***/ 122:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 14:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CLEAR_FIRST_LOAD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return lastGlobalAction; });
/* harmony export (immutable) */ __webpack_exports__["c"] = clearFirstLoad;
/* harmony export (immutable) */ __webpack_exports__["k"] = setLastGlobalAction;
/* harmony export (immutable) */ __webpack_exports__["l"] = setLastGlobalPage;
/* harmony export (immutable) */ __webpack_exports__["j"] = setGlobalNotification;
/* harmony export (immutable) */ __webpack_exports__["b"] = backInHistory;
/* harmony export (immutable) */ __webpack_exports__["d"] = exitTopify;
/* harmony export (immutable) */ __webpack_exports__["h"] = refreshPage;
/* harmony export (immutable) */ __webpack_exports__["i"] = resetAll;
/* harmony export (immutable) */ __webpack_exports__["g"] = pingServer;
/* harmony export (immutable) */ __webpack_exports__["e"] = getFetchConfig;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_router_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_Actions_UiActions__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_Actions_adsActions__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_Actions_ForumviewActions__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_Actions_ThreadviewActions__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_Actions_SearchResultActions__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_Actions_MessagesviewActions__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_Actions_UserprofileActions__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_Actions_InfiniteScrollActions__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_Actions_PhotoGalleryActions__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_Actions_OnlineUsersActions__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_Actions_ReleaseNotesActions__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_Actions_PortalPageActions__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_Actions_MetaActions__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_Actions_responseNormalizer__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_Actions_UserSettingsActions__ = __webpack_require__(26);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };






















var CLEAR_FIRST_LOAD = 'CLEAR_FIRST_LOAD';

var lastGlobalAction = {
	type: null,
	data: {}
};

function clearFirstLoad() {
	return {
		type: CLEAR_FIRST_LOAD
	};
}

function setLastGlobalAction(type, data) {
	if (type && data) {
		if (lastGlobalAction.type !== type) {
			lastGlobalAction = {
				type: type,
				data: _extends({}, data, {
					page: parseInt(data.page) || 1
				})
			};
		} else {
			lastGlobalAction = {
				type: type,
				data: Object.assign(lastGlobalAction.data, data, {
					forceRefresh: true,
					page: lastGlobalAction.data.page || parseInt(data.page)
				})
			};
		}
	}
	return lastGlobalAction;
}

function setLastGlobalPage(page) {
	if (page) {
		lastGlobalAction = _extends({}, lastGlobalAction, {
			data: _extends({}, lastGlobalAction.data, {
				page: parseInt(page)
			})
		});
	}
	return lastGlobalAction;
}

function setGlobalNotification(dispatch, json, response) {
	if ((!json.message || json.message.length === 0) && response.status === 401) {
		Object(__WEBPACK_IMPORTED_MODULE_2_Actions_UiActions__["B" /* displayNotification */])('warning', 'You don\'t have permissions to perform this action or you are not logged in. Please sign in and try again.');
		// Record the Google Analytics event.
		dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_Actions_adsActions__["A" /* trackGAEvent */])(false, 'noPerms', 'error', 'user', response.status));
	} else if (!json.message && response.status === 422) {
		Object(__WEBPACK_IMPORTED_MODULE_2_Actions_UiActions__["B" /* displayNotification */])('warning', 'Username or Password is incorrect.');
		// Record the Google Analytics event.
		dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_Actions_adsActions__["A" /* trackGAEvent */])(false, 'forumLoginFailed', 'error', 'user', response.status));
	} else if (!json.message && !response.ok && response.name !== "TypeError") {
		Object(__WEBPACK_IMPORTED_MODULE_2_Actions_UiActions__["B" /* displayNotification */])('warning', 'An error has occurred.');
		// Record the Google Analytics event.
		dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_Actions_adsActions__["A" /* trackGAEvent */])(false, 'forumCommunication', 'error', 'system', response.status ? response.status : 0));
	} else if (!json.message && response.message && response.name) {
		Object(__WEBPACK_IMPORTED_MODULE_2_Actions_UiActions__["B" /* displayNotification */])('error', 'An error has occurred. ' + response.message);
		// Record the Google Analytics event.
		dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_Actions_adsActions__["A" /* trackGAEvent */])(false, 'serverCommunication', 'error', 'system', response.status ? response.status : 0));
	}

	if (json && json.message && json.message.data) {
		json.message.data.map(function (element) {
			switch (element.type) {
				case 'success':
					Object(__WEBPACK_IMPORTED_MODULE_2_Actions_UiActions__["B" /* displayNotification */])('success', element.message, { force: true });
					break;
				case 'info':
					Object(__WEBPACK_IMPORTED_MODULE_2_Actions_UiActions__["B" /* displayNotification */])('info', element.message, { force: true });
					break;
				case 'alert':
				case 'warning':
					Object(__WEBPACK_IMPORTED_MODULE_2_Actions_UiActions__["B" /* displayNotification */])('warning', element.message, { force: true });
					break;
				case 'error':
					Object(__WEBPACK_IMPORTED_MODULE_2_Actions_UiActions__["B" /* displayNotification */])('error', element.message, { force: true });
					// Record the Google Analytics event.
					dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_Actions_adsActions__["A" /* trackGAEvent */])(false, 'errorReturned', 'error', 'system'));
					break;
				default:
					break;
			}
		});
	}
}

function backInHistory() {
	return function (dispatch) {
		if (lastGlobalAction.type !== null) {
			dispatch(Object(__WEBPACK_IMPORTED_MODULE_1_react_router_redux__["goBack"])());
		} else {
			// Go to landing page
			var landingPage = dispatch(Object(__WEBPACK_IMPORTED_MODULE_16_Actions_UserSettingsActions__["c" /* getLandingPage */])());
			dispatch(Object(__WEBPACK_IMPORTED_MODULE_1_react_router_redux__["push"])(landingPage));
		}
	};
}

function exitTopify() {
	var domain = location.hostname;
	if (domain.indexOf("www.") === 0) {
		domain = domain.substr(4);
	}

	domain = "." + domain;

	var days90 = new Date(),
	    days1 = new Date();
	days90.setTime(days90.getTime() + 90 * 86400000); // 90 days
	days1.setTime(days1.getTime() + 86400000); // 1 Day
	var expires90 = days90.toUTCString(),
	    expires1 = days1.toUTCString();

	document.cookie = 'topify_hideAppView=1;expires=' + expires90 + ';path=/;domain=' + domain;
	document.cookie = 'topify_hidePrompt=1;expires=' + expires1 + ';path=/;domain=' + domain;

	// Record the Google Analytics event.
	this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_Actions_adsActions__["A" /* trackGAEvent */])(false, 'exitTopify', 'userAction', 'exit'));

	var redirectToUrl = location.origin + location.pathname;

	if (!redirectToUrl) {
		redirectToUrl = this.props.forum_url;
	}

	var urlSearch = window.location.search.replace(/\?/, '').replace(/rtemv=\d+/i, '').replace(/nocache=\d+/i, '').replace(/tfr=1/i, '');

	window.location.href = redirectToUrl + '?' + urlSearch + (urlSearch.length ? '&' : '') + 'nocache=' + Date.now();
	location.reload(true);

	return false;
}

function refreshPage() {
	var manual = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

	return function (dispatch) {
		// Hide overlay and all opened stuff
		dispatch(Object(__WEBPACK_IMPORTED_MODULE_2_Actions_UiActions__["M" /* resetOverlay */])());
		// reset attachments gallery
		dispatch(Object(__WEBPACK_IMPORTED_MODULE_10_Actions_PhotoGalleryActions__["h" /* resetGallery */])());

		// We only want trigger analytics when we refresh manually
		if (manual) {
			// Record the Google Analytics event.
			dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_Actions_adsActions__["A" /* trackGAEvent */])(false, 'refresh_' + lastGlobalAction.type, 'userAction', 'consumption'));
		}

		// Update CacheBuster
		var cacheBust = new Date().getTime();
		dispatch(Object(__WEBPACK_IMPORTED_MODULE_14_Actions_MetaActions__["d" /* setCacheBuster */])(cacheBust));

		switch (lastGlobalAction.type) {
			case 'forum':
				dispatch(Object(__WEBPACK_IMPORTED_MODULE_9_Actions_InfiniteScrollActions__["f" /* resetInfinite */])());
				dispatch(Object(__WEBPACK_IMPORTED_MODULE_4_Actions_ForumviewActions__["f" /* resetForum */])());
				dispatch(Object(__WEBPACK_IMPORTED_MODULE_4_Actions_ForumviewActions__["e" /* fetchForum */])(lastGlobalAction.data, cacheBust));
				dispatch(Object(__WEBPACK_IMPORTED_MODULE_9_Actions_InfiniteScrollActions__["h" /* updatePageNumber */])(false, lastGlobalAction.data.page));
				break;

			case 'thread':
				dispatch(Object(__WEBPACK_IMPORTED_MODULE_9_Actions_InfiniteScrollActions__["f" /* resetInfinite */])());
				dispatch(Object(__WEBPACK_IMPORTED_MODULE_5_Actions_ThreadviewActions__["h" /* resetThread */])());
				dispatch(Object(__WEBPACK_IMPORTED_MODULE_5_Actions_ThreadviewActions__["e" /* fetchThread */])(lastGlobalAction.data, cacheBust));
				dispatch(Object(__WEBPACK_IMPORTED_MODULE_9_Actions_InfiniteScrollActions__["h" /* updatePageNumber */])(false, lastGlobalAction.data.page));
				break;

			case 'search':
				dispatch(Object(__WEBPACK_IMPORTED_MODULE_9_Actions_InfiniteScrollActions__["f" /* resetInfinite */])());
				dispatch(Object(__WEBPACK_IMPORTED_MODULE_6_Actions_SearchResultActions__["d" /* resetSearch */])());
				dispatch(Object(__WEBPACK_IMPORTED_MODULE_4_Actions_ForumviewActions__["f" /* resetForum */])());
				dispatch(Object(__WEBPACK_IMPORTED_MODULE_5_Actions_ThreadviewActions__["h" /* resetThread */])());
				dispatch(Object(__WEBPACK_IMPORTED_MODULE_6_Actions_SearchResultActions__["c" /* fetchSearch */])(lastGlobalAction.data, cacheBust));
				dispatch(Object(__WEBPACK_IMPORTED_MODULE_9_Actions_InfiniteScrollActions__["h" /* updatePageNumber */])(false, lastGlobalAction.data.page));
				break;

			case 'messages_pmroot':
			case 'messages_pmfolder':
			case 'messages_pm':
				dispatch(Object(__WEBPACK_IMPORTED_MODULE_9_Actions_InfiniteScrollActions__["f" /* resetInfinite */])());
				dispatch(Object(__WEBPACK_IMPORTED_MODULE_7_Actions_MessagesviewActions__["g" /* resetMessages */])());
				dispatch(Object(__WEBPACK_IMPORTED_MODULE_7_Actions_MessagesviewActions__["d" /* fetchMessages */])(lastGlobalAction.data, cacheBust));
				dispatch(Object(__WEBPACK_IMPORTED_MODULE_9_Actions_InfiniteScrollActions__["h" /* updatePageNumber */])(false, lastGlobalAction.data.page));
				break;

			case 'userprofile':
				dispatch(Object(__WEBPACK_IMPORTED_MODULE_9_Actions_InfiniteScrollActions__["f" /* resetInfinite */])());
				dispatch(Object(__WEBPACK_IMPORTED_MODULE_8_Actions_UserprofileActions__["f" /* resetUserProfile */])());
				dispatch(Object(__WEBPACK_IMPORTED_MODULE_4_Actions_ForumviewActions__["f" /* resetForum */])());
				dispatch(Object(__WEBPACK_IMPORTED_MODULE_5_Actions_ThreadviewActions__["h" /* resetThread */])());
				dispatch(Object(__WEBPACK_IMPORTED_MODULE_8_Actions_UserprofileActions__["e" /* fetchUserProfile */])(lastGlobalAction.data, cacheBust));
				dispatch(Object(__WEBPACK_IMPORTED_MODULE_9_Actions_InfiniteScrollActions__["h" /* updatePageNumber */])(false, lastGlobalAction.data.page));
				break;

			case 'onlineUsers':
				dispatch(Object(__WEBPACK_IMPORTED_MODULE_9_Actions_InfiniteScrollActions__["f" /* resetInfinite */])());
				dispatch(Object(__WEBPACK_IMPORTED_MODULE_11_Actions_OnlineUsersActions__["c" /* resetOnlineUsers */])());
				dispatch(Object(__WEBPACK_IMPORTED_MODULE_11_Actions_OnlineUsersActions__["d" /* whoIsOnline */])(lastGlobalAction.data.page, true));
				dispatch(Object(__WEBPACK_IMPORTED_MODULE_9_Actions_InfiniteScrollActions__["h" /* updatePageNumber */])(false, lastGlobalAction.data.page));
				break;

			case 'releaseNotes':
				dispatch(Object(__WEBPACK_IMPORTED_MODULE_9_Actions_InfiniteScrollActions__["f" /* resetInfinite */])());
				dispatch(Object(__WEBPACK_IMPORTED_MODULE_12_Actions_ReleaseNotesActions__["d" /* resetReleaseNotes */])());
				dispatch(Object(__WEBPACK_IMPORTED_MODULE_12_Actions_ReleaseNotesActions__["e" /* whatReleaseNotes */])(lastGlobalAction.data.page, true));
				dispatch(Object(__WEBPACK_IMPORTED_MODULE_9_Actions_InfiniteScrollActions__["h" /* updatePageNumber */])(false, lastGlobalAction.data.page));
				break;

			case 'portalpage':
				dispatch(Object(__WEBPACK_IMPORTED_MODULE_13_Actions_PortalPageActions__["f" /* resetPortalPage */])());
				dispatch(Object(__WEBPACK_IMPORTED_MODULE_13_Actions_PortalPageActions__["e" /* fetchPortalPage */])({ pagename: lastGlobalAction.data.pagename }));
				break;

			default:
				//noop
				break;
		}
	};
}

function resetAll() {
	return function (dispatch) {
		dispatch(Object(__WEBPACK_IMPORTED_MODULE_9_Actions_InfiniteScrollActions__["f" /* resetInfinite */])());
		dispatch(Object(__WEBPACK_IMPORTED_MODULE_8_Actions_UserprofileActions__["f" /* resetUserProfile */])());
		dispatch(Object(__WEBPACK_IMPORTED_MODULE_7_Actions_MessagesviewActions__["g" /* resetMessages */])());
		dispatch(Object(__WEBPACK_IMPORTED_MODULE_6_Actions_SearchResultActions__["d" /* resetSearch */])());
		dispatch(Object(__WEBPACK_IMPORTED_MODULE_5_Actions_ThreadviewActions__["h" /* resetThread */])());
		dispatch(Object(__WEBPACK_IMPORTED_MODULE_4_Actions_ForumviewActions__["f" /* resetForum */])());
		dispatch(Object(__WEBPACK_IMPORTED_MODULE_13_Actions_PortalPageActions__["f" /* resetPortalPage */])());
		dispatch(Object(__WEBPACK_IMPORTED_MODULE_12_Actions_ReleaseNotesActions__["d" /* resetReleaseNotes */])());
	};
}

function pingServer() {
	return function (dispatch, getState) {
		var state = getState(),
		    uid = state.ustate.id ? state.ustate.id : 0,
		    url = state.topifyPresets.forumSite.url,
		    config = dispatch(getFetchConfig());

		return fetch(url + ('?v=3.0&ajax=1&uid=' + uid + '&req=get&object=ping&_=' + new Date().getTime()), config).then(function (response) {
			if (response.ok) {
				response.json().then(function (json) {
					var result = Object(__WEBPACK_IMPORTED_MODULE_15_Actions_responseNormalizer__["a" /* responseNormalizer */])(json, false, {});
					dispatch(Object(__WEBPACK_IMPORTED_MODULE_15_Actions_responseNormalizer__["b" /* updateUstate */])(json, result));
				});
			}
		});
	};
}

/**
 * Unified fetch config constructor function
 *
 * @param cacheBust
 * @param method
 * @param body
 * @param urlencoded
 *
 * @returns {function(*, *)} => {{method: string, mode: string, credentials: string, redirect: string, cache: string, body: *}}
 */
function getFetchConfig() {
	var cacheBust = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	var method = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'GET';
	var body = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
	var urlencoded = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;

	return function (dispatch, getState) {
		var state = getState(),
		    cache = cacheBust ? 'reload' : 'default',
		    myHeaders = null;

		if (method === 'POST') {
			if (urlencoded) {
				myHeaders = myHeaders || new Headers();
				myHeaders.append("Content-Type", "application/x-www-form-urlencoded; charset=UTF-8");
			}
		}

		// Check if we want to force cache busting
		try {
			if (state.routing.locationBeforeTransitions.query && parseInt(state.routing.locationBeforeTransitions.query.forceCacheBust) === 1) {
				myHeaders = myHeaders || new Headers();
				myHeaders.append('pragma', 'no-cache');
				myHeaders.append('cache-control', 'no-cache');
				cache = 'reload';

				// remove the query string and replace url
				delete state.routing.locationBeforeTransitions.query.forceCacheBust;
				dispatch(Object(__WEBPACK_IMPORTED_MODULE_1_react_router_redux__["replace"])(state.routing.locationBeforeTransitions));
			}
		} catch (e) {/* ignore */}

		var config = {
			method: method,
			mode: 'cors',
			credentials: 'include',
			redirect: 'follow',
			cache: cache
		};

		if (method !== 'GET' && method !== 'HEAD' && body) {
			config.body = body;
		}

		if (myHeaders) {
			config.headers = myHeaders;
		}

		return config;
	};
}

/***/ }),

/***/ 148:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 149:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = deviceType;
/* harmony export (immutable) */ __webpack_exports__["a"] = devicePlatform;
var _isMobile = {
	ran: false,
	any: false,
	os: {
		version: false,
		platform: {
			android: false,
			blackberry: false,
			ios: false,
			webos: false,
			opera: false,
			windows: false
		}
	},
	browser: {
		engine: false,
		version: false
	}
};

// Detects if we have a mobile device, OS, version and browser used
function _detectMobile() {
	var s = void 0,
	    b = void 0;
	_isMobile.ran = true;

	// let's detect system and version
	if (s = navigator.userAgent.match(/(Windows.*Phone)[\s\/]*((?:\d+\.?)+)?/i)) {
		_isMobile.os.platform.windows = true;
		_isMobile.os.version = typeof s[2] !== 'undefined' ? s[2] : false;
		_isMobile.any = true;
	} else if (s = navigator.userAgent.match(/(Android)\s*((?:\d+\.?)+)?/i)) {
		_isMobile.os.platform.android = true;
		_isMobile.os.version = typeof s[2] !== 'undefined' ? s[2] : false;
		_isMobile.any = true;
	} else if (s = navigator.userAgent.match(/(iPad|iPhone|iPod)(?:;.*CPU.*OS ((?:\d+_?)+))?/i)) {
		_isMobile.os.platform.ios = s[1];
		_isMobile.os.version = typeof s[2] !== 'undefined' ? s[2].replace(/_/, '.') : false;
		_isMobile.any = true;
	} else if (s = navigator.userAgent.match(/(BlackBerry)\s*(\d+)?/i)) {
		_isMobile.os.platform.blackberry = true;
		_isMobile.os.version = typeof s[2] !== 'undefined' ? s[2] : false;
		_isMobile.any = true;
	} else if (s = navigator.userAgent.match(/(webOS)[\s\/]*((?:\d+\.?)+)?/i)) {
		_isMobile.os.platform.webos = true;
		_isMobile.os.version = typeof s[2] !== 'undefined' ? s[2] : false;
		_isMobile.any = true;
	} else if (s = navigator.userAgent.match(/(Opera Mini)[\s\/]*((?:\d+\.?)+)?/i)) {
		_isMobile.os.platform.opera = true;
		_isMobile.os.version = typeof s[2] !== 'undefined' ? s[2] : false;
		_isMobile.any = true;
	}

	// let's check some browser basics...
	if (b = navigator.userAgent.match(/(OPR)[\s\/]*((?:\d+\.?)+)/i)) {
		_isMobile.browser = {
			engine: typeof b[1] !== 'undefined' ? 'Opera' : false,
			version: typeof b[2] !== 'undefined' ? b[2] : false
		};
	} else if (b = navigator.userAgent.match(/(Edge)[\s\/]*((?:\d+\.?)+)/i)) {
		_isMobile.browser = {
			engine: typeof b[1] !== 'undefined' ? 'Edge' : false,
			version: typeof b[2] !== 'undefined' ? b[2] : false
		};
	} else if (b = navigator.userAgent.match(/(Firefox|FxiOS)[\s\/]*((?:\d+\.?)+)/i)) {
		_isMobile.browser = {
			engine: typeof b[1] !== 'undefined' ? 'Firefox' : false,
			version: typeof b[2] !== 'undefined' ? b[2] : false
		};
	} else if (b = navigator.userAgent.match(/(Chrome|CriOS)[\s\/]*((?:\d+\.?)+)/i)) {
		_isMobile.browser = {
			engine: typeof b[1] !== 'undefined' ? 'Chrome' : false,
			version: typeof b[2] !== 'undefined' ? b[2] : false
		};
	} else if (b = navigator.userAgent.match(/(Safari)[\s\/]*((?:\d+\.?)+)/i)) {
		_isMobile.browser = {
			engine: typeof b[1] !== 'undefined' ? 'Safari' : false,
			version: typeof b[2] !== 'undefined' ? b[2] : false
		};
	} else if (b = navigator.userAgent.match(/(IEMobile|MSIEMobile)[\s\/]*((?:\d+\.?)+)/i)) {
		_isMobile.browser = {
			engine: typeof b[1] !== 'undefined' ? 'MSIE' : false,
			version: typeof b[2] !== 'undefined' ? b[2] : false
		};
	}
}

function deviceType() {
	if (_isMobile.ran !== true) {
		_detectMobile();
	}
	return _isMobile;
}

function devicePlatform() {
	if (_isMobile.ran !== true) {
		_detectMobile();
	}

	if (_isMobile.any) {
		return Object.keys(_isMobile.os.platform).find(function (platform) {
			return _isMobile.os.platform[platform] !== false;
		});
	}
}

/***/ }),

/***/ 153:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_Common_actions_UstateActions__ = __webpack_require__(220);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0_Common_actions_UstateActions__["b"]; });


/***/ }),

/***/ 154:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return whoIsOnline; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_router_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_Actions_ContextInfoActions__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_Actions_MetaActions__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_Actions_GlobalMetaActions__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_Actions_InfiniteScrollActions__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_Actions_UserSettingsActions__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_Actions_responseNormalizer__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_Common_actions_OnlineUsersActions__ = __webpack_require__(224);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_7_Common_actions_OnlineUsersActions__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_7_Common_actions_OnlineUsersActions__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_7_Common_actions_OnlineUsersActions__["f"]; });














var whoIsOnline = function whoIsOnline(pageNum, forceRefresh) {

	return function (dispatch, getState) {

		var page = parseInt(pageNum),
		    onlineRequest = {
			page: page,
			forceRefresh: forceRefresh
		},
		    loadingBehavior = Object(__WEBPACK_IMPORTED_MODULE_4_Actions_InfiniteScrollActions__["e" /* getLoadingBehavior */])(getState, null, "onlineUsers", page, forceRefresh);

		if (Object(__WEBPACK_IMPORTED_MODULE_4_Actions_InfiniteScrollActions__["g" /* shouldNotUpdateState */])(getState, onlineRequest)) {
			dispatch(Object(__WEBPACK_IMPORTED_MODULE_4_Actions_InfiniteScrollActions__["i" /* updatePagesResult */])(pageNum || 1));
			Object(__WEBPACK_IMPORTED_MODULE_3_Actions_GlobalMetaActions__["k" /* setLastGlobalAction */])('onlineUsers', onlineRequest);
			return null;
		}

		dispatch(Object(__WEBPACK_IMPORTED_MODULE_7_Common_actions_OnlineUsersActions__["d" /* fetchOnlineUsers */])(loadingBehavior));

		var uid = dispatch(Object(__WEBPACK_IMPORTED_MODULE_1_Actions_ContextInfoActions__["i" /* currentUser */])()).id,
		    state = getState(),
		    page_size = dispatch(Object(__WEBPACK_IMPORTED_MODULE_5_Actions_UserSettingsActions__["d" /* getPageSize */])()),
		    url = state.topifyPresets.forumSite.url + ('?v=3.0&ajax=1&uid=' + uid + '&req=online'),
		    config = dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_Actions_GlobalMetaActions__["e" /* getFetchConfig */])(true));

		var lb = Object(__WEBPACK_IMPORTED_MODULE_5_Actions_UserSettingsActions__["g" /* mapOnlineUsersLoadingBehaviour */])(state.ui.userSettings.onlineUsersLoadingBehavior);

		return fetch(url + '&pagesize=' + page_size + '&page=' + page + '&lb=' + lb, config).then(function (response) {
			if (!response.ok) {
				try {
					response.json().then(function (json) {
						Object(__WEBPACK_IMPORTED_MODULE_3_Actions_GlobalMetaActions__["j" /* setGlobalNotification */])(dispatch, json, response);
					}).catch(function () {
						Object(__WEBPACK_IMPORTED_MODULE_3_Actions_GlobalMetaActions__["j" /* setGlobalNotification */])(dispatch, {}, response);
					});
				} catch (e) {
					Object(__WEBPACK_IMPORTED_MODULE_3_Actions_GlobalMetaActions__["j" /* setGlobalNotification */])(dispatch, {}, response);
				}

				// If we have a non authorized let's redirect to landing page
				if (response.status === 401) {
					var landingPage = dispatch(Object(__WEBPACK_IMPORTED_MODULE_5_Actions_UserSettingsActions__["c" /* getLandingPage */])());
					dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_react_router_redux__["replace"])(landingPage));
				} else {
					dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_Actions_GlobalMetaActions__["b" /* backInHistory */])());
				}
			} else {
				return response.json();
			}
		}).then(function (json) {
			if (!json) {
				return;
			}

			var other = Object.assign({}, { page: pageNum || 1 }, json.online ? json.online.meta : {});

			var result = Object(__WEBPACK_IMPORTED_MODULE_6_Actions_responseNormalizer__["a" /* responseNormalizer */])(json, pageNum, other);

			dispatch(Object(__WEBPACK_IMPORTED_MODULE_6_Actions_responseNormalizer__["b" /* updateUstate */])(json, result));

			dispatch(Object(__WEBPACK_IMPORTED_MODULE_2_Actions_MetaActions__["b" /* receiveGlobalMeta */])(json.online.meta, "Who is Online"));
			dispatch(Object(__WEBPACK_IMPORTED_MODULE_4_Actions_InfiniteScrollActions__["d" /* fetchSuccess */])(null, "onlineUsers", page, json.online.meta.totalPages, loadingBehavior));
			dispatch(Object(__WEBPACK_IMPORTED_MODULE_7_Common_actions_OnlineUsersActions__["e" /* receiveOnlineUsers */])(result, loadingBehavior));
		}).then(function () {
			Object(__WEBPACK_IMPORTED_MODULE_3_Actions_GlobalMetaActions__["k" /* setLastGlobalAction */])('onlineUsers', onlineRequest);
		}).catch(function (error) {
			Object(__WEBPACK_IMPORTED_MODULE_3_Actions_GlobalMetaActions__["j" /* setGlobalNotification */])(dispatch, {}, error);
		});
	};
};

/***/ }),

/***/ 155:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FETCH_RELEASE_NOTES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return FETCH_RELEASE_NOTES_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return RESET_RELEASE_NOTES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return resetReleaseNotes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return whatReleaseNotes; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_normalizr__ = __webpack_require__(218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_normalizr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_normalizr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_Actions_MetaActions__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_Actions_GlobalMetaActions__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_Actions_InfiniteScrollActions__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_Actions_UserSettingsActions__ = __webpack_require__(26);


var FETCH_RELEASE_NOTES = 'FETCH_RELEASE_NOTES';
var FETCH_RELEASE_NOTES_SUCCESS = 'FETCH_RELEASE_NOTES_SUCCESS';
var RESET_RELEASE_NOTES = 'RESET_RELEASE_NOTES';






var fetchReleaseNotes = function fetchReleaseNotes(loadingBehavior) {
	return {
		type: FETCH_RELEASE_NOTES,
		loadingBehavior: loadingBehavior
	};
};

var receiveReleaseNotes = function receiveReleaseNotes(data, loadingBehavior) {
	return {
		type: FETCH_RELEASE_NOTES_SUCCESS,
		data: data,
		loadingBehavior: loadingBehavior
	};
};

var resetReleaseNotes = function resetReleaseNotes() {
	return {
		type: RESET_RELEASE_NOTES
	};
};

var note = new __WEBPACK_IMPORTED_MODULE_0_normalizr__["schema"].Entity('notes', {}, { idAttribute: 'n_id' });

var whatReleaseNotes = function whatReleaseNotes(pageNum, forceRefresh) {

	return function (dispatch, getState) {

		var page = parseInt(pageNum),
		    notesRequest = {
			page: page,
			forceRefresh: forceRefresh
		},
		    loadingBehavior = Object(__WEBPACK_IMPORTED_MODULE_3_Actions_InfiniteScrollActions__["e" /* getLoadingBehavior */])(getState, null, "releaseNotes", page, forceRefresh);

		if (Object(__WEBPACK_IMPORTED_MODULE_3_Actions_InfiniteScrollActions__["g" /* shouldNotUpdateState */])(getState, notesRequest)) {
			dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_Actions_InfiniteScrollActions__["i" /* updatePagesResult */])(pageNum || 1));
			Object(__WEBPACK_IMPORTED_MODULE_2_Actions_GlobalMetaActions__["k" /* setLastGlobalAction */])('releaseNotes', notesRequest);
			return null;
		}

		dispatch(fetchReleaseNotes(loadingBehavior));

		var state = getState(),
		    page_size = dispatch(Object(__WEBPACK_IMPORTED_MODULE_4_Actions_UserSettingsActions__["d" /* getPageSize */])()),
		    url = state.topifyPresets.ffUrl + 'm/getnotifications?v=3.0&ajax=1',
		    config = dispatch(Object(__WEBPACK_IMPORTED_MODULE_2_Actions_GlobalMetaActions__["e" /* getFetchConfig */])());

		return fetch(url + '&pagesize=' + page_size + '&page=' + page, config).then(function (response) {
			if (!response.ok) {
				try {
					response.json().then(function (json) {
						Object(__WEBPACK_IMPORTED_MODULE_2_Actions_GlobalMetaActions__["j" /* setGlobalNotification */])(dispatch, json, response);
					});
				} catch (e) {
					Object(__WEBPACK_IMPORTED_MODULE_2_Actions_GlobalMetaActions__["j" /* setGlobalNotification */])(dispatch, {}, response);
				}
				return null;
			} else {
				return response.json();
			}
		}).then(function (json) {
			if (!json) {
				return;
			}

			var preNormalized = {
				notes: (json.notifications_topify || { data: [] }).data.map(function (e) {
					return Object.assign(e, { page: parseInt(page) || 1 });
				})
			},
			    other = {
				page: page || 1
			},
			    result = Object.assign({}, other, {}, Object(__WEBPACK_IMPORTED_MODULE_0_normalizr__["normalize"])(preNormalized, {
				notes: [note]
			}));

			var totalPages = Math.ceil(json.notifications_topify.total / page_size);

			dispatch(Object(__WEBPACK_IMPORTED_MODULE_1_Actions_MetaActions__["b" /* receiveGlobalMeta */])(null, "Topify Release Notes"));
			dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_Actions_InfiniteScrollActions__["d" /* fetchSuccess */])(null, "releaseNotes", page, totalPages, loadingBehavior));
			dispatch(receiveReleaseNotes(result, loadingBehavior));
		}).then(function () {
			Object(__WEBPACK_IMPORTED_MODULE_2_Actions_GlobalMetaActions__["k" /* setLastGlobalAction */])('releaseNotes', notesRequest);
		}).catch(function (error) {
			Object(__WEBPACK_IMPORTED_MODULE_2_Actions_GlobalMetaActions__["j" /* setGlobalNotification */])(dispatch, {}, error);
		});
	};
};

/***/ }),

/***/ 16:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return updatePageNumber; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_router_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_Actions_GlobalMetaActions__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_Common_actions_InfiniteScrollActions__ = __webpack_require__(72);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2_Common_actions_InfiniteScrollActions__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2_Common_actions_InfiniteScrollActions__["c"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_2_Common_actions_InfiniteScrollActions__["h"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_2_Common_actions_InfiniteScrollActions__["i"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_2_Common_actions_InfiniteScrollActions__["k"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_2_Common_actions_InfiniteScrollActions__["l"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_2_Common_actions_InfiniteScrollActions__["m"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_2_Common_actions_InfiniteScrollActions__["n"]; });








var updatePageNumber = function updatePageNumber(location) {
	var newPage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : __WEBPACK_IMPORTED_MODULE_1_Actions_GlobalMetaActions__["f" /* lastGlobalAction */].data.page;
	var routePathname = arguments[2];

	return function (dispatch, getState) {
		dispatch({
			type: __WEBPACK_IMPORTED_MODULE_2_Common_actions_InfiniteScrollActions__["h" /* UPDATE_PAGE_NUMBER */],
			page: parseInt(newPage)
		});

		Object(__WEBPACK_IMPORTED_MODULE_1_Actions_GlobalMetaActions__["l" /* setLastGlobalPage */])(newPage);

		if (routePathname) {
			var pathname = routePathname;
			try {
				pathname = getState().routing.locationBeforeTransitions.pathname;
			} catch (e) {
				pathname = routePathname;
			}

			location.query.page = newPage;
			dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_react_router_redux__["replace"])({
				pathname: pathname,
				query: location.query
			}));
		}
	};
};

/***/ }),

/***/ 17:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_Common_actions_MetaActions__ = __webpack_require__(312);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0_Common_actions_MetaActions__["g"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0_Common_actions_MetaActions__["h"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_0_Common_actions_MetaActions__["i"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_0_Common_actions_MetaActions__["j"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_0_Common_actions_MetaActions__["k"]; });


/***/ }),

/***/ 19:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["m"] = pathToRoot;
/* harmony export (immutable) */ __webpack_exports__["d"] = pathToForumsIndex;
/* harmony export (immutable) */ __webpack_exports__["c"] = pathToForum;
/* harmony export (immutable) */ __webpack_exports__["q"] = pathToThread;
/* harmony export (immutable) */ __webpack_exports__["n"] = pathToSearch;
/* harmony export (immutable) */ __webpack_exports__["b"] = pathToActiveTopics;
/* harmony export (immutable) */ __webpack_exports__["h"] = pathToNewPosts;
/* harmony export (immutable) */ __webpack_exports__["j"] = pathToParticipated;
/* harmony export (immutable) */ __webpack_exports__["p"] = pathToSubscribed;
/* harmony export (immutable) */ __webpack_exports__["l"] = pathToReleaseNotes;
/* harmony export (immutable) */ __webpack_exports__["e"] = pathToMessages;
/* harmony export (immutable) */ __webpack_exports__["f"] = pathToMessagesFolder;
/* harmony export (immutable) */ __webpack_exports__["g"] = pathToMessagesPM;
/* harmony export (immutable) */ __webpack_exports__["k"] = pathToPost;
/* harmony export (immutable) */ __webpack_exports__["r"] = pathToUserProfile;
/* harmony export (immutable) */ __webpack_exports__["i"] = pathToOnline;
/* harmony export (immutable) */ __webpack_exports__["o"] = pathToSettings;
/* harmony export (immutable) */ __webpack_exports__["a"] = parsePath;

function pathToRoot() {
	return '/';
}

function pathToForumsIndex() {
	return {"version":"1.0.0","IndexRoute":"index","section":{"home":false}}.section.home === false && {"version":"1.0.0","IndexRoute":"index","section":{"home":false}}.IndexRoute === 'index' ? '/' : '/forums';
}

function pathToForum(forumId) {
	return '/forums/' + forumId;
}

function pathToThread(threadId) {
	return '/topics/' + threadId;
}

function pathToSearch() {
	var searchid = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

	return '/search/' + searchid;
}

function pathToActiveTopics() {
	return '/latest';
}

function pathToNewPosts() {
	return '/updated';
}

function pathToParticipated() {
	return '/participated';
}

function pathToSubscribed() {
	return '/following';
}

function pathToReleaseNotes() {
	return '/release';
}

function pathToMessages() {
	return '/pms';
}

function pathToMessagesFolder(folder) {
	return '/pms/' + folder;
}

function pathToMessagesPM(message) {
	return '/pm/' + message;
}

function pathToPost(postId) {
	return '/topics/0?postid=' + postId;
}

function pathToUserProfile(userId) {
	return '/userprofile/' + userId;
}

function pathToOnline() {
	return '/online';
}

function pathToSettings() {
	return '/settings';
}

/** Get info about the path:
 * path[ 0 ] => pathname
 * path[ 1 ] => section unless we are at /
 * path[ 2 ] => id
 *
 * @param path
 * @returns {Array|{index: number, input: string}}
 */
function parsePath(path) {
	var re = /(?:([#/]*[?&]?)([^\/&?#]+))?/ig,
	    parsedPath = [],
	    m = void 0;
	while ((m = re.exec(path)) !== null) {
		if (m.index === re.lastIndex) {
			re.lastIndex++;
		}
		if (/[?&#]/.test(m[2]) === false) {
			parsedPath.push(m[2]);
		}
	}
	if (parsedPath.length) {
		parsedPath.unshift(path);
	}
	return parsedPath;
}

/***/ }),

/***/ 220:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SET_CURRENT_USER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return receiveCurrentUser; });
var SET_CURRENT_USER = 'SET_CURRENT_USER';

var receiveCurrentUser = function receiveCurrentUser(ustate) {
  return {
    type: SET_CURRENT_USER,
    ustate: ustate
  };
};

/***/ }),

/***/ 221:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return THREAD_FETCH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return THREAD_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return THREAD_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return THREAD_RESET; });
/* harmony export (immutable) */ __webpack_exports__["g"] = requestThread;
/* harmony export (immutable) */ __webpack_exports__["f"] = receiveThread;
/* harmony export (immutable) */ __webpack_exports__["e"] = failedThread;
/* harmony export (immutable) */ __webpack_exports__["h"] = resetThread;
var THREAD_FETCH = 'THREAD_FETCH';
var THREAD_SUCCESS = 'THREAD_SUCCESS';
var THREAD_FAILURE = 'THREAD_FAILURE';
var THREAD_RESET = 'THREAD_RESET';

function requestThread(thread) {
	return {
		type: THREAD_FETCH,
		thread: thread
	};
}

function receiveThread(thread, data) {
	return {
		type: THREAD_SUCCESS,
		thread: thread,
		data: data
	};
}

function failedThread(thread, error) {
	return {
		type: THREAD_FAILURE,
		thread: thread,
		error: error
	};
}

function resetThread() {
	return {
		type: THREAD_RESET
	};
}

/***/ }),

/***/ 222:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SEARCH_FETCH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SEARCH_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SEARCH_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RESET_SEARCH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return requestSearch; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return receiveSearch; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return failedSearch; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return resetSearch; });
var SEARCH_FETCH = 'SEARCH_FETCH';
var SEARCH_SUCCESS = 'SEARCH_SUCCESS';
var SEARCH_FAILURE = 'SEARCH_FAILURE';
var RESET_SEARCH = 'RESET_SEARCH';

var requestSearch = function requestSearch(query) {
	return {
		type: SEARCH_FETCH,
		query: query
	};
};

var receiveSearch = function receiveSearch(query, data) {
	return {
		type: SEARCH_SUCCESS,
		query: query,
		data: data
	};
};

var failedSearch = function failedSearch(query, error) {
	return {
		type: SEARCH_FAILURE,
		query: query,
		error: error
	};
};

var resetSearch = function resetSearch() {
	return {
		type: RESET_SEARCH
	};
};

/***/ }),

/***/ 223:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return MESSAGES_FETCH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return MESSAGES_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MESSAGES_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return MESSAGES_RESET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return SAVE_MESSAGES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return RESTORE_MESSAGES; });
/* unused harmony export MESSAGES_REQUEST_EPIC */
/* harmony export (immutable) */ __webpack_exports__["i"] = requestMessage;
/* harmony export (immutable) */ __webpack_exports__["h"] = receiveMessages;
/* harmony export (immutable) */ __webpack_exports__["g"] = failedMessages;
/* harmony export (immutable) */ __webpack_exports__["j"] = resetMessages;
/* unused harmony export saveMessages */
/* unused harmony export restoreMessages */
/* unused harmony export requestMessagesEpic */
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var MESSAGES_FETCH = 'MESSAGES_FETCH';
var MESSAGES_SUCCESS = 'MESSAGES_SUCCESS';
var MESSAGES_FAILURE = 'MESSAGES_FAILURE';
var MESSAGES_RESET = 'MESSAGES_RESET';
var SAVE_MESSAGES = 'SAVE_MESSAGES';
var RESTORE_MESSAGES = 'RESTORE_MESSAGES';

var MESSAGES_REQUEST_EPIC = 'MESSAGES_REQUEST_EPIC';

function requestMessage(message) {
	var id_name = {};

	switch (message.pmroute) {
		case 'pmfolder':
			id_name = { pmfolder: message.id };
			break;
		case 'pm':
			id_name = { pm: message.id };
			break;
	}

	return _extends({
		type: MESSAGES_FETCH,
		loadingBehavior: message.loadingBehavior
	}, id_name);
}

function receiveMessages(route, id, data, loadingBehavior) {
	return {
		type: MESSAGES_SUCCESS,
		pmroute: route,
		id: id,
		data: data,
		loadingBehavior: loadingBehavior
	};
}

function failedMessages(route, id, error) {
	return {
		type: MESSAGES_FAILURE,
		pmroute: route,
		id: id,
		error: error
	};
}

function resetMessages() {
	return {
		type: MESSAGES_RESET
	};
}

var saveMessages = function saveMessages() {
	return {
		type: SAVE_MESSAGES
	};
};

var restoreMessages = function restoreMessages() {
	return {
		type: RESTORE_MESSAGES
	};
};

function requestMessagesEpic(messagesRequest) {
	return {
		type: MESSAGES_REQUEST_EPIC,
		messagesRequest: messagesRequest
	};
}

/***/ }),

/***/ 224:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FETCH_ONLINE_USERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return FETCH_ONLINE_USERS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return RESET_ONLINE_USERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return fetchOnlineUsers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return receiveOnlineUsers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return resetOnlineUsers; });
var FETCH_ONLINE_USERS = 'FETCH_ONLINE_USERS';
var FETCH_ONLINE_USERS_SUCCESS = 'FETCH_ONLINE_USERS_SUCCESS';
var RESET_ONLINE_USERS = 'RESET_ONLINE_USERS';

var fetchOnlineUsers = function fetchOnlineUsers(loadingBehavior) {
	return {
		type: FETCH_ONLINE_USERS,
		loadingBehavior: loadingBehavior
	};
};

var receiveOnlineUsers = function receiveOnlineUsers(data, loadingBehavior) {
	return {
		type: FETCH_ONLINE_USERS_SUCCESS,
		data: data,
		loadingBehavior: loadingBehavior
	};
};

var resetOnlineUsers = function resetOnlineUsers() {
	return {
		type: RESET_ONLINE_USERS
	};
};

/***/ }),

/***/ 237:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SET_POST_HASH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SET_POST_ATTACHMENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return REMOVE_POST_ATTACHMENT; });
/* harmony export (immutable) */ __webpack_exports__["e"] = sendAttachment;
/* harmony export (immutable) */ __webpack_exports__["d"] = deleteAttachment;
/* harmony export (immutable) */ __webpack_exports__["f"] = setAttachmentsHash;
/* harmony export (immutable) */ __webpack_exports__["g"] = updateEditingPostAttachments;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_Actions_UiActions__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_Actions_GlobalMetaActions__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_Actions_adsActions__ = __webpack_require__(4);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var SET_POST_HASH = 'SET_POST_HASH';
var SET_POST_ATTACHMENT = 'SET_POST_ATTACHMENT';
var REMOVE_POST_ATTACHMENT = 'REMOVE_POST_ATTACHMENT';

var setPostHash = function setPostHash(responseHash) {
	return {
		type: SET_POST_HASH,
		responseHash: {
			posthash: responseHash.posthash,
			poststarttime: responseHash.poststarttime
		}
	};
};

var setPostAttachment = function setPostAttachment(attachments) {
	return {
		type: SET_POST_ATTACHMENT,
		attachments: attachments
	};
};

var removePostAttachment = function removePostAttachment(id) {
	return {
		type: REMOVE_POST_ATTACHMENT,
		id: id
	};
};

var uploadQuery = function uploadQuery(data) {
	return Object.keys(data).map(function (key) {
		return key + '=' + data[key];
	}).join('&');
};

function sendAttachment(file, data) {
	return function (dispatch, getState) {
		dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_Actions_UiActions__["R" /* showReplyModalAttachmentLoader */])());

		var state = getState(),
		    url = state.topifyPresets.forumSite.url,
		    config = dispatch(Object(__WEBPACK_IMPORTED_MODULE_1_Actions_GlobalMetaActions__["e" /* getFetchConfig */])(true, 'POST', file, false));
		return new Promise(function (resolve, reject) {
			return fetch(url + '?v=3.0&ajax=1&req=post&' + uploadQuery(data), config).then(function (response) {

				dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_Actions_UiActions__["G" /* hideReplyModalAttachmentLoader */])());

				if (!response.ok) {
					response.json().then(function (json) {
						// Record the Google Analytics event.
						dispatch(Object(__WEBPACK_IMPORTED_MODULE_2_Actions_adsActions__["A" /* trackGAEvent */])(false, 'fileUploadFailed', 'error', 'system'));

						Object(__WEBPACK_IMPORTED_MODULE_1_Actions_GlobalMetaActions__["j" /* setGlobalNotification */])(dispatch, json, response);
						resolve(function () {
							return {};
						});
					});
				} else {
					response.json().then(function (json) {
						Object(__WEBPACK_IMPORTED_MODULE_0_Actions_UiActions__["B" /* displayNotification */])('success', 'The attachment was successfully uploaded', { timeout: 1000 });

						// Record the Google Analytics event and for the forum.
						dispatch(Object(__WEBPACK_IMPORTED_MODULE_2_Actions_adsActions__["A" /* trackGAEvent */])(true, 'uploadFile', 'userAction', 'creation'));

						return resolve(function () {
							return {
								ids: json.ids,
								attach_urls: json.attach_urls,
								poststarttime: json.assign.poststarttime,
								posthash: json.assign.posthash
							};
						});
					});
				}
			});
		});
	};
}

function deleteAttachment(data) {
	return function (dispatch, getState) {
		var state = getState(),
		    url = state.topifyPresets.forumSite.url,
		    config = dispatch(Object(__WEBPACK_IMPORTED_MODULE_1_Actions_GlobalMetaActions__["e" /* getFetchConfig */])(true, 'POST'));

		return fetch(url + '?v=3.0&ajax=1&req=post&' + uploadQuery(data), config).then(function (response) {
			return response.json();
		}).then(function (json) {
			json.deleted.forEach(function (attachmentObj) {
				var id = Object.keys(attachmentObj)[0];
				dispatch(removePostAttachment(id));
			});

			Object(__WEBPACK_IMPORTED_MODULE_0_Actions_UiActions__["B" /* displayNotification */])('success', 'The attachment was successfully removed', { timeout: 1000 });

			// Record the Google Analytics event.
			dispatch(Object(__WEBPACK_IMPORTED_MODULE_2_Actions_adsActions__["A" /* trackGAEvent */])(false, 'deleteAttachment', 'userAction', 'creation'));
		});
	};
}

function setAttachmentsHash(hash) {
	var attachments = hash.attach_urls.map(function (url, index) {
		return {
			url: url,
			id: parseInt(hash.ids[index])
		};
	}).filter(function (attachment) {
		return typeof attachment.id === 'number';
	});

	return function (dispatch) {
		dispatch(setPostHash(hash));
		dispatch(setPostAttachment(attachments));
	};
}

function updateEditingPostAttachments() {
	return function (dispatch, getState) {
		var state = getState(),
		    selectedElements = state.meta.selectedElements || [],
		    attachments = state.threadview.entities.attachments || [];

		var attachmentKeys = Object.keys(selectedElements).map(function (postId) {
			return Object.keys(attachments).filter(function (attachment) {
				return parseInt(attachments[attachment].post) === parseInt(postId);
			});
		})[0];

		var attachmentsList = attachmentKeys.map(function (attachment_id) {
			return _extends({}, attachments[attachment_id], {
				url: attachments[attachment_id].href_thumbnail || attachments[attachment_id].href
			});
		});

		dispatch(setPostAttachment(attachmentsList));
	};
}

/***/ }),

/***/ 238:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SHOWN_NOTICE; });
/* harmony export (immutable) */ __webpack_exports__["c"] = noticeShown;
/* harmony export (immutable) */ __webpack_exports__["b"] = dismissNotice;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_Actions_GlobalMetaActions__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_Actions_adsActions__ = __webpack_require__(4);




var SHOWN_NOTICE = 'SHOWN_NOTICE';

function noticeShown(notices) {
	return {
		type: SHOWN_NOTICE,
		notices: Array.isArray(notices) ? notices : [notices]
	};
}

function dismissNotice(noticeId) {
	return function (dispatch, getState) {
		var state = getState(),
		    url = state.topifyPresets.forumSite.url,
		    userID = state.ustate.id ? state.ustate.id : 0;

		if (!noticeId || !userID) {
			return false;
		}

		topifyConsole.info('Dismiss notice', noticeId);

		var moreData = 'noticeid=' + noticeId;
		var fetchConfig = dispatch(Object(__WEBPACK_IMPORTED_MODULE_1_Actions_GlobalMetaActions__["e" /* getFetchConfig */])(true, 'POST', moreData));

		return fetch(url + ('?v=3.0&ajax=1&uid=' + userID + '&req=post&type=dismissnotice'), fetchConfig).then(function (response) {
			if (!response.ok) {
				try {
					response.json().then(function (json) {
						Object(__WEBPACK_IMPORTED_MODULE_1_Actions_GlobalMetaActions__["j" /* setGlobalNotification */])(dispatch, json, response);
					}).catch(function () {
						Object(__WEBPACK_IMPORTED_MODULE_1_Actions_GlobalMetaActions__["j" /* setGlobalNotification */])(dispatch, {}, response);
					});
				} catch (e) {
					Object(__WEBPACK_IMPORTED_MODULE_1_Actions_GlobalMetaActions__["j" /* setGlobalNotification */])(dispatch, {}, response);
				}
			} else {
				response.json().then(function (json) {
					Object(__WEBPACK_IMPORTED_MODULE_1_Actions_GlobalMetaActions__["j" /* setGlobalNotification */])(dispatch, json, { ok: true });
					// Record the Google Analytics event.
					dispatch(Object(__WEBPACK_IMPORTED_MODULE_2_Actions_adsActions__["A" /* trackGAEvent */])(false, 'dismissnotice', 'userAction', 'consumption'));
				});
			}
		}).catch(function (error) {
			Object(__WEBPACK_IMPORTED_MODULE_1_Actions_GlobalMetaActions__["j" /* setGlobalNotification */])(dispatch, {}, error);
		});
	};
}

/***/ }),

/***/ 26:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CHANGE_USER_SETTINGS; });
/* unused harmony export saveUserSettingsState */
/* harmony export (immutable) */ __webpack_exports__["h"] = saveSetting;
/* harmony export (immutable) */ __webpack_exports__["e"] = getSavedUserSettings;
/* harmony export (immutable) */ __webpack_exports__["b"] = fixLandingPage;
/* unused harmony export updateUserSettingsStorage */
/* harmony export (immutable) */ __webpack_exports__["f"] = mapLoadingBehaviour;
/* harmony export (immutable) */ __webpack_exports__["g"] = mapOnlineUsersLoadingBehaviour;
/* harmony export (immutable) */ __webpack_exports__["d"] = getPageSize;
/* harmony export (immutable) */ __webpack_exports__["c"] = getLandingPage;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_Actions_UiActions__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_Utils_nav_NavHelpers__ = __webpack_require__(19);



var CHANGE_USER_SETTINGS = 'CHANGE_USER_SETTINGS';

function saveUserSettingsState(userSettings) {
	return {
		type: CHANGE_USER_SETTINGS,
		userSettings: userSettings
	};
}

/** User Settings Functions **/
function saveSetting(userSettings) {
	return function (dispatch) {
		dispatch(updateUserSettingsStorage(userSettings));
		dispatch(saveUserSettingsState(userSettings));
		Object(__WEBPACK_IMPORTED_MODULE_0_Actions_UiActions__["B" /* displayNotification */])('success', 'Settings saved', { force: true, timeout: 1000 });
	};
}

function getSavedUserSettings() {
	try {
		// Let's take v2 and v3 settings and merge them taking priority v3
		var v2Settings = mapV2UserSettings(JSON.parse(window.localStorage.getItem('topify_local_settings'))),
		    // Topify v2 settings
		v3Settings = JSON.parse(window.localStorage.getItem('topifyLocalSettings')); // New Toify v3 settings
		return Object.assign({}, v2Settings, v3Settings);
	} catch (e) {
		topifyConsole.warn('Error loading localStorage: ', e);
	}
}

function fixLandingPage(landingPage) {
	try {
		if (landingPage === 'home' && {"version":"1.0.0","IndexRoute":"index","section":{"home":false}}.section.home === false) {
			return {"version":"1.0.0","IndexRoute":"index","section":{"home":false}}.IndexRoute;
		}
	} catch (e) {
		return landingPage;
	}
	return landingPage;
}

function updateUserSettingsStorage(userSettings) {
	return function (dispatch, getState) {
		try {
			var state = getState(),
			    currentSettings = state.ui.userSettings,
			    data = Object.assign({}, currentSettings, userSettings, { timestamp: new Date().getTime() });

			window.localStorage.setItem('topifyLocalSettings', JSON.stringify(data));
			topifyConsole.info('topify_local_settings saved');
		} catch (e) {
			topifyConsole.error('Error saving localStorage: topify_local_settings: ', e);
		}
	};
}

function mapLoadingBehaviour(lb) {
	var loading_behavior = {
		oldest: '1',
		newest: '2',
		unread: '3'
	};
	return loading_behavior[lb] ? loading_behavior[lb] : '1';
}

function mapOnlineUsersLoadingBehaviour(lb) {
	var loading_behavior = {
		recent: '0', // recent first
		az: '2', // username a -> z ( default )
		za: '1' // username z -> a
	};
	return loading_behavior[lb] ? loading_behavior[lb] : '2';
}

function getPageSize() {
	return function (dispatch, getState) {
		var state = getState(),
		    pageSizeOption = parseInt(state.ui.userSettings.pageSize),
		    pageSizeDesktop = state.ustate.pageSize ? state.ustate.pageSize : 10;
		return pageSizeOption === 0 ? pageSizeDesktop : pageSizeOption;
	};
}

/* Topify V2 uses a different set of values for settings */
function mapV2UserSettings(currentSettings) {
	if (currentSettings) {
		var translation = {
			show_attachment_thumbnails: 'showAttachmentsPreview',
			style_theme: 'styleTheme',
			font_size: 'fontSize',
			posts_per_page: 'pageSize'
		};

		Object.keys(currentSettings).map(function (key) {
			var newKey = translation[key] ? translation[key] : key;
			currentSettings[newKey] = currentSettings[key];
			return key;
		});
	}
}

function getLandingPage() {
	return function (dispatch, getState) {
		var state = getState(),
		    landingPagePath = Object(__WEBPACK_IMPORTED_MODULE_1_Utils_nav_NavHelpers__["m" /* pathToRoot */])();

		switch (state.ui.userSettings.landingPage) {
			case 'index':
				landingPagePath = Object(__WEBPACK_IMPORTED_MODULE_1_Utils_nav_NavHelpers__["d" /* pathToForumsIndex */])();
				break;
			case 'active':
				landingPagePath = Object(__WEBPACK_IMPORTED_MODULE_1_Utils_nav_NavHelpers__["b" /* pathToActiveTopics */])();
				break;
		}

		return landingPagePath;
	};
}

/***/ }),

/***/ 30:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["e"] = fetchForum;
/* harmony export (immutable) */ __webpack_exports__["g"] = updateFollowing;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_Actions_MetaActions__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_Actions_GlobalMetaActions__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_Actions_InfiniteScrollActions__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_Actions_UiActions__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_Actions_UserSettingsActions__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_Actions_responseNormalizer__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_Actions_adsActions__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_Common_actions_ForumviewActions__ = __webpack_require__(117);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_8_Common_actions_ForumviewActions__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_8_Common_actions_ForumviewActions__["c"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_8_Common_actions_ForumviewActions__["e"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_8_Common_actions_ForumviewActions__["f"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_8_Common_actions_ForumviewActions__["j"]; });















function fetchForum(forumRequest) {
	var cacheBust = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;


	return function (dispatch, getState) {
		forumRequest.loadingBehavior = Object(__WEBPACK_IMPORTED_MODULE_3_Actions_InfiniteScrollActions__["e" /* getLoadingBehavior */])(getState, forumRequest.id, "forum", forumRequest.page, forumRequest.forceRefresh);

		if (Object(__WEBPACK_IMPORTED_MODULE_3_Actions_InfiniteScrollActions__["g" /* shouldNotUpdateState */])(getState, forumRequest)) {
			dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_Actions_InfiniteScrollActions__["i" /* updatePagesResult */])(forumRequest.page || 1));
			return null;
		}

		dispatch(Object(__WEBPACK_IMPORTED_MODULE_8_Common_actions_ForumviewActions__["i" /* requestForum */])(forumRequest));

		var state = getState();
		var url = state.topifyPresets.forumSite.url;

		var userID = state.ustate.id ? state.ustate.id : 0;

		// get fetchConfig
		var fetchConfig = dispatch(Object(__WEBPACK_IMPORTED_MODULE_2_Actions_GlobalMetaActions__["e" /* getFetchConfig */])(cacheBust));

		var cacheBustQueryString = '&_=' + (cacheBust ? cacheBust : Object(__WEBPACK_IMPORTED_MODULE_1_Actions_MetaActions__["a" /* getCacheBuster */])(getState) || 0),
		    page_size = dispatch(Object(__WEBPACK_IMPORTED_MODULE_5_Actions_UserSettingsActions__["d" /* getPageSize */])());

		return fetch(url + ('?v=3.0&ajax=1&uid=' + userID + '&req=cat&id=' + forumRequest.id + '&pagesize=' + page_size + '&page=' + forumRequest.page + '&lb=1' + cacheBustQueryString), fetchConfig).then(function (response) {
			if (!response.ok) {
				try {
					response.json().then(function (json) {
						Object(__WEBPACK_IMPORTED_MODULE_2_Actions_GlobalMetaActions__["j" /* setGlobalNotification */])(dispatch, json, response);
					});
				} catch (e) {
					Object(__WEBPACK_IMPORTED_MODULE_2_Actions_GlobalMetaActions__["j" /* setGlobalNotification */])(dispatch, {}, response);
				}

				dispatch(Object(__WEBPACK_IMPORTED_MODULE_8_Common_actions_ForumviewActions__["g" /* failedForum */])(forumRequest, 'Bad response from server'));
				dispatch(Object(__WEBPACK_IMPORTED_MODULE_2_Actions_GlobalMetaActions__["b" /* backInHistory */])());
			} else {
				response.json().then(function (json) {
					Object(__WEBPACK_IMPORTED_MODULE_2_Actions_GlobalMetaActions__["j" /* setGlobalNotification */])(dispatch, json, { ok: true });

					var other = Object.assign({}, { page: forumRequest.page }, json.topic ? json.topic.meta : {});

					var result = Object(__WEBPACK_IMPORTED_MODULE_6_Actions_responseNormalizer__["a" /* responseNormalizer */])(json, forumRequest.page, other);

					var forumTitle = state.topifyPresets.forumSite.f_title;

					if (json.topic && json.topic.meta.path.length) {
						dispatch(Object(__WEBPACK_IMPORTED_MODULE_1_Actions_MetaActions__["b" /* receiveGlobalMeta */])(json.topic.meta, json.topic.meta.path[0].title, forumTitle));
					} else {
						dispatch(Object(__WEBPACK_IMPORTED_MODULE_1_Actions_MetaActions__["b" /* receiveGlobalMeta */])(null, forumTitle));
					}

					dispatch(Object(__WEBPACK_IMPORTED_MODULE_6_Actions_responseNormalizer__["b" /* updateUstate */])(json, result));

					var forumview = state.forumview;

					if (forumview.earliestLoadedPage === null || result.page < forumview.earliestLoadedPage) {
						result.earliestLoadedPage = result.page;
					}

					if (forumview.latestLoadedPage === null || result.page > forumview.latestLoadedPage) {
						result.latestLoadedPage = result.page;
					}

					dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_Actions_InfiniteScrollActions__["d" /* fetchSuccess */])(forumRequest.id, "forum", forumRequest.page, result.totalPages, forumRequest.loadingBehavior));
					dispatch(Object(__WEBPACK_IMPORTED_MODULE_8_Common_actions_ForumviewActions__["h" /* receiveForum */])(forumRequest, result));
				});
			}
		}).then(function () {
			Object(__WEBPACK_IMPORTED_MODULE_2_Actions_GlobalMetaActions__["k" /* setLastGlobalAction */])('forum', forumRequest);
		}).catch(function (error) {
			Object(__WEBPACK_IMPORTED_MODULE_2_Actions_GlobalMetaActions__["j" /* setGlobalNotification */])(dispatch, {}, error);
			dispatch(Object(__WEBPACK_IMPORTED_MODULE_8_Common_actions_ForumviewActions__["g" /* failedForum */])(forumRequest, 'Bad response from server'));
			dispatch(Object(__WEBPACK_IMPORTED_MODULE_2_Actions_GlobalMetaActions__["b" /* backInHistory */])());
		});
	};
}

function updateFollowing(data) {
	var subID = void 0,
	    subState = void 0,
	    subType = void 0;
	if (typeof data.forum !== 'undefined') {
		subID = data.forum.id;
		subState = data.forum.isSubscribed ? 0 : 1;
		subType = 'Forum';
	} else {
		//TODO - throw error if typeof data.thread is also undefined?
		subID = data.thread.id;
		subState = data.thread.isSubscribed ? 0 : 1;
		subType = 'Topic';
	}
	var subResponse = subState ? 'followed' : 'unfollowed';

	return function (dispatch, getState) {
		var state = getState(),
		    url = state.topifyPresets.forumSite.url,
		    body = 'type=sub&' + subType.toLowerCase() + '=' + subID + '&state=' + subState,
		    config = dispatch(Object(__WEBPACK_IMPORTED_MODULE_2_Actions_GlobalMetaActions__["e" /* getFetchConfig */])(true, 'POST', body));

		switch (subType) {
			case 'Forum':
				dispatch(Object(__WEBPACK_IMPORTED_MODULE_8_Common_actions_ForumviewActions__["k" /* updateForumFollow */])(subID, !!subState));
				break;
			case 'Topic':
				dispatch(Object(__WEBPACK_IMPORTED_MODULE_8_Common_actions_ForumviewActions__["l" /* updateThreadFollow */])(subID, !!subState));
				break;
		}

		return fetch(url + '?v=3.0&ajax=1&uid=' + data.ustate.id + '&req=post', config).then(function (response) {
			if (!response.ok) {
				try {
					response.json().then(function (json) {
						Object(__WEBPACK_IMPORTED_MODULE_2_Actions_GlobalMetaActions__["j" /* setGlobalNotification */])(dispatch, json, response);
					});
				} catch (e) {
					Object(__WEBPACK_IMPORTED_MODULE_2_Actions_GlobalMetaActions__["j" /* setGlobalNotification */])(dispatch, {}, response);
				}

				switch (subType) {
					case 'Forum':
						dispatch(Object(__WEBPACK_IMPORTED_MODULE_8_Common_actions_ForumviewActions__["k" /* updateForumFollow */])(subID, !subState));
						break;
					case 'Topic':
						dispatch(Object(__WEBPACK_IMPORTED_MODULE_8_Common_actions_ForumviewActions__["l" /* updateThreadFollow */])(subID, !subState));
						break;
				}
			} else {
				response.json().then(function (json) {
					if (subState) {
						// Record the Google Analytics event and for the forum.
						dispatch(Object(__WEBPACK_IMPORTED_MODULE_7_Actions_adsActions__["A" /* trackGAEvent */])(true, 'follow' + subType, 'userAction', 'consumption'));
					} else {
						// Record the Google Analytics event.
						dispatch(Object(__WEBPACK_IMPORTED_MODULE_7_Actions_adsActions__["A" /* trackGAEvent */])(false, 'unfollow' + subType, 'userAction', 'consumption'));
					}

					// Updating state with the returned value
					switch (subType) {
						case 'Forum':
							dispatch(Object(__WEBPACK_IMPORTED_MODULE_8_Common_actions_ForumviewActions__["k" /* updateForumFollow */])(subID, json.result));
							break;
						case 'Topic':
							dispatch(Object(__WEBPACK_IMPORTED_MODULE_8_Common_actions_ForumviewActions__["l" /* updateThreadFollow */])(subID, json.result));
							break;
					}

					if (json.result !== !!subState) {
						Object(__WEBPACK_IMPORTED_MODULE_4_Actions_UiActions__["B" /* displayNotification */])('warning', 'The ' + subType + ' is ' + subResponse, { timeout: 1500 });
					}
				});
			}
		});
	};
}

/***/ }),

/***/ 312:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return TOGGLE_SELECTED_ITEM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RESET_SELECTED_ITEM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SET_CACHE_BUST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return SET_GLOBAL_META; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SAVE_META; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return RESTORE_META; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return toggleSelectedItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return resetSelectedItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return setCacheBuster; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getCacheBuster; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return receiveGlobalMeta; });
/* unused harmony export saveMeta */
/* unused harmony export restoreMeta */
var TOGGLE_SELECTED_ITEM = 'TOGGLE_SELECTED_ITEM';
var RESET_SELECTED_ITEM = 'RESET_SELECTED_ITEM';
var SET_CACHE_BUST = 'SET_CACHE_BUST';
var SET_GLOBAL_META = 'SET_GLOBAL_META';
var SAVE_META = 'SAVE_META';
var RESTORE_META = 'RESTORE_META';

var toggleSelectedItem = function toggleSelectedItem(id) {
	return {
		type: TOGGLE_SELECTED_ITEM,
		id: id
	};
};

var resetSelectedItem = function resetSelectedItem() {
	return {
		type: RESET_SELECTED_ITEM
	};
};

var setCacheBuster = function setCacheBuster(cacheBust) {
	return {
		type: SET_CACHE_BUST,
		cacheBust: cacheBust
	};
};

var getCacheBuster = function getCacheBuster(getState) {
	return getState().meta.cacheBust;
};

var receiveGlobalMeta = function receiveGlobalMeta(meta, title, subTitle) {
	return {
		type: SET_GLOBAL_META,
		meta: meta,
		title: title,
		subTitle: subTitle
	};
};

var saveMeta = function saveMeta() {
	return {
		type: SAVE_META
	};
};

var restoreMeta = function restoreMeta() {
	return {
		type: RESTORE_META
	};
};

/***/ }),

/***/ 334:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 335:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 348:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 356:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(357);
module.exports = __webpack_require__(562);


/***/ }),

/***/ 4:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return GEOLOCATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return SHOW_INTERSTITIAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return HIDE_INTERSTITIAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return SAVE_AD_SLOT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DELETE_AD_SLOT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return SHOW_AD_SLOT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return HIDE_AD_SLOT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ADS_PERMISSIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return RESET_HIDDEN_ADS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return SET_GPTCORRELATOR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return DOCUMENT_VISIBLE; });
/* unused harmony export showInterstitial */
/* harmony export (immutable) */ __webpack_exports__["w"] = resetHiddenAdsPerUser;
/* unused harmony export hideInterstitial */
/* harmony export (immutable) */ __webpack_exports__["x"] = saveAdSlot;
/* harmony export (immutable) */ __webpack_exports__["m"] = deleteAdSlot;
/* harmony export (immutable) */ __webpack_exports__["z"] = showAdSlot;
/* harmony export (immutable) */ __webpack_exports__["o"] = hideAdSlot;
/* unused harmony export setAdsPermissions */
/* harmony export (immutable) */ __webpack_exports__["y"] = setGPTCorrelator;
/* unused harmony export setDocumentVisibility */
/* harmony export (immutable) */ __webpack_exports__["q"] = isLoggedIn;
/* harmony export (immutable) */ __webpack_exports__["t"] = preLoadTaboola;
/* harmony export (immutable) */ __webpack_exports__["C"] = triggerCaptify;
/* harmony export (immutable) */ __webpack_exports__["l"] = checkAdsPermissions;
/* harmony export (immutable) */ __webpack_exports__["r"] = loadSecondaryAds;
/* harmony export (immutable) */ __webpack_exports__["v"] = refreshTaboola;
/* harmony export (immutable) */ __webpack_exports__["u"] = refreshRevContent;
/* unused harmony export refreshGoogleAds */
/* unused harmony export cleanOldAdElements */
/* harmony export (immutable) */ __webpack_exports__["B"] = trackPageView;
/* harmony export (immutable) */ __webpack_exports__["A"] = trackGAEvent;
/* harmony export (immutable) */ __webpack_exports__["n"] = getGeoLocation;
/* harmony export (immutable) */ __webpack_exports__["p"] = initAdLibraries;
/* harmony export (immutable) */ __webpack_exports__["s"] = onPageView;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_postscribe__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_postscribe___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_postscribe__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_isomorphic_fetch__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_isomorphic_fetch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_isomorphic_fetch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_Actions_GlobalMetaActions__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_Utils_deviceType__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_Utils_nav_NavHelpers__ = __webpack_require__(19);
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }








var GEOLOCATION = 'GEOLOCATION';
var SHOW_INTERSTITIAL = 'SHOW_INTERSTITIAL';
var HIDE_INTERSTITIAL = 'HIDE_INTERSTITIAL';
var SAVE_AD_SLOT = 'SAVE_AD_SLOT';
var DELETE_AD_SLOT = 'DELETE_AD_SLOT';
var SHOW_AD_SLOT = 'SHOW_AD_SLOT';
var HIDE_AD_SLOT = 'HIDE_AD_SLOT';
var ADS_PERMISSIONS = 'ADS_PERMISSIONS';
var RESET_HIDDEN_ADS = 'RESET_HIDDEN_ADS';
var SET_GPTCORRELATOR = 'SET_GPTCORRELATOR';
var DOCUMENT_VISIBLE = 'DOCUMENT_VISIBLE';

var insertedNodes = [],
    useSSL = 'https:' === document.location.protocol,
    _exelateURL = '',
    pageCounter = 0,
    isUserLoggedIn = false,
    adsPermissions = { noAdsPermissions: false, secondaryAds: false },
    bodyDOM = document.body || document.getElementsByTagName('body')[0],
    headDOM = document.head || document.getElementsByTagName('head')[0],
    is = {
	VS: false,
	Lotame: false,
	prebid: typeof prebid_adUnits_def !== 'undefined' && prebid_adUnits_def && prebid_adUnits_def.length > 0,
	taboola: false,
	taboola_widget: false,
	sharethrough: false,
	VSInterstitial: false,
	homePageInContentAdUnit: false,
	netSeer: false
},
    loaded = {
	events: null,
	Lotame: false,
	Lotame_ccauds: false,
	VSAPI: false,
	comScore: false,
	viglink: false,
	customs: false,
	sharethrough: false,
	netSeer: false
};

var analyticsTrackerName = 'Topify';
window.PREBID_TIMEOUT = 700;
var geoLocationRefresh = 60000; // 60 secs

// Action creators
function setGeoLocation() {
	var location = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { allow: true, error: false, latitude: '', longitude: '', timestamp: 0 };

	return {
		type: GEOLOCATION,
		location: location
	};
}
function showInterstitial() {
	return {
		type: SHOW_INTERSTITIAL
	};
}
function resetHiddenAdsPerUser() {
	return {
		type: RESET_HIDDEN_ADS
	};
}
function hideInterstitial() {
	return {
		type: HIDE_INTERSTITIAL
	};
}
function saveAdSlot(slotName, adUnit) {
	return {
		type: SAVE_AD_SLOT,
		slotName: slotName,
		adUnit: adUnit
	};
}
function deleteAdSlot(slotName) {
	return {
		type: DELETE_AD_SLOT,
		slotName: slotName
	};
}
function showAdSlot(slotName) {
	return {
		type: SHOW_AD_SLOT,
		slotName: slotName
	};
}
function hideAdSlot(slotName) {
	return {
		type: HIDE_AD_SLOT,
		slotName: slotName
	};
}
function setAdsPermissions() {
	var values = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { noAdsPermissions: false, secondaryAds: false };

	return {
		type: ADS_PERMISSIONS,
		values: values
	};
}
function setGPTCorrelator(refresh) {
	return {
		type: SET_GPTCORRELATOR,
		refresh: refresh
	};
}
function setDocumentVisibility(visible) {
	return {
		type: DOCUMENT_VISIBLE,
		visible: visible
	};
}

function getBody() {
	if (!bodyDOM) {
		bodyDOM = document.body || document.getElementsByTagName('body')[0];
	}
	return bodyDOM;
}
function getHead() {
	if (!headDOM) {
		headDOM = document.head || document.getElementsByTagName('head')[0];
	}
	return headDOM;
}

// Is VS
function isVS(state) {
	var forumSite = state.topifyPresets.forumSite;
	is.VS = parseInt(forumSite.isVS) === 1;
	return is.VS;
}
// VS API
function loadVSAPI(state) {
	if (is.VS && is.Lotame && "production" === 'production') {
		__WEBPACK_IMPORTED_MODULE_0_postscribe___default()(getBody(), '<script id="vsapi_js" type="text/javascript" src="//d1r55yzuc1b1bw.cloudfront.net/vsapi.all.min.js"></script>', {
			done: function done() {
				topifyConsole.info("loading vsapi js tag");
				loaded.VSAPI = true;
				initVSAPI(state);
			},
			error: function error() {
				topifyConsole.warn('error loading: VSAPI');
			}
		});
	}
}
function initVSAPI(state) {
	// Inititating vsAPI
	if (typeof vsapi !== 'undefined') {
		var vs_api = vsapi.api();
		window._vs_observe = new vs_api.PostReadObserve();
		_vs_observe.debug = !("production" === 'production'); // log debug visibility and callback info, turn off in prod
		window._vs_beacon = new vs_api.PostReadBeacon(_vs_observe, state.ustate.id, 'https://api.verticalscope.com');
		window._vs_lotame = new vs_api.LotameBeacon(_vs_observe);

		_vs_observe.init();
		_vs_beacon.init();
		topifyConsole.log("vsAPI init");

		refreshVSAPI(state);
	} else if (is.VS && is.Lotame) {
		topifyConsole.log('re initVSAPI');
		setTimeout(function () {
			initVSAPI(state);
		}, 500);
	}
}
// Events
function initEvents(dispatch) {
	document.addEventListener('visibilitychange', function () {
		return focusChange(dispatch);
	});
	focusChange(dispatch);
}
function focusChange(dispatch) {
	topifyConsole.log('visibility change', !document.hidden, document.visibilityState);
	cleanOldAdElements();
	dispatch(setDocumentVisibility(!document.hidden));
}
// Ads ------
// Load Libraries: prebid, googletag, analytics ...
var loadLibraries = function loadLibraries(state) {
	return new Promise(function (resolve) {
		window.googletag = window.googletag || {};
		window.googletag.cmd = window.googletag.cmd || [];

		window._gaq = window._gaq || [];

		if (is.prebid) {
			window.pbjs = window.pbjs || {};
			window.pbjs.que = window.pbjs.que || [];
		}

		// Set up Google Analytics
		(function () {
			var gaq = document.createElement('script');
			gaq.type = 'text/javascript';
			gaq.async = true;
			gaq.src = (useSSL ? 'https://ssl' : 'http://www') + '.google-analytics.com/ga.js';
			var s = document.getElementsByTagName('script')[0];
			s.parentNode.insertBefore(gaq, s);
		})();

		(function (i, s, o, g, r, a, m) {
			i['GoogleAnalyticsObject'] = r;i[r] = i[r] || function () {
				(i[r].q = i[r].q || []).push(arguments);
			}, i[r].l = 1 * new Date();a = s.createElement(o), m = s.getElementsByTagName(o)[0];a.async = 1;a.src = g;m.parentNode.insertBefore(a, m);
		})(window, document, 'script', 'https://www.google-analytics.com/analytics.js', 'ga');

		ga(function () {
			ga('create', 'UA-36870210-7', { name: analyticsTrackerName });

			// Set the session scope appType dimension to the appropriate application type.
			// Defined dimensions:
			// dimension1 = forumId - hit
			// dimension2 = appType - session
			// dimension3 = forumUserGroup - hit
			ga(analyticsTrackerName + '.set', 'dimension2', 'react_v1');

			// appName
			ga(analyticsTrackerName + '.set', 'appName', 'Topify Browser V3');
			// hostname
			ga(analyticsTrackerName + '.set', 'hostname', state.topifyPresets.forumSite.f_site_name);

			topifyConsole.info('GA - create tracker: ' + analyticsTrackerName);

			if (state.topifyPresets.forumSite.f_analytics_id) {
				ga('create', state.topifyPresets.forumSite.f_analytics_id, { name: state.topifyPresets.forumSite.f_id });
				topifyConsole.info('GA - create tracker: ' + state.topifyPresets.forumSite.f_analytics_id + ' - forumId: ' + state.topifyPresets.forumSite.f_id);
			}
		});

		// AFS ads
		(function (G, o, O, g, L, e) {
			G[g] = G[g] || function () {
				(G[g]['q'] = G[g]['q'] || []).push(arguments);
			}, G[g]['t'] = 1 * new Date();
			L = o.createElement(O), e = o.getElementsByTagName(O)[0];
			L.async = 1;
			L.src = '//www.google.com/adsense/search/async-ads.js';
			e.parentNode.insertBefore(L, e);
		})(window, document, 'script', '_googCsa');

		// Prepare prebid loading
		// fallback to ga
		function initAdserver() {
			if (is.prebid) {
				if (pbjs.adserverRequestSent) {
					return;
				}
				pbjs.adserverRequestSent = true;
			}

			(function () {
				var gads = document.createElement('script');
				gads.async = true;
				gads.type = 'text/javascript';
				gads.src = (useSSL ? 'https:' : 'http:') + '//www.googletagservices.com/tag/js/gpt.js';
				var node = document.getElementsByTagName('script')[0];
				node.parentNode.insertBefore(gads, node);
			})();

			if (is.prebid) {
				// resolve the promise
				resolve(true);
			} else {
				resolve(false);
			}
		}

		setTimeout(initAdserver, window.PREBID_TIMEOUT);

		if (is.prebid) {
			// Loading prebid
			(function () {
				var pbjsEl = document.createElement("script");
				pbjsEl.type = "text/javascript";
				pbjsEl.async = true;
				pbjsEl.src = "//dz2fz0bgyq9tn.cloudfront.net/prebid-0.16.0-v1.js";
				var pbjsTargetEl = getHead();
				pbjsTargetEl.insertBefore(pbjsEl, pbjsTargetEl.firstChild);
			})();

			// enabling analytics
			pbjs.que.push(function () {
				// Add the below code snippet to your page
				pbjs.enableAnalytics({
					provider: 'ga',
					options: {
						trackerName: analyticsTrackerName,
						global: 'ga', // <string> name of GA global. Default is 'ga'
						enableDistribution: false
					}
				});
			});

			// setting adUnits
			pbjs.que.push(function () {
				pbjs.bidderSettings = {
					standard: {
						alwaysUseBid: false,
						adserverTargeting: [{
							key: "hb_bidder",
							val: function val(bidResponse) {
								topifyConsole.log('hb_bidder', bidResponse);
								return bidResponse.bidder;
							}
						}, {
							key: "hb_adid",
							val: function val(bidResponse) {
								return bidResponse.adId;
							}
						}, {
							key: "hb_pb",
							val: function val(bidResponse) {
								var cpm = bidResponse.cpm;
								if (cpm < 0.1) cpm = 0.10;
								if (cpm > 8) cpm = 20.00;
								var newCpm = (Math.floor(cpm * 10) / 10).toFixed(2);
								return "pb" + newCpm.replace(".", "");
							}
						}, {
							key: "hb_size",
							val: function val(bidResponse) {
								return bidResponse.size;
							}
						}]
					}
				};

				pbjs.requestBids({
					bidsBackHandler: function bidsBackHandler(bidResponses) {
						initAdserver();
					}
				});
			});

			// normalizing prebid adUnits definitions: ensure we are using the correct sizes int values
			try {
				prebid_adUnits_def = prebid_adUnits_def.map(function (ad) {
					ad.sizes = ad.sizes.map(function (sizes) {
						return sizes.map(function (size) {
							return parseInt(size);
						});
					});
					return ad;
				});
			} catch (e) {
				topifyConsole.error('Prebid normalizing Error:', e);
			}
		}
	});
};
function initGoogleAds(state) {
	window.googletag = window.googletag || {};
	window.googletag.cmd = window.googletag.cmd || [];

	window._gaq = window._gaq || [];

	if (is.prebid) {
		window.pbjs = window.pbjs || {};
		window.pbjs.que = window.pbjs.que || [];
	}

	topifyConsole.log('DEFINED: googletag, _gaq, pbjs');

	var forumSite = state.topifyPresets.forumSite,
	    googleKeywords = JSON.parse(forumSite.dfpTargets);

	loadLibraries(state).then(function () {
		topifyConsole.log('Targetting googleads');

		window.googletag.cmd.push(function () {
			//ForumSite Name Targeting
			googletag.pubads().setTargeting('sitename', forumSite.f_site_name);

			//Custom Targeting
			for (var key in googleKeywords) {
				if (googleKeywords.hasOwnProperty(key)) {
					googletag.pubads().setTargeting(key, googleKeywords[key]);
				}
			}

			// Set the GPS info. that is only gathered once when the web app loads.
			//GEO Location
			if (state.ads.geoLocation.latitude && state.ads.geoLocation.longitude) {
				topifyConsole.log('setting googletag location');
				googletag.pubads().setLocation(state.ads.geoLocation.latitude, state.ads.geoLocation.longitude);
			}

			topifyConsole.log('setting other googletag options');

			googletag.pubads().setCentering(true);
			googletag.pubads().disableInitialLoad();

			// common settings
			googletag.enableServices();

			if (is.prebid) {
				topifyConsole.log('setting prebid targeting');

				pbjs.que.push(function () {
					pbjs.setTargetingForGPTAsync();
				});
			}
		});
	});
}

// Check other ad libraries functions
function isLoggedIn() {
	return function (dispatch, getState) {
		isUserLoggedIn = !!getState().ustate.id;
		return isUserLoggedIn;
	};
}
function hasCustomScripts(state) {
	var forumSite = state.topifyPresets.forumSite;
	return forumSite.customscripts.length > 0;
}
function isTaboola(state) {
	// guests only, for now
	var forumSite = state.topifyPresets.forumSite;
	// check all taboola types
	is.taboola = !!(forumSite.f_taboola && !adsPermissions.noAdsPermissions && !isUserLoggedIn);
	is.taboola_widget = forumSite.f_taboola_widget && !adsPermissions.noAdsPermissions && !isUserLoggedIn ? forumSite.f_taboola_widget : false;
}
function isRevContent(state) {
	// guests only, for now
	var forumSite = state.topifyPresets.forumSite;
	return !!(forumSite.f_revcontent && !isUserLoggedIn);
}
function isLotame(state) {
	var forumSite = state.topifyPresets.forumSite;
	is.Lotame = !!(parseInt(forumSite.isVS) === 1 && forumSite.f_lotame);
	return is.Lotame;
}
function isSwoop(state) {
	// guests only
	var forumSite = state.topifyPresets.forumSite;
	return !!(forumSite.f_swoop && !isUserLoggedIn);
}
function isShareThrough(state) {
	var forumSite = state.topifyPresets.forumSite;
	is.sharethrough = !!(parseInt(forumSite.isVS) === 1 && forumSite.f_sharethrough);
	return is.sharethrough;
}
function isNetseer(state) {
	// guests only
	var page = document.getElementById('page');

	if (page === null) {
		return false;
	}

	try {
		if (state.topifyPresets.forumSite.netseer_tag_id && !adsPermissions.noAdsPermissions && !isUserLoggedIn) {
			window.netseer_tag_id = state.topifyPresets.forumSite.netseer_tag_id;
			window.netseer_publisher_label = state.topifyPresets.forumSite.f_site_name;
			page.classList.remove('no-ad');
			return true;
		} else {
			delete window.netseer_tag_id;
			delete window.netseer_publisher_label;
			page.classList.add('no-ad');
			return false;
		}
	} catch (e) {
		topifyConsole.error('NetSeer failed to check', e);
		delete window.netseer_tag_id;
		delete window.netseer_publisher_label;
		return false;
	}
}
function usesIframeMessenger(state) {
	var forumSite = state.topifyPresets.forumSite;
	var InterstitalAdUnit = void 0,
	    homePageInContentAdUnit = void 0,
	    tags = [];

	if (forumSite.dfpTags && parseInt(forumSite.isVS) === 1) {
		tags = JSON.parse(forumSite.dfpTags);

		if (tags.length > 0) {
			InterstitalAdUnit = tags.find(function (ad) {
				return parseInt(ad.at_id) === 4;
			});
			homePageInContentAdUnit = tags.find(function (ad) {
				return parseInt(ad.at_id) === 101;
			});
		}
	}

	if (InterstitalAdUnit) {
		is.VSInterstitial = true;
	}
	if (homePageInContentAdUnit) {
		is.homePageInContentAdUnit = true;
	}

	return is.VSInterstitial || is.homePageInContentAdUnit;
}

function goInterstitial() {
	return pageCounter === 2 && is.VSInterstitial;
}

// Load libraries functions
function get_ExelateUrl(state) {
	if (_exelateURL) {
		return _exelateURL;
	}

	var forumSite = state.topifyPresets.forumSite;

	var _nativeAds = false; // Note: for now it's only web
	var _verticals = {
		'AUTO': '//loadus.exelator.com/load/?p=239&g=%EXELATE%&c=285379&ctg=Automotive&cmake=%EX_MAKE%&cmodel=%EX_MODEL%',
		'COL': '//loadus.exelator.com/load/?p=239&g=%EXELATE%&c=927073&ctg=Mobile&make=%EX_MAKE%&Model=%EX_MODEL%',
		'OH': '//loadus.exelator.com/load/?p=239&g=%EXELATE%&c=118748&ctg=Mobile&make=%EX_MAKE%&Model=%EX_MODEL%',
		'PETS': '//loadus.exelator.com/load/?p=239&g=%EXELATE%&c=20208&ctg=Pets',
		'PE': '//loadus.exelator.com/load/?p=239&g=%EXELATE%&c=927260&ctg=OffRoadVehicles&vehicles=Tractors-Combines&new=no',
		'PS': '//loadus.exelator.com/load/?p=239&g=%EXELATE%&c=927260&ctg=OffRoadVehicles&vehicles=%EX_MAKE%',
		'RV': '//loadus.exelator.com/load/?p=239&g=%EXELATE%&c=285379&ctg=Automotive&cmake=%EX_MAKE%&cmodel=%EX_MODEL%',
		'SP': '//loadus.exelator.com/load/?p=239&g=%EXELATE%&c=23705&ctg=Sports&sprt=%EX_MAKE%',
		'TECH': '//loadus.exelator.com/load/?p=239&g=%EXELATE%&c=927073&ctg=Mobile&make=%EX_MAKE%&Model=%EX_MODEL%'
	};

	var exelateUrl = '';

	if (forumSite.f_vertical) {
		var vertical = forumSite.f_vertical.toUpperCase(),
		    googleKeywords = JSON.parse(forumSite.dfpTargets);
		topifyConsole.log('Exelate: ' + vertical);
		topifyConsole.log(googleKeywords);

		if (_verticals.hasOwnProperty(vertical)) {
			exelateUrl = _verticals[vertical];

			exelateUrl = exelateUrl.replace('%EXELATE%', forumSite.f_exelateid);

			if (exelateUrl.indexOf('%EX_MAKE%') > -1) {
				if (googleKeywords.hasOwnProperty('make')) {
					exelateUrl = exelateUrl.replace('%EX_MAKE%', googleKeywords.make);
				} else {
					exelateUrl = exelateUrl.replace('%EX_MAKE%', '');
				}
			}

			if (exelateUrl.indexOf('%EX_MODEL%') > -1) {
				if (googleKeywords.hasOwnProperty('model')) {
					exelateUrl = exelateUrl.replace('%EX_MODEL%', googleKeywords.model);
				} else {
					exelateUrl = exelateUrl.replace('%EX_MODEL%', '');
				}
			}

			// For native apps we need to add &APP=1
			exelateUrl = exelateUrl + (_nativeAds ? '&APP=1' : '');
		}
		topifyConsole.log('Exelate URL: ' + exelateUrl);
	}

	_exelateURL = exelateUrl;

	return _exelateURL;
}
function addCustomScripts(state) {
	// Custom ads js
	if (hasCustomScripts(state)) {
		var forumSite = state.topifyPresets.forumSite;
		forumSite.customscripts.forEach(function (s_data, s_index) {
			if (s_data['on_refresh'] || loaded.customs === false) {
				var script_id = (s_data['on_refresh'] ? '_delete' : '') + '_' + s_index;
				if (s_data['url']) {
					__WEBPACK_IMPORTED_MODULE_0_postscribe___default()(getBody(), '<script id="customjs' + script_id + '" type="text/javascript" src="' + s_data['url'] + '"></script>', {
						done: function done() {
							loaded.customs = true;
							topifyConsole.info("loading custom js tag ", s_index);
						},
						error: function error() {
							topifyConsole.warn('error loading: customScript', s_index);
						}
					});
				}

				if (s_data['code']) {
					__WEBPACK_IMPORTED_MODULE_0_postscribe___default()(getBody(), '<script id="customcode' + script_id + '" type="text/javascript">' + s_data['code'] + '</script>', {
						done: function done() {
							loaded.customs = true;
							topifyConsole.info("loading custom js code ", s_index);
						},
						error: function error() {
							topifyConsole.warn('error loading: customCode', s_index);
						}
					});
				}
			}
		});
	}
}
function addVibrantjs(state) {
	var vibrant_id = state.topifyPresets.forumSite.f_vibrant;
	if (vibrant_id) {
		// Vibrant Media IntelliTXT
		__WEBPACK_IMPORTED_MODULE_0_postscribe___default()(getBody(), '<script type="text/javascript" src="//aftest.us.intellitxt.com/intellitxt/front.asp?ipid=' + vibrant_id + '"></script>', {
			done: function done() {
				topifyConsole.info("loading vibrant js tag");
			},
			error: function error() {
				topifyConsole.warn('error loading: Vibrant');
			}
		});
	}
}
function addComScore(state) {
	// Set up comScore functionality before attempting to record any tracking.
	var comscoreScript = (useSSL ? 'https://sb' : 'http://b') + '.scorecardresearch.com/beacon.js';

	__WEBPACK_IMPORTED_MODULE_0_postscribe___default()(getBody(), '<script id="comScoreBeacon" type="text/javascript" async src="' + comscoreScript + '"></script>', {
		done: function done() {
			loaded.comScore = true;
			topifyConsole.info("loading comscore js");
			trackComScore(state);
		},
		error: function error() {
			topifyConsole.warn('error loading: ComScore');
		}
	});
}
function trackComScore(state) {
	var forumSite = state.topifyPresets.forumSite;
	var id = forumSite.f_comscoreid,
	    siteName = forumSite.f_site_name;

	if (loaded.comScore && id) {
		topifyConsole.log('trackComScore');
		var internalTrackComScore = function internalTrackComScore(id, siteName, retryCount) {
			if (self.COMSCORE && self.COMSCORE.beacon) {
				self.COMSCORE && COMSCORE.beacon({ c1: "2", c2: id, c4: siteName });
			} else {
				if (retryCount < 6) {
					window.setTimeout(function () {
						internalTrackComScore(id, siteName, retryCount + 1);
					}, 500);
				}
			}
		};

		internalTrackComScore(id, siteName, 1);
	}
}
function addExelate(state) {
	// get eXelate URL
	var exelateURL = get_ExelateUrl(state);

	if (exelateURL) {
		var exURL = document.location.protocol + exelateURL;
		exURL += '&mobileidtype=' + Object(__WEBPACK_IMPORTED_MODULE_3_Utils_deviceType__["a" /* devicePlatform */])();
		exURL += '&scantime=' + parseInt(Date.now() / 1000); // we only want 10 digits
		if (state.ads.geoLocation.latitude && state.ads.geoLocation.longitude) {
			exURL += '&gpslat=' + state.ads.geoLocation.latitude;
			exURL += '&gpslong=' + state.ads.geoLocation.longitude;
		}
		exURL += '&j=d';

		fetch(exURL, {
			method: 'GET',
			mode: 'cors',
			cache: 'reload',
			credentials: 'include'
		}).then(function () {
			topifyConsole.info("ran exelate");
		}).catch(function (error) {
			topifyConsole.warn('Error running exelate: ' + error.message);
		});
	}
}
function addLotame() {
	// Lotame js tag only for VS sites
	if (is.Lotame && !loaded.Lotame) {
		__WEBPACK_IMPORTED_MODULE_0_postscribe___default()(getHead(), '<script id="LOTCC_8060" type="text/javascript" src="//tags.crwdcntrl.net/c/8060/cc_af_ajax.js?ns=_cc0" ></script>', {
			done: function done() {
				topifyConsole.info("loading Lotame js tag");
				loaded.Lotame = true;
				refreshLotame();
			},
			error: function error() {
				topifyConsole.warn('error loading: Lotame');
			}
		});
	}
}
function addLotame_ccauds() {
	// Lotame js tag only for VS sites
	if (is.Lotame && !loaded.Lotame_ccauds) {
		__WEBPACK_IMPORTED_MODULE_0_postscribe___default()(getHead(), '<script id="lotame_ccauds_js" type="text/javascript" src="//ad.crwdcntrl.net/5/c=8059/pe=y/var=ccauds" ></script>', {
			done: function done() {
				topifyConsole.info("loading Lotame_ccauds js tag");
				loaded.Lotame_ccauds = true;
				setTargetingLotame_ccauds();
			},
			error: function error() {
				topifyConsole.warn('error loading: Lotame_ccauds');
			}
		});
	}
}

function addSwoop(state) {
	// swoop code every page view
	if (isSwoop(state)) {
		var swoopID = state.topifyPresets.forumSite.f_swoop,
		    serverbase = (useSSL ? 'https:' : 'http:') + '//ardrone.swoop.com/',
		    src = serverbase + 'js/spxw.js';

		__WEBPACK_IMPORTED_MODULE_0_postscribe___default()(getBody(), "<script id='swoop_sdk' data-domain='" + swoopID + "' data-serverbase='" + serverbase + "' type='text/javascript' src='" + src + "'></script>", {
			done: function done() {
				topifyConsole.info("loading swoop code");
			},
			error: function error() {
				topifyConsole.warn('error loading: swoop');
			}
		});
	}
}
function loadViglink(state) {
	var forumSite = state.topifyPresets.forumSite,
	    sectionsOk = ['thread'];
	var page = document.getElementById('page');

	if (sectionsOk.indexOf(__WEBPACK_IMPORTED_MODULE_2_Actions_GlobalMetaActions__["f" /* lastGlobalAction */].type) >= 0 && forumSite.f_vigkey && forumSite.f_vigkey.length > 0) {
		// VigLink
		// Note that, for VS sites, we only use VigLink for guest users.
		if (!isVS(state) || isVS(state) && !isUserLoggedIn) {
			// we are in guest only
			page.classList.remove('nolinks', 'nooptimize', 'norewrite');

			if (!loaded.viglink) {
				__WEBPACK_IMPORTED_MODULE_0_postscribe___default()(getBody(), "<script type='text/javascript'>var vglnk = { api_url: '//api.viglink.com/api',key: '" + forumSite.f_vigkey + "'};(function(d, t) {var s = d.createElement(t); s.type = 'text/javascript'; s.async = true;s.src = ('https:' == document.location.protocol ? vglnk.api_url:'//cdn.viglink.com/api') + '/vglnk.js';var r = d.getElementsByTagName(t)[0]; r.parentNode.insertBefore(s, r);}(document, 'script'));</script>", {
					done: function done() {
						topifyConsole.info('loading viglink js');
						loaded.viglink = true;
					},
					error: function error() {
						topifyConsole.warn('error loading: Viglink');
					}
				});
			}
			return true;
		}
	}

	// Adding classes to skip viglink
	page.classList.add('nolinks', 'nooptimize', 'norewrite');
}
function addShareThrough(state) {
	if (isShareThrough(state) && !loaded.sharethrough) {
		__WEBPACK_IMPORTED_MODULE_0_postscribe___default()(getBody(), '<script id="sharethrough_js" type="text/javascript" src="//native.sharethrough.com/assets/sfp.js"></script>', {
			done: function done() {
				topifyConsole.info("loading ShareThrough js tag");
				loaded.sharethrough = true;
			},
			error: function error() {
				topifyConsole.warn('error loading: ShareThrough');
			}
		});
	}
}
function loadNetSeer(state) {
	if (isNetseer(state) && !loaded.netSeer) {
		// let's ensure it's not there already
		var netseer_js = document.querySelectorAll('script#netseer_js');
		if (netseer_js && netseer_js.length) {
			netseer_js.forEach(function (item) {
				item.parentNode.removeChild(item);
			});
		}

		__WEBPACK_IMPORTED_MODULE_0_postscribe___default()(getBody(), '<script async="true" id="netseer_js" type="text/javascript" src="//ps.ns-cdn.com/dsatserving2/scripts/ns_vmtag.js"></script>', {
			done: function done() {
				topifyConsole.info("loading netSeer js tag");
				loaded.netSeer = true;
			},
			error: function error() {
				topifyConsole.warn('error loading: netSeer');
			}
		});
	}
}
function loadIframeMessenger(state) {
	usesIframeMessenger(state);

	if (is.homePageInContentAdUnit) {
		try {
			__WEBPACK_IMPORTED_MODULE_0_postscribe___default()(getBody(), '<script id="vsIframeMessenger" type="text/javascript" src="//assets2.topify.com/vendor/vs/vsIframeMessenger_1.0.js"></script>', {
				done: function done() {
					topifyConsole.info("loading vsIframeMessenger");
				},
				error: function error() {
					topifyConsole.warn('error loading: vsIframeMessenger');
				}
			});
		} catch (e) {
			topifyConsole.error('vsIframeMessenger Error:', e);
		}
	}
	try {
		if (is.VSInterstitial) {
			__WEBPACK_IMPORTED_MODULE_0_postscribe___default()(getBody(), '<script id="vsInterstitial" type="text/javascript" src="//assets2.topify.com/vendor/vs/vsInterstitialAd_2.0.js"></script>', {
				done: function done() {
					topifyConsole.info("loading vsInterstitialAd");
				},
				error: function error() {
					topifyConsole.warn('error loading: vsInterstitialAd');
				}
			});
		}
	} catch (e) {
		topifyConsole.error('vsInterstitialAd Error:', e);
	}
}
function loadSolveMedia(state) {
	try {
		var solvemediaData = state.ustate.solvemedia ? state.ustate.solvemedia : false;

		if (solvemediaData === false) {
			return;
		}

		window.SMInformation = JSON.parse(solvemediaData.SMInformation);
		__WEBPACK_IMPORTED_MODULE_0_postscribe___default()(getBody(), '<script id="solvemedia_script" type="text/javascript" src="' + solvemediaData.js + '"></script>', {
			done: function done() {
				topifyConsole.info("loading solveMedia js");
			},
			error: function error() {
				topifyConsole.warn('error loading: solveMedia');
			}
		});
	} catch (e) {
		topifyConsole.error('solveMedia Error:', e);
	}
}

function preLoadTaboola() {
	return function (dispatch, getState) {
		isTaboola(getState());

		if (is.taboola || is.taboola_widget) {
			window._taboola = window._taboola || [];
			_taboola.push({ article: 'auto' });

			__WEBPACK_IMPORTED_MODULE_0_postscribe___default()(getBody(), '<script id="taboola_script" type="text/javascript" src="//cdn.taboola.com/libtrc/verticalscope-network/loader.js"></script>', {
				done: function done() {
					topifyConsole.info("loading taboola loader");
				},
				error: function error() {
					topifyConsole.warn('error loading: Taboola loader');
				}
			});
		}
	};
}
function triggerCaptify(query) {
	// Clear previous pixel
	var captify_js = document.getElementById('captify_js');
	if (captify_js) {
		captify_js.parentNode.removeChild(captify_js);
	}

	if (is.VS !== true) {
		return true;
	}

	// process keywords: limit to 40, join +
	var captify_kw_limit = 40;
	window.captify_kw_query_11942 = query.trim().split(/\s+/, captify_kw_limit).join('+');

	__WEBPACK_IMPORTED_MODULE_0_postscribe___default()(getBody(), '<script id="captify_js" async="true" type="text/javascript" src="//p.cpx.to/p/11942/px.js" ></script>', {
		done: function done() {
			topifyConsole.info("loading Captify js tag, query:", window.captify_kw_query_11942);
		},
		error: function error() {
			topifyConsole.warn('error loading: Captify');
		}
	});
}

// Secondary ads
function checkAdsPermissions() {
	var currentForumId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

	return function (dispatch, getState) {
		var state = getState(),
		    forumSite = state.topifyPresets.forumSite,
		    ustate = state.ustate,
		    subforums_secondary_ads = forumSite.secondaryAdForumIDs ? JSON.parse(forumSite.secondaryAdForumIDs) : [],
		    forumId = typeof currentForumId === 'number' ? currentForumId : false,
		    usergroups_no_ads = forumSite.noAdGroupIDs ? JSON.parse(forumSite.noAdGroupIDs) : [],
		    user_groups = ustate.id ? ustate.membergroupids ? ustate.membergroupids : [ustate.usergroupid] : [];

		if (forumId === false) {
			return;
		}

		adsPermissions = {
			noAdsPermissions: false,
			secondaryAds: false
		};

		// Are we browsing a subforum set for "Secondary Ads"
		if (subforums_secondary_ads.length > 0) {
			adsPermissions.secondaryAds = forumSite.isVS && subforums_secondary_ads.findIndex(function (f_id) {
				var f_id_int = parseInt(f_id);
				return f_id_int === forumId || f_id_int === -999;
			}) >= 0;
		}

		// Is the user member of a "No Ads User Group"?
		if (user_groups.length > 0 && usergroups_no_ads.length > 0) {
			adsPermissions.noAdsPermissions = usergroups_no_ads.some(function (groupId) {
				var groupId_int = parseInt(groupId);
				return user_groups.findIndex(function (usergroup) {
					var usergroup_int = parseInt(usergroup);
					return usergroup_int === groupId_int;
				}) >= 0;
			});
		}

		topifyConsole.log('Ads Permissions', adsPermissions);

		dispatch(setAdsPermissions(adsPermissions));
	};
}
function loadSecondaryAds(type, props, callbackFunc, onErrorFunc) {
	return function (dispatch, getState) {
		switch (type) {
			case 'rubicon':
				loadRubicon(getState(), props, callbackFunc, onErrorFunc);
		}
	};
}

function loadRubicon(state) {
	var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	var callbackFunc = arguments[2];
	var onErrorFunc = arguments[3];

	var adSizeRubicon = null,
	    _rubiconContanier = document.getElementById(props.container);

	if (!props.size || props.size.length < 2 || !_rubiconContanier) {
		topifyConsole.warn('Rubicon Ad incorrect data provided', props);
		if (onErrorFunc) {
			onErrorFunc();
		}
		return false;
	}

	// Find the Rubicon size
	var RubiconAdSizesMap = {
		"468x60": 1,
		"728x90": 2,
		"120x600": 8,
		"160x600": 9,
		"300x600": 10,
		"300x250": 15,
		"336x280": 16,
		"320x50": 43,
		"300x50": 44,
		"300x1050": 54,
		"970x90": 55,
		"970x250": 57,
		"1000x90": 58,
		"320x480": 67,
		"1800x1000": 68,
		"480x320": 101,
		"768x1024": 102
	};
	var adSize = props.size[0] + 'x' + props.size[1];

	if (RubiconAdSizesMap[adSize]) {
		adSizeRubicon = RubiconAdSizesMap[adSize];
	} else {
		topifyConsole.warn('Rubicon Ad incorrect size provided', props);
		if (onErrorFunc) {
			onErrorFunc();
		}
		return false;
	}

	// force iframe size based on ad size
	_rubiconContanier.style.width = props.size[0] + 'px';
	_rubiconContanier.style.height = props.size[1] + 'px';

	// OnLoad event
	_rubiconContanier.onload = callbackFunc;

	var rp_site = '25062',
	    rp_zonesize = '97080-' + adSizeRubicon;

	var iFrameContent = '<!DOCTYPE html><html><head><title>rubicon ad</title><style type="text/css">body{margin:0;padding:0;}</style><script>window.rp_account = \'1019\'; window.rp_site = \'' + rp_site + '\'; window.rp_zonesize = \'' + rp_zonesize + '\'; window.rp_adtype = \'js\'; window.rp_smartfile = \'\'; window.rp_kw = \'' + state.topifyPresets.forumSite.f_site_name + '\';</script><script type="text/javascript" src="//ads.rubiconproject.com/ad/1019.js"></script></head><body></body></html>';

	var iFrameDoc = _rubiconContanier.contentWindow.document;
	// Clear and Write the content
	iFrameDoc.open();
	iFrameDoc.write(iFrameContent);
	iFrameDoc.close();

	topifyConsole.log('rubicon ad added', props, rp_site, rp_zonesize);
}

// Refresh some libraries
function refreshLotame() {
	// Starting and/or Refreshing Lotame
	if (loaded.Lotame) {
		if ((typeof _lotameObj === 'undefined' || !_lotameObj) && typeof _cc0 !== 'undefined') {
			// create a new object with ajax tag functionality
			window._lotameObj = new _cc0.ajax();
		}

		if (_lotameObj) {
			// this will result in the firing of a sync pixel
			_lotameObj.bcpa(true, true, true);
			topifyConsole.log('Lotame triggered');
		}
	}
}
function setTargetingLotame_ccauds() {
	if (is.Lotame && loaded.Lotame_ccauds) {

		if (typeof ccauds !== "undefined") {
			(function (ccauds) {
				var aud_abbr = [],
				    audience = ccauds.Profile.Audiences.Audience;
				for (var cci = 0; cci < audience.length; cci++) {
					aud_abbr.push(audience[cci].abbr);
				}
				googletag.cmd.push(function () {
					googletag.pubads().setTargeting("aud_abbr", aud_abbr);
					topifyConsole.log('setTargeting Lotame ccauds Audience ', aud_abbr);
				});
			})(ccauds);
		}

		googletag.cmd.push(function () {
			if (typeof ccauds !== "undefined" && typeof ccauds.Profile.tpid !== "undefined" && ccauds.Profile.tpid !== "") {
				googletag.pubads().setTargeting("tpid", ccauds.Profile.tpid);
				topifyConsole.log('setTargeting Lotame ccauds tpid ', ccauds.Profile.tpid);
			} else {
				googletag.pubads().setTargeting("tpid", "0");
				topifyConsole.log('setTargeting Lotame ccauds ', 0);
			}
		});
	}
}
function refreshVSAPI(state) {
	// Do we use vsAPI?
	if (loaded.VSAPI) {
		topifyConsole.log('refresh VSAPI');
		// Trigger vsapi track if we have to
		if (state.threadview.result.posts && state.threadview.result.posts.length > 0 && state.infiniteScroll.page) {
			topifyConsole.log('Clear and init vsApi call for post page for user ', state.ustate.id);
			_vs_beacon.userId = state.ustate.id; // set user id, just in case
			_vs_observe.clear();
			_vs_lotame.init(window.location.hostname, state.threadview.result.posts);

			// What posts are in this page?
			var pageIndex = state.threadview.pages.indexOf(state.infiniteScroll.page),
			    page_size = state.ui.userSettings.pageSize,
			    postsInPage = state.threadview.result.posts.slice(pageIndex * page_size, (pageIndex + 1) * page_size);

			// For each post on the page:
			postsInPage.forEach(function (post, index) {
				if (document.getElementById('post_message_' + post)) {
					_vs_observe.addPostElement(document.getElementById('post_container_' + post), document.getElementById('post_message_' + post), post, parseInt(state.threadview.entities.posts[post].topic), parseInt(state.threadview.entities.posts[post].forum), parseInt(state.threadview.entities.posts[post].forumUser), index + 1);
				}
			});
		}
	}
}
function refreshTaboola(type) {
	if (is.taboola_widget || is.taboola) {
		topifyConsole.groupCollapsed("taboola ads");
		topifyConsole.log("taboola type", type);

		var taboolaData = {},
		    _taboolaAd_id = '',
		    _taboolaAd_placement = '';

		switch (type) {
			case 'taboola':
				if (is.taboola) {
					_taboolaAd_id = 'taboola-mobile-below-article-thumbnails';

					taboolaData = {
						mode: 'thumbnails-f',
						container: _taboolaAd_id,
						placement: 'Mobile Below Article Thumbnails',
						target_type: 'mix'
					};
				}
				break;

			case 'recirculation':
				if (is.taboola_widget) {
					_taboolaAd_id = 'taboola-mid-article-stream-thumbnails';
					_taboolaAd_placement = is.taboola_widget;

					// clear current slot
					var currentTaboola = document.querySelectorAll('#taboola-mid-article-stream-thumbnails div.trc_rbox');
					if (currentTaboola && currentTaboola.length) {
						currentTaboola.forEach(function (item) {
							item.parentNode.removeChild(item);
						});
					}

					taboolaData = {
						mode: 'organic-thumbnails-a',
						container: _taboolaAd_id,
						placement: _taboolaAd_placement,
						target_type: 'mix'
					};
				}
				break;
		}

		if (window._taboola && taboolaData.container && document.getElementById(_taboolaAd_id)) {
			// Only if container exists
			topifyConsole.log("taboola push data", taboolaData);
			window._taboola.push(taboolaData);
			topifyConsole.log("taboola flush");
			window._taboola.push({ flush: true });
		} else {
			topifyConsole.log('not loaded');
		}
		topifyConsole.groupEnd("taboola ads");
	}
}
function refreshRevContent() {
	return function (dispatch, getState) {
		var state = getState();
		if (isRevContent(state)) {
			var f_revContent = state.topifyPresets.forumSite.f_revcontent || "",
			    revContentId = f_revContent.match(/(\d+)\s*,\s*(\d+)/);

			var prevjs = document.querySelectorAll('#revContent_js, script[id^="rc2js_beacon"]');
			if (prevjs && prevjs.length) {
				prevjs.forEach(function (item) {
					item.parentNode.removeChild(item);
				});
			}

			if (revContentId.length === 3) {
				var revContent_code = "\
					(function(){function ad_block_test(e,o){if(\"undefined\"!=typeof document.body){var t=\"0.1.2-dev\",\
					o=o?o:\"sponsorText\",n=document.createElement(\"DIV\");n.id=o,n.style.position=\"absolute\",\
					n.style.left=\"-999px\",n.appendChild(document.createTextNode(\"&nbsp;\")),document.body.appendChild(n),\
					setTimeout(function(){if(n){var o=0==n.clientHeight;try{}catch(d){console&&console.log&&console.log(\"ad-block-test error\",d)}\
					e(o,t),document.body.removeChild(n)}},175)}}ad_block_test(function(is_blocked){\
					var widget_id=" + revContentId[1] + ";if(is_blocked===true)widget_id=" + revContentId[2] + ";\
					var referer=\"\";try{if(referer=document.referrer,\"undefined\"==typeof referer)throw\"undefined\";}catch(exception){\
					referer=document.location.href,(\"\"==referer||\"undefined\"==typeof referer)&&(referer=document.URL)}referer=referer.substr(0,700);\
					var rcel=document.createElement(\"script\");rcel.id=\"rc_\"+Math.floor(Math.random()*1E3);\
					rcel.type=\"text/javascript\";rcel.src=\"http://trends.revcontent.com/serve.js.php?w=\"+widget_id+\"&t=\"+rcel.id+\"\
					&c=\"+(new Date).getTime()+\"&width=\"+(window.outerWidth||document.documentElement.clientWidth)+\"&referer=\"+referer+\"\
					&is_blocked=\"+is_blocked;rcel.async=true;\
					var rcds=document.getElementById(\"rcjsload_vs1vs1\");rcds.appendChild(rcel)})})();\
				";

				__WEBPACK_IMPORTED_MODULE_0_postscribe___default()(getBody(), "<script async id='revContent_js' type='text/javascript'>" + revContent_code + "</script>", {
					done: function done() {
						topifyConsole.info("loading revContent code");
					},
					error: function error() {
						topifyConsole.warn('error loading: revContent');
					}
				});
			}
		}
	};
}
function refreshGoogleAds(state) {
	topifyConsole.log('refreshGoogleAds');

	try {
		var path = Object(__WEBPACK_IMPORTED_MODULE_4_Utils_nav_NavHelpers__["a" /* parsePath */])(state.routing.locationBeforeTransitions.pathname),
		    ustate = state.ustate,
		    usergroup = typeof ustate.displaygrouptitle !== 'undefined' && ustate.displaygrouptitle ? ustate.displaygrouptitle : 'guest',
		    metaPath = state.meta.path && state.meta.path.length ? state.meta.path[0] : false,
		    currentSubforum_id = metaPath ? metaPath.id : -1,
		    currentSubforum_name = metaPath ? metaPath.title : '';

		var currentLegacyUrl = '',
		    PageID = 0;

		switch (path[1] || path[0]) {
			case 'topics':
				PageID = typeof state.meta.threadid !== 'undefined' ? state.meta.threadid : 0;
				currentLegacyUrl = state.threadview.entities.topics ? state.threadview.entities.topics[PageID].href : '';
				break;
			case 'forums':
				if (path[2]) {
					currentLegacyUrl = state.forumview.entities.forums ? state.forumview.entities.forums[state.forumview.forumId].href : '';
				} else {
					currentLegacyUrl = state.topifyPresets.forumSite.f_url;
					PageID = 'Homepage';
				}
				break;
			case 'portal':
				var portalpage = state.portalpage;
				currentLegacyUrl = portalpage.result && portalpage.result.portalpage ? state.topifyPresets.forumSite.f_url.replace(/\/$/, '') + '/' + portalpage.result.portalpage[0] + '.html' : '';
				PageID = !(portalpage.result && portalpage.result.portalpage) ? 'cmps' : /insurance/i.test(portalpage.result.portalpage[0]) ? 'insurance' : portalpage.result.portalpage[0];
				break;
			case '/':
				currentLegacyUrl = state.topifyPresets.forumSite.f_url;
				PageID = 'Homepage';
				break;
		}

		// ensure targeting for Lotame ccauds are set
		setTargetingLotame_ccauds();

		window.googletag.cmd.push(function () {
			// Sharethrough targetting
			if (is.sharethrough) {
				googletag.pubads().setTargeting("strNativeKey", state.topifyPresets.forumSite.f_sharethrough);
			}

			// update the dynamic targeting values
			googletag.pubads().setTargeting('forum_id', currentSubforum_id + '');
			googletag.pubads().setTargeting('forum_name', currentSubforum_name);
			googletag.pubads().setTargeting('group_id', usergroup);
			googletag.pubads().setTargeting('registered', isUserLoggedIn + '');
			googletag.pubads().setTargeting('PageID', PageID + '');

			googletag.pubads().set("page_url", currentLegacyUrl);

			var page = document.getElementById('page'),
			    page_backgroundColor = page ? window.getComputedStyle(page).getPropertyValue('background-color') : '';
			googletag.pubads().set('adsense_background_color', page_backgroundColor);
		});
	} catch (e) {
		topifyConsole.error('refreshGoogleAds setTargeting ERROR ', e);
	}
}

// Create a observers for DOM mutations on head and body
var observerConfig = { childList: true }; // configuration of the observer
var checkExcludedFromDelete = function checkExcludedFromDelete(node) {
	// urls to exclude from deletion
	var excludeSRC = ['google-analytics.com/ga.js', 'google-analytics.com/analytics.js', 'google.com/adsense/search/async-ads.js', 'googletagservices.com/tag/js/gpt.js', '/prebid-.*.js'],

	// Ids
	excludeIDs = ['vsIframeMessenger', 'vsInterstitial', 'comScoreBeacon', 'captify_js', 'LOTCC_8060', 'lotame_ccauds_js'],
	    excludeStyles = ['trc_rbox_container'];

	switch (node.nodeName) {
		case 'SCRIPT':
			return node.src && (node.id && excludeIDs.some(function (js) {
				return node.id === js;
			}) || // if we have id check it first
			excludeSRC.some(function (js) {
				return new RegExp(js, 'i').test(node.src);
			}));

		case 'STYLE':
			return excludeStyles.some(function (style) {
				return new RegExp(style).test(node.textContent);
			});
	}

	return false;
},
    trackAddedNodes = function trackAddedNodes(mutations) {
	mutations.forEach(function (mutation) {
		// convert nodeList into an array
		// avoiding nodeList.forEach polyfill for iOS8 + Chrome
		[].concat(_toConsumableArray(mutation.addedNodes)).forEach(function (node) {
			if (checkExcludedFromDelete(node) === false) {
				insertedNodes.push(node);
			}
		});

		// If there are removed nodes, remove them from our array
		if (mutation.removedNodes.length) {
			[].concat(_toConsumableArray(mutation.removedNodes)).forEach(function (removed) {
				var index = insertedNodes.findIndex(function (e) {
					return e === removed;
				});
				if (index >= 0) {
					insertedNodes.splice(index, 1);
				}
			});
		}
	});
},
    _mutationObserver_Body = new MutationObserver(trackAddedNodes),
    _mutationObserver_Head = new MutationObserver(trackAddedNodes);

// Cleans elements from previous page view
function cleanOldAdElements() {
	topifyConsole.groupCollapsed("cleaning ad elements");
	topifyConsole.time("cleaning ad elements");

	// Stop Observers
	_mutationObserver_Head.disconnect();
	_mutationObserver_Body.disconnect();

	// Elements
	var elementsToRemove = [].concat(_toConsumableArray(insertedNodes));

	// Swoop
	delete window.SPX;

	//eXelate
	if (typeof xl8iframe !== 'undefined') {
		try {
			elementsToRemove.push(xl8iframe);
		} catch (e) {/* ignore */}
	}

	// netseer
	// when netseer don't use the banner anymore just throws them out of page >:|
	// let's remove them
	var netSeerKeys = [];
	if (window.NETSEER && window.NETSEER.assignedBanners) {
		[].concat(_toConsumableArray(window.NETSEER.assignedBanners)).forEach(function (item, i) {
			if (parseInt(item.style.top) < 0) {
				// been removed by netseer
				netSeerKeys.push(i);
			}
		});
		netSeerKeys.reverse().forEach(function (i) {
			return window.NETSEER.assignedBanners.splice(i, 1);
		});
	}

	// remove the elements
	elementsToRemove.forEach(function (item) {
		try {
			item.parentNode.removeChild(item);
		} catch (e) {/* ignore */}
	});

	topifyConsole.timeEnd("cleaning ad elements");
	topifyConsole.log('Total Elements:', elementsToRemove.length);
	topifyConsole.groupEnd("cleaning ad elements");

	insertedNodes = [];
	_mutationObserver_Head.observe(getHead(), observerConfig);
	_mutationObserver_Body.observe(getBody(), observerConfig);
}

// Google analytics
function isValidAnalyticsID(value) {
	var pattern = new RegExp("^UA-\\d{4,10}(-\\d{1,4})?$");
	return pattern.test(value);
}
function getTrackingUrl(state) {
	var rtnUrl = '/';
	try {
		if (state.routing.locationBeforeTransitions) {
			rtnUrl = state.routing.locationBeforeTransitions.pathname;
			for (var q in state.routing.locationBeforeTransitions.query) {
				rtnUrl += rtnUrl.lastIndexOf('?') < 0 ? '?' : '&';
				if (q === 'page' && (state.meta.page || state.infiniteScroll.page)) {
					rtnUrl += q + '=' + (state.routing.locationBeforeTransitions.query.q ? // it's a search, grab query.page
					state.routing.locationBeforeTransitions.query.page : state.infiniteScroll.page || state.meta.page);
				} else {
					rtnUrl += q + '=' + state.routing.locationBeforeTransitions.query[q];
				}
			}
		} else {
			// let's grab by the current url
			throw true;
		}
	} catch (e) {
		if (window.location.hash && window.location.hash.length > 1) {
			rtnUrl = window.location.hash.substr(1);

			if (rtnUrl.lastIndexOf('_k=') >= 0) {
				rtnUrl = rtnUrl.substring(0, rtnUrl.lastIndexOf('_k=') - 1);
			}
		}
	}

	return rtnUrl;
}

function trackPageView() {
	return function (dispatch, getState) {
		var state = getState();
		// Defined dimensions:
		// dimension1 = forumId - hit
		// dimension2 = appType - session
		// dimension3 = forumUserGroup - hit
		var page = getTrackingUrl(state),
		    f_analytics_id = state.topifyPresets.forumSite.f_analytics_id,
		    f_id = state.topifyPresets.forumSite.f_id + '',
		    usergroup = typeof state.ustate.displaygrouptitle !== 'undefined' && state.ustate.displaygrouptitle ? state.ustate.displaygrouptitle : 'guest',
		    data = {
			page: page,
			appName: 'Topify Browser V3',
			dimension1: f_id,
			dimension3: usergroup
		};

		ga(analyticsTrackerName + '.set', data);
		ga(analyticsTrackerName + '.send', 'pageview');
		topifyConsole.info('GA PAGEVIEW ', data);

		if (f_analytics_id && isValidAnalyticsID(f_analytics_id)) {
			if (is.VS) {
				// We do special handling for VerticalScope forums to record a specific domain
				// as well as the current user's group in a custom variable.
				if ("production" === 'production' && _gaq) {
					_gaq.push(['_setAccount', f_analytics_id], ['_setDomainName', state.topifyPresets.forumSite.f_site_name], ['_setCustomVar', 1, 'grp', usergroup], ['_setCustomVar', 2, 'topify', '1'], ['_trackPageview', page]);
					topifyConsole.info('GA PAGEVIEW (VS) - analyticsId: ' + f_analytics_id + ' - page: ' + page + ' - forumSiteId: ' + f_id + ' - domain: ' + state.topifyPresets.forumSite.f_site_name + ' - group: ' + usergroup + ' - topify: 1');
				}
			} else {
				// all non VS
				ga(function () {
					if (!ga.getByName(f_id)) {
						ga('create', f_analytics_id, { name: f_id });
						topifyConsole.info('GA PAGEVIEW - create tracker: ' + f_analytics_id + ' - forumId: ' + f_id);
					}
					data = {
						page: page,
						appName: 'Topify Browser V3'
					};

					ga(f_id + '.set', data);
					ga(f_id + '.send', 'pageview');

					topifyConsole.info('GA PAGEVIEW - analyticsId: ' + f_analytics_id + ' - data: ', data);
				});
			}
		}
	};
}
function trackGAEvent(useForumAnalyticsId) {
	var label = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'unknown';
	var optionalCategory = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'topify';
	var optionalAction = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'event';
	var optionalValue = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
	var optionalForcedPage = arguments[5];

	return function (dispatch, getState) {
		var state = getState();
		var page = optionalForcedPage || getTrackingUrl(state),
		    f_analytics_id = state.topifyPresets.forumSite.f_analytics_id,
		    f_id = state.topifyPresets.forumSite.f_id + '',
		    usergroup = typeof state.ustate.displaygrouptitle !== 'undefined' && state.ustate.displaygrouptitle ? state.ustate.displaygrouptitle : 'guest',
		    data = {
			hitType: 'event',
			eventCategory: optionalCategory,
			eventAction: optionalAction,
			eventLabel: label,
			eventValue: optionalValue,

			page: page,
			dimension1: f_id,
			dimension3: usergroup
		};

		ga(function () {
			ga(analyticsTrackerName + '.send', data);
			topifyConsole.log('GA EVENT - analyticsId: ' + f_analytics_id + ' - data: ', data);
		});

		if (useForumAnalyticsId && f_analytics_id && isValidAnalyticsID(f_analytics_id)) {
			// reset values for forum analytics
			optionalCategory = 'topify';
			optionalAction = 'event';

			if (is.VS) {
				// We do special handling for VerticalScope forums to record a specific domain
				// as well as the current user's group in a custom variable.
				if ("production" === 'production' && _gaq) {
					_gaq.push(['_setAccount', f_analytics_id], ['_set', 'page', page], ['_setDomainName', state.topifyPresets.forumSite.f_site_name], ['_setCustomVar', 1, 'grp', usergroup], ['_setCustomVar', 2, 'topify', '1'], ['_trackEvent', optionalCategory, optionalAction, label, optionalValue, true]);
					topifyConsole.log('GA EVENT (VS) - analyticsId: ' + f_analytics_id + ' - page: ' + page + ' - forumSiteId: ' + f_id + ' - domain: ' + state.topifyPresets.forumSite.f_site_name + ' - group: ' + usergroup + ' - topify: 1 - ' + optionalCategory + ' - ' + optionalAction + ' - ' + label + ' - ' + optionalValue);
				}
			} else {
				// all non VS
				data.eventCategory = 'topify';
				data.eventAction = 'event';
				data.appName = 'Topify Browser V3';
				delete data.dimension1;
				delete data.dimension3;

				ga(function () {
					ga(f_id + '.send', data);
					topifyConsole.log('GA EVENT - analyticsId: ' + f_analytics_id + ' - forumId: ' + f_id + ' - data: ', data);
				});
			}
		}
	};
}

// Gets user location if they allow us
function getGeoLocation() {
	return function (dispatch, getState) {
		var state = getState();
		var geoLocation = {
			allow: true,
			error: false,
			latitude: '',
			longitude: '',
			timestamp: 0
		};

		if (state.ads.geoLocation.allow === false) {
			topifyConsole.info('geoLocation NOT allowed');
			return;
		}

		// Checking last geo check
		if (!useSSL || new Date().getTime() - geoLocationRefresh < state.ads.geoLocation.timestamp) {
			return true;
		}

		geoLocation.timestamp = new Date().getTime();

		navigator.geolocation.getCurrentPosition(function (position) {
			geoLocation.latitude = position.coords.latitude;
			geoLocation.longitude = position.coords.longitude;
			topifyConsole.log('geoLocation updated: ', geoLocation);

			// Updating googletag targeting
			if (window.googletag) {
				topifyConsole.log('Targetting googleads geoLocation');

				window.googletag.cmd.push(function () {
					googletag.pubads().setLocation(geoLocation.latitude, geoLocation.longitude);
				});
			}
			dispatch(setGeoLocation(geoLocation));
		}, function (error) {
			switch (error.code) {
				case error.PERMISSION_DENIED:
					geoLocation.allow = false;
					break;
				case error.POSITION_UNAVAILABLE:
				case error.TIMEOUT:
				case error.UNKNOWN_ERROR:
					geoLocation.error = true;
					break;
			}
			dispatch(setGeoLocation(geoLocation));
		}, {
			timeout: 10 * 1000
		});
	};
}

// Init Ads: check and loads general libraries, on first load
function initAdLibraries() {
	topifyConsole.info('Init Ads');

	return function (dispatch, getState) {
		var state = getState();

		// pass in the target node, as well as the observer options
		_mutationObserver_Head.observe(getHead(), observerConfig);
		_mutationObserver_Body.observe(getBody(), observerConfig);

		// Run pre-options
		isVS(state);
		dispatch(isLoggedIn());

		// We need to load these libraries as soon as possible
		loadIframeMessenger(state);

		isLotame(state);
		loadVSAPI(state);

		get_ExelateUrl(state);

		initEvents(dispatch);

		// Load the libraries
		initGoogleAds(state);
		addLotame();
		addLotame_ccauds();
		addVibrantjs(state);
		addCustomScripts(state);
		isNetseer(state);
		loadNetSeer(state);

		addComScore(state);
		addShareThrough(state);

		// First load
		addExelate(state);
	};
}

// On every page view
function onPageView() {
	var triggerValues = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

	topifyConsole.info('Ads onPageView', triggerValues);

	pageCounter++;

	if (pageCounter > 1) {
		cleanOldAdElements();
	}

	if (triggerValues && 'undefined' !== typeof triggerValues.captify) {
		// Captify needs to be triggered once per section
		triggerCaptify(triggerValues.captify);
	}

	return function (dispatch, getState) {
		var state = getState();

		dispatch(isLoggedIn());
		addSwoop(state);
		loadViglink(state);
		loadSolveMedia(state);
		loadNetSeer(state);

		dispatch(setGPTCorrelator(true));

		if (pageCounter > 1) {
			dispatch(getGeoLocation());
			trackComScore(state);
			refreshLotame();
			addCustomScripts(state);
			refreshVSAPI(state);
			refreshGoogleAds(state);
			addExelate(state);
		} else {
			refreshGoogleAds(state);
		}

		if (goInterstitial()) {
			dispatch(showInterstitial());
		} else if (state.ads.showInterstitial) {
			dispatch(hideInterstitial());
		}
	};
}

/***/ }),

/***/ 40:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export addPhotoGalleryItems */
/* harmony export (immutable) */ __webpack_exports__["e"] = fetchThread;
/* harmony export (immutable) */ __webpack_exports__["c"] = deletePosts;
/* harmony export (immutable) */ __webpack_exports__["d"] = doPollVote;
/* harmony export (immutable) */ __webpack_exports__["f"] = markAsRead;
/* harmony export (immutable) */ __webpack_exports__["g"] = reportPost;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_Actions_MetaActions__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_Actions_InfiniteScrollActions__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_Actions_GlobalMetaActions__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_Actions_PhotoGalleryActions__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_Actions_adsActions__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_Actions_UiActions__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_Actions_UserSettingsActions__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_Actions_responseNormalizer__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_Common_actions_ThreadviewActions__ = __webpack_require__(221);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_9_Common_actions_ThreadviewActions__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_9_Common_actions_ThreadviewActions__["d"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_9_Common_actions_ThreadviewActions__["h"]; });















function addPhotoGalleryItems(response) {
	var attachments = response.entities.attachments;
	return function (dispatch) {
		response.result.attachments.forEach(function (id) {
			var attachment = attachments[id];
			dispatch(Object(__WEBPACK_IMPORTED_MODULE_4_Actions_PhotoGalleryActions__["f" /* addPhoto */])({
				id: id,
				src: attachment.href,
				thumbnail: attachment.href_thumbnail ? attachment.href_thumbnail : attachment.href,
				w: 0,
				h: 0,
				postId: attachment.post
			}));
		});
	};
}

function fetchThread(thread) {
	var cacheBust = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;


	return function (dispatch, getState) {
		thread.loadingBehavior = Object(__WEBPACK_IMPORTED_MODULE_2_Actions_InfiniteScrollActions__["e" /* getLoadingBehavior */])(getState, thread.id, "thread", thread.page, thread.postid ? true : thread.forceRefresh);

		if (Object(__WEBPACK_IMPORTED_MODULE_2_Actions_InfiniteScrollActions__["g" /* shouldNotUpdateState */])(getState, thread)) {
			dispatch(Object(__WEBPACK_IMPORTED_MODULE_2_Actions_InfiniteScrollActions__["i" /* updatePagesResult */])(thread.page || 1));
			return null;
		}

		dispatch(Object(__WEBPACK_IMPORTED_MODULE_9_Common_actions_ThreadviewActions__["g" /* requestThread */])(thread));

		var state = getState();
		var url = state.topifyPresets.forumSite.url;

		var userID = state.ustate.id ? state.ustate.id : 0;
		var goto = thread.postid ? '&goto=true&postid=' + thread.postid : '&id=' + thread.id;
		var page = thread.postid ? '' : thread.page ? '&page=' + thread.page : '&page=0'; // if we have a postid skip the page

		// Avoid Cache if cacheBust is required
		var fetchConfig = dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_Actions_GlobalMetaActions__["e" /* getFetchConfig */])(cacheBust)),
		    cacheBustQueryString = '&_=' + (cacheBust ? cacheBust : Object(__WEBPACK_IMPORTED_MODULE_1_Actions_MetaActions__["a" /* getCacheBuster */])(getState) || 0),
		    lb = Object(__WEBPACK_IMPORTED_MODULE_7_Actions_UserSettingsActions__["f" /* mapLoadingBehaviour */])(state.ui.userSettings.loadingBehavior),
		    page_size = dispatch(Object(__WEBPACK_IMPORTED_MODULE_7_Actions_UserSettingsActions__["d" /* getPageSize */])());

		return fetch(url + ('?v=3.0&ajax=1&uid=' + userID + '&req=topic' + goto + '&pagesize=' + page_size + page + '&lb=' + lb + cacheBustQueryString), fetchConfig).then(function (response) {
			if (!response.ok) {
				try {
					response.json().then(function (json) {
						Object(__WEBPACK_IMPORTED_MODULE_3_Actions_GlobalMetaActions__["j" /* setGlobalNotification */])(dispatch, json, response);
					}).catch(function () {
						Object(__WEBPACK_IMPORTED_MODULE_3_Actions_GlobalMetaActions__["j" /* setGlobalNotification */])(dispatch, {}, response);
					});
				} catch (e) {
					Object(__WEBPACK_IMPORTED_MODULE_3_Actions_GlobalMetaActions__["j" /* setGlobalNotification */])(dispatch, {}, response);
				}

				dispatch(Object(__WEBPACK_IMPORTED_MODULE_9_Common_actions_ThreadviewActions__["e" /* failedThread */])(thread, 'Bad response from server'));
				dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_Actions_GlobalMetaActions__["b" /* backInHistory */])());
			} else {
				response.json().then(function (json) {
					Object(__WEBPACK_IMPORTED_MODULE_3_Actions_GlobalMetaActions__["j" /* setGlobalNotification */])(dispatch, json, { ok: true });

					var other = Object.assign({}, { page: json.post.meta.page }, json.post ? json.post.meta : {});

					var result = Object(__WEBPACK_IMPORTED_MODULE_8_Actions_responseNormalizer__["a" /* responseNormalizer */])(json, thread.page, other);

					thread.id = result.threadid;
					thread.page = json.post.meta.page;
					var forumTitle = state.topifyPresets.forumSite.f_title;

					dispatch(Object(__WEBPACK_IMPORTED_MODULE_1_Actions_MetaActions__["b" /* receiveGlobalMeta */])(json.post.meta, result.entities.topics[result.result.topics[0]].title, forumTitle));

					dispatch(Object(__WEBPACK_IMPORTED_MODULE_8_Actions_responseNormalizer__["b" /* updateUstate */])(json, result));

					dispatch(addPhotoGalleryItems(result));
					dispatch(Object(__WEBPACK_IMPORTED_MODULE_2_Actions_InfiniteScrollActions__["d" /* fetchSuccess */])(result.threadid, "thread", result.page, result.totalPages, thread.loadingBehavior));
					dispatch(Object(__WEBPACK_IMPORTED_MODULE_9_Common_actions_ThreadviewActions__["f" /* receiveThread */])(thread, result));
				});
			}
		}).then(function () {
			Object(__WEBPACK_IMPORTED_MODULE_3_Actions_GlobalMetaActions__["k" /* setLastGlobalAction */])('thread', thread);
		}).catch(function (error) {
			Object(__WEBPACK_IMPORTED_MODULE_3_Actions_GlobalMetaActions__["j" /* setGlobalNotification */])(dispatch, {}, error);
			dispatch(Object(__WEBPACK_IMPORTED_MODULE_9_Common_actions_ThreadviewActions__["e" /* failedThread */])(thread, 'Bad response from server'));
			dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_Actions_GlobalMetaActions__["b" /* backInHistory */])());
		});
	};
}

/**
 *
 * @param postsId
 * @param actionState bool true: delete | false: undelete
 * @returns {Function}
 */
function deletePosts(postsId) {
	var actionState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

	return function (dispatch, getState) {
		topifyConsole.log('Delete Posts', postsId);
		var state = getState(),
		    url = state.topifyPresets.forumSite.url,
		    userID = state.ustate.id ? state.ustate.id : 0,
		    newState = actionState ? "1" : "-1";

		var postids = [];
		postsId.forEach(function (postid) {
			postids.push('relpostid[]=' + postid);
		});
		postids = postids.join('&');

		var moreData = '&req=post&state=' + newState + '&type=moderate&action=delete';

		var fetchConfig = dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_Actions_GlobalMetaActions__["e" /* getFetchConfig */])(true, 'POST', postids));

		dispatch(Object(__WEBPACK_IMPORTED_MODULE_6_Actions_UiActions__["O" /* showGlobalLoading */])('Processing'));

		return fetch(url + ('?v=3.0&ajax=1&uid=' + userID + moreData), fetchConfig).then(function (response) {
			if (!response.ok) {
				try {
					response.json().then(function (json) {
						Object(__WEBPACK_IMPORTED_MODULE_3_Actions_GlobalMetaActions__["j" /* setGlobalNotification */])(dispatch, json, response);
					}).catch(function () {
						Object(__WEBPACK_IMPORTED_MODULE_3_Actions_GlobalMetaActions__["j" /* setGlobalNotification */])(dispatch, {}, response);
					});
				} catch (e) {
					Object(__WEBPACK_IMPORTED_MODULE_3_Actions_GlobalMetaActions__["j" /* setGlobalNotification */])(dispatch, {}, response);
				}

				dispatch(Object(__WEBPACK_IMPORTED_MODULE_9_Common_actions_ThreadviewActions__["e" /* failedThread */])(thread, 'Bad response from server'));
				dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_Actions_GlobalMetaActions__["b" /* backInHistory */])());
			} else {
				response.json().then(function (json) {
					Object(__WEBPACK_IMPORTED_MODULE_3_Actions_GlobalMetaActions__["j" /* setGlobalNotification */])(dispatch, json, { ok: true });
					if (json.state) {
						var count = json.result.postid.length,
						    message = count + ' post' + (count === 1 ? ' was' : 's were') + ' ' + (json.result.isDeleted ? 'deleted' : 'undeleted');
						Object(__WEBPACK_IMPORTED_MODULE_6_Actions_UiActions__["B" /* displayNotification */])('success', message);

						if (state.meta.permissions && state.meta.permissions.candeleteposts) {
							// is Mod
							// Record the Google Analytics event and for the forum.
							dispatch(Object(__WEBPACK_IMPORTED_MODULE_5_Actions_adsActions__["A" /* trackGAEvent */])(true, actionState ? 'modDeletePosts' : 'modUndeletePosts', 'moderatorAction', 'topic'));
						} else {
							// is regular user
							// Record the Google Analytics event and for the forum.
							dispatch(Object(__WEBPACK_IMPORTED_MODULE_5_Actions_adsActions__["A" /* trackGAEvent */])(true, 'deletePost', 'userAction', 'creation'));
						}
					} else {
						Object(__WEBPACK_IMPORTED_MODULE_6_Actions_UiActions__["B" /* displayNotification */])('warning', 'Some error happened. Try again.');
					}
				});
			}
		}).then(function () {
			dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_Actions_GlobalMetaActions__["h" /* refreshPage */])());
			dispatch(Object(__WEBPACK_IMPORTED_MODULE_6_Actions_UiActions__["D" /* hideGlobalLoading */])());
		}).catch(function (error) {
			dispatch(Object(__WEBPACK_IMPORTED_MODULE_6_Actions_UiActions__["D" /* hideGlobalLoading */])());
			Object(__WEBPACK_IMPORTED_MODULE_3_Actions_GlobalMetaActions__["j" /* setGlobalNotification */])(dispatch, {}, error);
			dispatch(Object(__WEBPACK_IMPORTED_MODULE_9_Common_actions_ThreadviewActions__["e" /* failedThread */])(thread, 'Bad response from server'));
			dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_Actions_GlobalMetaActions__["b" /* backInHistory */])());
		});
	};
}

function doPollVote(vote) {
	return function (dispatch, getState) {
		var state = getState(),
		    url = state.topifyPresets.forumSite.url + '?v=3.0&ajax=1&req=post&uid=' + state.ustate.id,
		    voteBody = 'type=vote&pollid=' + vote.pollID + '&topic=' + vote.topic + '&votes=' + vote.votes;

		var config = dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_Actions_GlobalMetaActions__["e" /* getFetchConfig */])(true, 'POST', voteBody));

		return fetch(url, config).then(function (response) {
			if (!response.ok) {
				try {
					response.json().then(function (json) {
						Object(__WEBPACK_IMPORTED_MODULE_3_Actions_GlobalMetaActions__["j" /* setGlobalNotification */])(dispatch, json, response);
					}).catch(function () {
						Object(__WEBPACK_IMPORTED_MODULE_3_Actions_GlobalMetaActions__["j" /* setGlobalNotification */])(dispatch, {}, response);
					});
				} catch (e) {
					Object(__WEBPACK_IMPORTED_MODULE_3_Actions_GlobalMetaActions__["j" /* setGlobalNotification */])(dispatch, {}, response);
				}
			} else {
				response.json().then(function (json) {
					dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_Actions_GlobalMetaActions__["h" /* refreshPage */])());
					Object(__WEBPACK_IMPORTED_MODULE_6_Actions_UiActions__["B" /* displayNotification */])('info', 'You have voted');
					// Record the Google Analytics event.
					dispatch(Object(__WEBPACK_IMPORTED_MODULE_5_Actions_adsActions__["A" /* trackGAEvent */])(false, 'pollVote', 'userAction', 'creation'));
				});
			}
		});
	};
}

function markAsRead(itemIds, type) {
	return function (dispatch, getState) {
		var state = getState(),
		    url = state.topifyPresets.forumSite.url,
		    userID = state.ustate.id ? state.ustate.id : 0;

		topifyConsole.log('Mark ' + type + ' as read', itemIds);

		if (!itemIds || !type) {
			return false;
		}

		var moreData = [],
		    analyticsEvent = null;

		switch (type) {
			case 'forums':
				moreData.push('forumid=' + itemIds);
				analyticsEvent = 'forumMarkedRead';
				break;

			case 'topics':
				itemIds = isNaN(itemIds) && itemIds.length ? itemIds : [itemIds];
				itemIds.forEach(function (item_id) {
					moreData.push('topicid[]=' + item_id);
				});
				analyticsEvent = 'topicMarkedRead';
				break;

			case 'announcement':
				moreData.push('type=markread');
				moreData.push('announcementid=' + itemIds);
				analyticsEvent = 'announcementMarkedRead';
				break;
		}
		moreData = moreData.join('&');

		var fetchConfig = dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_Actions_GlobalMetaActions__["e" /* getFetchConfig */])(true, 'POST', moreData));

		if (type !== 'announcement') {
			dispatch(Object(__WEBPACK_IMPORTED_MODULE_6_Actions_UiActions__["O" /* showGlobalLoading */])('Processing'));
		}

		return fetch(url + ('?v=3.0&ajax=1&uid=' + userID + '&req=post&type=markread'), fetchConfig).then(function (response) {
			if (!response.ok) {
				try {
					response.json().then(function (json) {
						Object(__WEBPACK_IMPORTED_MODULE_3_Actions_GlobalMetaActions__["j" /* setGlobalNotification */])(dispatch, json, response);
					}).catch(function () {
						Object(__WEBPACK_IMPORTED_MODULE_3_Actions_GlobalMetaActions__["j" /* setGlobalNotification */])(dispatch, {}, response);
					});
				} catch (e) {
					Object(__WEBPACK_IMPORTED_MODULE_3_Actions_GlobalMetaActions__["j" /* setGlobalNotification */])(dispatch, {}, response);
				}
			} else {
				response.json().then(function (json) {
					Object(__WEBPACK_IMPORTED_MODULE_3_Actions_GlobalMetaActions__["j" /* setGlobalNotification */])(dispatch, json, { ok: true });

					if (analyticsEvent) {
						// Record the Google Analytics event.
						dispatch(Object(__WEBPACK_IMPORTED_MODULE_5_Actions_adsActions__["A" /* trackGAEvent */])(false, analyticsEvent, 'userAction', 'consumption'));
					}
					if (type !== 'announcement') {
						dispatch(Object(__WEBPACK_IMPORTED_MODULE_1_Actions_MetaActions__["c" /* resetSelectedItem */])());
						dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_Actions_GlobalMetaActions__["h" /* refreshPage */])());
						dispatch(Object(__WEBPACK_IMPORTED_MODULE_6_Actions_UiActions__["D" /* hideGlobalLoading */])());
					}

					Object(__WEBPACK_IMPORTED_MODULE_6_Actions_UiActions__["B" /* displayNotification */])('info', 'Successfully marked as read', { force: true, timeout: 1500 });
				});
			}
		}).catch(function (error) {
			dispatch(Object(__WEBPACK_IMPORTED_MODULE_6_Actions_UiActions__["D" /* hideGlobalLoading */])());
			Object(__WEBPACK_IMPORTED_MODULE_3_Actions_GlobalMetaActions__["j" /* setGlobalNotification */])(dispatch, {}, error);
		});
	};
}

function reportPost(postId) {

	return function (dispatch, getState) {
		var state = getState(),
		    url = state.topifyPresets.forumSite.url,
		    userID = state.ustate.id ? state.ustate.id : 0;

		topifyConsole.log('Reporting Post', postId);

		if (!postId) {
			return false;
		}

		var moreData = "relpostid=" + postId;

		var fetchConfig = dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_Actions_GlobalMetaActions__["e" /* getFetchConfig */])(true, 'POST', moreData));

		return fetch(url + ('?v=3.0&ajax=1&uid=' + userID + '&req=post&type=report'), fetchConfig).then(function (response) {
			if (!response.ok) {
				try {
					response.json().then(function (json) {
						Object(__WEBPACK_IMPORTED_MODULE_3_Actions_GlobalMetaActions__["j" /* setGlobalNotification */])(dispatch, json, response);
					}).catch(function () {
						Object(__WEBPACK_IMPORTED_MODULE_3_Actions_GlobalMetaActions__["j" /* setGlobalNotification */])(dispatch, {}, response);
					});
				} catch (e) {
					Object(__WEBPACK_IMPORTED_MODULE_3_Actions_GlobalMetaActions__["j" /* setGlobalNotification */])(dispatch, {}, response);
				}
			} else {
				response.json().then(function (json) {
					Object(__WEBPACK_IMPORTED_MODULE_3_Actions_GlobalMetaActions__["j" /* setGlobalNotification */])(dispatch, json, { ok: true });
					// Record the Google Analytics event.
					dispatch(Object(__WEBPACK_IMPORTED_MODULE_5_Actions_adsActions__["A" /* trackGAEvent */])(false, "postReported", 'userAction', 'consumption'));
					Object(__WEBPACK_IMPORTED_MODULE_6_Actions_UiActions__["B" /* displayNotification */])('info', 'Post successfully reported');
				});
			}
		}).catch(function (error) {
			dispatch(Object(__WEBPACK_IMPORTED_MODULE_6_Actions_UiActions__["D" /* hideGlobalLoading */])());
			Object(__WEBPACK_IMPORTED_MODULE_3_Actions_GlobalMetaActions__["j" /* setGlobalNotification */])(dispatch, {}, error);
		});
	};
}

/***/ }),

/***/ 562:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/normalize.css/normalize.css
var normalize = __webpack_require__(563);
var normalize_default = /*#__PURE__*/__webpack_require__.n(normalize);

// EXTERNAL MODULE: ./src/styles/app.scss
var app = __webpack_require__(564);
var app_default = /*#__PURE__*/__webpack_require__.n(app);

// EXTERNAL MODULE: ./node_modules/react/react.js
var react = __webpack_require__(1);
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/react-dom/index.js
var react_dom = __webpack_require__(69);
var react_dom_default = /*#__PURE__*/__webpack_require__.n(react_dom);

// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 14 modules
var es = __webpack_require__(3);

// EXTERNAL MODULE: ./node_modules/react-router/es/index.js + 32 modules
var react_router_es = __webpack_require__(115);

// EXTERNAL MODULE: ./src/styles/forumview.scss
var forumview = __webpack_require__(148);
var forumview_default = /*#__PURE__*/__webpack_require__.n(forumview);

// EXTERNAL MODULE: ./src/styles/homepage.scss
var homepage = __webpack_require__(669);
var homepage_default = /*#__PURE__*/__webpack_require__.n(homepage);

// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(2);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);

// EXTERNAL MODULE: ./node_modules/reselect/lib/index.js
var lib = __webpack_require__(24);
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);

// CONCATENATED MODULE: ./src/selectors/metaSelector.js
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



var metaSelector = function metaSelector(state) {
	return state.meta;
};
var routingSelector = function routingSelector(state) {
	return state.routing;
};
var userPermissionsSelector = function userPermissionsSelector(state) {
	return state.ustate.perms;
};

/* harmony default export */ var selectors_metaSelector = (Object(lib["createSelector"])([metaSelector, routingSelector, userPermissionsSelector], function (meta, routing, userPermissions) {
	return _extends({}, meta, {
		userPermissions: userPermissions,
		routing: routing
	});
}));
// CONCATENATED MODULE: ./src/selectors/rootViewSelector.js



var forumviewSelector = function forumviewSelector(state) {
	return state.forumview.forumId ? state.forumview : state.searchresult;
};
var topifyPresetsSelector = function topifyPresetsSelector(state) {
	return state.topifyPresets;
};
var userStateSelector = function userStateSelector(state) {
	return state.ustate;
};
var uiStateSelector = function uiStateSelector(state) {
	return state.ui;
};

/* harmony default export */ var rootViewSelector = (Object(lib["createSelector"])([forumviewSelector, selectors_metaSelector, topifyPresetsSelector, userStateSelector, uiStateSelector], function (forumview, meta, topifyPresets, ustate, ui) {
	return {
		forumview: forumview,
		meta: meta,
		ustate: ustate,
		userSettings: ui.userSettings,
		forumSite: topifyPresets.forumSite,
		firstLoad: topifyPresets.firstLoad,
		initialRoute: topifyPresets.initialRoute,
		userInfo: topifyPresets.userInfo
	};
}));
// EXTERNAL MODULE: ./src/actions/GlobalMetaActions.js
var GlobalMetaActions = __webpack_require__(14);

// EXTERNAL MODULE: ./src/actions/MetaActions.js
var MetaActions = __webpack_require__(17);

// EXTERNAL MODULE: ./src/actions/WidgetActions.js
var WidgetActions = __webpack_require__(105);

// EXTERNAL MODULE: ./src/actions/adsActions.js
var adsActions = __webpack_require__(4);

// CONCATENATED MODULE: ./src/selectors/widgetsSelector.js



var widgetSelector = function widgetSelector(state) {
	return state.widgetState;
};
var widgetsSelector_userStateSelector = function userStateSelector(state) {
	return state.ustate;
};

/* harmony default export */ var widgetsSelector = (Object(lib["createSelector"])([widgetSelector, selectors_metaSelector, widgetsSelector_userStateSelector], function (widget, meta, ustate) {
	return {
		widgetState: widget,
		meta: meta,
		ustate: ustate
	};
}));
// EXTERNAL MODULE: ./node_modules/react-router-redux/lib/index.js
var react_router_redux_lib = __webpack_require__(6);
var react_router_redux_lib_default = /*#__PURE__*/__webpack_require__.n(react_router_redux_lib);

// EXTERNAL MODULE: ./src/styles/usericon.scss
var usericon = __webpack_require__(688);
var usericon_default = /*#__PURE__*/__webpack_require__.n(usericon);

// EXTERNAL MODULE: ./node_modules/lodash/isEqual.js
var isEqual = __webpack_require__(41);
var isEqual_default = /*#__PURE__*/__webpack_require__.n(isEqual);

// EXTERNAL MODULE: ./src/actions/UiActions.js
var UiActions = __webpack_require__(10);

// CONCATENATED MODULE: ./src/components/svg/SvgIcon.js



var SvgIcon_SvgIcon = function SvgIcon(props) {

	var style = {
		fill: 'currentColor',
		height: props.size,
		width: props.size
	};

	var icons = {
		account_circle: react_default.a.createElement(
			'svg',
			{ style: style, viewBox: '0 0 24 24' },
			react_default.a.createElement('path', { d: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 3c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zm0 14.2c-2.5 0-4.71-1.28-6-3.22.03-1.99 4-3.08 6-3.08 1.99 0 5.97 1.09 6 3.08-1.29 1.94-3.5 3.22-6 3.22z' }),
			react_default.a.createElement('path', { d: 'M0 0h24v24H0z', fill: 'none' })
		),
		hamburger: react_default.a.createElement(
			'svg',
			{ style: style, viewBox: '0 0 24 24' },
			react_default.a.createElement('path', { d: 'M0 0h24v24H0z', fill: 'none' }),
			react_default.a.createElement('path', { d: 'M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z' })
		),
		arrow_back: react_default.a.createElement(
			'svg',
			{ style: style, viewBox: '0 0 24 24' },
			react_default.a.createElement('path', { d: 'M0 0h24v24H0z', fill: 'none' }),
			react_default.a.createElement('path', { d: 'M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z' })
		),
		search: react_default.a.createElement(
			'svg',
			{ style: style, viewBox: '0 0 24 24' },
			react_default.a.createElement('path', { d: 'M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z' }),
			react_default.a.createElement('path', { d: 'M0 0h24v24H0z', fill: 'none' })
		),
		link: react_default.a.createElement(
			'svg',
			{ style: style, viewBox: '0 0 24 24' },
			react_default.a.createElement('path', { d: 'M0 0h24v24H0z', fill: 'none' }),
			react_default.a.createElement('path', { d: 'M3.9 12c0-1.71 1.39-3.1 3.1-3.1h4V7H7c-2.76 0-5 2.24-5 5s2.24 5 5 5h4v-1.9H7c-1.71 0-3.1-1.39-3.1-3.1zM8 13h8v-2H8v2zm9-6h-4v1.9h4c1.71 0 3.1 1.39 3.1 3.1s-1.39 3.1-3.1 3.1h-4V17h4c2.76 0 5-2.24 5-5s-2.24-5-5-5z' })
		),
		subscribe: react_default.a.createElement(
			'svg',
			{ style: style, viewBox: '0 0 24 24' },
			react_default.a.createElement('path', { d: 'M0 0h24v24H0z', fill: 'none' }),
			react_default.a.createElement('path', { d: 'M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z' }),
			react_default.a.createElement('path', { d: 'M0 0h24v24H0z', fill: 'none' })
		),
		alarm: react_default.a.createElement(
			'svg',
			{ style: style, viewBox: '0 0 24 24' },
			react_default.a.createElement('path', { d: 'M0 0h24v24H0z', fill: 'none' }),
			react_default.a.createElement('path', { d: 'M22 5.72l-4.6-3.86-1.29 1.53 4.6 3.86L22 5.72zM7.88 3.39L6.6 1.86 2 5.71l1.29 1.53 4.59-3.85zM12.5 8H11v6l4.75 2.85.75-1.23-4-2.37V8zM12 4c-4.97 0-9 4.03-9 9s4.02 9 9 9c4.97 0 9-4.03 9-9s-4.03-9-9-9zm0 16c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7z' })
		),
		clock: react_default.a.createElement(
			'svg',
			{ style: style, viewBox: '0 0 24 24' },
			react_default.a.createElement('path', { d: 'M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z' }),
			react_default.a.createElement('path', { d: 'M0 0h24v24H0z', fill: 'none' }),
			react_default.a.createElement('path', { d: 'M12.5 7H11v6l5.25 3.15.75-1.23-4.5-2.67z' })
		),
		forum: react_default.a.createElement(
			'svg',
			{ style: style, viewBox: '0 0 24 24' },
			react_default.a.createElement('path', { d: 'M0 0h24v24H0z', fill: 'none' }),
			react_default.a.createElement('path', { d: 'M21 6h-2v9H6v2c0 .55.45 1 1 1h11l4 4V7c0-.55-.45-1-1-1zm-4 6V3c0-.55-.45-1-1-1H3c-.55 0-1 .45-1 1v14l4-4h10c.55 0 1-.45 1-1z' })
		),
		message: react_default.a.createElement(
			'svg',
			{ style: style, viewBox: '0 0 24 24' },
			react_default.a.createElement('path', { d: 'M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-2 12H6v-2h12v2zm0-3H6V9h12v2zm0-3H6V6h12v2z' }),
			react_default.a.createElement('path', { d: 'M0 0h24v24H0z', fill: 'none' })
		),
		notification: react_default.a.createElement(
			'svg',
			{ style: style, viewBox: '0 0 24 24' },
			react_default.a.createElement('path', { d: 'M12 22c1.1 0 2-.9 2-2h-4c0 1.1.89 2 2 2zm6-6v-5c0-3.07-1.64-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.63 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2z' })
		),
		text: react_default.a.createElement(
			'svg',
			{ style: style, viewBox: '0 0 24 24' },
			react_default.a.createElement('path', { 'clip-rule': 'evenodd', d: 'M17.986,16.001c0,0.274-0.223,0.499-0.5,0.499H0.5c-0.275,0-0.5-0.225-0.5-0.499  V14c0-0.275,0.225-0.5,0.5-0.5h16.986c0.277,0,0.5,0.225,0.5,0.5V16.001z M21.986,8c0-0.275-0.223-0.5-0.5-0.5H0.5  C0.225,7.5,0,7.725,0,8v2.001C0,10.275,0.225,10.5,0.5,10.5h20.986c0.277,0,0.5-0.225,0.5-0.499V8z M13.986,2  c0-0.275-0.223-0.5-0.5-0.5H0.5C0.225,1.5,0,1.725,0,2v2.001C0,4.275,0.225,4.5,0.5,4.5h12.986c0.277,0,0.5-0.225,0.5-0.499V2z   M24,20c0-0.275-0.225-0.5-0.5-0.5h-23C0.225,19.5,0,19.725,0,20v2.001C0,22.275,0.225,22.5,0.5,22.5h23  c0.275,0,0.5-0.225,0.5-0.499V20z',
				'fill-rule': 'evenodd' })
		),
		cancel: react_default.a.createElement(
			'svg',
			{ style: style, viewBox: '0 0 24 24' },
			react_default.a.createElement('path', { d: 'M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z' }),
			react_default.a.createElement('path', { d: 'M0 0h24v24H0z', fill: 'none' })
		),
		clear: react_default.a.createElement(
			'svg',
			{ style: style, viewBox: '0 0 24 24' },
			react_default.a.createElement('path', { d: 'M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z' }),
			react_default.a.createElement('path', { d: 'M0 0h24v24H0z', fill: 'none' })
		),
		angle_up: react_default.a.createElement(
			'svg',
			{ style: style, viewBox: '0 0 1792 1792' },
			react_default.a.createElement('path', { d: 'M1395 1184q0 13-10 23l-50 50q-10 10-23 10t-23-10l-393-393-393 393q-10 10-23 10t-23-10l-50-50q-10-10-10-23t10-23l466-466q10-10 23-10t23 10l466 466q10 10 10 23z' })
		),
		angle_down: react_default.a.createElement(
			'svg',
			{ style: style, viewBox: '0 0 1792 1792' },
			react_default.a.createElement('path', { d: 'M1395 736q0 13-10 23l-466 466q-10 10-23 10t-23-10l-466-466q-10-10-10-23t10-23l50-50q10-10 23-10t23 10l393 393 393-393q10-10 23-10t23 10l50 50q10 10 10 23z' })
		),
		angle_double_up: react_default.a.createElement(
			'svg',
			{ style: style, viewBox: '0 0 1792 1792' },
			react_default.a.createElement('path', { d: 'M1395 1312q0 13-10 23l-50 50q-10 10-23 10t-23-10l-393-393-393 393q-10 10-23 10t-23-10l-50-50q-10-10-10-23t10-23l466-466q10-10 23-10t23 10l466 466q10 10 10 23zm0-384q0 13-10 23l-50 50q-10 10-23 10t-23-10l-393-393-393 393q-10 10-23 10t-23-10l-50-50q-10-10-10-23t10-23l466-466q10-10 23-10t23 10l466 466q10 10 10 23z' })
		),
		angle_double_down: react_default.a.createElement(
			'svg',
			{ style: style, viewBox: '0 0 1792 1792' },
			react_default.a.createElement('path', { d: 'M1395 864q0 13-10 23l-466 466q-10 10-23 10t-23-10l-466-466q-10-10-10-23t10-23l50-50q10-10 23-10t23 10l393 393 393-393q10-10 23-10t23 10l50 50q10 10 10 23zm0-384q0 13-10 23l-466 466q-10 10-23 10t-23-10l-466-466q-10-10-10-23t10-23l50-50q10-10 23-10t23 10l393 393 393-393q10-10 23-10t23 10l50 50q10 10 10 23z' })
		),
		first_page: react_default.a.createElement(
			'svg',
			{ style: style, viewBox: '0 0 24 24' },
			react_default.a.createElement('path', { d: 'M18.41 16.59L13.82 12l4.59-4.59L17 6l-6 6 6 6zM6 6h2v12H6z' }),
			react_default.a.createElement('path', { d: 'M24 24H0V0h24v24z', fill: 'none' })
		),
		last_page: react_default.a.createElement(
			'svg',
			{ style: style, viewBox: '0 0 24 24' },
			react_default.a.createElement('path', { d: 'M5.59 7.41L10.18 12l-4.59 4.59L7 18l6-6-6-6zM16 6h2v12h-2z' }),
			react_default.a.createElement('path', { d: 'M0 0h24v24H0V0z', fill: 'none' })
		),
		mark_read: react_default.a.createElement(
			'svg',
			{ style: style, viewBox: '0 0 24 24' },
			react_default.a.createElement('path', { d: 'M21.99 8c0-.72-.37-1.35-.94-1.7L12 1 2.95 6.3C2.38 6.65 2 7.28 2 8v10c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2l-.01-10zM12 13L3.74 7.84 12 3l8.26 4.84L12 13z' }),
			react_default.a.createElement('path', { d: 'M0 0h24v24H0z', fill: 'none' })
		),
		mark_unread: react_default.a.createElement(
			'svg',
			{ style: style, viewBox: '0 0 24 24' },
			react_default.a.createElement('path', { d: 'M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z' }),
			react_default.a.createElement('path', { d: 'M0 0h24v24H0z', fill: 'none' })
		),
		clip: react_default.a.createElement(
			'svg',
			{ style: style, viewBox: '0 0 24 24' },
			react_default.a.createElement('path', { d: 'M2 12.5C2 9.46 4.46 7 7.5 7H18c2.21 0 4 1.79 4 4s-1.79 4-4 4H9.5C8.12 15 7 13.88 7 12.5S8.12 10 9.5 10H17v2H9.41c-.55 0-.55 1 0 1H18c1.1 0 2-.9 2-2s-.9-2-2-2H7.5C5.57 9 4 10.57 4 12.5S5.57 16 7.5 16H17v2H7.5C4.46 18 2 15.54 2 12.5z' }),
			react_default.a.createElement('path', { d: 'M0 0h24v24H0V0z', fill: 'none' })
		),
		attach_file: react_default.a.createElement(
			'svg',
			{ style: style, viewBox: '0 0 24 24' },
			react_default.a.createElement('path', { d: 'M16.5 6v11.5c0 2.21-1.79 4-4 4s-4-1.79-4-4V5c0-1.38 1.12-2.5 2.5-2.5s2.5 1.12 2.5 2.5v10.5c0 .55-.45 1-1 1s-1-.45-1-1V6H10v9.5c0 1.38 1.12 2.5 2.5 2.5s2.5-1.12 2.5-2.5V5c0-2.21-1.79-4-4-4S7 2.79 7 5v12.5c0 3.04 2.46 5.5 5.5 5.5s5.5-2.46 5.5-5.5V6h-1.5z' }),
			react_default.a.createElement('path', { d: 'M0 0h24v24H0z', fill: 'none' })
		),
		upload_file: react_default.a.createElement(
			'svg',
			{ style: style, viewBox: '0 0 24 24' },
			react_default.a.createElement('path', { d: 'M0 0h24v24H0z', fill: 'none' }),
			react_default.a.createElement('path', { d: 'M9 16h6v-6h4l-7-7-7 7h4zm-4 2h14v2H5z' })
		),
		more_vert: react_default.a.createElement(
			'svg',
			{ style: style, viewBox: '0 0 48 48' },
			react_default.a.createElement('path', { d: 'M24 16c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 4c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm0 12c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4z' })
		),
		more_horiz: react_default.a.createElement(
			'svg',
			{ style: style, viewBox: '0 0 48 48' },
			react_default.a.createElement('path', { d: 'M12 20c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm24 0c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm-12 0c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4z' })
		),
		error_outline: react_default.a.createElement(
			'svg',
			{ style: style, viewBox: '0 0 24 24' },
			react_default.a.createElement('path', { d: 'M0 0h24v24H0V0z', fill: 'none' }),
			react_default.a.createElement('path', { d: 'M11 15h2v2h-2zm0-8h2v6h-2zm.99-5C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z' })
		),
		info: react_default.a.createElement(
			'svg',
			{ style: style, viewBox: '0 0 24 24' },
			react_default.a.createElement('path', { d: 'M0 0h24v24H0z', fill: 'none' }),
			react_default.a.createElement('path', { d: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z' })
		),
		info_outline: react_default.a.createElement(
			'svg',
			{ style: style, viewBox: '0 0 24 24' },
			react_default.a.createElement('path', { d: 'M0 0h24v24H0z', fill: 'none' }),
			react_default.a.createElement('path', { d: 'M11 17h2v-6h-2v6zm1-15C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zM11 9h2V7h-2v2z' })
		),
		warning: react_default.a.createElement(
			'svg',
			{ style: style, viewBox: '0 0 24 24' },
			react_default.a.createElement('path', { d: 'M0 0h24v24H0z', fill: 'none' }),
			react_default.a.createElement('path', { d: 'M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z' })
		),
		reply: react_default.a.createElement(
			'svg',
			{ style: style, viewBox: '0 0 24 24' },
			react_default.a.createElement('path', { d: 'M10 9V5l-7 7 7 7v-4.1c5 0 8.5 1.6 11 5.1-1-5-4-10-11-11z' }),
			react_default.a.createElement('path', { d: 'M0 0h24v24H0z', fill: 'none' })
		),
		quote: react_default.a.createElement(
			'svg',
			{ style: style, viewBox: '0 0 24 24' },
			react_default.a.createElement('path', { d: 'M6 17h3l2-4V7H5v6h3zm8 0h3l2-4V7h-6v6h3z' }),
			react_default.a.createElement('path', { d: 'M0 0h24v24H0z', fill: 'none' })
		),
		add_circle: react_default.a.createElement(
			'svg',
			{ style: style, viewBox: '0 0 24 24' },
			react_default.a.createElement('path', { d: 'M0 0h24v24H0z', fill: 'none' }),
			react_default.a.createElement('path', { d: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm5 11h-4v4h-2v-4H7v-2h4V7h2v4h4v2z' })
		),
		send: react_default.a.createElement(
			'svg',
			{ style: style, viewBox: '0 0 24 24' },
			react_default.a.createElement('path', { d: 'M2.01 21L23 12 2.01 3 2 10l15 2-15 2z' }),
			react_default.a.createElement('path', { d: 'M0 0h24v24H0z', fill: 'none' })
		),
		edit: react_default.a.createElement(
			'svg',
			{ style: style, viewBox: '0 0 24 24' },
			react_default.a.createElement('path', { d: 'M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.39-.39-1.02-.39-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z' }),
			react_default.a.createElement('path', { d: 'M0 0h24v24H0z', fill: 'none' })
		),
		lock_open: react_default.a.createElement(
			'svg',
			{ style: style, viewBox: '0 0 24 24' },
			react_default.a.createElement('path', { d: 'M0 0h24v24H0z', fill: 'none' }),
			react_default.a.createElement('path', { d: 'M12 17c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm6-9h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6h1.9c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm0 12H6V10h12v10z' })
		),
		lock_close: react_default.a.createElement(
			'svg',
			{ style: style, viewBox: '0 0 24 24' },
			react_default.a.createElement('path', { d: 'M0 0h24v24H0z', fill: 'none' }),
			react_default.a.createElement('path', { d: 'M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm3.1-9H8.9V6c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2z' })
		),
		checkbox: react_default.a.createElement(
			'svg',
			{ style: style, viewBox: '0 0 24 24' },
			react_default.a.createElement('path', { d: 'M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z' }),
			react_default.a.createElement('path', { d: 'M0 0h24v24H0z', fill: 'none' })
		),
		checkbox_checked: react_default.a.createElement(
			'svg',
			{ style: style, viewBox: '0 0 24 24' },
			react_default.a.createElement('path', { d: 'M0 0h24v24H0z', fill: 'none' }),
			react_default.a.createElement('path', { d: 'M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z' })
		),
		radio: react_default.a.createElement(
			'svg',
			{ style: style, viewBox: '0 0 24 24' },
			react_default.a.createElement('path', { d: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z' }),
			react_default.a.createElement('path', { d: 'M0 0h24v24H0z', fill: 'none' })
		),
		radio_checked: react_default.a.createElement(
			'svg',
			{ style: style, viewBox: '0 0 24 24' },
			react_default.a.createElement('path', { d: 'M12 7c-2.76 0-5 2.24-5 5s2.24 5 5 5 5-2.24 5-5-2.24-5-5-5zm0-5C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z' }),
			react_default.a.createElement('path', { d: 'M0 0h24v24H0z', fill: 'none' })
		),
		delete: react_default.a.createElement(
			'svg',
			{ style: style, viewBox: '0 0 24 24' },
			react_default.a.createElement('path', { d: 'M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z' }),
			react_default.a.createElement('path', { d: 'M0 0h24v24H0z', fill: 'none' })
		),
		delete_forever: react_default.a.createElement(
			'svg',
			{ style: style, viewBox: '0 0 24 24' },
			react_default.a.createElement('path', { d: 'M0 0h24v24H0V0z', fill: 'none' }),
			react_default.a.createElement('path', { d: 'M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zm2.46-7.12l1.41-1.41L12 12.59l2.12-2.12 1.41 1.41L13.41 14l2.12 2.12-1.41 1.41L12 15.41l-2.12 2.12-1.41-1.41L10.59 14l-2.13-2.12zM15.5 4l-1-1h-5l-1 1H5v2h14V4z' }),
			react_default.a.createElement('path', { d: 'M0 0h24v24H0z', fill: 'none' })
		),
		restore: react_default.a.createElement(
			'svg',
			{ style: style, viewBox: '0 0 24 24' },
			react_default.a.createElement('path', { d: 'M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zm-2 16c-2.05 0-3.81-1.24-4.58-3h1.71c.63.9 1.68 1.5 2.87 1.5 1.93 0 3.5-1.57 3.5-3.5S13.93 9.5 12 9.5c-1.35 0-2.52.78-3.1 1.9l1.6 1.6h-4V9l1.3 1.3C8.69 8.92 10.23 8 12 8c2.76 0 5 2.24 5 5s-2.24 5-5 5z' }),
			react_default.a.createElement('path', { d: 'M0 0h24v24H0z', fill: 'none' })
		),
		block: react_default.a.createElement(
			'svg',
			{ style: style, viewBox: '0 0 24 24' },
			react_default.a.createElement('path', { d: 'M0 0h24v24H0V0z', fill: 'none' }),
			react_default.a.createElement('path', { d: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm5 11H7v-2h10v2z' })
		),
		share: react_default.a.createElement(
			'svg',
			{ style: style, viewBox: '0 0 24 24' },
			react_default.a.createElement('path', { d: 'M0 0h24v24H0z', fill: 'none' }),
			react_default.a.createElement('path', { d: 'M18 16.08c-.76 0-1.44.3-1.96.77L8.91 12.7c.05-.23.09-.46.09-.7s-.04-.47-.09-.7l7.05-4.11c.54.5 1.25.81 2.04.81 1.66 0 3-1.34 3-3s-1.34-3-3-3-3 1.34-3 3c0 .24.04.47.09.7L8.04 9.81C7.5 9.31 6.79 9 6 9c-1.66 0-3 1.34-3 3s1.34 3 3 3c.79 0 1.5-.31 2.04-.81l7.12 4.16c-.05.21-.08.43-.08.65 0 1.61 1.31 2.92 2.92 2.92 1.61 0 2.92-1.31 2.92-2.92s-1.31-2.92-2.92-2.92z' })
		),
		check: react_default.a.createElement(
			'svg',
			{ style: style, viewBox: '0 0 24 24' },
			react_default.a.createElement('path', { d: 'M0 0h24v24H0z', fill: 'none' }),
			react_default.a.createElement('path', { d: 'M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z' })
		),
		settings: react_default.a.createElement(
			'svg',
			{ style: style, viewBox: '0 0 24 24' },
			react_default.a.createElement('path', { d: 'M0 0h24v24H0z', fill: 'none' }),
			react_default.a.createElement('path', { d: 'M19.43 12.98c.04-.32.07-.64.07-.98s-.03-.66-.07-.98l2.11-1.65c.19-.15.24-.42.12-.64l-2-3.46c-.12-.22-.39-.3-.61-.22l-2.49 1c-.52-.4-1.08-.73-1.69-.98l-.38-2.65C14.46 2.18 14.25 2 14 2h-4c-.25 0-.46.18-.49.42l-.38 2.65c-.61.25-1.17.59-1.69.98l-2.49-1c-.23-.09-.49 0-.61.22l-2 3.46c-.13.22-.07.49.12.64l2.11 1.65c-.04.32-.07.65-.07.98s.03.66.07.98l-2.11 1.65c-.19.15-.24.42-.12.64l2 3.46c.12.22.39.3.61.22l2.49-1c.52.4 1.08.73 1.69.98l.38 2.65c.03.24.24.42.49.42h4c.25 0 .46-.18.49-.42l.38-2.65c.61-.25 1.17-.59 1.69-.98l2.49 1c.23.09.49 0 .61-.22l2-3.46c.12-.22.07-.49-.12-.64l-2.11-1.65zM12 15.5c-1.93 0-3.5-1.57-3.5-3.5s1.57-3.5 3.5-3.5 3.5 1.57 3.5 3.5-1.57 3.5-3.5 3.5z' })
		),
		settings2: react_default.a.createElement(
			'svg',
			{ style: style, viewBox: '0 0 24 24' },
			react_default.a.createElement('path', { d: 'M0 0h24v24H0z', fill: 'none' }),
			react_default.a.createElement('path', { d: 'M12 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm7-7H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-1.75 9c0 .23-.02.46-.05.68l1.48 1.16c.13.11.17.3.08.45l-1.4 2.42c-.09.15-.27.21-.43.15l-1.74-.7c-.36.28-.76.51-1.18.69l-.26 1.85c-.03.17-.18.3-.35.3h-2.8c-.17 0-.32-.13-.35-.29l-.26-1.85c-.43-.18-.82-.41-1.18-.69l-1.74.7c-.16.06-.34 0-.43-.15l-1.4-2.42c-.09-.15-.05-.34.08-.45l1.48-1.16c-.03-.23-.05-.46-.05-.69 0-.23.02-.46.05-.68l-1.48-1.16c-.13-.11-.17-.3-.08-.45l1.4-2.42c.09-.15.27-.21.43-.15l1.74.7c.36-.28.76-.51 1.18-.69l.26-1.85c.03-.17.18-.3.35-.3h2.8c.17 0 .32.13.35.29l.26 1.85c.43.18.82.41 1.18.69l1.74-.7c.16-.06.34 0 .43.15l1.4 2.42c.09.15.05.34-.08.45l-1.48 1.16c.03.23.05.46.05.69z' })
		),
		photo_camera: react_default.a.createElement(
			'svg',
			{ style: style, viewBox: '0 0 24 24' },
			react_default.a.createElement('circle', { cx: '12', cy: '12', r: '3.2' }),
			react_default.a.createElement('path', { d: 'M9 2L7.17 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2h-3.17L15 2H9zm3 15c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5z' }),
			react_default.a.createElement('path', { d: 'M0 0h24v24H0z', fill: 'none' })
		),
		folder: react_default.a.createElement(
			'svg',
			{ style: style, viewBox: '0 0 24 24' },
			react_default.a.createElement('path', { d: 'M10 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2h-8l-2-2z' }),
			react_default.a.createElement('path', { d: 'M0 0h24v24H0z', fill: 'none' })
		),
		refresh: react_default.a.createElement(
			'svg',
			{ style: style, viewBox: '0 0 24 24' },
			react_default.a.createElement('path', { d: 'M17.65 6.35C16.2 4.9 14.21 4 12 4c-4.42 0-7.99 3.58-7.99 8s3.57 8 7.99 8c3.73 0 6.84-2.55 7.73-6h-2.08c-.82 2.33-3.04 4-5.65 4-3.31 0-6-2.69-6-6s2.69-6 6-6c1.66 0 3.14.69 4.22 1.78L13 11h7V4l-2.35 2.35z' }),
			react_default.a.createElement('path', { d: 'M0 0h24v24H0z', fill: 'none' })
		),
		announcement: react_default.a.createElement(
			'svg',
			{ style: style, viewBox: '0 0 24 24' },
			react_default.a.createElement('path', { d: 'M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-7 9h-2V5h2v6zm0 4h-2v-2h2v2z' }),
			react_default.a.createElement('path', { d: 'M0 0h24v24H0z', fill: 'none' })
		),
		pin: react_default.a.createElement(
			'svg',
			{ style: style, viewBox: '0 0 24 24' },
			react_default.a.createElement('path', { d: 'M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z' }),
			react_default.a.createElement('path', { d: 'M0 0h24v24H0z', fill: 'none' })
		)
	};

	return icons[props.icon];
};

SvgIcon_SvgIcon.propTypes = {
	size: prop_types_default.a.string.isRequired,
	icon: prop_types_default.a.string.isRequired
};

/* harmony default export */ var svg_SvgIcon = (SvgIcon_SvgIcon);
// EXTERNAL MODULE: ./src/utils/nav/NavHelpers.js
var NavHelpers = __webpack_require__(19);

// CONCATENATED MODULE: ./src/components/common/UserIconComponent.js
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

















var UserIconComponent_UserIconComponent = function (_React$Component) {
	_inherits(UserIconComponent, _React$Component);

	function UserIconComponent() {
		var _ref;

		var _temp, _this, _ret;

		_classCallCheck(this, UserIconComponent);

		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = UserIconComponent.__proto__ || Object.getPrototypeOf(UserIconComponent)).call.apply(_ref, [this].concat(args))), _this), _this._showUserModal = function (e, path, user) {
			e.stopPropagation();

			_this.props.dispatch(Object(UiActions["M" /* resetOverlay */])());
			_this.props.dispatch(Object(UiActions["U" /* showUserModal */])(path, user));
			// Record the Google Analytics event.
			_this.props.dispatch(Object(adsActions["A" /* trackGAEvent */])(false, 'userModal_' + path[1], 'uiAction', 'tap'));
		}, _temp), _possibleConstructorReturn(_this, _ret);
	}

	_createClass(UserIconComponent, [{
		key: 'shouldComponentUpdate',
		value: function shouldComponentUpdate(nextProps) {
			// very rarely we'll update it
			return !isEqual_default()(nextProps.user, this.props.user) || !isEqual_default()(nextProps.layout, this.props.layout) || nextProps.noAction !== this.props.noAction || nextProps.className !== this.props.className;
		}
	}, {
		key: 'showUserProfile',
		value: function showUserProfile(e, user) {
			e.stopPropagation();

			this.props.dispatch(Object(UiActions["M" /* resetOverlay */])());
			// Record the Google Analytics event.
			this.props.dispatch(Object(adsActions["A" /* trackGAEvent */])(false, 'userProfileByIcon', 'uiAction', 'tap'));
			this.props.dispatch(Object(react_router_redux_lib["push"])(Object(NavHelpers["r" /* pathToUserProfile */])(user.id)));
		}
	}, {
		key: 'render',
		value: function render() {
			var _this2 = this;

			var _props = this.props,
			    user = _props.user,
			    defaultUrl = _props.defaultUrl,
			    layout = _props.layout,
			    noAction = _props.noAction,
			    className = _props.className;


			var styles = {
				backgroundImage: 'url(' + (user.avatar || defaultUrl) + ')'
			},
			    onlineStatus = user.online === true ? react_default.a.createElement(
				'div',
				{ className: 'status online' },
				'online'
			) : null,
			    onClick = function onClick() {},
			    userLocation = user.location ? react_default.a.createElement(
				'div',
				{ className: 'userLocation' },
				user.location
			) : null;

			if (!noAction) {
				var path = Object(NavHelpers["a" /* parsePath */])(this.props.routing.locationBeforeTransitions.pathname);
				onClick = function onClick(e) {
					_this2._showUserModal(e, path, user);
				};
			}

			if (this.props.onClick) {
				onClick = this.props.onClick;
			}

			switch (layout) {
				case 'complete':
					return react_default.a.createElement(
						'div',
						{ className: 'uiContainer no-ad ' + (className ? className : ''), onClick: onClick },
						react_default.a.createElement('div', { className: 'avatar', style: styles }),
						react_default.a.createElement(
							'div',
							{ className: 'username' },
							user.userName
						),
						onlineStatus,
						userLocation
					);

				case 'nolocation':
					return react_default.a.createElement(
						'div',
						{ className: 'uiContainer no-ad ' + (className ? className : ''), onClick: onClick },
						react_default.a.createElement('div', { className: 'avatar', style: styles }),
						react_default.a.createElement(
							'div',
							{ className: 'username' },
							user.userName
						),
						onlineStatus
					);

				case 'nostatus':
					return react_default.a.createElement(
						'div',
						{ className: 'uiContainer no-ad ' + (className ? className : ''), onClick: onClick },
						react_default.a.createElement('div', { className: 'avatar', style: styles }),
						react_default.a.createElement(
							'div',
							{ className: 'username' },
							user.userName
						)
					);

				case 'quote':
					return react_default.a.createElement(
						'div',
						{ className: 'uiContainer no-ad ' + (className ? className : ''), onClick: onClick },
						react_default.a.createElement('div', { className: 'avatar', style: styles })
					);

				case 'userprofile':
					return react_default.a.createElement(
						'div',
						{ className: 'uiContainer no-ad ' + (className ? className : ''), onClick: onClick },
						react_default.a.createElement('div', { className: 'avatar', style: styles }),
						onlineStatus
					);

				case 'sidemenu':
					return react_default.a.createElement(
						'li',
						{ className: 'current-user ' + (className ? className : ''), onClick: function onClick(e) {
								return _this2.showUserProfile(e, user);
							} },
						react_default.a.createElement('div', { className: 'avatar', style: styles }),
						react_default.a.createElement(
							'h2',
							{ className: 'username', id: 'sideMenuUserName' },
							user.userName
						)
					);

				case 'editme':
					return react_default.a.createElement(
						'div',
						{ className: 'uiContainer no-ad ' + (className ? className : '') },
						react_default.a.createElement('div', { className: 'avatar', style: styles }),
						react_default.a.createElement(
							'div',
							{ className: 'update-me', onClick: onClick },
							react_default.a.createElement(svg_SvgIcon, { icon: 'photo_camera', size: this.props.size })
						)
					);

				default:
					throw 'Valid layout required for UserIconComponent';
			}
		}
	}]);

	return UserIconComponent;
}(react_default.a.Component);

UserIconComponent_UserIconComponent.defaultProps = {
	defaultUrl: ('https:' === document.location.protocol ? 'https://' : 'http://') + 'staticimages.topify.com/default_avatar.png',
	layout: 'complete',
	className: '',
	user: {
		avatar: '',
		userName: 'Guest'
	}
};

UserIconComponent_UserIconComponent.propTypes = {
	user: prop_types_default.a.object.isRequired,
	layout: prop_types_default.a.string,
	dispatch: prop_types_default.a.func.isRequired
};

var UserIconComponent_mapStateToProps = function mapStateToProps(state) {
	return {
		routing: state.routing
	};
};

/* harmony default export */ var common_UserIconComponent = (Object(es["b" /* connect */])(UserIconComponent_mapStateToProps)(UserIconComponent_UserIconComponent));
// CONCATENATED MODULE: ./src/components/common/CheckboxComponent.js
var CheckboxComponent__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function CheckboxComponent__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function CheckboxComponent__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function CheckboxComponent__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var CheckboxComponent_checkboxComponent = function (_React$Component) {
	CheckboxComponent__inherits(checkboxComponent, _React$Component);

	function checkboxComponent(props) {
		CheckboxComponent__classCallCheck(this, checkboxComponent);

		var _this = CheckboxComponent__possibleConstructorReturn(this, (checkboxComponent.__proto__ || Object.getPrototypeOf(checkboxComponent)).call(this, props));

		_this.onChangeHandle = function (event) {
			_this.setState({ itemChecked: event.target.checked });

			if (_this.props.onChange) {
				_this.props.onChange(event);
			}
		};

		_this.state = {
			itemChecked: !!props.checked
		};
		return _this;
	}

	CheckboxComponent__createClass(checkboxComponent, [{
		key: 'componentWillReceiveProps',
		value: function componentWillReceiveProps(nextProps) {
			if (nextProps.checked !== this.state.itemChecked) {
				this.setState({ itemChecked: nextProps.checked });
			}
		}
	}, {
		key: 'render',
		value: function render() {
			var _props = this.props,
			    name = _props.name,
			    id = _props.id,
			    value = _props.value,
			    multiple = _props.multiple,
			    label = _props.label,
			    postLabel = _props.postLabel,
			    className = _props.className,
			    type = multiple ? 'checkbox' : 'radio',
			    text = label ? react_default.a.createElement(
				'span',
				null,
				label
			) : null,
			    postText = postLabel ? react_default.a.createElement(
				'span',
				null,
				postLabel
			) : null,
			    icon = (multiple ? 'checkbox' : 'radio') + (this.state.itemChecked ? '_checked' : ''),
			    label_class = (this.state.itemChecked ? 'checked ' : '') + className;


			return react_default.a.createElement(
				'label',
				{ className: 'custom-checkbox ' + label_class, onClick: function onClick(e) {
						return e.stopPropagation();
					} },
				text,
				react_default.a.createElement('input', {
					name: name,
					id: id,
					value: value,
					checked: this.state.itemChecked,
					onChange: this.onChangeHandle,
					type: type,
					className: 'custom-checkbox' }),
				react_default.a.createElement(
					'div',
					{ className: 'icon' },
					react_default.a.createElement(svg_SvgIcon, { icon: icon, size: '24px' })
				),
				postText
			);
		}
	}]);

	return checkboxComponent;
}(react_default.a.Component);

CheckboxComponent_checkboxComponent.propTypes = {
	name: prop_types_default.a.string.isRequired,
	value: prop_types_default.a.string.isRequired,
	multiple: prop_types_default.a.bool.isRequired,
	checked: prop_types_default.a.bool.isRequired,
	label: prop_types_default.a.oneOfType([prop_types_default.a.string, prop_types_default.a.array]),
	postLabel: prop_types_default.a.oneOfType([prop_types_default.a.string, prop_types_default.a.array]),
	onClick: prop_types_default.a.func,
	onChange: prop_types_default.a.func
};

/* harmony default export */ var CheckboxComponent = (CheckboxComponent_checkboxComponent);
// EXTERNAL MODULE: ./node_modules/date-fns/format/index.js
var format = __webpack_require__(329);
var format_default = /*#__PURE__*/__webpack_require__.n(format);

// EXTERNAL MODULE: ./node_modules/date-fns/distance_in_words_to_now/index.js
var distance_in_words_to_now = __webpack_require__(751);
var distance_in_words_to_now_default = /*#__PURE__*/__webpack_require__.n(distance_in_words_to_now);

// CONCATENATED MODULE: ./src/utils/time.js



function prettyDate(epoch) {
	var dateFormat = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'MMM DD, YYYY';

	var time = epoch * 1000;

	if (dateFormat === 'datetime') {
		return format_default()(time);
	}

	if (new Date().getTime() - time > 5 * 86400000) {
		// before 5 days
		return format_default()(time, dateFormat);
	} else {
		return distance_in_words_to_now_default()(time, {
			addSuffix: true,
			includeSeconds: true
		});
	}
}
// CONCATENATED MODULE: ./src/components/common/dateComponent.js






var dateComponent_dateComponent = function dateComponent(_ref) {
	var timestamp = _ref.timestamp,
	    _ref$icon = _ref.icon,
	    icon = _ref$icon === undefined ? false : _ref$icon,
	    _ref$icon_name = _ref.icon_name,
	    icon_name = _ref$icon_name === undefined ? 'clock' : _ref$icon_name;

	var iconTag = icon ? react_default.a.createElement(svg_SvgIcon, { size: '12px', icon: icon_name }) : null;

	if (timestamp) {
		return react_default.a.createElement(
			'time',
			{ dateTime: prettyDate(timestamp, 'datetime') },
			iconTag,
			prettyDate(timestamp)
		);
	} else {
		return react_default.a.createElement(
			'time',
			null,
			iconTag,
			'Never'
		);
	}
};

dateComponent_dateComponent.propTypes = {
	timestamp: prop_types_default.a.oneOfType([prop_types_default.a.string, prop_types_default.a.number]).isRequired
};

/* harmony default export */ var common_dateComponent = (dateComponent_dateComponent);
// CONCATENATED MODULE: ./src/utils/entities.js
function simpleDecodeEntities(text) {
	return typeof text === 'string' ? text.replace(/&amp;/g, '&').replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace(/&quot;/g, '"') : text;
}
// EXTERNAL MODULE: ./node_modules/parsimmon/build/parsimmon.umd.min.js
var parsimmon_umd_min = __webpack_require__(759);
var parsimmon_umd_min_default = /*#__PURE__*/__webpack_require__.n(parsimmon_umd_min);

// CONCATENATED MODULE: ./src/utils/bbcode/BBCodeParser.js


var bbcodeOpenBegin = Object(parsimmon_umd_min["string"])('[');
var bbcodeCloseBegin = Object(parsimmon_umd_min["string"])('[/');
var bbcodeEnd = Object(parsimmon_umd_min["string"])(']');

var htmlOpenBegin = Object(parsimmon_umd_min["string"])('<');
var htmlEnd = Object(parsimmon_umd_min["string"])('>');
var htmlContent = Object(parsimmon_umd_min["regex"])(/[^>]+/);

var bbcodeType = Object(parsimmon_umd_min["regex"])(/\w+/);
var bbcodeValue = Object(parsimmon_umd_min["regex"])(/[^\]]+/);
var singleTagValues = Object(parsimmon_umd_min["regex"])(/\[(?!\/)(.*?)\]/, 1);
var bbcodeValueNoQuotes = Object(parsimmon_umd_min["regex"])(/[^\]'"]+/);
var bbcodeAttrVal = Object(parsimmon_umd_min["regex"])(/[^\] ]+/);

var quote = Object(parsimmon_umd_min["regex"])(/['"]/);
var words = Object(parsimmon_umd_min["regex"])(/[^\[<]+/);

// Handle stray html tags
var htmlTag = Object(parsimmon_umd_min["seqMap"])(htmlOpenBegin, htmlContent, htmlEnd, function (a, b, c) {
	switch (b) {
		case 'br':
			return '\n';
		default:
			return '';
	}
});

var bbcodeQuotedValue = Object(parsimmon_umd_min["seqMap"])(quote, bbcodeValueNoQuotes, quote, function (_, val, __) {
	return val;
});

var attrValue = Object(parsimmon_umd_min["seq"])(Object(parsimmon_umd_min["regex"])(/[= ]/), bbcodeQuotedValue.or(bbcodeValue));

// OPEN TAGS [TAG(=VALUE)]
var bbcodeOpenTag = Object(parsimmon_umd_min["seqMap"])(bbcodeOpenBegin, bbcodeType, attrValue.atMost(1), bbcodeEnd, function (_, type, attrs, __) {
	return {
		tag: type.toLowerCase(),
		attributes: attrs.length > 0 ? attrs[0][1] : []
	};
}).desc('bbcode open tag');

// ATTRIBTE KEY VALUE PAIRS KEY=VAL
var bbcodeAttrPair = Object(parsimmon_umd_min["seq"])(parsimmon_umd_min["whitespace"], bbcodeType.skip(Object(parsimmon_umd_min["string"])('=')), bbcodeAttrVal).map(function (_, key, val) {
	return {
		key: key,
		val: val
	};
}).desc('bbcode multi attribute pair');

// OPEN TAGS [TAG (KEY=VALUE)+]
var bbcodeOpenMultiParmTag = Object(parsimmon_umd_min["seqMap"])(bbcodeOpenBegin, bbcodeType, bbcodeAttrPair.atLeast(1), bbcodeEnd, function (_, type, pairs, __) {
	return {
		tag: type.toLowerCase(),
		attributes: pairs
	};
}).desc('bbcode open tag (multi param)');

// CLOSE TAGS [/TAG]
var bbcodeCloseTag = Object(parsimmon_umd_min["seqMap"])(bbcodeCloseBegin, bbcodeType, bbcodeEnd, function (_, type, __) {
	return {
		tag: type.toLowerCase()
	};
}).desc('bbcode close tag');

// SINGLE TAG [TAG]
var nobbcodeSingleTag = Object(parsimmon_umd_min["seqMap"])(singleTagValues, function (content) {
	return {
		open: {
			tag: content,
			attributes: null
		},
		content: null,
		close: null
	};
}).desc('no bbcode single tag');

var BBCodeParser_content = Object(parsimmon_umd_min["lazy"])(function () {
	return Object(parsimmon_umd_min["alt"])(htmlTag, words, bbcodeBlock, nobbcodeSingleTag).many();
});

var bbcodeBlock = Object(parsimmon_umd_min["seqMap"])(Object(parsimmon_umd_min["alt"])(bbcodeOpenTag, bbcodeOpenMultiParmTag), BBCodeParser_content, bbcodeCloseTag, function (open, mid, close) {
	return {
		open: open,
		content: mid,
		close: close
	};
});

/* harmony default export */ var BBCodeParser = (BBCodeParser_content);
// CONCATENATED MODULE: ./src/components/posts/QuoteComponent.js








var QuoteComponent_QuoteComponent = function QuoteComponent(props) {
	var user = props.users[props.userName] || {
		avatar: '',
		userName: ''
	};

	if (user.avatar === '') {
		for (var u in props.users) {
			if (props.users.hasOwnProperty(u)) {
				if (props.users[u].userName === props.userName) {
					user = {
						id: u,
						avatar: props.users[u].avatar,
						userName: props.users[u].userName
					};
				}
			}
		}
	}

	var link_to = props.postId > 0 ? react_default.a.createElement(
		react_router_es["b" /* Link */],
		{ to: '/topics/0?postid=' + props.postId, className: 'link' },
		'Original Post',
		react_default.a.createElement(svg_SvgIcon, { size: '16px', icon: 'link' })
	) : '',
	    userAvatar = user.userName ? react_default.a.createElement(
		'div',
		{ className: 'icon' },
		react_default.a.createElement(common_UserIconComponent, { user: user, layout: 'quote' })
	) : null;

	return react_default.a.createElement(
		'div',
		{ className: 'quote' },
		react_default.a.createElement('div', { className: 'pointer' }),
		react_default.a.createElement(
			'div',
			{ className: 'user' },
			userAvatar,
			react_default.a.createElement(
				'div',
				{ className: 'detail' },
				user.userName ? user.userName + ' said:' : 'Quote:'
			),
			link_to
		),
		react_default.a.createElement(
			'div',
			{ className: 'body' },
			props.children
		)
	);
};

QuoteComponent_QuoteComponent.defaultProps = {
	defaultUrl: ('https:' === document.location.protocol ? 'https://' : 'http://') + 'staticimages.topify.com/default_avatar.png'
};

QuoteComponent_QuoteComponent.propTypes = {
	postId: prop_types_default.a.number.isRequired,
	userName: prop_types_default.a.string.isRequired
};

// Quote is connected to state since we need the global loaded users data
/* harmony default export */ var posts_QuoteComponent = (QuoteComponent_QuoteComponent);
// CONCATENATED MODULE: ./src/components/posts/tweetComponent.js
var tweetComponent__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function tweetComponent__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function tweetComponent__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function tweetComponent__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var tweetComponent_tweetComponent = function (_React$Component) {
	tweetComponent__inherits(tweetComponent, _React$Component);

	function tweetComponent(props) {
		tweetComponent__classCallCheck(this, tweetComponent);

		var _this2 = tweetComponent__possibleConstructorReturn(this, (tweetComponent.__proto__ || Object.getPrototypeOf(tweetComponent)).call(this, props));

		_this2.state = {
			isLoaded: false,
			tweetResponse: ''
		};
		return _this2;
	}

	tweetComponent__createClass(tweetComponent, [{
		key: 'componentDidMount',
		value: function componentDidMount() {
			var _props = this.props,
			    tweetid = _props.tweetid,
			    tweetElementsId = _props.tweetElementsId;

			if (tweetid) {
				var data = {
					url: 'https://api.twitter.com/1/statuses/oembed.json',
					data: 'id=' + tweetid
				};

				if (!document.getElementById('twitter-wjs')) {
					var script_widget = document.createElement('script');
					script_widget.id = 'twitter-wjs';
					script_widget.src = '//platform.twitter.com/widgets.js';
					document.head.appendChild(script_widget);
				}

				// Twitter doesn't allow CORS, we need to hack this way
				var _this = this;
				window[tweetElementsId] = function (data) {
					_this.setState({
						isLoaded: true,
						tweetResponse: data
					});
					setTimeout(function () {
						twttr.widgets.load(document.getElementById(tweetElementsId));
					}, 10);
				};

				var script = document.createElement('script');
				script.src = data.url + '?id=' + tweetid + '&omit_script=true&callback=' + tweetElementsId;
				script.id = 'js_' + tweetElementsId;
				document.head.appendChild(script);
			}
		}
	}, {
		key: 'cleanAux',
		value: function cleanAux() {
			delete window[this.props.tweetElementsId];
			var element = document.getElementById('js_' + this.props.tweetElementsId);
			if (element) {
				element.parentNode.removeChild(element);
			}
		}
	}, {
		key: 'render',
		value: function render() {
			var tweetElementsId = this.props.tweetElementsId;


			if (this.state.isLoaded) {
				this.cleanAux();
				if (this.state.tweetResponse.html) {
					return react_default.a.createElement('div', { className: 'tweet', id: tweetElementsId, dangerouslySetInnerHTML: { __html: this.state.tweetResponse.html } });
				} else {
					return react_default.a.createElement(
						'div',
						{ className: 'tweet', id: tweetElementsId },
						'An error occurred while retrieving this tweet'
					);
				}
			} else {
				return react_default.a.createElement(
					'div',
					{ className: 'tweet', id: tweetElementsId },
					'loading tweet...'
				);
			}
		}
	}]);

	return tweetComponent;
}(react_default.a.Component);

tweetComponent_tweetComponent.propTypes = {
	tweetid: prop_types_default.a.string.isRequired
};

/* harmony default export */ var posts_tweetComponent = (tweetComponent_tweetComponent);
// EXTERNAL MODULE: ./node_modules/postscribe/dist/postscribe.js
var postscribe = __webpack_require__(216);
var postscribe_default = /*#__PURE__*/__webpack_require__.n(postscribe);

// CONCATENATED MODULE: ./src/components/posts/livestreamComponent.js
var livestreamComponent__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function livestreamComponent__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function livestreamComponent__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function livestreamComponent__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var livestreamComponent_livestreamComponent = function (_React$Component) {
	livestreamComponent__inherits(livestreamComponent, _React$Component);

	function livestreamComponent(props) {
		livestreamComponent__classCallCheck(this, livestreamComponent);

		var _this = livestreamComponent__possibleConstructorReturn(this, (livestreamComponent.__proto__ || Object.getPrototypeOf(livestreamComponent)).call(this, props));

		_this.width = null;
		_this.height = null;
		_this.livestreamId = null;
		return _this;
	}

	livestreamComponent__createClass(livestreamComponent, [{
		key: 'componentWillMount',
		value: function componentWillMount() {
			this.width = window.innerWidth - 100;
			this.height = window.innerHeight - 100;
			this.livestreamId = 'feed-embed-stand-alone';
			this.cleanOld();
		}
	}, {
		key: 'componentDidMount',
		value: function componentDidMount() {
			var js_id = "js_" + this.livestreamId;

			postscribe_default()(document.getElementsByTagName('body')[0], '<script type="text/javascript" id=' + js_id + ' data-embed_id=' + this.livestreamId + ' src="//livestream.com/assets/plugins/referrer_tracking.js"></script>', {
				done: function done() {
					topifyConsole.log('loading livestream referrer_tracking');
				},
				error: function error() {
					topifyConsole.warn('error loading: livestream referrer_tracking');
				}
			});
		}
	}, {
		key: 'componentWillUnmount',
		value: function componentWillUnmount() {
			this.cleanOld();
		}
	}, {
		key: 'cleanOld',
		value: function cleanOld() {
			var element = document.getElementById('js_' + this.livestreamId);
			if (element) {
				element.parentNode.removeChild(element);
				topifyConsole.log("cleaning livestream referrer_tracking");
			}
		}
	}, {
		key: 'getUrl',
		value: function getUrl() {
			return '//livestream.com/accounts/' + this.props.content + '/feed_embed?width=' + this.width + '&height=' + this.height;
		}
	}, {
		key: 'render',
		value: function render() {
			var url = this.getUrl();

			return react_default.a.createElement('iframe', {
				src: url,
				width: this.width, height: this.height,
				frameBorder: '0',
				id: this.livestreamId,
				scrolling: 'auto', allowFullScreen: true });
		}
	}]);

	return livestreamComponent;
}(react_default.a.Component);

livestreamComponent_livestreamComponent.propTypes = {
	content: prop_types_default.a.string.isRequired
};

/* harmony default export */ var posts_livestreamComponent = (livestreamComponent_livestreamComponent);
// CONCATENATED MODULE: ./src/utils/bbcode/RawToReact.js
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();










function convertCodeBlock(codeBlockObject, props) {
	var style = {};
	var _codeBlockObject$open = codeBlockObject.open,
	    tag = _codeBlockObject$open.tag,
	    attributes = _codeBlockObject$open.attributes,
	    content = codeBlockObject.content,
	    close = codeBlockObject.close;


	switch (tag) {
		case 'quote':
			var username = '',
			    id = 0;

			if (typeof attributes === 'string') {
				var _ref = attributes.indexOf(';') < 0 ? [attributes, 0] : attributes.split(';');

				var _ref2 = _slicedToArray(_ref, 2);

				username = _ref2[0];
				id = _ref2[1];
			}
			if (content) {
				return react_default.a.createElement(
					posts_QuoteComponent,
					{ key: 'quote_' + RawToReact_key_counter,
						postId: parseInt(id),
						userName: username,
						posts: props.posts || {},
						users: props.users || {} },
					recurseConvert(content, props)
				);
			} else {
				return '[' + tag + (attributes || '') + ']';
			}

		case 'list':
			var newList = [],
			    open = false,
			    lineNo = 0;
			// we can have single tags [*] for <li> elements
			// we need to group lines in same li element
			content.forEach(function (c) {
				if (c.close === null && c.open.tag === '*') {
					lineNo++;
					c.close = { tag: 'li' };
					c.open.tag = 'li';
					c.content = [];
					open = true;
					newList[lineNo] = c;
				} else if (open) {
					newList[lineNo].content.push(c);
				}
			});

			var newContent = newList.length ? newList : content,
			    lines = newContent.map(function (c) {
				switch (typeof c === 'undefined' ? 'undefined' : _typeof(c)) {
					case 'string':
						return c.split('\n').filter(function (t) {
							return t !== '';
						});

					default:
						RawToReact_key_counter++;
						return convertCodeBlock(c, props);
				}
			}).filter(function (l) {
				return l.length !== undefined ? l.length > 0 : true;
			});

			if (attributes === "1") {
				return react_default.a.createElement(
					'ol',
					{ key: RawToReact_key_counter },
					lines.length && lines[0].length ? lines[0] : lines
				);
			} else {
				return react_default.a.createElement(
					'ul',
					{ key: RawToReact_key_counter },
					lines.length && lines[0].length ? lines[0] : lines
				);
			}

		case 'email':
			return react_default.a.createElement(
				'a',
				{ key: RawToReact_key_counter, href: 'mailto:' + (attributes || content), 'data-rel': 'external' },
				recurseConvert(content, props)
			);

		case 'code':
		case 'html':
		case 'php':
			return react_default.a.createElement(
				'pre',
				{ key: RawToReact_key_counter },
				recurseConvert(content, props)
			);

		case 'justify':
		case 'center':
		case 'right':
		case 'left':
			return react_default.a.createElement(
				'p',
				{ key: RawToReact_key_counter, className: 'text-align-' + tag },
				recurseConvert(content, props)
			);

		case 'size':
			style = {
				fontSize: attributes < 8 ? 8 : (attributes > 32 ? 32 : attributes) + 'px'
			};
			return react_default.a.createElement(
				'span',
				{ key: RawToReact_key_counter, style: style },
				recurseConvert(content, props)
			);

		case 'font':
			return react_default.a.createElement(
				'span',
				{ key: RawToReact_key_counter },
				recurseConvert(content, props)
			);

		case 'indent':
			return react_default.a.createElement(
				'span',
				{ key: RawToReact_key_counter, className: 'text-indented' },
				recurseConvert(content, props)
			);

		case 'url':
			if (attributes) {
				// if the url is a video embed it
				var _is_video = is_embed_video(attributes);
				if (_is_video) {
					// Adapt the block to videos tags
					codeBlockObject.open.attributes = typeof content !== 'string' && typeof content[0] === 'string' ? content[0] : content;
					codeBlockObject.content = attributes;
				} else {
					_is_video = is_embed_video(content[0]);
					if (_is_video) {
						codeBlockObject.open.attributes = _is_video;
						codeBlockObject.content = typeof content !== 'string' && typeof content[0] === 'string' ? content[0] : content;
					}
				}

				if (_is_video) {
					codeBlockObject.open.tag = _is_video;
					return react_default.a.createElement(
						'div',
						{ key: 'video_' + RawToReact_key_counter },
						react_default.a.createElement(
							'em',
							{ key: 'videotitle_' + RawToReact_key_counter, className: 'videoembed_title' },
							codeBlockObject.open.attributes
						),
						convertCodeBlock(codeBlockObject, props)
					);
				} else {
					var href = (typeof attributes === 'string' ? attributes : content[0]).replace(/(^&quot;)|(&quot;$)/ig, '');
					return react_default.a.createElement(
						'a',
						{ key: RawToReact_key_counter, href: href, target: '_blank' },
						recurseConvert(content, props)
					);
				}
			} else {
				return embed_video(content);
			}

		case 'ame':
			if (typeof attributes === 'string' && attributes.match(/youtu(?:be\.com|\.be)/i)) {
				var title = typeof content !== 'string' && typeof content[0] === 'string' ? content[0] : content;
				return react_default.a.createElement(
					'div',
					null,
					react_default.a.createElement(
						'em',
						{ className: 'videoembed_title' },
						title
					),
					embed_video(attributes)
				);
			}

			if (typeof content !== 'string' && typeof content[0] === 'string' && content[0].match(/youtu(?:be\.com|\.be)/i)) {
				return embed_video(content[0]);
			}

			if (attributes && attributes.length > 0 && content) {
				return react_default.a.createElement(
					'a',
					{ href: attributes, target: '_blank', key: RawToReact_key_counter },
					recurseConvert(content, props)
				);
			}
			return embed_video(content);

		case 'video':
			var video_data = attributes,
			    is_video = is_embed_video(attributes);

			if (!is_video) {
				is_video = is_embed_video(content);
				video_data = content;
			}
			return embed_video(video_data, is_video);

		case 'youtube':
		case 'youtubehd':
		case 'youtube_browser':
			if (content.indexOf(':') < 0) {
				content = 'https://www.youtube.com/watch?v=' + content;
			}
			return embed_video(content, 'youtube');

		case 'dm': // dailymotion
		case 'metacafe': // metacafe
		case 'vimeo': // vimeo
		case 'soundcloud':
			// SoundCloud
			return embed_video(content, tag);

		case 'tweet':
			// twitter
			var tweetid = content[0];

			if (content[0].indexOf('://') >= 0) {
				var newtweetid = /\d+$/.exec(tweetid);
				tweetid = newtweetid[0];
			}
			var tweetElementsId = 'tweet_' + tweetid + '_' + new Date().getTime() + parseInt(Math.random() * 1000);

			return react_default.a.createElement(posts_tweetComponent, { key: RawToReact_key_counter, tweetid: tweetid, tweetElementsId: tweetElementsId });

		case 'thread':
		case 'post':
			// internal links
			var type = tag === 'post' ? '0?postid=' : '',
			    itemId = attributes.length ? attributes : content[0];
			return react_default.a.createElement(
				react_router_es["b" /* Link */],
				{ key: RawToReact_key_counter, to: '/topics/' + type + itemId, className: 'link' },
				content,
				react_default.a.createElement(svg_SvgIcon, { size: '16px', icon: 'link' })
			);

		case 'gs':
			// Google Spreadsheet
			return react_default.a.createElement(
				'a',
				{ key: RawToReact_key_counter, href: 'https://spreadsheets.google.com/pub?key=' + content + '&hl=en&single=true&gid=0&output=html', target: '_blank' },
				'Open this Spreadsheet.'
			);

		case 'gd':
			// Google Document
			return react_default.a.createElement(
				'a',
				{ key: RawToReact_key_counter, href: 'https://docs.google.com/document/pub?id=' + content, target: '_blank' },
				'Open this Google Document.'
			);

		case 'gp':
			// Google Presentation
			return react_default.a.createElement(
				'a',
				{ key: RawToReact_key_counter, href: 'https://docs.google.com/present/view?id=' + content, target: '_blank' },
				'Open this Presentation.'
			);

		case 'iurl':
			return react_default.a.createElement(
				'span',
				{ key: RawToReact_key_counter, className: 'inline_image' },
				react_default.a.createElement(
					'a',
					{ key: 'a_' + RawToReact_key_counter, href: attributes, target: '_blank' },
					recurseConvert(content, props)
				)
			);

		case 'color':
			style = { color: attributes };
			return react_default.a.createElement(
				'span',
				{ key: RawToReact_key_counter, style: style },
				recurseConvert(content, props)
			);

		case 'img':
			return react_default.a.createElement('img', { key: RawToReact_key_counter, src: content[0] });
		case 'imgnoism':
			// no ISM nor netseer
			return react_default.a.createElement('img', { key: RawToReact_key_counter, src: content[0], className: 'no-ad' });
		case 'noviglink':
			// No Viglink content
			return react_default.a.createElement(
				'div',
				{ key: RawToReact_key_counter, className: 'p nolinks' },
				recurseConvert(content, props)
			);
		case 'nointellitxt':
			// No Vibrant
			return react_default.a.createElement(
				'span',
				{ key: RawToReact_key_counter, id: 'nointelliTXT' },
				recurseConvert(content, props)
			);

		case 'info':
			return react_default.a.createElement(
				'span',
				{ key: RawToReact_key_counter, className: 'info' },
				react_default.a.createElement(svg_SvgIcon, { size: '20px', icon: 'info' }),
				recurseConvert(content, props)
			);
		case 'warn':
			return react_default.a.createElement(
				'span',
				{ key: RawToReact_key_counter, className: 'warning' },
				react_default.a.createElement(svg_SvgIcon, { size: '20px', icon: 'warning' }),
				recurseConvert(content, props)
			);

		case 'highlight':
			return react_default.a.createElement(
				'span',
				{ key: RawToReact_key_counter, className: 'highlight' },
				recurseConvert(content, props)
			);

		case 'mention':
			// Link to user profile - will show the @user
			return react_default.a.createElement(
				'em',
				{ key: RawToReact_key_counter },
				'@',
				react_default.a.createElement(
					react_router_es["b" /* Link */],
					{ key: 'link_' + RawToReact_key_counter, to: '/userprofile/' + content, className: 'link' },
					content
				)
			);

		case 'scroll':
			return react_default.a.createElement(
				'marquee',
				{ key: RawToReact_key_counter },
				recurseConvert(content, props)
			);
		case 'i':
		case 'em':
			return react_default.a.createElement(
				'em',
				{ key: RawToReact_key_counter },
				recurseConvert(content, props)
			);
		case 'b':
			return react_default.a.createElement(
				'strong',
				{ key: RawToReact_key_counter },
				recurseConvert(content, props)
			);
		case 's':
			return react_default.a.createElement(
				'del',
				{ key: RawToReact_key_counter },
				recurseConvert(content, props)
			);
		case 'sub':
			return react_default.a.createElement(
				'sub',
				{ key: RawToReact_key_counter },
				recurseConvert(content, props)
			);
		case 'u':
			return react_default.a.createElement(
				'span',
				{ key: RawToReact_key_counter, style: { textDecoration: 'underline' } },
				recurseConvert(content, props)
			);
		case 'sup':
			return react_default.a.createElement(
				'sup',
				{ key: RawToReact_key_counter },
				recurseConvert(content, props)
			);

		case 'ol':
			return react_default.a.createElement(
				'ol',
				{ key: RawToReact_key_counter },
				recurseConvert(cleanExtraCR(content), props)
			);
		case 'ul':
			return react_default.a.createElement(
				'ul',
				{ key: RawToReact_key_counter },
				recurseConvert(cleanExtraCR(content), props)
			);
		case 'li':
			return react_default.a.createElement(
				'li',
				{ key: RawToReact_key_counter },
				recurseConvert(content, props)
			);

		case 'table':
			return react_default.a.createElement(
				'table',
				{ key: RawToReact_key_counter },
				recurseConvert(content, props)
			);
		case 'tr':
			return react_default.a.createElement(
				'tr',
				{ key: RawToReact_key_counter },
				recurseConvert(content, props)
			);
		case 'th':
			return react_default.a.createElement(
				'th',
				{ key: RawToReact_key_counter },
				recurseConvert(content, props)
			);
		case 'td':
			return react_default.a.createElement(
				'td',
				{ key: RawToReact_key_counter },
				recurseConvert(content, props)
			);

		case 'livestream':
			if (content && content.length > 0) {
				return react_default.a.createElement(posts_livestreamComponent, { content: content[0], key: RawToReact_key_counter });
			}
			return null;

		case 'spoiler':
			return react_default.a.createElement(
				'div',
				{ className: 'spoilerAlert' },
				react_default.a.createElement(
					'p',
					null,
					'Spoiler Alert ',
					react_default.a.createElement(
						'em',
						{ onClick: function onClick(e) {
								return showSpoiler(e);
							} },
						'Show'
					)
				),
				react_default.a.createElement(
					'div',
					{ className: 'spoiler-message hidden' },
					recurseConvert(content, props)
				)
			);

		default:
			if (close) {
				return react_default.a.createElement(
					'span',
					{ key: RawToReact_key_counter },
					'[' + tag + (attributes || '') + ']',
					react_default.a.createElement(
						'span',
						{ key: RawToReact_key_counter },
						recurseConvert(content, props)
					),
					'[' + close.tag + ']'
				);
			} else {
				return react_default.a.createElement(
					'span',
					{ key: RawToReact_key_counter },
					'[' + tag + (attributes || '') + ']'
				);
			}
	}
}

var RawToReact_key_counter = 0,
    allowHTML = false;

function recurseConvert(parseArray, props) {
	var sub_key_counter = 0;
	return parseArray.map(function (e) {
		RawToReact_key_counter++;
		if (typeof e === 'string') {
			if (e) {
				sub_key_counter++;
				// We dangerously set innerhtml here because vbulletin pre-sanitizes the content
				return e !== "\n" ? react_default.a.createElement('span', { key: RawToReact_key_counter + '_' + sub_key_counter, dangerouslySetInnerHTML: { __html: (allowHTML ? simpleDecodeEntities(e) : e).replace(/\n/ig, '<br />') } }) : null;
			}
			return false;
		} else {

			if (e.content || e.attributes) {
				// convert if we have content or attributes
				return convertCodeBlock(e, props);
			} else if (e.open.tag) {
				// malformed tags? let's leave them
				var _tag = '[' + e.open.tag + ']'; // recreate the tag
				return react_default.a.createElement('span', { key: RawToReact_key_counter, dangerouslySetInnerHTML: { __html: _tag } });
			}
		}
	});
}

// Cleans extra carriage returns between elements
function cleanExtraCR(content) {
	var re = /^[\n|\r]+$/;
	return content ? content.filter(function (e) {
		return !(typeof e === 'string' && re.test(e));
	}) : [];
}

// Checks for potential embed videos
function is_embed_video(content) {
	var videoSites = [{ type: 'youtube', reg: 'youtu(?:be\.com|\.be)\/(?:watch\?v=)?([a-z0-9\-\_]+)' }, { type: 'soundcloud', reg: 'soundcloud.com\/player\/[?]url=.+' }, { type: 'vimeo', reg: 'player.vimeo.com\/video\/.+' }, { type: 'metacafe', reg: 'metacafe.com\/embed\/.+' }, { type: 'dm', reg: 'dailymotion.com\/embed\/video\/.+' } // dailymotion
	];

	if ((typeof content === 'undefined' ? 'undefined' : _typeof(content)) === 'object') {
		content = content.length > 0 ? content[0] : '';
	}

	for (var i = 0; i < videoSites.length; i++) {
		var video = videoSites[i],
		    re = new RegExp(video.reg, 'i');
		if (re.test(content)) {
			return video.type;
		}
	}

	return false;
}

// video embeding or not
function embed_video(content) {
	var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

	if ((typeof content === 'undefined' ? 'undefined' : _typeof(content)) === 'object') {
		content = content.length > 0 ? content[0] : '';
	}

	switch (type) {
		case 'dm':
			// dailymotion
			return react_default.a.createElement('iframe', { key: RawToReact_key_counter, className: 'videoembed', src: 'https://www.dailymotion.com/embed/video/' + content, frameBorder: '0' });

		case 'metacafe':
			// metacafe
			return react_default.a.createElement('iframe', { key: RawToReact_key_counter, className: 'videoembed', src: 'https://www.metacafe.com/embed/' + content, allowFullScreen: true, frameBorder: '0' });

		case 'vimeo':
			// vimeo
			return react_default.a.createElement('iframe', { key: RawToReact_key_counter, className: 'videoembed', src: 'https://player.vimeo.com/video/' + content, frameBorder: '0', allowFullScreen: true });

		case 'soundcloud':
			// SoundCloud
			return react_default.a.createElement('iframe', { key: RawToReact_key_counter, className: 'videoembed', scrolling: 'no', frameBorder: 'no', src: 'https://w.soundcloud.com/player/?url=' + encodeURIComponent(content) + '&auto_play=false&hide_related=false&show_comments=true&show_user=true&show_reposts=false&visual=true' });

		case 'youtube':
		default:
			// is a youtube video?
			var _ym = content.match(/youtu(?:be\.com|\.be)\/(?:watch\?v=)?([a-z0-9\-\_]+)/i);
			if (_ym && _ym[1]) {
				var _youtube = 'https://www.youtube.com/embed/' + _ym[1];
				return react_default.a.createElement('iframe', { key: RawToReact_key_counter, className: 'videoembed', src: _youtube, frameBorder: '0', allowFullScreen: true });
			} else {
				return react_default.a.createElement(
					'a',
					{ key: RawToReact_key_counter, href: content, target: '_blank' },
					content
				);
			}
	}
}

function showSpoiler(e) {
	e.stopPropagation();

	e.target.classList.add('hidden');
	e.target.parentNode.nextSibling.classList.remove('hidden');
	return true;
}

/* harmony default export */ var RawToReact = (function (rawBody, props) {
	var html = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

	var _parser$parse = BBCodeParser.parse(rawBody),
	    status = _parser$parse.status,
	    value = _parser$parse.value,
	    expected = _parser$parse.expected,
	    index = _parser$parse.index;

	RawToReact_key_counter = 0;
	allowHTML = html;

	if (status) {
		return recurseConvert(value, props);
	} else {
		RawToReact_key_counter++;
		topifyConsole.error("Failed to parse, expected:", expected, " at index", index);
		topifyConsole.log(rawBody.slice(index - 100, index + 200));
		return react_default.a.createElement('span', { key: RawToReact_key_counter, dangerouslySetInnerHTML: { __html: rawBody } });
	}
});
// EXTERNAL MODULE: ./src/actions/ForumviewActions.js
var ForumviewActions = __webpack_require__(30);

// CONCATENATED MODULE: ./src/components/threads/ThreadComponent.js
var ThreadComponent__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function ThreadComponent__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function ThreadComponent__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function ThreadComponent__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
















var ThreadComponent_ThreadComponent = function (_React$Component) {
	ThreadComponent__inherits(ThreadComponent, _React$Component);

	function ThreadComponent() {
		var _ref;

		var _temp, _this, _ret;

		ThreadComponent__classCallCheck(this, ThreadComponent);

		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		return _ret = (_temp = (_this = ThreadComponent__possibleConstructorReturn(this, (_ref = ThreadComponent.__proto__ || Object.getPrototypeOf(ThreadComponent)).call.apply(_ref, [this].concat(args))), _this), _this.subscribeThread = function (event) {
			var userState = _this.props.ustate,
			    isSub = void 0,
			    subType = void 0;
			event.stopPropagation(); // stop here

			if (userState.id) {
				if (typeof _this.props.forum !== 'undefined') {
					isSub = _this.props.forum.isSubscribed;
					subType = 'forum';
				} else {
					isSub = _this.props.thread.isSubscribed;
					subType = 'topic';
				}

				if (isSub) {
					_this.props.dispatch(Object(UiActions["N" /* showConfirmModal */])('Unsubscribe', 'Would you like to unsubscribe from this ' + subType + '?', function () {
						return _this.props.dispatch(Object(ForumviewActions["g" /* updateFollowing */])(_this.props));
					}));
				} else {
					_this.props.dispatch(Object(ForumviewActions["g" /* updateFollowing */])(_this.props));
				}

				// Record the Google Analytics event.
				_this.props.dispatch(Object(adsActions["A" /* trackGAEvent */])(false, 'followingTopic', 'uiAction', 'tap'));
			} else {
				// for guests show the login modal
				_this.props.dispatch(Object(UiActions["M" /* resetOverlay */])());
				_this.props.dispatch(Object(UiActions["P" /* showLoginModal */])());
				// Record the Google Analytics event.
				_this.props.dispatch(Object(adsActions["A" /* trackGAEvent */])(false, 'followTopic', 'userAction', 'loginPrompt'));
			}
		}, _temp), ThreadComponent__possibleConstructorReturn(_this, _ret);
	}

	ThreadComponent__createClass(ThreadComponent, [{
		key: 'selectThread',
		value: function selectThread() {
			this.props.dispatch(Object(MetaActions["e" /* toggleSelectedItem */])(this.props.thread.id));
		}
	}, {
		key: 'render',
		value: function render() {
			var _this2 = this;

			var _props$thread = this.props.thread,
			    id = _props$thread.id,
			    title = _props$thread.title,
			    postsCount = _props$thread.postsCount,
			    lastDateline = _props$thread.lastDateline,
			    dateline = _props$thread.dateline,
			    unread = _props$thread.unread,
			    isSubscribed = _props$thread.isSubscribed;


			var preview = this.props.showLast && this.props.thread.previewlast ? this.props.thread.previewlast : this.props.thread.preview,
			    content_showed = this.props.expandedContent ? RawToReact(this.props.expandedContent, this.props, false) : simpleDecodeEntities(preview);

			var statsData = postsCount ? react_default.a.createElement(
				'div',
				{ className: 'stats' },
				react_default.a.createElement(
					'div',
					{ className: 'stats-counter' },
					react_default.a.createElement(svg_SvgIcon, { size: '12px', icon: 'forum' }),
					postsCount.toLocaleString(),
					' ',
					'post' + (parseInt(postsCount) !== 1 ? 's' : '')
				),
				react_default.a.createElement(common_dateComponent, { timestamp: lastDateline, icon: true })
			) : react_default.a.createElement(
				'div',
				{ className: 'stats single-right' },
				react_default.a.createElement(common_dateComponent, { timestamp: dateline, icon: true })
			);

			var subscribe = this.props.isSubscribable ? react_default.a.createElement(
				'div',
				{ className: 'subscribe', onClick: this.subscribeThread },
				react_default.a.createElement(svg_SvgIcon, { size: '20px', icon: 'subscribe' })
			) : '';

			var deleted = this.props.thread.isDeleted ? react_default.a.createElement(
				'div',
				{ className: 'thread-deleted' },
				react_default.a.createElement(svg_SvgIcon, { size: '20px', icon: 'delete' })
			) : null;

			var user = this.props.user || { avatar: '', userName: '-' };

			var checked = !!(this.props.selectedElements && this.props.selectedElements[id]),
			    checkBox = this.props.isSubscribable && this.props.isSearch !== true && !deleted ? react_default.a.createElement(CheckboxComponent, {
				name: 'threadSelect_' + this.props.thread.forum,
				id: 'threadSelect_' + id,
				value: id,
				checked: checked,
				multiple: true,
				className: 'inPost',
				onChange: function onChange() {
					return _this2.selectThread();
				}
			}) : null;

			return react_default.a.createElement(
				'div',
				{ className: 'nolinks thread' + (this.props.ustate.id && unread ? ' indicator' : '') + (isSubscribed ? ' subscribed' : '') + (deleted ? ' deleted' : '') + (checked ? ' selected-item' : '') },
				react_default.a.createElement(
					'div',
					{ className: 'left' },
					react_default.a.createElement(common_UserIconComponent, { user: user, layout: 'nolocation' })
				),
				react_default.a.createElement(
					'div',
					{ className: 'right' },
					react_default.a.createElement(
						'div',
						{ className: 'thread-info' },
						checkBox,
						subscribe,
						deleted
					),
					react_default.a.createElement(
						'div',
						{ className: 'title' },
						RawToReact(title)
					),
					statsData,
					react_default.a.createElement(
						'div',
						{ className: 'topic-preview' },
						content_showed
					)
				)
			);
		}
	}]);

	return ThreadComponent;
}(react_default.a.Component);

/* harmony default export */ var threads_ThreadComponent = (ThreadComponent_ThreadComponent);
// CONCATENATED MODULE: ./src/components/widgets/WidgetThreadListComponent.js
var WidgetThreadListComponent__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function WidgetThreadListComponent__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function WidgetThreadListComponent__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function WidgetThreadListComponent__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var WidgetThreadListComponent_WidgetThreadListComponent = function (_React$Component) {
	WidgetThreadListComponent__inherits(WidgetThreadListComponent, _React$Component);

	function WidgetThreadListComponent() {
		var _ref;

		var _temp, _this, _ret;

		WidgetThreadListComponent__classCallCheck(this, WidgetThreadListComponent);

		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		return _ret = (_temp = (_this = WidgetThreadListComponent__possibleConstructorReturn(this, (_ref = WidgetThreadListComponent.__proto__ || Object.getPrototypeOf(WidgetThreadListComponent)).call.apply(_ref, [this].concat(args))), _this), _this.gotoThread = function (event) {
			if (event.currentTarget.dataset.threadid) {
				_this.props.dispatch(Object(react_router_redux_lib["push"])(Object(NavHelpers["q" /* pathToThread */])(event.currentTarget.dataset.threadid)));
			}
		}, _temp), WidgetThreadListComponent__possibleConstructorReturn(_this, _ret);
	}

	WidgetThreadListComponent__createClass(WidgetThreadListComponent, [{
		key: 'buildList',
		value: function buildList(key, topic, users) {
			var thisUser = this.props.showLast && topic.lastUserid && users[topic.lastUserid] ? users[topic.lastUserid] : users[topic.forumUser];

			return react_default.a.createElement(
				'li',
				{ key: key, 'data-threadid': topic.id, onClick: this.gotoThread },
				react_default.a.createElement(threads_ThreadComponent, {
					thread: topic,
					isSubscribable: true,
					isSearch: true,
					user: thisUser,
					dispatch: this.props.dispatch,
					ustate: this.props.ustate,
					showLast: this.props.showLast,
					selectedElements: false
				})
			);
		}
	}, {
		key: 'threadListPage',
		value: function threadListPage() {
			var _this2 = this;

			// We need to use results to preserve the order received
			var _props$widget = this.props.widget,
			    _props$widget$entitie = _props$widget.entities,
			    topics = _props$widget$entitie.topics,
			    users = _props$widget$entitie.users,
			    resultTopics = _props$widget.result.topics;

			return resultTopics.map(function (k, i) {
				return _this2.buildList(i, topics[k], users);
			});
		}
	}, {
		key: 'render',
		value: function render() {
			if (!this.props.widget || this.props.widget.isFetching) {
				return react_default.a.createElement('span', null);
			}

			return react_default.a.createElement(
				'ul',
				null,
				this.threadListPage()
			);
		}
	}]);

	return WidgetThreadListComponent;
}(react_default.a.Component);

/* harmony default export */ var widgets_WidgetThreadListComponent = (Object(es["b" /* connect */])(widgetsSelector)(WidgetThreadListComponent_WidgetThreadListComponent));
// CONCATENATED MODULE: ./src/components/common/LoaderCssComponent.js


/* harmony default export */ var LoaderCssComponent = (function (props) {
	var style = props.style ? props.style : {},
	    extraClassName = props.className ? '  ' + props.className : '',
	    hasContainer = !!(props.container !== false || props.containerClass),
	    containerClass = props.containerClass ? props.containerClass : '';

	var loader = react_default.a.createElement(
		'div',
		{ className: 'loader-css' + extraClassName, style: style },
		react_default.a.createElement('div', null)
	);

	return hasContainer === false ? loader : react_default.a.createElement(
		'div',
		{ className: containerClass },
		loader
	);
});
// CONCATENATED MODULE: ./src/components/widgets/WidgetContainerComponent.js
var WidgetContainerComponent__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function WidgetContainerComponent__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function WidgetContainerComponent__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function WidgetContainerComponent__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }















var WidgetContainerComponent_WidgetContainerComponent = function (_React$Component) {
	WidgetContainerComponent__inherits(WidgetContainerComponent, _React$Component);

	function WidgetContainerComponent(props) {
		WidgetContainerComponent__classCallCheck(this, WidgetContainerComponent);

		var _this = WidgetContainerComponent__possibleConstructorReturn(this, (WidgetContainerComponent.__proto__ || Object.getPrototypeOf(WidgetContainerComponent)).call(this, props));

		_this.refreshThisWidget = function () {
			_this.props.dispatch(Object(WidgetActions["i" /* refreshWidget */])(_this.widgetShortName));
			_this.props.dispatch(Object(adsActions["A" /* trackGAEvent */])(false, 'refresh_Widget-' + _this.widgetShortName, 'userAction', 'consumption'));
		};

		_this.prepareRequest = function () {
			var id = 'new';
			switch (_this.props.type) {
				case 'popularTopics':
					id = 'new_byv';
			}

			return {
				id: id,
				showtopics: null,
				showposts: null,
				page: 1,
				pageSize: 4
			};
		};

		_this.widgetShortName = _this.props.widgetName.replace(/\s+|\./ig, '_');
		return _this;
	}

	WidgetContainerComponent__createClass(WidgetContainerComponent, [{
		key: 'componentDidMount',
		value: function componentDidMount() {
			this.dispatchRequest(this.props, false);
		}
	}, {
		key: 'componentWillUnmount',
		value: function componentWillUnmount() {
			this.props.dispatch(Object(WidgetActions["g" /* deleteWidget */])(this.widgetShortName));
		}
	}, {
		key: 'shouldComponentUpdate',
		value: function shouldComponentUpdate(nextProps) {
			var thisWidget = this.props.widgetState.widgets[this.widgetShortName],
			    thisWidgetNext = nextProps.widgetState.widgets[this.widgetShortName];
			return !!(thisWidget && thisWidgetNext && (thisWidget.isFetching !== thisWidgetNext.isFetching || thisWidget.beenUpdated !== thisWidgetNext.beenUpdated));
		}
	}, {
		key: 'componentWillReceiveProps',
		value: function componentWillReceiveProps(nextProps) {
			var thisWidget = this.props.widgetState.widgets[this.widgetShortName],
			    thisWidgetNext = nextProps.widgetState.widgets[this.widgetShortName];

			if (thisWidgetNext && thisWidget && thisWidget.isFetching !== true && typeof thisWidget.refresh !== 'undefined') {
				if (thisWidget.refresh !== thisWidgetNext.refresh) {
					this.dispatchRequest(this.props, true);
				}
			}
		}
	}, {
		key: 'dispatchRequest',
		value: function dispatchRequest(props, refresh) {
			var requestParams = this.prepareRequest(props);
			var cacheBust = refresh ? new Date().getTime() : false;
			this.props.dispatch(Object(WidgetActions["h" /* fetchWidget */])(requestParams, this.widgetShortName, this.props.type, cacheBust));
		}
	}, {
		key: 'getWidget',
		value: function getWidget() {
			var widget = null;
			switch (this.props.type) {
				case 'activeTopics':
				case 'popularTopics':
					widget = react_default.a.createElement(widgets_WidgetThreadListComponent, {
						widget: this.props.widgetState.widgets[this.widgetShortName],
						showLast: true
					});
					break;

				default:
					widget = react_default.a.createElement(
						'div',
						{ className: 'widgetSubContainer' },
						react_default.a.createElement(
							'p',
							null,
							'Widget called: ',
							this.props.widgetName
						),
						react_default.a.createElement(
							'p',
							null,
							'Some text here'
						),
						react_default.a.createElement(
							'p',
							null,
							RawToReact('more text here')
						)
					);
					break;
			}

			return widget;
		}
	}, {
		key: 'render',
		value: function render() {
			var thisWidget = this.props.widgetState.widgets[this.widgetShortName] || null;
			var component = thisWidget && thisWidget.isFetching === false ? this.getWidget() : react_default.a.createElement(LoaderCssComponent, { containerClass: 'loaderContainer' });

			return react_default.a.createElement(
				'div',
				{ id: 'widget-' + this.widgetShortName, className: 'widget threads' },
				react_default.a.createElement(
					'div',
					{ className: 'forumGroup' },
					this.props.widgetName,
					react_default.a.createElement(
						'div',
						{ className: 'icon refresh', onClick: this.refreshThisWidget },
						react_default.a.createElement(svg_SvgIcon, { icon: 'refresh', size: '16px' })
					)
				),
				react_default.a.createElement(
					'div',
					{ className: 'thread widgetContainer' },
					component
				)
			);
		}
	}]);

	return WidgetContainerComponent;
}(react_default.a.Component);

/* harmony default export */ var widgets_WidgetContainerComponent = (Object(es["b" /* connect */])(widgetsSelector)(WidgetContainerComponent_WidgetContainerComponent));
// CONCATENATED MODULE: ./src/components/RootViewComponent.js
var RootViewComponent__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function RootViewComponent__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function RootViewComponent__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function RootViewComponent__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




















var RootViewComponent_RootViewComponent = function (_React$Component) {
	RootViewComponent__inherits(RootViewComponent, _React$Component);

	function RootViewComponent(props) {
		RootViewComponent__classCallCheck(this, RootViewComponent);

		var _this = RootViewComponent__possibleConstructorReturn(this, (RootViewComponent.__proto__ || Object.getPrototypeOf(RootViewComponent)).call(this, props));

		_this.getRootWidgets = function () {
			var widgets = [];

			widgets.push(react_default.a.createElement(widgets_WidgetContainerComponent, { key: '1', widgetName: 'Active Topics', type: 'activeTopics' }));
			widgets.push(react_default.a.createElement(widgets_WidgetContainerComponent, { key: '2', widgetName: 'Popular Images', type: 'popularImages' }));
			widgets.push(react_default.a.createElement(widgets_WidgetContainerComponent, { key: '3', widgetName: 'Popular Threads', type: 'popularTopics' }));
			widgets.push(react_default.a.createElement(widgets_WidgetContainerComponent, { key: '4', widgetName: 'Vendor Topics', type: 'vendorTopics' }));

			return widgets;
		};

		_this.initialView = function () {
			var forumSite = _this.props.forumSite;

			return [react_default.a.createElement(
				'div',
				{ className: 'coverphoto', key: 'coverphoto' },
				react_default.a.createElement('img', { className: 'no-ad', src: forumSite.cover_photo })
			), react_default.a.createElement(
				'div',
				{ className: 'detail', key: 'detail' },
				react_default.a.createElement(
					'div',
					{ className: 'title' },
					forumSite.f_title
				),
				react_default.a.createElement(
					'div',
					{ className: 'url' },
					forumSite.f_url
				)
			), react_default.a.createElement(LoaderCssComponent, { key: 'loader' })];
		};

		return _this;
	}

	RootViewComponent__createClass(RootViewComponent, [{
		key: 'componentWillMount',
		value: function componentWillMount() {
			this.props.dispatch(Object(WidgetActions["j" /* resetWidgets */])());
			this.props.dispatch(Object(GlobalMetaActions["g" /* pingServer */])());
		}
	}, {
		key: 'componentDidMount',
		value: function componentDidMount() {
			// Do not load root if we are on first load and we need to load other page
			if (this.props.firstLoad && (this.props.initialRoute || this.props.userSettings.landingPage !== 'home')) {
				return;
			}

			window.scrollTo(0, 0);

			// Setting Header title
			this.props.dispatch(Object(MetaActions["b" /* receiveGlobalMeta */])(null, this.props.forumSite.f_title));
			// trigger ad updates
			this.props.dispatch(Object(adsActions["s" /* onPageView */])());
			// Record the Google Analytics pageview
			this.props.dispatch(Object(adsActions["B" /* trackPageView */])());
		}
	}, {
		key: 'componentWillUnmount',
		value: function componentWillUnmount() {
			this.props.dispatch(Object(WidgetActions["j" /* resetWidgets */])());
		}
	}, {
		key: 'render',
		value: function render() {
			var content = this.props.userInfo === null ? react_default.a.createElement(
				'div',
				{ className: 'forumsIndex nolinks' },
				this.getRootWidgets()
			) : this.initialView();

			return react_default.a.createElement(
				'div',
				{ className: 'forumRoot nolinks' },
				content
			);
		}
	}]);

	return RootViewComponent;
}(react_default.a.Component);

RootViewComponent_RootViewComponent.propTypes = {
	forumSite: prop_types_default.a.shape({
		cover_photo: prop_types_default.a.string.isRequired,
		f_title: prop_types_default.a.string.isRequired,
		f_url: prop_types_default.a.string.isRequired
	})
};

/* harmony default export */ var components_RootViewComponent = (Object(es["b" /* connect */])(rootViewSelector)(RootViewComponent_RootViewComponent));
// CONCATENATED MODULE: ./src/selectors/forumViewSelector.js



var forumViewSelector_forumviewSelector = function forumviewSelector(state) {
	return state.forumview.forumId ? state.forumview : state.searchresult;
};
var forumViewSelector_topifyPresetsSelector = function topifyPresetsSelector(state) {
	return state.topifyPresets;
};
var forumViewSelector_userStateSelector = function userStateSelector(state) {
	return state.ustate;
};
var forumViewSelector_uiStateSelector = function uiStateSelector(state) {
	return state.ui;
};

/* harmony default export */ var forumViewSelector = (Object(lib["createSelector"])([forumViewSelector_forumviewSelector, selectors_metaSelector, forumViewSelector_topifyPresetsSelector, forumViewSelector_userStateSelector, forumViewSelector_uiStateSelector], function (forumview, meta, topifyPresets, ustate, ui) {
	return {
		forumview: forumview,
		meta: meta,
		ustate: ustate,
		userSettings: ui.userSettings,
		forumSite: topifyPresets.forumSite,
		firstLoad: topifyPresets.firstLoad,
		initialRoute: topifyPresets.initialRoute,
		initialId: topifyPresets.initialId,
		secondayId: topifyPresets.secondayId
	};
}));
// CONCATENATED MODULE: ./src/components/forums/ForumComponent.js
var ForumComponent__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function ForumComponent__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function ForumComponent__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function ForumComponent__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var ForumComponent_ForumComponent = function (_React$Component) {
	ForumComponent__inherits(ForumComponent, _React$Component);

	function ForumComponent() {
		var _ref;

		var _temp, _this, _ret;

		ForumComponent__classCallCheck(this, ForumComponent);

		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		return _ret = (_temp = (_this = ForumComponent__possibleConstructorReturn(this, (_ref = ForumComponent.__proto__ || Object.getPrototypeOf(ForumComponent)).call.apply(_ref, [this].concat(args))), _this), _this.subscribeForum = function (event) {
			var userState = _this.props.ustate,
			    isSub = void 0,
			    subType = void 0;

			event.stopPropagation(); // stop here

			if (userState.id) {
				if (typeof _this.props.forum !== 'undefined') {
					isSub = !!_this.props.forum.isSubscribed;
					subType = 'forum';
				} else {
					isSub = !!_this.props.thread.isSubscribed;
					subType = 'topic';
				}

				if (isSub) {
					_this.props.dispatch(Object(UiActions["N" /* showConfirmModal */])('Unsubscribe', 'Would you like to unsubscribe from this ' + subType + '?', function () {
						return _this.props.dispatch(Object(ForumviewActions["g" /* updateFollowing */])(_this.props));
					}));
				} else {
					_this.props.dispatch(Object(ForumviewActions["g" /* updateFollowing */])(_this.props));
				}

				// Record the Google Analytics event.
				_this.props.dispatch(Object(adsActions["A" /* trackGAEvent */])(false, 'followingForum', 'uiAction', 'tap'));
			} else {
				// for guests show the login modal
				_this.props.dispatch(Object(UiActions["M" /* resetOverlay */])());
				_this.props.dispatch(Object(UiActions["P" /* showLoginModal */])());
				// Record the Google Analytics event.
				_this.props.dispatch(Object(adsActions["A" /* trackGAEvent */])(false, 'followForum', 'userAction', 'loginPrompt'));
			}
		}, _temp), ForumComponent__possibleConstructorReturn(_this, _ret);
	}

	ForumComponent__createClass(ForumComponent, [{
		key: 'render',
		value: function render() {
			var _props$forum = this.props.forum,
			    title = _props$forum.title,
			    topicCounter = _props$forum.topicCounter,
			    lastPost = _props$forum.lastPost,
			    isRead = _props$forum.isRead,
			    isSubscribed = _props$forum.isSubscribed;


			return react_default.a.createElement(
				'div',
				{ className: 'forum' + (isRead ? '' : ' indicator') + (isSubscribed ? ' subscribed' : '') },
				react_default.a.createElement(
					'div',
					{ className: 'title' },
					RawToReact(title)
				),
				react_default.a.createElement(
					'div',
					{ className: 'subscribe', onClick: this.subscribeForum },
					react_default.a.createElement(svg_SvgIcon, { size: '20px', icon: 'subscribe' })
				),
				react_default.a.createElement(
					'div',
					{ className: 'stats' },
					react_default.a.createElement(
						'div',
						{ className: 'left-stats' },
						react_default.a.createElement(svg_SvgIcon, { size: '12px', icon: 'forum' }),
						topicCounter.toLocaleString(),
						' topics'
					),
					react_default.a.createElement(common_dateComponent, { timestamp: lastPost, icon: true })
				)
			);
		}
	}]);

	return ForumComponent;
}(react_default.a.Component);

/* harmony default export */ var forums_ForumComponent = (ForumComponent_ForumComponent);
// CONCATENATED MODULE: ./src/components/forums/ForumLinkComponent.js



var ForumLinkComponent_ForumLinkComponent = function ForumLinkComponent(props) {
	var _props$forum = props.forum,
	    title = _props$forum.title,
	    link = _props$forum.link;


	var openLink = function openLink() {
		window.open(link);
	};

	return react_default.a.createElement(
		'div',
		{ className: 'forum', onClick: function onClick() {
				return openLink();
			} },
		react_default.a.createElement(
			'div',
			{ className: 'title' },
			RawToReact(title)
		),
		react_default.a.createElement(
			'div',
			{ className: 'link' },
			link
		)
	);
};

/* harmony default export */ var forums_ForumLinkComponent = (ForumLinkComponent_ForumLinkComponent);
// EXTERNAL MODULE: ./node_modules/lodash/throttle.js
var throttle = __webpack_require__(333);
var throttle_default = /*#__PURE__*/__webpack_require__.n(throttle);

// CONCATENATED MODULE: ./src/selectors/adSelector.js


var adSelector_routingSelector = function routingSelector(state) {
	return state.routing;
};
var adSelector_topifyPresetsSelector = function topifyPresetsSelector(state) {
	return state.topifyPresets;
};
var adSelector_userStateSelector = function userStateSelector(state) {
	return state.ustate;
};
var adSelector_uiStateSelector = function uiStateSelector(state) {
	return state.ui;
};
var adsStateSelector = function adsStateSelector(state) {
	return state.ads;
};

/* harmony default export */ var adSelector = (Object(lib["createSelector"])([adSelector_routingSelector, adSelector_topifyPresetsSelector, adSelector_userStateSelector, adSelector_uiStateSelector, adsStateSelector], function (routing, topifyPresets, ustate, ui, ads) {
	return {
		topifyPresets: topifyPresets,
		ads: ads,
		ustate: ustate,
		routing: routing,
		overlayElements: {
			sidebarOpened: ui.sidebarOpened,
			searchBarOpened: ui.searchBarOpened,
			headerOverflowOpened: ui.headerOverflowOpened,
			loginModalOpened: ui.loginModalOpened,
			confirmModalOpened: ui.confirmModalOpened,
			globalLoading: ui.globalLoading,
			replyModalOpened: ui.replyModal.opened,
			userModalOpened: ui.userModal.opened,
			shareModalOpened: ui.shareModal.opened,
			announcementsOpen: ui.announcementsOpen
		}
	};
}));
// CONCATENATED MODULE: ./src/components/ads/afsAdComponent.js



var afsAdComponent_AFSAdComponent = function AFSAdComponent(_ref) {
	var adName = _ref.adName;

	return react_default.a.createElement('div', { id: adName, className: 'afs-ad', style: { width: 'auto', height: 'auto' } });
};

afsAdComponent_AFSAdComponent.propTypes = {
	adName: prop_types_default.a.string.isRequired
};

/* harmony default export */ var afsAdComponent = (afsAdComponent_AFSAdComponent);
// CONCATENATED MODULE: ./src/components/ads/inContentAdComponent.js



var inContentAdComponent_InContentAdComponent = function InContentAdComponent(_ref) {
	var adName = _ref.adName,
	    height = _ref.height;

	return react_default.a.createElement('div', { id: adName, style: { width: '100%', height: height || 'auto' } });
};

inContentAdComponent_InContentAdComponent.propTypes = {
	adName: prop_types_default.a.string.isRequired
};

/* harmony default export */ var inContentAdComponent = (inContentAdComponent_InContentAdComponent);
// CONCATENATED MODULE: ./src/components/ads/secondaryAdComponent.js



var secondaryAdComponent_secondaryAdComponent = function secondaryAdComponent(_ref) {
	var adName = _ref.adName,
	    type = _ref.type;

	var className = 'secondary-ad ' + type + '_secondary-ad';

	return react_default.a.createElement('iframe', { id: 'SecondaryAd_' + adName, className: className, scrolling: 'no' });
};

secondaryAdComponent_secondaryAdComponent.propTypes = {
	adName: prop_types_default.a.string.isRequired,
	type: prop_types_default.a.string.isRequired
};

/* harmony default export */ var ads_secondaryAdComponent = (secondaryAdComponent_secondaryAdComponent);
// CONCATENATED MODULE: ./src/utils/swipe.js
/**
 * Simple Swipe event handler from:
 * http://nineteentwentyseven.com/2015/12/08/simple-touch-events-horizontal-swiping-for-reactjs-image-modal
 * ****
 * Usage:
 * call it in componentDidMount with Swipe.init( DOMelement, callbackFunction );
 * and then kill it in componentWillUnmount with Swipe.kill( DOMelement );
 *
 **/

// min x delta swipe for horizontal swipe
var MIN_X = 30;
// max y delta for horizontal swipe
var MAX_Y = 50;

var eventObj = {
	startX: 0,
	startY: 0,
	endX: 0,
	endY: 0
};

var swipe_callback = void 0;

function init(el, action) {
	el.addEventListener('touchstart', handleStart, false);
	el.addEventListener('touchmove', handleMove, false);
	el.addEventListener('touchend', handleEnd, false);
	swipe_callback = action;
}

function kill(el) {
	el.removeEventListener('touchstart', handleStart);
	el.removeEventListener('touchmove', handleMove);
	el.removeEventListener('touchend', handleEnd);
	swipe_callback = undefined;
}

function handleStart(e) {
	// assuming single touch, e.touches is an Array of all touches,
	// but with single touch there is only one element
	var touch = e.touches[0];
	eventObj.startX = touch.screenX;
	eventObj.startY = touch.screenY;
}

function handleMove(e) {
	var touch = e.touches[0];
	eventObj.endX = touch.screenX;
	eventObj.endY = touch.screenY;
}

function handleEnd() {
	var code = void 0;
	var xDelta = eventObj.startX - eventObj.endX;

	// check to see if the delta of X is great enough to trigger a swipe gesture
	// also see if the Y delta wasn’t too drastic to be considered horizontal
	if (Math.abs(xDelta) > MIN_X && Math.abs(eventObj.startY - eventObj.endY) < MAX_Y) {
		// acceptable swipe, now if it delta is negative, it’s a left swipe, otherwise right
		code = xDelta < 0 ? 'left' : 'right';
	}

	// trigger callback
	if (swipe_callback && code) {
		swipe_callback(code);
	}
}
// CONCATENATED MODULE: ./src/components/ads/AdComponent.js
var AdComponent__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function AdComponent__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function AdComponent__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function AdComponent__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

















var adRefreshTime = 45 * 1000; // 45 seconds
var prebid_slot_used = {};

/**
 * Component to render Ads
 * We can pass the following props:
 *  - adType int *[mandatory] indicates what ad we want to render. see bellow for types
 *  - adName string *[mandatory] is the name of the ad and the id of the container div
 *  - search object *[mandatory for AFS] for AFS we need to pass some info about the ad (is top, query, page)
 *  - fallbackAdType array [optional] in case the adType is not defined we'll check for any of these adTypes
 *  - className string [optional] className by type are automatically added but if we need to include any extra we can use this prop
 *  - tag string [optional] if we want the ad to wrapped on a tag
 *  - isFetching bool [optional] if refresh depends upon we are not fetching data at the moment, like Bottom_Content_Rectangle
 *
 * Ads active for a site are defined in: topifyPresets.forumSite.dfpTags
 * adTypes will match those on topifyPresets but adType=0 which is AFS and doesn't need Ad Unit
 *
 * Ad Types in app can have the following types:
 * - 0 - 'AFS': AdSense For Search
 * - 1 - 'InContentLeaderboard': usually 320x50 ad inserted every # threads or posts
 * - 2 - 'InContentBottomRectangle': Big 300x250 at the bottom of some pages
 * - 3 - 'FixedBottomLeaderboard': 320x50 ad fixed at the bottom of the viewport and always visible
 * - 4 - 'Insterstitial': Interstitial triggered once after 2 pageviews
 * - 5 - 'InContentTopicAd': ad inserted in index page between categories and at the top of threads (usually fallbackAdType = [1])
 * - 6 - 'beaconLastPost': beacon triggered on some sites
 * - 50 - 'PortalInsurance1': Insurance ad on portal page
 * - 51 - 'PortalInsurance2': Insurance ad on portal page
 * - 52 - 'PortalInsurance3': Insurance ad on portal page
 * - 53 - 'PortalInsurance4': Insurance ad on portal page
 * - 54 - 'PortalInsurance5': Insurance ad on portal page
 * - 101 - 'InContentHomePage': Insurance fake forum in index page
 * - 105 - 'InContentTopicAd_1': ShareThrough ad every # posts (usually fallbackAdType = [1])
 * - 205 - 'InContentTopicAd_2': Yieldmo Hyperscroll/Outstream ad every # posts (usually fallbackAdType = [1])
 * - 305 - 'InContentTopicAd_3': NOT USED
 * - 505 - 'InContentTopicCampaign': Sharethrough Video Campaigns. Top of threads (bellow adType=5) and posts
 *
 */

var AdComponent_AdComponent = function (_React$Component) {
	AdComponent__inherits(AdComponent, _React$Component);

	function AdComponent(props) {
		AdComponent__classCallCheck(this, AdComponent);

		var _this = AdComponent__possibleConstructorReturn(this, (AdComponent.__proto__ || Object.getPrototypeOf(AdComponent)).call(this, props));

		AdComponent__initialiseProps.call(_this);

		_this.visibilityObserver = null;
		_this.theAdElement = null;
		_this.refreshTimer = null;
		_this.adUnit = null;
		_this.ad_slot = {};
		_this.propsChanged = false;
		_this.lastRefreshTime = 0;
		_this.adType = null;
		_this.state = {
			adHidden: false
		};
		return _this;
	}

	AdComponent__createClass(AdComponent, [{
		key: 'componentWillMount',
		value: function componentWillMount() {
			var _this2 = this;

			this.adType = parseInt(this.props.adType);

			if (this.adType === 0) {
				// search AFS
				this.adUnit = this._getAFSAdUnit();
				this.props.dispatch(Object(adsActions["x" /* saveAdSlot */])(this.props.adName));
			} else {
				// gets potential adTypes passed
				this.adTypes = [this.props.adType].concat(_toConsumableArray(this.props.fallbackAdType ? this.props.fallbackAdType : []));
				// ensure everything is int
				this.adTypes.forEach(function (adType, i) {
					return _this2.adTypes[i] = parseInt(adType);
				});

				var units = this._get_AdUnits(),
				    ad_unit = this._find_adType(units, 0);

				if (ad_unit) {
					this.adUnit = this._parseAd(ad_unit);
					this.props.dispatch(Object(adsActions["x" /* saveAdSlot */])(this.props.adName));
				}
			}

			this._checkPerms();
		}
	}, {
		key: 'componentDidMount',
		value: function componentDidMount() {
			topifyConsole.log('Mounted ad:', this.props.adName);
			if (this._isAlwaysShown()) {
				if (this.adUnit) {
					// Some ads are always visible
					this.props.dispatch(Object(adsActions["z" /* showAdSlot */])(this.props.adName));
					this.displayAdUnit();
				}
			} else {
				// Use IntersectionObserver if is available
				if (window.IntersectionObserver) {
					var options = {
						rootMargin: '30% 0%', // 30% of the viewport above and below
						threshold: 0 // just when it shows up
					};

					this.visibilityObserver = new IntersectionObserver(this._checkAdVisibility, options);

					if (this.visibilityObserver && this.theAdElement) {
						this.visibilityObserver.observe(this.theAdElement);
					}
				} else {
					// others just show or hide per scroll position
					window.addEventListener("scroll", this.handleScroll, { passive: true });
					this._checkAdVisibility();
				}
			}
		}
	}, {
		key: 'componentWillReceiveProps',
		value: function componentWillReceiveProps(nextProps) {
			if (nextProps.ads.resetHiddenAds !== this.props.ads.resetHiddenAds) {
				// show those ads hidden
				this._resetAdHidden();
			}
			if (nextProps.ads.resetHiddenAds !== this.props.ads.resetHiddenAds || nextProps.ads.noAdsPermissions !== this.props.ads.noAdsPermissions || nextProps.ads.secondaryAds !== this.props.ads.secondaryAds) {
				this._checkPerms(nextProps);
			}

			// If we have closed the overlays open or the document is on focus again
			// if the ad_slot exists and it's a refreshable ad
			// then re-start refresh
			if ((this.ad_slot.getSlotElementId || nextProps.ads.secondaryAds) && this._noRepetitiveRefreshAd() === false && (this.overlayElementsChanged(nextProps) || nextProps.ads.documentVisible !== this.props.ads.documentVisible) && this.overlayElementsOpen(nextProps) === false && nextProps.ads.documentVisible) {
				this.lastRefreshTime = 0;
				this.scheduleRefresh(500);
			}
		}
	}, {
		key: 'shouldComponentUpdate',
		value: function shouldComponentUpdate(nextProps, nextState) {
			this.propsChanged = nextState.adHidden !== this.state.adHidden || nextProps.ads.noAdsPermissions !== this.props.ads.noAdsPermissions || nextProps.ads.secondaryAds !== this.props.ads.secondaryAds || typeof nextProps.ads.adSlots[nextProps.adName] !== 'undefined' && nextProps.ads.adSlots[nextProps.adName] !== this.props.ads.adSlots[nextProps.adName];

			if (this.propsChanged) {
				this.lastRefreshTime = 0;
			}

			return this.propsChanged;
		}
	}, {
		key: 'componentWillUpdate',
		value: function componentWillUpdate() {
			// if we allowed to swipe to hide, remove events
			if (this._swipeToHide() && this.theAdElement) {
				kill(this.theAdElement);
			}
		}
	}, {
		key: 'componentDidUpdate',
		value: function componentDidUpdate() {
			var _this3 = this;

			if (this.adUnit && this.state.adHidden === false && this._noAdsPermissions() === false && this.props.ads.adSlots[this.props.adName] === true) {
				this._addPrebidAdUnit(this.adUnit);
				topifyConsole.log('pbjs.adUnits', this._isPrebid() ? pbjs.adUnits : 'no prebid');
				this.displayAdUnit();
			} else {
				if (this.props.ads.adSlots[this.props.adName] === true) {
					this.props.dispatch(Object(adsActions["o" /* hideAdSlot */])(this.props.adName));
				}
				this.removeAdUnit();
			}
			// do we allow to swipe to hide?
			if (this._swipeToHide() && this.theAdElement) {
				init(this.theAdElement, function (code) {
					_this3._swipedThenHide(code);
				});
			}
		}
	}, {
		key: 'componentWillUnmount',
		value: function componentWillUnmount() {
			// disconnecting visibilityObserver
			if (this.visibilityObserver) {
				this.visibilityObserver.disconnect();
			} else {
				this.handleScroll.cancel();
				// removing scroll event
				window.removeEventListener("scroll", this.handleScroll, { passive: true });
			}

			// if we allowed to swipe to hide, remove events
			if (this._swipeToHide() && this.theAdElement) {
				kill(this.theAdElement);
			}

			// Remove the ad unit
			this.removeAdUnit();
			this.props.dispatch(Object(adsActions["m" /* deleteAdSlot */])(this.props.adName));
		}
	}, {
		key: 'displayAdUnit',
		value: function displayAdUnit() {
			var _this4 = this;

			if (this.adType === 0) {
				// Search AFS
				if (this._noAdsPermissions() === false) {
					this.displayAFS();
				}
				return;
			}
			// We already have the ad and nothing have changed
			if (this.ad_slot.getSlotElementId && this.propsChanged === false) {
				return;
			}
			// if we are temporary not showing ads, keep on it expecting a change
			if (this._noAdsPermissions() || this.props.ads.secondaryAds || this.state.adHidden) {
				this.scheduleRefresh();
				return;
			}

			var adName = this.props.adName,
			    adType = this.adType,
			    ad = this.adUnit;

			googletag.cmd.push(function () {
				if (googletag.defineSlot && googletag.display) {
					if (!_this4.ad_slot || Object.keys(_this4.ad_slot).length <= 0) {
						if (adType === 4) {
							_this4.ad_slot = googletag.defineSlot(ad.path, ad.size, adName).setCollapseEmptyDiv(true, true).addService(googletag.pubads());
						} else {
							var sizeAd = _this4._getAdSizes();
							_this4.ad_slot = googletag.defineSlot(ad.path, sizeAd, adName).setCollapseEmptyDiv(!_this4._isFluid()).addService(googletag.pubads());
						}
						googletag.display(adName);
					}
					_this4.scheduleRefresh();
				}
			});
		}
	}, {
		key: 'refreshAdUnit',
		value: function refreshAdUnit() {
			var _this5 = this;

			var adName = this.props.adName,
			    ad_slot = this.ad_slot,
			    timestamp = new Date().getTime();

			// The DOM is not there
			if (this.theAdElement === null) {
				return;
			}

			// Do we skip refresh...?
			if (this.props.ads.documentVisible === false || this.overlayElementsOpen()) {
				topifyConsole.log('Ad not visible, skip refresh:', this.props.adName);
				return;
			}
			// If the adSlot wasn't generated when we need it
			if (!ad_slot.getSlotElementId && !this.props.ads.secondaryAds) {
				this.displayAdUnit();
				return;
			}
			// only refresh at most every adRefreshTime
			if (timestamp - adRefreshTime < this.lastRefreshTime) {
				this.scheduleRefresh();
				return;
			}

			// in some cases we don't want to reload ads
			if (this._avoidReloadAdUnit()) {
				return;
			}
			// some ads don't need to be refreshed
			if (this._noRepetitiveRefreshAd() && this.ad_slot.getSlotElementId()) {
				googletag.cmd.push(function () {
					googletag.display(ad_slot.getSlotElementId());
					googletag.pubads().refresh([ad_slot], { changeCorrelator: _this5.props.ads.changeGPTCorrelator });
					if (_this5.props.ads.changeGPTCorrelator) {
						_this5.props.dispatch(Object(adsActions["y" /* setGPTCorrelator */])(false));
					}
				});
				return;
			}

			this.lastRefreshTime = 0;

			// Refresh
			if (this.props.ads.secondaryAds) {
				// If we use secondary ads... Rubicon standalone
				var type = 'rubicon',
				    secAdsProps = {
					size: this.adUnit.size,
					container: 'SecondaryAd_' + this.props.adName
				};
				topifyConsole.info("Secondary Ads", type, secAdsProps);
				var callBack = function callBack() {
					topifyConsole.log('Secondary Ad loaded!! (Rubicon)', _this5.props.adName);
					_this5.theAdElement.classList.remove('hidden');
					_this5.lastRefreshTime = timestamp - 1000;
				},
				    onError = function onError() {
					topifyConsole.warn('Secondary Ad failed!! (Rubicon)', _this5.props.adName);
					_this5.theAdElement.classList.add('hidden');
					_this5.removeAdUnit();
				};

				this.props.dispatch(Object(adsActions["r" /* loadSecondaryAds */])(type, secAdsProps, callBack, onError));
				// leave 2 sec before regular refresh
				this.scheduleRefresh(adRefreshTime - 2000);
			} else if (this._isPrebid()) {
				// If it's prebid
				this.theAdElement.classList.remove('hidden');
				// Refresh individual ad
				pbjs.que.push(function () {
					topifyConsole.info('using pbjs', ad_slot.getSlotElementId());

					// if we have come back form no ads space, we can have an ad defined, display it
					if (!document.getElementById(ad_slot.getSlotElementId()).getAttribute('data-google-query-id')) {
						googletag.display(ad_slot.getSlotElementId());
					}

					// just in case we'll refresh after the refreshtime
					_this5.scheduleRefresh(adRefreshTime);

					// requestBids
					pbjs.requestBids({
						timeout: window.PREBID_TIMEOUT,
						adUnitCodes: [ad_slot.getSlotElementId()],
						bidsBackHandler: function bidsBackHandler() {
							topifyConsole.info('getBidResponsesForAdUnitCode for:', ad_slot.getSlotElementId(), pbjs.getBidResponsesForAdUnitCode(ad_slot.getSlotElementId()));

							_this5.lastRefreshTime = pbjs.getBidResponsesForAdUnitCode(ad_slot.getSlotElementId()).bids.length > 0 ? timestamp - 1000 : timestamp - 10000;
							topifyConsole.log('REFRESH:', _this5.lastRefreshTime, ad_slot.getSlotElementId());

							googletag.cmd.push(function () {
								if (googletag.pubads().clear) {
									googletag.pubads().clear([ad_slot]);
								}
							});

							// Let's trigger the refresh
							_this5.scheduleRefresh(adRefreshTime);

							try {
								pbjs.setTargetingForGPTAsync([ad_slot.getSlotElementId()]);
							} catch (e) {
								topifyConsole.error('pbjs.setTargetingForGPTAsync', adName, ad_slot.getSlotElementId());
							}

							googletag.cmd.push(function () {
								googletag.pubads().refresh([ad_slot], { changeCorrelator: _this5.props.ads.changeGPTCorrelator });
								if (_this5.props.ads.changeGPTCorrelator) {
									_this5.props.dispatch(Object(adsActions["y" /* setGPTCorrelator */])(false));
								}
							});
						}
					});
				});
			} else {
				// If prebid is not ready yet or it's not present we load ads without it
				topifyConsole.info('using googletag', ad_slot.getSlotElementId());
				this.theAdElement.classList.remove('hidden');
				googletag.cmd.push(function () {
					if (googletag.pubads().clear) {
						googletag.pubads().clear([ad_slot]);
					}
				});

				if (!document.getElementById(ad_slot.getSlotElementId()).getAttribute('data-google-query-id')) {
					googletag.cmd.push(function () {
						googletag.display(ad_slot.getSlotElementId());
					});
				}
				googletag.cmd.push(function () {
					_this5.lastRefreshTime = timestamp - 1000;
					_this5.scheduleRefresh(adRefreshTime);

					googletag.pubads().refresh([ad_slot], { changeCorrelator: _this5.props.ads.changeGPTCorrelator });
					if (_this5.props.ads.changeGPTCorrelator) {
						_this5.props.dispatch(Object(adsActions["y" /* setGPTCorrelator */])(false));
					}
				});
			}
		}

		/**
   * Schedules an ad refresh
   *
   * @param extraTime if we want to add an extra time
   */

	}, {
		key: 'scheduleRefresh',
		value: function scheduleRefresh() {
			var _this6 = this;

			var extraTime = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

			if (this.refreshTimer) {
				clearTimeout(this.refreshTimer);
				this.refreshTimer = undefined;
			}
			this.refreshTimer = setTimeout(function () {
				_this6.refreshAdUnit();
			}, 1000 + extraTime);
		}
	}, {
		key: 'removeAdUnit',
		value: function removeAdUnit() {
			var _this7 = this;

			clearTimeout(this.refreshTimer);
			this.refreshTimer = undefined;

			// remove ad slots
			var adName = this.props.adName;
			topifyConsole.log('removeAdUnit', this.props.adName);
			if (this.ad_slot && Object.keys(this.ad_slot).length !== 0) {
				googletag.cmd.push(function () {
					if (googletag.destroySlots) {
						googletag.destroySlots([_this7.ad_slot]);
					}
				});
				this.ad_slot = {};
			}

			if (this._isPrebid()) {
				// Delete from prebis adUnits
				var adIndex = prebid_adUnits.findIndex(function (ad) {
					return ad.code === adName;
				});

				if (adIndex >= 0) {
					// Remove adUnits from tracking
					if (prebid_adUnits[adIndex] && prebid_adUnits[adIndex].Topifytype) {
						delete prebid_slot_used[prebid_adUnits[adIndex].Topifytype];
					}

					// Remove adUnits from prebid adUnits
					if (pbjs.removeAdUnit) {
						pbjs.removeAdUnit(adName);
					}
					prebid_adUnits.splice(adIndex, 1);
				}
			}
		}
	}, {
		key: 'displayAFS',
		value: function displayAFS() {
			if (this.props.ads.adSlots[this.props.adName]) {
				this.adUnit.pageOptions.adPage = this.props.search.page; // page
				this.adUnit.pageOptions.query = this.props.search.searchQuery; // search query

				// if we have all the values we need trigger the ads
				if (typeof _googCsa === 'function' && this.adUnit.pageOptions.pubId && this.adUnit.pageOptions.channel && this.adUnit.pageOptions.query) {
					_googCsa('ads', this.adUnit.pageOptions, this.adUnit.adblock);
				}
			}
		}
	}, {
		key: '_swipedThenHide',
		value: function _swipedThenHide(code) {
			this.props.dispatch(Object(adsActions["A" /* trackGAEvent */])(false, 'swipeHide', 'userAction', 'ads'));
			this.setState({ adHidden: true });
		}
	}, {
		key: '_resetAdHidden',
		value: function _resetAdHidden() {
			if (this.state.adHidden === true && this.props.ads.adSlots[this.props.adName] === false) {
				this.props.dispatch(Object(adsActions["z" /* showAdSlot */])(this.props.adName));
			}
			this.setState({ adHidden: false });
		}
	}, {
		key: '_isPositionOk',
		value: function _isPositionOk() {
			var ad = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

			var positionOk = false;

			if (ad) {
				// Using IntersectionObserver
				positionOk = ad.isIntersecting && ad.intersectionRatio > 0;
			} else {
				// old method
				var rect = this.theAdElement ? this.theAdElement.getBoundingClientRect() : null,
				    viewport = window.innerHeight || document.documentElement.clientHeight;
				positionOk = rect && (rect.top >= 0 && rect.top - viewport / 3 <= viewport || rect.bottom <= 0 && rect.bottom + viewport / 3 >= 0);
			}

			// Bottom endContentRectangle will only load when the page is fully loaded
			if (parseInt(this.adType) === 2 && this.props.isFetching === true) {
				return false;
			}

			return positionOk;
		}
	}, {
		key: '_get_AdUnits',
		value: function _get_AdUnits() {
			var forumSite = this.props.topifyPresets.forumSite;

			if (forumSite.dfpTags) {
				return JSON.parse(forumSite.dfpTags);
			}
		}
	}, {
		key: '_find_adType',
		value: function _find_adType(units, i) {
			var ad_unit = void 0,
			    adType = parseInt(this.adTypes[i]);

			if (units.length > 0) {
				ad_unit = units.find(function (ad) {
					return parseInt(ad.at_id) === adType;
				});
			}

			if (ad_unit) {
				this.adType = parseInt(adType);
				ad_unit.fda_path = ad_unit.fda_path.trim();
			} else if (i < this.adTypes.length - 1) {
				return this._find_adType(units, i + 1);
			}

			return ad_unit;
		}
	}, {
		key: '_avoidReloadAdUnit',
		value: function _avoidReloadAdUnit() {
			return this.props.ads.adSlots[this.props.adName] === false || this.adType === 0 || // AFS
			this._noAdsPermissions() || this.state.adHidden;
		}
	}, {
		key: '_noRepetitiveRefreshAd',
		value: function _noRepetitiveRefreshAd() {
			return !this.props.ads.secondaryAds && this._isYieldmo() || // inCcontentTopicAd && Yieldmo
			this.adType === 4 || // Interstitial
			this.adType === 101 || // InContentHomePage
			this.adType === 105 && this.props.topifyPresets.forumSite.f_sharethrough || // ShareThrough
			this.adType === 505 && this.props.topifyPresets.forumSite.f_sharethrough || // 505: 'InContentTopicCampaign' - ShareThrough
			this.adType >= 50 && this.adType <= 59 // Insurance ads for portal page
			;
		}
	}, {
		key: '_addPrebidAdUnit',
		value: function _addPrebidAdUnit(ad) {
			// Skip if we are in search or it's don't need prebid
			if (ad === null || !ad.size || this._isPrebid() === false || this.adType === 0 || this._noAdsPermissions() || this.props.ads.secondaryAds || this.state.adHidden) {
				return;
			}

			var adName = this.props.adName,
			    prebid_slot_used_already = false,
			    unit = '',
			    size = new RegExp(ad.size[0] + 'x' + ad.size[1] + '_', 'ig');

			// already used
			for (var u_size in prebid_slot_used) {
				if (prebid_slot_used[u_size] === adName) {
					prebid_slot_used_already = true;
				}
			}

			if (prebid_slot_used_already) {
				return;
			}

			switch (this.adType) {
				// 1 'inContentLeaderboard'
				// 2 'endContentRectangle'
				// 3 'bottomFixedLeaderboard'
				// 5 'inContentTopicAd'
				// 101 'InContentHomePage'
				// 105 'inContentTopicAd_1'
				// 205: 'inContentTopicAd_2'
				// 305: 'inContentTopicAd_3'
				// 505: 'InContentTopicCampaign' - ShareThrough
				default:
					var u = prebid_adUnits_def.find(function (the_ad) {
						var unit = the_ad.code.match(size);
						return unit && typeof prebid_slot_used[the_ad.code] === 'undefined';
					});

					unit = u && u.code ? JSON.parse(JSON.stringify(u)) : {};
					break;
			}

			if (unit.code) {
				unit.Topifytype = unit.code + '';
				unit.code = adName;

				var currentAdUnits = pbjs.adUnits || [];

				if (currentAdUnits.findIndex(function (ad) {
					return ad.code === adName;
				}) < 0) {
					pbjs.que.push(function () {
						if (pbjs.addAdUnits) {
							pbjs.addAdUnits(unit);
						}
					});
					if (prebid_adUnits.findIndex(function (ad) {
						return ad.code === adName;
					}) < 0) {
						prebid_adUnits.push(unit);

						// Tracking which adUnits is being used
						prebid_slot_used[unit.Topifytype] = adName;
						topifyConsole.log('prebid_slot_used: ', prebid_slot_used);
					}
				}
			}
		}
	}, {
		key: '_getAFSAdUnit',
		value: function _getAFSAdUnit() {
			var forumSite = this.props.topifyPresets.forumSite;

			// AFS - page options base values
			var adUnit = {
				pageOptions: {
					pubId: forumSite.f_afs_publisherid,
					channel: forumSite.f_afs_channelid,
					query: '',
					hl: 'en',
					adtest:  true ? 'off' : 'on',
					adPage: 1,
					location: false,
					siteLinks: false
				},
				// AFS - adblock options base values
				adblock: {
					container: this.props.adName,
					detailedAttribution: false,
					// style
					width: document.getElementById('header').getBoundingClientRect().width - 20 + 'px',
					fontSizeAttribution: 8,
					fontSizeAnnotation: 8,
					fontSizeTitle: 10,
					fontSizeDescription: 9,
					fontSizeDomainLink: 11,
					colorBackground: '#CCCCCC',
					colorBorder: '#636363',
					colorAdSeparator: '#636363'
				}
			};

			// Other settings
			if (this.props.search.isTop === true) {
				delete adUnit.adblock.number;
				adUnit.adblock.maxTop = 1;
			} else {
				delete adUnit.adblock.maxTop;
				adUnit.adblock.number = 1;
			}

			return adUnit;
		}
	}, {
		key: '_getAdUnit',
		value: function _getAdUnit() {
			if (this.props.ads.secondaryAds) {
				switch (this.adType) {
					case 1: // 'inContentLeaderboard'
					case 2: // 'endContentRectangle'
					case 3:
						// 'bottomFixedLeaderboard'
						return react_default.a.createElement(ads_secondaryAdComponent, { key: this.props.adName, adName: this.props.adName, type: 'rubicon' });

					default:
						return null;
				}
			} else {
				switch (this.adType) {
					case 0:
						// 'AFS adsense for search'
						return react_default.a.createElement(afsAdComponent, { key: this.props.adName, adName: this.props.adName });

					case 1: // 'inContentLeaderboard'
					case 2: // 'endContentRectangle'
					case 3: // 'bottomFixedLeaderboard'
					case 5: // 'inContentTopicAd'
					case 4: // 'interstitialAd'
					case 101: // 'InContentHomePage'
					case 105: // 'inContentTopicAd_1' - ShareThrough
					case 205: // 'inContentTopicAd_2' - yieldmo Hyperscroll/Outstream
					case 305: // 'inContentTopicAd_3'
					case 505:
						// 'InContentTopicCampaign' - ShareThrough
						return react_default.a.createElement(inContentAdComponent, { key: this.props.adName, adName: this.props.adName });

					default:
						return null;
				}
			}
		}
	}, {
		key: '_getAdUnitClasses',
		value: function _getAdUnitClasses() {
			var className = 'ad-card ';

			className += this.props.ads.secondaryAds ? 'secondary-ad-container ' : '';

			switch (this.adType) {
				case 0:
					// AFS
					className += this.props.search.isTop === true ? 'search-top-ad ' : 'search-ad ';
					break;

				case 1:
					// 'inContentLeaderboard'
					className += 'in-content-leaderboard-ad ';
					break;

				case 2:
					//'endContentRectangle'
					className += 'bottom-ad ';
					break;

				case 3:
					//'bottomFixedLeaderboard'
					className += '';
					break;

				case 4:
					// 'interstitialAd'
					className += 'interstitial-ad ';
					break;

				case 5: // 'inContentTopicAd'
				case 105: // 'inContentTopicAd_1' - ShareThrough
				case 205: // 'inContentTopicAd_2' - yieldmo Hyperscroll/Outstream
				case 305: // 'inContentTopicAd_3'
				case 505:
					//'InContentTopicCampaign' - ShareThrough
					className += 'in-content-ad ';
					break;

				case 101:
					// 'InContentHomePage'
					className += 'homepage-in-content-ad ';
					break;

				default:
					className += '';
					break;
			}

			return className + (this.props.className ? this.props.className + ' ' : '') + (this._noAdsPermissions() === true || this.state.adHidden === true ? 'hidden ' : '');
		}
	}, {
		key: '_getAdSizes',
		value: function _getAdSizes() {
			switch (true) {
				case this._isYieldmo() && this.adType === 205:
					return [[320, 50], [320, 186]];

				case this._isYieldmo():
					return [[320, 186], [320, 50], [320, 150], 'fluid'];

				case this._isFluid():
					return [this.adUnit.size, 'fluid'];

				default:
					return this.adUnit.size;
			}
		}
	}, {
		key: '_isFluid',
		value: function _isFluid() {
			return this.adType === 2 || //'endContentRectangle'
			this.adType === 5 || // 'inContentTopicAd' - yieldmo
			this.adType === 101 || // 'InContentHomePage'
			this.adType === 105 || // 'inContentTopicAd_1' - ShareThrough
			this.adType === 505 || // 'InContentTopicCampaign' - ShareThrough
			this.adType >= 50 && this.adType <= 59 // Insurance ads for portal page
			;
		}
	}, {
		key: '_isYieldmo',
		value: function _isYieldmo() {
			return parseInt(this.props.topifyPresets.forumSite.f_yieldmo) === 1 && (this.adType === 5 || // 'inContentTopicAd' - yieldmo
			this.adType === 205 // 'inContentTopicAd2' - yieldmo Hyperscroll/Outstream
			);
		}
	}, {
		key: '_isPrebid',
		value: function _isPrebid() {
			return !!(typeof pbjs !== 'undefined' && pbjs) && !this._isYieldmo() && !(this.adType === 105 && this.props.topifyPresets.forumSite.f_sharethrough) // ShareThrough
			&& !(this.adType === 505 && this.props.topifyPresets.forumSite.f_sharethrough) // 'InContentTopicCampaign' - ShareThrough
			&& !(this.adType === 4 && this.props.ads.showInterstitial) // interstitial
			&& !(this.adType >= 50 && this.adType <= 59) // Insurance ads for portal page
			;
		}
	}, {
		key: '_isAlwaysShown',
		value: function _isAlwaysShown() {
			// We want some ads to be shown always and skip the in-viewport check
			return this.adType === 0 // AFS
			|| this.adType === 3 // bottomFixedLeaderboard
			|| this.adType === 4 && this.props.ads.showInterstitial // interstitial
			|| !this.props.ads.secondaryAds && this._isYieldmo() // inCcontentTopicAd && Yieldmo
			|| this.adType === 101 // InContentHomePage
			|| this.adType === 105 && this.props.topifyPresets.forumSite.f_sharethrough // ShareThrough
			|| this.adType === 505 && this.props.topifyPresets.forumSite.f_sharethrough // 'InContentTopicCampaign' - ShareThrough
			|| this.adType >= 50 && this.adType <= 59 // Insurance ads for portal page
			;
		}
	}, {
		key: '_doesItNeedDOM',
		value: function _doesItNeedDOM() {
			return !(this.adType >= 50 && this.adType <= 59) // portal ads
			;
		}
	}, {
		key: '_noAdsPermissions',
		value: function _noAdsPermissions() {
			var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;

			return props.ads.noAdsPermissions && !(this.adType >= 50 && this.adType <= 59) && // insurance portal ads
			this.adType !== 101 // InContentHomePage
			;
		}
	}, {
		key: '_swipeToHide',
		value: function _swipeToHide() {
			return this.adType === 3; // Fixed_Bottom_Leaderboard
		}
	}, {
		key: '_checkPerms',
		value: function _checkPerms() {
			var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;

			// Remove the adUnit
			if (props.ads.secondaryAds || this._noAdsPermissions(props) || this.state.adHidden) {
				this.removeAdUnit();
			}

			// Hide or Show ads depending on permissions
			if (this._noAdsPermissions(props) || this.state.adHidden) {
				if (props.ads.adSlots[props.adName] === true) {
					props.dispatch(Object(adsActions["o" /* hideAdSlot */])(props.adName));
				}
			} else if (props.ads.adSlots[props.adName] === false && this._isAlwaysShown()) {
				props.dispatch(Object(adsActions["z" /* showAdSlot */])(props.adName));
			}
		}
	}, {
		key: 'render',
		value: function render() {
			var _this8 = this;

			if (this._doesItNeedDOM() === false || this.adUnit === null || typeof this.adUnit.index === 'undefined' && typeof this.adUnit.adblock === 'undefined') {
				return null;
			}

			var adUnit = this._getAdUnit(),
			    className = this._getAdUnitClasses();

			if (adUnit === null) {
				return null;
			}

			var content = null,
			    styles = {};

			if (typeof this.props.ads.adSlots[this.props.adName] === 'undefined' || this.props.ads.adSlots[this.props.adName] !== true) {
				content = react_default.a.createElement('div', { id: this.props.adName + '_container', className: className, ref: function ref(ad) {
						return _this8.theAdElement = ad;
					}, style: styles });
			} else {
				content = react_default.a.createElement(
					'div',
					{ id: this.props.adName + '_container', className: className, ref: function ref(ad) {
							return _this8.theAdElement = ad;
						}, style: styles },
					adUnit
				);
			}

			// If we have a wrapper tag
			if (this.props.tag) {
				var CustomTag = '' + this.props.tag;
				return react_default.a.createElement(
					CustomTag,
					null,
					content
				);
			} else {
				return content;
			}
		}
	}]);

	return AdComponent;
}(react_default.a.Component);

var AdComponent__initialiseProps = function _initialiseProps() {
	var _this9 = this;

	this.overlayElementsChanged = function (nextProps) {
		return !isEqual_default()(nextProps.overlayElements, _this9.props.overlayElements);
	};

	this.overlayElementsOpen = function () {
		var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this9.props;

		// do we have anything open?
		return Object.values(props.overlayElements).some(function (v) {
			return v;
		});
	};

	this.handleScroll = throttle_default()(function () {
		return _this9._checkAdVisibility();
	}, 200);

	this._checkAdVisibility = function (entries) {
		// We are in a noAds subforum
		if (_this9._noAdsPermissions() || _this9.state.adHidden) {
			return;
		}

		var entry = _this9.visibilityObserver && entries.length ? entries[0] : null;

		if (_this9._isAlwaysShown() || _this9._isPositionOk(entry)) {
			if (_this9.props.ads.adSlots[_this9.props.adName] !== true) {
				_this9.props.dispatch(Object(adsActions["z" /* showAdSlot */])(_this9.props.adName));
			}
		} else {
			if (_this9.props.ads.adSlots[_this9.props.adName] === true) {
				_this9.props.dispatch(Object(adsActions["o" /* hideAdSlot */])(_this9.props.adName));
				_this9.lastRefreshTime = null;
			}
		}
	};

	this._parseAd = function (ad_unit) {
		var re = /(?:\/(\d+)\/)?(?:([_a-zA-Z0-9]+)_)?((?:\d+x\d+)|(?:fluid))(?:_([_a-zA-Z0-9]+))?/ig;

		var _adPath = re.exec(ad_unit.fda_path) || [];
		_adPath['path'] = ad_unit.fda_path;

		// Formatting sizes
		if (_adPath[3]) {
			var size = _adPath[3].split('x');
			if (parseInt(size[0]) && parseInt(size[1]) || size[0] === 'fluid') {
				_adPath['size'] = size[0] === 'fluid' ? [size[0]] : [parseInt(size[0]), parseInt(size[1])];
			}
		} else {
			// Default sizes
			switch (parseInt(ad_unit.at_id)) {
				case 1:
					// 'inContentLeaderboard'
					_adPath['size'] = [320, 50];
					break;
				case 2:
					//'endContentRectangle'
					_adPath['size'] = [300, 250];
					break;
				case 3:
					// 'bottomFixedLeaderboard'
					_adPath['size'] = [320, 50];
					break;
				case 4: // 'interstitial'
				case 101: // 'InContentHomePage'
				case 505:
					// 'InContentTopicCampaign' - ShareThrough
					_adPath['size'] = [1, 1];
					break;
				case 5: // 'inContentTopicAd'
				case 105: // 'inContentTopicAd_1'
				case 205: // 'inContentTopicAd_2' - yieldmo Hyperscroll/Outstream
				case 305:
					// 'inContentTopicAd_3'
					_adPath['size'] = [320, 150];
					break;
			}
		}

		return _adPath;
	};
};

/* harmony default export */ var ads_AdComponent = (Object(es["b" /* connect */])(adSelector)(AdComponent_AdComponent));
// EXTERNAL MODULE: ./src/actions/InfiniteScrollActions.js
var InfiniteScrollActions = __webpack_require__(16);

// EXTERNAL MODULE: ./src/actions/ThreadviewActions.js
var ThreadviewActions = __webpack_require__(40);

// CONCATENATED MODULE: ./src/components/forums/ForumListComponent.js
var ForumListComponent__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function ForumListComponent__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function ForumListComponent__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function ForumListComponent__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }


















var ForumListComponent_ForumListComponent = function (_React$Component) {
	ForumListComponent__inherits(ForumListComponent, _React$Component);

	function ForumListComponent() {
		var _ref;

		var _temp, _this, _ret;

		ForumListComponent__classCallCheck(this, ForumListComponent);

		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		return _ret = (_temp = (_this = ForumListComponent__possibleConstructorReturn(this, (_ref = ForumListComponent.__proto__ || Object.getPrototypeOf(ForumListComponent)).call.apply(_ref, [this].concat(args))), _this), _this.gotoForum = function (id) {
			_this.props.dispatch(Object(InfiniteScrollActions["f" /* resetInfinite */])());
			_this.props.dispatch(Object(ForumviewActions["f" /* resetForum */])());
			_this.props.dispatch(Object(ThreadviewActions["h" /* resetThread */])());

			_this.props.dispatch(Object(react_router_redux_lib["push"])(Object(NavHelpers["c" /* pathToForum */])(id)));
		}, _this.buildForum = function (forum) {
			var forumId = _this.props.forumview.forumId,
			    ustate = _this.props.ustate;

			//		let isFirst = ( i === 0 && pageNum === 1 ); // Let's assume we want the first ad on the first page

			if (forum.id !== forumId) {
				if (forum.link) {
					return react_default.a.createElement(
						'li',
						{ key: forum.id },
						react_default.a.createElement(forums_ForumLinkComponent, { forum: forum })
					);
				} else {
					return react_default.a.createElement(
						'li',
						{ key: forum.id, onClick: function onClick() {
								return _this.gotoForum(forum.id);
							} },
						react_default.a.createElement(forums_ForumComponent, { forum: forum, ustate: ustate, dispatch: _this.props.dispatch })
					);
				}
			}
		}, _this.buildPage = function (pageNum) {
			var _this$props$forumview = _this.props.forumview,
			    entities = _this$props$forumview.entities,
			    result = _this$props$forumview.result;


			var forums = result.forums.filter(function (e) {
				return entities.forums[e] && entities.forums[e].page === pageNum;
			}),
			    forumsList = forums.map(function (id, i) {
				return _this.buildForum(entities.forums[id]);
			});

			return react_default.a.createElement(
				'ul',
				{ key: pageNum, className: 'scroll_page page_' + pageNum },
				forumsList
			);
		}, _temp), ForumListComponent__possibleConstructorReturn(_this, _ret);
	}

	ForumListComponent__createClass(ForumListComponent, [{
		key: 'render',
		value: function render() {
			var _this2 = this;

			var _props$forumview = this.props.forumview,
			    forums = _props$forumview.entities.forums,
			    result = _props$forumview.result,
			    forumId = _props$forumview.forumId;

			var forumListPage = null;
			var adUnitIncontent = typeof this.props.adUnitIncontent !== 'undefined' && this.props.adUnitIncontent;

			if (this.props.isScrolled) {
				// if we use infiniteSroll build pages
				forumListPage = this.props.pages.map(function (pageNum) {
					return _this2.buildPage(pageNum);
				});
			} else {
				var listForums = this.props.forumList || result.forums,
				    isThePlaceForTheAd = listForums.length > 2 ? 1 : 0,
				    // for > 2 subforums: after the second, otherwise after first
				forumList = listForums.map(function (k, i) {
					var the_forum = void 0,
					    forum = forums[k];

					if (forum.id !== forumId) {
						if (forum.link) {
							the_forum = [react_default.a.createElement(
								'li',
								{ key: i },
								react_default.a.createElement(forums_ForumLinkComponent, { forum: forum })
							)];
						} else {
							the_forum = [react_default.a.createElement(
								'li',
								{ key: i, onClick: function onClick() {
										return _this2.gotoForum(forum.id);
									} },
								react_default.a.createElement(forums_ForumComponent, { forum: forum, ustate: _this2.props.ustate, dispatch: _this2.props.dispatch })
							)];
						}
					}

					// if we are in the place where the ad needs to be, place it
					var adUnit = adUnitIncontent && i === isThePlaceForTheAd ? react_default.a.createElement(ads_AdComponent, { key: 'HomePage_In_Content_Ad_' + forum.id, adType: '101', adName: 'HomePage_In_Content_Ad_' + forum.id, tag: 'li' }) : '';

					if (adUnit) {
						the_forum.push(adUnit);
					}

					return the_forum;
				});

				forumListPage = react_default.a.createElement(
					'ul',
					null,
					forumList
				);
			}

			return react_default.a.createElement(
				'div',
				{ ref: this.props.listRef, className: 'forums nolinks' },
				forumListPage
			);
		}
	}]);

	return ForumListComponent;
}(react_default.a.Component);

ForumListComponent_ForumListComponent.propTypes = {
	dispatch: prop_types_default.a.func.isRequired
};

/* harmony default export */ var forums_ForumListComponent = (Object(es["b" /* connect */])(forumViewSelector)(ForumListComponent_ForumListComponent));
// CONCATENATED MODULE: ./src/components/ForumsIndexViewComponent.js
var ForumsIndexViewComponent__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function ForumsIndexViewComponent__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function ForumsIndexViewComponent__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function ForumsIndexViewComponent__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
















var ForumsIndexViewComponent_ForumsIndexViewComponent = function (_React$Component) {
	ForumsIndexViewComponent__inherits(ForumsIndexViewComponent, _React$Component);

	function ForumsIndexViewComponent() {
		var _ref;

		var _temp, _this, _ret;

		ForumsIndexViewComponent__classCallCheck(this, ForumsIndexViewComponent);

		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		return _ret = (_temp = (_this = ForumsIndexViewComponent__possibleConstructorReturn(this, (_ref = ForumsIndexViewComponent.__proto__ || Object.getPrototypeOf(ForumsIndexViewComponent)).call.apply(_ref, [this].concat(args))), _this), _this.groupForums = function () {
			var _this$props$forumview = _this.props.forumview,
			    forums = _this$props$forumview.entities.forums,
			    result = _this$props$forumview.result;

			var structure = {};
			var displayOrder = [];

			result.forums.forEach(function (v) {
				var forum = forums[v];
				if (parseInt(forum.parent) !== -1) {
					if (!structure[forum.parent]) {
						structure[forum.parent] = [];
					}
					structure[forum.parent].push(forum.id);
				} else {
					displayOrder.push(v);
				}
			});

			return displayOrder.filter(function (t) {
				return structure[t] !== undefined;
			}) // API sends missing data sometimes.
			.map(function (v, i) {
				var adUnit = i === 1 ? react_default.a.createElement(ads_AdComponent, { adType: '5', fallbackAdType: [1], adName: 'In_Content_Ad' }) : null,
				    adUnitIncontent = i === 0; // first category

				var forumGroup = [react_default.a.createElement(
					'div',
					{ key: 'forumgroup' + i },
					react_default.a.createElement(
						'div',
						{ className: 'forumGroup nolinks' },
						RawToReact(forums[v].title)
					),
					react_default.a.createElement(forums_ForumListComponent, { forumList: structure[v], adUnitIncontent: adUnitIncontent })
				)];
				if (adUnit) {
					forumGroup.push(adUnit);
				}

				return forumGroup;
			});
		}, _temp), ForumsIndexViewComponent__possibleConstructorReturn(_this, _ret);
	}

	ForumsIndexViewComponent__createClass(ForumsIndexViewComponent, [{
		key: 'componentWillMount',
		value: function componentWillMount() {
			this.props.dispatch(Object(ForumviewActions["f" /* resetForum */])());
		}
	}, {
		key: 'componentDidMount',
		value: function componentDidMount() {
			// is this index the landing page per config?
			var thisIsIndex = {"version":"1.0.0","IndexRoute":"index","section":{"home":false}}.IndexRoute === 'index' && {"version":"1.0.0","IndexRoute":"index","section":{"home":false}}.section.home === false;

			if (thisIsIndex && this.props.firstLoad && (this.props.initialRoute || this.props.userSettings.landingPage !== 'index')) {
				return;
			}

			window.scrollTo(0, 0);
			this.props.dispatch(Object(ForumviewActions["e" /* fetchForum */])({
				id: -1,
				size: 10,
				page: 1,
				forceRefresh: true
			}));
		}
	}, {
		key: 'componentWillUnmount',
		value: function componentWillUnmount() {
			this.props.dispatch(Object(ForumviewActions["f" /* resetForum */])());
		}
	}, {
		key: 'componentWillReceiveProps',
		value: function componentWillReceiveProps(nextProps) {
			if (nextProps.forumview.forumId) {
				this.props.dispatch(Object(adsActions["l" /* checkAdsPermissions */])(-1));
				this.props.dispatch(Object(adsActions["w" /* resetHiddenAdsPerUser */])());
			}

			if (nextProps.forumview.loaded && nextProps.forumview.loaded !== this.props.forumview.loaded) {
				window.scrollTo(0, 0);

				// trigger ad updates
				this.props.dispatch(Object(adsActions["s" /* onPageView */])({ captify: "" }));
				// Record the Google Analytics pageview
				this.props.dispatch(Object(adsActions["B" /* trackPageView */])());
			}
		}
	}, {
		key: 'render',
		value: function render() {
			var forumSite = this.props.forumSite;

			var lists = this.props.forumview.loaded ? this.groupForums() : react_default.a.createElement(LoaderCssComponent, null);

			return react_default.a.createElement(
				'div',
				{ className: 'forumRoot' },
				react_default.a.createElement(
					'div',
					{ className: 'coverphoto' },
					react_default.a.createElement('img', { className: 'no-ad', src: forumSite.cover_photo })
				),
				react_default.a.createElement(
					'div',
					{ className: 'detail nolinks nooptimize norewrite' },
					react_default.a.createElement(
						'div',
						{ className: 'title' },
						forumSite.f_title
					),
					react_default.a.createElement(
						'div',
						{ className: 'url' },
						forumSite.f_url
					)
				),
				lists,
				react_default.a.createElement(ads_AdComponent, { adType: '2', adName: 'Bottom_Content_Rectangle', isFetching: this.props.forumview.isFetching })
			);
		}
	}]);

	return ForumsIndexViewComponent;
}(react_default.a.Component);

ForumsIndexViewComponent_ForumsIndexViewComponent.propTypes = {
	forumSite: prop_types_default.a.shape({
		cover_photo: prop_types_default.a.string.isRequired,
		f_title: prop_types_default.a.string.isRequired,
		f_url: prop_types_default.a.string.isRequired
	})
};

/* harmony default export */ var components_ForumsIndexViewComponent = (Object(es["b" /* connect */])(forumViewSelector)(ForumsIndexViewComponent_ForumsIndexViewComponent));
// EXTERNAL MODULE: ./src/styles/breadcrumb.scss
var breadcrumb = __webpack_require__(334);
var breadcrumb_default = /*#__PURE__*/__webpack_require__.n(breadcrumb);

// CONCATENATED MODULE: ./src/components/common/BreadcrumbComponent.js
var BreadcrumbComponent__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function BreadcrumbComponent__toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function BreadcrumbComponent__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function BreadcrumbComponent__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function BreadcrumbComponent__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



















var BreadcrumbComponent_BreadcrumbComponent = function (_React$Component) {
	BreadcrumbComponent__inherits(BreadcrumbComponent, _React$Component);

	function BreadcrumbComponent(props) {
		BreadcrumbComponent__classCallCheck(this, BreadcrumbComponent);

		var _this = BreadcrumbComponent__possibleConstructorReturn(this, (BreadcrumbComponent.__proto__ || Object.getPrototypeOf(BreadcrumbComponent)).call(this, props));

		_this.scrollToLastElement = function () {
			// get last element and container
			var lastItem = document.querySelectorAll('#breadCrumbBar li:last-of-type');

			if (_this.bcContainer && lastItem && lastItem.length > 0) {
				_this.scroll = parseInt(lastItem[0].getBoundingClientRect().left);

				_this.scrollTimer = requestAnimationFrame(function () {
					_this.scrollTo();
				});
			}
		};

		_this.gotoIndex = function () {
			_this.props.dispatch(Object(InfiniteScrollActions["f" /* resetInfinite */])());
			_this.props.dispatch(Object(ForumviewActions["f" /* resetForum */])());
			_this.props.dispatch(Object(react_router_redux_lib["push"])(Object(NavHelpers["d" /* pathToForumsIndex */])()));
			// Record the Google Analytics event.
			_this.props.dispatch(Object(adsActions["A" /* trackGAEvent */])(false, 'breadCrumb', 'uiAction', 'tap'));
		};

		_this.gotoForum = function (id) {
			_this.props.dispatch(Object(InfiniteScrollActions["f" /* resetInfinite */])());
			_this.props.dispatch(Object(ForumviewActions["f" /* resetForum */])());
			_this.props.dispatch(Object(react_router_redux_lib["push"])(Object(NavHelpers["c" /* pathToForum */])(id)));
			// Record the Google Analytics event.
			_this.props.dispatch(Object(adsActions["A" /* trackGAEvent */])(false, 'breadCrumb', 'uiAction', 'tap'));
		};

		_this.step = 15;
		_this.scroll = 0;
		_this.scrollTimer = null;
		_this.bcContainer = null;
		return _this;
	}

	BreadcrumbComponent__createClass(BreadcrumbComponent, [{
		key: 'componentDidMount',
		value: function componentDidMount() {
			this.scrollToLastElement();
		}
	}, {
		key: 'shouldComponentUpdate',
		value: function shouldComponentUpdate(nextProps) {
			// very rarely we'll update it
			return !isEqual_default()(nextProps.path, this.props.path);
		}
	}, {
		key: 'componentDidUpdate',
		value: function componentDidUpdate() {
			this.scrollToLastElement();
		}
	}, {
		key: 'componentWillUnmount',
		value: function componentWillUnmount() {
			cancelAnimationFrame(this.scrollTimer);
		}
	}, {
		key: 'scrollTo',
		value: function scrollTo() {
			var _this2 = this;

			if (this.scroll > 0) {
				this.scroll -= this.step;
				if (this.bcContainer) {
					this.bcContainer.scrollLeft += this.step;
				}
				this.scrollTimer = requestAnimationFrame(function () {
					_this2.scrollTo();
				});
			} else {
				this.scroll = 0;
			}
		}
	}, {
		key: 'render',
		value: function render() {
			var _this3 = this;

			var path = this.props.path;

			path = path ? path : []; // prevents error when path is empty

			var reversedPath = (this.props.routeParams.forumId && path.length > 0 && parseInt(this.props.routeParams.forumId) === parseInt(path[0].id) ? [].concat(BreadcrumbComponent__toConsumableArray(path)).splice(1) : [].concat(BreadcrumbComponent__toConsumableArray(path))).reverse(); // if we are in the subforum don't show it on the breadcrumb

			var pathComponents = reversedPath.map(function (p, i) {
				return react_default.a.createElement(
					'li',
					{ key: i, className: 'item' },
					react_default.a.createElement(
						'span',
						{ onClick: function onClick() {
								return _this3.gotoForum(p.id);
							} },
						RawToReact(p.title)
					)
				);
			});

			return react_default.a.createElement(
				'div',
				{ key: 'breadcrumb', id: 'breadCrumbBar', className: 'bcContainer nolinks', ref: function ref(bc) {
						return _this3.bcContainer = bc;
					} },
				react_default.a.createElement(
					'ul',
					null,
					react_default.a.createElement(
						'li',
						{ className: 'item' },
						react_default.a.createElement(
							'span',
							{ onClick: this.gotoIndex },
							'Index'
						)
					),
					pathComponents
				)
			);
		}
	}]);

	return BreadcrumbComponent;
}(react_default.a.Component);

BreadcrumbComponent_BreadcrumbComponent.displayName = 'BreadcrumbComponent';
BreadcrumbComponent_BreadcrumbComponent.defaultProps = {
	scrollOptions: {
		eventPassthrough: true,
		scrollX: true,
		scrollY: false,
		preventDefault: false
	}
};

BreadcrumbComponent_BreadcrumbComponent.propTypes = {
	dispatch: prop_types_default.a.func.isRequired,
	routeParams: prop_types_default.a.object.isRequired
};

/* harmony default export */ var common_BreadcrumbComponent = (Object(es["b" /* connect */])(selectors_metaSelector)(BreadcrumbComponent_BreadcrumbComponent));
// EXTERNAL MODULE: ./src/actions/UserSettingsActions.js
var UserSettingsActions = __webpack_require__(26);

// CONCATENATED MODULE: ./src/components/threads/ThreadListComponent.js
var ThreadListComponent__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function ThreadListComponent__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function ThreadListComponent__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function ThreadListComponent__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



















var ThreadListComponent_ThreadListComponent = function (_React$Component) {
	ThreadListComponent__inherits(ThreadListComponent, _React$Component);

	function ThreadListComponent(props) {
		ThreadListComponent__classCallCheck(this, ThreadListComponent);

		var _this = ThreadListComponent__possibleConstructorReturn(this, (ThreadListComponent.__proto__ || Object.getPrototypeOf(ThreadListComponent)).call(this, props));

		_this.gotoThread = function (id) {
			_this.props.dispatch(Object(InfiniteScrollActions["f" /* resetInfinite */])());
			_this.props.dispatch(Object(ForumviewActions["f" /* resetForum */])());
			_this.props.dispatch(Object(react_router_redux_lib["push"])(Object(NavHelpers["q" /* pathToThread */])(id)));
		};

		_this.buildTopic = function (topic, i, pageNum, pageSize) {
			var entities = _this.props.forumview.entities,
			    isSearch = _this.props.isSearch;


			var adUnit = '';
			if (isSearch) {
				var searchProp = {
					isTop: false,
					page: (_this.props.forumview.page - 1) * (pageSize / 10) + (i + 1) / 10,
					searchQuery: _this.props.forumview.query.searchQuery
				};
				adUnit = (i + 1) % 10 === 0 ? react_default.a.createElement(ads_AdComponent, { key: 'In_Search_Ad_' + topic.id, adType: '0', adName: 'In_Search_Ad_' + topic.id, search: searchProp, tag: 'li' }) : null;
			} else {
				adUnit = i % 4 === 0 && i !== 0 ? react_default.a.createElement(ads_AdComponent, { key: 'In_Content_Ad_' + topic.id, adType: '1', adName: 'In_Content_Ad_' + topic.id, tag: 'li' }) : null;
			}

			var thisUser = _this.props.showLast && topic.lastUserid && entities.users[topic.lastUserid] ? entities.users[topic.lastUserid] : entities.users[topic.forumUser];

			var the_topic = [react_default.a.createElement(
				'li',
				{ key: topic.id, onClick: function onClick() {
						return _this.gotoThread(topic.id);
					} },
				react_default.a.createElement(threads_ThreadComponent, {
					thread: topic,
					isSubscribable: true,
					isSearch: isSearch,
					user: thisUser,
					dispatch: _this.props.dispatch,
					ustate: _this.props.ustate,
					showLast: _this.props.showLast,
					selectedElements: _this.props.meta.selectedElements
				})
			)];

			if (adUnit) {
				the_topic.push(adUnit);
			}

			return the_topic;
		};

		_this.buildPage = function (pageNum, pageSize) {
			var _this$props$forumview = _this.props.forumview,
			    entities = _this$props$forumview.entities,
			    result = _this$props$forumview.result;


			var topics = result.topics.filter(function (e) {
				return entities.topics[e] && entities.topics[e].page === pageNum;
			}),
			    topicsList = topics.map(function (id, i) {
				return _this.buildTopic(entities.topics[id], i, pageNum, pageSize);
			});

			return react_default.a.createElement(
				'ul',
				{ key: pageNum, className: 'scroll_page page_' + pageNum },
				topicsList
			);
		};

		_this.pages = {};
		return _this;
	}

	ThreadListComponent__createClass(ThreadListComponent, [{
		key: 'shouldComponentUpdate',
		value: function shouldComponentUpdate(nextProps) {
			return !isEqual_default()(nextProps.meta.selectedElements, this.props.meta.selectedElements) || !isEqual_default()(nextProps.forumview, this.props.forumview) || !isEqual_default()(nextProps.pages, this.props.pages);
		}
	}, {
		key: 'threadListPage',
		value: function threadListPage() {
			var _this2 = this;

			var pageSize = this.props.dispatch(Object(UserSettingsActions["d" /* getPageSize */])());
			return this.props.pages.map(function (pageNum) {
				return _this2.buildPage(pageNum, pageSize);
			});
		}
	}, {
		key: 'summary',
		value: function summary() {
			var _props$forumview = this.props.forumview,
			    forums = _props$forumview.entities.forums,
			    forumId = _props$forumview.forumId,
			    total = _props$forumview.total;

			if (forums && forums.hasOwnProperty(forumId)) {
				return react_default.a.createElement(
					'div',
					{ className: 'summary' },
					total.toLocaleString(),
					' Topics'
				);
			}
			return '';
		}
	}, {
		key: 'render',
		value: function render() {
			var result = this.props.forumview.result;


			if (result.topics.length === 0) {
				return react_default.a.createElement('span', null);
			}

			return react_default.a.createElement(
				'div',
				{ ref: this.props.listRef, className: 'threads' },
				this.summary(),
				this.threadListPage()
			);
		}
	}]);

	return ThreadListComponent;
}(react_default.a.Component);

ThreadListComponent_ThreadListComponent.propTypes = {
	dispatch: prop_types_default.a.func.isRequired,
	pages: prop_types_default.a.array.isRequired
};

/* harmony default export */ var threads_ThreadListComponent = (Object(es["b" /* connect */])(forumViewSelector)(ThreadListComponent_ThreadListComponent));
// CONCATENATED MODULE: ./src/selectors/announcementsViewSelector.js


var announcementsViewSelector_forumviewSelector = function forumviewSelector(state) {
	return state.forumview.forumId ? state.forumview : state.searchresult;
};
var announcementsViewSelector_uiStateSelector = function uiStateSelector(state) {
	return state.ui;
};

/* harmony default export */ var announcementsViewSelector = (Object(lib["createSelector"])([announcementsViewSelector_forumviewSelector, announcementsViewSelector_uiStateSelector], function (forumview, ui) {
	return {
		forumview: forumview,
		announcementsOpen: ui.announcementsOpen
	};
}));
// CONCATENATED MODULE: ./src/components/threads/AnnouncementThreadListComponent.js
var AnnouncementThreadListComponent__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function AnnouncementThreadListComponent__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function AnnouncementThreadListComponent__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function AnnouncementThreadListComponent__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var AnnouncementThreadListComponent_AnnouncementThreadListComponent = function (_React$Component) {
	AnnouncementThreadListComponent__inherits(AnnouncementThreadListComponent, _React$Component);

	function AnnouncementThreadListComponent() {
		var _ref;

		var _temp, _this, _ret;

		AnnouncementThreadListComponent__classCallCheck(this, AnnouncementThreadListComponent);

		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		return _ret = (_temp = (_this = AnnouncementThreadListComponent__possibleConstructorReturn(this, (_ref = AnnouncementThreadListComponent.__proto__ || Object.getPrototypeOf(AnnouncementThreadListComponent)).call.apply(_ref, [this].concat(args))), _this), _this.expandMessage = function (event) {
			if (event.currentTarget.dataset.announcementid) {
				var aId = parseInt(event.currentTarget.dataset.announcementid),
				    collapsed = event.currentTarget.classList.contains('collapsed');

				// mark as read
				if (collapsed && _this.props.forumview.entities.announcements[aId].unread) {
					_this.props.dispatch(Object(ThreadviewActions["f" /* markAsRead */])(aId, 'announcement'));
				} else {
					window.scrollTo(0, 0);
				}

				event.currentTarget.classList.toggle('collapsed');

				// Record the Google Analytics event.
				_this.props.dispatch(Object(adsActions["A" /* trackGAEvent */])(false, collapsed ? 'expandAnnouncement' : 'collapseAnnouncement', 'uiAction', 'tap'));
			}
		}, _this.buildAnnouncement = function (key, topic, users) {
			return react_default.a.createElement(
				'li',
				{ key: 'announcements_' + key, className: 'announcement collapsed', 'data-announcementid': topic.id, onClick: _this.expandMessage },
				react_default.a.createElement(threads_ThreadComponent, {
					thread: topic,
					isSubscribable: false,
					expandedContent: topic.message,
					user: users[topic.forumUser],
					users: users,
					dispatch: _this.props.dispatch,
					ustate: _this.props.ustate
				})
			);
		}, _temp), AnnouncementThreadListComponent__possibleConstructorReturn(_this, _ret);
	}

	AnnouncementThreadListComponent__createClass(AnnouncementThreadListComponent, [{
		key: 'render',
		value: function render() {
			var _this2 = this;

			var _props$forumview = this.props.forumview,
			    _props$forumview$enti = _props$forumview.entities,
			    users = _props$forumview$enti.users,
			    announcements = _props$forumview$enti.announcements,
			    result = _props$forumview.result;


			if (result.announcements.length === 0) {
				return null;
			}

			var announcementList = result.announcements.map(function (k, i) {
				return _this2.buildAnnouncement(i, announcements[k], users);
			});

			return react_default.a.createElement(
				'div',
				{ id: 'announcements', className: 'threads announcement' },
				react_default.a.createElement(
					'div',
					{ className: 'list-summary' },
					'Announcements ( ',
					result.announcements.length,
					' Topic',
					result.announcements.length === 1 ? '' : 's',
					' )'
				),
				react_default.a.createElement(
					'ul',
					null,
					announcementList
				)
			);
		}
	}]);

	return AnnouncementThreadListComponent;
}(react_default.a.Component);

AnnouncementThreadListComponent_AnnouncementThreadListComponent.propTypes = {
	dispatch: prop_types_default.a.func.isRequired,
	forumview: prop_types_default.a.object.isRequired,
	ustate: prop_types_default.a.object.isRequired
};

/* harmony default export */ var threads_AnnouncementThreadListComponent = (Object(es["b" /* connect */])(forumViewSelector)(AnnouncementThreadListComponent_AnnouncementThreadListComponent));
// CONCATENATED MODULE: ./src/components/threads/StickyThreadListComponent.js
var StickyThreadListComponent__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function StickyThreadListComponent__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function StickyThreadListComponent__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function StickyThreadListComponent__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var StickyThreadListComponent_StickyThreadListComponent = function (_React$Component) {
	StickyThreadListComponent__inherits(StickyThreadListComponent, _React$Component);

	function StickyThreadListComponent() {
		var _ref;

		var _temp, _this, _ret;

		StickyThreadListComponent__classCallCheck(this, StickyThreadListComponent);

		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		return _ret = (_temp = (_this = StickyThreadListComponent__possibleConstructorReturn(this, (_ref = StickyThreadListComponent.__proto__ || Object.getPrototypeOf(StickyThreadListComponent)).call.apply(_ref, [this].concat(args))), _this), _this.gotoThread = function (id) {
			_this.props.dispatch(Object(react_router_redux_lib["push"])(Object(NavHelpers["q" /* pathToThread */])(id)));
		}, _this.buildTopic = function (key, topic, users) {
			return react_default.a.createElement(
				'li',
				{ key: 'sticky_' + key, onClick: function onClick() {
						return _this.gotoThread(topic.id);
					} },
				react_default.a.createElement(threads_ThreadComponent, {
					thread: topic,
					isSubscribable: true,
					user: users[topic.forumUser],
					users: users,
					dispatch: _this.props.dispatch,
					ustate: _this.props.ustate,
					selectedElements: _this.props.meta.selectedElements
				})
			);
		}, _temp), StickyThreadListComponent__possibleConstructorReturn(_this, _ret);
	}

	StickyThreadListComponent__createClass(StickyThreadListComponent, [{
		key: 'render',
		value: function render() {
			var _this2 = this;

			var _props$forumview = this.props.forumview,
			    _props$forumview$enti = _props$forumview.entities,
			    users = _props$forumview$enti.users,
			    sticky = _props$forumview$enti.sticky,
			    result = _props$forumview.result;


			if (result.sticky.length === 0) {
				return null;
			}

			var stickyList = result.sticky.map(function (k, i) {
				return _this2.buildTopic(i, sticky[k], users);
			});

			return react_default.a.createElement(
				'div',
				{ className: 'threads sticky' },
				react_default.a.createElement(
					'div',
					{ className: 'list-summary' },
					'Sticky Topics ( ',
					result.sticky.length,
					' Topic',
					result.sticky.length === 1 ? '' : 's',
					' )'
				),
				react_default.a.createElement(
					'ul',
					null,
					stickyList
				)
			);
		}
	}]);

	return StickyThreadListComponent;
}(react_default.a.Component);

/* harmony default export */ var threads_StickyThreadListComponent = (Object(es["b" /* connect */])(forumViewSelector)(StickyThreadListComponent_StickyThreadListComponent));
// CONCATENATED MODULE: ./src/components/forums/AnnouncementsViewComponent.js
var AnnouncementsViewComponent__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function AnnouncementsViewComponent__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function AnnouncementsViewComponent__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function AnnouncementsViewComponent__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }














var AnnouncementsViewComponent_AnnouncementsViewComponent = function (_React$Component) {
	AnnouncementsViewComponent__inherits(AnnouncementsViewComponent, _React$Component);

	function AnnouncementsViewComponent(props) {
		AnnouncementsViewComponent__classCallCheck(this, AnnouncementsViewComponent);

		var _this = AnnouncementsViewComponent__possibleConstructorReturn(this, (AnnouncementsViewComponent.__proto__ || Object.getPrototypeOf(AnnouncementsViewComponent)).call(this, props));

		_this.announcementsView = function (e) {
			var type = e.currentTarget.dataset.type,
			    actionStats = type + 'Topics';

			if (_this.props.announcementsOpen && _this.state[type]) {
				_this.setState(_defineProperty({}, type, false));
				_this.props.dispatch(Object(UiActions["z" /* closeAnnouncements */])());

				// Record the Google Analytics event.
				_this.props.dispatch(Object(adsActions["A" /* trackGAEvent */])(false, 'hide' + actionStats, 'uiAction', 'tap'));
			} else if (_this.annContainer[type]) {
				_this._fixHeightByBottomFixAdPosition(type);
				_this.setState(_defineProperty({}, type, true));
				_this.props.dispatch(Object(UiActions["K" /* openAnnouncements */])());

				// Record the Google Analytics event.
				_this.props.dispatch(Object(adsActions["A" /* trackGAEvent */])(false, 'show' + actionStats, 'uiAction', 'tap'));
			}
		};

		_this.state = {
			sticky: false,
			announcement: false
		};

		_this.annContainer = {};
		_this.stickiesAlone = false;
		return _this;
	}

	AnnouncementsViewComponent__createClass(AnnouncementsViewComponent, [{
		key: 'componentWillMount',
		value: function componentWillMount() {
			// We need to check if we only have stickies in the page
			if ((this.props.forumview.entities.forums === undefined || Object.keys(this.props.forumview.entities.forums).length <= 1) && (this.props.forumview.entities.topics === undefined || Object.keys(this.props.forumview.entities.topics).length === 0)) {
				this.stickiesAlone = true;
			}
		}
	}, {
		key: 'componentDidMount',
		value: function componentDidMount() {
			this.props.dispatch(Object(UiActions["z" /* closeAnnouncements */])());
			this.bottomFloatingAd = document.getElementById('Fixed_Bottom_Leaderboard_container');
		}
	}, {
		key: 'componentWillUnmount',
		value: function componentWillUnmount() {
			this.props.dispatch(Object(UiActions["z" /* closeAnnouncements */])());
		}
	}, {
		key: 'shouldComponentUpdate',
		value: function shouldComponentUpdate(nextProps) {
			return nextProps.forumview.loaded !== this.props.forumview.loaded || nextProps.forumview.isFetching !== this.props.forumview.isFetching || nextProps.forumview.forumId !== this.props.forumview.forumId || nextProps.announcementsOpen !== this.props.announcementsOpen;
		}
	}, {
		key: 'componentWillReceiveProps',
		value: function componentWillReceiveProps(nextProps) {
			if (nextProps.forumview.forumId !== this.props.forumview.forumId) {
				this.props.dispatch(Object(UiActions["z" /* closeAnnouncements */])());
			}
		}
	}, {
		key: '_fixHeightByBottomFixAdPosition',
		value: function _fixHeightByBottomFixAdPosition(type) {
			var bottomFloatingAd = this.bottomFloatingAd || document.getElementById('Fixed_Bottom_Leaderboard_container');
			if (bottomFloatingAd) {
				try {
					this.annContainer[type].style.bottom = bottomFloatingAd.getBoundingClientRect().height + 'px';
				} catch (e) {/* ignore */
				}
			}
		}
	}, {
		key: 'buildPage',
		value: function buildPage(type) {
			var _this2 = this;

			var result = this.props.forumview.result;


			var elementsLength = 0,
			    elementsList = null,
			    iconName = 'error_outline';

			switch (type) {
				case 'sticky':
					iconName = 'pin';
					elementsLength = result.sticky.length;
					elementsList = react_default.a.createElement(threads_StickyThreadListComponent, { key: 'stickiesList' });
					break;

				case 'announcement':
					iconName = 'announcement';
					elementsLength = result.announcements.length;
					elementsList = react_default.a.createElement(threads_AnnouncementThreadListComponent, { key: 'announcementsList' });
					break;
			}

			var areAnnouncementsOpen = this.state[type] && elementsLength > 0 && this.props.announcementsOpen ? ' open' : '',
			    announcementsIcon = elementsLength > 0 ? react_default.a.createElement(
				'div',
				{ className: 'announcements-icon ' + type + (this.state[type] ? ' open' : ''), 'data-type': type, onClick: this.announcementsView },
				react_default.a.createElement(svg_SvgIcon, { icon: this.props.announcementsOpen ? 'clear' : iconName, size: '16px' })
			) : null;

			// if we have no topics and no sub-forums show stickies as regular threads
			return type === 'sticky' && this.stickiesAlone ? elementsList : react_default.a.createElement(
				'div',
				{ key: type },
				announcementsIcon,
				react_default.a.createElement(
					'section',
					{ className: 'thread pivotal announcements' + areAnnouncementsOpen, ref: function ref(h) {
							return _this2.annContainer[type] = h;
						} },
					elementsList
				)
			);
		}
	}, {
		key: 'buildElements',
		value: function buildElements() {
			var elements = [],
			    announcements = [],
			    stickies = null;

			// get announcements if we have any
			announcements.push(this.buildPage('announcement'));

			// if we have stickies alone not include them in the container
			if (this.stickiesAlone) {
				stickies = this.buildPage('sticky');
			} else {
				announcements.push(this.buildPage('sticky'));
			}

			var floatingEl = announcements.length ? react_default.a.createElement(
				'div',
				{ key: 'container' },
				announcements
			) : null;

			elements.push(floatingEl);
			elements.push(stickies);

			return elements;
		}
	}, {
		key: 'render',
		value: function render() {
			var loaded = this.props.forumview.loaded;

			var anyOpen = this.props.announcementsOpen ? ' open' : '';

			if (!loaded) {
				return null;
			}

			return react_default.a.createElement(
				'section',
				{ className: 'announcements-container' + anyOpen },
				this.buildElements()
			);
		}
	}]);

	return AnnouncementsViewComponent;
}(react_default.a.Component);

/* harmony default export */ var forums_AnnouncementsViewComponent = (Object(es["b" /* connect */])(announcementsViewSelector)(AnnouncementsViewComponent_AnnouncementsViewComponent));
// EXTERNAL MODULE: ./src/styles/infinitescroller.scss
var infinitescroller = __webpack_require__(762);
var infinitescroller_default = /*#__PURE__*/__webpack_require__.n(infinitescroller);

// EXTERNAL MODULE: ./src/styles/pageselector.scss
var pageselector = __webpack_require__(763);
var pageselector_default = /*#__PURE__*/__webpack_require__.n(pageselector);

// EXTERNAL MODULE: ./src/utils/deviceType.js
var deviceType = __webpack_require__(149);

// CONCATENATED MODULE: ./src/components/infiniteScroll/PageSelectorComponent.js
var PageSelectorComponent__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function PageSelectorComponent__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function PageSelectorComponent__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function PageSelectorComponent__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }












var PageSelectorComponent_PageSelectorComponent = function (_React$Component) {
	PageSelectorComponent__inherits(PageSelectorComponent, _React$Component);

	function PageSelectorComponent(props) {
		PageSelectorComponent__classCallCheck(this, PageSelectorComponent);

		var _this = PageSelectorComponent__possibleConstructorReturn(this, (PageSelectorComponent.__proto__ || Object.getPrototypeOf(PageSelectorComponent)).call(this, props));

		_this.toggleBody = function () {
			_this.setState({
				isOpen: !_this.state.isOpen
			});
		};

		_this.onPageInputChange = function (e) {
			var newPage = parseInt(e.target.value);

			_this.setState({
				jumpPage: isNaN(newPage) ? null : newPage
			});
		};

		_this.onFirstButtonClick = function () {
			_this.setState({
				isOpen: false
			});

			if (_this.props.onFirstButtonClick) {
				// Record the Google Analytics event.
				_this.props.dispatch(Object(adsActions["A" /* trackGAEvent */])(false, 'firstPage', 'uiAction', 'pageSelector'));
				_this.props.onFirstButtonClick();
			}
		};

		_this.onLastButtonClick = function () {
			_this.setState({
				isOpen: false
			});

			if (_this.props.onLastButtonClick) {
				// Record the Google Analytics event.
				_this.props.dispatch(Object(adsActions["A" /* trackGAEvent */])(false, 'lastPage', 'uiAction', 'pageSelector'));
				_this.props.onLastButtonClick();
			}
		};

		_this.onJumpPage = function (e) {
			e.preventDefault();

			// Validate input
			var newPage = _this.state.jumpPage;

			if (isNaN(newPage)) {
				newPage = _this.props.currentPage;
			}

			if (newPage < 1) {
				newPage = 1;
			}

			if (newPage > _this.props.totalPages) {
				newPage = _this.props.totalPages;
			}

			_this.setState({
				isOpen: false,
				jumpPage: newPage
			});

			if (_this.props.onJumpPage) {
				// Record the Google Analytics event.
				_this.props.dispatch(Object(adsActions["A" /* trackGAEvent */])(false, 'jumpPage', 'uiAction', 'pageSelector'));

				_this.props.dispatch(Object(UiActions["A" /* closeIOSKeyboard */])());
				_this.props.onJumpPage(newPage);
			}
		};

		_this.focusInput = function () {
			var deviceInfo = Object(deviceType["b" /* deviceType */])();

			// iOS breaks things when the keyboard opens
			if (deviceInfo.any && deviceInfo.os.platform.ios !== false && _this.deviceInfo.browser.engine === 'Safari') {
				_this.props.dispatch(Object(UiActions["L" /* openIOSKeyboard */])());
			}
		};

		_this.blurInput = function () {
			// we need to delay this action because iOS won't trigger the submit action
			setTimeout(function () {
				return _this.props.dispatch(Object(UiActions["A" /* closeIOSKeyboard */])());
			}, 150);
		};

		_this.state = {
			isOpen: false,
			jumpPage: props.currentPage
		};
		return _this;
	}

	PageSelectorComponent__createClass(PageSelectorComponent, [{
		key: 'shouldComponentUpdate',
		value: function shouldComponentUpdate(nextProps, nextState) {
			return nextProps.bottomAdPos !== this.props.bottomAdPos || nextProps.currentPage !== this.props.currentPage || nextProps.totalPages !== this.props.totalPages || nextProps.bottomPosition !== this.props.bottomPosition || nextState.isOpen !== this.state.isOpen || nextState.jumpPage !== this.state.jumpPage;
		}
	}, {
		key: 'componentWillReceiveProps',
		value: function componentWillReceiveProps(nextProps) {
			this.setState({
				jumpPage: nextProps.currentPage
			});
		}
	}, {
		key: 'render',
		value: function render() {
			var _props = this.props,
			    currentPage = _props.currentPage,
			    totalPages = _props.totalPages,
			    bottomPosition = _props.bottomPosition;
			var _state = this.state,
			    isOpen = _state.isOpen,
			    jumpPage = _state.jumpPage;


			if (isNaN(totalPages) || totalPages <= 1) {
				return react_default.a.createElement('span', null);
			}

			return react_default.a.createElement(
				'div',
				{ className: 'page-selector', style: { bottom: bottomPosition + 'px' } },
				react_default.a.createElement(
					'div',
					{ className: 'page-selector-header', onClick: this.toggleBody },
					react_default.a.createElement(
						'span',
						null,
						currentPage,
						' / ',
						totalPages
					),
					react_default.a.createElement(
						'span',
						{ className: 'toggle-icon' },
						react_default.a.createElement(svg_SvgIcon, { size: '18px', icon: isOpen ? "angle_down" : "angle_up" })
					)
				),
				react_default.a.createElement(
					'div',
					{ className: "page-selector-body" + (isOpen ? "" : " hidden") },
					react_default.a.createElement(
						'div',
						null,
						react_default.a.createElement(
							'button',
							{ className: "full-width" + (currentPage === 1 ? ' disabled' : ''), onClick: this.onFirstButtonClick },
							react_default.a.createElement(svg_SvgIcon, { size: '1.5em', icon: 'first_page' }),
							' First page'
						)
					),
					react_default.a.createElement(
						'div',
						{ className: parseInt(totalPages) <= 2 ? 'hidden' : '' },
						react_default.a.createElement('input', { className: 'page-input', type: 'number', value: jumpPage || '',
							onChange: this.onPageInputChange,
							onFocus: this.focusInput,
							onBlur: this.blurInput
						}),
						react_default.a.createElement(
							'button',
							{ className: 'jump-button', onClick: this.onJumpPage },
							'Jump'
						)
					),
					react_default.a.createElement(
						'div',
						null,
						react_default.a.createElement(
							'button',
							{ className: "full-width" + (currentPage === totalPages ? ' disabled' : ''), onClick: this.onLastButtonClick },
							'Last page ',
							react_default.a.createElement(svg_SvgIcon, { size: '1.5em', icon: 'last_page' })
						)
					)
				)
			);
		}
	}]);

	return PageSelectorComponent;
}(react_default.a.Component);

PageSelectorComponent_PageSelectorComponent.propTypes = {
	currentPage: prop_types_default.a.number.isRequired,
	totalPages: prop_types_default.a.number.isRequired,
	onFirstButtonClick: prop_types_default.a.func,
	onLastButtonClick: prop_types_default.a.func,
	onJumpPage: prop_types_default.a.func
};

var PageSelectorComponent_mapStateToProps = function mapStateToProps(state) {
	return {
		bottomAdPos: state.ads.adSlots && state.ads.adSlots.Fixed_Bottom_Leaderboard
	};
};

/* harmony default export */ var infiniteScroll_PageSelectorComponent = (Object(es["b" /* connect */])(PageSelectorComponent_mapStateToProps)(PageSelectorComponent_PageSelectorComponent));
// CONCATENATED MODULE: ./src/selectors/infiniteScrollSelector.js
var infiniteScrollSelector__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



var infiniteScrollSelector = function infiniteScrollSelector(state) {
	return state.infiniteScroll;
};
var adsSelector = function adsSelector(state) {
	return state.ads;
};
var uiSelector = function uiSelector(state) {
	return state.ui;
};

/* harmony default export */ var selectors_infiniteScrollSelector = (Object(lib["createSelector"])([infiniteScrollSelector, adsSelector, uiSelector], function (infiniteScroll, ads, ui) {
	return infiniteScrollSelector__extends({}, infiniteScroll, {
		adSlots: ads.adSlots,
		iOSkeyBoardOpen: ui.iOSkeyBoardOpen,
		announcementsOpen: ui.announcementsOpen,
		shareModalOpened: ui.shareModal.opened,
		headerOverflowOpened: ui.headerOverflowOpened,
		sidebarOpened: ui.sidebarOpened,
		searchBarOpened: ui.searchBarOpened,
		userModalOpened: ui.userModal.opened
	});
}));
// CONCATENATED MODULE: ./src/components/infiniteScroll/InfiniteScrollComponent.js
var InfiniteScrollComponent__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function InfiniteScrollComponent__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function InfiniteScrollComponent__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function InfiniteScrollComponent__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

















var InfiniteScrollComponent_InfiniteScrollComponent = function (_React$Component) {
	InfiniteScrollComponent__inherits(InfiniteScrollComponent, _React$Component);

	function InfiniteScrollComponent(props) {
		InfiniteScrollComponent__classCallCheck(this, InfiniteScrollComponent);

		var _this = InfiniteScrollComponent__possibleConstructorReturn(this, (InfiniteScrollComponent.__proto__ || Object.getPrototypeOf(InfiniteScrollComponent)).call(this, props));

		_this._overflowItemsOpen = function () {
			return _this.props.iOSkeyBoardOpen || _this.props.announcementsOpen || _this.props.shareModalOpened || _this.props.headerOverflowOpened || _this.props.sidebarOpened || _this.props.userModalOpened || _this.props.searchBarOpened;
		};

		_this.loadPage = function (page) {
			var forceRefresh = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

			page = parseInt(page);
			if (page === _this.props.page) {
				return null;
			}

			// Stop listening for scroll
			_this.suppressScrollListener = true;

			// If the page we want is already in screen, just scroll to it
			var gotoPageDim = _this._getPageDimensions(page);
			if (gotoPageDim.height) {
				// If we have breadCrumb bar we want to scroll bellow it
				var topPageHeight = _this.props.extraHeaderHeight + _this.headerHeight + _this.breadCrumbHeight,
				    scroll_y = window.scrollY + gotoPageDim.top - topPageHeight;

				// Scroll to the top of the page we want to go to
				window.scrollTo(0, scroll_y);

				// Update the page number
				_this.updatePageNumber(page);

				// Done
				return true;
			}

			if (page < _this.props.page - InfiniteScrollActions["a" /* FRAME_SIZE */] + 1 || page > _this.props.page + InfiniteScrollActions["a" /* FRAME_SIZE */] - 1) {
				if (page < _this.props.page - InfiniteScrollActions["a" /* FRAME_SIZE */] || page > _this.props.page + InfiniteScrollActions["a" /* FRAME_SIZE */]) {
					forceRefresh = true;
					window.scrollTo(0, 0);
				}

				new Promise(function (resolve) {
					resolve(_this.props.loadPage(page, forceRefresh));
				}).then(function () {
					_this.isLoadingTop = false;
					_this.isLoadingBottom = false;
					_this.suppressScrollListener = false;
				});
			} else {
				window.scrollTo(0, window.scrollY + _this._getPageDimensions(page).top);
				_this.updatePageNumber(page);
			}
		};

		_this.loadPreviousPage = function () {
			var page = _this.props.page;

			_this.isLoadingTop = true;
			_this.loadPage(page - 1);
		};

		_this.synchronizePages = function () {
			var scrollDirection = _this.scrollDirection; // calling it once
			// Skip sync if we have a replyModal or confirmModal open
			var skipUpdate = history.state && (history.state.type === 'confirmModal' || history.state.type === 'replyModal');

			if (_this._isLoading() || skipUpdate || scrollDirection === undefined) {
				return null;
			} else {
				var pageRect = void 0,
				    theSelectedPage = null,
				    topPageHeight = _this.props.extraHeaderHeight + _this.headerHeight - _this.breadCrumbHeight;

				// Go through all current pages to check where we are
				_this.props.pages.forEach(function (p) {
					// if we are 'up' we take the first one matching
					// otherwise we'll take the latest
					if (scrollDirection === 'up' && theSelectedPage) {
						return; // skip to next one because forEach will run through all
					}
					pageRect = _this._getPageDimensions(p);

					if (pageRect.top > 0 && pageRect.top < window.innerHeight - _this.state.bottomPosition || // just show up from the bottom
					pageRect.bottom < window.innerHeight && pageRect.bottom > topPageHeight || // just show up from the top
					pageRect.top < window.innerHeight - _this.state.bottomPosition && pageRect.bottom >= window.innerHeight - _this.state.bottomPosition // it's totally on viewport
					) {
							theSelectedPage = p;
						}
				});

				_this.updatePageNumber(theSelectedPage || _this.props.page);
			}
		};

		_this.throttleScroll = throttle_default()(function () {
			var page = _this.props.page,
			    diffPos = _this.previousPos - _this.currentPos;

			// Skip the first catch after forcing reposition
			if (_this.justRepositioned) {
				_this.justRepositioned = false;
				return true;
			}

			// save position
			_this.currentPos = window.scrollY;

			// do we force skip?
			if (_this.suppressScrollListener || _this._overflowItemsOpen()) {
				return false;
			}

			// if the page is loading skip
			if (_this._isLoading()) {
				return false;
			}

			var currentPage = _this._getPageDimensions(page),
			    diffOffset = _this.previousState.offset - currentPage.offsetTop;

			// Skip because previous page have changed in size,
			// probably ads or images loading or ads clearing
			if (diffOffset === diffPos) {
				return false;
			}

			// Do we need to load a new page or sync pages?
			if (_this._needLoadNewPage() === false) {
				_this.synchronizePages();
			}
		}, 100, {
			'leading': true,
			'trailing': true
		});

		_this.loadingAnimation = function (pos) {
			return react_default.a.createElement(LoaderCssComponent, { container: false, className: pos });
		};

		_this.state = {
			bottomPosition: 0
		};

		_this.suppressScrollListener = true;
		_this.justRepositioned = false;
		_this.currentPos = 0;
		_this.previousPos = 0;

		_this.isLoadingTop = false;
		_this.isLoadingBottom = false;
		_this.previousState = {
			page: 0,
			offset: 0
		};
		_this.scrollTopBeforeUpdate = 0;
		_this.breadCrumbHeight = 0;
		_this.headerHeight = 0;
		_this.bottomFloatingAd = null;
		_this.rePositionFixAdTimer = null;
		return _this;
	}

	InfiniteScrollComponent__createClass(InfiniteScrollComponent, [{
		key: 'componentWillMount',
		value: function componentWillMount() {
			// Getting header height, for the breadcrumb we need to wait until is mounted
			var header = document.getElementById('header');
			this.headerHeight = header.getBoundingClientRect().height;
		}
	}, {
		key: 'componentDidMount',
		value: function componentDidMount() {
			var _this2 = this;

			// To be sure we have the correct page number
			this.updatePageNumber(this.props.page);

			// Getting breadcrumb height
			var breadCrumb = document.getElementById('breadCrumbBar');
			this.breadCrumbHeight = breadCrumb ? breadCrumb.getBoundingClientRect().height : 0;

			// Getting bottom floating height
			this.bottomFloatingAd = document.getElementById('Fixed_Bottom_Leaderboard_container');
			this.rePositionFixAdTimer = setTimeout(function () {
				_this2._getBottomFixAdPosition();
			}, 1000);

			this.attachScrollListener();
		}
	}, {
		key: 'componentWillUnmount',
		value: function componentWillUnmount() {
			this.detachScrollListener();

			if (this.rePositionFixAdTimer) {
				clearTimeout(this.rePositionFixAdTimer);
				this.rePositionFixAdTimer = undefined;
			}
		}
	}, {
		key: 'componentWillReceiveProps',
		value: function componentWillReceiveProps(nextProps) {
			if (nextProps.iOSkeyBoardOpen !== this.props.iOSkeyBoardOpen) {
				this.setState({
					bottomPosition: 0
				});
			}
		}
	}, {
		key: 'shouldComponentUpdate',
		value: function shouldComponentUpdate(nextProps, nextState) {
			return nextProps.totalPages !== this.props.totalPages || nextProps.page !== this.props.page || nextProps.isFetching !== this.props.isFetching || !isEqual_default()(nextProps.pages, this.props.pages) || nextState.bottomPosition !== this.state.bottomPosition || nextProps.adSlots.Fixed_Bottom_Leaderboard !== this.props.adSlots.Fixed_Bottom_Leaderboard || nextProps.extraHeaderHeight !== this.props.extraHeaderHeight;
		}
	}, {
		key: 'componentWillUpdate',
		value: function componentWillUpdate(nextProps) {
			this.suppressScrollListener = true;
			// Let's get the current scroll position
			this.scrollTopBeforeUpdate = window.scrollY;
			this.previousState.page = nextProps.pages[0];
			this.previousState.offset = this._getPageDimensions(nextProps.page).offsetTop;
		}
	}, {
		key: 'componentDidUpdate',
		value: function componentDidUpdate(prevProps, prevState) {
			var _this3 = this;

			// If the fixed bottom ad changed then reposition the page selector
			try {
				if (prevProps.adSlots.Fixed_Bottom_Leaderboard !== this.props.adSlots.Fixed_Bottom_Leaderboard || prevState.bottomPosition !== this.state.bottomPosition) {
					if (this.rePositionFixAdTimer) {
						clearTimeout(this.rePositionFixAdTimer);
						this.rePositionFixAdTimer = undefined;
					}
					this._getBottomFixAdPosition();

					this.rePositionFixAdTimer = setTimeout(function () {
						_this3._getBottomFixAdPosition();
					}, 500);
				}
			} catch (e) {} /* ignore it */

			// Do we need to fix Scroll Position?
			if (this.listRef && this.props.pages[0] !== this.props.page && (this.props.isFetching === false && this.previousState.page === this.props.pages[0] || // when going up: not fetching and new page (lastPage) will be on pos 0
			prevProps.pages[1] === this.props.pages[0] // when going down: first page removed and previous pos 1 is now 0
			)) {

				this._fixScrollPosition();
			}

			// Reset if needed isLoadingTop and isLoadingBottom
			if (prevProps.isFetching !== this.props.isFetching && !this.props.isFetching) {
				this.isLoadingTop = this.isLoadingTop && this.props.isFetching;
				this.isLoadingBottom = this.isLoadingBottom && this.props.isFetching;
			}

			this.suppressScrollListener = false;

			// If page changed or if we just landed on the section,
			// we need to check if we need to load next page
			// even before the user scrolls
			if (this._overflowItemsOpen() === false && this.props.totalPages > 0 && ( // If we have pages at all
			prevProps.page !== this.props.page || // page changed
			this.props.pages.length === 1 && this.props.totalPages !== this.props.page // we only have 1 page loaded and there are more
			)) {
				this._needLoadNewPage();
			}
		}
	}, {
		key: '_fixScrollPosition',
		value: function _fixScrollPosition() {
			this.suppressScrollListener = true;

			// diff between distances from current page to the top and
			// previous current page before to the top is the diff in the scroll
			var pageDims = this._getPageDimensions(this.props.page),
			    diffFromTop = pageDims.offsetTop - this.previousState.offset;

			if (diffFromTop) {
				window.scrollTo(0, this.scrollTopBeforeUpdate + diffFromTop);
				this.justRepositioned = true;
			}

			this.previousPos = window.scrollY;
			this.suppressScrollListener = false;
		}
	}, {
		key: 'attachScrollListener',
		value: function attachScrollListener() {
			this.suppressScrollListener = false;
			window.addEventListener("resize", this.synchronizePages);
			window.addEventListener("scroll", this.throttleScroll);
		}
	}, {
		key: 'detachScrollListener',
		value: function detachScrollListener() {
			this.suppressScrollListener = true;
			this.throttleScroll.cancel();
			window.removeEventListener("resize", this.synchronizePages);
			window.removeEventListener("scroll", this.throttleScroll);
		}
	}, {
		key: 'loadNextPage',
		value: function loadNextPage() {
			var page = this.props.page;

			this.isLoadingBottom = true;
			this.loadPage(page + 1);
		}
	}, {
		key: 'updatePageNumber',
		value: function updatePageNumber(page) {
			var _this4 = this;

			var location = this.props.location;

			// Do we need to update? avoid updating if everything is already OK

			var currentQueryPage = this.props.location.query && this.props.location.query.page ? parseInt(this.props.location.query.page) : null;

			if (isFinite(page) === false || // page passed is not a number
			page === 1 && currentQueryPage === null || // we are in page 1 and we have the query saying otherwise
			currentQueryPage === page // the querystring already says we are here
			) {
					this.previousPos = window.scrollY;
					this.suppressScrollListener = false;
					return true;
				}

			this.suppressScrollListener = true;

			new Promise(function (resolve) {
				resolve(_this4.props.dispatch(Object(InfiniteScrollActions["h" /* updatePageNumber */])(location, page, location.pathname)));
			}).then(function () {
				_this4.suppressScrollListener = false;
			});
		}
	}, {
		key: 'loadPreviousButton',
		value: function loadPreviousButton() {
			return react_default.a.createElement(
				'div',
				{ className: 'loadMore', onClick: this.loadPreviousPage },
				'Load Previous'
			);
		}
	}, {
		key: 'topLoader',
		value: function topLoader() {
			var _props = this.props,
			    page = _props.page,
			    pages = _props.pages;


			if (this.isLoadingTop) {
				return this.loadingAnimation('top');
			} else if (pages[0] > 1 && (pages.length <= 1 || page === pages[0])) {
				return this.loadPreviousButton();
			}
		}
	}, {
		key: 'bottomLoader',
		value: function bottomLoader() {
			var _props2 = this.props,
			    totalPages = _props2.totalPages,
			    page = _props2.page;


			if (page <= totalPages && this.isLoadingBottom) {
				return this.loadingAnimation('bottom');
			}
		}

		/**
   * Get all dimensions we wanna use about one page
   * getBoundingClientRect ( height, top, bottom... ) and offsetTop
   *
   * @param page
   * @returns {*}
   * @private
   */

	}, {
		key: '_getPageDimensions',
		value: function _getPageDimensions(page) {
			var defaultDimensions = { height: 0, top: 0, bottom: 0, width: 0, offsetTop: 0 };

			try {
				var thePage = this.listRef.getElementsByClassName('page_' + page)[0];
				return Object.assign(thePage.getBoundingClientRect(), { offsetTop: thePage.offsetTop });
			} catch (e) {
				return defaultDimensions;
			}
		}
	}, {
		key: '_isLoading',
		value: function _isLoading() {
			return this.props.isFetching || this.isLoadingTop || this.isLoadingBottom;
		}
	}, {
		key: '_needLoadNewPage',
		value: function _needLoadNewPage() {
			// we check first natural order ( bottom - next page ) then
			// check the other way ( top - previous page )
			if (!this._isLoading() && // if loading, skip
			this.props.totalPages > this.props.page && // if we are at the bottom, skip
			this.props.pages.indexOf(this.props.page + 1) < 0 // if we have the page already loaded, no need
			) {
					// Load Next page
					this.loadNextPage();
					return true;
				} else if (!this._isLoading() && // if loading, skip
			this.props.page !== 1 && // if we are at top, skip
			this.props.pages.indexOf(this.props.page - 1) < 0 // if we already have the previous page, no need
			) {
					// Load Previous page
					this.loadPreviousPage();
					return true;
				}

			return false;
		}
	}, {
		key: '_getBottomFixAdPosition',
		value: function _getBottomFixAdPosition() {
			var bottomFloatingAd = this.bottomFloatingAd || document.getElementById('Fixed_Bottom_Leaderboard_container');
			if (bottomFloatingAd) {
				try {
					this.setState({
						bottomPosition: bottomFloatingAd.getBoundingClientRect().height
					});
				} catch (e) {/* ignore */
				}
			}
		}
	}, {
		key: 'render',
		value: function render() {
			var _this5 = this;

			var _props3 = this.props,
			    page = _props3.page,
			    totalPages = _props3.totalPages;


			var childrenWithProps = react_default.a.Children.map(this.props.children, function (child) {
				if (child) {
					return react_default.a.cloneElement(child, {
						pages: _this5.props.pages,
						listRef: function listRef(list) {
							return _this5.listRef = list;
						}
					});
				}
			});

			var style = { paddingTop: Math.round(this.props.extraHeaderHeight) + 1 + 'px' };

			return react_default.a.createElement(
				'div',
				{ id: 'scroll', ref: this.props.scrollRef, style: style },
				this.topLoader(),
				childrenWithProps,
				this.bottomLoader(),
				react_default.a.createElement(infiniteScroll_PageSelectorComponent, {
					currentPage: page,
					totalPages: totalPages,
					onFirstButtonClick: function onFirstButtonClick() {
						return _this5.loadPage(1);
					},
					onLastButtonClick: function onLastButtonClick() {
						return _this5.loadPage(totalPages);
					},
					onJumpPage: function onJumpPage(newPage) {
						return _this5.loadPage(newPage, true);
					},
					bottomPosition: this.state.bottomPosition
				})
			);
		}
	}, {
		key: 'scrollDirection',
		get: function get() {
			if (this.previousPos) {
				switch (true) {
					case this.currentPos > this.previousPos:
						this.prevDirection = 'down';
						break;

					case this.currentPos < this.previousPos:
						this.prevDirection = 'up';
						break;
				}
			}

			this.previousPos = this.currentPos;
			return this.prevDirection;
		}

		// Throttle the scroll listener to every 100ms

	}]);

	return InfiniteScrollComponent;
}(react_default.a.Component);

InfiniteScrollComponent_InfiniteScrollComponent.defaultProps = {
	page: 1,
	totalPages: 0,
	extraHeaderHeight: 0,
	earliestLoadedPage: null,
	latestLoadedPage: null
};

InfiniteScrollComponent_InfiniteScrollComponent.propTypes = {
	page: prop_types_default.a.oneOfType([prop_types_default.a.string, prop_types_default.a.number]),
	totalPages: prop_types_default.a.number.isRequired,
	isFetching: prop_types_default.a.bool.isRequired,
	loadPage: prop_types_default.a.func.isRequired,
	location: prop_types_default.a.object.isRequired,
	earliestLoadedPage: prop_types_default.a.number,
	latestLoadedPage: prop_types_default.a.number,
	scrollRef: prop_types_default.a.func.isRequired
};

/* harmony default export */ var infiniteScroll_InfiniteScrollComponent = (Object(es["b" /* connect */])(selectors_infiniteScrollSelector)(InfiniteScrollComponent_InfiniteScrollComponent));
// CONCATENATED MODULE: ./src/components/ForumViewComponent.js
var ForumViewComponent__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function ForumViewComponent__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function ForumViewComponent__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function ForumViewComponent__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






















var ForumViewComponent_ForumViewComponent = function (_React$Component) {
	ForumViewComponent__inherits(ForumViewComponent, _React$Component);

	function ForumViewComponent() {
		var _ref;

		var _temp, _this, _ret;

		ForumViewComponent__classCallCheck(this, ForumViewComponent);

		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		return _ret = (_temp = (_this = ForumViewComponent__possibleConstructorReturn(this, (_ref = ForumViewComponent.__proto__ || Object.getPrototypeOf(ForumViewComponent)).call.apply(_ref, [this].concat(args))), _this), _this.loadPage = function (page, forceRefresh) {
			_this.props.dispatch(Object(ForumviewActions["e" /* fetchForum */])({
				id: _this.props.routeParams.forumId,
				page: page,
				forceRefresh: forceRefresh
			}));
		}, _temp), ForumViewComponent__possibleConstructorReturn(_this, _ret);
	}

	ForumViewComponent__createClass(ForumViewComponent, [{
		key: 'componentDidMount',
		value: function componentDidMount() {
			this.props.dispatch(Object(InfiniteScrollActions["f" /* resetInfinite */])());
			this.props.dispatch(Object(ForumviewActions["f" /* resetForum */])());
			this.props.dispatch(Object(ThreadviewActions["h" /* resetThread */])());
			this.props.dispatch(Object(UiActions["z" /* closeAnnouncements */])());

			var page = this.props.location.query.page || 1;
			this.props.dispatch(Object(ForumviewActions["e" /* fetchForum */])({
				id: this.props.routeParams.forumId,
				page: parseInt(page)
			}));
		}
	}, {
		key: 'componentWillUnmount',
		value: function componentWillUnmount() {
			this.props.dispatch(Object(ForumviewActions["f" /* resetForum */])());
			this.props.dispatch(Object(ThreadviewActions["h" /* resetThread */])());
			this.props.dispatch(Object(InfiniteScrollActions["f" /* resetInfinite */])());
			this.props.dispatch(Object(UiActions["z" /* closeAnnouncements */])());
		}
	}, {
		key: 'shouldComponentUpdate',
		value: function shouldComponentUpdate(nextProps) {
			return nextProps.forumview.loaded !== this.props.forumview.loaded || nextProps.forumview.isFetching !== this.props.forumview.isFetching || nextProps.forumview.result.topics.length !== this.props.forumview.result.topics.length || nextProps.forumview.forumId !== this.props.forumview.forumId;
		}
	}, {
		key: 'componentWillReceiveProps',
		value: function componentWillReceiveProps(nextProps) {
			if (this.props.routeParams.forumId !== nextProps.routeParams.forumId) {
				window.scrollTo(0, 0);

				this.props.dispatch(Object(ForumviewActions["e" /* fetchForum */])({
					id: nextProps.routeParams.forumId,
					page: 1,
					forceRefresh: true
				}));
				return;
			}
			if (nextProps.forumview.forumId !== this.props.forumview.forumId) {
				this.props.dispatch(Object(UiActions["z" /* closeAnnouncements */])());
				this.props.dispatch(Object(adsActions["l" /* checkAdsPermissions */])(parseInt(nextProps.forumview.forumId)));
				this.props.dispatch(Object(adsActions["w" /* resetHiddenAdsPerUser */])());
			}
			if (nextProps.forumview.loaded && nextProps.forumview.loaded !== this.props.forumview.loaded) {
				// trigger ad updates
				this.props.dispatch(Object(adsActions["s" /* onPageView */])({ captify: "" }));
				// Record the Google Analytics pageview
				this.props.dispatch(Object(adsActions["B" /* trackPageView */])());
			}
		}
	}, {
		key: 'render',
		value: function render() {
			var _this2 = this;

			var _props$forumview = this.props.forumview,
			    loaded = _props$forumview.loaded,
			    isFetching = _props$forumview.isFetching;


			if (!loaded) {
				return react_default.a.createElement(LoaderCssComponent, null);
			}

			var adUnit = react_default.a.createElement(ads_AdComponent, { adType: '5', fallbackAdType: [1], adName: 'In_Content_Ad' }),
			    campaignAd = react_default.a.createElement(ads_AdComponent, { adType: '505', adName: 'Campaign_Top_Ad' }),
			    bottomAdUnit = react_default.a.createElement(ads_AdComponent, { adType: '2', adName: 'Bottom_Content_Rectangle', isFetching: isFetching });

			return react_default.a.createElement(
				'div',
				null,
				react_default.a.createElement(common_BreadcrumbComponent, { routeParams: this.props.routeParams }),
				react_default.a.createElement(forums_AnnouncementsViewComponent, null),
				react_default.a.createElement(forums_ForumListComponent, null),
				adUnit,
				campaignAd,
				react_default.a.createElement(
					infiniteScroll_InfiniteScrollComponent,
					{
						scrollRef: function scrollRef(i) {
							return _this2.infiniteScroll = i;
						},
						isFetching: isFetching,
						loadPage: this.loadPage,
						location: this.props.location },
					react_default.a.createElement(threads_ThreadListComponent, null)
				),
				bottomAdUnit
			);
		}
	}]);

	return ForumViewComponent;
}(react_default.a.Component);

/* harmony default export */ var components_ForumViewComponent = (Object(es["b" /* connect */])(forumViewSelector)(ForumViewComponent_ForumViewComponent));
// EXTERNAL MODULE: ./src/styles/post.scss
var styles_post = __webpack_require__(764);
var styles_post_default = /*#__PURE__*/__webpack_require__.n(styles_post);

// CONCATENATED MODULE: ./src/selectors/threadViewSelector.js



var threadviewSelector = function threadviewSelector(state, props) {
	return props.threadview || state.threadview;
};
var threadViewSelector_userStateSelector = function userStateSelector(state) {
	return state.ustate;
};
var threadViewSelector_infiniteScrollSelector = function infiniteScrollSelector(state) {
	return state.infiniteScroll;
};
var threadViewSelector_topifyPresetsSelector = function topifyPresetsSelector(state) {
	return state.topifyPresets;
};

/* harmony default export */ var threadViewSelector = (Object(lib["createSelector"])([threadviewSelector, selectors_metaSelector, threadViewSelector_userStateSelector, threadViewSelector_infiniteScrollSelector, threadViewSelector_topifyPresetsSelector], function (threadview, meta, ustate, infiniteScroll, topifyPresets) {
	var forumid = function forumid() {
		if (threadview.threadid && threadview.entities.topics) {
			return parseInt(threadview.entities.topics[threadview.threadid].forum);
		} else {
			return null;
		}
	};

	return {
		forumId: forumid(),
		ustate: ustate,
		threadview: threadview,
		meta: meta,
		currentPage: infiniteScroll.page,
		totalPages: infiniteScroll.totalPages,
		forumSite: topifyPresets.forumSite
	};
}));
// CONCATENATED MODULE: ./src/components/ads/inThreadAdComponent.js




var inThreadAdComponent_inThreadAdComponent = function inThreadAdComponent(_ref) {
	var adContainerId = _ref.adContainerId,
	    className = _ref.className;

	className = "inThreadAd-placeholder " + className;

	return react_default.a.createElement(
		'div',
		{ className: className },
		react_default.a.createElement('div', { id: adContainerId })
	);
};

/* harmony default export */ var ads_inThreadAdComponent = (Object(es["b" /* connect */])(selectors_infiniteScrollSelector)(inThreadAdComponent_inThreadAdComponent));
// EXTERNAL MODULE: ./src/actions/PhotoGalleryActions.js
var PhotoGalleryActions = __webpack_require__(86);

// CONCATENATED MODULE: ./src/components/common/PhotoSwipeGallery.js
var PhotoSwipeGallery__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function PhotoSwipeGallery__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function PhotoSwipeGallery__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function PhotoSwipeGallery__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var PhotoSwipeGallery_PhotoSwipeGallery = function (_React$Component) {
	PhotoSwipeGallery__inherits(PhotoSwipeGallery, _React$Component);

	function PhotoSwipeGallery() {
		var _ref;

		var _temp, _this, _ret;

		PhotoSwipeGallery__classCallCheck(this, PhotoSwipeGallery);

		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		return _ret = (_temp = (_this = PhotoSwipeGallery__possibleConstructorReturn(this, (_ref = PhotoSwipeGallery.__proto__ || Object.getPrototypeOf(PhotoSwipeGallery)).call.apply(_ref, [this].concat(args))), _this), _this.thumbnailContent = function (item) {
			return react_default.a.createElement('img', { src: item.src });
		}, _this.showPhotoSwipe = function (itemIndex, postId) {
			return function (e) {
				e.preventDefault();
				var options = _this.props.options;
				options.index = itemIndex;
				options.getThumbBoundsFn = function (index) {
					var thumbnail = react_dom_default.a.findDOMNode(_this.refs['thumbnail' + index]);
					var img = thumbnail.getElementsByTagName('img')[0];
					var pageYScroll = window.pageYOffset || document.documentElement.scrollTop;
					var rect = img.getBoundingClientRect();
					return { x: rect.left, y: rect.top + pageYScroll, w: rect.width };
				};
				_this.props.dispatch(Object(PhotoGalleryActions["i" /* showGallery */])(options, postId));
				// Record the Google Analytics event.
				_this.props.dispatch(Object(adsActions["A" /* trackGAEvent */])(false, 'open', 'uiAction', 'mediaViewer'));
			};
		}, _temp), PhotoSwipeGallery__possibleConstructorReturn(_this, _ret);
	}

	PhotoSwipeGallery__createClass(PhotoSwipeGallery, [{
		key: 'render',
		value: function render() {
			var _this2 = this;

			return react_default.a.createElement(
				'div',
				{ className: 'pswp-gallery postFooter' },
				react_default.a.createElement(
					'div',
					{ className: 'title' },
					'Attachments'
				),
				react_default.a.createElement(
					'ul',
					{ className: 'pswp-thumbnails' },
					this.props.attachments().map(function (item) {
						return react_default.a.createElement(
							'li',
							{ key: item.index, ref: 'thumbnail' + item.index,
								className: 'pswp-thumbnail attachmentItem',
								onClick: _this2.showPhotoSwipe(item.index, _this2.props.postId) },
							_this2.thumbnailContent(item)
						);
					})
				)
			);
		}
	}]);

	return PhotoSwipeGallery;
}(react_default.a.Component);

PhotoSwipeGallery_PhotoSwipeGallery.propTypes = {
	items: prop_types_default.a.object.isRequired,
	options: prop_types_default.a.object
};


function PhotoSwipeGallery_mapStateToProps(state) {
	return {
		isOpen: state.photogallery.isOpen,
		items: state.photogallery.items,
		options: state.photogallery.options
	};
}

/* harmony default export */ var common_PhotoSwipeGallery = (Object(es["b" /* connect */])(PhotoSwipeGallery_mapStateToProps)(PhotoSwipeGallery_PhotoSwipeGallery));
// EXTERNAL MODULE: ./node_modules/photoswipe/dist/photoswipe.css
var photoswipe = __webpack_require__(765);
var photoswipe_default = /*#__PURE__*/__webpack_require__.n(photoswipe);

// EXTERNAL MODULE: ./node_modules/photoswipe/dist/default-skin/default-skin.css
var default_skin = __webpack_require__(766);
var default_skin_default = /*#__PURE__*/__webpack_require__.n(default_skin);

// CONCATENATED MODULE: ./src/components/posts/PostComponent.js
var PostComponent__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function PostComponent__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function PostComponent__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function PostComponent__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }


















var PostComponent_PostComponent = function (_React$Component) {
	PostComponent__inherits(PostComponent, _React$Component);

	function PostComponent(props) {
		PostComponent__classCallCheck(this, PostComponent);

		var _this = PostComponent__possibleConstructorReturn(this, (PostComponent.__proto__ || Object.getPrototypeOf(PostComponent)).call(this, props));

		_this._post = function () {
			var _this$props = _this.props,
			    postId = _this$props.postId,
			    posts = _this$props.posts;

			return posts[postId];
		};

		_this._getThumbnailContent = function (item) {
			return react_default.a.createElement('img', { src: item.thumbnail });
		};

		_this._getVisibleAttachments = function () {
			return _this.props.items[_this.props.postId] || [];
		};

		_this._getEditNote = function () {
			var post = _this._post();
			if (post.edited && post.edited.when) {
				var editedReason = post.edited.why ? react_default.a.createElement(
					'span',
					null,
					' - Reason: ',
					react_default.a.createElement(
						'em',
						null,
						post.edited.why
					)
				) : null;
				return react_default.a.createElement(
					'div',
					{ className: 'postFooter postEdited' },
					react_default.a.createElement(
						'div',
						{ className: 'title' },
						'Post Edited'
					),
					react_default.a.createElement(
						'ul',
						null,
						react_default.a.createElement(
							'li',
							null,
							'Last edited by ',
							react_default.a.createElement(
								'em',
								null,
								post.edited.who_username
							),
							'\xA0-\xA0',
							react_default.a.createElement(common_dateComponent, { timestamp: post.edited.when }),
							editedReason
						)
					)
				);
			}
			return null;
		};

		_this.state = {
			showAttachmentsPreview: _this.props.userSettings.showAttachmentsPreview
		};
		return _this;
	}

	PostComponent__createClass(PostComponent, [{
		key: 'shouldComponentUpdate',
		value: function shouldComponentUpdate(nextProps, nextState) {
			return nextProps.isSelected !== this.props.isSelected || nextProps.postId !== this.props.postId || nextProps.userSettings.showAttachmentsPreview !== this.props.userSettings.showAttachmentsPreview || nextState.showAttachmentsPreview !== this.state.showAttachmentsPreview;
		}
	}, {
		key: 'selectPost',
		value: function selectPost() {
			this.props.dispatch(Object(MetaActions["e" /* toggleSelectedItem */])(this.props.postId));
		}
	}, {
		key: 'showAttachments',
		value: function showAttachments() {
			this.setState({ showAttachmentsPreview: true });
		}
	}, {
		key: 'render',
		value: function render() {
			var _this2 = this;

			var _props = this.props,
			    users = _props.users,
			    isSearch = _props.isSearch,
			    isUserProfile = _props.isUserProfile,
			    perms = _props.perms,
			    post = this._post(),
			    userName = post.forumUserName ? 'Guest (' + post.forumUserName + ')' : '',
			    user = post.forumUser ? users[post.forumUser] : { userName: userName || 'Guest', avatar: '' },
			    postNum = post.isDeleted ? '_' : post.num || this.props.postNum,
			    reducedView = isSearch || isUserProfile;

			// Parse bbCode


			var allowHtml = !reducedView && this.props.allowHtml;
			var reactComponents = RawToReact(reducedView || post.isDeleted ? post.preview : post.message, this.props, allowHtml);

			// If we have a title show it
			var title = isUserProfile ? react_default.a.createElement(
				'div',
				{ className: 'post_title' },
				react_default.a.createElement(
					'span',
					{ className: 'post_title_title' },
					post.threadStarter ? 'Started:' : 'Replied to:'
				),
				' ',
				react_default.a.createElement(
					'em',
					null,
					RawToReact(this.props.threadTitle)
				)
			) : post.title ? react_default.a.createElement(
				'div',
				{ className: 'post_title' },
				RawToReact(post.title)
			) : '';

			var permissions = perms.canseeattachments ? '' : react_default.a.createElement(
				'span',
				{ className: 'note' },
				'not allowed to see attachments'
			);

			// If the post has attachments show them, unless we are in a search
			var attachmentList = post.attachments && post.attachments.length > 0 ? reducedView || !perms.canseeattachments ? react_default.a.createElement(
				'div',
				{ className: 'postFooter inSearch' },
				react_default.a.createElement(
					'ul',
					null,
					react_default.a.createElement(
						'li',
						{ className: 'attachmentItem' },
						post.attachments.length,
						' ',
						react_default.a.createElement(svg_SvgIcon, { icon: 'clip', size: '16px' }),
						' ',
						permissions
					)
				)
			) : this.state.showAttachmentsPreview ? react_default.a.createElement(common_PhotoSwipeGallery, { postId: post.id, attachments: this._getVisibleAttachments, thumbnailContent: this._getThumbnailContent }) : react_default.a.createElement(
				'div',
				{ className: 'postFooter inSearch' },
				react_default.a.createElement(
					'div',
					{ className: 'title' },
					'Attachments'
				),
				react_default.a.createElement(
					'ul',
					null,
					react_default.a.createElement(
						'li',
						{ className: 'attachmentItem' },
						post.attachments.length,
						' ',
						react_default.a.createElement(svg_SvgIcon, { icon: 'clip', size: '16px' }),
						react_default.a.createElement(
							'div',
							{ className: 'modal-buttons' },
							react_default.a.createElement(
								'button',
								{ className: 'action-button', onClick: function onClick() {
										return _this2.showAttachments();
									} },
								'Show ',
								post.attachments.length > 1 ? 'these' : 'this',
								' thumbnail',
								post.attachments.length > 1 ? 's' : ''
							)
						)
					)
				)
			) : react_default.a.createElement('span', null);

			var itemSelected = this.props.isSelected ? ' selected-item' : '',
			    itemDeleted = post.isDeleted ? ' deleted' : '',
			    itemModerated = post.isModerated ? ' moderated' : '';

			var checkBox = !reducedView ? react_default.a.createElement(CheckboxComponent, {
				name: 'postSelect_' + post.topic,
				id: 'postSelected_' + post.id,
				value: post.id,
				checked: this.props.isSelected,
				multiple: true,
				className: 'inPost',
				onChange: function onChange() {
					return _this2.selectPost();
				}
			}) : null;

			var editNote = this._getEditNote(),
			    className = 'post' + itemModerated + itemDeleted + itemSelected;

			return react_default.a.createElement(
				'div',
				{ className: className },
				react_default.a.createElement(
					'div',
					{ className: 'left' },
					react_default.a.createElement(common_UserIconComponent, { user: user })
				),
				react_default.a.createElement(
					'div',
					{ className: 'right' },
					react_default.a.createElement(
						'div',
						{ className: 'time' },
						react_default.a.createElement(common_dateComponent, { timestamp: post.dateline }),
						' \xB7 #',
						postNum,
						checkBox
					),
					title,
					react_default.a.createElement('div', { className: 'chevron' }),
					react_default.a.createElement(
						'div',
						{ className: 'body', id: 'post_message_' + post.id },
						reactComponents,
						react_default.a.createElement(
							'span',
							null,
							reducedView ? ' [...]' : ''
						)
					),
					attachmentList,
					editNote
				)
			);
		}
	}]);

	return PostComponent;
}(react_default.a.Component);

var PostComponent_mapStateToProps = function mapStateToProps(state, props) {
	return {
		items: state.photogallery.items,
		userSettings: state.ui.userSettings,
		isSelected: !!state.meta.selectedElements[props.postId]
	};
};

/* harmony default export */ var posts_PostComponent = (Object(es["b" /* connect */])(PostComponent_mapStateToProps)(PostComponent_PostComponent));
// EXTERNAL MODULE: ./node_modules/photoswipe/dist/photoswipe.js
var dist_photoswipe = __webpack_require__(767);
var dist_photoswipe_default = /*#__PURE__*/__webpack_require__.n(dist_photoswipe);

// EXTERNAL MODULE: ./node_modules/photoswipe/dist/photoswipe-ui-default.js
var photoswipe_ui_default = __webpack_require__(768);
var photoswipe_ui_default_default = /*#__PURE__*/__webpack_require__.n(photoswipe_ui_default);

// CONCATENATED MODULE: ./src/utils/sizeOf.js
function sizeOf(url, callback) {
	var image = new window.Image();
	image.src = url;
	image.onload = function () {
		callback(image.width, image.height);
	};
}
// CONCATENATED MODULE: ./src/components/common/PhotoSwipe.js
var PhotoSwipe__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function PhotoSwipe__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function PhotoSwipe__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function PhotoSwipe__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var PhotoSwipe_PhotoSwipe = function (_React$Component) {
	PhotoSwipe__inherits(PhotoSwipe, _React$Component);

	function PhotoSwipe() {
		var _ref;

		var _temp, _this, _ret;

		PhotoSwipe__classCallCheck(this, PhotoSwipe);

		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		return _ret = (_temp = (_this = PhotoSwipe__possibleConstructorReturn(this, (_ref = PhotoSwipe.__proto__ || Object.getPrototypeOf(PhotoSwipe)).call.apply(_ref, [this].concat(args))), _this), _this.componentDidMount = function () {
			if (_this.props.isOpen) {
				var visibleItems = _this.props.items[_this.props.postId] || [];
				_this.openPhotoSwipe(visibleItems, _this.props.options);
			}
		}, _this.componentWillReceiveProps = function (nextProps) {
			var visibleItems = nextProps.items[nextProps.postId] || [];
			if (nextProps.isOpen) {
				if (!_this.props.isOpen) {
					_this.openPhotoSwipe(visibleItems, nextProps.options);
				} else {
					_this.photoSwipe.items.length = 0;
					visibleItems.forEach(function (item) {
						_this.photoSwipe.items.push(item);
					});
					_this.photoSwipe.invalidateCurrItems();
					_this.photoSwipe.updateSize(true);
				}
			} else if (_this.props.isOpen) {
				_this.photoSwipe.close();
			}
		}, _this.componentWillUnmount = function () {
			if (_this.photoSwipe) {
				_this.photoSwipe.close();
			}
		}, _this.openPhotoSwipe = function (items, options) {
			var pswpElement = react_dom_default.a.findDOMNode(_this);
			_this.photoSwipe = new dist_photoswipe_default.a(pswpElement, photoswipe_ui_default_default.a, items, options);
			_this.photoSwipe.listen('close', _this.handleClose);
			_this.photoSwipe.listen('gettingData', function (index, item) {
				sizeOf(item.src, function (width, height) {
					item.w = width;
					item.h = height;
					_this.photoSwipe.updateSize(true);
				});
			});
			_this.photoSwipe.listen('imageLoadComplete', function (index, item) {
				_this.photoSwipe.updateSize(true);
			});
			_this.photoSwipe.init();
		}, _this.handleClose = function () {
			_this.props.dispatch(Object(PhotoGalleryActions["g" /* hideGallery */])());
		}, _temp), PhotoSwipe__possibleConstructorReturn(_this, _ret);
	}

	PhotoSwipe__createClass(PhotoSwipe, [{
		key: 'render',
		value: function render() {
			return react_default.a.createElement(
				'div',
				{ className: 'pswp', tabIndex: '-1', role: 'dialog', 'aria-hidden': 'true' },
				react_default.a.createElement('div', { className: 'pswp__bg' }),
				react_default.a.createElement(
					'div',
					{ className: 'pswp__scroll-wrap' },
					react_default.a.createElement(
						'div',
						{ className: 'pswp__container' },
						react_default.a.createElement('div', { className: 'pswp__item no-ad' }),
						react_default.a.createElement('div', { className: 'pswp__item no-ad' }),
						react_default.a.createElement('div', { className: 'pswp__item no-ad' })
					),
					react_default.a.createElement(
						'div',
						{ className: 'pswp__ui pswp__ui--hidden' },
						react_default.a.createElement(
							'div',
							{ className: 'pswp__top-bar' },
							react_default.a.createElement('div', { className: 'pswp__counter' }),
							react_default.a.createElement('button', { className: 'pswp__button pswp__button--close',
								title: 'Close (Esc)' }),
							react_default.a.createElement('button', { className: 'pswp__button pswp__button--share',
								title: 'Share' }),
							react_default.a.createElement('button', { className: 'pswp__button pswp__button--fs',
								title: 'Toggle fullscreen' }),
							react_default.a.createElement('button', { className: 'pswp__button pswp__button--zoom',
								title: 'Zoom in/out' }),
							react_default.a.createElement(
								'div',
								{ className: 'pswp__preloader' },
								react_default.a.createElement(
									'div',
									{ className: 'pswp__preloader__icn' },
									react_default.a.createElement(
										'div',
										{ className: 'pswp__preloader__cut' },
										react_default.a.createElement('div', { className: 'pswp__preloader__donut' })
									)
								)
							)
						),
						react_default.a.createElement(
							'div',
							{
								className: 'pswp__share-modal pswp__share-modal--hidden pswp__single-tap' },
							react_default.a.createElement('div', { className: 'pswp__share-tooltip' })
						),
						react_default.a.createElement('button', { className: 'pswp__button pswp__button--arrow--left',
							title: 'Previous (arrow left)' }),
						react_default.a.createElement('button', { className: 'pswp__button pswp__button--arrow--right',
							title: 'Next (arrow right)' }),
						react_default.a.createElement(
							'div',
							{ className: 'pswp__caption' },
							react_default.a.createElement('div', { className: 'pswp__caption__center' })
						)
					)
				)
			);
		}
	}]);

	return PhotoSwipe;
}(react_default.a.Component);

PhotoSwipe_PhotoSwipe.propTypes = {
	isOpen: prop_types_default.a.bool.isRequired,
	items: prop_types_default.a.object.isRequired,
	options: prop_types_default.a.object,
	onClose: prop_types_default.a.func
};


function PhotoSwipe_mapStateToProps(state) {
	return {
		items: state.photogallery.items,
		postId: state.photogallery.postId,
		isOpen: state.photogallery.isOpen,
		options: state.photogallery.options
	};
}

/* harmony default export */ var common_PhotoSwipe = (Object(es["b" /* connect */])(PhotoSwipe_mapStateToProps)(PhotoSwipe_PhotoSwipe));
// CONCATENATED MODULE: ./src/components/posts/PostListComponent.js
var PostListComponent__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function PostListComponent__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function PostListComponent__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function PostListComponent__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }


























var PostListComponent_PostListComponent = function (_React$Component) {
	PostListComponent__inherits(PostListComponent, _React$Component);

	function PostListComponent(props) {
		PostListComponent__classCallCheck(this, PostListComponent);

		var _this = PostListComponent__possibleConstructorReturn(this, (PostListComponent.__proto__ || Object.getPrototypeOf(PostListComponent)).call(this, props));

		_this._resetThread = function () {
			if (!/topics|search/.test(location.hash)) {
				_this.props.dispatch(Object(MetaActions["c" /* resetSelectedItem */])());
				_this.props.dispatch(Object(ThreadviewActions["h" /* resetThread */])());
			}
		};

		_this._resetGallery = function () {
			if (!/topics|search/.test(location.hash)) {
				_this.props.dispatch(Object(PhotoGalleryActions["h" /* resetGallery */])());
			}
		};

		_this.buildPost = function (post, i, pageNum, pageSize) {
			var _this$props$threadvie = _this.props.threadview,
			    _this$props$threadvie2 = _this$props$threadvie.entities,
			    posts = _this$props$threadvie2.posts,
			    users = _this$props$threadvie2.users,
			    page = _this$props$threadvie.page,
			    total = _this$props$threadvie.total,
			    totalPages = _this$props$threadvie.totalPages,
			    ustate = _this.props.ustate;


			var isSearch = _this.props.isSearch,
			    isUserProfile = _this.props.isUserProfile,
			    isFirst = i === 0 && pageNum === 1,
			    // Let's assume we want the first ad on the first page
			isLast = page === totalPages && post.num === total;

			var adUnit = null,
			    inThreadAd = null;

			var postNum = post.num || 1 + i + (pageNum - 1) * pageSize;

			switch (true) {
				case isUserProfile:
					// no Ads on user profile
					break;

				case isSearch:
					var searchProp = {
						isTop: false,
						page: (_this.props.threadview.page - 1) * (pageSize / 10) + (i + 1) / 10,
						searchQuery: _this.props.threadview.query.searchQuery
					};
					adUnit = (i + 1) % 10 === 0 ? react_default.a.createElement(ads_AdComponent, { key: 'In_Search_Ad_' + post.id, adType: '0', adName: 'In_Search_Ad_' + post.id, search: searchProp, tag: 'li' }) : null;
					break;

				default:
					var k = i + 1,
					    adType = isFirst ? 5 : 1,
					    fallbackAdType = adType === 5 ? [1] : [];

					// On first page after the 3th post
					inThreadAd = k === 3 && pageNum === 1 ? react_default.a.createElement(ads_inThreadAdComponent, { key: 'taboola_inthread_' + post.id, adContainerId: 'taboola-mid-article-stream-thumbnails', className: '' }) : null;

					switch (true) {
						case k === 4 && pageNum === 1:
							// after 4th and fallback to regular 320x50 - 'inContentTopicAd_2' - yieldmo Hyperscroll/Outstream
							adUnit = react_default.a.createElement(ads_AdComponent, { key: 'In_Content_Ad_2_' + post.id, adType: '205', fallbackAdType: [1], adName: 'In_Content_Ad_2_' + post.id, tag: 'li' });
							break;

						case k % 8 === 0 && !isLast:
							// Every 8 posts unless is the last thing in the page
							adUnit = react_default.a.createElement(ads_AdComponent, { key: 'In_Content_Ad_1_' + post.id, adType: '105', fallbackAdType: [1], adName: 'In_Content_Ad_1_' + post.id, tag: 'li' });
							break;

						case (k % 4 === 0 || i === 0 && isFirst) && !isLast:
							// Every 4 posts unless we have already one, skip the top position on first page and last position in last page
							adUnit = react_default.a.createElement(ads_AdComponent, { key: 'In_Content_Ad_' + post.id, adType: adType, fallbackAdType: fallbackAdType, adName: 'In_Content_Ad_' + post.id, tag: 'li' });
							break;

						default:
							adUnit = null;
					}
			}

			var renderedPost = [react_default.a.createElement(
				'li',
				{ key: 'post_' + post.id, id: 'post_container_' + post.id, className: 'post_container',
					onClick: function onClick() {
						return isSearch || isUserProfile ? _this.gotoPost(post.id) : true;
					} },
				react_default.a.createElement(posts_PostComponent, {
					isSearch: isSearch,
					isUserProfile: isUserProfile,
					postId: post.id,
					postNum: postNum,
					posts: posts,
					users: users,
					perms: ustate.perms,
					key: post.id,
					allowHtml: !!_this.props.threadview.allowhtml,
					threadTitle: _this.getThreadTitle(post.topic)
				})
			)];

			if (inThreadAd) {
				renderedPost.push(inThreadAd);
			}
			if (adUnit) {
				renderedPost.push(adUnit);
			}

			return renderedPost;
		};

		_this.buildPage = function (pageNum, pageSize) {
			var _this$props$threadvie3 = _this.props.threadview,
			    entities = _this$props$threadvie3.entities,
			    result = _this$props$threadvie3.result;


			var post = result.posts.filter(function (e) {
				return entities.posts[e] && entities.posts[e].page === pageNum;
			}),
			    postList = post.map(function (id, i) {
				return _this.buildPost(entities.posts[id], i, pageNum, pageSize);
			});

			return react_default.a.createElement(
				'ul',
				{ key: pageNum, className: 'scroll_page post_page page_' + pageNum },
				postList
			);
		};

		_this.pages = {};
		return _this;
	}

	PostListComponent__createClass(PostListComponent, [{
		key: 'componentDidMount',
		value: function componentDidMount() {
			this.props.dispatch(Object(MetaActions["c" /* resetSelectedItem */])());
			window.addEventListener('popstate', this._resetThread);
			window.addEventListener('popstate', this._resetGallery);
		}
	}, {
		key: 'componentWillUnmount',
		value: function componentWillUnmount() {
			window.removeEventListener('popstate', this._resetThread);
			window.removeEventListener('popstate', this._resetGallery);
			this.props.dispatch(Object(MetaActions["c" /* resetSelectedItem */])());
		}
	}, {
		key: 'shouldComponentUpdate',
		value: function shouldComponentUpdate(nextProps) {
			return !isEqual_default()(nextProps.meta.selectedElements, this.props.meta.selectedElements) || !isEqual_default()(nextProps.threadview, this.props.threadview) || !isEqual_default()(nextProps.pages, this.props.pages);
		}
	}, {
		key: 'gotoPost',
		value: function gotoPost(id) {
			this.props.dispatch(Object(react_router_redux_lib["push"])(Object(NavHelpers["k" /* pathToPost */])(id)));
		}
	}, {
		key: 'getThreadTitle',
		value: function getThreadTitle(topicId) {
			if (topicId && this.props.isUserProfile) {
				var topic = this.props.threadview.entities.topics[parseInt(topicId)];
				return topic.title;
			}
			return '';
		}
	}, {
		key: 'render',
		value: function render() {
			var _this2 = this;

			var pageSize = this.props.dispatch(Object(UserSettingsActions["d" /* getPageSize */])());
			var postsListPage = this.props.pages.map(function (pageNum) {
				return _this2.buildPage(pageNum, pageSize);
			});

			if (!this.props.threadview.loaded) {
				return react_default.a.createElement(LoaderCssComponent, { key: 'loader' });
			}

			return react_default.a.createElement(
				'div',
				{ ref: this.props.listRef, className: 'posts' },
				postsListPage,
				react_default.a.createElement(common_PhotoSwipe, null)
			);
		}
	}]);

	return PostListComponent;
}(react_default.a.Component);

PostListComponent_PostListComponent.propTypes = {
	threadview: prop_types_default.a.object.isRequired,
	dispatch: prop_types_default.a.func.isRequired,
	pages: prop_types_default.a.array.isRequired
};

PostListComponent_PostListComponent.defaultProps = {
	isSearch: false,
	isUserProfile: false
};

/* harmony default export */ var posts_PostListComponent = (Object(es["b" /* connect */])(threadViewSelector)(PostListComponent_PostListComponent));
// EXTERNAL MODULE: ./src/styles/polls.scss
var styles_polls = __webpack_require__(769);
var styles_polls_default = /*#__PURE__*/__webpack_require__.n(styles_polls);

// CONCATENATED MODULE: ./src/components/posts/PollDataComponent.js
var PollDataComponent__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function PollDataComponent__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function PollDataComponent__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function PollDataComponent__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }














var PollDataComponent_PollDataComponent = function (_React$Component) {
	PollDataComponent__inherits(PollDataComponent, _React$Component);

	function PollDataComponent(props) {
		PollDataComponent__classCallCheck(this, PollDataComponent);

		var _this = PollDataComponent__possibleConstructorReturn(this, (PollDataComponent.__proto__ || Object.getPrototypeOf(PollDataComponent)).call(this, props));

		_this.buildPollOption = function (pollChoice, multiVote) {
			// Parse bbCode allowing HTML
			var pollOptionText = RawToReact(pollChoice.text, _this.props, true);

			return react_default.a.createElement(
				'li',
				{ key: pollChoice.id },
				react_default.a.createElement(CheckboxComponent, {
					name: 'votes_' + pollChoice.poll,
					id: 'pollOpt_' + pollChoice.id,
					value: pollChoice.id,
					checked: _this.state.checkVote.indexOf(pollChoice.id) !== -1,
					multiple: multiVote,
					className: 'pollVote',
					label: pollOptionText,
					onChange: function onChange(e) {
						return _this.saveCheckedField(e);
					}
				})
			);
		};

		_this.buildPollResult = function (pollVote, pollOption, noShowResultsText, voteTotal) {
			var votes = noShowResultsText ? '-' : parseInt(pollVote.votes),
			    votePercent = voteTotal > 0 ? Math.round(parseInt(pollVote.votes) / voteTotal * 100) : 0;

			// Parse bbCode allowing HTML
			var pollOptionText = RawToReact(pollOption.text, _this.props, true);

			return react_default.a.createElement(
				'li',
				{ key: pollOption.id },
				react_default.a.createElement(
					'p',
					{ className: 'result' },
					pollOptionText
				),
				react_default.a.createElement(
					'div',
					{ className: 'result-bar' },
					react_default.a.createElement(
						'p',
						{ 'data-percent': votePercent, style: { width: votePercent + '%' } },
						react_default.a.createElement(
							'span',
							null,
							noShowResultsText ? '' : votePercent,
							'%'
						)
					),
					react_default.a.createElement(
						'span',
						{ className: 'votes-result' },
						votes,
						' votes'
					)
				)
			);
		};

		_this.countVotes = function (pollVote) {
			return parseInt(pollVote.votes);
		};

		_this.onPollOptionsClick = function () {
			var choices = document.getElementsByClassName("choices-poll");
			for (var i = 0; i < choices.length; i++) {
				choices[i].classList.remove('hide-poll');
			}
			var results = document.getElementsByClassName("results-poll");
			for (var _i = 0; _i < results.length; _i++) {
				results[_i].classList.add('hide-poll');
			}
		};

		_this.onSubmitVoteClick = function () {
			var voteValue = '',
			    pollID = _this.props.threadview.result.polls[0];
			if (_this.state.radioVote !== '') {
				voteValue = /[^-]+$/.exec(_this.state.radioVote);
			} else if (_this.state.checkVote !== '') {
				var i = void 0,
				    len = void 0;
				for (i = 0, len = _this.state.checkVote.length; i < len; i++) {
					if (voteValue === '') {
						voteValue = /[^-]+$/.exec(_this.state.checkVote[i]);
					} else {
						voteValue += ';' + /[^-]+$/.exec(_this.state.checkVote[i]);
					}
				}
			} else {
				Object(UiActions["B" /* displayNotification */])('error', 'Please select a poll option and submit again.', { force: true, timeout: 2000 });
				return false;
			}

			_this.props.dispatch(Object(ThreadviewActions["d" /* doPollVote */])({
				pollID: pollID,
				topic: _this.props.threadview.threadid,
				votes: voteValue
			}));
		};

		_this.onViewResultsClick = function () {
			var results = document.getElementsByClassName("results-poll");
			for (var i = 0; i < results.length; i++) {
				results[i].classList.remove('hide-poll');
			}
			var choices = document.getElementsByClassName("choices-poll");
			for (var _i2 = 0; _i2 < choices.length; _i2++) {
				choices[_i2].classList.add('hide-poll');
			}
		};

		_this.state = {
			radioVote: '',
			checkVote: []
		};
		return _this;
	}

	PollDataComponent__createClass(PollDataComponent, [{
		key: 'saveCheckedField',
		value: function saveCheckedField(event) {
			var fieldValue = event.target.checked ? event.target.value : false;

			if (event.target.type === 'checkbox') {
				// multiple
				var tempCheckVote = this.state.checkVote,
				    currentPos = this.state.checkVote.indexOf(event.target.value);

				if (!fieldValue && currentPos >= 0) {
					// deselecting exiting value
					tempCheckVote.splice(currentPos, 1);
				} else if (fieldValue && currentPos < 0) {
					// selecting non existing value
					tempCheckVote.push(fieldValue);
				}
				this.setState({ checkVote: tempCheckVote });
			} else {
				this.setState({ radioVote: fieldValue });
			}
		}
	}, {
		key: 'render',
		value: function render() {
			var _this2 = this;

			var _props$threadview = this.props.threadview,
			    _props$threadview$ent = _props$threadview.entities,
			    pollOptions = _props$threadview$ent.pollOptions,
			    polls = _props$threadview$ent.polls,
			    pollVotes = _props$threadview$ent.pollVotes,
			    result = _props$threadview.result;

			if (result.polls.length === 0) {
				return null;
			}

			var pollID = result.polls[0];
			var showPoll = !polls[pollID].closed && polls[pollID].uservote === '',
			    closedPoll = polls[pollID].closed ? react_default.a.createElement(
				'li',
				{ className: 'result-poll poll-option' },
				react_default.a.createElement(
					'p',
					null,
					'Poll is Closed'
				)
			) : null,
			    votedPoll = polls[pollID].uservote !== '' && !polls[pollID].closed ? react_default.a.createElement(
				'li',
				{ className: 'result-poll poll-option' },
				react_default.a.createElement(
					'p',
					null,
					'You Voted'
				)
			) : null,
			    gobackPoll = !polls[pollID].closed && polls[pollID].uservote === '' ? react_default.a.createElement(
				'li',
				{ className: 'result-poll poll-option' },
				react_default.a.createElement(
					'p',
					{ className: 'viewOptions', 'data-type': 'typePoll', onClick: this.onPollOptionsClick },
					'Return to Poll Options'
				)
			) : null,
			    reviewPoll = polls[pollID].showresults ? react_default.a.createElement(
				'p',
				{ className: 'viewResults', 'data-type': 'typePoll', onClick: this.onViewResultsClick },
				'View Poll Results'
			) : null,
			    hideResults = showPoll ? 'hide-poll' : '',
			    hideChoices = !showPoll ? 'hide-poll' : '';

			var question = '',
			    noShowResultsText = null;
			if (polls) {
				question = polls[result.polls[0]].question;
				if (polls[result.polls[0]].noshowresultstext !== '') {
					noShowResultsText = polls[result.polls[0]].noshowresultstext;
				}
			}

			var multiVote = polls[pollID].multiple === '1';
			var voteCount = result.pollVotes ? result.pollVotes.map(function (k, i) {
				return _this2.countVotes(pollVotes[k]);
			}) : react_default.a.createElement('span', null);
			var voteTotal = voteCount.reduce(function (a, b) {
				return a + b;
			}, 0);
			var pollChoices = result.pollOptions ? result.pollOptions.map(function (k, i) {
				return _this2.buildPollOption(pollOptions[k], multiVote);
			}) : react_default.a.createElement('span', null);
			var pollResults = result.pollVotes ? result.pollVotes.map(function (k, i) {
				return _this2.buildPollResult(pollVotes[k], pollOptions[k], noShowResultsText, voteTotal);
			}) : react_default.a.createElement('span', null);

			return react_default.a.createElement(
				'div',
				{ className: 'pollContainer' },
				react_default.a.createElement(
					'ul',
					{ className: 'cards' },
					react_default.a.createElement(
						'li',
						{ className: 'title' },
						react_default.a.createElement(
							'h6',
							null,
							'POLL: ',
							question
						),
						react_default.a.createElement(
							'span',
							{ className: 'note' },
							noShowResultsText
						)
					),
					react_default.a.createElement(
						'li',
						{ className: 'topic-card sticky taking-poll choices-poll ' + hideChoices },
						react_default.a.createElement(
							'ul',
							null,
							pollChoices
						)
					),
					react_default.a.createElement(
						'li',
						{ className: 'topic-card sticky result-poll results-poll ' + hideResults },
						react_default.a.createElement(
							'ul',
							null,
							pollResults
						)
					)
				),
				react_default.a.createElement(
					'ul',
					{ className: 'cards choices-poll ' + hideChoices },
					react_default.a.createElement(
						'li',
						{ className: 'card-actions taking-poll poll-option' },
						react_default.a.createElement('input', { type: 'button', value: 'Submit your vote', className: 'poll-submit', id: 'submit_poll_vote', 'data-type': 'typePoll', onClick: this.onSubmitVoteClick }),
						reviewPoll
					)
				),
				react_default.a.createElement(
					'ul',
					{ className: 'cards results-poll ' + hideResults },
					closedPoll,
					votedPoll,
					gobackPoll
				)
			);
		}
	}]);

	return PollDataComponent;
}(react_default.a.Component);

PollDataComponent_PollDataComponent.propTypes = {
	dispatch: prop_types_default.a.func.isRequired,
	threadview: prop_types_default.a.object.isRequired
};

/* harmony default export */ var posts_PollDataComponent = (Object(es["b" /* connect */])(threadViewSelector)(PollDataComponent_PollDataComponent));
// CONCATENATED MODULE: ./src/components/ThreadViewComponent.js
var ThreadViewComponent__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function ThreadViewComponent__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function ThreadViewComponent__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function ThreadViewComponent__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






















var ThreadViewComponent_ThreadViewComponent = function (_React$Component) {
	ThreadViewComponent__inherits(ThreadViewComponent, _React$Component);

	function ThreadViewComponent(props) {
		ThreadViewComponent__classCallCheck(this, ThreadViewComponent);

		var _this = ThreadViewComponent__possibleConstructorReturn(this, (ThreadViewComponent.__proto__ || Object.getPrototypeOf(ThreadViewComponent)).call(this, props));

		_this.loadPage = function (page, forceRefresh) {
			_this.props.dispatch(Object(ThreadviewActions["e" /* fetchThread */])({
				id: parseInt(_this.props.routeParams.threadId),
				page: page,
				forceRefresh: forceRefresh
			}));
		};

		_this.state = {
			loadRevContent: false,
			loadTaboola: false,
			loadTaboolaWidget: false
		};
		return _this;
	}

	ThreadViewComponent__createClass(ThreadViewComponent, [{
		key: 'componentDidMount',
		value: function componentDidMount() {
			var page = this.props.location.query.page,
			    post = this.props.location.query.postid;

			this.props.dispatch(Object(PhotoGalleryActions["h" /* resetGallery */])());
			this.props.dispatch(Object(ThreadviewActions["h" /* resetThread */])());
			this.props.dispatch(Object(InfiniteScrollActions["f" /* resetInfinite */])());

			this.props.dispatch(Object(ThreadviewActions["e" /* fetchThread */])({
				id: parseInt(this.props.routeParams.threadId),
				page: page ? parseInt(page) : null,
				postid: post ? parseInt(post) : null
			}));

			// Checking ad Permissions
			if (this.props.forumId) {
				this.props.dispatch(Object(adsActions["l" /* checkAdsPermissions */])(this.props.forumId));
				this.props.dispatch(Object(adsActions["w" /* resetHiddenAdsPerUser */])());
			}

			this.props.dispatch(Object(adsActions["t" /* preLoadTaboola */])());
		}
	}, {
		key: 'componentWillUnmount',
		value: function componentWillUnmount() {
			this.props.dispatch(Object(PhotoGalleryActions["h" /* resetGallery */])());
			this.props.dispatch(Object(ThreadviewActions["h" /* resetThread */])());
			this.props.dispatch(Object(InfiniteScrollActions["f" /* resetInfinite */])());
		}
	}, {
		key: 'componentDidUpdate',
		value: function componentDidUpdate(prevProps, prevState) {
			if (this.props.threadview.isFetching === false) {
				if (prevState.loadTaboola === false && this.state.loadTaboola === true) {
					Object(adsActions["v" /* refreshTaboola */])('taboola');
				}
				if (prevState.loadRevContent === false && this.state.loadRevContent === true) {
					this.props.dispatch(Object(adsActions["u" /* refreshRevContent */])());
				}
				if (prevState.loadTaboolaWidget === false && this.state.loadTaboolaWidget === true) {
					Object(adsActions["v" /* refreshTaboola */])('recirculation');
				}

				var postContainer = null;
				if (this.props.location.query.postid) {
					var postid = this.props.location.query.postid;
					postContainer = document.getElementById('post_container_' + postid);

					if (postid && postContainer) {
						var postPage = postContainer.parentNode.className.match(/page_(\d+)/),
						    page = postPage && postPage.length > 0 ? parseInt(postPage[1]) : this.props.meta.page;

						// rewriting the url to the correct one
						var pathname = '/topics/' + this.props.meta.threadid,
						    query = Object.assign({}, this.props.location.query);

						query.page = page;

						// keep postid in query until we are on the thread
						if (parseInt(this.props.params.threadId) === parseInt(this.props.meta.threadid)) {
							delete query.postid;
							delete query.s;
						} else {
							query.postid = postid;
							query.s = 1;
						}

						this.props.dispatch(Object(react_router_redux_lib["replace"])({
							pathname: pathname,
							query: query
						}));

						// scrolling to the post
						window.scrollTo(0, postContainer.offsetTop - 15);
					}
				} else if (!this.props.location.query.page || parseInt(this.props.location.query.page) === 0) {
					if (this.props.threadview.postid) {
						postContainer = document.getElementById('post_container_' + this.props.threadview.postid);
						if (postContainer) {
							// scrolling to the post
							window.scrollTo(0, postContainer.offsetTop - 15);
						}
					} else {
						window.scrollTo(0, window.scrollY + 5);
					}
				}
			}
		}
	}, {
		key: 'shouldComponentUpdate',
		value: function shouldComponentUpdate(nextProps, nextState) {
			return nextProps.threadview.loaded !== this.props.threadview.loaded || nextProps.threadview.isFetching !== this.props.threadview.isFetching || nextProps.threadview.result.posts.length !== this.props.threadview.result.posts.length || nextProps.threadview.threadid !== this.props.threadview.threadid || nextState.loadRevContent !== this.state.loadRevContent || nextState.loadTaboola !== this.state.loadTaboola || nextState.loadTaboolaWidget !== this.state.loadTaboolaWidget || nextProps.location.query !== this.props.location.query;
		}
	}, {
		key: 'componentWillReceiveProps',
		value: function componentWillReceiveProps(nextProps) {
			if (this.props.routeParams.threadId !== nextProps.routeParams.threadId || this.props.location.query.postid !== nextProps.location.query.postid) {
				var page = parseInt(nextProps.location.query.page),
				    post = nextProps.location.query.postid;

				// only refresh if we are not already in the thread and page we want
				var oldThreadId = this.props.threadview.threadid,
				    newThreadid = nextProps.threadview.threadid,
				    oldPage = parseInt(this.props.threadview.page);

				if (oldThreadId !== newThreadid || nextProps.location.query.postid && nextProps.location.query.s === undefined) {
					this.props.dispatch(Object(PhotoGalleryActions["h" /* resetGallery */])());
					this.props.dispatch(Object(InfiniteScrollActions["f" /* resetInfinite */])());
					this.props.dispatch(Object(ThreadviewActions["h" /* resetThread */])());
				}

				if (!(oldThreadId === newThreadid && oldPage === page)) {
					this.props.dispatch(Object(ThreadviewActions["e" /* fetchThread */])({
						id: nextProps.routeParams.threadId,
						page: page ? parseInt(page) : null,
						postid: post ? parseInt(post) : null
					}));
				}
			} else {
				if (nextProps.threadview.isFetching === false && nextProps.currentPage && nextProps.totalPages) {
					this.setState({
						loadTaboola: nextProps.forumSite.f_taboola && !nextProps.forumSite.f_revcontent && nextProps.currentPage === nextProps.totalPages,
						loadRevContent: nextProps.forumSite.f_revcontent && nextProps.currentPage === nextProps.totalPages,
						loadTaboolaWidget: parseInt(nextProps.currentPage) === 1
					});
				}
			}

			if (nextProps.forumId !== this.props.forumId) {
				this.props.dispatch(Object(adsActions["l" /* checkAdsPermissions */])(nextProps.forumId));
			}
			if (nextProps.threadview.threadid !== this.props.threadview.threadid) {
				this.props.dispatch(Object(adsActions["w" /* resetHiddenAdsPerUser */])());
			}
			if (nextProps.threadview.loaded && nextProps.threadview.loaded !== this.props.threadview.loaded) {
				// trigger ad updates
				this.props.dispatch(Object(adsActions["s" /* onPageView */])({ captify: "" }));
				// Record the Google Analytics pageview
				this.props.dispatch(Object(adsActions["B" /* trackPageView */])());
			}
		}
	}, {
		key: 'render',
		value: function render() {
			var _this2 = this;

			var _props$threadview = this.props.threadview,
			    threadid = _props$threadview.threadid,
			    loaded = _props$threadview.loaded,
			    isFetching = _props$threadview.isFetching,
			    topics = _props$threadview.entities.topics,
			    posts = _props$threadview.result.posts;


			if (!loaded) {
				return react_default.a.createElement(LoaderCssComponent, null);
			}

			var campaignAd = react_default.a.createElement(ads_AdComponent, { adType: '505', adName: 'Campaign_Top_Ad' }),
			    bottomAdUnit = react_default.a.createElement(ads_AdComponent, { key: 'thread_BottomAd', adType: '2', adName: 'Bottom_Content_Rectangle', isFetching: isFetching }),
			    taboolaAd = posts.length > 0 && this.state.loadTaboola ? react_default.a.createElement(ads_inThreadAdComponent, { adContainerId: 'taboola-mobile-below-article-thumbnails', className: 'taboola-placeholder ad-card' }) : null,
			    revContent = posts.length > 0 && this.state.loadRevContent ? react_default.a.createElement(ads_inThreadAdComponent, { adContainerId: 'rcjsload_vs1vs1', className: 'ad-card' }) : null;

			var topNote = isFetching === false && (topics[threadid].isDeleted || !topics[threadid].isOpen) ? react_default.a.createElement(
				'div',
				{ className: 'topic-alert' },
				'This topic is ',
				topics[threadid].isDeleted ? 'deleted' : !topics[threadid].isOpen ? 'closed' : ''
			) : '';

			return react_default.a.createElement(
				'div',
				null,
				react_default.a.createElement(common_BreadcrumbComponent, { routeParams: this.props.routeParams }),
				topNote,
				campaignAd,
				react_default.a.createElement(posts_PollDataComponent, null),
				react_default.a.createElement(
					infiniteScroll_InfiniteScrollComponent,
					{
						scrollRef: function scrollRef(i) {
							return _this2.infiniteScroll = i;
						},
						isFetching: isFetching,
						loadPage: this.loadPage,
						location: this.props.location },
					react_default.a.createElement(posts_PostListComponent, null)
				),
				taboolaAd,
				revContent,
				bottomAdUnit
			);
		}
	}]);

	return ThreadViewComponent;
}(react_default.a.Component);

/* harmony default export */ var components_ThreadViewComponent = (Object(es["b" /* connect */])(threadViewSelector)(ThreadViewComponent_ThreadViewComponent));
// EXTERNAL MODULE: ./src/styles/searchview.scss
var searchview = __webpack_require__(770);
var searchview_default = /*#__PURE__*/__webpack_require__.n(searchview);

// CONCATENATED MODULE: ./src/selectors/searchResultSelector.js



var searchResultSelector = function searchResultSelector(state) {
	return state.searchresult;
};

/* harmony default export */ var selectors_searchResultSelector = (Object(lib["createSelector"])([searchResultSelector, selectors_metaSelector], function (searchresult, meta) {
	return {
		searchresult: searchresult,
		meta: meta
	};
}));
// EXTERNAL MODULE: ./src/actions/SearchResultActions.js
var SearchResultActions = __webpack_require__(104);

// CONCATENATED MODULE: ./src/components/SearchViewComponent.js
var SearchViewComponent__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function SearchViewComponent__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function SearchViewComponent__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function SearchViewComponent__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }


























var SearchViewComponent_SearchViewComponent = function (_React$Component) {
	SearchViewComponent__inherits(SearchViewComponent, _React$Component);

	function SearchViewComponent(props) {
		SearchViewComponent__classCallCheck(this, SearchViewComponent);

		var _this = SearchViewComponent__possibleConstructorReturn(this, (SearchViewComponent.__proto__ || Object.getPrototypeOf(SearchViewComponent)).call(this, props));

		SearchViewComponent__initialiseProps.call(_this);

		_this.redirect = false;

		_this.state = {
			headerHeight: 0
		};
		return _this;
	}

	SearchViewComponent__createClass(SearchViewComponent, [{
		key: 'componentWillMount',
		value: function componentWillMount() {
			this.props.dispatch(Object(adsActions["l" /* checkAdsPermissions */])(0));
			this.props.dispatch(Object(adsActions["w" /* resetHiddenAdsPerUser */])());
		}
	}, {
		key: 'componentDidMount',
		value: function componentDidMount() {
			window.scrollTo(0, 0);
			this.repositionScroll();
			this._resetStore();
			this.dispatchSearch(this.props);
		}
	}, {
		key: 'componentWillUnmount',
		value: function componentWillUnmount() {
			this._resetStore();
		}
	}, {
		key: 'componentWillReceiveProps',
		value: function componentWillReceiveProps(nextProps) {
			if (nextProps.location.query.refresh || nextProps.location.query.q !== this.props.location.query.q || nextProps.location.query.showtopics !== this.props.location.query.showtopics || nextProps.location.query.showposts !== this.props.location.query.showposts || nextProps.location.query.forumid !== this.props.location.query.forumid || nextProps.route.path !== this.props.route.path && this.redirect === false) {
				this._resetStore();

				window.scrollTo(0, 0);
				nextProps.location.query.page = 1;

				// if we are refreshing (searching again the same term) clear the url
				if (nextProps.location.query.refresh) {
					var query = nextProps.location.query;
					delete query.refresh;
					this.props.dispatch(Object(react_router_redux_lib["replace"])({
						pathname: nextProps.location.pathname,
						query: query
					}));
				}

				this.dispatchSearch(nextProps);
				this.repositionScroll();
			} else if (nextProps.route.path !== this.props.route.path && this.redirect) {
				this.redirect = false;
			}

			if (nextProps.searchresult.isFetching === false && this.props.searchresult.isFetching && nextProps.searchresult.loaded && nextProps.searchresult.loaded !== this.props.searchresult.loaded) {
				// trigger ad updates
				this.props.dispatch(Object(adsActions["s" /* onPageView */])());
				// Record the Google Analytics pageview
				this.props.dispatch(Object(adsActions["B" /* trackPageView */])());
			}
		}
	}, {
		key: 'componentDidUpdate',
		value: function componentDidUpdate(prevProps) {
			if (prevProps.searchresult.isFetching && this.props.searchresult.isFetching === false && this.props.searchresult.loaded) {
				// Update the URL if we need to
				if (this.props.searchresult.query.action === 'updated' && this.props.route.path !== 'updated') {
					this.redirect = true;
					this.props.dispatch(Object(react_router_redux_lib["replace"])({ pathname: Object(NavHelpers["h" /* pathToNewPosts */])() }));
				} else if (this.props.searchresult.query.action === 'latest' && this.props.route.path !== 'latest') {
					this.redirect = true;
					this.props.dispatch(Object(react_router_redux_lib["replace"])({ pathname: Object(NavHelpers["b" /* pathToActiveTopics */])() }));
				} else if (this.props.searchresult.query.action === 'participated' && this.props.route.path !== 'participated') {
					this.redirect = true;
					this.props.dispatch(Object(react_router_redux_lib["replace"])({ pathname: Object(NavHelpers["j" /* pathToParticipated */])() }));
				} else if ((!this.props.searchresult.query.action || this.props.searchresult.query.action === 'search') && (parseInt(this.props.routeParams.searchId) !== parseInt(this.props.searchresult.searchId) || this.props.location.query.q !== this.props.searchresult.query.searchQuery || parseInt(this.props.location.query.showposts) !== parseInt(this.props.searchresult.query.showposts) || parseInt(this.props.location.query.forumid) !== parseInt(this.props.searchresult.query.forumId))) {
					var query = {
						q: this.props.searchresult.query.searchQuery,
						showposts: this.props.searchresult.query.showposts
					};
					if (this.props.searchresult.query.forumId !== null) {
						query.forumid = this.props.searchresult.query.forumId;
					}
					if (this.props.location.query.page) {
						query.page = this.props.location.query.page;
					}

					this.redirect = true;

					this.props.dispatch(Object(react_router_redux_lib["replace"])({
						pathname: Object(NavHelpers["n" /* pathToSearch */])(this.props.searchresult.searchId),
						query: query
					}));
				}

				this.repositionScroll();

				// Stuff to trigger once per search, not on every page
				if (this.props.searchresult.query.action === 'search' && this.props.searchresult.query.searchQuery && parseInt(prevProps.searchresult.searchId) !== parseInt(this.props.searchresult.searchId)) {
					// Captify needs to be triggered once per search
					Object(adsActions["C" /* triggerCaptify */])(this.props.searchresult.query.searchQuery);

					// Record the Google Analytics event per search
					var isForumSearch = this.props.searchresult.query.forumid ? 1 : 0;
					this.props.dispatch(Object(adsActions["A" /* trackGAEvent */])(false, 'search', 'userAction', 'consumption', isForumSearch));
				}
			}
		}
	}, {
		key: '_resetStore',
		value: function _resetStore() {
			this.props.dispatch(Object(ForumviewActions["f" /* resetForum */])());
			this.props.dispatch(Object(ThreadviewActions["h" /* resetThread */])());
			this.props.dispatch(Object(SearchResultActions["d" /* resetSearch */])());
			this.props.dispatch(Object(InfiniteScrollActions["f" /* resetInfinite */])());
		}
	}, {
		key: 'toggleSubscribeType',
		value: function toggleSubscribeType(subType) {
			var query = this.props.location.query,
			    pathname = this.props.location.pathname;

			query.showtopics = parseInt(subType);
			query.page = 1;

			this.props.dispatch(Object(react_router_redux_lib["replace"])({
				pathname: pathname,
				query: query
			}));
		}
	}, {
		key: 'resultsHeader',
		value: function resultsHeader() {
			var _this2 = this;

			return react_default.a.createElement(
				'header',
				{ className: 'thread', ref: function ref(h) {
						return _this2.header = h;
					} },
				this._createHeaderContent()
			);
		}
	}, {
		key: '_createHeaderContent',
		value: function _createHeaderContent() {
			var _props$searchresult = this.props.searchresult,
			    loaded = _props$searchresult.loaded,
			    isFetching = _props$searchresult.isFetching,
			    result = _props$searchresult.result;


			if (loaded && !isFetching && result.posts.length <= 0 && result.topics.length <= 0 && result.forums.length <= 0) {
				switch (this.props.searchresult.query.action) {
					case 'latest':
						return react_default.a.createElement(
							'div',
							{ className: 'details' },
							'There are no recently active topics.'
						);
					case 'updated':
						// updated
						return react_default.a.createElement(
							'div',
							{ className: 'details' },
							'There are no new posts.'
						);
					case 'fav':
						// following and/or subscribed and/or favorite
						return [this.subHeaderSelector(), react_default.a.createElement(
							'div',
							{ key: 'details', className: 'details' },
							'You are not subscribed to any ',
							parseInt(this.props.searchresult.query.showtopics) === 1 ? 'topics' : 'forums'
						)];
					default:
						return [react_default.a.createElement(
							'div',
							{ key: 'details', className: 'commonWords' },
							'There are no results for ',
							react_default.a.createElement(
								'span',
								{ className: 'query' },
								this.props.location.query.q
							)
						), this.commonWords()];
				}
			}

			switch (this.props.route.path) {
				case 'following':
					return this.subHeaderSelector();

				case 'latest':
				case 'participated':
				case 'updated':
					return null;
			}

			return react_default.a.createElement(
				'div',
				{ className: 'details' },
				'Search results for: ',
				react_default.a.createElement(
					'span',
					{ className: 'query' },
					this.props.location.query.q
				)
			);
		}
	}, {
		key: 'subHeaderSelector',
		value: function subHeaderSelector() {
			var _this3 = this;

			var showTopic = parseInt(this.props.location.query.showtopics || this.props.searchresult.query.showtopics);
			return react_default.a.createElement(
				'div',
				{ key: 'subHeaderSelector', className: 'subheader-selector' },
				react_default.a.createElement(
					'div',
					{ className: showTopic === 1 ? 'active' : 'inactive', onClick: function onClick() {
							return _this3.toggleSubscribeType(1);
						} },
					'Topics'
				),
				react_default.a.createElement(
					'div',
					{ className: showTopic === 0 ? 'active' : 'inactive', onClick: function onClick() {
							return _this3.toggleSubscribeType(0);
						} },
					'Forums'
				)
			);
		}
	}, {
		key: 'commonWords',
		value: function commonWords() {
			return this.props.searchresult.commonwords && this.props.searchresult.commonwords.length > 0 ? react_default.a.createElement(
				'div',
				{ key: 'commonWords', className: 'commonWords' },
				'The following words were omitted from the search because they are too common or too short: ',
				react_default.a.createElement(
					'span',
					{ className: 'query' },
					this.props.searchresult.commonwords.join(',')
				)
			) : null;
		}
	}, {
		key: 'searchResults',
		value: function searchResults() {
			var showLast = this.props.searchresult && (this.props.searchresult.query.action === 'latest' || this.props.searchresult.query.action === 'updated' || this.props.searchresult.query.action === 'fav');

			if (parseInt(this.props.searchresult.query.showposts) === 1 && this.props.searchresult.result.posts.length > 0) {
				return react_default.a.createElement(posts_PostListComponent, { threadview: this.props.searchresult, isSearch: true });
			} else if (this.props.searchresult.query.action === 'fav') {
				if (parseInt(this.props.searchresult.query.showtopics) === 1 && this.props.searchresult.result.topics.length > 0) {
					return react_default.a.createElement(threads_ThreadListComponent, { showLast: showLast });
				} else if (this.props.searchresult.result.forums.length > 0) {
					return react_default.a.createElement(forums_ForumListComponent, { isScrolled: true });
				} else {
					return null;
				}
			} else if ((this.props.searchresult && this.props.searchresult.query.action === 'latest' || this.props.searchresult && this.props.searchresult.query.action === 'updated' || this.props.searchresult && this.props.searchresult.query.action === 'participated' || this.props.searchresult && this.props.searchresult.query.showposts === 0 || parseInt(this.props.location.query.showposts) === 0) && this.props.searchresult.result.topics.length > 0) {
				return react_default.a.createElement(threads_ThreadListComponent, { isSearch: parseInt(this.props.location.query.showposts) === 0, showLast: showLast });
			} else {
				return null;
			}
		}
	}, {
		key: 'getAdUnit',
		value: function getAdUnit() {
			var showPosts = this.props.location.query.showposts ? parseInt(this.props.location.query.showposts) : 0;
			if (this.props.location.query.q && this.props.searchresult.query.action === 'search' && (showPosts === 1 && this.props.searchresult.result.posts.length > 0 || showPosts === 0 && this.props.searchresult.result.topics.length > 0)) {
				var searchProp = {
					isTop: true,
					page: 1,
					searchQuery: this.props.location.query.q
				};

				return react_default.a.createElement(ads_AdComponent, { key: 'In_Search_Ad_Top', adType: '0', adName: 'In_Search_Ad_Top', search: searchProp });
			}

			return null;
		}
	}, {
		key: 'render',
		value: function render() {
			var _this4 = this;

			var _props$searchresult2 = this.props.searchresult,
			    isFetching = _props$searchresult2.isFetching,
			    loaded = _props$searchresult2.loaded;


			if (!loaded) {
				return react_default.a.createElement(
					'div',
					{ className: 'search' },
					this.resultsHeader(),
					react_default.a.createElement(LoaderCssComponent, { style: { marginTop: this.state.headerHeight + 'px' } })
				);
			}

			return react_default.a.createElement(
				'div',
				{ className: 'search' },
				this.resultsHeader(),
				react_default.a.createElement(
					infiniteScroll_InfiniteScrollComponent,
					{
						scrollRef: function scrollRef(i) {
							return _this4.infiniteScroll = i;
						},
						isFetching: isFetching,
						loadPage: this.loadPage,
						location: this.props.location,
						extraHeaderHeight: this.state.headerHeight
					},
					this.getAdUnit(),
					this.searchResults()
				)
			);
		}
	}]);

	return SearchViewComponent;
}(react_default.a.Component);

var SearchViewComponent__initialiseProps = function _initialiseProps() {
	var _this5 = this;

	this.prepareSearchRequest = function (props) {
		var id = 'search',
		    page = props.location.query.page || 1,
		    showposts = 0,
		    showtopics = null;

		switch (props.route.path) {
			case 'latest':
				id = 'new';
				break;

			case 'following':
				id = 'fav';
				showtopics = props.location.query.showtopics || 1;
				break;

			case 'participated':
				id = 'part';
				break;

			case 'updated':
				id = 'unread';
				break;

			default:
				showposts = props.location.query.showposts || 0;
				break;
		}

		var searchRequest = {
			id: id,
			showtopics: showtopics,
			showposts: showposts,
			page: page
		};

		if (id === 'search') {
			searchRequest.searchQuery = props.location.query.q;
			searchRequest.forumId = props.location.query.forumid || null;
			searchRequest.searchId = props.routeParams.searchId;
		}

		return searchRequest;
	};

	this.dispatchSearch = function (props) {
		var searchRequest = _this5.prepareSearchRequest(props);
		_this5.props.dispatch(Object(SearchResultActions["c" /* fetchSearch */])(searchRequest));
	};

	this.loadPage = function (page, forceRefresh) {
		var searchRequest = _this5.prepareSearchRequest(_this5.props);
		searchRequest.page = page;
		searchRequest.forceRefresh = forceRefresh;

		_this5.props.dispatch(Object(SearchResultActions["c" /* fetchSearch */])(searchRequest));
	};

	this.repositionScroll = function () {
		if (_this5.header) {
			var headerDim = _this5.header.getBoundingClientRect();

			if (!isNaN(headerDim.height) && headerDim.height !== _this5.state.headerHeight) {
				_this5.setState({ headerHeight: headerDim.height });
			}
		} else {
			_this5.setState({ headerHeight: 0 });
		}
	};
};

/* harmony default export */ var components_SearchViewComponent = (Object(es["b" /* connect */])(selectors_searchResultSelector)(SearchViewComponent_SearchViewComponent));
// EXTERNAL MODULE: ./src/styles/userprofile.scss
var userprofile = __webpack_require__(771);
var userprofile_default = /*#__PURE__*/__webpack_require__.n(userprofile);

// CONCATENATED MODULE: ./src/selectors/ustateSelector.js


var ustateSelector_userStateSelector = function userStateSelector(state) {
	return state.ustate;
};

/* harmony default export */ var ustateSelector = (Object(lib["createSelector"])(ustateSelector_userStateSelector, function (ustate) {
	return {
		ustate: ustate
	};
}));
// CONCATENATED MODULE: ./src/selectors/userprofileResultSelector.js




var userprofileResultSelector = function userprofileResultSelector(state) {
	return state.userprofileview;
};

/* harmony default export */ var selectors_userprofileResultSelector = (Object(lib["createSelector"])([userprofileResultSelector, selectors_metaSelector, ustateSelector], function (userprofile, meta, ustate) {
	return {
		userprofileview: userprofile,
		meta: meta,
		ustate: ustate.ustate
	};
}));
// EXTERNAL MODULE: ./src/actions/UserprofileActions.js
var UserprofileActions = __webpack_require__(87);

// CONCATENATED MODULE: ./src/components/UserprofileViewComponent.js
var UserprofileViewComponent__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function UserprofileViewComponent__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function UserprofileViewComponent__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function UserprofileViewComponent__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




























var UserprofileViewComponent_UserProfileViewComponent = function (_React$Component) {
	UserprofileViewComponent__inherits(UserProfileViewComponent, _React$Component);

	function UserProfileViewComponent(props) {
		UserprofileViewComponent__classCallCheck(this, UserProfileViewComponent);

		var _this = UserprofileViewComponent__possibleConstructorReturn(this, (UserProfileViewComponent.__proto__ || Object.getPrototypeOf(UserProfileViewComponent)).call(this, props));

		_this.repositionScroll = function () {
			if (_this.header) {
				var headerDim = _this.header.getBoundingClientRect();

				if (headerDim.height && headerDim.height !== _this.state.headerHeight) {
					_this.setState({ headerHeight: headerDim.height });
				}
			}
		};

		_this.loadPage = function (page, forceRefresh) {
			_this.props.dispatch(Object(UserprofileActions["e" /* fetchUserProfile */])({
				id: _this.props.routeParams.userid,
				page: page,
				forceRefresh: forceRefresh
			}));
		};

		_this.redirect = false;
		_this.state = {
			headerHeight: 0
		};
		return _this;
	}

	UserprofileViewComponent__createClass(UserProfileViewComponent, [{
		key: 'dispatchFetchUserProfile',
		value: function dispatchFetchUserProfile(props) {
			var page = props.location.query.page || 1,
			    userid = props.routeParams.userid;

			if (userid) {
				this.props.dispatch(Object(UserprofileActions["e" /* fetchUserProfile */])({
					id: userid,
					page: parseInt(page)
				}));
			}
		}
	}, {
		key: 'componentWillMount',
		value: function componentWillMount() {
			this.props.dispatch(Object(adsActions["l" /* checkAdsPermissions */])(0));
			this.props.dispatch(Object(adsActions["w" /* resetHiddenAdsPerUser */])());
			this.props.dispatch(Object(UserprofileActions["f" /* resetUserProfile */])());
			this.props.dispatch(Object(InfiniteScrollActions["f" /* resetInfinite */])());
			this.props.dispatch(Object(ForumviewActions["f" /* resetForum */])());
			this.props.dispatch(Object(ThreadviewActions["h" /* resetThread */])());
		}
	}, {
		key: 'componentDidUpdate',
		value: function componentDidUpdate() {
			if (this.props.userprofileview.isFetching === false && this.props.userprofileview.firstLoad) {
				// If can get user's name as id, we need the real userID in the URL
				if (this.props.userprofileview.user.id && parseInt(this.props.userprofileview.user.id) !== parseInt(this.props.routeParams.userid)) {

					this.redirect = true;

					this.props.dispatch(Object(react_router_redux_lib["replace"])({
						pathname: Object(NavHelpers["r" /* pathToUserProfile */])(this.props.userprofileview.user.id),
						query: this.props.location.query.page || 1
					}));
				}

				this.repositionScroll();
			}
		}
	}, {
		key: 'componentDidMount',
		value: function componentDidMount() {
			window.scrollTo(0, 0);
			this.dispatchFetchUserProfile(this.props);
			this.repositionScroll();
		}
	}, {
		key: 'componentWillUnmount',
		value: function componentWillUnmount() {
			this.props.dispatch(Object(UserprofileActions["f" /* resetUserProfile */])());
			this.props.dispatch(Object(ForumviewActions["f" /* resetForum */])());
			this.props.dispatch(Object(ThreadviewActions["h" /* resetThread */])());
			this.props.dispatch(Object(InfiniteScrollActions["f" /* resetInfinite */])());
		}
	}, {
		key: 'componentWillReceiveProps',
		value: function componentWillReceiveProps(nextProps) {
			if (this.props.routeParams.userid !== nextProps.routeParams.userid) {
				if (this.redirect === false) {
					this.props.dispatch(Object(UserprofileActions["f" /* resetUserProfile */])());
					this.props.dispatch(Object(InfiniteScrollActions["f" /* resetInfinite */])());
					this.props.dispatch(Object(ForumviewActions["f" /* resetForum */])());
					this.props.dispatch(Object(ThreadviewActions["h" /* resetThread */])());

					this.dispatchFetchUserProfile(nextProps);
					this.repositionScroll();
				} else {
					this.redirect = false;
				}
			}

			if (nextProps.userprofileview.loaded && nextProps.userprofileview.loaded !== this.props.userprofileview.loaded) {
				// trigger ad updates
				this.props.dispatch(Object(adsActions["s" /* onPageView */])());
				// Record the Google Analytics pageview
				this.props.dispatch(Object(adsActions["B" /* trackPageView */])());
			}
		}
	}, {
		key: 'userProfileHeader',
		value: function userProfileHeader() {
			var _this2 = this;

			var _props$userprofilevie = this.props.userprofileview,
			    user = _props$userprofilevie.user,
			    loaded = _props$userprofilevie.loaded;


			var stats = !loaded || !this.props.userprofileview.user.id ? null : react_default.a.createElement(
				'ul',
				{ className: 'stats' },
				react_default.a.createElement(
					'li',
					null,
					react_default.a.createElement(
						'span',
						null,
						'Joined Forum'
					),
					' ',
					react_default.a.createElement(common_dateComponent, { timestamp: user.joinDate })
				),
				react_default.a.createElement(
					'li',
					null,
					react_default.a.createElement(
						'span',
						null,
						'Total Posts'
					),
					' ',
					react_default.a.createElement(
						'span',
						null,
						user.postsCount
					)
				),
				react_default.a.createElement(
					'li',
					null,
					react_default.a.createElement(
						'span',
						null,
						'Topics Started'
					),
					' ',
					react_default.a.createElement(
						'span',
						null,
						user.topicsCount
					)
				)
			),
			    location = user.location ? react_default.a.createElement(
				'div',
				{ className: 'userLocation' },
				'Location: ',
				user.location
			) : null;

			return react_default.a.createElement(
				'header',
				{ className: 'thread', ref: function ref(h) {
						return _this2.header = h;
					} },
				react_default.a.createElement(
					'div',
					{ className: 'left' },
					react_default.a.createElement(common_UserIconComponent, { user: user, layout: 'userprofile', noAction: true })
				),
				react_default.a.createElement(
					'div',
					{ className: 'right' },
					react_default.a.createElement(
						'div',
						{ className: 'bannedUser' + (user.is_banned ? '' : ' hidden') },
						react_default.a.createElement(
							'span',
							null,
							'This user is banned'
						)
					),
					react_default.a.createElement(
						'div',
						{ className: 'userProfileName' },
						user.userName ? user.userName : '...'
					),
					location,
					stats
				)
			);
		}
	}, {
		key: 'profileResults',
		value: function profileResults() {
			var user = this.props.userprofileview.user;

			if (user.lastActivityList && user.lastActivityList.length > 0) {
				return react_default.a.createElement(posts_PostListComponent, { threadview: this.props.userprofileview, isUserProfile: true });
			} else {
				return null;
			}
		}
	}, {
		key: 'render',
		value: function render() {
			var _this3 = this;

			var _props$userprofilevie2 = this.props.userprofileview,
			    isFetching = _props$userprofilevie2.isFetching,
			    loaded = _props$userprofilevie2.loaded;


			if (!loaded) {
				return react_default.a.createElement(
					'div',
					{ className: 'userProfile' },
					this.userProfileHeader(),
					react_default.a.createElement(LoaderCssComponent, { style: { marginTop: this.state.headerHeight + 'px' } })
				);
			}

			var bottomAdUnit = react_default.a.createElement(ads_AdComponent, { key: 'thread_BottomAd', adType: '2', adName: 'Bottom_Content_Rectangle', isFetching: isFetching });

			return react_default.a.createElement(
				'div',
				{ className: 'userProfile' },
				this.userProfileHeader(),
				react_default.a.createElement(
					infiniteScroll_InfiniteScrollComponent,
					{
						scrollRef: function scrollRef(i) {
							return _this3.infiniteScroll = i;
						},
						isFetching: isFetching,
						loadPage: this.loadPage,
						location: this.props.location,
						extraHeaderHeight: this.state.headerHeight
					},
					this.profileResults()
				),
				bottomAdUnit
			);
		}
	}]);

	return UserProfileViewComponent;
}(react_default.a.Component);

/* harmony default export */ var UserprofileViewComponent = (Object(es["b" /* connect */])(selectors_userprofileResultSelector)(UserprofileViewComponent_UserProfileViewComponent));
// EXTERNAL MODULE: ./src/styles/messages.scss
var styles_messages = __webpack_require__(335);
var styles_messages_default = /*#__PURE__*/__webpack_require__.n(styles_messages);

// EXTERNAL MODULE: ./src/actions/MessagesviewActions.js
var MessagesviewActions = __webpack_require__(65);

// CONCATENATED MODULE: ./src/selectors/messagesSelector.js



var messagesviewSelector = function messagesviewSelector(state) {
	return state.messagesview;
};

/* harmony default export */ var messagesSelector = (Object(lib["createSelector"])([messagesviewSelector, selectors_metaSelector], function (messagesview, meta) {
	return {
		messagesview: messagesview,
		meta: meta
	};
}));
// CONCATENATED MODULE: ./src/components/messages/FolderComponent.js




var FolderComponent_PmFolderComponent = function PmFolderComponent(_ref) {
	var folder = _ref.folder;

	var unread_counter = folder.unread > 0 ? react_default.a.createElement(
		'span',
		{ className: 'unreadCounter' },
		react_default.a.createElement(svg_SvgIcon, { size: '12px', icon: 'error_outline' }),
		folder.unread + ' new message' + (folder.unread === 1 ? '' : 's')
	) : null;

	return react_default.a.createElement(
		'div',
		{ className: 'nolinks' },
		react_default.a.createElement(
			'div',
			{ className: 'name' },
			simpleDecodeEntities(folder.name)
		),
		react_default.a.createElement(
			'div',
			{ className: 'stats' },
			react_default.a.createElement(
				'span',
				{ className: 'left-stats' },
				react_default.a.createElement(svg_SvgIcon, { size: '12px', icon: 'message' }),
				folder.count + ' message' + (folder.count === 1 ? '' : 's')
			),
			unread_counter
		)
	);
};

/* harmony default export */ var FolderComponent = (FolderComponent_PmFolderComponent);
// CONCATENATED MODULE: ./src/components/MessagesViewComponent.js
var MessagesViewComponent__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function MessagesViewComponent__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function MessagesViewComponent__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function MessagesViewComponent__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




















var MessagesViewComponent_MessagesViewComponent = function (_React$Component) {
	MessagesViewComponent__inherits(MessagesViewComponent, _React$Component);

	function MessagesViewComponent() {
		MessagesViewComponent__classCallCheck(this, MessagesViewComponent);

		return MessagesViewComponent__possibleConstructorReturn(this, (MessagesViewComponent.__proto__ || Object.getPrototypeOf(MessagesViewComponent)).apply(this, arguments));
	}

	MessagesViewComponent__createClass(MessagesViewComponent, [{
		key: 'componentWillMount',
		value: function componentWillMount() {
			this.setState({
				pmroute: 'pmroot',
				id: null
			});
		}
	}, {
		key: 'componentDidMount',
		value: function componentDidMount() {
			this.props.dispatch(Object(MetaActions["c" /* resetSelectedItem */])());
			this.props.dispatch(Object(InfiniteScrollActions["f" /* resetInfinite */])());
			this.props.dispatch(Object(MessagesviewActions["g" /* resetMessages */])());
			this.props.dispatch(Object(MessagesviewActions["d" /* fetchMessages */])({
				pmroute: 'pmroot',
				size: 1,
				page: 1,
				id: null
			}));
		}
	}, {
		key: 'componentWillUnmount',
		value: function componentWillUnmount() {
			this.props.dispatch(Object(MetaActions["c" /* resetSelectedItem */])());
			this.props.dispatch(Object(MessagesviewActions["g" /* resetMessages */])());
		}
	}, {
		key: 'componentWillReceiveProps',
		value: function componentWillReceiveProps(nextProps) {
			if (nextProps.messagesview.loaded && nextProps.messagesview.loaded !== this.props.messagesview.loaded) {
				// trigger ad updates
				this.props.dispatch(Object(adsActions["s" /* onPageView */])());
				// Record the Google Analytics pageview
				this.props.dispatch(Object(adsActions["B" /* trackPageView */])());
			}
		}
	}, {
		key: 'shouldComponentUpdate',
		value: function shouldComponentUpdate(nextProps) {
			return nextProps.messagesview.loaded !== this.props.messagesview.loaded || nextProps.messagesview.isFetching !== this.props.messagesview.isFetching || nextProps.messagesview.result.pmfolders.length !== this.props.messagesview.result.pmfolders.length;
		}
	}, {
		key: 'goToFolder',
		value: function goToFolder(folderId) {
			if (isFinite(parseInt(folderId))) {
				this.props.dispatch(Object(MessagesviewActions["g" /* resetMessages */])());
				this.props.dispatch(Object(react_router_redux_lib["push"])(Object(NavHelpers["f" /* pathToMessagesFolder */])(folderId)));
			} else {
				this.props.dispatch(Object(MessagesviewActions["g" /* resetMessages */])());
				this.props.dispatch(Object(react_router_redux_lib["push"])(Object(NavHelpers["e" /* pathToMessages */])()));
			}
		}
	}, {
		key: 'render',
		value: function render() {
			var _this2 = this;

			var _props$messagesview = this.props.messagesview,
			    pmfolders = _props$messagesview.entities.pmfolders,
			    result = _props$messagesview.result,
			    loaded = _props$messagesview.loaded,
			    isFetching = _props$messagesview.isFetching;


			if (!loaded || isFetching) {
				return react_default.a.createElement(LoaderCssComponent, null);
			}

			var items_list = result.pmfolders.map(function (k, i) {
				var className = "pmfolder " + (pmfolders[k].unread > 0 ? 'unread' : '');
				return react_default.a.createElement(
					'li',
					{ className: className, key: 'pmfolder_' + i, onClick: function onClick() {
							return _this2.goToFolder(k);
						} },
					react_default.a.createElement(FolderComponent, { key: i, folder: pmfolders[k] })
				);
			}),
			    bottomAdUnit = react_default.a.createElement(ads_AdComponent, { adType: '2', adName: 'Bottom_Content_Rectangle' });

			return react_default.a.createElement(
				'div',
				{ className: 'messagesRoot' },
				react_default.a.createElement(
					'ul',
					null,
					items_list
				),
				bottomAdUnit
			);
		}
	}]);

	return MessagesViewComponent;
}(react_default.a.Component);

/* harmony default export */ var components_MessagesViewComponent = (Object(es["b" /* connect */])(messagesSelector)(MessagesViewComponent_MessagesViewComponent));
// CONCATENATED MODULE: ./src/components/messages/MessagePreviewComponent.js











var MessagePreviewComponent_messagePreviewComponent = function messagePreviewComponent(_ref) {
	var pm = _ref.pm,
	    users = _ref.users,
	    selectedElements = _ref.selectedElements,
	    dispatch = _ref.dispatch;

	var userFrom = react_default.a.createElement(common_UserIconComponent, { user: users[pm.fromUser] }),
	    msgPreview = simpleDecodeEntities(pm.messagepreview),
	    usersTo = null;

	if (pm.sent) {
		var usersTo_list = pm.toUser.map(function (k) {
			var onlineStatus = users[k].online === true ? react_default.a.createElement(
				'span',
				{ className: 'status online' },
				react_default.a.createElement(svg_SvgIcon, { size: '12px', icon: 'account_circle' })
			) : null;
			return react_default.a.createElement(
				'li',
				{ className: 'user-info', key: 'toUser_' + k },
				react_default.a.createElement(
					'div',
					{ className: 'username' },
					users[k].userName,
					' ',
					onlineStatus
				)
			);
		});

		usersTo = react_default.a.createElement(
			'div',
			{ className: 'usersTo postFooter' },
			react_default.a.createElement(
				'ul',
				null,
				usersTo_list
			)
		);
	}

	var checked = !!selectedElements[pm.id];

	return react_default.a.createElement(
		'div',
		{ className: 'nolinks thread ' + (checked ? 'selected-item' : '') },
		react_default.a.createElement(
			'div',
			{ className: 'left' },
			userFrom
		),
		react_default.a.createElement(
			'div',
			{ className: 'right' },
			react_default.a.createElement(
				'div',
				{ className: 'stats' },
				react_default.a.createElement(common_dateComponent, { timestamp: pm.dateline, icon: true }),
				react_default.a.createElement(CheckboxComponent, {
					name: 'pmSelect',
					id: 'pmSelected_' + pm.id,
					value: pm.id,
					checked: checked,
					multiple: true,
					className: 'inPost',
					onChange: function onChange() {
						return dispatch(Object(MetaActions["e" /* toggleSelectedItem */])(pm.id));
					}
				})
			),
			react_default.a.createElement(
				'div',
				{ className: 'title' },
				simpleDecodeEntities(pm.title)
			),
			react_default.a.createElement(
				'div',
				{ className: 'body topic-preview', id: 'pm_message_' + pm.id },
				msgPreview,
				' [\u2026]'
			),
			usersTo
		)
	);
};

MessagePreviewComponent_messagePreviewComponent.propTypes = {
	users: prop_types_default.a.object.isRequired,
	pm: prop_types_default.a.object.isRequired
};

/* harmony default export */ var MessagePreviewComponent = (MessagePreviewComponent_messagePreviewComponent);
// CONCATENATED MODULE: ./src/components/messages/MessagesPreviewListComponent.js
var MessagesPreviewListComponent__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function MessagesPreviewListComponent__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function MessagesPreviewListComponent__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function MessagesPreviewListComponent__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }













var MessagesPreviewListComponent_MessagesPreviewListComponent = function (_React$Component) {
	MessagesPreviewListComponent__inherits(MessagesPreviewListComponent, _React$Component);

	function MessagesPreviewListComponent() {
		var _ref;

		var _temp, _this, _ret;

		MessagesPreviewListComponent__classCallCheck(this, MessagesPreviewListComponent);

		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		return _ret = (_temp = (_this = MessagesPreviewListComponent__possibleConstructorReturn(this, (_ref = MessagesPreviewListComponent.__proto__ || Object.getPrototypeOf(MessagesPreviewListComponent)).call.apply(_ref, [this].concat(args))), _this), _this.goToPm = function (event) {
			var pmId = event.currentTarget.dataset.pmid,
			    page = event.currentTarget.dataset.page;

			if (isFinite(parseInt(pmId))) {
				_this.props.dispatch(Object(MessagesviewActions["g" /* resetMessages */])());
				var pmLocation = {
					pathname: Object(NavHelpers["g" /* pathToMessagesPM */])(pmId),
					query: { frompage: page || 1 }
				};
				_this.props.dispatch(Object(react_router_redux_lib["push"])(pmLocation));
			}
		}, _this.buildPage = function (pageNum) {
			var _this$props$messagesv = _this.props.messagesview,
			    entities = _this$props$messagesv.entities,
			    result = _this$props$messagesv.result;


			var pms = result.pms.filter(function (e) {
				return entities.pms[e] && entities.pms[e].page === pageNum;
			}),
			    pmList = pms.map(function (id, i) {
				return _this.buildMessage(entities.pms[id], i, pageNum);
			});

			return react_default.a.createElement(
				'ul',
				{ key: pageNum, id: 'message_page_' + pageNum, className: 'alert scroll_page page_' + pageNum },
				pmList
			);
		}, _temp), MessagesPreviewListComponent__possibleConstructorReturn(_this, _ret);
	}

	MessagesPreviewListComponent__createClass(MessagesPreviewListComponent, [{
		key: 'componentDidMount',
		value: function componentDidMount() {
			this.props.dispatch(Object(MetaActions["c" /* resetSelectedItem */])());
		}
	}, {
		key: 'buildMessage',
		value: function buildMessage(msg, i, pageNum) {
			var entities = this.props.messagesview.entities;

			var className = "pmpreview " + (msg.unread ? 'unread' : '');

			return react_default.a.createElement(
				'li',
				{ className: className, id: 'pmpreview_' + msg.id, key: 'pmpreview_' + msg.id, 'data-pmid': msg.id, 'data-page': pageNum, onClick: this.goToPm },
				react_default.a.createElement(MessagePreviewComponent, { key: msg.id, pm: msg, users: entities.users, selectedElements: this.props.meta.selectedElements, dispatch: this.props.dispatch })
			);
		}
	}, {
		key: 'render',
		value: function render() {
			var _this2 = this;

			var result = this.props.messagesview.result;


			if (result.pms.length === 0) {
				return null;
			}

			var messagesListPage = this.props.pages.map(function (pageNum, index) {
				return _this2.buildPage(pageNum, index);
			});

			return react_default.a.createElement(
				'div',
				{ className: 'messagesRoot messagesContainer', ref: this.props.listRef },
				messagesListPage
			);
		}
	}]);

	return MessagesPreviewListComponent;
}(react_default.a.Component);

MessagesPreviewListComponent_MessagesPreviewListComponent.propTypes = {
	dispatch: prop_types_default.a.func.isRequired,
	pages: prop_types_default.a.array.isRequired
};

/* harmony default export */ var messages_MessagesPreviewListComponent = (Object(es["b" /* connect */])(messagesSelector)(MessagesPreviewListComponent_MessagesPreviewListComponent));
// CONCATENATED MODULE: ./src/components/messages/MessagesFolderViewComponent.js
var MessagesFolderViewComponent__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function MessagesFolderViewComponent__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function MessagesFolderViewComponent__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function MessagesFolderViewComponent__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
















var MessagesFolderViewComponent_MessagesViewComponent = function (_React$Component) {
	MessagesFolderViewComponent__inherits(MessagesViewComponent, _React$Component);

	function MessagesViewComponent(props) {
		MessagesFolderViewComponent__classCallCheck(this, MessagesViewComponent);

		var _this = MessagesFolderViewComponent__possibleConstructorReturn(this, (MessagesViewComponent.__proto__ || Object.getPrototypeOf(MessagesViewComponent)).call(this, props));

		_this.loadPage = function (page, forceRefresh) {
			_this.props.dispatch(Object(MessagesviewActions["d" /* fetchMessages */])({
				pmroute: _this.state.pmroute,
				page: page ? page : 1,
				id: _this.state.id,
				forceRefresh: forceRefresh
			}));
		};

		_this.repositionScroll = function () {
			if (_this.header) {
				var headerDim = _this.header.getBoundingClientRect();

				if (headerDim.height && headerDim.height !== _this.state.headerHeight) {
					_this.setState({ headerHeight: headerDim.height });
				}
			}
		};

		_this.getHeaderHeight = function () {
			var header = document.getElementById('header');
			return header ? header.getBoundingClientRect().height : 0;
		};

		_this.state = {
			pmroute: 'pmfolder',
			id: null,
			headerHeight: 0
		};
		return _this;
	}

	MessagesFolderViewComponent__createClass(MessagesViewComponent, [{
		key: 'componentWillMount',
		value: function componentWillMount() {
			this.setState({
				pmroute: 'pmfolder',
				id: this.props.params.folderId || null
			});
		}
	}, {
		key: 'componentDidMount',
		value: function componentDidMount() {
			this.repositionScroll();
			var page = this.props.location.query.page || 1;
			this.props.dispatch(Object(InfiniteScrollActions["f" /* resetInfinite */])());

			this.loadPage(parseInt(page), true);
		}
	}, {
		key: 'componentWillReceiveProps',
		value: function componentWillReceiveProps(nextProps) {
			var pmroute = 'pmfolder',
			    id = nextProps.params.folderId || null;
			this.setState({
				id: id
			});

			var page = this.props.location.query.page || 1;

			if (parseInt(nextProps.params.folderId) !== parseInt(this.props.params.folderId)) {
				this.props.dispatch(Object(MessagesviewActions["d" /* fetchMessages */])({
					pmroute: pmroute,
					page: page ? parseInt(page) : 1,
					id: id
				}));
			} else if (nextProps.messagesview.loaded && nextProps.messagesview.loaded !== this.props.messagesview.loaded) {
				// trigger ad updates
				this.props.dispatch(Object(adsActions["s" /* onPageView */])());
				// Record the Google Analytics pageview
				this.props.dispatch(Object(adsActions["B" /* trackPageView */])());
			}
		}
	}, {
		key: 'shouldComponentUpdate',
		value: function shouldComponentUpdate(nextProps, nextState) {
			return nextProps.messagesview.loaded !== this.props.messagesview.loaded || nextProps.messagesview.isFetching !== this.props.messagesview.isFetching || nextProps.messagesview.result.pms.length !== this.props.messagesview.result.pms.length || nextProps.params.folderId !== this.props.params.folderId || nextState.id !== this.state.id || nextState.headerHeight !== this.state.headerHeight;
		}
	}, {
		key: 'componentDidUpdate',
		value: function componentDidUpdate() {
			this.repositionScroll();

			// If we loaded and we have a pmid in the querystring, scroll to it
			if (this.props.messagesview.loaded && this.props.location.query.msgid) {
				var folderLocation = {
					pathname: this.props.location.pathname,
					query: this.props.location.query.page ? { page: this.props.location.query.page } : null
				},
				    pmContainer = document.getElementById('pmpreview_' + this.props.location.query.msgid);

				if (pmContainer) {
					window.scrollTo(0, pmContainer.offsetTop - 15);
				}
				// remove the pmid from the querystring
				this.props.dispatch(Object(react_router_redux_lib["replace"])(folderLocation));
			}
		}
	}, {
		key: 'goToFolder',
		value: function goToFolder(folderId) {
			if (isFinite(parseInt(folderId))) {
				this.props.dispatch(Object(MessagesviewActions["g" /* resetMessages */])());
				// Record the Google Analytics event.
				this.props.dispatch(Object(adsActions["A" /* trackGAEvent */])(false, 'backToMessagesFolder', 'uiAction', 'tap'));
				this.props.dispatch(Object(react_router_redux_lib["push"])(Object(NavHelpers["f" /* pathToMessagesFolder */])(folderId)));
			} else {
				this.props.dispatch(Object(MessagesviewActions["g" /* resetMessages */])());
				// Record the Google Analytics event.
				this.props.dispatch(Object(adsActions["A" /* trackGAEvent */])(false, 'backToMsgFolderList', 'uiAction', 'tap'));
				this.props.dispatch(Object(react_router_redux_lib["push"])(Object(NavHelpers["e" /* pathToMessages */])()));
			}
		}
	}, {
		key: '_getHeather',
		value: function _getHeather() {
			var _this2 = this;

			var _props$messagesview = this.props.messagesview,
			    result = _props$messagesview.result,
			    total = _props$messagesview.total,
			    totalPages = _props$messagesview.totalPages,
			    loaded = _props$messagesview.loaded,
			    isFetching = _props$messagesview.isFetching;

			var summary = total ? react_default.a.createElement(
				'div',
				{ className: 'right list-summary' },
				total.toLocaleString(),
				' Message',
				parseInt(total) === 1 ? '' : 's',
				' / ',
				totalPages.toLocaleString(),
				' Page',
				parseInt(totalPages) === 1 ? '' : 's'
			) : null,
			    noResults = loaded && !isFetching && result.pms.length === 0 ? react_default.a.createElement(
				'div',
				null,
				react_default.a.createElement(
					'h4',
					null,
					'There are currently no messages within this folder.'
				)
			) : null;
			return react_default.a.createElement(
				'header',
				{ className: 'thread topLink', ref: function ref(h) {
						return _this2.header = h;
					} },
				react_default.a.createElement(
					'span',
					{ className: 'loadMore', onClick: function onClick() {
							return _this2.goToFolder();
						} },
					'Return to Messages Folder List'
				),
				summary,
				noResults
			);
		}
	}, {
		key: 'render',
		value: function render() {
			var _this3 = this;

			var _props$messagesview2 = this.props.messagesview,
			    result = _props$messagesview2.result,
			    totalPages = _props$messagesview2.totalPages,
			    loaded = _props$messagesview2.loaded,
			    isFetching = _props$messagesview2.isFetching;


			if (!loaded || result.pms && parseInt(result.pms) === 0 && loaded) {
				return react_default.a.createElement(
					'div',
					{ className: 'messagesRoot messagesContainer' },
					this._getHeather(),
					react_default.a.createElement(LoaderCssComponent, { style: { marginTop: this.state.headerHeight + 'px' } })
				);
			}

			var bottomAdUnit = react_default.a.createElement(ads_AdComponent, { adType: '2', adName: 'Bottom_Content_Rectangle' }),
			    items_list = result.pms.length > 0 ? react_default.a.createElement(
				infiniteScroll_InfiniteScrollComponent,
				{
					scrollRef: function scrollRef(i) {
						return _this3.infiniteScroll = i;
					},
					totalPages: totalPages,
					isFetching: isFetching,
					loadPage: this.loadPage,
					location: this.props.location,
					extraHeaderHeight: this.state.headerHeight
				},
				react_default.a.createElement(messages_MessagesPreviewListComponent, null)
			) : react_default.a.createElement('div', { style: { marginTop: this.state.headerHeight + this.getHeaderHeight() + 10 + 'px' } });

			return react_default.a.createElement(
				'div',
				{ className: 'messagesRoot messagesContainer' },
				this._getHeather(),
				items_list,
				bottomAdUnit
			);
		}
	}]);

	return MessagesViewComponent;
}(react_default.a.Component);

/* harmony default export */ var MessagesFolderViewComponent = (Object(es["b" /* connect */])(messagesSelector)(MessagesFolderViewComponent_MessagesViewComponent));
// CONCATENATED MODULE: ./src/components/messages/MessageViewComponent.js
var MessageViewComponent__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function MessageViewComponent__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function MessageViewComponent__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function MessageViewComponent__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






















var MessageViewComponent_MessageViewComponent = function (_React$Component) {
	MessageViewComponent__inherits(MessageViewComponent, _React$Component);

	function MessageViewComponent(props) {
		MessageViewComponent__classCallCheck(this, MessageViewComponent);

		var _this = MessageViewComponent__possibleConstructorReturn(this, (MessageViewComponent.__proto__ || Object.getPrototypeOf(MessageViewComponent)).call(this, props));

		_this.repositionScroll = function () {
			if (_this.header) {
				var headerDim = _this.header.getBoundingClientRect();

				if (headerDim.height && headerDim.height !== _this.state.headerHeight) {
					_this.setState({ headerHeight: headerDim.height + _this.getHeaderHeight() });
				}
			}
		};

		_this.getHeaderHeight = function () {
			var header = document.getElementById('header');
			return header ? header.getBoundingClientRect().height : 0;
		};

		_this.state = {
			headerHeight: 0
		};
		return _this;
	}

	MessageViewComponent__createClass(MessageViewComponent, [{
		key: 'componentWillMount',
		value: function componentWillMount() {
			// Grab the page we are coming from to send the user back
			this.previousPage = parseInt(this.props.location.query.frompage) || 1;
			this.props.dispatch(Object(react_router_redux_lib["replace"])(this.props.location.pathname));
		}
	}, {
		key: 'componentDidMount',
		value: function componentDidMount() {
			this.props.dispatch(Object(MetaActions["c" /* resetSelectedItem */])());
			this.props.dispatch(Object(MessagesviewActions["d" /* fetchMessages */])({
				pmroute: 'pm',
				id: this.props.params.messageId
			}));
		}
	}, {
		key: 'shouldComponentUpdate',
		value: function shouldComponentUpdate(nextProps, nextState) {
			return nextProps.messagesview.loaded !== this.props.messagesview.loaded || nextProps.messagesview.isFetching !== this.props.messagesview.isFetching || nextProps.messagesview.result.pmfolders.length !== this.props.messagesview.result.pmfolders.length || nextProps.messagesview.result.pms.length !== this.props.messagesview.result.pms.length || nextProps.params.messageId !== this.props.params.messageId || nextState.headerHeight !== this.state.headerHeight;
		}
	}, {
		key: 'componentWillReceiveProps',
		value: function componentWillReceiveProps(nextProps) {
			if (nextProps.params.messageId !== this.props.params.messageId) {
				this.props.dispatch(Object(MessagesviewActions["d" /* fetchMessages */])({
					pmroute: pmroute,
					id: nextProps.params.messageId
				}));
			} else if (nextProps.messagesview.loaded && nextProps.messagesview.loaded !== this.props.messagesview.loaded) {
				// trigger ad updates
				this.props.dispatch(Object(adsActions["s" /* onPageView */])());
				// Record the Google Analytics pageview
				this.props.dispatch(Object(adsActions["B" /* trackPageView */])());
			}
		}
	}, {
		key: 'componentDidUpdate',
		value: function componentDidUpdate() {
			this.repositionScroll();
		}
	}, {
		key: 'goToFolder',
		value: function goToFolder(folderId) {
			if (isFinite(parseInt(folderId))) {
				// Record the Google Analytics event.
				this.props.dispatch(Object(adsActions["A" /* trackGAEvent */])(false, 'backToMessagesFolder', 'uiAction', 'tap'));

				var folderLocation = { pathname: Object(NavHelpers["f" /* pathToMessagesFolder */])(folderId) };
				folderLocation.query = Object.assign({ msgid: this.props.params.messageId }, this.previousPage > 1 ? { page: this.previousPage } : {});

				this.props.dispatch(Object(react_router_redux_lib["push"])(folderLocation));
			} else {
				// Record the Google Analytics event.
				this.props.dispatch(Object(adsActions["A" /* trackGAEvent */])(false, 'backToMsgFolderList', 'uiAction', 'tap'));
				this.props.dispatch(Object(react_router_redux_lib["push"])(Object(NavHelpers["e" /* pathToMessages */])()));
			}
		}
	}, {
		key: '_getHeather',
		value: function _getHeather() {
			var _this2 = this;

			var _props$messagesview = this.props.messagesview,
			    entities = _props$messagesview.entities,
			    loaded = _props$messagesview.loaded,
			    isFetching = _props$messagesview.isFetching;

			var folderId = loaded && !isFetching ? entities.pms[this.props.params.messageId].folder : null,
			    folderName = folderId ? entities.pmfolders[folderId].name : null,
			    linkBack = folderName ? react_default.a.createElement(
				'span',
				{ className: 'loadMore', onClick: function onClick() {
						return _this2.goToFolder(folderId);
					} },
				'Return to ',
				react_default.a.createElement(
					'strong',
					null,
					folderName
				)
			) : react_default.a.createElement(
				'span',
				{ className: 'loadMore', onClick: function onClick() {
						return _this2.goToFolder(false);
					} },
				'Go back to Messages'
			);

			return react_default.a.createElement(
				'header',
				{ className: 'thread topLink', ref: function ref(h) {
						return _this2.header = h;
					} },
				linkBack
			);
		}
	}, {
		key: 'render',
		value: function render() {
			var _props$messagesview2 = this.props.messagesview,
			    _props$messagesview2$ = _props$messagesview2.entities,
			    pms = _props$messagesview2$.pms,
			    users = _props$messagesview2$.users,
			    loaded = _props$messagesview2.loaded,
			    isFetching = _props$messagesview2.isFetching;


			if (!loaded || isFetching) {
				return react_default.a.createElement(
					'div',
					{ className: 'messagesRoot messagesContainer' },
					this._getHeather(),
					react_default.a.createElement(LoaderCssComponent, { style: { marginTop: this.state.headerHeight + 'px' } })
				);
			}

			var pm = pms[this.props.params.messageId],
			    msgText = RawToReact(pm.message, this.props.messagesview.entities, true),
			    userFrom = react_default.a.createElement(common_UserIconComponent, { user: users[pm.fromUser] }),
			    bottomAdUnit = react_default.a.createElement(ads_AdComponent, { adType: '2', adName: 'Bottom_Content_Rectangle' }),
			    usersTo_list = pm.toUser.map(function (k) {
				var onlineStatus = users[k].online === true ? react_default.a.createElement(
					'span',
					{ className: 'status online' },
					react_default.a.createElement(svg_SvgIcon, { size: '12px', icon: 'account_circle' })
				) : null;
				return react_default.a.createElement(
					'li',
					{ className: 'user-info', key: 'toUser_' + k },
					react_default.a.createElement(
						'div',
						{ className: 'username' },
						users[k].userName,
						' ',
						onlineStatus
					)
				);
			}),
			    usersTo = pm.toUser.length ? react_default.a.createElement(
				'div',
				{ className: 'usersTo postFooter' },
				react_default.a.createElement(
					'ul',
					null,
					usersTo_list
				)
			) : null;

			return react_default.a.createElement(
				'div',
				{ className: 'messagesRoot messagesContainer nolinks' },
				this._getHeather(),
				react_default.a.createElement(
					'ul',
					{ style: { marginTop: this.state.headerHeight + 'px' } },
					react_default.a.createElement(
						'li',
						{ className: 'post thread pmpreview' },
						react_default.a.createElement(
							'div',
							{ className: 'left' },
							userFrom
						),
						react_default.a.createElement(
							'div',
							{ className: 'right' },
							react_default.a.createElement(
								'div',
								{ className: 'stats single-right' },
								react_default.a.createElement(common_dateComponent, { timestamp: pm.dateline, icon: true })
							),
							react_default.a.createElement(
								'div',
								{ className: 'title' },
								simpleDecodeEntities(pm.title)
							),
							react_default.a.createElement(
								'div',
								{ className: 'body', id: 'pm_message_' + pm.id },
								msgText
							),
							usersTo
						)
					)
				),
				bottomAdUnit
			);
		}
	}]);

	return MessageViewComponent;
}(react_default.a.Component);

/* harmony default export */ var messages_MessageViewComponent = (Object(es["b" /* connect */])(messagesSelector)(MessageViewComponent_MessageViewComponent));
// CONCATENATED MODULE: ./src/selectors/onlineUsersSelector.js


var onlineUsersSelector = function onlineUsersSelector(state) {
  return state.onlineUsers;
};

/* harmony default export */ var selectors_onlineUsersSelector = (Object(lib["createSelector"])(onlineUsersSelector, function (onlineUsers) {
  return { onlineUsers: onlineUsers };
}));
// EXTERNAL MODULE: ./src/actions/OnlineUsersActions.js
var OnlineUsersActions = __webpack_require__(154);

// CONCATENATED MODULE: ./src/components/onlineusers/OnlineUsersListComponent.js
var OnlineUsersListComponent__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function OnlineUsersListComponent__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function OnlineUsersListComponent__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function OnlineUsersListComponent__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var OnlineUsersListComponent_OnlineUsersListComponent = function (_React$Component) {
	OnlineUsersListComponent__inherits(OnlineUsersListComponent, _React$Component);

	function OnlineUsersListComponent() {
		var _ref;

		var _temp, _this, _ret;

		OnlineUsersListComponent__classCallCheck(this, OnlineUsersListComponent);

		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		return _ret = (_temp = (_this = OnlineUsersListComponent__possibleConstructorReturn(this, (_ref = OnlineUsersListComponent.__proto__ || Object.getPrototypeOf(OnlineUsersListComponent)).call.apply(_ref, [this].concat(args))), _this), _this.buildUser = function (user) {
			if (user.userName === 'Guest') {
				return null;
			}
			return react_default.a.createElement(
				'li',
				{ key: user.id },
				react_default.a.createElement(
					'div',
					{ className: 'post' },
					react_default.a.createElement(
						'div',
						{ className: 'left' },
						react_default.a.createElement(common_UserIconComponent, { user: user, layout: 'userprofile' })
					),
					react_default.a.createElement(
						'div',
						{ className: 'right' },
						react_default.a.createElement(
							'div',
							{ className: 'username' },
							user.userName ? user.userName : 'Loading...'
						),
						react_default.a.createElement(
							'div',
							{ className: 'since' },
							'Last active ',
							react_default.a.createElement(common_dateComponent, { timestamp: user.lastActivity })
						)
					)
				)
			);
		}, _this.buildPage = function (pageNum) {
			var _this$props$onlineUse = _this.props.onlineUsers,
			    entities = _this$props$onlineUse.entities,
			    result = _this$props$onlineUse.result;


			var onlineUsers = result.online.filter(function (e) {
				return entities.online[e] && entities.online[e].page === pageNum;
			}),
			    usersList = onlineUsers.map(function (id, i) {
				return _this.buildUser(entities.online[id]);
			});

			return react_default.a.createElement(
				'ul',
				{ key: pageNum, className: 'scroll_page page_' + pageNum },
				usersList
			);
		}, _temp), OnlineUsersListComponent__possibleConstructorReturn(_this, _ret);
	}

	OnlineUsersListComponent__createClass(OnlineUsersListComponent, [{
		key: 'onlineUsersListPage',
		value: function onlineUsersListPage() {
			var _this2 = this;

			return this.props.pages.map(function (pageNum) {
				return _this2.buildPage(pageNum);
			});
		}
	}, {
		key: 'render',
		value: function render() {
			return react_default.a.createElement(
				'div',
				{ ref: this.props.listRef, style: { paddingBottom: '50px' } },
				this.onlineUsersListPage()
			);
		}
	}]);

	return OnlineUsersListComponent;
}(react_default.a.Component);

OnlineUsersListComponent_OnlineUsersListComponent.propTypes = {
	dispatch: prop_types_default.a.func.isRequired,
	pages: prop_types_default.a.array.isRequired
};

/* harmony default export */ var onlineusers_OnlineUsersListComponent = (Object(es["b" /* connect */])(selectors_onlineUsersSelector)(OnlineUsersListComponent_OnlineUsersListComponent));
// CONCATENATED MODULE: ./src/components/OnlineViewComponent.js
var OnlineViewComponent__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function OnlineViewComponent__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function OnlineViewComponent__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function OnlineViewComponent__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }












var OnlineViewComponent_OnlineViewComponent = function (_React$Component) {
	OnlineViewComponent__inherits(OnlineViewComponent, _React$Component);

	function OnlineViewComponent(props) {
		OnlineViewComponent__classCallCheck(this, OnlineViewComponent);

		var _this = OnlineViewComponent__possibleConstructorReturn(this, (OnlineViewComponent.__proto__ || Object.getPrototypeOf(OnlineViewComponent)).call(this, props));

		_this.repositionScroll = function () {
			if (_this.header) {
				var headerDim = _this.header.getBoundingClientRect();

				if (headerDim.height && headerDim.height !== _this.state.headerHeight) {
					_this.setState({ headerHeight: headerDim.height });
				}
			}
		};

		_this.onlineUsersList = function () {
			var isFetching = _this.props.onlineUsers.isFetching;

			if (_this.onlineUsers.length !== 0) {
				return react_default.a.createElement(
					infiniteScroll_InfiniteScrollComponent,
					{
						scrollRef: function scrollRef(i) {
							return _this.infiniteScroll = i;
						},
						isFetching: isFetching,
						loadPage: _this.loadPage,
						location: _this.props.location,
						extraHeaderHeight: _this.state.headerHeight
					},
					react_default.a.createElement(onlineusers_OnlineUsersListComponent, null)
				);
			} else {
				return react_default.a.createElement(
					'div',
					null,
					'No registered user online'
				);
			}
		};

		_this.loadPage = function (pageNum) {
			_this.props.dispatch(Object(OnlineUsersActions["d" /* whoIsOnline */])(pageNum));
		};

		_this.state = {
			headerHeight: 0
		};
		return _this;
	}

	OnlineViewComponent__createClass(OnlineViewComponent, [{
		key: 'componentWillMount',
		value: function componentWillMount() {
			this.props.dispatch(Object(InfiniteScrollActions["f" /* resetInfinite */])());
			this.props.dispatch(Object(OnlineUsersActions["c" /* resetOnlineUsers */])());
		}
	}, {
		key: 'componentDidMount',
		value: function componentDidMount() {
			this.repositionScroll();
			var page = this.props.location.query.page || 1;
			this.loadPage(page);
		}
	}, {
		key: 'componentWillUnmount',
		value: function componentWillUnmount() {
			this.props.dispatch(Object(InfiniteScrollActions["f" /* resetInfinite */])());
			this.props.dispatch(Object(OnlineUsersActions["c" /* resetOnlineUsers */])());
		}
	}, {
		key: 'componentWillReceiveProps',
		value: function componentWillReceiveProps(nextProps) {
			if (nextProps.onlineUsers.loaded && nextProps.onlineUsers.loaded !== this.props.onlineUsers.loaded) {
				// trigger ad updates
				this.props.dispatch(Object(adsActions["s" /* onPageView */])());
				// Record the Google Analytics pageview
				this.props.dispatch(Object(adsActions["B" /* trackPageView */])());
			}
		}
	}, {
		key: 'componentDidUpdate',
		value: function componentDidUpdate() {
			this.repositionScroll();
		}
	}, {
		key: '_getHeather',
		value: function _getHeather() {
			var _this2 = this;

			return react_default.a.createElement(
				'header',
				{ className: 'thread', ref: function ref(h) {
						return _this2.header = h;
					} },
				react_default.a.createElement(
					'div',
					{ className: 'right' },
					react_default.a.createElement(
						'ul',
						{ className: 'stats' },
						react_default.a.createElement(
							'li',
							null,
							react_default.a.createElement(
								'span',
								null,
								'Members Online'
							),
							' ',
							react_default.a.createElement(
								'span',
								null,
								this.props.onlineUsers.totals.members || '-'
							)
						),
						react_default.a.createElement(
							'li',
							null,
							react_default.a.createElement(
								'span',
								null,
								'Guests Online'
							),
							' ',
							react_default.a.createElement(
								'span',
								null,
								this.props.onlineUsers.totals.guests || '-'
							)
						)
					)
				)
			);
		}
	}, {
		key: 'render',
		value: function render() {
			if (!this.props.onlineUsers.loaded) {
				return react_default.a.createElement(
					'div',
					{ id: 'onlineUsers' },
					this._getHeather(),
					react_default.a.createElement(LoaderCssComponent, { style: { marginTop: this.state.headerHeight + 'px' } })
				);
			}

			return react_default.a.createElement(
				'div',
				{ id: 'onlineUsers' },
				this._getHeather(),
				this.onlineUsersList()
			);
		}
	}, {
		key: 'onlineUsers',
		get: function get() {
			var _props$onlineUsers = this.props.onlineUsers,
			    online = _props$onlineUsers.entities.online,
			    result = _props$onlineUsers.result;

			return result.online.filter(function (user) {
				return online[user].userName !== 'Guest';
			});
		}
	}]);

	return OnlineViewComponent;
}(react_default.a.Component);

/* harmony default export */ var components_OnlineViewComponent = (Object(es["b" /* connect */])(selectors_onlineUsersSelector)(OnlineViewComponent_OnlineViewComponent));
// EXTERNAL MODULE: ./src/styles/page.scss
var styles_page = __webpack_require__(772);
var styles_page_default = /*#__PURE__*/__webpack_require__.n(styles_page);

// EXTERNAL MODULE: ./src/styles/animate.scss
var animate = __webpack_require__(773);
var animate_default = /*#__PURE__*/__webpack_require__.n(animate);

// EXTERNAL MODULE: ./src/styles/old_phones.scss
var old_phones = __webpack_require__(774);
var old_phones_default = /*#__PURE__*/__webpack_require__.n(old_phones);

// EXTERNAL MODULE: ./node_modules/react-s-alert/index.js
var react_s_alert = __webpack_require__(310);
var react_s_alert_default = /*#__PURE__*/__webpack_require__.n(react_s_alert);

// EXTERNAL MODULE: ./node_modules/react-s-alert/dist/s-alert-default.css
var s_alert_default = __webpack_require__(775);
var s_alert_default_default = /*#__PURE__*/__webpack_require__.n(s_alert_default);

// EXTERNAL MODULE: ./node_modules/react-s-alert/dist/s-alert-css-effects/stackslide.css
var stackslide = __webpack_require__(776);
var stackslide_default = /*#__PURE__*/__webpack_require__.n(stackslide);

// EXTERNAL MODULE: ./src/actions/UstateActions.js
var UstateActions = __webpack_require__(153);

// EXTERNAL MODULE: ./src/styles/header.scss
var header = __webpack_require__(777);
var header_default = /*#__PURE__*/__webpack_require__.n(header);

// CONCATENATED MODULE: ./src/selectors/headerSelector.js
var headerSelector__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



var headerSelector_uiSelector = function uiSelector(state) {
	return state.ui;
};
var headerSelector_metaSelector = function metaSelector(state) {
	return state.meta;
};
var headerSelector_routingSelector = function routingSelector(state) {
	return state.routing;
};
var headerSelector_userPermissionsSelector = function userPermissionsSelector(state) {
	return state.ustate.perms;
};
var headerSelector_widgetSelector = function widgetSelector(state) {
	return state.widgetState;
};

/* harmony default export */ var headerSelector = (Object(lib["createSelector"])([headerSelector_uiSelector, headerSelector_metaSelector, headerSelector_routingSelector, headerSelector_userPermissionsSelector, headerSelector_widgetSelector], function (ui, meta, routing, userPermissions, widget) {
	return headerSelector__extends({
		widgetState: widget,
		ui: {
			headerOverflowOpened: ui.headerOverflowOpened,
			sidebarOpened: ui.sidebarOpened
		}
	}, meta, {
		userPermissions: userPermissions,
		routing: routing
	});
}));
// EXTERNAL MODULE: ./src/actions/ContextInfoActions.js + 1 modules
var ContextInfoActions = __webpack_require__(73);

// EXTERNAL MODULE: ./node_modules/isomorphic-fetch/fetch-npm-browserify.js
var fetch_npm_browserify = __webpack_require__(39);
var fetch_npm_browserify_default = /*#__PURE__*/__webpack_require__.n(fetch_npm_browserify);

// CONCATENATED MODULE: ./src/actions/ModToolsActions.js








/**
 * openCloseThread
 *
 * @param threadId
 * @param actionState bool true: open | false: close
 * @returns {Function}
 */
function openCloseThread(threadId) {
	var actionState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

	return function (dispatch, getState) {
		if (!threadId) {
			topifyConsole.warn((actionState ? 'Open' : 'Close') + ' Thread - thread id not provided', threadId);
			return;
		}
		topifyConsole.log(actionState, (actionState ? 'Open' : 'Close') + ' Thread', threadId);

		var state = getState(),
		    url = state.topifyPresets.forumSite.url,
		    userID = state.ustate.id ? state.ustate.id : 0,
		    newState = actionState ? 1 : 0;

		var moreData = 'type=openclose&action=openclose&threadid=' + threadId + '&state=' + newState;

		var fetchConfig = dispatch(Object(GlobalMetaActions["e" /* getFetchConfig */])(true, 'POST', moreData));

		dispatch(Object(UiActions["O" /* showGlobalLoading */])('Processing'));

		return fetch(url + ('?v=3.0&ajax=1&uid=' + userID + '&req=post'), fetchConfig).then(function (response) {
			if (!response.ok) {
				try {
					response.json().then(function (json) {
						Object(GlobalMetaActions["j" /* setGlobalNotification */])(dispatch, json, response);
					});
				} catch (e) {
					Object(GlobalMetaActions["j" /* setGlobalNotification */])(dispatch, {}, response);
				}
			} else {
				response.json().then(function (json) {
					if (json.state) {
						Object(GlobalMetaActions["j" /* setGlobalNotification */])(dispatch, json, { ok: true });

						// Record the Google Analytics event.
						dispatch(Object(adsActions["A" /* trackGAEvent */])(false, json.result.isOpen ? 'modOpenTopic' : 'modCloseTopic', 'moderatorAction', 'topic'));

						var message = 'This Topic is ' + (json.result.isOpen ? 'open' : 'closed'),
						    notificationType = 'success';
						if (json.result.isOpen !== actionState) {
							message = 'Something went wrong, the Topic didn\'t change its state.' + message;
							notificationType = 'warning';
						}
						Object(UiActions["B" /* displayNotification */])(notificationType, message);
					} else {
						Object(UiActions["B" /* displayNotification */])('warning', 'Some error happened. Try again.');
					}
				});
			}
		}).then(function () {
			dispatch(Object(GlobalMetaActions["h" /* refreshPage */])());
			dispatch(Object(UiActions["D" /* hideGlobalLoading */])());
		}).catch(function (error) {
			dispatch(Object(UiActions["D" /* hideGlobalLoading */])());
			Object(GlobalMetaActions["j" /* setGlobalNotification */])(dispatch, {}, error);
			dispatch(Object(GlobalMetaActions["h" /* refreshPage */])());
		});
	};
}

/**
 * deleteRestoreThread
 *
 * @param threadId
 * @param actionState bool true: restore | false: delete
 * @returns {Function}
 */
function deleteRestoreThread(threadId) {
	var actionState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

	return function (dispatch, getState) {
		if (!threadId) {
			topifyConsole.warn((actionState ? 'Restore' : 'Delete') + ' Thread - thread id not provided', threadId);
			return;
		}
		topifyConsole.log(actionState, (actionState ? 'Restore' : 'Delete') + ' Thread', threadId);

		var state = getState(),
		    url = state.topifyPresets.forumSite.url,
		    userID = state.ustate.id ? state.ustate.id : 0,
		    newState = actionState ? 1 : 0;

		var moreData = 'type=deletethread&action=delete&threadid=' + threadId + '&state=' + newState;

		var fetchConfig = dispatch(Object(GlobalMetaActions["e" /* getFetchConfig */])(true, 'POST', moreData));

		dispatch(Object(UiActions["O" /* showGlobalLoading */])('Processing'));

		return fetch(url + ('?v=3.0&ajax=1&uid=' + userID + '&req=post'), fetchConfig).then(function (response) {
			if (!response.ok) {
				try {
					response.json().then(function (json) {
						Object(GlobalMetaActions["j" /* setGlobalNotification */])(dispatch, json, response);
					});
				} catch (e) {
					Object(GlobalMetaActions["j" /* setGlobalNotification */])(dispatch, {}, response);
				}
			} else {
				response.json().then(function (json) {
					if (json.state) {
						Object(GlobalMetaActions["j" /* setGlobalNotification */])(dispatch, json, { ok: true });

						// Record the Google Analytics event.
						dispatch(Object(adsActions["A" /* trackGAEvent */])(false, json.result.isDeleted ? 'modDeleteTopic' : 'modRestoreTopic', 'moderatorAction', 'topic'));

						var message = 'You have ' + (json.result.isDeleted ? 'deleted' : 'restored') + ' this topic',
						    notificationType = 'success';
						if (json.result.isDeleted === actionState) {
							message = 'Something went wrong, the Topic didn\'t change its state.';
							notificationType = 'warning';
						}
						Object(UiActions["B" /* displayNotification */])(notificationType, message);
					} else {
						Object(UiActions["B" /* displayNotification */])('warning', 'Some error happened. Try again.');
					}
				});
			}
		}).then(function () {
			dispatch(Object(GlobalMetaActions["h" /* refreshPage */])());
			dispatch(Object(UiActions["D" /* hideGlobalLoading */])());
		}).catch(function (error) {
			dispatch(Object(UiActions["D" /* hideGlobalLoading */])());
			Object(GlobalMetaActions["j" /* setGlobalNotification */])(dispatch, {}, error);
			dispatch(Object(GlobalMetaActions["h" /* refreshPage */])());
		});
	};
}

/**
 * Lifts ban on user
 *
 * @param banneduserId
 * @returns {Function}
 */
function liftUserBan(banneduserId) {
	return function (dispatch, getState) {
		if (!banneduserId) {
			topifyConsole.warn('Lift user ban - User id not provided', banneduserId);
			return;
		}
		topifyConsole.log('Lift user ban', banneduserId);

		var state = getState(),
		    url = state.topifyPresets.forumSite.url,
		    userID = state.ustate.id ? state.ustate.id : 0;

		var moreData = 'type=moderate_user&action=unban&userid=' + banneduserId;

		var fetchConfig = dispatch(Object(GlobalMetaActions["e" /* getFetchConfig */])(true, 'POST', moreData));

		dispatch(Object(UiActions["O" /* showGlobalLoading */])('Processing'));

		return fetch(url + ('?v=3.0&ajax=1&uid=' + userID + '&req=post'), fetchConfig).then(function (response) {
			if (!response.ok) {
				try {
					response.json().then(function (json) {
						Object(GlobalMetaActions["j" /* setGlobalNotification */])(dispatch, json, response);
					});
				} catch (e) {
					Object(GlobalMetaActions["j" /* setGlobalNotification */])(dispatch, {}, response);
				}
			} else {
				response.json().then(function (json) {
					if (json.state) {
						Object(GlobalMetaActions["j" /* setGlobalNotification */])(dispatch, json, { ok: true });
						var message = 'Ban on user "' + json.result.username + '" has been lifted',
						    notificationType = 'success';
						Object(UiActions["B" /* displayNotification */])(notificationType, message);
					} else {
						Object(UiActions["B" /* displayNotification */])('warning', 'Some error happened. Try again.');
					}
				});
			}
		}).then(function () {
			dispatch(Object(GlobalMetaActions["h" /* refreshPage */])());
			dispatch(Object(UiActions["D" /* hideGlobalLoading */])());
		}).catch(function (error) {
			dispatch(Object(UiActions["D" /* hideGlobalLoading */])());
			Object(GlobalMetaActions["j" /* setGlobalNotification */])(dispatch, {}, error);
			dispatch(Object(GlobalMetaActions["h" /* refreshPage */])());
		});
	};
}

/**
 * Request Ban confirmation to the site
 *
 * @param banneduserId
 * @param type
 * @param renderConfirm
 * @returns {Function}
 */
function banUser_confirm(banneduserId, type, renderConfirm) {
	return function (dispatch, getState) {
		if (!banneduserId) {
			topifyConsole.warn('Ban user - User id not provided', banneduserId);
			return;
		}
		topifyConsole.log('Ban user', banneduserId);

		var state = getState(),
		    url = state.topifyPresets.forumSite.url,
		    userID = state.ustate.id ? state.ustate.id : 0,
		    ban_type = type + 'ban_confirm';

		var moreData = 'type=moderate_user&action=' + ban_type + '&req=post&userid=' + banneduserId;

		var fetchConfig = dispatch(Object(GlobalMetaActions["e" /* getFetchConfig */])(true, 'POST', moreData));

		dispatch(Object(UiActions["O" /* showGlobalLoading */])('Processing'));

		return fetch(url + ('?v=3.0&ajax=1&uid=' + userID + '&req=post'), fetchConfig).then(function (response) {
			if (!response.ok) {
				try {
					response.json().then(function (json) {
						Object(GlobalMetaActions["j" /* setGlobalNotification */])(dispatch, json, response);
					});
				} catch (e) {
					Object(GlobalMetaActions["j" /* setGlobalNotification */])(dispatch, {}, response);
				}
				dispatch(Object(GlobalMetaActions["h" /* refreshPage */])());
			} else {
				response.json().then(function (json) {
					if (json.result.username && json.result.userid) {
						var title = "Ban User Confirmation",
						    content = renderConfirm(type, json.result);
						var props = { type: type, userid: json.result.userid };
						dispatch(Object(UiActions["N" /* showConfirmModal */])(title, content, function () {
							return sendBanConfirmation(props, dispatch);
						}));
					}
				});
			}
		}).then(function () {
			dispatch(Object(UiActions["D" /* hideGlobalLoading */])());
		}).catch(function (error) {
			dispatch(Object(UiActions["D" /* hideGlobalLoading */])());
			Object(GlobalMetaActions["j" /* setGlobalNotification */])(dispatch, {}, error);
			dispatch(Object(GlobalMetaActions["h" /* refreshPage */])());
		});
	};
}

/**
 * Sends data to Ban User
 *
 * @param banneduserId
 * @param type
 * @param data
 * @returns {Function}
 */
function ModToolsActions_banUser(banneduserId, type, data) {
	return function (dispatch, getState) {
		if (!banneduserId) {
			topifyConsole.warn('Ban user - User id not provided', banneduserId);
			return;
		}
		topifyConsole.log('Ban user', banneduserId, type, data);

		var state = getState(),
		    url = state.topifyPresets.forumSite.url,
		    userID = state.ustate.id ? state.ustate.id : 0,
		    ban_type = type + 'ban';

		var moreData = 'type=moderate_user&action=' + ban_type + '&req=post&userid=' + banneduserId;
		for (var field in data) {
			if (data.hasOwnProperty(field)) {
				moreData += '&' + field + '=' + encodeURIComponent(data[field]);
			}
		}

		var fetchConfig = dispatch(Object(GlobalMetaActions["e" /* getFetchConfig */])(true, 'POST', moreData));

		dispatch(Object(UiActions["O" /* showGlobalLoading */])('Processing'));

		return fetch(url + ('?v=3.0&ajax=1&uid=' + userID + '&req=post'), fetchConfig).then(function (response) {
			if (!response.ok) {
				try {
					response.json().then(function (json) {
						Object(GlobalMetaActions["j" /* setGlobalNotification */])(dispatch, json, response);
					});
				} catch (e) {
					Object(GlobalMetaActions["j" /* setGlobalNotification */])(dispatch, {}, response);
				}
			} else {
				response.json().then(function (json) {
					if (json.result && json.result.username && json.result.userid) {
						Object(GlobalMetaActions["j" /* setGlobalNotification */])(dispatch, json, { ok: true });
						var message = json.result.message.text ? react_default.a.createElement(
							'span',
							null,
							'Result: ',
							json.result.message.text
						) : 'User "' + json.result.username + '" has been banned ' + (json.result.message.lift ? 'until ' + json.result.message.lift : 'permanently'),
						    notificationType = 'success';
						Object(UiActions["B" /* displayNotification */])(notificationType, message);
					} else {
						Object(UiActions["B" /* displayNotification */])('warning', 'Some error happened. Try again.');
					}
				});
			}
		}).then(function () {
			dispatch(Object(GlobalMetaActions["h" /* refreshPage */])());
			dispatch(Object(UiActions["D" /* hideGlobalLoading */])());
		}).catch(function (error) {
			dispatch(Object(UiActions["D" /* hideGlobalLoading */])());
			Object(GlobalMetaActions["j" /* setGlobalNotification */])(dispatch, {}, error);
			dispatch(Object(GlobalMetaActions["h" /* refreshPage */])());
		});
	};
}

/**
 * Verifies form, get form data and dispatch sending the data
 * @param props
 * @param dispatch
 * @returns {boolean}
 */
function sendBanConfirmation(props, dispatch) {
	var error = false,
	    data = {},
	    form = document.getElementsByClassName('banUserForm');
	form = form && form.length > 0 ? form[0] : null;

	if (form) {
		var selectFields = form.getElementsByTagName('select'),
		    inputFields = form.getElementsByTagName('input');

		// selectFields is a HTMLCollection, we convert it to an array to allow map
		[].slice.call(selectFields).map(function (el) {
			if (el.name && el.value) {
				data[el.name] = el.value;
			}
		});
		// inputFields is a HTMLCollection, we convert it to an array to allow map
		[].slice.call(inputFields).map(function (el) {
			if (el.name) {
				if (el.required && !el.value) {
					Object(UiActions["B" /* displayNotification */])('warning', 'Please fill mandatory fields.');
					el.parentNode.classList.add('required-incomplete');
					error = true;
				} else {
					data[el.name] = el.value;
				}
			}
		});

		if (error) {
			return false;
		} else {
			dispatch(Object(UiActions["O" /* showGlobalLoading */])('Processing'));
			dispatch(Object(adsActions["A" /* trackGAEvent */])(false, 'modBanUser_' + (props.type ? props.type : 'simple'), 'moderatorAction', 'banUser'));
			dispatch(ModToolsActions_banUser(props.userid, props.type, data));
			return true;
		}
	}
	return false;
}
// CONCATENATED MODULE: ./src/components/header/LoadingComponent.js


var LoadingComponent_LoadingComponent = function LoadingComponent(_ref) {
	var text = _ref.text;

	return react_default.a.createElement(
		'div',
		null,
		text || 'Loading',
		react_default.a.createElement(
			'span',
			{ className: 'loadingdot bounce1' },
			'.'
		),
		react_default.a.createElement(
			'span',
			{ className: 'loadingdot bounce2' },
			'.'
		),
		react_default.a.createElement(
			'span',
			{ className: 'loadingdot' },
			'.'
		)
	);
};

/* harmony default export */ var header_LoadingComponent = (LoadingComponent_LoadingComponent);
// CONCATENATED MODULE: ./src/components/header/HeaderComponent.js
var HeaderComponent__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var HeaderComponent__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function HeaderComponent__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function HeaderComponent__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function HeaderComponent__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




























var HeaderComponent_HeaderComponent = function (_React$Component) {
	HeaderComponent__inherits(HeaderComponent, _React$Component);

	function HeaderComponent(props) {
		HeaderComponent__classCallCheck(this, HeaderComponent);

		var _this = HeaderComponent__possibleConstructorReturn(this, (HeaderComponent.__proto__ || Object.getPrototypeOf(HeaderComponent)).call(this, props));

		_this.handleHamburgerClick = function () {
			if (_this.props.ui.sidebarOpened) {
				_this.props.dispatch(Object(react_router_redux_lib["goBack"])());
				_this.props.dispatch(Object(UiActions["V" /* sidebarOff */])());
			} else {
				_this.props.dispatch(Object(UiActions["W" /* sidebarOn */])());
			}
			// Record the Google Analytics event.
			_this.props.dispatch(Object(adsActions["A" /* trackGAEvent */])(false, 'sideMenu', 'uiAction', 'header'));
		};

		_this.handleSearchBarClick = function () {
			_this.props.dispatch(Object(UiActions["Y" /* toggleSearchBar */])());
			// Record the Google Analytics event.
			_this.props.dispatch(Object(adsActions["A" /* trackGAEvent */])(false, 'searchBar', 'uiAction', 'header'));
		};

		_this.handleMoreActionsClick = function () {
			_this.props.dispatch(Object(UiActions["X" /* toggleHeaderOverflow */])());
			// Record the Google Analytics event.
			_this.props.dispatch(Object(adsActions["A" /* trackGAEvent */])(false, 'overflowMenu', 'uiAction', 'header'));
		};

		_this.replyTo = function (event) {
			var options = {
				type: event.currentTarget.dataset.type,
				id: _this.currentPath[2]
			};

			_this.props.dispatch(Object(UiActions["M" /* resetOverlay */])());

			// get data we need
			if (_this.currentPath.length) {
				var userInfo = {};
				switch (_this.currentPath[1]) {
					case 'pms':
						if (options.type === 'newMessage') {
							delete options.id;
						}
						break;

					case 'pm':
						userInfo = _this.props.dispatch(Object(ContextInfoActions["r" /* messageTo */])(options.id));
						options = HeaderComponent__extends({}, options, { user: userInfo });
						break;

					case 'userprofile':
						userInfo = _this.props.dispatch(Object(ContextInfoActions["m" /* getUserInfo */])(options.id));
						options = HeaderComponent__extends({}, options, { user: userInfo });
						break;
				}
			}

			_this.props.dispatch(Object(UiActions["Q" /* showReplyModal */])(options));

			// Record the Google Analytics event.
			_this.props.dispatch(Object(adsActions["A" /* trackGAEvent */])(false, 'replyTo_' + options.type, 'uiAction', 'header'));
		};

		_this.deleteSelectedPosts = function (event) {
			var type = event.currentTarget.dataset.type;

			_this.props.dispatch(Object(UiActions["M" /* resetOverlay */])());

			var title = (type === 'delete' ? 'Delete' : 'Restore') + ' Post' + (_this.selectedItems > 1 ? 's' : ''),
			    question = 'Are you sure you want to ' + (type === 'delete' ? 'delete' : 'restore') + ' ' + (_this.selectedItems > 1 ? 'these ' + _this.selectedItems : 'the') + ' selected post' + (_this.selectedItems > 1 ? 's' : '') + '?';
			_this.props.dispatch(Object(UiActions["N" /* showConfirmModal */])(title, question, function () {
				return _this.props.dispatch(Object(ThreadviewActions["c" /* deletePosts */])(Object.keys(_this.props.selectedElements), type === 'delete'));
			}));
			// Record the Google Analytics event.
			_this.props.dispatch(Object(adsActions["A" /* trackGAEvent */])(false, type === 'delete' ? 'deletePosts' : 'undeletePosts', 'uiAction', 'header'));
		};

		_this.deleteSelectedPms = function () {
			var isFolder = _this.currentPath[1] === 'pms',
			    selectedPMs = isFolder ? Object.keys(_this.props.selectedElements) : [_this.currentPath[2]];

			_this.props.dispatch(Object(UiActions["M" /* resetOverlay */])());

			var title = 'Delete PM' + (isFolder && _this.selectedItems > 1 ? 's' : ''),
			    question = 'Are you sure you want to delete ' + (isFolder && _this.selectedItems > 1 ? 'these ' + _this.selectedItems : 'the') + ' ' + (!isFolder ? '' : 'selected') + ' Message' + (isFolder && _this.selectedItems > 1 ? 's' : '') + '?';
			_this.props.dispatch(Object(UiActions["N" /* showConfirmModal */])(title, question, function () {
				return _this.props.dispatch(Object(MessagesviewActions["c" /* deletePms */])(selectedPMs, isFolder));
			}));
			// Record the Google Analytics event.
			_this.props.dispatch(Object(adsActions["A" /* trackGAEvent */])(false, 'deletePM', 'uiAction', 'header'));
		};

		_this.moveSelectedPms = function () {
			var selectedPMs = Object.keys(_this.props.selectedElements),
			    folderList = _this.props.dispatch(Object(ContextInfoActions["k" /* getPmFolders */])()),
			    otherFolders = Object.keys(folderList).filter(function (f) {
				return folderList[f].movableitems && parseInt(f) !== parseInt(_this.currentPath[2]);
			}),
			    folderSelect = [];

			if (folderList[_this.currentPath[2]].movableitems !== true) {
				Object(UiActions["B" /* displayNotification */])('warning', 'You cannot move messages from "' + folderList[_this.currentPath[2]].name + '" folder');
				return;
			}

			if (otherFolders.length <= 0) {
				Object(UiActions["B" /* displayNotification */])('warning', 'You don\'t have messages folders');
				return;
			}

			if (selectedPMs.length <= 0) {
				return;
			}

			otherFolders.map(function (fid) {
				var folder = folderList[fid],
				    textOp = simpleDecodeEntities(folder.name) + ' ( ' + folder.count + ' message' + (folder.count === 1 ? '' : 's') + ' )',
				    op = react_default.a.createElement(
					'option',
					{ key: 'folder_' + folder.id, value: folder.id },
					textOp
				);
				folderSelect.push(op);
			});

			var title = "Move Messages",
			    content = react_default.a.createElement(
				'div',
				null,
				react_default.a.createElement(
					'p',
					null,
					'Where do you want to move ',
					selectedPMs.length > 1 ? 'them' : 'it',
					'? '
				),
				react_default.a.createElement(
					'div',
					{ className: 'styled-field folderList' },
					react_default.a.createElement(
						'select',
						{ ref: function ref(f) {
								return _this.selectFolder = f;
							} },
						folderSelect
					)
				)
			);

			_this.props.dispatch(Object(UiActions["N" /* showConfirmModal */])(title, content, function () {
				return _this.props.dispatch(Object(MessagesviewActions["f" /* movePMs */])(selectedPMs, _this.selectFolder.value));
			}));
		};

		_this.markPmsAsRead = function (event) {
			var read = event.currentTarget.dataset.type === 'read';

			_this.props.dispatch(Object(UiActions["M" /* resetOverlay */])());
			_this.props.dispatch(Object(MessagesviewActions["e" /* markAsReadPM */])(Object.keys(_this.props.selectedElements), read));
			// Record the Google Analytics event.
			_this.props.dispatch(Object(adsActions["A" /* trackGAEvent */])(false, 'markMessageAsRead', 'uiAction', 'header', read ? 1 : 0));
		};

		_this.markThreadsAsRead = function () {
			_this.props.dispatch(Object(UiActions["M" /* resetOverlay */])());
			_this.props.dispatch(Object(ThreadviewActions["f" /* markAsRead */])(Object.keys(_this.props.selectedElements), 'topics'));
			// Record the Google Analytics event.
			_this.props.dispatch(Object(adsActions["A" /* trackGAEvent */])(false, 'markThreadsAsRead', 'uiAction', 'header'));
		};

		_this.openCloseThisThread = function (event) {
			var open = event.currentTarget.dataset.type === 'open',
			    threadid = _this.currentPath[2];

			_this.props.dispatch(Object(UiActions["M" /* resetOverlay */])());
			_this.props.dispatch(openCloseThread(threadid, open));
			// Record the Google Analytics event.
			_this.props.dispatch(Object(adsActions["A" /* trackGAEvent */])(false, 'openCloseThread', 'uiAction', 'header', open ? 1 : 0));
		};

		_this.clearSelectedItems = function () {
			_this.props.dispatch(Object(UiActions["M" /* resetOverlay */])());
			_this.props.dispatch(Object(MetaActions["c" /* resetSelectedItem */])());
			// Record the Google Analytics event.
			_this.props.dispatch(Object(adsActions["A" /* trackGAEvent */])(false, 'clearSelected', 'uiAction', 'header'));
		};

		_this.navigateBack = function () {
			_this.props.dispatch(Object(react_router_redux_lib["goBack"])());
		};

		_this.shareLink = function () {
			_this.props.dispatch(Object(UiActions["T" /* showShareModal */])());
		};

		_this.reportSelectedPost = function () {
			var title = "Reporting post",
			    content = react_default.a.createElement(
				'div',
				null,
				react_default.a.createElement(
					'p',
					null,
					'Are you sure you want to report this post?'
				),
				react_default.a.createElement('input', { id: 'reason', type: 'text', placeholder: 'Reason for reporting' })
			);
			_this.props.dispatch(Object(UiActions["N" /* showConfirmModal */])(title, content, function () {
				return _this.props.dispatch(Object(ThreadviewActions["g" /* reportPost */])(Object.keys(_this.props.selectedElements)[0]));
			}));
		};

		_this.goToUserCP = function () {
			_this.props.dispatch(Object(react_router_redux_lib["push"])('/usercp'));
		};

		_this.selectedItems = 0;
		_this.rightIcons = new Map();
		_this.prevRightIcons = [];
		_this.showOverfloMenu = true;
		_this.currentPath = [];
		_this.iconsMustUpdate = true;
		return _this;
	}

	HeaderComponent__createClass(HeaderComponent, [{
		key: 'componentDidMount',
		value: function componentDidMount() {
			this.currentPath = Object(NavHelpers["a" /* parsePath */])(this.props.routing.locationBeforeTransitions.pathname);
		}
	}, {
		key: 'shouldComponentUpdate',
		value: function shouldComponentUpdate(nextProps) {
			this.iconsMustUpdate = this.selectedItems !== Object.keys(nextProps.selectedElements).length || !isEqual_default()(nextProps.userPermissions, this.props.userPermissions) || this.props.routing.locationBeforeTransitions.pathname !== nextProps.routing.locationBeforeTransitions.pathname || this.props.isLoading !== nextProps.isLoading || this.props.isFetchingAny !== nextProps.isFetchingAny;

			return this.props.title !== nextProps.title || this.props.subTitle !== nextProps.subTitle || this.iconsMustUpdate;
		}
	}, {
		key: 'componentWillUpdate',
		value: function componentWillUpdate(nextProps) {
			this.selectedItems = Object.keys(nextProps.selectedElements).length;

			if (this.props.routing.locationBeforeTransitions.pathname !== nextProps.routing.locationBeforeTransitions.pathname) {
				this.rightIcons.clear(); // reset previous options
				this.currentPath = Object(NavHelpers["a" /* parsePath */])(nextProps.routing.locationBeforeTransitions.pathname);
			}
		}

		/* Event handlers */

	}, {
		key: 'buildLeftIcons',


		/* Build icons */
		value: function buildLeftIcons() {
			return this.selectedItems > 0 ? react_default.a.createElement(
				'div',
				{ key: 'back', className: 'buttons', onClick: this.clearSelectedItems },
				react_default.a.createElement(svg_SvgIcon, { icon: 'arrow_back', size: '24px' })
			) : react_default.a.createElement(
				'div',
				{ key: 'hamburger', className: 'buttons', onClick: this.handleHamburgerClick },
				react_default.a.createElement(svg_SvgIcon, { icon: 'hamburger', size: '24px' })
			);
		}

		// Options showed here as icons should not be on the overflow menu (HeaderOverFlowComponent), le's avoid duplications

	}, {
		key: 'buildRightIcons',
		value: function buildRightIcons() {
			var _this2 = this;

			var activeIcons = {},
			    options = [],
			    icon = null;

			this.showOverfloMenu = true;

			// if isFetching do not change icons
			if (this.iconsMustUpdate && this.props.isLoading !== true) {
				var path = this.currentPath[1] || this.currentPath[0];
				// Set icons defaulted to no show unless we can easily set them up.
				// WARNING! The order set here will be order shown in header so keep it
				this.rightIcons.set('newTopic', {
					show: false,
					className: "",
					type: "newTopic",
					onclick: this.replyTo,
					icon: 'add_circle'
				});
				this.rightIcons.set('replyQuoting', {
					show: false,
					className: "",
					type: "replyQuoting",
					onclick: this.replyTo,
					icon: 'quote'
				});
				this.rightIcons.set('replyToThread', {
					show: false,
					className: "",
					type: "replyPost",
					onclick: this.replyTo,
					icon: 'add_circle'
				});
				this.rightIcons.set('editPost', {
					show: false,
					className: "",
					type: "editPost",
					onclick: this.replyTo,
					icon: 'edit'
				});
				this.rightIcons.set('deletePosts', {
					show: false,
					className: "",
					type: 'delete',
					onclick: this.deleteSelectedPosts,
					icon: 'delete'
				});
				this.rightIcons.set('unDeletePosts', {
					show: false,
					className: "",
					type: 'restore',
					onclick: this.deleteSelectedPosts,
					icon: 'restore'
				});
				this.rightIcons.set('reportPost', {
					show: false,
					className: "",
					type: null,
					onclick: this.reportSelectedPost,
					icon: 'warning'
				});
				this.rightIcons.set('closeThread', {
					show: false,
					className: "modTools",
					type: "close",
					onclick: this.openCloseThisThread,
					icon: 'lock_close'
				});
				this.rightIcons.set('openThread', {
					show: false,
					className: "modTools",
					type: "open",
					onclick: this.openCloseThisThread,
					icon: 'lock_open'
				});
				this.rightIcons.set('newMessage', {
					show: false,
					className: "",
					type: "newMessage",
					onclick: this.replyTo,
					icon: 'add_circle'
				});
				this.rightIcons.set('markThreadAsRead', {
					show: false,
					className: "",
					type: "read",
					onclick: this.markThreadsAsRead,
					icon: 'mark_read'
				});
				this.rightIcons.set('markPMAsRead', {
					show: false,
					className: "",
					type: "read",
					onclick: this.markPmsAsRead,
					icon: 'mark_read'
				});
				this.rightIcons.set('markPMAsUnRead', {
					show: false,
					className: "",
					type: "unread",
					onclick: this.markPmsAsRead,
					icon: 'mark_unread'
				});
				this.rightIcons.set('movePMs', {
					show: false,
					className: "",
					type: null,
					onclick: this.moveSelectedPms,
					icon: 'folder'
				});
				this.rightIcons.set('replyMessageQuoting', {
					show: false,
					className: "",
					type: "replyMessageQuoting",
					onclick: this.replyTo,
					icon: 'quote'
				});
				this.rightIcons.set('replyMessage', {
					show: false,
					className: "",
					type: "replyMessage",
					onclick: this.replyTo,
					icon: 'reply'
				});
				this.rightIcons.set('deletePms', {
					show: false,
					className: "",
					type: null,
					onclick: this.deleteSelectedPms,
					icon: 'delete'
				});
				this.rightIcons.set('userCP', {
					show: false,
					className: "",
					type: null,
					onclick: this.goToUserCP,
					icon: 'settings2'
				});
				this.rightIcons.set('newMessageUserProfile', {
					show: false,
					className: "",
					type: "newMessage",
					onclick: this.replyTo,
					icon: 'message'
				});
				// checkok can be set by path
				this.rightIcons.set('checkok', {
					show: path === 'settings',
					className: "",
					type: null,
					onclick: this.navigateBack,
					icon: 'check'
				});
				// share can be set by path
				this.rightIcons.set('share', {
					show: /\//.test(path),
					className: "",
					type: null,
					onclick: this.shareLink,
					icon: 'share'
				});
				// search can be set by path

				// if we don't have new 'home' then we allow search on index forums = '/'
				var searchAllowedByPath = {"version":"1.0.0","IndexRoute":"index","section":{"home":false}}.section.home === true ? /forums|search|topics/.test(path) : /\/|forums|search|topics/.test(path);
				this.rightIcons.set('search', {
					show: this.props.userPermissions && this.props.userPermissions.search && searchAllowedByPath,
					className: "",
					type: null,
					onclick: this.handleSearchBarClick,
					icon: 'search'
				});

				// Check icons show/hide per path
				switch (path) {
					case 'forums':
						activeIcons.newTopic = this.props.dispatch(Object(ContextInfoActions["a" /* canCreateThread */])()) && this.selectedItems <= 0;
						activeIcons.share = this.selectedItems <= 0;
						activeIcons.markThreadAsRead = this.selectedItems > 0;
						break;

					case 'topics':
						var canIReplyThread = this.props.dispatch(Object(ContextInfoActions["f" /* canReplyThread */])()),
						    threadOpenClosePerms = this.props.dispatch(Object(ContextInfoActions["e" /* canOpenCloseThread */])());

						activeIcons.deletePosts = canIReplyThread && this.selectedItems > 0 && this.props.dispatch(Object(ContextInfoActions["b" /* canDeletePosts */])(false));
						activeIcons.unDeletePosts = canIReplyThread && this.selectedItems > 0 && this.props.dispatch(Object(ContextInfoActions["b" /* canDeletePosts */])(true));
						activeIcons.replyQuoting = activeIcons.unDeletePosts === false && canIReplyThread && this.selectedItems > 0;
						activeIcons.replyToThread = canIReplyThread;
						activeIcons.editPost = canIReplyThread && this.selectedItems === 1 && this.props.dispatch(Object(ContextInfoActions["d" /* canEditPost */])(Object.keys(this.props.selectedElements)[0]));
						activeIcons.reportPost = activeIcons.unDeletePosts === false && this.selectedItems === 1 && this.props.dispatch(Object(ContextInfoActions["g" /* canReportPost */])());
						activeIcons.closeThread = threadOpenClosePerms === true && this.selectedItems === 0;
						activeIcons.openThread = threadOpenClosePerms === false && this.selectedItems === 0;
						activeIcons.share = threadOpenClosePerms !== true && this.selectedItems === 0;
						break;

					case 'pms':
						var _markAsRead = this.selectedItems > 0 && this.props.dispatch(Object(ContextInfoActions["v" /* selectedPMsUnread */])(true)),
						    folderList = this.selectedItems ? this.props.dispatch(Object(ContextInfoActions["k" /* getPmFolders */])()) : [],
						    foldersCanMove = Object.keys(folderList).filter(function (f) {
							return folderList[f].movableitems && parseInt(f) !== parseInt(_this2.currentPath[2]);
						});

						activeIcons.newMessage = this.props.userPermissions && this.props.userPermissions.cansendmessages;
						activeIcons.deletePms = this.selectedItems > 0;
						activeIcons.movePMs = this.selectedItems > 0 && folderList[this.currentPath[2]] && folderList[this.currentPath[2]].movableitems && foldersCanMove.length > 0;
						activeIcons.markPMAsRead = this.selectedItems > 0 && _markAsRead;
						activeIcons.markPMAsUnRead = this.selectedItems > 0 && !_markAsRead;
						break;

					case 'pm':
						activeIcons.replyMessageQuoting = this.props.userPermissions && this.props.userPermissions.cansendmessages;
						activeIcons.replyMessage = this.props.userPermissions && this.props.userPermissions.cansendmessages;
						activeIcons.deletePms = true;
						break;

					case 'userprofile':
						var current_User = this.props.dispatch(Object(ContextInfoActions["i" /* currentUser */])()),
						    selected_user = parseInt(this.currentPath[2]);

						activeIcons.userCP = current_User.id === selected_user;
						activeIcons.newMessageUserProfile = !(parseInt(current_User.id) === selected_user);
						break;

					case 'search':
						break;

					case 'following':
					case 'participated':
					case 'latest':
					case 'updated':
						activeIcons.markThreadAsRead = this.selectedItems > 0;
						break;

					case 'register':
						this.showOverfloMenu = false;
						break;

					case 'settings':
						this.showOverfloMenu = false;
						break;
				}

				// Create the array with the icons
				this.rightIcons.forEach(function (value, key) {
					if (value.show || activeIcons[key] === true) {
						icon = react_default.a.createElement(
							'div',
							{ key: key, className: 'buttons ' + value.className, 'data-type': value.type,
								onClick: value.onclick },
							react_default.a.createElement(svg_SvgIcon, { icon: value.icon, size: '24px' })
						);
						options.push(icon);
					}
				});

				this.prevRightIcons = options;
			}

			return this.prevRightIcons;
		}
	}, {
		key: 'getHeaderTitle',
		value: function getHeaderTitle() {
			var _props = this.props,
			    title = _props.title,
			    subTitle = _props.subTitle;


			var titleText = this.props.isLoading ? react_default.a.createElement(header_LoadingComponent, { text: 'Loading' }) : RawToReact(title);

			return this.selectedItems > 0 ? react_default.a.createElement(
				'div',
				{ className: 'title' },
				react_default.a.createElement(
					'div',
					{ className: 'titleBottom' },
					this.selectedItems
				)
			) : react_default.a.createElement(
				'div',
				{ className: 'title' },
				react_default.a.createElement(
					'div',
					{ className: 'titleTop' },
					subTitle ? RawToReact(subTitle) : ""
				),
				react_default.a.createElement(
					'div',
					{ className: 'titleBottom' },
					titleText
				)
			);
		}
	}, {
		key: 'render',
		value: function render() {
			var leftIcons = this.buildLeftIcons(),
			    rightIcons = this.buildRightIcons(),
			    headerTitle = this.getHeaderTitle(),
			    overFlowMenu = this.showOverfloMenu ? react_default.a.createElement(
				'div',
				{ className: 'buttons', onClick: this.handleMoreActionsClick },
				react_default.a.createElement(svg_SvgIcon, { icon: 'more_vert', size: '24px' })
			) : null;

			return react_default.a.createElement(
				'header',
				{ id: 'header', className: 'primary nolinks' },
				react_default.a.createElement(
					'div',
					{ className: 'buttons-container leftHeaderIcons' },
					leftIcons
				),
				headerTitle,
				react_default.a.createElement(
					'div',
					{ className: 'buttons-container ' + (this.props.isLoading ? 'hidden' : '') + ' ' },
					rightIcons
				),
				overFlowMenu
			);
		}
	}]);

	return HeaderComponent;
}(react_default.a.Component);

HeaderComponent_HeaderComponent.propTypes = {
	title: prop_types_default.a.string.isRequired,
	subTitle: prop_types_default.a.string
};

/* harmony default export */ var header_HeaderComponent = (Object(es["b" /* connect */])(headerSelector)(HeaderComponent_HeaderComponent));
// EXTERNAL MODULE: ./src/styles/header_overflow.scss
var header_overflow = __webpack_require__(778);
var header_overflow_default = /*#__PURE__*/__webpack_require__.n(header_overflow);

// CONCATENATED MODULE: ./src/components/modtools/banUserConfirmation.js


/**
 * Creates the confirmation ban user form
 * @param content
 * @param type
 * @returns {XML}
 */
var banUserConfirmation_banUserConfirmation = function banUserConfirmation(_ref) {
	var content = _ref.content,
	    type = _ref.type;

	var title = type === '' ? react_default.a.createElement(
		'p',
		null,
		'You are about to ban the user ',
		react_default.a.createElement(
			'strong',
			null,
			content.username
		),
		' (id:',
		content.userid,
		')'
	) : react_default.a.createElement(
		'p',
		null,
		'You are about to perform the following actions concerning the user ',
		react_default.a.createElement(
			'strong',
			null,
			content.username
		),
		' (id:',
		content.userid,
		')'
	),
	    form = [],
	    field = [],
	    lines_el = [],
	    li = null,
	    option = null,
	    key_counter = 0;

	content.message.map(function (line) {
		field = null;
		var data = line.data,
		    label = data['label'] ? data['label'].replace(/<br\s+[/]?\s*>/g, '').replace(/\s*:\s*$/, '') : null;

		key_counter++;

		switch (line.type) {
			case 'text':
				lines_el = [];
				if (typeof data['text'] !== 'string' && data['text'].length > 0) {
					data['text'].map(function (text) {
						// Cleaning
						text = text.replace(/<br\s+[/]?\s*>/, '');
						var el = react_default.a.createElement(
							'span',
							{ className: 'text', key: key_counter },
							text,
							react_default.a.createElement('br', null)
						);
						lines_el.push(el);
						key_counter++;
					});
				} else {
					lines_el = data['text'].replace(/<br\s+[/]?\s*>/g, '');
				}

				field = react_default.a.createElement(
					'p',
					{ key: key_counter, className: 'styled-field' },
					lines_el
				);
				form.push(field);
				break;

			case 'input':
				field = react_default.a.createElement(
					'p',
					{ key: key_counter, className: 'field styled-field' },
					react_default.a.createElement(
						'label',
						{ className: 'field-label' },
						label,
						': ',
						react_default.a.createElement('input', { name: line['name'], required: data['required'] ? 'required' : false, placeholder: data['placeholder'], defaultValue: data['value'] ? data['value'] : null })
					)
				);
				form.push(field);
				break;

			case 'select':
				lines_el = [];
				for (option in data['options']) {
					if (data['options'].hasOwnProperty(option)) {
						li = react_default.a.createElement(
							'option',
							{ key: key_counter + '_' + option, value: option },
							data['options'][option]
						);
						lines_el.push(li);
					}
				}
				field = react_default.a.createElement(
					'p',
					{ key: key_counter, className: 'styled-field' },
					label,
					': ',
					react_default.a.createElement(
						'select',
						{ name: line['name'], defaultValue: data['value'] ? data['value'] : null },
						lines_el
					)
				);
				form.push(field);
				break;
		}
	});

	return react_default.a.createElement(
		'div',
		{ className: 'banUserForm' },
		title,
		form,
		react_default.a.createElement(
			'p',
			null,
			'Please confirm your intentions'
		)
	);
};

/* harmony default export */ var modtools_banUserConfirmation = (banUserConfirmation_banUserConfirmation);
// CONCATENATED MODULE: ./src/components/header/HeaderOverflowComponent.js
var HeaderOverflowComponent__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function HeaderOverflowComponent__toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function HeaderOverflowComponent__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function HeaderOverflowComponent__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function HeaderOverflowComponent__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
























var HeaderOverflowComponent_HeaderOverflow = function (_React$Component) {
	HeaderOverflowComponent__inherits(HeaderOverflow, _React$Component);

	function HeaderOverflow(props) {
		HeaderOverflowComponent__classCallCheck(this, HeaderOverflow);

		var _this = HeaderOverflowComponent__possibleConstructorReturn(this, (HeaderOverflow.__proto__ || Object.getPrototypeOf(HeaderOverflow)).call(this, props));

		_this.callMarkAsRead = function () {
			switch (_this.currentPath[1] || _this.currentPath[0]) {
				case '/':
				case 'forums':
					var id = _this.currentPath[2] || '-1';
					_this.props.dispatch(Object(ThreadviewActions["f" /* markAsRead */])(id, 'forums'));
					break;

				case 'following':
				case 'participated':
				case 'latest':
				case 'updated':
					var items = _this.props.dispatch(Object(ContextInfoActions["u" /* selectedItemsUnread */])());
					if (items && items.unreadItems.length) {
						_this.props.dispatch(Object(ThreadviewActions["f" /* markAsRead */])(items.unreadItems, items.entity));
					}
					_this.props.dispatch(Object(UiActions["M" /* resetOverlay */])());
					break;

				case 'pms':
					_this.props.dispatch(Object(UiActions["M" /* resetOverlay */])());
					_this.props.dispatch(Object(MessagesviewActions["e" /* markAsReadPM */])(_this.currentPath[2], true, true));
					break;
			}
			// Record the Google Analytics event.
			_this.props.dispatch(Object(adsActions["A" /* trackGAEvent */])(false, 'markAsRead_' + (_this.currentPath[1] || 'index'), 'uiAction', 'overflow'));
		};

		_this.moveSelectedPms = function () {
			var selectedPMs = [_this.currentPath[2]],
			    messageFolder = _this.props.dispatch(Object(ContextInfoActions["h" /* currentPMFolder */])(parseInt(_this.currentPath[2]))),
			    folderList = _this.props.dispatch(Object(ContextInfoActions["k" /* getPmFolders */])()),
			    otherFolders = Object.keys(folderList).filter(function (f) {
				return folderList[f].movableitems && parseInt(f) !== parseInt(messageFolder.id);
			}),
			    folderSelect = [];

			if (folderList[messageFolder.id].movableitems !== true) {
				Object(UiActions["B" /* displayNotification */])('warning', 'You cannot move messages from "' + folderList[messageFolder.id].name + '" folder');
				return;
			}

			if (otherFolders.length <= 0) {
				Object(UiActions["B" /* displayNotification */])('warning', 'You don\'t have messages folders');
				return;
			}

			if (selectedPMs.length <= 0) {
				return;
			}

			otherFolders.map(function (fid) {
				var folder = folderList[fid],
				    textOp = simpleDecodeEntities(folder.name) + ' ( ' + folder.count + ' message' + (folder.count === 1 ? '' : 's') + ' )',
				    op = react_default.a.createElement(
					'option',
					{ key: 'folder_' + folder.id, value: folder.id },
					textOp
				);
				folderSelect.push(op);
			});

			var title = "Move Messages",
			    content = react_default.a.createElement(
				'div',
				null,
				react_default.a.createElement(
					'p',
					null,
					'Where do you want to move ',
					selectedPMs.length > 1 ? 'them' : 'it',
					'? '
				),
				react_default.a.createElement(
					'div',
					{ className: 'styled-field folderList' },
					react_default.a.createElement(
						'select',
						{ ref: function ref(f) {
								return _this.selectFolder = f;
							} },
						folderSelect
					)
				)
			);

			_this.props.dispatch(Object(UiActions["N" /* showConfirmModal */])(title, content, function () {
				return _this.props.dispatch(Object(MessagesviewActions["f" /* movePMs */])(selectedPMs, _this.selectFolder.value));
			}));
		};

		_this.currentPath = [];
		return _this;
	}

	HeaderOverflowComponent__createClass(HeaderOverflow, [{
		key: 'componentDidMount',
		value: function componentDidMount() {
			this.currentPath = Object(NavHelpers["a" /* parsePath */])(this.props.routing.locationBeforeTransitions.pathname);
		}
	}, {
		key: 'componentWillUpdate',
		value: function componentWillUpdate(nextProps) {
			if (this.props.routing.locationBeforeTransitions.pathname !== nextProps.routing.locationBeforeTransitions.pathname) {
				this.currentPath = Object(NavHelpers["a" /* parsePath */])(nextProps.routing.locationBeforeTransitions.pathname);
			}
		}
	}, {
		key: 'login',
		value: function login() {
			this.props.dispatch(Object(UiActions["M" /* resetOverlay */])());
			this.props.dispatch(Object(UiActions["P" /* showLoginModal */])());
			// Record the Google Analytics event.
			this.props.dispatch(Object(adsActions["A" /* trackGAEvent */])(false, 'login', 'uiAction', 'overflow'));
		}
	}, {
		key: 'refresh',
		value: function refresh() {
			this.props.dispatch(Object(GlobalMetaActions["h" /* refreshPage */])(true));
			// Record the Google Analytics event.
			this.props.dispatch(Object(adsActions["A" /* trackGAEvent */])(false, 'refresh', 'uiAction', 'overflow'));
		}
	}, {
		key: 'refreshWidgets',
		value: function refreshWidgets() {
			// Refresh all widgets
			this.props.dispatch(Object(WidgetActions["i" /* refreshWidget */])());
			this.props.dispatch(Object(UiActions["M" /* resetOverlay */])());

			// Record the Google Analytics event.
			this.props.dispatch(Object(adsActions["A" /* trackGAEvent */])(false, 'refresh_AllWidgets', 'uiAction', 'overflow'));
		}
	}, {
		key: 'settings',
		value: function settings() {
			this.props.dispatch(Object(react_router_redux_lib["push"])(Object(NavHelpers["o" /* pathToSettings */])()));
			// Record the Google Analytics event.
			this.props.dispatch(Object(adsActions["A" /* trackGAEvent */])(false, 'settings', 'uiAction', 'overflow'));
		}
	}, {
		key: 'goBack',
		value: function goBack() {
			this.props.dispatch(Object(react_router_redux_lib["goBack"])());
		}
	}, {
		key: 'deleteThread',
		value: function deleteThread(_deleteThread) {
			var _this2 = this;

			this.props.dispatch(Object(UiActions["M" /* resetOverlay */])());
			var title = (_deleteThread ? 'Restore' : 'Delete') + ' Topic',
			    question = 'Would you like to ' + (_deleteThread ? 'restore' : 'delete') + ' this topic?',
			    threadid = this.currentPath[2];

			this.props.dispatch(Object(UiActions["N" /* showConfirmModal */])(title, question, function () {
				return _this2.props.dispatch(deleteRestoreThread(threadid, _deleteThread));
			}));

			// Record the Google Analytics event.
			this.props.dispatch(Object(adsActions["A" /* trackGAEvent */])(false, 'deleteRestoreThread', 'uiAction', 'overflow', _deleteThread ? 1 : 0));
		}
	}, {
		key: 'subscribeTo',
		value: function subscribeTo() {
			var _this3 = this;

			var isSub = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

			var subType = '',
			    data = {};
			switch (this.currentPath[1]) {
				case 'forums':
					subType = 'Forum';
					data = {
						forum: {
							id: parseInt(this.currentPath[2]),
							isSubscribed: isSub
						}
					};
					break;

				case 'topics':
					subType = 'Topic';
					data = {
						thread: {
							id: parseInt(this.currentPath[2]),
							isSubscribed: isSub
						}
					};
					break;
			}

			data.ustate = this.props.dispatch(Object(ContextInfoActions["i" /* currentUser */])());

			this.props.dispatch(Object(UiActions["M" /* resetOverlay */])());

			if (isSub === 1) {
				this.props.dispatch(Object(UiActions["N" /* showConfirmModal */])('Unsubscribe', 'Would you like to unsubscribe from this ' + subType + '?', function () {
					return _this3.props.dispatch(Object(ForumviewActions["g" /* updateFollowing */])(data));
				}));
			} else {
				this.props.dispatch(Object(ForumviewActions["g" /* updateFollowing */])(data));
			}

			// Record the Google Analytics event.
			this.props.dispatch(Object(adsActions["A" /* trackGAEvent */])(false, 'subscribe_' + subType, 'uiAction', 'overflow'));
		}
	}, {
		key: 'banUser',
		value: function banUser(user_info, banType) {
			var _this4 = this;

			this.props.dispatch(Object(UiActions["M" /* resetOverlay */])());
			if (banType === 'unban') {
				var title = 'Lift Ban',
				    question = react_default.a.createElement(
					'p',
					null,
					'Are you sure you want to lift the ban on ',
					react_default.a.createElement(
						'strong',
						null,
						user_info.userName
					),
					'?'
				);
				this.props.dispatch(Object(UiActions["N" /* showConfirmModal */])(title, question, function () {
					return _this4.props.dispatch(liftUserBan(user_info.id));
				}));
			} else {
				this.props.dispatch(banUser_confirm(user_info.id, banType, function (type, content) {
					return react_default.a.createElement(modtools_banUserConfirmation, { type: type, content: content });
				}));
			}

			// Record the Google Analytics event.
			this.props.dispatch(Object(adsActions["A" /* trackGAEvent */])(false, 'banUser_' + (banType ? banType : 'simple'), 'uiAction', 'overflow'));
			this.props.dispatch(Object(adsActions["A" /* trackGAEvent */])(false, 'modBanUserConfirmation_' + (banType ? banType : 'simple'), 'moderatorAction', 'banUser'));
		}
	}, {
		key: 'shareLink',
		value: function shareLink() {
			this.props.dispatch(Object(UiActions["T" /* showShareModal */])());
		}
	}, {
		key: 'buildOptions',


		// Options showed as icons (HeaderComponent) should not be here, le's avoid duplications
		value: function buildOptions() {
			var _this5 = this;

			var isLoggedin = this.props.dispatch(Object(adsActions["q" /* isLoggedIn */])()),
			    options = [],
			    logIn = isLoggedin ? null : react_default.a.createElement(
				'li',
				{ key: 'login', onClick: function onClick() {
						return _this5.login();
					} },
				'Login'
			),
			    refresh = react_default.a.createElement(
				'li',
				{ key: 'refresh', onClick: function onClick() {
						return _this5.refresh();
					} },
				'Refresh'
			),
			    settings = react_default.a.createElement(
				'li',
				{ key: 'settings', onClick: function onClick() {
						return _this5.settings();
					} },
				'Settings'
			);

			if (this.currentPath && this.currentPath.length > 0) {
				switch (this.currentPath[1] || this.currentPath[0]) {
					case '/':
						if ({"version":"1.0.0","IndexRoute":"index","section":{"home":false}}.section.home === true) {
							refresh = false;
							options = [react_default.a.createElement(
								'li',
								{ key: 'refresh', onClick: function onClick() {
										return _this5.refreshWidgets();
									} },
								'Refresh'
							)];
						} else {
							options = [react_default.a.createElement(
								'li',
								{ key: 'markasread', onClick: this.callMarkAsRead },
								'Mark ',
								this.currentPath[2] ? 'forum ' : '',
								'as read'
							)];
						}
						break;

					case 'forums':
						if (isLoggedin) {
							options = [react_default.a.createElement(
								'li',
								{ key: 'markasread', onClick: this.callMarkAsRead },
								'Mark ',
								this.currentPath[2] ? 'forum ' : '',
								'as read'
							)];
							if (this.currentPath[2]) {
								var subscribe = this.props.dispatch(Object(ContextInfoActions["n" /* isSubscribedForum */])()) ? react_default.a.createElement(
									'li',
									{ key: 'subscribe', onClick: function onClick() {
											return _this5.subscribeTo(1);
										} },
									'Unsubscribe'
								) : react_default.a.createElement(
									'li',
									{ key: 'subscribe', onClick: function onClick() {
											return _this5.subscribeTo(0);
										} },
									'Subscribe'
								);
								options.push(subscribe);
							}
						}
						break;

					case 'topics':
						var share = react_default.a.createElement(
							'li',
							{ key: 'share', onClick: function onClick() {
									return _this5.shareLink();
								} },
							'Share this page'
						);
						if (isLoggedin) {
							options = [];

							var _subscribe = this.props.dispatch(Object(ContextInfoActions["o" /* isSubscribedThread */])()) ? react_default.a.createElement(
								'li',
								{ key: 'subscribe', onClick: function onClick() {
										return _this5.subscribeTo(1);
									} },
								'Unsubscribe'
							) : react_default.a.createElement(
								'li',
								{ key: 'subscribe', onClick: function onClick() {
										return _this5.subscribeTo(0);
									} },
								'Subscribe'
							);
							options.push(_subscribe);

							var threadDeletePerms = this.props.dispatch(Object(ContextInfoActions["c" /* canDeleteThread */])());
							if (threadDeletePerms !== null) {
								var deleteThread = threadDeletePerms ? react_default.a.createElement(
									'li',
									{ key: 'deleteThread', onClick: function onClick() {
											return _this5.deleteThread(false);
										} },
									'Delete topic'
								) : react_default.a.createElement(
									'li',
									{ key: 'restoreThread', onClick: function onClick() {
											return _this5.deleteThread(true);
										} },
									'Restore topic'
								);
								options.unshift(deleteThread);
							}

							var threadOpenClosePerms = this.props.dispatch(Object(ContextInfoActions["e" /* canOpenCloseThread */])());
							if (threadOpenClosePerms !== null) {
								options.unshift(share);
							}
						} else {
							options.unshift(share);
						}

						break;

					case 'following':
					case 'participated':
					case 'latest':
					case 'updated':
						options = [react_default.a.createElement(
							'li',
							{ key: 'markasread', onClick: this.callMarkAsRead },
							'Mark all as read'
						)];
						break;

					case 'pms':
						if (typeof this.currentPath[2] !== 'undefined') {
							options = [react_default.a.createElement(
								'li',
								{ key: 'markasread', onClick: this.callMarkAsRead },
								'Mark folder as read'
							)];
						}
						break;

					case 'pm':
						options = [];
						var messageFolder = this.props.dispatch(Object(ContextInfoActions["h" /* currentPMFolder */])(parseInt(this.currentPath[2]))),
						    folderList = this.props.dispatch(Object(ContextInfoActions["k" /* getPmFolders */])()),
						    foldersCanMove = Object.keys(folderList).filter(function (f) {
							return folderList[f].movableitems && parseInt(f) !== parseInt(messageFolder.id);
						});

						if (messageFolder && folderList[messageFolder.id].movableitems && foldersCanMove.length) {
							options = [react_default.a.createElement(
								'li',
								{ key: 'movePM', onClick: this.moveSelectedPms },
								'Move Message to folder'
							)];
						}
						break;

					case 'userprofile':
						var banUserOptions = [],
						    current_User = this.props.dispatch(Object(ContextInfoActions["i" /* currentUser */])()),
						    selected_user = parseInt(this.currentPath[2]),
						    selected_user_info = null;

						// ModTools
						if (this.props.userPermissions && this.props.userPermissions.modperms && current_User.id !== selected_user) {
							if (current_User && selected_user) {
								selected_user_info = this.props.dispatch(Object(ContextInfoActions["m" /* getUserInfo */])(selected_user));
							}
							if (selected_user_info) {
								if (!selected_user_info.is_banned && this.props.userPermissions.modperms.canbanusers) {
									banUserOptions = this.props.userPermissions.modperms.banuser_actions.map(function (banAction) {
										return react_default.a.createElement(
											'li',
											{ key: 'banUser' + banAction[1], onClick: function onClick() {
													return _this5.banUser(selected_user_info, banAction[1]);
												} },
											banAction[0]
										);
									});
								} else if (selected_user_info.is_banned && this.props.userPermissions.modperms.canunbanusers) {
									banUserOptions = [react_default.a.createElement(
										'li',
										{ key: 'unbanUser', onClick: function onClick() {
												return _this5.banUser(selected_user_info, 'unban');
											} },
										'Lift ban'
									)];
								}
							}
							if (banUserOptions.length > 0) {
								var _options;

								(_options = options).unshift.apply(_options, HeaderOverflowComponent__toConsumableArray(banUserOptions));
							}
						}
						break;

					case 'register':
						options = [];
						logIn = null;
						refresh = false;
						break;

					case 'settings':
						options = [react_default.a.createElement(
							'li',
							{ key: 'goback', onClick: function onClick() {
									return _this5.goBack();
								} },
							'Close Settings'
						)];
						refresh = false;
						settings = false;
						break;

					default:

				}
				// We'll have refresh everywhere unless we specifically avoid it
				if (refresh) {
					options.push(refresh);
				}
				// We'll have settings everywhere unless we specifically avoid it
				if (settings) {
					options.push(settings);
				}
			}

			return react_default.a.createElement(
				'ul',
				null,
				logIn,
				options
			);
		}
	}, {
		key: 'render',
		value: function render() {
			var opened = this.props.ui.headerOverflowOpened ? 'opened' : '',
			    options = this.props.ui.headerOverflowOpened ? this.buildOptions() : '';

			return react_default.a.createElement(
				'section',
				null,
				react_default.a.createElement(
					'div',
					{ id: 'headerOverFlow', className: 'overflow ' + opened },
					options
				)
			);
		}
	}]);

	return HeaderOverflow;
}(react_default.a.Component);

/* harmony default export */ var HeaderOverflowComponent = (Object(es["b" /* connect */])(headerSelector)(HeaderOverflowComponent_HeaderOverflow));
// EXTERNAL MODULE: ./src/styles/searchbar.scss
var searchbar = __webpack_require__(779);
var searchbar_default = /*#__PURE__*/__webpack_require__.n(searchbar);

// CONCATENATED MODULE: ./src/components/header/SearchBarComponent.js
var SearchBarComponent__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var SearchBarComponent__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function SearchBarComponent__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function SearchBarComponent__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function SearchBarComponent__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

















var SearchBarComponent_SearchBarComponent = function (_React$Component) {
	SearchBarComponent__inherits(SearchBarComponent, _React$Component);

	function SearchBarComponent(props) {
		SearchBarComponent__classCallCheck(this, SearchBarComponent);

		var _this = SearchBarComponent__possibleConstructorReturn(this, (SearchBarComponent.__proto__ || Object.getPrototypeOf(SearchBarComponent)).call(this, props));

		_this.updateSearchQuery = function (e) {
			_this.setState({
				searchQuery: e.target.value
			});
		};

		_this.updateSearchForumid = function (e) {
			var forumId = parseInt(e.target.value);

			_this.setState({
				forumId: forumId > 0 ? parseInt(_this.props.forumId) : null
			});
		};

		_this.updateFetchScope = function (e) {
			_this.setState(SearchBarComponent__extends({}, _this.state, {
				scope: {
					showposts: parseInt(e.target.value)
				}
			}));
		};

		_this.clearInput = function () {
			_this.setState({
				searchQuery: '',
				forumId: null
			});
			// Record the Google Analytics event.
			_this.props.dispatch(Object(adsActions["A" /* trackGAEvent */])(false, 'forumSearchClear', 'uiAction', 'cancel'));
		};

		_this.handleSearch = function (event) {
			event.preventDefault();

			_this.searchTextInput.blur();

			if (_this.state.searchQuery) {
				_this.props.dispatch(Object(InfiniteScrollActions["f" /* resetInfinite */])());
				_this.props.dispatch(Object(SearchResultActions["d" /* resetSearch */])());

				var query = {
					q: _this.state.searchQuery,
					showposts: _this.state.scope.showposts === 0 ? 0 : 1,
					page: 1,
					refresh: /^#\/search/.test(document.location.hash) ? 1 : null // if we are already on search add 'refresh' to querystring
				};
				if (_this.state.forumId) {
					query.forumid = _this.state.forumId;
				}

				_this.props.dispatch(Object(react_router_redux_lib["push"])({
					pathname: Object(NavHelpers["n" /* pathToSearch */])(0),
					query: query
				}));
			}
		};

		_this.state = {
			searchQuery: '',
			forumId: null,
			scope: {
				showposts: 0
			}
		};
		return _this;
	}

	SearchBarComponent__createClass(SearchBarComponent, [{
		key: 'render',
		value: function render() {
			var _this2 = this;

			var opened = this.props.isOpen ? 'opened' : '',
			    forumsDisabled = this.props.forumId && this.props.forumId > 0 ? '' : 'disabled';

			return react_default.a.createElement(
				'form',
				{ onSubmit: this.handleSearch },
				react_default.a.createElement(
					'div',
					{ id: 'searchbar', className: opened },
					react_default.a.createElement(
						'div',
						{ className: 'top' },
						react_default.a.createElement(
							'div',
							{ className: 'query' },
							react_default.a.createElement('input', { type: 'text',
								onChange: this.updateSearchQuery,
								value: this.state.searchQuery,
								placeholder: 'Search terms...',
								ref: function ref(it) {
									return _this2.searchTextInput = it;
								}
							}),
							react_default.a.createElement(
								'div',
								{ className: 'clear', onClick: this.clearInput },
								react_default.a.createElement(svg_SvgIcon, { size: '18px', icon: 'clear' })
							)
						),
						react_default.a.createElement(
							'div',
							{ className: 'search', onClick: this.handleSearch },
							'Search'
						)
					),
					react_default.a.createElement(
						'div',
						{ className: 'bottom' },
						react_default.a.createElement(
							'span',
							{ className: 'description' },
							'Search in the current'
						),
						react_default.a.createElement(
							'div',
							{ className: 'buttons' },
							react_default.a.createElement(
								'label',
								{ className: forumsDisabled },
								'Forum',
								react_default.a.createElement('input', {
									disabled: !!forumsDisabled,
									type: 'radio',
									name: 'searchtype',
									value: '1',
									onChange: this.updateSearchForumid,
									checked: this.state.forumId > 0
								})
							),
							react_default.a.createElement(
								'label',
								null,
								'Everywhere',
								react_default.a.createElement('input', {
									type: 'radio',
									name: 'searchtype',
									value: '0',
									onChange: this.updateSearchForumid,
									checked: this.state.forumId <= 0 || this.state.forumId === null
								})
							)
						)
					),
					react_default.a.createElement(
						'div',
						{ className: 'bottom' },
						react_default.a.createElement(
							'span',
							{ className: 'description' },
							'and show me'
						),
						react_default.a.createElement(
							'div',
							{ className: 'buttons' },
							react_default.a.createElement(
								'label',
								null,
								'Posts',
								react_default.a.createElement('input', { type: 'radio',
									name: 'showposts',
									value: '1',
									checked: this.state.scope.showposts === 1,
									onChange: this.updateFetchScope })
							),
							react_default.a.createElement(
								'label',
								null,
								'Threads',
								react_default.a.createElement('input', { type: 'radio',
									name: 'showposts',
									value: '0',
									checked: this.state.scope.showposts === 0,
									onChange: this.updateFetchScope })
							)
						)
					)
				)
			);
		}
	}]);

	return SearchBarComponent;
}(react_default.a.Component);

function SearchBarComponent_mapStateToProps(state) {
	return {
		forumId: state.forumview.forumId || (state.searchresult.query && state.searchresult.query.forumId ? state.searchresult.query.forumId : null),
		isOpen: state.ui.searchBarOpened
	};
}

SearchBarComponent_SearchBarComponent.propTypes = {
	dispatch: prop_types_default.a.func.isRequired
};

/* harmony default export */ var header_SearchBarComponent = (Object(es["b" /* connect */])(SearchBarComponent_mapStateToProps)(SearchBarComponent_SearchBarComponent));
// EXTERNAL MODULE: ./src/styles/sidebar.scss
var sidebar = __webpack_require__(780);
var sidebar_default = /*#__PURE__*/__webpack_require__.n(sidebar);

// EXTERNAL MODULE: ./node_modules/create-hash/browser.js
var browser = __webpack_require__(781);
var browser_default = /*#__PURE__*/__webpack_require__.n(browser);

// CONCATENATED MODULE: ./src/actions/authenticateActions.js












function authenticate(data) {

	return function (dispatch, getState) {
		var state = getState();
		var url = state.topifyPresets.forumSite.url;
		var config = {};

		dispatch(Object(UiActions["E" /* hideLoginModal */])());
		dispatch(Object(UiActions["O" /* showGlobalLoading */])('Logging in'));

		if (data.social) {
			dispatch(authenticateActions_socialLogin(data));
		} else {
			var password = data.password;

			switch (state.topifyPresets.forumInfo.f_p_type) {
				case 'md5':
					password = browser_default()('md5').update(data.password).digest('hex');
					break;
			}

			var body = 'username=' + data.username + '&password=' + password + '&remember=true';

			config = dispatch(Object(GlobalMetaActions["e" /* getFetchConfig */])(true, 'POST', body));

			return fetch(url + '?v=3.0&ajax=1&req=login', config).then(function (response) {
				dispatch(Object(UiActions["D" /* hideGlobalLoading */])());

				if (!response.ok) {
					try {
						response.json().then(function (json) {
							Object(GlobalMetaActions["j" /* setGlobalNotification */])(dispatch, json, response);
						}).catch(function () {
							Object(GlobalMetaActions["j" /* setGlobalNotification */])(dispatch, {}, response);
						});
					} catch (e) {
						Object(GlobalMetaActions["j" /* setGlobalNotification */])(dispatch, {}, response);
					}
				} else {
					response.json().then(function (json) {
						if (json.login) {
							if (json.login.userName) {
								var message = 'Welcome back, ' + json.login.userName + '!';
								Object(UiActions["B" /* displayNotification */])('success', message);
							}

							// Update user info if present
							if (json.ustate) {
								dispatch(Object(UstateActions["a" /* receiveCurrentUser */])(json.ustate));
							}

							// Record the Google Analytics event and for the forum.
							dispatch(Object(adsActions["A" /* trackGAEvent */])(true, 'forumLogin', 'userAction', 'security'));

							// Refresh the page
							dispatch(Object(GlobalMetaActions["h" /* refreshPage */])());
						}
					});
				}
			});
		}
	};
}

function authenticateActions_socialLogin(data, url) {
	return function (dispatch, getState) {
		var state = getState();
		var url = state.topifyPresets.forumSite.url;
		// Record the Google Analytics event.
		dispatch(Object(adsActions["A" /* trackGAEvent */])(false, 'forumSocialStart', 'userAction', 'creation'));

		var currentUri = encodeURIComponent(state.routing.locationBeforeTransitions.pathname.replace(/^\//, ''));
		// We need to load the page directly
		window.location = url + '?v=3.0&ajax=1&req=login&social=1&provider=' + data.provider + '&reg=1&uri=' + currentUri;
	};
}

function registerUserName(data) {
	return function (dispatch, getState) {
		var state = getState();
		var url = state.topifyPresets.forumSite.url;

		dispatch(Object(UiActions["O" /* showGlobalLoading */])('Registering new user'));

		// Update CacheBuster
		var cacheBust = new Date().getTime();
		dispatch(Object(MetaActions["d" /* setCacheBuster */])(cacheBust));

		var pass = data.password ? '&password=' + data.password : '',
		    uri = data.uri ? '&uri=' + encodeURIComponent(data.uri) : '',
		    body = 'agree=' + data.agree + '&provider=' + data.provider + '&username=' + encodeURIComponent(data.username) + pass + uri;

		var config = dispatch(Object(GlobalMetaActions["e" /* getFetchConfig */])(true, 'POST', body));

		return fetch(url + '?v=3.0&ajax=1&req=register', config).then(function (response) {
			dispatch(Object(UiActions["D" /* hideGlobalLoading */])());

			if (!response.ok) {
				try {
					response.json().then(function (json) {
						Object(GlobalMetaActions["j" /* setGlobalNotification */])(dispatch, json, response);
					}).catch(function () {
						Object(GlobalMetaActions["j" /* setGlobalNotification */])(dispatch, {}, response);
					});
				} catch (e) {
					Object(GlobalMetaActions["j" /* setGlobalNotification */])(dispatch, {}, response);
				}
			} else {
				response.json().then(function (json) {
					if (json.message && json.message.data && json.message.data.length) {
						Object(UiActions["B" /* displayNotification */])(json.message.data[0].type, json.message.data[0].message);
					}

					if (json.login) {
						// Record the Google Analytics event and for the forum.
						dispatch(Object(adsActions["A" /* trackGAEvent */])(true, 'forumRegister', 'userAction', 'security'));

						if (data.uri) {
							// If we come from an URI go there
							dispatch(Object(react_router_redux_lib["push"])(data.uri));
						} else {
							// Go to landing page
							var landingPage = dispatch(Object(UserSettingsActions["c" /* getLandingPage */])());
							dispatch(Object(react_router_redux_lib["push"])(landingPage));
						}
					}
				});
			}
		});
	};
}

function checkUserName(name) {
	return function (dispatch, getState) {
		var state = getState();
		var url = state.topifyPresets.forumSite.url;

		var config = dispatch(Object(GlobalMetaActions["e" /* getFetchConfig */])(true));

		return fetch(url + '?v=3.0&ajax=1&object=reg_username&req=get&name=' + name + '&_=' + new Date().getTime(), config).then(function (response) {
			if (!response.ok) {
				Object(GlobalMetaActions["j" /* setGlobalNotification */])(dispatch, {}, response);
			} else {
				return response.json();
			}
		}).then(function (json) {
			return {
				username: json.username,
				suggestedusername: json.suggestedusername
			};
		});
	};
}

function doLogout() {
	var _this = this;

	var url = this.props.forumSiteUrl + '?v=3.0&ajax=1&req=logout&_=' + Date.now();
	var config = this.props.dispatch(Object(GlobalMetaActions["e" /* getFetchConfig */])(true));

	this.props.dispatch(Object(UiActions["O" /* showGlobalLoading */])('Logging out'));

	return fetch(url, config).then(function (response) {
		_this.props.dispatch(Object(UiActions["D" /* hideGlobalLoading */])());
		if (!response.ok) {
			try {
				response.json().then(function (json) {
					Object(GlobalMetaActions["j" /* setGlobalNotification */])(dispatch, json, response);
				}).catch(function () {
					Object(GlobalMetaActions["j" /* setGlobalNotification */])(dispatch, {}, response);
				});
			} catch (e) {
				Object(GlobalMetaActions["j" /* setGlobalNotification */])(dispatch, {}, response);
			}
		} else {
			Object(UiActions["B" /* displayNotification */])('success', 'You have been logged out');
			response.json().then(function (json) {
				json.ustate.notifications = { pms: 0 };
				_this.props.dispatch(Object(GlobalMetaActions["i" /* resetAll */])());
				_this.props.dispatch(Object(MetaActions["d" /* setCacheBuster */])(new Date().getTime()));
				_this.props.dispatch(Object(UstateActions["a" /* receiveCurrentUser */])(json.ustate));

				// Record the Google Analytics event.
				_this.props.dispatch(Object(adsActions["A" /* trackGAEvent */])(false, 'forumLogout', 'userAction', 'security'));

				var landingPage = _this.props.dispatch(Object(UserSettingsActions["c" /* getLandingPage */])());
				try {
					if (_this.props.routing.locationBeforeTransitions.pathname === landingPage) {
						_this.props.dispatch(Object(GlobalMetaActions["h" /* refreshPage */])());
					} else {
						throw true; // to Landing page
					}
				} catch (e) {
					// Go to landing page
					_this.props.dispatch(Object(react_router_redux_lib["push"])(landingPage));
				}
			});
		}
	});
}
// CONCATENATED MODULE: ./src/selectors/sidebarSelector.js


var sidebarSelector_metaSelector = function metaSelector(state) {
	return state.meta;
};
var sidebarSelector_topifyPresetsSelector = function topifyPresetsSelector(state) {
	return state.topifyPresets;
};
var sidebarSelector_userStateSelector = function userStateSelector(state) {
	return state.ustate;
};
var sidebarSelector_routingSelector = function routingSelector(state) {
	return state.routing;
};
var sidebarSelector_uiSelector = function uiSelector(state) {
	return state.ui;
};

/* harmony default export */ var sidebarSelector = (Object(lib["createSelector"])([sidebarSelector_metaSelector, sidebarSelector_topifyPresetsSelector, sidebarSelector_userStateSelector, sidebarSelector_routingSelector, sidebarSelector_uiSelector], function (meta, topifyPresets, ustate, routing, ui) {
	return {
		isOpen: ui.sidebarOpened,
		meta: meta,
		ustate: ustate,
		custom_links: topifyPresets.forumSite.custom_links,
		forumSiteUrl: topifyPresets.forumSite.url,
		isVS: topifyPresets.forumSite.isVS,
		routing: routing
	};
}));
// CONCATENATED MODULE: ./src/components/common/SidebarComponent.js
var SidebarComponent__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function SidebarComponent__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function SidebarComponent__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function SidebarComponent__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





























var SidebarComponent_SidebarComponent = function (_React$Component) {
	SidebarComponent__inherits(SidebarComponent, _React$Component);

	function SidebarComponent(props) {
		SidebarComponent__classCallCheck(this, SidebarComponent);

		var _this = SidebarComponent__possibleConstructorReturn(this, (SidebarComponent.__proto__ || Object.getPrototypeOf(SidebarComponent)).call(this, props));

		_this.toggleSidebar = function () {
			if (_this.props.isOpen) {
				_this.props.dispatch(Object(react_router_redux_lib["goBack"])());
				_this.props.dispatch(Object(UiActions["V" /* sidebarOff */])());
			}
			return true;
		};

		_this.gotoRoot = function () {
			_this.goToSection(NavHelpers["m" /* pathToRoot */]());
			_this.props.dispatch(Object(adsActions["A" /* trackGAEvent */])(false, 'goToRoot', 'uiAction', 'sideMenu'));
		};

		_this.gotoForumsIndex = function () {
			_this.goToSection(NavHelpers["d" /* pathToForumsIndex */]());
			_this.props.dispatch(Object(adsActions["A" /* trackGAEvent */])(false, 'goToForumsIndex', 'uiAction', 'sideMenu'));
		};

		_this.gotoActiveTopics = function () {
			_this.goToSection(NavHelpers["b" /* pathToActiveTopics */]());
			_this.props.dispatch(Object(adsActions["A" /* trackGAEvent */])(false, 'goToActive', 'uiAction', 'sideMenu'));
		};

		_this.gotoSubscribed = function () {
			_this.goToSection(NavHelpers["p" /* pathToSubscribed */]());

			_this.props.dispatch(Object(adsActions["A" /* trackGAEvent */])(false, 'goToSubscribed', 'uiAction', 'sideMenu'));
		};

		_this.gotoParticipated = function () {
			_this.goToSection(NavHelpers["j" /* pathToParticipated */]());

			_this.props.dispatch(Object(adsActions["A" /* trackGAEvent */])(false, 'goToParticipated', 'uiAction', 'sideMenu'));
		};

		_this.gotoNewPosts = function () {
			_this.goToSection(NavHelpers["h" /* pathToNewPosts */]());

			_this.props.dispatch(Object(adsActions["A" /* trackGAEvent */])(false, 'goToNewPosts', 'uiAction', 'sideMenu'));
		};

		_this.goToMessages = function () {
			if (_this.props.ustate.id) {
				_this.goToSection(NavHelpers["e" /* pathToMessages */]());

				// Record the Google Analytics event.
				_this.props.dispatch(Object(adsActions["A" /* trackGAEvent */])(false, 'messageNotificationIcon', 'uiAction', 'sideMenu'));
			} else {
				// for guests show the login modal
				_this.props.dispatch(Object(UiActions["P" /* showLoginModal */])());
				// Record the Google Analytics event.
				_this.props.dispatch(Object(adsActions["A" /* trackGAEvent */])(false, 'sideMenuMessageNotificationIcon', 'userAction', 'loginPrompt'));
			}
		};

		_this.gotoOnline = function () {
			_this.goToSection(NavHelpers["i" /* pathToOnline */]());

			_this.props.dispatch(Object(adsActions["A" /* trackGAEvent */])(false, 'goToOnline', 'uiAction', 'sideMenu'));
		};

		_this.gotoReleaseNotes = function () {
			_this.goToSection(NavHelpers["l" /* pathToReleaseNotes */]());

			_this.props.dispatch(Object(adsActions["A" /* trackGAEvent */])(false, 'gotoReleaseNotes', 'uiAction', 'sideMenu'));
		};

		_this._showLoginModal = function () {
			_this.props.dispatch(Object(UiActions["P" /* showLoginModal */])());

			_this.props.dispatch(Object(adsActions["A" /* trackGAEvent */])(false, 'login', 'uiAction', 'sideMenu'));
		};

		_this._showLogoutModal = function () {
			_this.props.dispatch(Object(UiActions["V" /* sidebarOff */])());
			_this.props.dispatch(Object(UiActions["N" /* showConfirmModal */])('Sign Out', 'Are you sure you want to sign out of the current forum?', doLogout.bind(_this)));
			_this.props.dispatch(Object(adsActions["A" /* trackGAEvent */])(false, 'logout', 'uiAction', 'sideMenu'));
		};

		_this._showExitModal = function () {
			_this.props.dispatch(Object(UiActions["V" /* sidebarOff */])());
			_this.props.dispatch(Object(UiActions["N" /* showConfirmModal */])('Exit Mobile View', 'Are you sure you want exit to the desktop version?', GlobalMetaActions["d" /* exitTopify */].bind(_this)));
			//Tracks exit analytics event in exitTopify function since program does not return
			_this.props.dispatch(Object(adsActions["A" /* trackGAEvent */])(false, 'exitTopify', 'uiAction', 'sideMenu'));
		};

		_this.gotoRegister = function (e) {
			_this.props.dispatch(Object(UiActions["V" /* sidebarOff */])());

			var thisLocation = _this.props.routing.locationBeforeTransitions,
			    redirectUrl = _this.props.ustate.registerUrl,
			    mobileurl = thisLocation.pathname ? thisLocation.pathname.replace(/^\//, '') + thisLocation.search : '';

			switch (e.currentTarget.dataset.type) {
				case 'register':
					redirectUrl = _this.props.ustate.registerUrl;
					break;

				case 'storefront':
					redirectUrl = _this.props.ustate.storeFrontUrl;
					break;
			}

			document.location.replace('' + redirectUrl + (/\?/i.test(redirectUrl) ? '&' : '?') + 'mobileurl=' + (mobileurl ? encodeURIComponent(mobileurl) : '/'));
		};

		_this.currentUser = null;
		return _this;
	}

	SidebarComponent__createClass(SidebarComponent, [{
		key: 'shouldComponentUpdate',
		value: function shouldComponentUpdate(nextProps) {
			return this.props.ustate.id !== nextProps.ustate.id || this.props.ustate.notifications !== nextProps.ustate.notifications || this.props.isOpen !== nextProps.isOpen || !isEqual_default()(this.props.custom_links, nextProps.custom_links);
		}
	}, {
		key: 'componentDidUpdate',
		value: function componentDidUpdate(prevProps) {
			// Let's check if we have new notifications
			if (this.props.ustate.notifications && this.props.ustate.notifications.pms) {
				if (!prevProps.ustate.notifications && this.props.ustate.notifications.pms > 0 || prevProps.ustate.notifications.pms < this.props.ustate.notifications.pms) {
					var message = 'You have ' + this.props.ustate.notifications.pms + ' new ';
					message += parseInt(this.props.ustate.notifications.pms) === 1 ? 'message' : 'messages';
					Object(UiActions["B" /* displayNotification */])('info', message, { timeout: 2000 });
				}
			}

			if (this.props.isOpen && prevProps.isOpen === false) {
				// using pushState to avoid popstate to be triggered
				history.pushState({ topifyExtra: true, type: 'sidebar' }, '', window.location);
			}
		}
	}, {
		key: 'goToSection',
		value: function goToSection(newPath) {
			var currentPath = NavHelpers["a" /* parsePath */](this.props.routing.locationBeforeTransitions.pathname);
			if (newPath === currentPath[0]) {
				this.props.dispatch(Object(GlobalMetaActions["h" /* refreshPage */])());
			} else {
				this.props.dispatch(Object(react_router_redux_lib["push"])(newPath));
			}
		}
	}, {
		key: 'gotoLink',
		value: function gotoLink(link) {
			this.toggleSidebar();
			window.open(link.url);

			// Record the Google Analytics event.
			this.props.dispatch(Object(adsActions["A" /* trackGAEvent */])(false, 'followedExternalLink', 'userAction', 'consumption'));
			this.props.dispatch(Object(adsActions["A" /* trackGAEvent */])(false, 'followedExternalLink', 'uiAction', 'sideMenu'));
		}
	}, {
		key: 'getMessagesNotifications',
		value: function getMessagesNotifications() {
			var className = '',
			    counter = '';
			if (this.props.ustate.notifications && this.props.ustate.notifications.pms) {
				className = ' notification_on';
				counter = react_default.a.createElement(
					'span',
					{ className: 'sideMenuCounter' },
					this.props.ustate.notifications.pms
				);
			}

			return react_default.a.createElement(
				'li',
				{ className: 'messages-icon' + className, onClick: this.goToMessages },
				counter,
				react_default.a.createElement(svg_SvgIcon, { size: '32px', icon: 'message' })
			);
		}
	}, {
		key: 'getUserLink',
		value: function getUserLink() {
			if (this.props.ustate.id) {
				if (!this.currentUser || this.currentUser.id !== this.props.ustate.id || this.props.isOpen) {
					this.currentUser = this.props.dispatch(Object(ContextInfoActions["i" /* currentUser */])());
				}
				return react_default.a.createElement(common_UserIconComponent, { user: this.currentUser, layout: 'sidemenu' });
			}
			return null;
		}
	}, {
		key: 'render',
		value: function render() {
			var _this2 = this;

			var opened = this.props.isOpen ? 'opened' : '';

			var userLoggedIn = this.props.ustate.id;
			var customLinks_items = this.props.custom_links.map(function (p, i) {
				return react_default.a.createElement(
					'li',
					{ key: i, className: 'item', onClick: function onClick() {
							return _this2.gotoLink(p);
						} },
					react_default.a.createElement(
						'span',
						null,
						simpleDecodeEntities(p.text)
					)
				);
			});
			var customLinks = this.props.custom_links.length > 0 ? react_default.a.createElement(
				'ul',
				{ className: 'links custom-links' },
				customLinks_items
			) : react_default.a.createElement('span', null);

			var perms = {
				subscribed: this.props.ustate.perms && this.props.ustate.perms.search && userLoggedIn,
				participated: this.props.ustate.perms && this.props.ustate.perms.participated && userLoggedIn,
				latest: this.props.ustate.perms && this.props.ustate.perms.latest,
				updated: this.props.ustate.perms && this.props.ustate.perms.updated && userLoggedIn,
				whosonline: this.props.ustate.perms && this.props.ustate.perms.whosonline
			};

			var home = {"version":"1.0.0","IndexRoute":"index","section":{"home":false}}.section.home === true ? react_default.a.createElement(
				'li',
				{ onClick: this.gotoRoot },
				'Home'
			) : null,
			    messagesNotifications = this.getMessagesNotifications(),
			    userLink = this.getUserLink(),
			    messages = userLoggedIn ? react_default.a.createElement(
				'li',
				{ onClick: this.goToMessages },
				'Private Messages'
			) : null,
			    signInOut = userLoggedIn ? react_default.a.createElement(
				'li',
				{ onClick: this._showLogoutModal },
				'Sign Out'
			) : react_default.a.createElement(
				'li',
				{ onClick: this._showLoginModal },
				'Sign In for More'
			),
			    subscribed = perms.subscribed ? react_default.a.createElement(
				'li',
				{ onClick: this.gotoSubscribed },
				'Subscribed'
			) : null,
			    participated = perms.participated ? react_default.a.createElement(
				'li',
				{ onClick: this.gotoParticipated },
				'Participated'
			) : null,
			    latest = perms.latest ? react_default.a.createElement(
				'li',
				{ onClick: this.gotoActiveTopics },
				'Active Topics'
			) : null,
			    newPosts = perms.updated ? react_default.a.createElement(
				'li',
				{ onClick: this.gotoNewPosts },
				'New Posts'
			) : null,
			    whosonline = perms.whosonline ? react_default.a.createElement(
				'li',
				{ onClick: this.gotoOnline },
				'Who\'s Online'
			) : null,
			    register = !userLoggedIn && this.props.ustate.registerUrl && this.props.isVS ? react_default.a.createElement(
				'li',
				{ 'data-type': 'register', onClick: this.gotoRegister },
				'Register'
			) : null,
			    storeFront = !userLoggedIn && this.props.ustate.storeFrontUrl && this.props.isVS ? react_default.a.createElement(
				'li',
				{ 'data-type': 'storefront', onClick: this.gotoRegister },
				'Advertise with Us'
			) : null;

			return react_default.a.createElement(
				'section',
				{ id: 'sideMenu', className: 'nolinks sidebar ' + opened },
				react_default.a.createElement(
					'ul',
					{ className: 'notifications' },
					messagesNotifications,
					react_default.a.createElement(
						'li',
						{ className: 'notifications-icon' },
						react_default.a.createElement(svg_SvgIcon, { size: '32px', icon: 'notification' })
					),
					react_default.a.createElement(
						'li',
						{ className: 'releases-icon', onClick: this.gotoReleaseNotes },
						react_default.a.createElement(svg_SvgIcon, { size: '32px', icon: 'info_outline' })
					)
				),
				react_default.a.createElement(
					'nav',
					{ className: 'links' },
					userLink,
					home,
					react_default.a.createElement(
						'li',
						{ onClick: this.gotoForumsIndex },
						'Forums Index'
					),
					subscribed,
					participated,
					latest,
					newPosts,
					messages,
					whosonline,
					signInOut,
					register,
					storeFront,
					react_default.a.createElement(
						'li',
						{ onClick: this._showExitModal },
						'Exit Enhanced Mobile View'
					)
				),
				customLinks
			);
		}
	}]);

	return SidebarComponent;
}(react_default.a.Component);

SidebarComponent_SidebarComponent.propTypes = {
	isOpen: prop_types_default.a.bool.isRequired,
	dispatch: prop_types_default.a.func.isRequired,
	custom_links: prop_types_default.a.array.isRequired
};

/* harmony default export */ var common_SidebarComponent = (Object(es["b" /* connect */])(sidebarSelector)(SidebarComponent_SidebarComponent));
// EXTERNAL MODULE: ./src/styles/modals.scss
var modals = __webpack_require__(122);
var modals_default = /*#__PURE__*/__webpack_require__.n(modals);

// CONCATENATED MODULE: ./src/components/modals/ModalComponent.js
var ModalComponent__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function ModalComponent__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function ModalComponent__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function ModalComponent__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var ModalComponent_ModalComponent = function (_React$Component) {
	ModalComponent__inherits(ModalComponent, _React$Component);

	function ModalComponent() {
		var _ref;

		var _temp, _this, _ret;

		ModalComponent__classCallCheck(this, ModalComponent);

		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		return _ret = (_temp = (_this = ModalComponent__possibleConstructorReturn(this, (_ref = ModalComponent.__proto__ || Object.getPrototypeOf(ModalComponent)).call.apply(_ref, [this].concat(args))), _this), _this.onClickOutsideWindow = function () {
			if (_this.props.isOpen && _this.props.onClickOutsideWindow) {
				_this.props.onClickOutsideWindow();
				// Record the Google Analytics event.
				_this.props.dispatch(Object(adsActions["A" /* trackGAEvent */])(false, 'modalOverlay', 'uiAction', 'cancel'));
			}
		}, _this.avoidScrollPropagation = function (e) {
			e.stopPropagation();
		}, _temp), ModalComponent__possibleConstructorReturn(_this, _ret);
	}

	ModalComponent__createClass(ModalComponent, [{
		key: 'render',
		value: function render() {
			var isOpen = this.props.isOpen;


			if (!isOpen) {
				return null;
			}

			var className = 'modal-window ' + (this.props.className ? this.props.className : '');

			return react_default.a.createElement(
				'div',
				{ className: 'modal nolinks nooptimize norewrite', onClick: this.onClickOutsideWindow, onTouchMove: this.avoidScrollPropagation },
				react_default.a.createElement(
					'div',
					{ className: className, onClick: function onClick(e) {
							e.stopPropagation();
						} },
					react_default.a.createElement(
						'div',
						{ className: 'modal-content' },
						this.props.children
					)
				)
			);
		}
	}]);

	return ModalComponent;
}(react_default.a.Component);

ModalComponent_ModalComponent.propTypes = {
	isOpen: prop_types_default.a.bool.isRequired,
	onClickOutsideWindow: prop_types_default.a.func // Optional: What to do if the user clicks outside of the modal window
};

/* harmony default export */ var modals_ModalComponent = (Object(es["b" /* connect */])()(ModalComponent_ModalComponent));
// CONCATENATED MODULE: ./src/components/modals/LoginModalComponent.js
var LoginModalComponent__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function LoginModalComponent__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function LoginModalComponent__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function LoginModalComponent__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }













var LoginModalComponent_LoginModalComponent = function (_React$Component) {
	LoginModalComponent__inherits(LoginModalComponent, _React$Component);

	function LoginModalComponent() {
		var _ref;

		var _temp, _this, _ret;

		LoginModalComponent__classCallCheck(this, LoginModalComponent);

		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		return _ret = (_temp = (_this = LoginModalComponent__possibleConstructorReturn(this, (_ref = LoginModalComponent.__proto__ || Object.getPrototypeOf(LoginModalComponent)).call.apply(_ref, [this].concat(args))), _this), _this.hideModal = function () {
			if (_this.props.isOpen) {
				_this.props.dispatch(Object(react_router_redux_lib["goBack"])());
			}
		}, _this.submitForm = function (e) {
			e.preventDefault();

			if (_this.validateLogin()) {
				var data = {
					username: _this.username.value,
					password: _this.password.value,
					social: false
				};
				_this.props.dispatch(authenticate(data));
			} else {
				Object(UiActions["B" /* displayNotification */])('error', 'Please provide a valid User name and Password', { force: true });
				return false;
			}
		}, _temp), LoginModalComponent__possibleConstructorReturn(_this, _ret);
	}

	LoginModalComponent__createClass(LoginModalComponent, [{
		key: 'shouldComponentUpdate',
		value: function shouldComponentUpdate(nextProps) {
			return nextProps.isOpen !== this.props.isOpen;
		}
	}, {
		key: 'componentDidUpdate',
		value: function componentDidUpdate(prevProps) {
			if (prevProps.isOpen === false && prevProps.isOpen !== this.props.isOpen) {
				// using pushState to avoid popstate to be triggered
				history.pushState({ topifyExtra: true, type: 'loginModal' }, '', window.location);
			}
		}
	}, {
		key: 'validateLogin',
		value: function validateLogin() {
			return this.username && /[^\s]+/.test(this.username.value) && this.password && /.+/.test(this.password.value);
		}
	}, {
		key: 'socialLogin',
		value: function socialLogin(provider) {
			var data = {
				provider: provider,
				social: true
			};
			this.props.dispatch(authenticate(data));
		}
	}, {
		key: 'buildSocialButton',
		value: function buildSocialButton() {
			var _this2 = this;

			var button = null,
			    buttons = [];

			if (this.props.socialOptions && this.props.socialOptions.facebook) {
				button = react_default.a.createElement('input', { key: 'fb', className: 'button facebook', type: 'button', value: 'Facebook', onClick: function onClick() {
						return _this2.socialLogin('facebook');
					} });
				buttons.push(button);
			}
			if (this.props.socialOptions && this.props.socialOptions.google) {
				button = react_default.a.createElement('input', { key: 'g+', className: 'button google', type: 'button', value: 'Google', onClick: function onClick() {
						return _this2.socialLogin('google');
					} });
				buttons.push(button);
			}
			if (this.props.socialOptions && this.props.socialOptions.twitter) {
				button = react_default.a.createElement('input', { key: 'tw', className: 'button twitter', type: 'button', value: 'Twitter', onClick: function onClick() {
						return _this2.socialLogin('twitter');
					} });
				buttons.push(button);
			}

			return buttons.length ? react_default.a.createElement(
				'div',
				null,
				react_default.a.createElement(
					'div',
					{ className: 'login-modal-register' },
					react_default.a.createElement(
						'span',
						null,
						'Or Continue with:'
					)
				),
				react_default.a.createElement(
					'div',
					{ key: 'social-buttons', className: 'modal-buttons social-buttons block-buttons' },
					buttons
				)
			) : react_default.a.createElement(
				'div',
				{ className: 'login-modal-register' },
				react_default.a.createElement(
					'span',
					null,
					'Don\'t have an account?'
				),
				react_default.a.createElement(
					'a',
					{ href: this.props.registerUrl },
					'Register with the forum'
				)
			);
		}
	}, {
		key: 'render',
		value: function render() {
			var _this3 = this;

			return react_default.a.createElement(
				modals_ModalComponent,
				{ isOpen: this.props.isOpen, onClickOutsideWindow: this.hideModal, className: 'login-modal' },
				react_default.a.createElement(
					'h2',
					null,
					'Sign In'
				),
				react_default.a.createElement(
					'h3',
					null,
					'to the Current Forum'
				),
				react_default.a.createElement(
					'form',
					{ className: 'modal-form', onSubmit: this.submitForm },
					react_default.a.createElement('input', { ref: function ref(u) {
							return _this3.username = u;
						}, type: 'text', placeholder: 'User Name' }),
					react_default.a.createElement('input', { ref: function ref(p) {
							return _this3.password = p;
						}, type: 'password', placeholder: 'Password' }),
					react_default.a.createElement(
						'div',
						{ className: 'modal-buttons' },
						react_default.a.createElement('input', { className: 'action-button', type: 'submit', value: 'Sign In' }),
						react_default.a.createElement('input', { className: 'cancel-button', type: 'button', value: 'Cancel', onClick: this.hideModal })
					)
				),
				this.buildSocialButton()
			);
		}
	}]);

	return LoginModalComponent;
}(react_default.a.Component);

LoginModalComponent_LoginModalComponent.propTypes = {
	isOpen: prop_types_default.a.bool.isRequired,
	dispatch: prop_types_default.a.func.isRequired
};

var LoginModalComponent_mapStateToProps = function mapStateToProps(state) {
	return {
		isOpen: state.ui.loginModalOpened,
		socialOptions: state.ustate.socialOptions,
		registerUrl: state.ustate.registerUrl
	};
};

/* harmony default export */ var modals_LoginModalComponent = (Object(es["b" /* connect */])(LoginModalComponent_mapStateToProps)(LoginModalComponent_LoginModalComponent));
// CONCATENATED MODULE: ./src/components/modals/ConfirmModalComponent.js
var ConfirmModalComponent__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function ConfirmModalComponent__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function ConfirmModalComponent__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function ConfirmModalComponent__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var ConfirmModalComponent_ConfirmModalComponent = function (_React$Component) {
	ConfirmModalComponent__inherits(ConfirmModalComponent, _React$Component);

	function ConfirmModalComponent() {
		var _ref;

		var _temp, _this, _ret;

		ConfirmModalComponent__classCallCheck(this, ConfirmModalComponent);

		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		return _ret = (_temp = (_this = ConfirmModalComponent__possibleConstructorReturn(this, (_ref = ConfirmModalComponent.__proto__ || Object.getPrototypeOf(ConfirmModalComponent)).call.apply(_ref, [this].concat(args))), _this), _this.hideModal = function () {
			if (_this.props.isOpen) {
				_this.props.dispatch(Object(react_router_redux_lib["goBack"])());
			}
		}, _this.onOkClick = function (e) {
			var result = true;
			if (_this.props.onOkClick) {
				result = _this.props.onOkClick(e);
			}

			if (result !== false) {
				_this.hideModal();
			}
		}, _this.onCancelClick = function (e) {
			if (_this.props.onCancelClick) {
				_this.props.onCancelClick(e);
			}

			_this.hideModal();
		}, _temp), ConfirmModalComponent__possibleConstructorReturn(_this, _ret);
	}

	ConfirmModalComponent__createClass(ConfirmModalComponent, [{
		key: 'shouldComponentUpdate',
		value: function shouldComponentUpdate(nextProps) {
			return nextProps.isOpen !== this.props.isOpen;
		}
	}, {
		key: 'componentDidUpdate',
		value: function componentDidUpdate(prevProps) {
			if (prevProps.isOpen === false && prevProps.isOpen !== this.props.isOpen) {
				// using pushState to avoid popstate to be triggered
				history.pushState({ topifyExtra: true, type: 'confirmModal' }, '', window.location);
			}
		}
	}, {
		key: 'render',
		value: function render() {
			return react_default.a.createElement(
				modals_ModalComponent,
				{ isOpen: this.props.isOpen, onClickOutsideWindow: this.hideModal, className: 'confirm-modal' },
				react_default.a.createElement(
					'h2',
					null,
					this.props.header
				),
				react_default.a.createElement(
					'div',
					{ className: 'confirm-modal-content' },
					this.props.text
				),
				react_default.a.createElement(
					'div',
					{ className: 'modal-buttons' },
					react_default.a.createElement(
						'button',
						{ className: 'action-button', onClick: this.onOkClick },
						'OK'
					),
					react_default.a.createElement(
						'button',
						{ className: 'cancel-button', onClick: this.onCancelClick },
						'Cancel'
					)
				)
			);
		}
	}]);

	return ConfirmModalComponent;
}(react_default.a.Component);

ConfirmModalComponent_ConfirmModalComponent.propTypes = {
	isOpen: prop_types_default.a.bool.isRequired,
	header: prop_types_default.a.string,
	text: prop_types_default.a.oneOfType([prop_types_default.a.string, prop_types_default.a.object]),
	onOkClick: prop_types_default.a.func,
	onCancelClick: prop_types_default.a.func
};

var ConfirmModalComponent_mapStateToProps = function mapStateToProps(state) {
	return {
		isOpen: state.ui.confirmModalOpened,
		header: state.ui.confirmModalOptions.header,
		text: state.ui.confirmModalOptions.text,
		onOkClick: state.ui.confirmModalOptions.action,
		onCancelClick: state.ui.confirmModalOptions.onCancel
	};
};

/* harmony default export */ var modals_ConfirmModalComponent = (Object(es["b" /* connect */])(ConfirmModalComponent_mapStateToProps)(ConfirmModalComponent_ConfirmModalComponent));
// EXTERNAL MODULE: ./src/actions/AttachmentsActions.js
var AttachmentsActions = __webpack_require__(237);

// CONCATENATED MODULE: ./src/actions/ReplyActions.js








function sendReply(user, data) {
	return function (dispatch, getState) {

		dispatch(Object(UiActions["S" /* showReplyModalLoader */])());

		var state = getState(),
		    url = state.topifyPresets.forumSite.url,
		    body = '' + Object.keys(data).map(function (key) {
			return key + '=' + data[key];
		}).join('&'),
		    config = dispatch(Object(GlobalMetaActions["e" /* getFetchConfig */])(true, 'POST', body));

		return fetch(url + '?v=3.0&ajax=1&uid=' + user.id + '&req=post', config).then(function (response) {

			dispatch(Object(UiActions["H" /* hideReplyModalLoader */])());

			if (!response.ok) {
				try {
					response.json().then(function (json) {
						Object(GlobalMetaActions["j" /* setGlobalNotification */])(dispatch, json, response);
					}).catch(function () {
						Object(GlobalMetaActions["j" /* setGlobalNotification */])(dispatch, {}, response);
					});
				} catch (e) {
					Object(GlobalMetaActions["j" /* setGlobalNotification */])(dispatch, {}, response);
				}
			} else {
				switch (data.type) {
					case 'topic':
						response.json().then(function (json) {
							dispatch(Object(UiActions["F" /* hideReplyModal */])());

							// Update CacheBuster
							var cacheBust = new Date().getTime();
							dispatch(Object(MetaActions["d" /* setCacheBuster */])(cacheBust));

							// Record the Google Analytics event and for the forum.
							dispatch(Object(adsActions["A" /* trackGAEvent */])(true, 'newTopic', 'userAction', 'creation'));

							dispatch(Object(react_router_redux_lib["replace"])(Object(NavHelpers["q" /* pathToThread */])(json.post.data[0].topic)));
						});
						break;

					case 'pm':
						dispatch(Object(MetaActions["c" /* resetSelectedItem */])());
						dispatch(Object(UiActions["F" /* hideReplyModal */])());
						Object(UiActions["B" /* displayNotification */])('success', 'Message sent', { timeout: 1500 });

						// Record the Google Analytics event and for the forum.
						dispatch(Object(adsActions["A" /* trackGAEvent */])(true, 'sentMessage', 'userAction', 'creation'));
						// Record the Google Analytics event
						dispatch(Object(adsActions["A" /* trackGAEvent */])(false, data.reply ? 'messageReply' : 'messageNew', 'userAction', 'creation'));

						dispatch(Object(GlobalMetaActions["h" /* refreshPage */])());
						break;

					case 'reply':
					case 'edit':
						dispatch(Object(MetaActions["c" /* resetSelectedItem */])());
						dispatch(Object(react_router_redux_lib["goBack"])());
						dispatch(Object(UiActions["F" /* hideReplyModal */])());
						response.json().then(function (json) {
							if (json.post.data && json.post.data[0].id) {
								// Update CacheBuster
								var cacheBust = new Date().getTime();
								dispatch(Object(MetaActions["d" /* setCacheBuster */])(cacheBust));

								// Record the Google Analytics event and for the forum.
								dispatch(Object(adsActions["A" /* trackGAEvent */])(true, data.type === 'reply' ? 'newReply' : 'editPost', 'userAction', 'creation'));

								// go to the postid given back from the site
								dispatch(Object(react_router_redux_lib["replace"])(Object(NavHelpers["k" /* pathToPost */])(json.post.data[0].id)));
							} else {
								dispatch(Object(GlobalMetaActions["h" /* refreshPage */])());
							}
						});
						break;

					default:
						break;
				}
			}
		});
	};
}
// EXTERNAL MODULE: ./node_modules/blueimp-load-image/js/index.js
var js = __webpack_require__(807);
var js_default = /*#__PURE__*/__webpack_require__.n(js);

// CONCATENATED MODULE: ./src/utils/imageUploader.js
var imageUploader__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function imageUploader__toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function imageUploader__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }







var imageUploader_ImageUploader = function () {
	function ImageUploader(dispatch, setAttachmentsHash) {
		var _this = this;

		imageUploader__classCallCheck(this, ImageUploader);

		this.uploadFiles = function () {
			setTimeout(function () {
				_this.uploadImages();
			}, 50);
		};

		this.prepareFile = function (file, isValid) {
			return !(!isValid && !_this.userInput(file));
		};

		this.convertImage = function (file) {
			try {
				js_default.a.parseMetaData(file, function (metaData) {
					if (metaData && metaData.exif) {
						var orientation = metaData.exif.get('Orientation'),
						    rotation = 0;
						switch (orientation) {
							case 3:
								// Upside down.
								rotation = 180;
								break;
							case 6:
								// 90 degrees counter-clockwise.
								rotation = 90;
								break;
							case 8:
								// 90 degrees clockwise.
								rotation = 270;
								break;
							default:
								break;
						}
						_this.uploadRotations.push(rotation);
					} else {
						_this.uploadRotations.push(0);
					}
				}, {
					maxMetaDataSize: 262144,
					disableImageHead: true,
					disableExifThumbnail: true,
					disableExifSub: true,
					disableExifGps: true
				});
			} catch (ex) {
				_this.uploadRotations.push(0);
			}
		};

		this.uploadImages = function () {
			var files = new FormData(),
			    response = void 0;
			if (_this.isInvalid) {
				return null;
			}
			_this.originalBlobs.forEach(function (file, index) {
				files.append('files[]', file.blob, file.name.replace(/(\..{3,})/ig, '_' + new Date().getTime() + '$1'));
				files.append('rotations[]', _this.uploadRotations[index]);
			});
			response = _this.dispatch(Object(AttachmentsActions["e" /* sendAttachment */])(files, _this.data));
			response.then(function (responseHash) {
				_this.setAttachmentsHash(responseHash());
			}).catch(function (error) {
				topifyConsole.error(error);
				_this.dispatch(Object(UiActions["G" /* hideReplyModalAttachmentLoader */])());
			});
		};

		this.dispatch = dispatch;
		this.setAttachmentsHash = setAttachmentsHash;
	}

	imageUploader__createClass(ImageUploader, [{
		key: 'processFiles',
		value: function processFiles(files, data) {
			this.originalBlobs = [];
			this.uploadRotations = [];
			this.isInvalid = false;
			this.invalidFiles = [];
			this.files = files;
			this.data = data;

			if (files.length > 0) {
				this.validateFiles(this.uploadFiles);
			}
		}
	}, {
		key: 'validateFiles',
		value: function validateFiles(callback) {
			var _this2 = this;

			[].concat(imageUploader__toConsumableArray(this.files)).forEach(function (file) {
				if (_this2.validateAttachment(file, _this2.prepareFile)) {
					_this2.addImage(file);
					_this2.convertImage(file);
				} else {
					_this2.isInvalid = true;
					_this2.invalidFiles = [].concat(imageUploader__toConsumableArray(_this2.invalidFiles), [file]);
				}
			}, callback());
		}
	}, {
		key: 'validateAttachment',
		value: function validateAttachment(file, callback) {
			var size = file.size,
			    extension = file.name.substr(file.name.lastIndexOf('.') + 1).toLowerCase(),
			    limits = this.dispatch(Object(ContextInfoActions["z" /* uploadLimits */])()),
			    isValid = true;

			if (limits && limits[extension]) {
				if (limits[extension].width > 0 && file.width > limits[extension].width || limits[extension].height > 0 && file.height > limits[extension].height || size > parseInt(limits[extension].size) || !limits[extension].permissions) {
					isValid = false;
				}
				return callback(file, isValid);
			}
		}
	}, {
		key: 'addImage',
		value: function addImage(file) {
			var blob = void 0;
			if (file.byteContent) {
				blob = new Blob([file.byteContent], { type: file.type });
			} else {
				blob = new Blob([file]);
			}
			this.originalBlobs.push({
				blob: blob,
				name: file.name
			});
		}
	}, {
		key: 'userAnswer',
		value: function userAnswer(file) {
			this.isInvalid = false;
			this.addImage(file);
			this.convertImage(file);
			if (this.invalidFiles.length - 1 === this.invalidFiles.indexOf(file)) {
				this.uploadFiles();
			}
		}
	}, {
		key: 'userInput',
		value: function userInput(file) {
			this.dispatch(Object(UiActions["N" /* showConfirmModal */])('Re-size Warning', 'The files need to be resized\nDo you like to proceed?', this.userAnswer.bind(this, file)));
		}
	}]);

	return ImageUploader;
}();

/* harmony default export */ var imageUploader = (imageUploader_ImageUploader);
// EXTERNAL MODULE: ./node_modules/react-select/lib/Select.js
var Select = __webpack_require__(163);
var Select_default = /*#__PURE__*/__webpack_require__.n(Select);

// EXTERNAL MODULE: ./node_modules/react-select/dist/react-select.css
var react_select = __webpack_require__(819);
var react_select_default = /*#__PURE__*/__webpack_require__.n(react_select);

// EXTERNAL MODULE: ./node_modules/react-textarea-autosize/es/index.js
var react_textarea_autosize_es = __webpack_require__(820);

// CONCATENATED MODULE: ./src/components/modals/ReplyModalComponent.js
var ReplyModalComponent__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var ReplyModalComponent__typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var ReplyModalComponent__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function ReplyModalComponent__defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function ReplyModalComponent__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function ReplyModalComponent__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function ReplyModalComponent__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



























var ReplyModalComponent_ReplyModalComponent = function (_Component) {
	ReplyModalComponent__inherits(ReplyModalComponent, _Component);

	function ReplyModalComponent(props) {
		ReplyModalComponent__classCallCheck(this, ReplyModalComponent);

		var _this = ReplyModalComponent__possibleConstructorReturn(this, (ReplyModalComponent.__proto__ || Object.getPrototypeOf(ReplyModalComponent)).call(this, props));

		_this.sendMessage = function () {
			if (_this.props.attachmentLoading) {
				Object(UiActions["B" /* displayNotification */])('warning', 'please wait for attachment to load and try again');
			} else {
				_this.props.dispatch(sendReply(_this.currentUser, _this.data));
			}
		};

		_this.attachImage = function () {
			var postLimit = parseInt(_this.props.ustate.perms.limitPostAttachments);

			if (_this.props.attachmentLoading) {
				Object(UiActions["B" /* displayNotification */])('warning', 'please wait for attachment to load and try again');
			} else {
				if (postLimit === -1 || _this.props.attachments.length < postLimit) {
					document.querySelector('#imagePicker').click();
				} else {
					Object(UiActions["B" /* displayNotification */])('warning', 'attachment limit reached');
				}
			}
		};

		_this.uploadFiles = function (event) {
			_this.uploader.processFiles(event.target.files, _this.attachmentsData);
			document.querySelector('#imagePicker').value = null;
		};

		_this.hideThisReplyModal = function () {
			_this.setState({ value: [] });
			_this.props.dispatch(Object(react_router_redux_lib["goBack"])());
			_this.props.dispatch(Object(UiActions["F" /* hideReplyModal */])());

			// Record the Google Analytics event.
			_this.props.dispatch(Object(adsActions["A" /* trackGAEvent */])(false, 'replyToBack', 'uiAction', 'header'));
		};

		_this.getUsernames = function (input) {
			var url = _this.props.url,
			    config = _this.props.dispatch(Object(GlobalMetaActions["e" /* getFetchConfig */])(true));

			var username = (typeof input === 'undefined' ? 'undefined' : ReplyModalComponent__typeof(input)) === 'object' && input.username ? input.username : input;
			_this.selectLoading = true;

			return fetch(url + '?v=3.0&ajax=1&object=name_suggest&req=get&name=' + username, config).then(function (response) {
				if (!response.ok) {
					Object(GlobalMetaActions["j" /* setGlobalNotification */])(dispatch, {}, response);
				} else {
					return response.json();
				}
			}).then(function (json) {
				_this.selectLoading = false;
				return { options: json.names };
			});
		};

		_this.doSetAttachmentsHash = function (hash) {
			_this.props.dispatch(Object(AttachmentsActions["f" /* setAttachmentsHash */])(hash));
		};

		_this.handleInputChange = function (event) {
			var target = event.target;
			var value = target.value;
			var name = target.name;

			_this.setState(ReplyModalComponent__defineProperty({}, name, value));
		};

		_this.handleSelectChange = function (value) {
			_this.setState({ uservalues: value });
		};

		_this.state = {
			title: '',
			subject: '',
			message: '',
			reason: '',
			uservalues: []

		};
		_this.uploader = new imageUploader(_this.props.dispatch, _this.doSetAttachmentsHash);
		_this.selectLoading = false;
		return _this;
	}

	ReplyModalComponent__createClass(ReplyModalComponent, [{
		key: 'shouldComponentUpdate',
		value: function shouldComponentUpdate(nextProps, nextState) {
			return nextProps.isOpen !== this.props.isOpen || nextProps.loading !== this.props.loading || nextProps.responseHash !== this.props.responseHash || nextProps.attachmentLoading !== this.props.attachmentLoading || !isEqual_default()(nextProps.attachments, this.props.attachments) || !isEqual_default()(nextProps.options, this.props.options) || !isEqual_default()(nextState, this.state);
		}
	}, {
		key: 'componentWillReceiveProps',
		value: function componentWillReceiveProps(nextProps) {
			if (nextProps.isOpen !== this.props.isOpen) {
				if (nextProps.isOpen) {
					// Update state
					this._refreshState(nextProps);
				} else {
					// reset state if we close it
					this.setState({
						title: '',
						subject: '',
						message: '',
						reason: '',
						uservalues: []
					});
				}
			}
		}
	}, {
		key: 'componentDidUpdate',
		value: function componentDidUpdate(prevProps) {
			if (prevProps.isOpen === false && prevProps.isOpen !== this.props.isOpen) {
				// using pushState to avoid popstate to be triggered
				history.pushState({ topifyExtra: true, type: 'replyModal' }, '', window.location);
			}
		}
	}, {
		key: '_refreshState',
		value: function _refreshState(nextProps) {
			var newState = {};

			if (nextProps.options && nextProps.options.user && this.state.uservalues.length === 0) {
				newState = {
					uservalues: [{
						userid: nextProps.options.user.id,
						username: nextProps.options.user.userName || nextProps.options.user.username
					}]
				};
			}

			// Get default state values per type and set other settings
			switch (nextProps.options.type) {
				case 'editPost':
					// Get current attachments when editing
					this.props.dispatch(Object(AttachmentsActions["g" /* updateEditingPostAttachments */])());
					newState.message = this._messageContent(nextProps);
					break;

				case 'replyQuoting':
				case 'replyPost':
					newState.title = this.props.dispatch(Object(ContextInfoActions["y" /* topicTitle */])(nextProps.options.id));
					newState.message = this._messageContent(nextProps);
					break;

				case 'replyMessageQuoting':
				case 'replyMessage':
					newState.subject = 'Re: ' + this.props.dispatch(Object(ContextInfoActions["q" /* messageTitle */])(nextProps.options.id)).replace(/Re:\s*/, '');
					newState.message = this._messageContent(nextProps);
					break;
			}

			// Save the new state
			this.setState(newState);
		}
	}, {
		key: '_messageContent',
		value: function _messageContent(props) {
			switch (props.options.type) {
				case 'replyQuoting':
					return this.props.dispatch(Object(ContextInfoActions["t" /* replyQuote */])());

				case 'editPost':
					return this.props.dispatch(Object(ContextInfoActions["p" /* messageContent */])());

				case 'replyMessageQuoting':
					return this.props.dispatch(Object(ContextInfoActions["t" /* replyQuote */])([parseInt(props.options.id)]));

				default:
					return '';
			}
		}
	}, {
		key: 'title',
		value: function title() {
			switch (this.type) {
				case 'replyQuoting':
				case 'replyPost':
					return 'Post Reply';

				case 'newTopic':
					return 'New Topic';

				case 'newMessage':
					return 'Create Message';

				case 'replyMessageQuoting':
				case 'replyMessage':
					return 'Message Reply';

				case 'editPost':
					return 'Edit Post';

				default:
					return '';
			}
		}
	}, {
		key: 'recipients',
		value: function recipients() {
			return react_default.a.createElement(Select_default.a.Async, {
				multi: true,
				matchProp: 'label',
				valueKey: 'userid',
				labelKey: 'username',
				placeholder: 'To:',
				value: this.state.uservalues,
				loadOptions: this.getUsernames,
				isLoading: this.selectLoading,
				autoload: false,
				minimumInput: 1,
				backspaceRemoves: true,
				onChange: this.handleSelectChange
			});
		}
	}, {
		key: 'deleteImage',
		value: function deleteImage(id) {
			document.getElementById('attachment_' + id).classList.add('removing');
			this.props.dispatch(Object(AttachmentsActions["d" /* deleteAttachment */])(ReplyModalComponent__extends({}, this.removeAttachmentData, {
				delete: id
			})));
		}
	}, {
		key: 'actionButtons',
		value: function actionButtons() {
			switch (this.type) {
				case 'newTopic':
				case 'replyQuoting':
				case 'replyPost':
				case 'editPost':
					return react_default.a.createElement(
						'div',
						{ className: 'buttons-container' },
						react_default.a.createElement(
							'div',
							{ className: 'buttons', onClick: this.attachImage },
							react_default.a.createElement(svg_SvgIcon, { icon: 'attach_file', size: '24px' }),
							react_default.a.createElement('input', { type: 'file', id: 'imagePicker', name: 'file',
								accept: 'image/png, image/jpeg, image/jpg, image/gif', style: { display: 'none' },
								onChange: this.uploadFiles,
								multiple: false })
						),
						react_default.a.createElement(
							'div',
							{ className: 'buttons', onClick: this.sendMessage },
							react_default.a.createElement(svg_SvgIcon, { icon: 'send', size: '24px' })
						)
					);

				default:
					return react_default.a.createElement(
						'div',
						{ className: 'buttons-container' },
						react_default.a.createElement(
							'div',
							{ className: 'buttons', onClick: this.sendMessage },
							react_default.a.createElement(svg_SvgIcon, { icon: 'send', size: '24px' })
						)
					);
			}
		}
	}, {
		key: 'images',
		value: function images() {
			var _this2 = this;

			var klazz = this.props.attachmentLoading === true ? '' : 'hidden';
			return this.props.attachments.map(function (attachment) {
				return react_default.a.createElement(
					'li',
					{ key: attachment.id, id: 'attachment_' + attachment.id, className: 'attachment' },
					react_default.a.createElement(
						'span',
						{ className: 'remove', onClick: function onClick() {
								_this2.deleteImage(attachment.id);
							} },
						'X'
					),
					react_default.a.createElement('img', { src: attachment.url, alt: '', style: { maxWidth: '140px' } })
				);
			}).concat(react_default.a.createElement(
				'li',
				{ key: '999', className: klazz + ' loader' },
				react_default.a.createElement(LoaderCssComponent, { style: { width: '140px', height: '90px' } })
			));
		}
	}, {
		key: 'content',
		value: function content() {
			switch (this.type) {
				case 'newTopic':
					var forumTitle = this.props.meta.path ? this.props.meta.path[0].title : '';
					return react_default.a.createElement(
						'div',
						{ className: 'reply-modal' },
						react_default.a.createElement(common_UserIconComponent, { user: this.currentUser, layout: 'nostatus', className: 'user-info', noAction: true }),
						react_default.a.createElement(
							'div',
							{ className: 'field' },
							react_default.a.createElement(
								'span',
								null,
								'New topic in: ',
								react_default.a.createElement(
									'em',
									null,
									RawToReact(forumTitle)
								)
							)
						),
						react_default.a.createElement(
							'div',
							{ className: 'field input' },
							react_default.a.createElement(
								'label',
								{ htmlFor: 'replyTitle', className: 'field-label' },
								react_default.a.createElement('input', { name: 'title', onChange: this.handleInputChange, type: 'text', placeholder: 'Title', value: this.state.title })
							)
						),
						react_default.a.createElement(
							'div',
							{ className: 'field input' },
							react_default.a.createElement(
								'label',
								{ htmlFor: 'replyMessage', className: 'field-label' },
								react_default.a.createElement(react_textarea_autosize_es["a" /* default */], { name: 'message',
									style: { maxHeight: 200 },
									onChange: this.handleInputChange,
									placeholder: 'Your Post...',
									value: this.state.message
								})
							)
						),
						react_default.a.createElement(
							'ul',
							null,
							this.images()
						)
					);

				case 'replyQuoting':
				case 'replyPost':
					return react_default.a.createElement(
						'div',
						{ className: 'reply-modal' },
						react_default.a.createElement(common_UserIconComponent, { user: this.currentUser, layout: 'nostatus', className: 'user-info', noAction: true }),
						react_default.a.createElement(
							'div',
							{ className: 'field input' },
							react_default.a.createElement(
								'span',
								null,
								'Post reply to:'
							),
							react_default.a.createElement(
								'label',
								{ htmlFor: 'replyTitle', className: 'field-label' },
								react_default.a.createElement('input', { name: 'title', onChange: this.handleInputChange, type: 'text', placeholder: 'Title', value: this.state.title })
							)
						),
						react_default.a.createElement(
							'div',
							{ className: 'field input' },
							react_default.a.createElement(
								'label',
								{ htmlFor: 'replyMessage', className: 'field-label' },
								react_default.a.createElement(react_textarea_autosize_es["a" /* default */], {
									name: 'message',
									onChange: this.handleInputChange,
									style: { maxHeight: 200 },
									placeholder: 'Your Post...',
									value: this.state.message
								})
							)
						),
						react_default.a.createElement(
							'ul',
							null,
							this.images()
						)
					);

				case 'editPost':
					return react_default.a.createElement(
						'div',
						{ className: 'reply-modal' },
						react_default.a.createElement(common_UserIconComponent, { user: this.currentUser, layout: 'nostatus', className: 'user-info', noAction: true }),
						react_default.a.createElement(
							'div',
							{ className: 'field input' },
							react_default.a.createElement(
								'label',
								{ htmlFor: 'reasonForEditing', className: 'field-label' },
								react_default.a.createElement('input', { name: 'reason', onChange: this.handleInputChange, type: 'text', placeholder: 'Reason for Editing', value: this.state.reason })
							)
						),
						react_default.a.createElement(
							'div',
							{ className: 'field input' },
							react_default.a.createElement(
								'label',
								{ htmlFor: 'replyMessage', className: 'field-label' },
								react_default.a.createElement(react_textarea_autosize_es["a" /* default */], {
									name: 'message',
									style: { maxHeight: 200 },
									onChange: this.handleInputChange,
									placeholder: 'Your Post...',
									value: this.state.message
								})
							)
						),
						react_default.a.createElement(
							'ul',
							null,
							this.images()
						)
					);

				case 'newMessage':
					return react_default.a.createElement(
						'div',
						{ className: 'reply-modal' },
						react_default.a.createElement(
							'div',
							{ className: 'field' },
							this.recipients(),
							react_default.a.createElement('label', { htmlFor: 'replyTo', className: 'field-label' })
						),
						react_default.a.createElement(
							'div',
							{ className: 'field input' },
							react_default.a.createElement(
								'label',
								{ htmlFor: 'replySubject', className: 'field-label' },
								react_default.a.createElement('input', { name: 'subject', onChange: this.handleInputChange, type: 'text', placeholder: 'Subject:', value: this.state.subject })
							)
						),
						react_default.a.createElement(
							'div',
							{ className: 'field input' },
							react_default.a.createElement(
								'label',
								{ htmlFor: 'replyMessage', className: 'field-label' },
								react_default.a.createElement(react_textarea_autosize_es["a" /* default */], {
									name: 'message',
									style: { maxHeight: 200 },
									onChange: this.handleInputChange,
									placeholder: 'Your message...',
									value: this.state.message
								})
							)
						)
					);

				case 'replyMessageQuoting':
				case 'replyMessage':
					return react_default.a.createElement(
						'div',
						{ className: 'reply-modal' },
						react_default.a.createElement(
							'div',
							{ className: 'field' },
							this.recipients(),
							react_default.a.createElement('label', { htmlFor: 'replyTo', className: 'field-label' })
						),
						react_default.a.createElement(
							'div',
							{ className: 'field input' },
							react_default.a.createElement(
								'label',
								{ htmlFor: 'replySubject', className: 'field-label' },
								react_default.a.createElement('input', { name: 'subject', onChange: this.handleInputChange, type: 'text', placeholder: 'Subject:', readOnly: true, value: this.state.subject })
							)
						),
						react_default.a.createElement(
							'div',
							{ className: 'field input' },
							react_default.a.createElement(
								'label',
								{ htmlFor: 'replyMessage', className: 'field-label' },
								react_default.a.createElement(react_textarea_autosize_es["a" /* default */], {
									name: 'message',
									style: { maxHeight: 200 },
									onChange: this.handleInputChange,
									placeholder: 'Your message...',
									value: this.state.message
								})
							)
						)
					);
			}
		}
	}, {
		key: 'render',
		value: function render() {
			if (!this.props.isOpen) {
				return null;
			}

			var className = this.props.loading ? ' opened' : '';

			return react_default.a.createElement(
				'div',
				{ className: 'modal reply' },
				react_default.a.createElement(
					'div',
					{ className: 'reply-window', onClick: function onClick(e) {
							e.stopPropagation();
						} },
					react_default.a.createElement(
						'header',
						{ id: 'headerModal', className: 'primary' },
						react_default.a.createElement(
							'div',
							{ className: 'buttons-container leftHeaderIcons' },
							react_default.a.createElement(
								'div',
								{ className: 'buttons', onClick: this.hideThisReplyModal },
								react_default.a.createElement(svg_SvgIcon, { icon: 'arrow_back', size: '24px' })
							)
						),
						react_default.a.createElement(
							'div',
							{ className: 'title' },
							this.title()
						),
						this.actionButtons()
					),
					react_default.a.createElement(
						'section',
						{ className: 'reply-content' },
						this.content()
					),
					react_default.a.createElement(
						'div',
						{ className: 'overlayMask' + className },
						react_default.a.createElement(
							'span',
							{ className: 'globalLoading' + className },
							'Sending...'
						)
					)
				)
			);
		}
	}, {
		key: 'currentUser',
		get: function get() {
			return this.props.dispatch(Object(ContextInfoActions["i" /* currentUser */])());
		}
	}, {
		key: 'type',
		get: function get() {
			return this.props.options.type;
		}
	}, {
		key: 'data',
		get: function get() {
			var data = void 0,
			    sendTo = void 0;
			switch (this.type) {
				case 'newTopic':
					return ReplyModalComponent__extends({
						type: 'topic',
						forumid: this.props.options.id,
						title: encodeURIComponent(this.state.title),
						message: encodeURIComponent(this.state.message)
					}, this.props.responseHash);

				case 'replyPost':
				case 'replyQuoting':
					data = ReplyModalComponent__extends({
						type: 'reply',
						forumid: this.props.dispatch(Object(ContextInfoActions["w" /* topicForumId */])(this.props.options.id)),
						topic: this.props.options.id,
						message: encodeURIComponent(this.state.message)
					}, this.props.responseHash);
					var oldTitle = this.props.dispatch(Object(ContextInfoActions["y" /* topicTitle */])(this.props.options.id));
					if (oldTitle !== this.state.title) {
						data.title = encodeURIComponent(this.state.title);
					}

					return data;

				case 'editPost':
					var reasonValue = this.state.reason;
					data = ReplyModalComponent__extends({
						type: 'edit',
						relpostid: parseInt(this.props.dispatch(Object(ContextInfoActions["s" /* postSelected */])())),
						message: encodeURIComponent(this.state.message)
					}, this.props.responseHash);

					if (reasonValue === '') {
						return data;
					} else {
						return ReplyModalComponent__extends({}, data, {
							reason: reasonValue
						});
					}

				case 'newMessage':
					sendTo = this.state.uservalues.map(function (t) {
						return t.userid;
					}).join(',');
					return {
						type: 'pm',
						to: sendTo,
						message: encodeURIComponent(this.state.message),
						title: encodeURIComponent(this.state.subject)
					};

				case 'replyMessageQuoting':
				case 'replyMessage':
					sendTo = this.state.uservalues.map(function (t) {
						return t.userid;
					}).join(',');
					return {
						type: 'pm',
						to: sendTo,
						reply: this.props.options.id,
						title: encodeURIComponent(this.state.subject),
						message: encodeURIComponent(this.state.message)
					};

				default:
					return {};
			}
		}
	}, {
		key: 'attachmentsData',
		get: function get() {
			switch (this.type) {
				case 'newTopic':
					return ReplyModalComponent__extends({
						type: 'upload',
						forumid: this.props.options.id,
						uid: this.currentUser.id
					}, this.props.responseHash);

				case 'replyPost':
				case 'replyQuoting':
					return ReplyModalComponent__extends({
						type: 'upload',
						topic: this.props.options.id,
						uid: this.currentUser.id
					}, this.props.responseHash);

				case 'editPost':
					return ReplyModalComponent__extends({
						type: 'upload',
						post: parseInt(this.props.dispatch(Object(ContextInfoActions["s" /* postSelected */])())),
						uid: this.currentUser.id
					}, this.props.responseHash);

				default:
					return {};
			}
		}
	}, {
		key: 'removeAttachmentData',
		get: function get() {
			switch (this.type) {
				case 'editPost':
					return ReplyModalComponent__extends({
						type: 'deleteattachment',
						uid: this.currentUser.id,
						editpost: parseInt(this.props.dispatch(Object(ContextInfoActions["s" /* postSelected */])()))
					}, this.props.responseHash);

				default:
					return ReplyModalComponent__extends({
						type: 'deleteattachment',
						uid: this.currentUser.id
					}, this.props.responseHash);
			}
		}
	}]);

	return ReplyModalComponent;
}(react["Component"]);

var ReplyModalComponent_mapStateToProps = function mapStateToProps(state) {
	return {
		isOpen: state.ui.replyModal.opened,
		options: state.ui.replyModal.options,
		loading: state.ui.replyModal.loading,
		responseHash: state.ui.replyModal.responseHash,
		attachments: state.ui.replyModal.attachments,
		attachmentLoading: state.ui.replyModal.attachmentLoading,
		url: state.topifyPresets.forumSite.url,
		ustate: state.ustate,
		forumview: state.forumview,
		meta: state.meta
	};
};

/* harmony default export */ var modals_ReplyModalComponent = (Object(es["b" /* connect */])(ReplyModalComponent_mapStateToProps)(ReplyModalComponent_ReplyModalComponent));
// CONCATENATED MODULE: ./src/components/modals/UserModalComponent.js
var UserModalComponent__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function UserModalComponent__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function UserModalComponent__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function UserModalComponent__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



















var UserModalComponent_UserModalComponent = function (_React$Component) {
	UserModalComponent__inherits(UserModalComponent, _React$Component);

	function UserModalComponent() {
		var _ref;

		var _temp, _this, _ret;

		UserModalComponent__classCallCheck(this, UserModalComponent);

		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		return _ret = (_temp = (_this = UserModalComponent__possibleConstructorReturn(this, (_ref = UserModalComponent.__proto__ || Object.getPrototypeOf(UserModalComponent)).call.apply(_ref, [this].concat(args))), _this), _this.hideModalAndBack = function () {
			if (_this.props.isOpen) {
				_this.props.dispatch(Object(react_router_redux_lib["goBack"])());
			}
		}, _this.sendMessage = function () {
			var userInfo = _this.props.user.userName ? _this.props.user : _this.props.dispatch(Object(ContextInfoActions["m" /* getUserInfo */])(parseInt(_this.props.user.id)));
			_this.hideModal();

			if (_this.currentUser.id) {
				_this.props.dispatch(Object(UiActions["Q" /* showReplyModal */])({ type: 'newMessage', user: userInfo }));
				// Record the Google Analytics event.
				_this.props.dispatch(Object(adsActions["A" /* trackGAEvent */])(false, 'messageByUserModal', 'uiAction', 'tap'));
			} else {
				// for guests show the login modal
				_this.props.dispatch(Object(UiActions["P" /* showLoginModal */])());
				// Record the Google Analytics event.
				_this.props.dispatch(Object(adsActions["A" /* trackGAEvent */])(false, 'messageByUserModal', 'userAction', 'loginPrompt'));
			}
		}, _temp), UserModalComponent__possibleConstructorReturn(_this, _ret);
	}

	UserModalComponent__createClass(UserModalComponent, [{
		key: 'shouldComponentUpdate',
		value: function shouldComponentUpdate(nextProps) {
			return nextProps.isOpen !== this.props.isOpen;
		}
	}, {
		key: 'componentDidUpdate',
		value: function componentDidUpdate(prevProps) {
			if (prevProps.isOpen === false && prevProps.isOpen !== this.props.isOpen) {
				// using pushState to avoid popstate to be triggered
				history.pushState({ topifyExtra: true, type: 'userModal' }, '', window.location);
			}
		}
	}, {
		key: 'hideModal',
		value: function hideModal() {
			this.props.dispatch(Object(UiActions["J" /* hideUserModal */])());
		}
	}, {
		key: 'showUserProfile',
		value: function showUserProfile() {
			this.hideModal();

			if (this.currentUser.id) {
				this.props.dispatch(Object(react_router_redux_lib["replace"])(Object(NavHelpers["r" /* pathToUserProfile */])(this.props.user.id)));
				// Record the Google Analytics event.
				this.props.dispatch(Object(adsActions["A" /* trackGAEvent */])(false, 'userProfileByUserModal', 'uiAction', 'tap'));
			} else {
				// for guests show the login modal
				this.props.dispatch(Object(UiActions["P" /* showLoginModal */])());
				// Record the Google Analytics event.
				this.props.dispatch(Object(adsActions["A" /* trackGAEvent */])(false, 'userProfileByUserModal', 'userAction', 'loginPrompt'));
			}
		}
	}, {
		key: 'banUser',
		value: function banUser(userId) {
			var banType = ''; // from here just regular ban
			this.props.dispatch(banUser_confirm(userId, banType, function (type, content) {
				return react_default.a.createElement(modtools_banUserConfirmation, { type: type, content: content });
			}));
			this.hideModal();
			// Record the Google Analytics event.
			this.props.dispatch(Object(adsActions["A" /* trackGAEvent */])(false, 'userBanByUserModal', 'uiAction', 'tap'));
		}
	}, {
		key: 'moreOptions',
		value: function moreOptions() {
			var _this2 = this;

			this.currentUser;
			var userPerms = this.userPerms;
			if (this.props.isOpen) {
				// ModTools
				if (userPerms.modperms) {
					if (userPerms.modperms.canbanusers && this.currentUser.id !== this.props.user.id) {
						return react_default.a.createElement(
							'div',
							{ className: 'action-button alert', onClick: function onClick() {
									return _this2.banUser(_this2.props.user.id);
								} },
							react_default.a.createElement(svg_SvgIcon, { size: '32px', icon: 'block' })
						);
					}
				}
			}
			return null;
		}
	}, {
		key: 'render',
		value: function render() {
			var _this3 = this;

			var _props = this.props,
			    user = _props.user,
			    defaultUrl = _props.defaultUrl;


			var userImage = user.avatar === '' ? defaultUrl : user.avatar,
			    isGuest = !user.id;

			var sendMessage = !isGuest && this.currentUser.id !== user.id ? react_default.a.createElement(
				'div',
				{ className: 'action-button', onClick: this.sendMessage },
				react_default.a.createElement(svg_SvgIcon, { size: '32px', icon: 'message' })
			) : null,
			    moreOptions = !isGuest ? this.moreOptions() : null,
			    showUserProfile = !isGuest ? react_default.a.createElement(
				'div',
				{ className: 'action-button', onClick: function onClick() {
						return _this3.showUserProfile();
					} },
				react_default.a.createElement(svg_SvgIcon, { size: '32px', icon: 'account_circle' })
			) : null;

			return react_default.a.createElement(
				modals_ModalComponent,
				{ isOpen: this.props.isOpen, onClickOutsideWindow: this.hideModalAndBack, className: 'user-modal' },
				react_default.a.createElement(
					'span',
					{ className: 'username' },
					user.userName
				),
				react_default.a.createElement(
					'div',
					{ className: 'avatar' },
					react_default.a.createElement('img', { className: 'no-ad', src: userImage })
				),
				react_default.a.createElement(
					'div',
					{ className: 'modal-buttons' },
					sendMessage,
					moreOptions,
					showUserProfile
				)
			);
		}
	}, {
		key: 'currentUser',
		get: function get() {
			return this.props.dispatch(Object(ContextInfoActions["i" /* currentUser */])());
		}
	}, {
		key: 'userPerms',
		get: function get() {
			return this.props.dispatch(Object(ContextInfoActions["l" /* getUSerPermissions */])());
		}
	}]);

	return UserModalComponent;
}(react_default.a.Component);

UserModalComponent_UserModalComponent.defaultProps = {
	defaultUrl: ('https:' === document.location.protocol ? 'https://' : 'http://') + 'staticimages.topify.com/default_avatar.png'
};

UserModalComponent_UserModalComponent.propTypes = {
	isOpen: prop_types_default.a.bool.isRequired,
	path: prop_types_default.a.array.isRequired,
	user: prop_types_default.a.object.isRequired
};

var UserModalComponent_mapStateToProps = function mapStateToProps(state) {
	return {
		isOpen: state.ui.userModal.opened,
		path: state.ui.userModal.path,
		user: state.ui.userModal.user
	};
};

/* harmony default export */ var modals_UserModalComponent = (Object(es["b" /* connect */])(UserModalComponent_mapStateToProps)(UserModalComponent_UserModalComponent));
// CONCATENATED MODULE: ./src/components/modals/ShareLinkComponent.js
var ShareLinkComponent__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function ShareLinkComponent__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function ShareLinkComponent__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function ShareLinkComponent__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }


















var ShareLinkComponent_ShareModalComponent = function (_React$Component) {
	ShareLinkComponent__inherits(ShareModalComponent, _React$Component);

	function ShareModalComponent() {
		var _ref;

		var _temp, _this, _ret;

		ShareLinkComponent__classCallCheck(this, ShareModalComponent);

		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		return _ret = (_temp = (_this = ShareLinkComponent__possibleConstructorReturn(this, (_ref = ShareModalComponent.__proto__ || Object.getPrototypeOf(ShareModalComponent)).call.apply(_ref, [this].concat(args))), _this), _this.hideModalAndBack = function () {
			if (_this.props.isOpen) {
				_this.props.dispatch(Object(react_router_redux_lib["goBack"])());
			}
		}, _temp), ShareLinkComponent__possibleConstructorReturn(_this, _ret);
	}

	ShareLinkComponent__createClass(ShareModalComponent, [{
		key: 'shouldComponentUpdate',
		value: function shouldComponentUpdate(nextProps) {
			return nextProps.isOpen !== this.props.isOpen;
		}
	}, {
		key: 'componentDidUpdate',
		value: function componentDidUpdate(prevProps) {
			if (prevProps.isOpen === false && prevProps.isOpen !== this.props.isOpen) {
				// using pushState to avoid popstate to be triggered
				history.pushState({ topifyExtra: true, type: 'shareModal' }, '', window.location);
			}
		}
	}, {
		key: 'thisContext',
		value: function thisContext() {
			var thisContext = {
				type: null,
				url: null,
				title: null
			},
			    path = Object(NavHelpers["a" /* parsePath */])(this.props.routing.locationBeforeTransitions.pathname);

			if (path && path.length > 0) {
				switch (path[1] || path[0]) {
					case '/':
						return {
							type: 'Home',
							url: this.props.f_url,
							title: simpleDecodeEntities(this.props.title)
						};

					case 'forums':
						// TODO: implement -> process.env.config.section.home === true
						return {
							type: 'Forum',
							url: this.props.dispatch(Object(ContextInfoActions["j" /* forumHref */])(path[2])),
							title: simpleDecodeEntities(this.props.title)
						};

					case 'topics':
						return {
							type: 'Topic',
							url: this.props.dispatch(Object(ContextInfoActions["x" /* topicHref */])(path[2])),
							title: simpleDecodeEntities(this.props.title)
						};
				}
			}
			return thisContext;
		}
	}, {
		key: 'shareAction',
		value: function shareAction(type) {
			var thisContext = this.thisContext(),
			    closeThis = true;

			switch (type) {
				case 'facebook':
					window.open('https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(thisContext.url));
					break;

				case 'twitter':
					window.open('https://twitter.com/home?status=' + encodeURIComponent(thisContext.url));
					break;

				case 'google':
					window.open('https://plus.google.com/share?url=' + encodeURIComponent(thisContext.url));
					break;

				case 'sms':
				case 'email':
					// do nothing but do not exit
					break;

				case 'clipboard':
					closeThis = false;
					this.clipboardText.textContent = thisContext.url;
					this.clipboard.classList.add('hidden');
					this.clipboardText.classList.remove('hidden');

					// is element selectable?
					if (this.clipboardText) {
						// select text
						var range = document.createRange();
						range.selectNodeContents(this.clipboardText);

						var selection = window.getSelection();
						// ensure selection is empty
						selection.removeAllRanges();
						// load our selected text
						selection.addRange(range);

						try {
							// copy text
							var copied = document.execCommand('copy');

							if (copied) {
								selection.removeAllRanges();
								Object(UiActions["B" /* displayNotification */])('info', 'Link copied', { timeout: 1000 });
								closeThis = true;
							} else {
								throw false;
							}
						} catch (err) {
							Object(UiActions["B" /* displayNotification */])('warning', 'You have to tap and copy the link manually', { force: true, timeout: 4000 });
						}
					}

					break;

				default:
					// Do nothing.
					return;
			}

			// send analytics of what and how is shared
			this.props.dispatch(Object(adsActions["A" /* trackGAEvent */])(false, thisContext.type ? thisContext.type.toLowerCase() : 'unk', 'userAction', 'sharing'));
			this.props.dispatch(Object(adsActions["A" /* trackGAEvent */])(false, type, 'userAction', 'sharingAction'));

			if (closeThis) {
				// and close
				this.hideModalAndBack();
			}
		}
	}, {
		key: 'buildShareButtons',
		value: function buildShareButtons() {
			var _this2 = this;

			var thisContext = this.thisContext(),
			    email = 'mailto:?subject=' + encodeURIComponent(thisContext.title) + '&body=' + encodeURIComponent(thisContext.url + "\r\n"),
			    deviceInfo = Object(deviceType["b" /* deviceType */])(),
			    smsFormat = deviceInfo.os.platform.ios && deviceInfo.browser.engine === 'Safari' ? '&' : '?',
			    sms = 'sms:' + smsFormat + 'body=' + thisContext.url;

			var buttons = [react_default.a.createElement('input', { key: 'clipboard', className: 'button clipboard', type: 'button', value: 'copy to clipboard', ref: function ref(c) {
					return _this2.clipboard = c;
				}, onClick: function onClick() {
					return _this2.shareAction('clipboard');
				} }), react_default.a.createElement('span', { key: 'clipboard-text', className: 'clipboard-text hidden', ref: function ref(t) {
					return _this2.clipboardText = t;
				} }), react_default.a.createElement('input', { key: 'fb', className: 'button facebook', type: 'button', value: 'Facebook', onClick: function onClick() {
					return _this2.shareAction('facebook');
				} }), react_default.a.createElement('input', { key: 'g+', className: 'button google', type: 'button', value: 'Google', onClick: function onClick() {
					return _this2.shareAction('google');
				} }), react_default.a.createElement('input', { key: 'tw', className: 'button twitter', type: 'button', value: 'Twitter', onClick: function onClick() {
					return _this2.shareAction('twitter');
				} }), react_default.a.createElement(
				'a',
				{ key: 'email', className: 'button email', href: email, onClick: function onClick() {
						return _this2.shareAction('email');
					} },
				'email'
			), react_default.a.createElement(
				'a',
				{ key: 'sms', className: 'button sms', href: sms, onClick: function onClick() {
						return _this2.shareAction('sms');
					} },
				'sms'
			)];

			return react_default.a.createElement(
				'div',
				{ key: 'social-buttons', className: 'modal-buttons social-buttons block-buttons' },
				buttons
			);
		}
	}, {
		key: 'render',
		value: function render() {
			var thisContext = this.thisContext();

			return react_default.a.createElement(
				modals_ModalComponent,
				{ isOpen: this.props.isOpen, onClickOutsideWindow: this.hideModalAndBack },
				react_default.a.createElement(
					'div',
					{ className: 'share-modal' },
					react_default.a.createElement(
						'h2',
						null,
						'Share'
					),
					react_default.a.createElement(
						'h3',
						null,
						thisContext.title
					),
					react_default.a.createElement(
						'div',
						{ className: 'modal-buttons' },
						this.buildShareButtons()
					),
					react_default.a.createElement(
						'div',
						{ className: 'modal-buttons' },
						react_default.a.createElement('input', { className: 'cancel-button', type: 'button', value: 'Cancel', onClick: this.hideModalAndBack })
					)
				)
			);
		}
	}]);

	return ShareModalComponent;
}(react_default.a.Component);

ShareLinkComponent_ShareModalComponent.propTypes = {
	isOpen: prop_types_default.a.bool.isRequired
};

var ShareLinkComponent_mapStateToProps = function mapStateToProps(state) {
	return {
		isOpen: state.ui.shareModal.opened,
		routing: state.routing,
		title: state.meta.title || '',
		f_url: state.topifyPresets.forumSite.f_url
	};
};

/* harmony default export */ var ShareLinkComponent = (Object(es["b" /* connect */])(ShareLinkComponent_mapStateToProps)(ShareLinkComponent_ShareModalComponent));
// CONCATENATED MODULE: ./src/selectors/uiSelectors.js


var uiSelectors_uiSelector = function uiSelector(state) {
	return state.ui;
};
var uiSelectors_routingSelector = function routingSelector(state) {
	return state.routing;
};
var uiSelectors_userPermissionsSelector = function userPermissionsSelector(state) {
	return state.ustate.perms;
};

/* harmony default export */ var uiSelectors = (Object(lib["createSelector"])([uiSelectors_uiSelector, uiSelectors_routingSelector, uiSelectors_userPermissionsSelector], function (ui, routing, userPermissions) {
	return {
		sidebarOpened: ui.sidebarOpened,
		searchBarOpened: ui.searchBarOpened,
		headerOverflowOpened: ui.headerOverflowOpened,
		loginModalOpened: ui.loginModalOpened,
		confirmModalOpened: ui.confirmModalOpened,
		confirmModalOptions: ui.confirmModalOptions,
		globalLoading: ui.globalLoading,
		replyModalOpened: ui.replyModal.opened,
		userModalOpened: ui.userModal.opened,
		shareModalOpened: ui.shareModal.opened,
		iOSkeyBoardOpen: ui.iOSkeyBoardOpen,
		announcementsOpen: ui.announcementsOpen,
		userPermissions: userPermissions,
		routing: routing
	};
}));
// CONCATENATED MODULE: ./src/components/common/overlayComponent.js
var overlayComponent__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function overlayComponent__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function overlayComponent__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function overlayComponent__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }














var overlayComponent_overlayComponent = function (_React$Component) {
	overlayComponent__inherits(overlayComponent, _React$Component);

	function overlayComponent() {
		var _ref;

		var _temp, _this, _ret;

		overlayComponent__classCallCheck(this, overlayComponent);

		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		return _ret = (_temp = (_this = overlayComponent__possibleConstructorReturn(this, (_ref = overlayComponent.__proto__ || Object.getPrototypeOf(overlayComponent)).call.apply(_ref, [this].concat(args))), _this), _this.resetThisOverlay = function () {
			if (_this.props.sidebarOpened) {
				_this.props.dispatch(Object(react_router_redux_lib["goBack"])());
			}
			_this.props.dispatch(Object(UiActions["M" /* resetOverlay */])());
			// Record the Google Analytics event.
			_this.props.dispatch(Object(adsActions["A" /* trackGAEvent */])(false, 'overlayClose', 'uiAction', 'tap'));
		}, _temp), overlayComponent__possibleConstructorReturn(_this, _ret);
	}

	overlayComponent__createClass(overlayComponent, [{
		key: 'shouldComponentUpdate',
		value: function shouldComponentUpdate(nextProps) {
			return nextProps.headerOverflowOpened !== this.props.headerOverflowOpened || nextProps.searchBarOpened !== this.props.searchBarOpened || nextProps.sidebarOpened !== this.props.sidebarOpened || nextProps.globalLoading !== this.props.globalLoading;
		}
	}, {
		key: 'overlayClass',
		value: function overlayClass() {
			return this.props.headerOverflowOpened || this.props.searchBarOpened || this.props.sidebarOpened || this.props.globalLoading ? ' opened' : '';
		}
	}, {
		key: 'globalLoadingClass',
		value: function globalLoadingClass() {
			return this.props.globalLoading ? ' opened' : '';
		}
	}, {
		key: 'render',
		value: function render() {
			return react_default.a.createElement(
				'div',
				{ className: 'overlayMask' + this.overlayClass(), onClick: this.resetThisOverlay },
				react_default.a.createElement(
					'span',
					{ className: 'globalLoading' + this.globalLoadingClass() },
					this.props.globalLoading
				)
			);
		}
	}]);

	return overlayComponent;
}(react_default.a.Component);

overlayComponent_overlayComponent.propTypes = {
	dispatch: prop_types_default.a.func.isRequired,
	globalLoading: prop_types_default.a.string.isRequired,
	headerOverflowOpened: prop_types_default.a.bool.isRequired,
	searchBarOpened: prop_types_default.a.bool.isRequired,
	sidebarOpened: prop_types_default.a.bool.isRequired
};

/* harmony default export */ var common_overlayComponent = (Object(es["b" /* connect */])(uiSelectors)(overlayComponent_overlayComponent));
// CONCATENATED MODULE: ./src/components/alerts/alertsTemplate.js
var alertsTemplate__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function alertsTemplate__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function alertsTemplate__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function alertsTemplate__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



var alertsTemplate_TopifyAlertsTemplate = function (_React$Component) {
	alertsTemplate__inherits(TopifyAlertsTemplate, _React$Component);

	function TopifyAlertsTemplate() {
		alertsTemplate__classCallCheck(this, TopifyAlertsTemplate);

		return alertsTemplate__possibleConstructorReturn(this, (TopifyAlertsTemplate.__proto__ || Object.getPrototypeOf(TopifyAlertsTemplate)).apply(this, arguments));
	}

	alertsTemplate__createClass(TopifyAlertsTemplate, [{
		key: 'render',
		value: function render() {
			var closeX = react_default.a.createElement('span', { className: 's-alert-close', onClick: this.props.handleClose });

			return react_default.a.createElement(
				'div',
				{ className: this.props.classNames, id: this.props.id, style: this.props.styles },
				react_default.a.createElement(
					'div',
					{ className: 's-alert-box-inner', onClick: this.props.handleClose },
					closeX,
					this.props.message
				)
			);
		}
	}]);

	return TopifyAlertsTemplate;
}(react_default.a.Component);

/* harmony default export */ var alertsTemplate = (alertsTemplate_TopifyAlertsTemplate);
// EXTERNAL MODULE: ./src/actions/NoticesActions.js
var NoticesActions = __webpack_require__(238);

// CONCATENATED MODULE: ./src/components/alerts/NoticeComponent.js
var NoticeComponent__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function NoticeComponent__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function NoticeComponent__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function NoticeComponent__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }













var NoticeComponent_NoticeComponent = function (_React$Component) {
	NoticeComponent__inherits(NoticeComponent, _React$Component);

	function NoticeComponent(props) {
		NoticeComponent__classCallCheck(this, NoticeComponent);

		var _this = NoticeComponent__possibleConstructorReturn(this, (NoticeComponent.__proto__ || Object.getPrototypeOf(NoticeComponent)).call(this, props));

		_this.saveDismissedNotice = function (e) {
			e.stopPropagation();
			_this.props.dispatch(Object(NoticesActions["b" /* dismissNotice */])(_this.props.notice.id));
			_this.handleClose(e);
		};

		_this.showDismiss = function () {
			var _this$props = _this.props,
			    notice = _this$props.notice,
			    isLoggedIn = _this$props.isLoggedIn;

			return notice && notice.dismissible && isLoggedIn;
		};

		_this.handleClose = function (e) {
			e.stopPropagation();
			_this.setState({ hidden: true });
			_this.props.dispatch(Object(NoticesActions["c" /* noticeShown */])([_this.props.notice.id]));
		};

		_this.expandMessage = function (event) {
			if (event.currentTarget) {
				var collapsed = event.currentTarget.classList.contains('collapsed');

				if (!collapsed) {
					window.scrollTo(0, 0);
				}

				event.currentTarget.classList.toggle('collapsed');

				// Record the Google Analytics event.
				_this.props.dispatch(Object(adsActions["A" /* trackGAEvent */])(false, collapsed ? 'expandNotice' : 'collapseNotice', 'uiAction', 'tap'));
			}
		};

		_this.state = {
			hidden: false
		};
		return _this;
	}

	NoticeComponent__createClass(NoticeComponent, [{
		key: 'shouldComponentUpdate',
		value: function shouldComponentUpdate(nextProps, nextState) {
			return !isEqual_default()(nextProps, this.props) || !isEqual_default()(nextState, this.state);
		}
	}, {
		key: 'render',
		value: function render() {
			if (this.state.hidden) {
				return null;
			}

			var closeX = this.showDismiss() ? react_default.a.createElement(
				'div',
				{ className: 'modal-buttons notice-buttons' },
				react_default.a.createElement(
					'button',
					{ className: 'action-button', onClick: this.saveDismissedNotice },
					react_default.a.createElement(svg_SvgIcon, { size: '1rem', icon: 'delete_forever' }),
					' Dismiss notice'
				)
			) : react_default.a.createElement(
				'div',
				{ className: 'notice-buttons', onClick: this.handleClose },
				react_default.a.createElement(svg_SvgIcon, { size: '1.5rem', icon: 'cancel' })
			);

			var content_showed = simpleDecodeEntities(RawToReact(this.props.notice.content.replace(/\n{2,}/m, "\n")));

			return react_default.a.createElement(
				'li',
				{ key: 'notice_' + this.props.notice.id, className: 'notice collapsed', onClick: this.expandMessage },
				react_default.a.createElement(
					'div',
					{ className: 'nolinks thread' },
					react_default.a.createElement(
						'div',
						{ className: 'right' },
						react_default.a.createElement(
							'div',
							{ className: 'thread-info' },
							closeX
						),
						react_default.a.createElement(
							'div',
							{ className: 'notice-content' },
							content_showed
						)
					)
				)
			);
		}
	}]);

	return NoticeComponent;
}(react_default.a.Component);

/* harmony default export */ var alerts_NoticeComponent = (Object(es["b" /* connect */])()(NoticeComponent_NoticeComponent));
// CONCATENATED MODULE: ./src/components/alerts/NoticesListComponent.js
var NoticesListComponent__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function NoticesListComponent__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function NoticesListComponent__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function NoticesListComponent__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var NoticesListComponent_NoticesListComponent = function (_React$Component) {
	NoticesListComponent__inherits(NoticesListComponent, _React$Component);

	function NoticesListComponent(props) {
		NoticesListComponent__classCallCheck(this, NoticesListComponent);

		var _this = NoticesListComponent__possibleConstructorReturn(this, (NoticesListComponent.__proto__ || Object.getPrototypeOf(NoticesListComponent)).call(this, props));

		_this.buildNotice = function (key, notice) {
			return react_default.a.createElement(alerts_NoticeComponent, {
				key: key,
				notice: notice,
				dispatch: _this.props.dispatch,
				isLoggedIn: _this.props.userId
			});
		};

		_this.noticesShown = [];
		return _this;
	}

	NoticesListComponent__createClass(NoticesListComponent, [{
		key: 'shouldComponentUpdate',
		value: function shouldComponentUpdate(nextProps) {
			return nextProps.isLoading !== this.props.isLoading || !isEqual_default()(nextProps.notices.entities, this.props.notices.entities);
		}
	}, {
		key: 'componentDidUpdate',
		value: function componentDidUpdate() {
			if (this.noticesShown.length) {
				this.props.dispatch(Object(NoticesActions["c" /* noticeShown */])(this.noticesShown));
			}
			this.noticesShown = [];
		}
	}, {
		key: 'render',
		value: function render() {
			var _this2 = this;

			if (this.props.isFetching) {
				return null;
			}

			var _props$notices = this.props.notices,
			    entities = _props$notices.entities,
			    result = _props$notices.result,
			    shown = _props$notices.shown;

			var counter = 0;

			var noticesList = result.map(function (notice, i) {
				if (shown[notice] === undefined && // did we already show it?
				entities[notice].content // and do we have content?
				) {
						counter++;
						// if it's persisten show it always until the user closes it
						if (entities[notice].persistent === false) {
							_this2.noticesShown.push(notice);
						}
						return _this2.buildNotice(i, entities[notice]);
					}
			});

			if (counter === 0) {
				return null;
			}

			return react_default.a.createElement(
				'div',
				{ id: 'notices', className: 'threads notices' },
				react_default.a.createElement(
					'ul',
					null,
					noticesList
				)
			);
		}
	}]);

	return NoticesListComponent;
}(react_default.a.Component);

NoticesListComponent_NoticesListComponent.propTypes = {
	notices: prop_types_default.a.object.isRequired,
	isLoading: prop_types_default.a.bool.isRequired,
	userId: prop_types_default.a.number.isRequired
};

var NoticesListComponent_mapStateToProps = function mapStateToProps(state) {
	return {
		notices: state.notices,
		isLoading: state.meta.isLoading,
		userId: state.ustate.id
	};
};

/* harmony default export */ var alerts_NoticesListComponent = (Object(es["b" /* connect */])(NoticesListComponent_mapStateToProps)(NoticesListComponent_NoticesListComponent));
// CONCATENATED MODULE: ./src/selectors/ads.js


var ads_adsSelector = function adsSelector(state) {
	return state.ads;
};

/* harmony default export */ var selectors_ads = (Object(lib["createSelector"])([ads_adsSelector], function (ads) {
	return {
		geoLocation: ads.geoLocation,
		adSlots: ads.adSlots,
		showInterstitial: ads.showInterstitial,
		noAdsPermissions: ads.noAdsPermissions,
		secondaryAds: ads.secondaryAds,
		analytics: ads.analytics
	};
}));
// CONCATENATED MODULE: ./src/components/PageComponent.js
var PageComponent__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var PageComponent__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function PageComponent__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function PageComponent__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function PageComponent__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










































var PageComponent_PageComponent = function (_React$Component) {
	PageComponent__inherits(PageComponent, _React$Component);

	function PageComponent(props) {
		PageComponent__classCallCheck(this, PageComponent);

		var _this = PageComponent__possibleConstructorReturn(this, (PageComponent.__proto__ || Object.getPrototypeOf(PageComponent)).call(this, props));

		_this.checkOldPhone = function () {
			//handling webkit/flex styles for older ios devices
			var deviceInfo = Object(deviceType["b" /* deviceType */])();

			return deviceInfo.any && (deviceInfo.os.platform.ios && deviceInfo.os.version < '9' || deviceInfo.os.platform.android && (deviceInfo.browser.engine === 'Safari' && parseInt(deviceInfo.browser.version) <= 534 || deviceInfo.browser.engine === 'Chrome' && parseInt(deviceInfo.browser.version) <= 37));
		};

		_this.deviceInfo = {};
		_this.state = {
			viewportHeight: window.innerHeight - 48
		};
		_this.currentScroll = 0;
		_this.isOldPhone = _this.checkOldPhone();
		return _this;
	}

	PageComponent__createClass(PageComponent, [{
		key: 'componentWillMount',
		value: function componentWillMount() {
			var _props = this.props,
			    initialRoute = _props.initialRoute,
			    initialId = _props.initialId,
			    secondayId = _props.secondayId,
			    routes = _props.routes,
			    isVS = _props.isVS;

			// Get userInfo as soon as possible

			if (this.props.userInfo && this.props.userInfo.id) {
				this.props.dispatch(Object(UstateActions["a" /* receiveCurrentUser */])(this.props.userInfo));
			}

			var landingPagePath = this.props.dispatch(Object(UserSettingsActions["c" /* getLandingPage */])());

			history.replaceState(null, '', location.href.replace(/rtemv=\d+/i, '').replace(/tfr=1/i, ''));

			// if we have an initial route from the forum but we don't have already a different path
			if (initialRoute && !(routes.length > 1 && routes[1].path)) {
				if (initialRoute === 'portal' && parseInt(isVS) !== 1) {
					// we only allow portal for VS sites
					this.props.dispatch(Object(GlobalMetaActions["c" /* clearFirstLoad */])());
				} else {
					var path = {
						pathname: initialRoute + "/" + initialId
					};
					if (secondayId) {
						path.query = { postid: secondayId };
					}

					this.props.dispatch(Object(react_router_redux_lib["push"])(path));
				}
			} else if (routes.length > 1 && routes[1].path) {
				// Let's insert a step in history to the home page if we start on a page other than home
				// unless we are on 'localhost' env
				if (/localhost|192\.168\./.test(window.location.host) === false) {
					history.replaceState(null, '', this.props.forum_url);
					history.pushState(null, '', this.props.forum_url);
					this.props.dispatch(Object(react_router_redux_lib["push"])(this.props.location));
				}
			} else if (landingPagePath !== this.props.location.pathname) {
				// Go to the landingPage from UserSettings
				this.props.dispatch(Object(react_router_redux_lib["push"])(landingPagePath));
			}

			// Ask for geoLocation
			this.props.dispatch(Object(adsActions["n" /* getGeoLocation */])());

			// Init ads
			this.props.dispatch(Object(adsActions["p" /* initAdLibraries */])());

			//handling webkit/flex styles for older ios devices
			this.deviceInfo = Object(deviceType["b" /* deviceType */])();

			topifyConsole.info('deviceInfo:', this.deviceInfo);
			document.body.classList.add(Object(deviceType["a" /* devicePlatform */])(), this.deviceInfo.browser.engine);
		}
	}, {
		key: 'componentDidMount',
		value: function componentDidMount() {
			var _this2 = this;

			// If we have a message to show
			if (this.props.location.query.msg) {
				Object(UiActions["B" /* displayNotification */])(this.props.location.query.msgtype || 'warning', this.props.location.query.msg, { timeout: 2000 });
				// remove msg from the url
				delete this.props.location.query.msg;
				delete this.props.location.query.msgtype;
				this.props.dispatch(Object(react_router_redux_lib["replace"])(this.props.location));
			}

			if (this.props.firstLoad) {
				this.props.dispatch(Object(GlobalMetaActions["c" /* clearFirstLoad */])());
			}

			window.addEventListener('popstate', function (e) {
				return _this2.resetOverWindows(e);
			});
			window.addEventListener('resize', function () {
				return _this2.getViewportHeight();
			});

			this.getViewportHeight();
		}
	}, {
		key: 'componentWillReceiveProps',
		value: function componentWillReceiveProps(nextProps) {
			if (nextProps.loginModalOpened || nextProps.confirmModalOpened || nextProps.globalLoading || nextProps.headerOverflowOpened || nextProps.searchBarOpened || nextProps.userModalOpened || nextProps.replyModalOpened || nextProps.shareModalOpened || nextProps.iOSkeyBoardOpen || nextProps.announcementsOpen) {
				// Take the scroll position
				this.currentScroll = this.currentScroll || document.body.scrollTop;

				// Prevents page scrolling while modal is open
				document.body.classList.add('no-scroll');
			} else {
				// Safely remove the class we added
				document.body.classList.remove('no-scroll');

				// Only for iOS - Safari: we need to restore scroll position
				if (this.currentScroll > 0 && this.deviceInfo.os.platform.ios && this.deviceInfo.browser.engine === 'Safari') {
					document.body.scrollTop = this.currentScroll;
				}
				// clear scroll position
				this.currentScroll = 0;
			}

			// Track page view if it's the case
			if (nextProps.ads.analytics !== this.props.ads.analytics && nextProps.routing.locationBeforeTransitions.pathname === this.props.routing.locationBeforeTransitions.pathname && nextProps.infiniteScrollPage !== this.props.infiniteScrollPage) {
				// trigger ad updates
				this.props.dispatch(Object(adsActions["s" /* onPageView */])());
				// Record the Google Analytics pageview
				this.props.dispatch(Object(adsActions["B" /* trackPageView */])());
			}
		}
	}, {
		key: 'shouldComponentUpdate',
		value: function shouldComponentUpdate(nextProps, nextState) {
			return nextProps.children !== this.props.children || !isEqual_default()(nextState, this.state) || nextProps.ads.showInterstitial !== this.props.ads.showInterstitial || nextProps.userSettings.styleTheme !== this.props.userSettings.styleTheme || nextProps.userSettings.fontSize !== this.props.userSettings.fontSize;
		}
	}, {
		key: 'getViewportHeight',
		value: function getViewportHeight() {
			this.setState({ viewportHeight: window.innerHeight - 48 });
		}
	}, {
		key: 'resetOverWindows',
		value: function resetOverWindows(e) {
			if (this.props.confirmModalOpened) {
				if (e.state && e.state.type === 'confirmModal') {
					topifyConsole.info('cleaning history ', e.state);
					this.props.dispatch(Object(react_router_redux_lib["goBack"])());
				}

				this.props.dispatch(Object(UiActions["C" /* hideConfirmModal */])());
				return true;
			}

			// In some cases we have more than 1 extra entry in history, let's clean them up
			if (e.state && e.state.topifyExtra) {
				topifyConsole.info('cleaning history ', e.state);
				this.props.dispatch(Object(react_router_redux_lib["goBack"])());
			}

			// Close any modal open
			if (this.props.headerOverflowOpened) {
				this.props.dispatch(Object(UiActions["X" /* toggleHeaderOverflow */])());
			}
			if (this.props.searchBarOpened) {
				this.props.dispatch(Object(UiActions["Y" /* toggleSearchBar */])());
			}
			if (this.props.sidebarOpened) {
				this.props.dispatch(Object(UiActions["V" /* sidebarOff */])());
			}
			if (this.props.userModalOpened) {
				this.props.dispatch(Object(UiActions["J" /* hideUserModal */])());
			}
			if (this.props.loginModalOpened) {
				this.props.dispatch(Object(UiActions["E" /* hideLoginModal */])());
			}
			if (this.props.replyModalOpened) {
				this.props.dispatch(Object(UiActions["F" /* hideReplyModal */])());
			}
			if (this.props.shareModalOpened) {
				this.props.dispatch(Object(UiActions["I" /* hideShareModal */])());
			}

			return true;
		}
	}, {
		key: 'interstitialAd',
		value: function interstitialAd() {
			if (this.props.ads.showInterstitial) {
				return react_default.a.createElement(ads_AdComponent, { adType: '4', adName: 'Interstitial_Ad' });
			} else {
				return null;
			}
		}
	}, {
		key: 'render',
		value: function render() {
			var style = this.props.userSettings.styleTheme ? ' style-' + this.props.userSettings.styleTheme : ' style-light',
			    fontSize = this.props.userSettings.fontSize ? ' fontSize-' + this.props.userSettings.fontSize : ' fontSize-normal',
			    appClassNames = (this.isOldPhone ? ' old_phones' : '') + style + fontSize;

			/**
    * This means spacing between notifications.
    * Note that since we reduce the padding of the alert (page.css -> .s-alert-wrapper)
    * we need to adapt this spacing: ( ( <our padding top> - 22 ) * 2 ) + <the space we want>
    * this way we have => ( ( 10 - 22 ) * 2 ) + 2) = -22
    */
			var alertSpacing = -22;

			return react_default.a.createElement(
				'div',
				{ id: 'app', className: appClassNames, style: { minHeight: this.state.viewportHeight } },
				react_default.a.createElement(react_s_alert_default.a, {
					stack: { spacing: alertSpacing },
					timeout: 4000,
					effect: this.isOldPhone ? '' : 'stackslide',
					position: 'top',
					html: true,
					offset: 2,
					contentTemplate: alertsTemplate
				}),
				react_default.a.createElement(header_HeaderComponent, null),
				react_default.a.createElement(header_SearchBarComponent, null),
				react_default.a.createElement(HeaderOverflowComponent, null),
				react_default.a.createElement(
					'section',
					{ id: 'page' },
					react_default.a.createElement(alerts_NoticesListComponent, null),
					this.props.children,
					react_default.a.createElement('div', { className: 'clearBottom' })
				),
				react_default.a.createElement(ads_AdComponent, { adType: '3', className: 'bottom-fixed-ad', adName: 'Fixed_Bottom_Leaderboard' }),
				react_default.a.createElement(common_SidebarComponent, null),
				react_default.a.createElement(modals_LoginModalComponent, null),
				react_default.a.createElement(modals_ConfirmModalComponent, null),
				react_default.a.createElement(modals_ReplyModalComponent, null),
				react_default.a.createElement(modals_UserModalComponent, null),
				react_default.a.createElement(ShareLinkComponent, null),
				react_default.a.createElement(common_overlayComponent, null),
				this.interstitialAd()
			);
		}
	}]);

	return PageComponent;
}(react_default.a.Component);

PageComponent_PageComponent.propTypes = {
	initialRoute: prop_types_default.a.string,
	initialId: prop_types_default.a.string,
	secondayId: prop_types_default.a.string
};

var PageComponent_mapStateToProps = function mapStateToProps(state) {
	return PageComponent__extends({
		firstLoad: state.topifyPresets.firstLoad,
		initialRoute: state.topifyPresets.initialRoute,
		initialId: state.topifyPresets.initialId,
		secondayId: state.topifyPresets.secondayId,
		forum_url: state.topifyPresets.forumSite.f_url,
		isVS: state.topifyPresets.forumSite.isVS,
		userInfo: state.topifyPresets.userInfo,
		registerUrl: state.ustate.registerUrl,
		socialOptions: state.ustate.socialOptions
	}, uiSelectors(state), {
		userSettings: state.ui.userSettings,
		ads: selectors_ads(state),
		routing: state.routing,
		infiniteScrollPage: state.infiniteScroll.page
	});
};

/* harmony default export */ var components_PageComponent = (Object(es["b" /* connect */])(PageComponent_mapStateToProps)(PageComponent_PageComponent));
// CONCATENATED MODULE: ./src/selectors/releaseNotesSelector.js


var releaseNotesSelector = function releaseNotesSelector(state) {
  return state.releaseNotes;
};

/* harmony default export */ var selectors_releaseNotesSelector = (Object(lib["createSelector"])(releaseNotesSelector, function (releaseNotes) {
  return { releaseNotes: releaseNotes };
}));
// EXTERNAL MODULE: ./src/actions/ReleaseNotesActions.js
var ReleaseNotesActions = __webpack_require__(155);

// EXTERNAL MODULE: ./src/styles/releasenotes.scss
var releasenotes = __webpack_require__(821);
var releasenotes_default = /*#__PURE__*/__webpack_require__.n(releasenotes);

// CONCATENATED MODULE: ./src/components/releasenotes/ReleaseNotesListComponent.js
var ReleaseNotesListComponent__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function ReleaseNotesListComponent__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function ReleaseNotesListComponent__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function ReleaseNotesListComponent__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }














var ReleaseNotesListComponent_ReleaseNotesListComponent = function (_React$Component) {
	ReleaseNotesListComponent__inherits(ReleaseNotesListComponent, _React$Component);

	function ReleaseNotesListComponent() {
		var _ref;

		var _temp, _this, _ret;

		ReleaseNotesListComponent__classCallCheck(this, ReleaseNotesListComponent);

		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		return _ret = (_temp = (_this = ReleaseNotesListComponent__possibleConstructorReturn(this, (_ref = ReleaseNotesListComponent.__proto__ || Object.getPrototypeOf(ReleaseNotesListComponent)).call.apply(_ref, [this].concat(args))), _this), _this.expandNotification = function (e) {
			e.stopPropagation();
			e.currentTarget.classList.toggle('showNote');
			return true;
		}, _this.buildNote = function (note) {
			return react_default.a.createElement(
				'div',
				{ className: 'releaseNote', key: note.n_id, onClick: _this.expandNotification },
				react_default.a.createElement(
					'div',
					{ className: 'noteTitle' },
					[note.n_title],
					react_default.a.createElement(
						'p',
						null,
						react_default.a.createElement(common_dateComponent, { timestamp: note.n_timestamp_unix, icon: true })
					)
				),
				react_default.a.createElement(
					'div',
					{ className: 'noteContent' },
					RawToReact(note.n_text.replace(/\n\t/ig, '').replace(/\n\n/ig, '\n '))
				)
			);
		}, _this.buildPage = function (pageNum) {
			var _this$props$releaseNo = _this.props.releaseNotes,
			    entities = _this$props$releaseNo.entities,
			    result = _this$props$releaseNo.result;


			var releaseNotes = result.notes.filter(function (e) {
				return entities.notes[e] && entities.notes[e].page === pageNum;
			}),
			    notesList = releaseNotes.map(function (id, i) {
				return _this.buildNote(entities.notes[id]);
			});

			return react_default.a.createElement(
				'ul',
				{ key: pageNum, className: 'scroll_page page_' + pageNum },
				notesList
			);
		}, _temp), ReleaseNotesListComponent__possibleConstructorReturn(_this, _ret);
	}

	ReleaseNotesListComponent__createClass(ReleaseNotesListComponent, [{
		key: 'releaseNotesPage',
		value: function releaseNotesPage() {
			var _this2 = this;

			return this.props.pages.map(function (pageNum) {
				return _this2.buildPage(pageNum);
			});
		}
	}, {
		key: 'render',
		value: function render() {
			return react_default.a.createElement(
				'div',
				{ ref: this.props.listRef, className: 'releaseNoteContainer' },
				this.releaseNotesPage()
			);
		}
	}]);

	return ReleaseNotesListComponent;
}(react_default.a.Component);

ReleaseNotesListComponent_ReleaseNotesListComponent.propTypes = {
	dispatch: prop_types_default.a.func.isRequired,
	pages: prop_types_default.a.array.isRequired
};

/* harmony default export */ var releasenotes_ReleaseNotesListComponent = (Object(es["b" /* connect */])(selectors_releaseNotesSelector)(ReleaseNotesListComponent_ReleaseNotesListComponent));
// CONCATENATED MODULE: ./src/components/ReleaseNotesViewComponent.js
var ReleaseNotesViewComponent__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function ReleaseNotesViewComponent__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function ReleaseNotesViewComponent__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function ReleaseNotesViewComponent__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }















var ReleaseNotesViewComponent_ReleaseNotesViewComponent = function (_React$Component) {
	ReleaseNotesViewComponent__inherits(ReleaseNotesViewComponent, _React$Component);

	function ReleaseNotesViewComponent() {
		var _ref;

		var _temp, _this, _ret;

		ReleaseNotesViewComponent__classCallCheck(this, ReleaseNotesViewComponent);

		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		return _ret = (_temp = (_this = ReleaseNotesViewComponent__possibleConstructorReturn(this, (_ref = ReleaseNotesViewComponent.__proto__ || Object.getPrototypeOf(ReleaseNotesViewComponent)).call.apply(_ref, [this].concat(args))), _this), _this.releaseNotesList = function () {
			var isFetching = _this.props.releaseNotes.isFetching;

			if (_this.releaseNotes.length !== 0) {
				return react_default.a.createElement(
					infiniteScroll_InfiniteScrollComponent,
					{
						scrollRef: function scrollRef(i) {
							return _this.infiniteScroll = i;
						},
						isFetching: isFetching,
						loadPage: _this.loadPage,
						location: _this.props.location },
					react_default.a.createElement(releasenotes_ReleaseNotesListComponent, null)
				);
			} else {
				return react_default.a.createElement(
					'div',
					null,
					'Unable to retrieve release notifications'
				);
			}
		}, _this.loadPage = function (pageNum) {
			_this.props.dispatch(Object(ReleaseNotesActions["e" /* whatReleaseNotes */])(pageNum));
		}, _temp), ReleaseNotesViewComponent__possibleConstructorReturn(_this, _ret);
	}

	ReleaseNotesViewComponent__createClass(ReleaseNotesViewComponent, [{
		key: 'componentWillUnmount',
		value: function componentWillUnmount() {
			this.props.dispatch(Object(InfiniteScrollActions["f" /* resetInfinite */])());
			this.props.dispatch(Object(ReleaseNotesActions["d" /* resetReleaseNotes */])());
		}
	}, {
		key: 'componentDidMount',
		value: function componentDidMount() {
			var page = this.props.location.query.page || 1;
			this.loadPage(page);
		}
	}, {
		key: 'componentWillReceiveProps',
		value: function componentWillReceiveProps(nextProps) {
			if (nextProps.releaseNotes.loaded && nextProps.releaseNotes.loaded !== this.props.releaseNotes.loaded) {
				// trigger ad updates
				this.props.dispatch(Object(adsActions["s" /* onPageView */])());
				// Record the Google Analytics pageview
				this.props.dispatch(Object(adsActions["B" /* trackPageView */])());
				// Ping server for user info
				this.props.dispatch(Object(GlobalMetaActions["g" /* pingServer */])());
			}
		}
	}, {
		key: 'render',
		value: function render() {
			if (!this.props.releaseNotes.loaded) {
				return react_default.a.createElement(LoaderCssComponent, null);
			}

			return react_default.a.createElement(
				'div',
				null,
				this.releaseNotesList()
			);
		}
	}, {
		key: 'releaseNotes',
		get: function get() {
			return this.props.releaseNotes.result;
		}
	}]);

	return ReleaseNotesViewComponent;
}(react_default.a.Component);

/* harmony default export */ var components_ReleaseNotesViewComponent = (Object(es["b" /* connect */])(selectors_releaseNotesSelector)(ReleaseNotesViewComponent_ReleaseNotesViewComponent));
// EXTERNAL MODULE: ./src/styles/portalpage.scss
var portalpage = __webpack_require__(822);
var portalpage_default = /*#__PURE__*/__webpack_require__.n(portalpage);

// CONCATENATED MODULE: ./src/selectors/portalPageSelector.js



var portalPageSelector_topifyPresetsSelector = function topifyPresetsSelector(state) {
	return state.topifyPresets;
};
var portalPageSelector_userStateSelector = function userStateSelector(state) {
	return state.ustate;
};
var portalPageSelector = function portalPageSelector(state) {
	return state.portalpage;
};

/* harmony default export */ var selectors_portalPageSelector = (Object(lib["createSelector"])([selectors_metaSelector, portalPageSelector_topifyPresetsSelector, portalPageSelector_userStateSelector, portalPageSelector], function (meta, topifyPresets, ustate, portalpage) {
	return {
		meta: meta,
		ustate: ustate,
		topifyPresets: topifyPresets,
		portalpage: portalpage
	};
}));
// EXTERNAL MODULE: ./src/actions/PortalPageActions.js
var PortalPageActions = __webpack_require__(118);

// CONCATENATED MODULE: ./src/components/PortalPageComponent.js
var PortalPageComponent__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function PortalPageComponent__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function PortalPageComponent__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function PortalPageComponent__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

















var PortalPageComponent_PortalPageComponent = function (_React$Component) {
	PortalPageComponent__inherits(PortalPageComponent, _React$Component);

	function PortalPageComponent() {
		PortalPageComponent__classCallCheck(this, PortalPageComponent);

		return PortalPageComponent__possibleConstructorReturn(this, (PortalPageComponent.__proto__ || Object.getPrototypeOf(PortalPageComponent)).apply(this, arguments));
	}

	PortalPageComponent__createClass(PortalPageComponent, [{
		key: 'componentDidMount',
		value: function componentDidMount() {
			if (this.props.params.pagename) {
				this.props.dispatch(Object(PortalPageActions["e" /* fetchPortalPage */])({
					pagename: this.props.params.pagename
				}));
			} else {
				// Go to landing page
				var landingPage = this.props.dispatch(Object(UserSettingsActions["c" /* getLandingPage */])());
				this.props.dispatch(Object(react_router_redux_lib["replace"])(landingPage));
			}
		}
	}, {
		key: 'componentWillReceiveProps',
		value: function componentWillReceiveProps(nextProps) {
			if (nextProps.portalpage.isFetching === false) {
				this.props.dispatch(Object(adsActions["l" /* checkAdsPermissions */])(-1));
			}
			if (nextProps.portalpage.loaded && nextProps.portalpage.loaded !== this.props.portalpage.loaded) {
				// trigger ad updates
				this.props.dispatch(Object(adsActions["s" /* onPageView */])());
				// Record the Google Analytics pageview
				this.props.dispatch(Object(adsActions["B" /* trackPageView */])());
			}
		}
	}, {
		key: 'componentDidUpdate',
		value: function componentDidUpdate() {
			var _this2 = this;

			window.scrollTo(0, 0);

			if (this.props.portalpage.isFetching === false) {
				// Record the Google Analytics pageview
				this.props.dispatch(Object(adsActions["B" /* trackPageView */])());

				// Some scripts allowed to run in the pages when they are needed
				var scripts = [{
					type: 'twitter',
					script: ('https:' === document.location.protocol ? 'https://' : 'http://') + 'platform.twitter.com/widgets.js',
					selector: ".twitter-share-button"
				}];
				scripts.forEach(function (script) {
					// do we have the element needed?
					if (_this2.thePageContainer.querySelector(script.selector)) {
						// load the script
						var src = script.script;
						postscribe_default()(_this2.thePageContainer, '<script type="text/javascript" src="' + src + '"></script>', {
							done: function done() {
								topifyConsole.log("loading:", script.type);
							},
							error: function error() {
								topifyConsole.warn('error loading: ', script.type);
							}
						});
					}
				}, this);
			}
		}
	}, {
		key: 'getAdComponents',
		value: function getAdComponents() {
			var forumSite = this.props.topifyPresets.forumSite;
			var dfpTags = void 0;

			if (forumSite.dfpTags) {
				dfpTags = JSON.parse(forumSite.dfpTags);
			}

			var adUnits = dfpTags.filter(function (ad) {
				return parseInt(ad.at_id) >= 50 && parseInt(ad.at_id) <= 59;
			});

			if (adUnits) {
				return adUnits.map(function (unit) {
					var adName = /(?:\/[^/]+\/)?(.*)/ig.exec(unit.fda_path);
					if (adName.length === 2) {
						return react_default.a.createElement(ads_AdComponent, { key: adName[1], adType: unit.at_id, adName: adName[1] });
					} else {
						return null;
					}
				});
			}
			return null;
		}
	}, {
		key: 'render',
		value: function render() {
			var _this3 = this;

			if (!this.props.portalpage.loaded) {
				return react_default.a.createElement(LoaderCssComponent, null);
			}

			if (this.getPage && this.getPage.content) {
				var ads = this.getAdComponents();
				return react_default.a.createElement(
					'div',
					null,
					react_default.a.createElement(common_BreadcrumbComponent, { routeParams: this.props.routeParams }),
					react_default.a.createElement(
						'div',
						{ className: 'portalPage', ref: function ref(_ref) {
								return _this3.thePageContainer = _ref;
							} },
						ads,
						react_default.a.createElement('div', { key: 'page', dangerouslySetInnerHTML: { __html: this.getPage.content } })
					)
				);
			} else {
				return react_default.a.createElement(
					'div',
					null,
					'There is no content to show'
				);
			}
		}
	}, {
		key: 'getPage',
		get: function get() {
			var page = false;
			if (this.props.params.pagename && this.props.portalpage.entities.page) {
				page = this.props.portalpage.entities.page[this.props.params.pagename] || false;
			}
			return page;
		}
	}]);

	return PortalPageComponent;
}(react_default.a.Component);

/* harmony default export */ var components_PortalPageComponent = (Object(es["b" /* connect */])(selectors_portalPageSelector)(PortalPageComponent_PortalPageComponent));
// EXTERNAL MODULE: ./src/styles/register.scss
var styles_register = __webpack_require__(823);
var styles_register_default = /*#__PURE__*/__webpack_require__.n(styles_register);

// EXTERNAL MODULE: ./node_modules/normalizr/dist/src/index.js
var dist_src = __webpack_require__(218);
var dist_src_default = /*#__PURE__*/__webpack_require__.n(dist_src);

// CONCATENATED MODULE: ./src/selectors/registerUserSelector.js


var registerUserSelector_topifyPresetsSelector = function topifyPresetsSelector(state) {
	return state.topifyPresets;
};
var registerUserSelector_userStateSelector = function userStateSelector(state) {
	return state.ustate;
};

/* harmony default export */ var registerUserSelector = (Object(lib["createSelector"])([registerUserSelector_topifyPresetsSelector, registerUserSelector_userStateSelector], function (topifyPresets, ustate) {
	return {
		siteTitle: topifyPresets.forumSite.f_title,
		siteUrl: topifyPresets.forumSite.url,
		isVS: topifyPresets.forumSite.isVS,
		registerUrl: ustate.registerUrl
	};
}));
// CONCATENATED MODULE: ./src/components/RegisterComponent.js
var RegisterComponent__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function RegisterComponent__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function RegisterComponent__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function RegisterComponent__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






















var RegisterComponent_RegisterComponent = function (_React$Component) {
	RegisterComponent__inherits(RegisterComponent, _React$Component);

	function RegisterComponent(props) {
		RegisterComponent__classCallCheck(this, RegisterComponent);

		var _this = RegisterComponent__possibleConstructorReturn(this, (RegisterComponent.__proto__ || Object.getPrototypeOf(RegisterComponent)).call(this, props));

		_this.repositionScroll = function () {
			if (_this.header) {
				var headerDim = _this.header.getBoundingClientRect();
				var _form = react_dom_default.a.findDOMNode(_this.form);
				if (_form && headerDim.height) {
					_form.style.marginTop = headerDim.bottom + 'px';
				}
			}
		};

		_this.submitForm = function (e) {
			e.preventDefault();

			if (_this.forum_rules_agree.state.itemChecked === false) {
				_this.forum_rules_agree_container.classList.add('alert');
				var message = 'You must agree with the Forum rules';
				Object(UiActions["B" /* displayNotification */])('error', message, { force: true });
				return false;
			} else {
				_this.forum_rules_agree_container.classList.remove('alert');
			}
			if (_this.validateLogin()) {
				var data = {
					provider: _this.state.provider,
					username: _this.username.value,
					password: _this.props.location.query.pass === '1' ? _this.password.value : null,
					agree: _this.forum_rules_agree.state.itemChecked ? 1 : 0,
					uri: _this.state.uri
				};
				_this.props.dispatch(registerUserName(data));
			} else {
				var _message = 'Please provide a valid User Name' + (_this.props.location.query.pass === '1' ? ' and Password' : '');
				Object(UiActions["B" /* displayNotification */])('error', _message, { force: true });
				return false;
			}
		};

		_this.timerCheckUserName = null;

		_this.state = {
			nameOk: true,
			suggestedName: null,
			provider: null,
			uri: null,
			forum_rules: 'Loading...'
		};
		return _this;
	}

	RegisterComponent__createClass(RegisterComponent, [{
		key: 'componentDidMount',
		value: function componentDidMount() {
			this.setState({
				provider: this.props.location.query.provider,
				uri: this.props.location.query.uri || null,
				nameOk: this.props.location.query.ok === '1'
			});

			// Ping server for user info
			this.props.dispatch(Object(GlobalMetaActions["g" /* pingServer */])());

			this.repositionScroll();
			this.props.dispatch(Object(MetaActions["b" /* receiveGlobalMeta */])(null, 'Register New User', this.props.siteTitle));
			this.retrieveForumRules();
		}
	}, {
		key: 'componentDidUpdate',
		value: function componentDidUpdate() {
			this.repositionScroll();
		}
	}, {
		key: 'retrieveForumRules',


		/**
   * retrieves the forum rules
   */
		value: function retrieveForumRules() {
			var _this2 = this;

			var config = this.props.dispatch(Object(GlobalMetaActions["e" /* getFetchConfig */])(true));

			var user = new dist_src["schema"].Entity('users');

			return fetch(this.props.siteUrl + '?v=3.0&ajax=1&object=forum_rules&req=get&_=' + new Date().getTime(), config).then(function (response) {
				if (response.ok) {
					response.json().then(function (json) {
						if (json.forum_rules) {
							_this2.setState({
								forum_rules: json.forum_rules || 'error loading forum rules'
							});
							var result = Object.assign({}, Object(dist_src["normalize"])({
								users: json.forumUser.data
							}, {
								users: [user]
							}));
							var new_ustate = json.ustate;
							try {
								var currentUser = result.entities.users[new_ustate.id];
								new_ustate = Object.assign({}, new_ustate, { userName: currentUser.userName, avatar: currentUser.avatar, online: currentUser.online, lastActivity: currentUser.lastActivity });
							} catch (e) {
								new_ustate = Object.assign({}, new_ustate, { userName: null, avatar: null, online: null, lastActivity: null });
							}

							_this2.props.dispatch(Object(UstateActions["a" /* receiveCurrentUser */])(new_ustate));
						}
					});
				}
			});
		}
	}, {
		key: 'verifyUserName',
		value: function verifyUserName() {
			var _this3 = this;

			if (this.timerCheckUserName) {
				clearTimeout(this.timerCheckUserName);
				this.timerCheckUserName = undefined;
			}

			this.timerCheckUserName = setTimeout(function () {
				var username = _this3.username.value;
				_this3.setState = _this3.setState.bind(_this3);
				if (username) {
					_this3.props.dispatch(checkUserName(username)).then(function (response) {
						// in case we get the return too late and the input already changed
						if (username !== _this3.username.value) {
							return true;
						}
						if (response.username) {
							_this3.setState({
								nameOk: true,
								suggestedName: false
							});
						} else {
							_this3.setState({
								nameOk: false,
								suggestedName: decodeURIComponent(response.suggestedusername)
							});
						}
					});
				} else {
					_this3.setState({
						nameOk: false,
						suggestedName: decodeURIComponent(_this3.props.location.query.suggestedusername) || ''
					});
				}
			}, 400);
		}
	}, {
		key: 'validateLogin',
		value: function validateLogin() {
			var pass = this.props.location.query.pass === '1' ? this.password.value && this.password && /.+/.test(this.password.value) : true;
			return pass && this.username && /[^\s]+/.test(this.username.value);
		}
	}, {
		key: 'toggleShowRules',
		value: function toggleShowRules() {
			this.forum_rules_container.classList.toggle('hidden');
		}
	}, {
		key: 'render',
		value: function render() {
			var _this4 = this;

			// Only for VS sites with Integrated Registration form
			if (this.props.location.query.isvs === '1') {
				if (!this.props.registerUrl) {
					return react_default.a.createElement(LoaderCssComponent, null);
				}

				var redirectUrl = this.props.location.query.uri ? this.props.location.query.uri : '',
				    registration_url = '' + this.props.registerUrl + (/\?/i.test(this.props.registerUrl) ? '&' : '?') + 'mobileurl=' + (redirectUrl ? redirectUrl : '/');

				var content = react_default.a.createElement(
					'div',
					{ className: 'register' },
					react_default.a.createElement(
						'header',
						{ className: 'thread', ref: function ref(h) {
								return _this4.header = h;
							} },
						react_default.a.createElement(
							'h2',
							null,
							'Register at'
						),
						react_default.a.createElement(
							'h3',
							null,
							this.props.siteTitle
						)
					),
					react_default.a.createElement(
						'div',
						{ className: 'register-form', ref: function ref(h) {
								return _this4.form = h;
							} },
						react_default.a.createElement(
							'p',
							null,
							'You are not registered.'
						),
						react_default.a.createElement(
							'p',
							null,
							'We are redirecting you to our registration form.'
						),
						react_default.a.createElement(
							'p',
							{ className: 'note' },
							'Or click ',
							react_default.a.createElement(
								'a',
								{ href: registration_url },
								'Register with the forum'
							)
						)
					)
				);

				setTimeout(function () {
					document.location.replace(registration_url);
				}, 1000);

				return content;
			}

			var fields = {
				username: {
					label: 'Choose your User Name',
					input_placeholder: 'choose your user name',
					input_default: decodeURIComponent(this.props.location.query.suggestedusername) || ''
				},
				password: {
					label: 'Password',
					input_placeholder: 'password'
				}
			},
			    suggestion = this.state.suggestedName ? react_default.a.createElement(
				'span',
				null,
				'Our suggestion: ',
				react_default.a.createElement(
					'strong',
					null,
					this.state.suggestedName
				)
			) : null,
			    validUserName = this.state.nameOk ? react_default.a.createElement(
				'p',
				null,
				' '
			) : react_default.a.createElement(
				'p',
				{ className: 'action-button alert note' },
				react_default.a.createElement(svg_SvgIcon, { size: '16px', icon: 'warning' }),
				'User name already used, try a different one. ',
				suggestion
			),
			    passwordNeeded = this.props.location.query.pass && this.props.location.query.pass === '1' ? react_default.a.createElement(
				'div',
				{ key: 'password_label', className: 'field styled-field' },
				react_default.a.createElement(
					'label',
					{ className: 'field-label' },
					fields.password.label,
					react_default.a.createElement('input', { name: 'password',
						required: 'required', type: 'password', placeholder: fields.password.input_placeholder,
						ref: function ref(p) {
							return _this4.password = p;
						} })
				)
			) : null;

			return react_default.a.createElement(
				'div',
				{ className: 'register' },
				react_default.a.createElement(
					'header',
					{ className: 'thread', ref: function ref(h) {
							return _this4.header = h;
						} },
					react_default.a.createElement(
						'h2',
						null,
						'Register at'
					),
					react_default.a.createElement(
						'h3',
						null,
						this.props.siteTitle
					)
				),
				react_default.a.createElement(
					'div',
					{ className: 'register-form', ref: function ref(h) {
							return _this4.form = h;
						} },
					react_default.a.createElement(
						'form',
						{ className: 'modal-form', onSubmit: this.submitForm },
						react_default.a.createElement(
							'div',
							{ key: 'username_label', className: 'field styled-field' },
							react_default.a.createElement(
								'label',
								{ className: 'field-label' },
								fields.username.label,
								react_default.a.createElement('input', { className: this.state.nameOk ? 'isok' : 'alert', name: 'username',
									required: 'required', type: 'text', placeholder: fields.username.input_placeholder,
									defaultValue: fields.username.input_default ? fields.username.input_default : null,
									ref: function ref(u) {
										return _this4.username = u;
									}, onChange: function onChange(e) {
										return _this4.verifyUserName(e);
									} })
							),
							validUserName
						),
						passwordNeeded,
						react_default.a.createElement(
							'div',
							{ className: 'note' },
							'Your account will be associated with your ',
							react_default.a.createElement(
								'strong',
								null,
								this.props.location.query.provider
							),
							' account'
						),
						react_default.a.createElement(
							'div',
							{ className: 'note', ref: function ref(fr) {
									return _this4.forum_rules_agree_container = fr;
								} },
							react_default.a.createElement(CheckboxComponent, {
								name: 'agree',
								id: 'cb_rules_agree',
								value: '1',
								className: 'inLine',
								checked: false,
								multiple: true,
								ref: function ref(fr) {
									return _this4.forum_rules_agree = fr;
								}
							}),
							react_default.a.createElement(
								'span',
								null,
								'Yes, I agree with the ',
								react_default.a.createElement(
									'span',
									{ style: { textDecoration: 'underline' }, onClick: function onClick() {
											return _this4.toggleShowRules();
										} },
									'Forum Rules'
								)
							),
							react_default.a.createElement(
								'div',
								{ id: 'forum-rules', className: 'hidden', ref: function ref(fr) {
										return _this4.forum_rules_container = fr;
									} },
								react_default.a.createElement(
									'a',
									{ className: 'close-forumrules', onClick: function onClick() {
											return _this4.toggleShowRules();
										} },
									'hide',
									react_default.a.createElement(svg_SvgIcon, { icon: 'angle_up', size: '16px' })
								),
								react_default.a.createElement('div', { dangerouslySetInnerHTML: { __html: this.state.forum_rules } }),
								react_default.a.createElement(
									'a',
									{ className: 'close-forumrules', onClick: function onClick() {
											return _this4.toggleShowRules();
										} },
									'hide',
									react_default.a.createElement(svg_SvgIcon, { icon: 'angle_up', size: '16px' })
								)
							)
						),
						react_default.a.createElement(
							'div',
							{ className: 'modal-buttons' },
							react_default.a.createElement('input', { className: 'action-button', type: 'submit', value: 'Register' })
						)
					)
				)
			);
		}
	}]);

	return RegisterComponent;
}(react_default.a.Component);

/* harmony default export */ var components_RegisterComponent = (Object(es["b" /* connect */])(registerUserSelector)(RegisterComponent_RegisterComponent));
// EXTERNAL MODULE: ./src/styles/settings.scss
var styles_settings = __webpack_require__(348);
var styles_settings_default = /*#__PURE__*/__webpack_require__.n(styles_settings);

// CONCATENATED MODULE: ./src/selectors/settingsSelector.js


var settingsSelector_uiSelector = function uiSelector(state) {
	return state.ui;
};
var settingsSelector_topifyPresetsSelector = function topifyPresetsSelector(state) {
	return state.topifyPresets;
};
var settingsSelector_userStateSelector = function userStateSelector(state) {
	return state.ustate;
};

/* harmony default export */ var settingsSelector = (Object(lib["createSelector"])([settingsSelector_uiSelector, settingsSelector_topifyPresetsSelector, settingsSelector_userStateSelector], function (ui, topifyPresets, ustate) {
	return {
		userSettings: ui.userSettings,
		siteTitle: topifyPresets.forumSite.f_title,
		ustate: ustate
	};
}));
// CONCATENATED MODULE: ./src/components/SettingsComponent.js
var SettingsComponent__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var SettingsComponent__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function SettingsComponent__defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function SettingsComponent__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function SettingsComponent__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function SettingsComponent__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }















var SettingsComponent_SettingsComponent = function (_React$Component) {
	SettingsComponent__inherits(SettingsComponent, _React$Component);

	function SettingsComponent(props) {
		SettingsComponent__classCallCheck(this, SettingsComponent);

		var _this = SettingsComponent__possibleConstructorReturn(this, (SettingsComponent.__proto__ || Object.getPrototypeOf(SettingsComponent)).call(this, props));

		_this.state = SettingsComponent__extends({}, _this.props.userSettings);
		return _this;
	}

	SettingsComponent__createClass(SettingsComponent, [{
		key: 'componentWillMount',
		value: function componentWillMount() {
			this.props.dispatch(Object(GlobalMetaActions["g" /* pingServer */])());
		}
	}, {
		key: 'componentDidMount',
		value: function componentDidMount() {
			this.props.dispatch(Object(MetaActions["b" /* receiveGlobalMeta */])(null, 'Settings', this.props.siteTitle));
			window.scrollTo(0, 0);
		}
	}, {
		key: 'updateState',
		value: function updateState(event) {
			var value = event.target.checked ? event.target.value : false,
			    newStateProp = SettingsComponent__defineProperty({}, event.target.name, event.target.type === 'checkbox' && value ? true : value);

			this.setState(newStateProp);
			this.props.dispatch(Object(UserSettingsActions["h" /* saveSetting */])(newStateProp));
			this.props.dispatch(Object(adsActions["A" /* trackGAEvent */])(false, event.target.name + '_' + newStateProp[event.target.name], 'userAction', 'settings'));
		}
	}, {
		key: 'render',
		value: function render() {
			var _this2 = this;

			var whosonline = this.props.ustate.perms && this.props.ustate.perms.whosonline ? react_default.a.createElement(
				'li',
				{ className: 'settings-option' },
				react_default.a.createElement(
					'h1',
					null,
					'Online Users List Sorting'
				),
				react_default.a.createElement(
					'ul',
					null,
					react_default.a.createElement(
						'li',
						{ className: 'option' },
						react_default.a.createElement(CheckboxComponent, {
							name: 'onlineUsersLoadingBehavior',
							id: 'online-loading-behavior_recent',
							postLabel: 'Recent first',
							value: 'recent',
							className: 'inLine',
							checked: this.state.onlineUsersLoadingBehavior === 'recent',
							multiple: false,
							onChange: function onChange(e) {
								return _this2.updateState(e);
							}
						})
					),
					react_default.a.createElement(
						'li',
						{ className: 'option' },
						react_default.a.createElement(CheckboxComponent, {
							name: 'onlineUsersLoadingBehavior',
							id: 'online-loading-behavior_oldest',
							postLabel: 'UserName A -> Z',
							value: 'az',
							className: 'inLine',
							checked: this.state.onlineUsersLoadingBehavior === 'az',
							multiple: false,
							onChange: function onChange(e) {
								return _this2.updateState(e);
							}
						})
					),
					react_default.a.createElement(
						'li',
						{ className: 'option' },
						react_default.a.createElement(CheckboxComponent, {
							name: 'onlineUsersLoadingBehavior',
							id: 'online-loading-behavior_newest',
							postLabel: 'UserName Z -> A',
							value: 'za',
							className: 'inLine',
							checked: this.state.onlineUsersLoadingBehavior === 'za',
							multiple: false,
							onChange: function onChange(e) {
								return _this2.updateState(e);
							}
						})
					)
				)
			) : null;

			return react_default.a.createElement(
				'div',
				{ className: 'settings thread' },
				react_default.a.createElement(
					'ul',
					{ className: 'settings-form' },
					react_default.a.createElement(
						'li',
						{ className: 'settings-option' },
						react_default.a.createElement(
							'h1',
							null,
							'Loading Behavior'
						),
						react_default.a.createElement(
							'div',
							{ className: 'note' },
							'On those pages where sorting is available'
						),
						react_default.a.createElement(
							'ul',
							null,
							react_default.a.createElement(
								'li',
								{ className: 'option' },
								react_default.a.createElement(CheckboxComponent, {
									name: 'loadingBehavior',
									id: 'loading-behavior_oldest',
									postLabel: 'Oldest first',
									value: 'oldest',
									className: 'inLine',
									checked: this.state.loadingBehavior === 'oldest',
									multiple: false,
									onChange: function onChange(e) {
										return _this2.updateState(e);
									}
								})
							),
							react_default.a.createElement(
								'li',
								{ className: 'option' },
								react_default.a.createElement(CheckboxComponent, {
									name: 'loadingBehavior',
									id: 'loading-behavior_newest',
									postLabel: 'Newest first',
									value: 'newest',
									className: 'inLine',
									checked: this.state.loadingBehavior === 'newest',
									multiple: false,
									onChange: function onChange(e) {
										return _this2.updateState(e);
									}
								})
							)
						)
					),
					whosonline,
					react_default.a.createElement(
						'li',
						{ className: 'settings-option' },
						react_default.a.createElement(
							'h1',
							null,
							'Items Per Page'
						),
						react_default.a.createElement(
							'div',
							{ className: 'note' },
							'When an option other than \'Same as desktop\' is selected any change on desktop settings for this will be ignored'
						),
						react_default.a.createElement(
							'ul',
							null,
							react_default.a.createElement(
								'li',
								{ className: 'option' },
								react_default.a.createElement(CheckboxComponent, {
									name: 'pageSize',
									id: 'items-per-page_0',
									postLabel: 'Same value as desktop ( currently ' + (this.props.ustate.pageSize ? this.props.ustate.pageSize : 10) + ' )',
									value: '0',
									className: 'inLine',
									checked: parseInt(this.state.pageSize) === 0,
									multiple: false,
									onChange: function onChange(e) {
										return _this2.updateState(e);
									}
								})
							),
							react_default.a.createElement(
								'li',
								{ className: 'option' },
								react_default.a.createElement(CheckboxComponent, {
									name: 'pageSize',
									id: 'items-per-page_10',
									postLabel: '10 items per page (default)',
									value: '10',
									className: 'inLine',
									checked: parseInt(this.state.pageSize) === 10,
									multiple: false,
									onChange: function onChange(e) {
										return _this2.updateState(e);
									}
								})
							),
							react_default.a.createElement(
								'li',
								{ className: 'option' },
								react_default.a.createElement(CheckboxComponent, {
									name: 'pageSize',
									id: 'items-per-page_20',
									postLabel: '20 items per page',
									value: '20',
									className: 'inLine',
									checked: parseInt(this.state.pageSize) === 20,
									multiple: false,
									onChange: function onChange(e) {
										return _this2.updateState(e);
									}
								})
							),
							react_default.a.createElement(
								'li',
								{ className: 'option' },
								react_default.a.createElement(CheckboxComponent, {
									name: 'pageSize',
									id: 'items-per-page_50',
									postLabel: '50 items per page',
									value: '50',
									className: 'inLine',
									checked: parseInt(this.state.pageSize) === 50,
									multiple: false,
									onChange: function onChange(e) {
										return _this2.updateState(e);
									}
								})
							)
						)
					),
					react_default.a.createElement(
						'li',
						{ className: 'settings-option' },
						react_default.a.createElement(
							'h1',
							null,
							'Theme'
						),
						react_default.a.createElement(
							'ul',
							null,
							react_default.a.createElement(
								'li',
								{ className: 'option' },
								react_default.a.createElement(CheckboxComponent, {
									name: 'styleTheme',
									id: 'style-theme_dark',
									postLabel: 'Dark theme',
									value: 'dark',
									className: 'inLine',
									checked: this.state.styleTheme === 'dark',
									multiple: false,
									onChange: function onChange(e) {
										return _this2.updateState(e);
									}
								})
							),
							react_default.a.createElement(
								'li',
								{ className: 'option' },
								react_default.a.createElement(CheckboxComponent, {
									name: 'styleTheme',
									id: 'style-theme_light',
									postLabel: 'Light theme (default)',
									value: 'light',
									className: 'inLine',
									checked: this.state.styleTheme === 'light',
									multiple: false,
									onChange: function onChange(e) {
										return _this2.updateState(e);
									}
								})
							)
						)
					),
					react_default.a.createElement(
						'li',
						{ className: 'settings-option' },
						react_default.a.createElement(
							'h1',
							null,
							'Font Size'
						),
						react_default.a.createElement(
							'ul',
							null,
							react_default.a.createElement(
								'li',
								{ className: 'option' },
								react_default.a.createElement(CheckboxComponent, {
									name: 'fontSize',
									id: 'font-size_small',
									postLabel: 'Small',
									value: 'small',
									className: 'inLine fontSize-small',
									checked: this.state.fontSize === 'small',
									multiple: false,
									onChange: function onChange(e) {
										return _this2.updateState(e);
									}
								})
							),
							react_default.a.createElement(
								'li',
								{ className: 'option' },
								react_default.a.createElement(CheckboxComponent, {
									name: 'fontSize',
									id: 'font-size_normal',
									postLabel: 'Normal',
									value: 'normal',
									className: 'inLine fontSize-normal',
									checked: this.state.fontSize === 'normal',
									multiple: false,
									onChange: function onChange(e) {
										return _this2.updateState(e);
									}
								})
							),
							react_default.a.createElement(
								'li',
								{ className: 'option' },
								react_default.a.createElement(CheckboxComponent, {
									name: 'fontSize',
									id: 'font-size_big',
									postLabel: 'Big',
									value: 'big',
									className: 'inLine fontSize-big',
									checked: this.state.fontSize === 'big',
									multiple: false,
									onChange: function onChange(e) {
										return _this2.updateState(e);
									}
								})
							),
							react_default.a.createElement(
								'li',
								{ className: 'option' },
								react_default.a.createElement(CheckboxComponent, {
									name: 'fontSize',
									id: 'font-size_huge',
									postLabel: 'Huge',
									value: 'huge',
									className: 'inLine fontSize-huge',
									checked: this.state.fontSize === 'huge',
									multiple: false,
									onChange: function onChange(e) {
										return _this2.updateState(e);
									}
								})
							)
						)
					),
					react_default.a.createElement(
						'li',
						{ className: 'settings-option' },
						react_default.a.createElement(
							'h1',
							null,
							'Attachment Previews'
						),
						react_default.a.createElement(
							'ul',
							null,
							react_default.a.createElement(
								'li',
								{ className: 'option' },
								react_default.a.createElement(CheckboxComponent, {
									name: 'showAttachmentsPreview',
									id: 'attachment-previews',
									value: 'true',
									className: 'inLine',
									postLabel: 'Show Attachment Previews',
									checked: this.state.showAttachmentsPreview === true,
									multiple: true,
									onChange: function onChange(e) {
										return _this2.updateState(e);
									}
								})
							)
						)
					),
					react_default.a.createElement(
						'li',
						{ className: 'settings-option' },
						react_default.a.createElement(
							'h1',
							null,
							'Your Landing Page'
						),
						react_default.a.createElement(
							'div',
							{ className: 'note' },
							'The default page that will load when you land on the site'
						),
						react_default.a.createElement(
							'ul',
							null,
							react_default.a.createElement(
								'li',
								{ className: 'option ' + (!{"version":"1.0.0","IndexRoute":"index","section":{"home":false}}.section.home ? 'hidden' : '') },
								react_default.a.createElement(CheckboxComponent, {
									name: 'landingPage',
									id: 'landingPage-home',
									value: 'home',
									className: 'inLine',
									postLabel: 'Forum Home',
									checked: this.state.landingPage === 'home',
									multiple: false,
									onChange: function onChange(e) {
										return _this2.updateState(e);
									}
								})
							),
							react_default.a.createElement(
								'li',
								{ className: 'option' },
								react_default.a.createElement(CheckboxComponent, {
									name: 'landingPage',
									id: 'landingPage-index',
									value: 'index',
									className: 'inLine',
									postLabel: 'Forums Index',
									checked: this.state.landingPage === 'index',
									multiple: false,
									onChange: function onChange(e) {
										return _this2.updateState(e);
									}
								})
							),
							react_default.a.createElement(
								'li',
								{ className: 'option' },
								react_default.a.createElement(CheckboxComponent, {
									name: 'landingPage',
									id: 'landingPage-active',
									value: 'active',
									className: 'inLine',
									postLabel: 'Active Topics',
									checked: this.state.landingPage === 'active',
									multiple: false,
									onChange: function onChange(e) {
										return _this2.updateState(e);
									}
								})
							)
						)
					)
				)
			);
		}
	}]);

	return SettingsComponent;
}(react_default.a.Component);

/* harmony default export */ var components_SettingsComponent = (Object(es["b" /* connect */])(settingsSelector)(SettingsComponent_SettingsComponent));
// EXTERNAL MODULE: ./node_modules/react-avatar-editor/dist/index.js
var dist = __webpack_require__(824);
var dist_default = /*#__PURE__*/__webpack_require__.n(dist);

// EXTERNAL MODULE: ./node_modules/date-fns/parse/index.js
var parse = __webpack_require__(32);
var parse_default = /*#__PURE__*/__webpack_require__.n(parse);

// EXTERNAL MODULE: ./node_modules/date-fns/is_date/index.js
var is_date = __webpack_require__(231);
var is_date_default = /*#__PURE__*/__webpack_require__.n(is_date);

// EXTERNAL MODULE: ./node_modules/date-fns/is_valid/index.js
var is_valid = __webpack_require__(331);
var is_valid_default = /*#__PURE__*/__webpack_require__.n(is_valid);

// EXTERNAL MODULE: ./src/utils/polyfills/canvas-to-blob.js
var canvas_to_blob = __webpack_require__(825);
var canvas_to_blob_default = /*#__PURE__*/__webpack_require__.n(canvas_to_blob);

// CONCATENATED MODULE: ./src/components/userCPComponent.js
var userCPComponent__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function userCPComponent__toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function userCPComponent__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function userCPComponent__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function userCPComponent__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




























//canvas.toBlob polyfill for safari


var userCPComponent_UserCPComponent = function (_React$Component) {
	userCPComponent__inherits(UserCPComponent, _React$Component);

	function UserCPComponent(props) {
		userCPComponent__classCallCheck(this, UserCPComponent);

		var _this = userCPComponent__possibleConstructorReturn(this, (UserCPComponent.__proto__ || Object.getPrototypeOf(UserCPComponent)).call(this, props));

		_this.hideElement = function (el) {
			var list = Array.isArray(el) ? el : [el];
			list.forEach(function (element) {
				if (element) {
					element.classList.add('hidden');
				}
			});
		};

		_this.showElement = function (el) {
			var list = Array.isArray(el) ? el : [el];
			list.forEach(function (element) {
				if (element) {
					element.classList.remove('hidden');
				}
			});
		};

		_this.addAvatar = function () {
			document.querySelector('#avatarPicker').click();
		};

		_this.loadAvatar = function (evt) {
			var reader = new FileReader();
			var setState = _this.setState.bind(_this);
			var avatar = Object.assign({}, _this.state.avatar);

			reader.onload = function () {
				avatar.url = reader.result;
				avatar.scale = 1;
				setState({ avatar: avatar });
				document.querySelector('#avatarPicker').value = null;
			};
			reader.readAsDataURL(evt.target.files[0]);
		};

		_this.saveAvatar = function () {
			var canvas = _this.avatar.editor.getImageScaledToCanvas(),
			    avatarLimits = _this.props.ustate.usercp.profile.avatarLimits;

			canvas.toBlob(function (blob) {
				var formData = new FormData();
				formData.append('upload', blob, 'avatar_' + new Date().getTime() + '.png');
				formData.append('newAvatar', true); // we need to include an extra field to avoid vb 4.x error

				var message = react_default.a.createElement(
					'div',
					null,
					'Are you sure you want to save this image as your avatar?',
					react_default.a.createElement(
						'p',
						null,
						react_default.a.createElement('img', { src: canvas.toDataURL("image/png", 1.0), width: avatarLimits.width ? avatarLimits.width : 100, height: avatarLimits.height ? avatarLimits.height : 100 })
					)
				);

				_this.props.dispatch(Object(UiActions["N" /* showConfirmModal */])('Save avatar', message, function () {
					_this.sendAvatar(formData);
				}));
			}, 'image/png');
		};

		_this.deleteAvatar = function () {
			_this.props.dispatch(Object(UiActions["N" /* showConfirmModal */])('Delete avatar', 'Are you sure you want to delete your avatar? (this action cannot be undone)', function () {
				var formData = new FormData();
				formData.append('delete', true);
				_this.sendAvatar(formData);
			}));
		};

		_this.editAvatar = function () {
			var avatar = Object.assign({}, _this.state.avatar, { editAvatar: true });
			_this.setState({ avatar: avatar });
			document.body.classList.add('no-scroll');
			_this.props.dispatch(Object(adsActions["A" /* trackGAEvent */])(false, 'editAvatar', 'userAction', 'userCP'));
		};

		_this.resetAvatar = function () {
			var avatar = Object.assign({}, _this.state.avatar, {
				editAvatar: false,
				url: null,
				scale: 1,
				rotate: 0,
				preview: null
			});
			_this.setState({ avatar: avatar });
			document.body.classList.remove('no-scroll');
		};

		_this.state = {
			maxH: window.innerHeight || document.documentElement.clientHeight,
			maxW: window.innerWidth || document.documentElement.clientWidth,
			avatar: {
				editAvatar: false,
				url: null,
				scale: 1,
				rotate: 0,
				preview: null
			},
			password: {
				length: null,
				lowerCase: null,
				upperCase: null,
				numbers: null,
				symbols: null
			}
		};

		_this.isRestoring = false;
		_this.isSaving = {};
		_this.avatar = {
			editor: null,
			scale: 1,
			rotate: 0
		};
		_this.fields = {};
		_this.fieldTexts = {};
		return _this;
	}

	userCPComponent__createClass(UserCPComponent, [{
		key: 'componentWillMount',
		value: function componentWillMount() {
			var userReq = {
				id: 0,
				cp: true,
				page: 1
			};
			this.props.dispatch(Object(UserprofileActions["e" /* fetchUserProfile */])(userReq, new Date().getTime()));
		}
	}, {
		key: 'shouldComponentUpdate',
		value: function shouldComponentUpdate(nextProps, nextState) {
			return !isEqual_default()(this.props.ustate, nextProps.ustate) || !isEqual_default()(this.state, nextState);
		}
	}, {
		key: 'componentDidMount',
		value: function componentDidMount() {
			this.props.dispatch(Object(MetaActions["b" /* receiveGlobalMeta */])(null, 'User Control Panel', this.props.siteTitle));
		}

		/* ************** */

	}, {
		key: 'focusField',

		/* ************** */

		value: function focusField(field) {
			if (this.fields[field]) {
				this.fields['' + field].focus();
			}
		}
	}, {
		key: 'editField',
		value: function editField(field) {
			if (this.fields[field]) {
				var fields = null,
				    fieldTexts = null,
				    editField = this.fields[field + '_edit'],
				    saveField = this.fields[field + '_save'],
				    restoreField = this.fields[field + '_restore'];

				switch (field) {
					case 'password':
						// password fields
						fields = [restoreField, this.fields['' + field], this.fields[field + '_verify']];
						fieldTexts = [this.fieldTexts['' + field], this.fieldTexts[field + '_verify'], this.fieldTexts[field + '_rules']];
						if (this.fields[field + '_current']) {
							fieldTexts.push(this.fields[field + '_current']);
						}

						this.hideElement([editField]);
						this.showElement(fields);
						this.showElement(fieldTexts);

						fields[0].focus();
						break;

					case 'birthday':
						// Show/hide action icons
						this.hideElement([editField]);
						this.showElement([saveField, restoreField]);

						this.fields['' + field].focus();
						break;

					case 'dst':
					case 'timezone':
					case 'showbirthday':
						fieldTexts = this.fields['' + field];
						fields = this.fields[field + '_select'];

						this.hideElement([editField, fieldTexts]);
						this.showElement([saveField, restoreField, fields]);
						break;

					default:
						// Show/hide action icons
						this.hideElement([editField]);
						this.showElement([saveField, restoreField]);
						break;
				}
			}
		}
	}, {
		key: 'saveCheckedField',
		value: function saveCheckedField(event) {
			this.saveField(event.target.name, false);
		}
	}, {
		key: 'saveField',
		value: function saveField(field) {
			var _this2 = this;

			var force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

			setTimeout(function () {
				if (_this2.isSaving[field]) {
					return false;
				}
				if (_this2.isRestoring) {
					_this2.isRestoring = false;
				} else {
					_this2.isSaving[field] = true;

					var valueToSave = null,
					    editField = _this2.fields['' + field],
					    editField2 = null;

					switch (field) {
						case 'email':
							if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(editField.innerHTML)) {
								editField.classList.remove('isok', 'notok');

								if (editField && (force || editField.dataset.original !== editField.innerHTML)) {
									valueToSave = [[field, editField.innerHTML]];
								}
							} else {
								editField.classList.add('notok');
								editField.classList.remove('isok');
								Object(UiActions["B" /* displayNotification */])('warning', 'You entered an invalid email address', { timeout: 2000 });
							}
							break;

						case 'password':
							editField2 = _this2.fields[field + '_current'];

							if (_this2.verifyPass() && force) {
								if (editField2) {
									valueToSave = [[field, editField.value], ['password_current', editField2.value]];
								} else {
									valueToSave = [[field, editField.value]];
								}
							}
							break;

						case 'birthday':
							if (_this2.verifyBirthday()) {
								if (_this2.fields.birthday.value !== _this2.fields.birthday.dataset.original) {
									valueToSave = [[field, _this2.fields.birthday.value]];
								}
							} else {
								Object(UiActions["B" /* displayNotification */])('warning', 'You entered an invalid date', { timeout: 2000 });
							}
							break;

						case 'dst':
						case 'timezone':
						case 'showbirthday':
							editField = _this2.fields[field + '_select'];
							var selectedValue = editField.value,
							    theField = _this2.fields['' + field];

							_this2.hideElement(editField);
							_this2.showElement(theField);

							valueToSave = [[field, selectedValue]];
							break;

						default:
							// Check box items
							if (editField.state && typeof editField.state.itemChecked !== 'undefined') {
								valueToSave = [[field, editField.state.itemChecked]];
							} else {
								if (editField && (force || editField.dataset.original !== editField.innerHTML)) {
									valueToSave = [[field, editField.innerHTML]];
								}
							}
					}

					_this2.restoreIcons(field);

					if (valueToSave && valueToSave.length && field) {
						valueToSave = [['field', field]].concat(userCPComponent__toConsumableArray(valueToSave));

						var response = _this2.props.dispatch(Object(UserprofileActions["g" /* saveUserCP */])(valueToSave));

						response.then(function (r) {
							_this2.isSaving[field] = false;
							if (r().result) {
								if (field === 'password') {
									_this2.cancelField(field);
								}
							} else {
								_this2.cancelField(field);
								_this2.editField(field);
							}
						}).catch(function (error) {
							topifyConsole.error(error);
							_this2.isSaving[field] = false;
							_this2.cancelField(field);
						});
					} else {
						_this2.isSaving[field] = false;
					}
				}
			}, 50);
		}
	}, {
		key: 'cancelField',
		value: function cancelField(field) {
			this.isRestoring = true;

			var theField = void 0,
			    theField2 = void 0,
			    theField3 = void 0;

			switch (field) {
				case 'email':
					theField = this.fields['' + field];
					theField.innerHTML = theField.dataset.original;
					break;

				case 'password':
					theField = this.fields['' + field];
					theField2 = this.fields[field + '_verify'];
					theField3 = this.fields[field + '_current'];
					var fields = theField3 ? [theField, theField2, theField3] : [theField, theField2];
					var fieldTexts = [this.fieldTexts['' + field], this.fieldTexts[field + '_verify'], this.fieldTexts[field + '_rules']];

					if (this.fieldTexts[field + '_current']) {
						fieldTexts.push(this.fieldTexts[field + '_current']);
					}

					this.hideElement(fieldTexts);
					this.hideElement(fields);

					theField.value = '';
					theField.blur();
					theField2.value = '';
					theField2.blur();
					if (theField3) {
						theField3.value = '';
						theField3.blur();
					}
					this.verifyPassRules();
					break;

				case 'birthday':
					this.fields['' + field].classList.remove('isok', 'notok');
					this.fields['' + field].value = this.fields['' + field].dataset.original;
					break;

				case 'dst':
				case 'timezone':
				case 'showbirthday':
					theField = this.fields['' + field];
					theField2 = this.fields[field + '_select'];

					this.hideElement(theField2);
					this.showElement(theField);

					theField2.value = theField2.dataset.original;
					break;

				default:
					document.execCommand('undo');
					this.fields['' + field].blur();
			}

			this.restoreIcons(field);
			this.isRestoring = false;
		}
	}, {
		key: 'restoreIcons',
		value: function restoreIcons(field) {
			var showFields = [this.fields[field + '_edit']],
			    hideFields = [this.fields[field + '_save'], this.fields[field + '_restore']];
			this.showElement(showFields);
			this.hideElement(hideFields);
		}

		/* ************** */

		/** Options **/

	}, {
		key: 'showUserOptions',
		value: function showUserOptions() {
			var _this3 = this;

			var loaded = this.props.ustate.usercp && this.props.ustate.usercp.profile;

			if (!loaded) {
				return null;
			}

			var options = this.props.ustate.usercp.options,
			    dstOptions = [],
			    timezoneOptions = [];

			var option = void 0,
			    aux = null,
			    op = null;

			for (option in options.dst.dst_options) {
				if (options.dst.dst_options.hasOwnProperty(option)) {
					op = react_default.a.createElement(
						'option',
						{ key: option, value: option },
						simpleDecodeEntities(options.dst.dst_options[option])
					);
					dstOptions.push(op);
				}
			}
			for (option in options.dst.timezone_options) {
				if (options.dst.timezone_options.hasOwnProperty(option)) {
					aux = options.dst.timezone_options[option];
					op = react_default.a.createElement(
						'option',
						{ key: option, value: aux[0] },
						simpleDecodeEntities(aux[1])
					);
					timezoneOptions.push(op);
				}
			}

			var optionField = void 0,
			    settingoption = null,
			    settingOptions = [],
			    settingsMessaging = [],
			    settingsDateTime = [];

			// Options checkboxes for 'Receive Email'
			for (optionField in options.email) {
				if (options.email[optionField] && options.email[optionField].text !== null && options.email[optionField].value !== null) {
					(function () {
						var this_optionField = optionField;
						settingoption = react_default.a.createElement(
							'dd',
							{ key: this_optionField },
							react_default.a.createElement(CheckboxComponent, {
								name: this_optionField,
								id: this_optionField,
								postLabel: options.email[this_optionField].text,
								value: '1',
								className: 'inLine',
								checked: parseInt(options.email[this_optionField].value) === 1,
								multiple: true,
								ref: function ref(op) {
									return _this3.fields[this_optionField] = op;
								},
								onChange: function onChange(e) {
									return _this3.saveCheckedField(e);
								}
							})
						);
						settingOptions.push(settingoption);
					})();
				}
			}

			if (settingOptions.length) {
				settingoption = react_default.a.createElement(
					'dl',
					{ key: 'recemail' },
					react_default.a.createElement(
						'dt',
						null,
						'Receive Email'
					),
					settingOptions
				);
				settingsMessaging.push(settingoption);
				settingOptions = [];
			}

			// Options checkboxes for 'Private Messaging'
			for (optionField in options.pm) {
				if (options.pm[optionField] && options.pm[optionField].text !== null && options.pm[optionField].value !== null) {
					(function () {
						var this_optionField = optionField;
						settingoption = react_default.a.createElement(
							'dd',
							{ key: this_optionField },
							react_default.a.createElement(CheckboxComponent, {
								name: this_optionField,
								id: this_optionField,
								postLabel: options.pm[this_optionField].text,
								value: '1',
								className: 'inLine',
								checked: parseInt(options.pm[this_optionField].value) === 1,
								multiple: true,
								ref: function ref(op) {
									return _this3.fields[this_optionField] = op;
								},
								onChange: function onChange(e) {
									return _this3.saveCheckedField(e);
								}
							})
						);
						settingOptions.push(settingoption);
					})();
				}
			}

			if (settingOptions.length) {
				settingoption = react_default.a.createElement(
					'dl',
					{ key: 'messaging' },
					react_default.a.createElement(
						'dt',
						null,
						'Private Messaging'
					),
					settingOptions
				);
				settingsMessaging.push(settingoption);
			}

			// Date & Time
			if (options.dst !== null) {
				var timeZoneSelected = options.dst.timezone ? options.dst.timezone_options.filter(function (t) {
					return t[0].toString() === options.dst.timezone.toString();
				})[0] : [];

				settingsDateTime = [react_default.a.createElement(
					'dl',
					{ key: 'timezone' },
					react_default.a.createElement(
						'dt',
						null,
						'Time Zone'
					),
					react_default.a.createElement(
						'dd',
						{ className: 'options' },
						react_default.a.createElement(
							'div',
							{ className: 'icon action-button edit', ref: function ref(f) {
									return _this3.fields['timezone_edit'] = f;
								}, onClick: function onClick() {
									return _this3.editField('timezone');
								} },
							react_default.a.createElement(svg_SvgIcon, { icon: 'edit', size: '20px' })
						),
						react_default.a.createElement(
							'div',
							{ className: 'icon action-button restore hidden', ref: function ref(f) {
									return _this3.fields['timezone_restore'] = f;
								}, onClick: function onClick() {
									return _this3.cancelField('timezone');
								} },
							react_default.a.createElement(svg_SvgIcon, { icon: 'restore', size: '20px' })
						),
						react_default.a.createElement(
							'div',
							{ className: 'icon action-button save hidden', ref: function ref(f) {
									return _this3.fields['timezone_save'] = f;
								}, onClick: function onClick() {
									return _this3.saveField('timezone', true);
								} },
							react_default.a.createElement(svg_SvgIcon, { icon: 'check', size: '20px' })
						)
					),
					react_default.a.createElement(
						'dd',
						{ className: 'styled-field' },
						react_default.a.createElement(
							'span',
							{
								className: 'selectedItem',
								onClick: function onClick() {
									return _this3.editField('timezone');
								},
								ref: function ref(f) {
									return _this3.fields['timezone'] = f;
								}
							},
							simpleDecodeEntities(timeZoneSelected.length ? timeZoneSelected[1] : 'choose one')
						),
						react_default.a.createElement(
							'select',
							{
								className: 'hidden',
								name: 'timezone',
								ref: function ref(f) {
									return _this3.fields['timezone_select'] = f;
								},
								defaultValue: options.dst.timezone,
								'data-original': options.dst.timezone
							},
							timezoneOptions
						)
					)
				)];

				if (dstOptions.length) {
					var dstSelect = react_default.a.createElement(
						'dl',
						{ key: 'dst' },
						react_default.a.createElement(
							'dt',
							null,
							'DST Correction Option'
						),
						react_default.a.createElement(
							'dd',
							{ className: 'options' },
							react_default.a.createElement(
								'div',
								{ className: 'icon action-button edit', ref: function ref(f) {
										return _this3.fields['dst_edit'] = f;
									},
									onClick: function onClick() {
										return _this3.editField('dst');
									} },
								react_default.a.createElement(svg_SvgIcon, { icon: 'edit', size: '20px' })
							),
							react_default.a.createElement(
								'div',
								{ className: 'icon action-button restore hidden',
									ref: function ref(f) {
										return _this3.fields['dst_restore'] = f;
									},
									onClick: function onClick() {
										return _this3.cancelField('dst');
									} },
								react_default.a.createElement(svg_SvgIcon, { icon: 'restore', size: '20px' })
							),
							react_default.a.createElement(
								'div',
								{ className: 'icon action-button save hidden', ref: function ref(f) {
										return _this3.fields['dst_save'] = f;
									},
									onClick: function onClick() {
										return _this3.saveField('dst', true);
									} },
								react_default.a.createElement(svg_SvgIcon, { icon: 'check', size: '20px' })
							)
						),
						react_default.a.createElement(
							'dd',
							{ className: 'styled-field' },
							react_default.a.createElement(
								'span',
								{
									className: 'selectedItem',
									onClick: function onClick() {
										return _this3.editField('dst');
									},
									ref: function ref(f) {
										return _this3.fields['dst'] = f;
									}
								},
								simpleDecodeEntities(options.dst.dst_options[options.dst.dst])
							),
							react_default.a.createElement(
								'select',
								{
									className: 'hidden',
									name: 'dst',
									ref: function ref(f) {
										return _this3.fields['dst_select'] = f;
									},
									defaultValue: options.dst.dst,
									'data-original': options.dst.dst
								},
								dstOptions
							)
						)
					);
					settingsDateTime.push(dstSelect);
				}
			}

			return [react_default.a.createElement(
				'li',
				{ key: 'messaging', className: 'settings-element' },
				react_default.a.createElement(
					'div',
					{ className: 'title' },
					'Messaging & Notifications Options:'
				),
				settingsMessaging
			), react_default.a.createElement(
				'li',
				{ key: 'datetime', className: 'settings-element' },
				react_default.a.createElement(
					'div',
					{ className: 'title' },
					'Date & Time Options:'
				),
				settingsDateTime
			)];
		}

		/** Email & Password Methods **/

	}, {
		key: 'verifyPass',
		value: function verifyPass() {
			// Current password?
			var currentPassOk = true,
			    currentPass = this.fields.password_current;

			if (this.props.ustate.usercp.profile.needscurrentpass && !(currentPass && currentPass.value)) {
				this.fields.password_current.classList.add('notok');
				this.fields.password_current.classList.remove('isok');
				this.hideElement(this.fields['password_save']);
				currentPassOk = false;
			} else if (currentPass) {
				this.fields.password_current.classList.remove('isok', 'notok');
			}

			// New password
			if (this.verifyPassRules() && currentPassOk && this.fields.password && this.fields.password_verify && this.fields.password.value.length && this.fields.password.value === this.fields.password_verify.value) {
				this.fields.password_verify.classList.add('isok');
				this.fields.password_verify.classList.remove('notok');
				this.showElement(this.fields['password_save']);
				return true;
			} else {
				this.fields.password_verify.classList.add('notok');
				this.fields.password_verify.classList.remove('isok');
				this.hideElement(this.fields['password_save']);
				return false;
			}
		}
	}, {
		key: 'verifyPassRules',
		value: function verifyPassRules() {
			var passOk = true;

			if (this.props.ustate.usercp.profile && this.props.ustate.usercp.profile.passwordRules) {
				var rules = this.props.ustate.usercp.profile.passwordRules,
				    statePassword = Object.assign({}, this.state.password);

				if (rules.passwordLength) {
					statePassword.length = this.fields.password.value.length >= parseInt(rules.passwordLength);
					passOk = passOk & statePassword.length;
				}
				if (rules.containsLowerCase) {
					statePassword.lowerCase = /[a-z]+/.test(this.fields.password.value);
					passOk = passOk & statePassword.lowerCase;
				}
				if (rules.containsUpperCase) {
					statePassword.upperCase = /[A-Z]+/.test(this.fields.password.value);
					passOk = passOk & statePassword.upperCase;
				}
				if (rules.containsNumbers) {
					statePassword.numbers = /[0-9]+/.test(this.fields.password.value);
					passOk = passOk & statePassword.numbers;
				}
				if (rules.containsSymbols) {
					statePassword.symbols = /\W+/.test(this.fields.password.value);
					passOk = passOk & statePassword.symbols;
				}

				this.setState({ password: statePassword });
			}

			return passOk;
		}
	}, {
		key: 'showEmailPass',
		value: function showEmailPass() {
			var _this4 = this;

			var loaded = this.props.ustate.usercp && this.props.ustate.usercp.profile,
			    canChangeEmail = loaded && this.props.ustate.usercp.profile.canmodifyemail,
			    needsCurrentPass = loaded && this.props.ustate.usercp.profile.needscurrentpass;

			if (!loaded) {
				return null;
			}

			var passField = null,
			    passwordForm = [react_default.a.createElement(
				'dd',
				{ key: 'password_icon', className: 'options' },
				react_default.a.createElement(
					'div',
					{ className: 'icon action-button edit', ref: function ref(f) {
							return _this4.fields['password_edit'] = f;
						}, onClick: function onClick() {
							return _this4.editField('password');
						} },
					react_default.a.createElement(svg_SvgIcon, { icon: 'edit', size: '20px' })
				),
				react_default.a.createElement(
					'div',
					{ className: 'icon action-button restore hidden', ref: function ref(f) {
							return _this4.fields['password_restore'] = f;
						}, onClick: function onClick() {
							return _this4.cancelField('password');
						} },
					react_default.a.createElement(svg_SvgIcon, { icon: 'restore', size: '20px' })
				),
				react_default.a.createElement(
					'div',
					{ className: 'icon action-button save hidden', ref: function ref(f) {
							return _this4.fields['password_save'] = f;
						}, onClick: function onClick() {
							return _this4.saveField('password', true);
						} },
					react_default.a.createElement(svg_SvgIcon, { icon: 'check', size: '20px' })
				)
			)];
			// do we need the user to include current password?
			if (needsCurrentPass) {
				passField = react_default.a.createElement(
					'dd',
					{ key: 'currentpassword' },
					react_default.a.createElement(
						'span',
						{ className: 'label hidden', ref: function ref(f) {
								return _this4.fieldTexts['password_current'] = f;
							} },
						'Your current password:'
					),
					react_default.a.createElement('input', { className: 'hidden', type: 'password', placeholder: 'current password', onInput: function onInput() {
							return _this4.verifyPass();
						},
						ref: function ref(f) {
							return _this4.fields['password_current'] = f;
						} })
				);
				passwordForm.push(passField);
			}

			passField = [react_default.a.createElement(
				'dd',
				{ key: 'newpassword' },
				react_default.a.createElement(
					'span',
					{ className: 'label hidden', ref: function ref(f) {
							return _this4.fieldTexts['password'] = f;
						} },
					'Your new password:'
				),
				react_default.a.createElement('input', { className: 'hidden', type: 'password', placeholder: 'password', ref: function ref(f) {
						return _this4.fields['password'] = f;
					}, onInput: function onInput() {
						return _this4.verifyPassRules();
					} })
			), react_default.a.createElement(
				'dd',
				{ key: 'verifypassword' },
				react_default.a.createElement(
					'span',
					{ className: 'label hidden', ref: function ref(f) {
							return _this4.fieldTexts['password_verify'] = f;
						} },
					'Verify new password:'
				),
				react_default.a.createElement('input', { className: 'hidden', type: 'password', placeholder: 'verify password', ref: function ref(f) {
						return _this4.fields['password_verify'] = f;
					}, onInput: function onInput() {
						return _this4.verifyPass();
					} })
			)];

			if (this.props.ustate.usercp.profile.passwordRules) {
				var passwordRules = this.props.ustate.usercp.profile.passwordRules,
				    state = this.state,
				    ruleOk = false,
				    rule = void 0,
				    rules = [];

				Object.keys(this.props.ustate.usercp.profile.passwordRules).forEach(function (item) {
					if (passwordRules[item]) {
						switch (item) {
							case 'passwordLength':
								ruleOk = state.password.length ? react_default.a.createElement(svg_SvgIcon, { icon: 'check', size: '20px' }) : react_default.a.createElement(svg_SvgIcon, { icon: 'cancel', size: '20px' });
								rule = react_default.a.createElement(
									'li',
									{ key: 'passrules_length', className: state.password.length ? 'isok' : 'notok' },
									ruleOk,
									' Minimum length is ',
									passwordRules[item]
								);
								rules.push(rule);
								break;

							case 'containsLowerCase':
								ruleOk = state.password.lowerCase ? react_default.a.createElement(svg_SvgIcon, { icon: 'check', size: '20px' }) : react_default.a.createElement(svg_SvgIcon, { icon: 'cancel', size: '20px' });
								rule = react_default.a.createElement(
									'li',
									{ key: 'passrules_lowercase', className: state.password.lowerCase ? 'isok' : 'notok' },
									ruleOk,
									' Must contain lower-case characters'
								);
								rules.push(rule);
								break;

							case 'containsUpperCase':
								ruleOk = state.password.upperCase ? react_default.a.createElement(svg_SvgIcon, { icon: 'check', size: '20px' }) : react_default.a.createElement(svg_SvgIcon, { icon: 'cancel', size: '20px' });
								rule = react_default.a.createElement(
									'li',
									{ key: 'passrules_uppercase', className: state.password.upperCase ? 'isok' : 'notok' },
									ruleOk,
									' Must contain upper-case characters'
								);
								rules.push(rule);
								break;

							case 'containsNumbers':
								ruleOk = state.password.numbers ? react_default.a.createElement(svg_SvgIcon, { icon: 'check', size: '20px' }) : react_default.a.createElement(svg_SvgIcon, { icon: 'cancel', size: '20px' });
								rule = react_default.a.createElement(
									'li',
									{ key: 'passrules_numbers', className: state.password.numbers ? 'isok' : 'notok' },
									ruleOk,
									' Must contain numbers'
								);
								rules.push(rule);
								break;

							case 'containsSymbols':
								ruleOk = state.password.symbols ? react_default.a.createElement(svg_SvgIcon, { icon: 'check', size: '20px' }) : react_default.a.createElement(svg_SvgIcon, { icon: 'cancel', size: '20px' });
								rule = react_default.a.createElement(
									'li',
									{ key: 'passrules_symbols', className: state.password.symbols ? 'isok' : 'notok' },
									ruleOk,
									' Must contain symbols'
								);
								rules.push(rule);
								break;
						}
					}
				});

				var rulesList = react_default.a.createElement(
					'dd',
					{ key: 'passrules', className: 'password-rules hidden', ref: function ref(f) {
							return _this4.fieldTexts['password_rules'] = f;
						} },
					react_default.a.createElement(
						'ul',
						null,
						rules
					)
				);
				passField.unshift(rulesList);
			}

			passwordForm = [].concat(userCPComponent__toConsumableArray(passwordForm), userCPComponent__toConsumableArray(passField));

			var settings = react_default.a.createElement(
				'dl',
				{ key: 'settings' },
				react_default.a.createElement(
					'dt',
					null,
					'e-mail'
				),
				react_default.a.createElement(
					'dd',
					{ className: 'options' },
					react_default.a.createElement(
						'span',
						{ className: 'note alert' },
						canChangeEmail ? '' : 'you are not allowed to change your email'
					),
					react_default.a.createElement(
						'div',
						{ className: 'icon action-button edit' + (canChangeEmail ? '' : ' hidden'), ref: function ref(f) {
								return _this4.fields['email_edit'] = f;
							}, onClick: function onClick() {
								return _this4.focusField('email');
							} },
						react_default.a.createElement(svg_SvgIcon, { icon: 'edit', size: '20px' })
					),
					react_default.a.createElement(
						'div',
						{ className: 'icon action-button restore hidden', ref: function ref(f) {
								return _this4.fields['email_restore'] = f;
							}, onClick: function onClick() {
								return _this4.cancelField('email');
							} },
						react_default.a.createElement(svg_SvgIcon, { icon: 'restore', size: '20px' })
					),
					react_default.a.createElement(
						'div',
						{ className: 'icon action-button save hidden', ref: function ref(f) {
								return _this4.fields['email_save'] = f;
							}, onClick: function onClick() {
								return _this4.saveField('email', true);
							} },
						react_default.a.createElement(svg_SvgIcon, { icon: 'check', size: '20px' })
					)
				),
				react_default.a.createElement(
					'dd',
					null,
					react_default.a.createElement(
						'span',
						{
							contentEditable: canChangeEmail,
							onBlur: function onBlur() {
								return _this4.saveField('email');
							},
							onFocus: function onFocus() {
								return _this4.editField('email');
							},
							onInput: function onInput() {
								return _this4.editField('email');
							},
							ref: function ref(f) {
								return _this4.fields['email'] = f;
							},
							'data-original': this.props.ustate.usercp.profile.email
						},
						this.props.ustate.usercp.profile.email
					)
				),
				react_default.a.createElement(
					'dt',
					null,
					'Password'
				),
				passwordForm
			);

			return react_default.a.createElement(
				'li',
				{ className: 'settings-element' },
				react_default.a.createElement(
					'div',
					{ className: 'title' },
					'Email & Password:'
				),
				settings
			);
		}

		/** User Profile **/

	}, {
		key: 'verifyBirthday',
		value: function verifyBirthday() {
			var bd = parse_default()(this.fields.birthday.value),
			    isValidBD = bd && is_date_default()(bd) && is_valid_default()(bd);

			this.fields.birthday.classList.toggle('isok', isValidBD);
			this.fields.birthday.classList.toggle('notok', !isValidBD);

			return isValidBD;
		}
	}, {
		key: 'showUserProfile',
		value: function showUserProfile() {
			var _this5 = this;

			var loaded = this.props.ustate.usercp && this.props.ustate.usercp.profile;

			if (!loaded) {
				return null;
			}

			var birthDaySettings = this.props.ustate.usercp.profile.birthday,
			    bday = parse_default()(birthDaySettings.birthday),
			    birthdayFormated = bday && is_date_default()(bday) && is_valid_default()(bday) ? format_default()(bday, 'YYYY-MM-DD') : '',
			    showBirthDay = birthDaySettings.showbirthday,
			    showbirthdayOptions = [],
			    option = void 0,
			    op = null;

			for (option in birthDaySettings.showbirthday_options) {
				if (birthDaySettings.showbirthday_options.hasOwnProperty(option)) {
					op = react_default.a.createElement(
						'option',
						{ key: option, value: option },
						birthDaySettings.showbirthday_options[option]
					);
					showbirthdayOptions.push(op);
				}
			}

			var bdPrivacy = showbirthdayOptions.length > 0 ? [react_default.a.createElement(
				'dt',
				{ key: 'privacy_t' },
				'Privacy'
			), react_default.a.createElement(
				'dd',
				{ key: 'privacy_o', className: 'options' },
				react_default.a.createElement(
					'div',
					{ className: 'icon action-button edit', ref: function ref(f) {
							return _this5.fields['showbirthday_edit'] = f;
						}, onClick: function onClick() {
							return _this5.editField('showbirthday');
						} },
					react_default.a.createElement(svg_SvgIcon, { icon: 'edit', size: '20px' })
				),
				react_default.a.createElement(
					'div',
					{ className: 'icon action-button restore hidden', ref: function ref(f) {
							return _this5.fields['showbirthday_restore'] = f;
						}, onClick: function onClick() {
							return _this5.cancelField('showbirthday');
						} },
					react_default.a.createElement(svg_SvgIcon, { icon: 'restore', size: '20px' })
				),
				react_default.a.createElement(
					'div',
					{ className: 'icon action-button save hidden', ref: function ref(f) {
							return _this5.fields['showbirthday_save'] = f;
						}, onClick: function onClick() {
							return _this5.saveField('showbirthday', true);
						} },
					react_default.a.createElement(svg_SvgIcon, { icon: 'check', size: '20px' })
				)
			), react_default.a.createElement(
				'dd',
				{ key: 'privacy_f', className: 'styled-field' },
				react_default.a.createElement(
					'span',
					{
						className: 'selectedItem',
						onClick: function onClick() {
							return _this5.editField('showbirthday');
						},
						ref: function ref(f) {
							return _this5.fields['showbirthday'] = f;
						}
					},
					birthDaySettings.showbirthday_options[showBirthDay]
				),
				react_default.a.createElement(
					'select',
					{
						className: 'hidden',
						name: 'showbirthday',
						ref: function ref(f) {
							return _this5.fields['showbirthday_select'] = f;
						},
						defaultValue: showBirthDay,
						'data-original': showBirthDay
					},
					showbirthdayOptions
				)
			)] : null;

			var settings = react_default.a.createElement(
				'dl',
				null,
				react_default.a.createElement(
					'dt',
					null,
					'Birthday'
				),
				react_default.a.createElement(
					'dd',
					{ className: 'options' },
					react_default.a.createElement(
						'div',
						{ className: 'icon action-button edit', ref: function ref(f) {
								return _this5.fields['birthday_edit'] = f;
							}, onClick: function onClick() {
								return _this5.focusField('birthday');
							} },
						react_default.a.createElement(svg_SvgIcon, { icon: 'edit', size: '20px' })
					),
					react_default.a.createElement(
						'div',
						{ className: 'icon action-button restore hidden', ref: function ref(f) {
								return _this5.fields['birthday_restore'] = f;
							}, onClick: function onClick() {
								return _this5.cancelField('birthday');
							} },
						react_default.a.createElement(svg_SvgIcon, { icon: 'restore', size: '20px' })
					),
					react_default.a.createElement(
						'div',
						{ className: 'icon action-button save hidden', ref: function ref(f) {
								return _this5.fields['birthday_save'] = f;
							}, onClick: function onClick() {
								return _this5.saveField('birthday', true);
							} },
						react_default.a.createElement(svg_SvgIcon, { icon: 'check', size: '20px' })
					)
				),
				react_default.a.createElement(
					'dd',
					null,
					react_default.a.createElement('input', {
						type: 'date',
						autoComplete: 'bday',
						onFocus: function onFocus() {
							return _this5.editField('birthday');
						},
						onInput: function onInput() {
							return _this5.editField('birthday');
						},
						ref: function ref(f) {
							return _this5.fields['birthday'] = f;
						},
						'data-original': birthdayFormated,
						defaultValue: birthdayFormated
					})
				),
				bdPrivacy
			);

			return react_default.a.createElement(
				'li',
				{ className: 'settings-element' },
				react_default.a.createElement(
					'div',
					{ className: 'title' },
					'User Profile:'
				),
				settings
			);
		}

		/** Avatar Methods **/

	}, {
		key: 'errorLoadingAvatar',
		value: function errorLoadingAvatar() {
			Object(UiActions["B" /* displayNotification */])('error', 'There was an error loading the image. Please try again or use a different image.');
			this.resetAvatar();
		}
	}, {
		key: 'sendAvatar',
		value: function sendAvatar(formData) {
			var _this6 = this;

			var response = this.props.dispatch(Object(UserprofileActions["h" /* uploadAvatar */])(formData));
			this.resetAvatar();

			response.then(function (result) {
				_this6.resetAvatar();
			}).catch(function (error) {
				topifyConsole.error(error);
			});
		}
	}, {
		key: 'handleScale',
		value: function handleScale() {
			var scale = parseFloat(this.avatar.scale.value),
			    avatar = Object.assign({}, this.state.avatar, { scale: scale });
			this.setState({ avatar: avatar });
		}
	}, {
		key: 'handleRotate',
		value: function handleRotate() {
			var rotate = parseFloat(this.avatar.rotate.value),
			    avatar = Object.assign({}, this.state.avatar, { rotate: rotate });
			this.setState({ avatar: avatar });
		}
	}, {
		key: 'showAvatar',
		value: function showAvatar() {
			var _this7 = this;

			var canChangeAvatar = this.props.ustate.usercp && this.props.ustate.usercp.profile && this.props.ustate.usercp.profile.avatarLimits.permissions,
			    avatarLimits = canChangeAvatar ? this.props.ustate.usercp.profile.avatarLimits : null,
			    border = 10,
			    avatarUrl = this.state.avatar.url || this.props.ustate.avatar,
			    scaleValue = this.state.avatar.scale || 1,
			    rotateValue = this.state.avatar.rotate || 0,
			    scaleStyle = null,
			    canvasStyle = null;

			if (avatarLimits) {
				var portrait = this.state.maxH > this.state.maxW,
				    hNeed = document.getElementById('header').getBoundingClientRect().height + 24,
				    width = portrait ? parseInt(this.state.maxH - hNeed) : parseInt(this.state.maxW - hNeed),
				    maxW = portrait ? Math.min(300, this.state.maxW) : Math.min(300, this.state.maxH - 125);

				width = width > maxW ? maxW : width;

				scaleStyle = {
					width: width + 'px'
				};
				canvasStyle = { width: width + 'px', height: width + 'px' };
			}

			return avatarLimits && this.state.avatar.editAvatar ? react_default.a.createElement(
				'li',
				{ className: 'settings-element avatarEditor' },
				react_default.a.createElement(
					'header',
					{ className: 'block-buttons' },
					react_default.a.createElement(
						'div',
						{ className: 'action-button', onClick: this.addAvatar },
						react_default.a.createElement(svg_SvgIcon, { size: '24px', icon: 'upload_file' })
					),
					react_default.a.createElement(
						'div',
						{ className: 'action-button', onClick: this.deleteAvatar },
						react_default.a.createElement(svg_SvgIcon, { size: '24px', icon: 'delete_forever' })
					),
					react_default.a.createElement(
						'div',
						{ className: 'action-button', onClick: this.saveAvatar },
						react_default.a.createElement(svg_SvgIcon, { size: '24px', icon: 'check' })
					),
					react_default.a.createElement(
						'div',
						{ className: 'action-button', onClick: this.resetAvatar },
						react_default.a.createElement(svg_SvgIcon, { size: '24px', icon: 'cancel' })
					)
				),
				react_default.a.createElement(dist_default.a, {
					ref: function ref(a) {
						return _this7.avatar.editor = a;
					},
					image: avatarUrl,
					width: avatarLimits.width,
					height: avatarLimits.height,
					border: border,
					color: [0, 0, 0, 0.5] // RGBA
					, scale: this.state.avatar.scale,
					rotate: this.state.avatar.rotate,
					onSave: this.saveAvatar,
					style: canvasStyle,
					onLoadFailure: this.errorLoadingAvatar
				}),
				react_default.a.createElement(
					'div',
					{ className: 'avatar-controls' },
					react_default.a.createElement(
						'div',
						{ className: 'control' },
						react_default.a.createElement(
							'p',
							null,
							'Scale ( ',
							scaleValue,
							' )'
						),
						react_default.a.createElement('input', { ref: function ref(i) {
								return _this7.avatar.scale = i;
							}, type: 'range', onChange: function onChange() {
								_this7.handleScale();
							},
							min: '0.01', max: '2', step: '0.01', value: scaleValue,
							style: scaleStyle })
					),
					react_default.a.createElement(
						'div',
						{ className: 'control' },
						react_default.a.createElement(
							'p',
							null,
							'Rotate ( ',
							rotateValue,
							' deg. )'
						),
						react_default.a.createElement('input', { ref: function ref(i) {
								return _this7.avatar.rotate = i;
							}, type: 'range', onChange: function onChange() {
								_this7.handleRotate();
							},
							min: '0', max: '360', step: '10', value: rotateValue,
							style: scaleStyle })
					),
					react_default.a.createElement('input', { type: 'file',
						name: 'file',
						id: 'avatarPicker',
						accept: 'image/png, image/jpeg, image/jpg, image/gif', style: { display: 'none' },
						onChange: this.loadAvatar,
						multiple: false
					})
				)
			) : null;
		}

		/* ************** */

	}, {
		key: 'render',
		value: function render() {
			return react_default.a.createElement(
				'div',
				{ className: 'userCP settings thread' },
				react_default.a.createElement(
					'ul',
					null,
					react_default.a.createElement(
						'li',
						{ className: 'settings-element' },
						react_default.a.createElement(
							'h3',
							null,
							'Your User CP, ',
							this.props.ustate.userName
						)
					),
					react_default.a.createElement(
						'li',
						{ className: 'settings-element' },
						react_default.a.createElement(
							'div',
							{ className: 'title' },
							'Avatar:'
						),
						react_default.a.createElement(common_UserIconComponent, { user: this.props.ustate, layout: 'editme', size: '24px', noAction: true, onClick: this.editAvatar })
					),
					this.showAvatar(),
					this.showEmailPass(),
					this.showUserProfile(),
					this.showUserOptions()
				)
			);
		}
	}]);

	return UserCPComponent;
}(react_default.a.Component);

/* harmony default export */ var userCPComponent = (Object(es["b" /* connect */])(selectors_userprofileResultSelector)(userCPComponent_UserCPComponent));
// CONCATENATED MODULE: ./src/routes.js




















// Check the conf if we have home active and what's the IndexRoute
var indexRoute = react_default.a.createElement(react_router_es["a" /* IndexRoute */], { component: components_RootViewComponent }),
    forumIndex = react_default.a.createElement(react_router_es["d" /* Route */], { path: 'forums', component: components_ForumsIndexViewComponent });

try {
	var envConf = {"version":"1.0.0","IndexRoute":"index","section":{"home":false}} || { IndexRoute: 'root', section: { home: true } };

	if (!envConf.section.home) {
		switch (envConf.IndexRoute) {
			case 'index':
			default:
				indexRoute = react_default.a.createElement(react_router_es["a" /* IndexRoute */], { component: components_ForumsIndexViewComponent });
				forumIndex = null;
				break;
		}
	}
} catch (e) {
	/* ignore and continue with default */
}

/* harmony default export */ var src_routes = (function (history) {
	return react_default.a.createElement(
		react_router_es["e" /* Router */],
		{ history: history },
		react_default.a.createElement(
			react_router_es["d" /* Route */],
			{ path: '/(forumsite/:id)', component: components_PageComponent },
			indexRoute,
			forumIndex,
			react_default.a.createElement(react_router_es["d" /* Route */], { path: 'forums/:forumId', component: components_ForumViewComponent }),
			react_default.a.createElement(react_router_es["d" /* Route */], { path: 'topics/:threadId', component: components_ThreadViewComponent }),
			react_default.a.createElement(react_router_es["d" /* Route */], { path: 'search/:searchId', component: components_SearchViewComponent }),
			react_default.a.createElement(react_router_es["d" /* Route */], { path: 'following', component: components_SearchViewComponent }),
			react_default.a.createElement(react_router_es["d" /* Route */], { path: 'latest', component: components_SearchViewComponent }),
			react_default.a.createElement(react_router_es["d" /* Route */], { path: 'participated', component: components_SearchViewComponent }),
			react_default.a.createElement(react_router_es["d" /* Route */], { path: 'updated', component: components_SearchViewComponent }),
			react_default.a.createElement(react_router_es["d" /* Route */], { path: 'userprofile/:userid', component: UserprofileViewComponent }),
			react_default.a.createElement(react_router_es["d" /* Route */], { path: 'release', component: components_ReleaseNotesViewComponent }),
			react_default.a.createElement(react_router_es["d" /* Route */], { path: 'pms', component: components_MessagesViewComponent }),
			react_default.a.createElement(react_router_es["d" /* Route */], { path: 'pms/:folderId', component: MessagesFolderViewComponent }),
			react_default.a.createElement(react_router_es["d" /* Route */], { path: 'pm/:messageId', component: messages_MessageViewComponent }),
			react_default.a.createElement(react_router_es["d" /* Route */], { path: 'online', component: components_OnlineViewComponent }),
			react_default.a.createElement(react_router_es["d" /* Route */], { path: 'portal/:pagename', component: components_PortalPageComponent }),
			react_default.a.createElement(react_router_es["d" /* Route */], { path: 'register', component: components_RegisterComponent }),
			react_default.a.createElement(react_router_es["d" /* Route */], { path: 'settings', component: components_SettingsComponent }),
			react_default.a.createElement(react_router_es["d" /* Route */], { path: 'usercp', component: userCPComponent }),
			react_default.a.createElement(react_router_es["c" /* Redirect */], { from: '*', to: '/' })
		)
	);
});
// EXTERNAL MODULE: ./src/store/configureStore.js
var configureStore = __webpack_require__(826);
var configureStore_default = /*#__PURE__*/__webpack_require__.n(configureStore);

// CONCATENATED MODULE: ./src/Containers/Root.js
var Root__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function Root__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Root__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function Root__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var store = configureStore_default()();
var Root_history = Object(react_router_redux_lib["syncHistoryWithStore"])(react_router_es["f" /* hashHistory */], store);

var Root_Root = function (_React$Component) {
	Root__inherits(Root, _React$Component);

	function Root() {
		Root__classCallCheck(this, Root);

		return Root__possibleConstructorReturn(this, (Root.__proto__ || Object.getPrototypeOf(Root)).apply(this, arguments));
	}

	Root__createClass(Root, [{
		key: 'render',
		value: function render() {
			return react_default.a.createElement(
				es["a" /* Provider */],
				{ store: store },
				src_routes(Root_history)
			);
		}
	}]);

	return Root;
}(react_default.a.Component);

/* harmony default export */ var Containers_Root = (Root_Root);
// CONCATENATED MODULE: ./src/utils/topifyConsole.js
function topifyConsole__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var TopifyConsole = function TopifyConsole(debug) {
	topifyConsole__classCallCheck(this, TopifyConsole);

	this.clear = function () {
		this.debugState > 0 ? console.clear() : null;
	};

	this.error = function () {
		var _console;

		this.debugState > 0 ? (_console = console).error.apply(_console, arguments) : null;
	};

	this.time = function () {
		var _console2;

		this.debugState > 1 ? (_console2 = console).time.apply(_console2, arguments) : null;
	};

	this.timeEnd = function () {
		var _console3;

		this.debugState > 1 ? (_console3 = console).timeEnd.apply(_console3, arguments) : null;
	};

	this.timeStamp = function () {
		var _console4;

		this.debugState > 1 ? (_console4 = console).timeStamp.apply(_console4, arguments) : null;
	};

	this.warn = function () {
		var _console5;

		this.debugState > 1 ? (_console5 = console).warn.apply(_console5, arguments) : null;
	};

	this.table = function () {
		var _console6;

		this.debugState > 2 ? (_console6 = console).table.apply(_console6, arguments) : null;
	};

	this.info = function () {
		var _console7;

		this.debugState > 2 ? (_console7 = console).info.apply(_console7, arguments) : null;
	};

	this.log = function () {
		var _console8;

		this.debugState > 3 ? (_console8 = console).log.apply(_console8, arguments) : null;
	};

	this.debug = function () {
		var _console9;

		this.debugState > 3 ? (_console9 = console).debug.apply(_console9, arguments) : null;
	};

	this.group = function () {
		var _console10;

		this.debugState > 3 ? (_console10 = console).group.apply(_console10, arguments) : null;
	};

	this.groupCollapsed = function () {
		var _console11;

		this.debugState > 3 ? (_console11 = console).groupCollapsed.apply(_console11, arguments) : null;
	};

	this.groupEnd = function () {
		var _console12;

		this.debugState > 3 ? (_console12 = console).groupEnd.apply(_console12, arguments) : null;
	};

	this.assert = function () {
		var _console13;

		this.debugState > 3 ? (_console13 = console).assert.apply(_console13, arguments) : null;
	};

	this.count = function () {
		var _console14;

		this.debugState > 3 ? (_console14 = console).count.apply(_console14, arguments) : null;
	};

	this.dir = function () {
		var _console15;

		this.debugState > 3 ? (_console15 = console).dir.apply(_console15, arguments) : null;
	};

	this.dirxml = function () {
		var _console16;

		this.debugState > 3 ? (_console16 = console).dirxml.apply(_console16, arguments) : null;
	};

	this.profile = function () {
		var _console17;

		this.debugState > 3 ? (_console17 = console).profile.apply(_console17, arguments) : null;
	};

	this.profileEnd = function () {
		var _console18;

		this.debugState > 3 ? (_console18 = console).profileEnd.apply(_console18, arguments) : null;
	};

	this.trace = function () {
		var _console19;

		this.debugState > 3 ? (_console19 = console).trace.apply(_console19, arguments) : null;
	};

	// What level of console we want?
	this.debugState = debug;
	console.log('Topify\'s debug mode: ', this.debugState);
}

// topify_debug >= 1
// only errors and clear


// topify_debug >= 2
// warning, errors and timing


// topify_debug >= 3
// info, warning, error, timing and table


// topify_debug >= 4
// all
;

/* harmony default export */ var utils_topifyConsole = (TopifyConsole);
// CONCATENATED MODULE: ./src/run.js









if (false) {
	var perf = require('react-addons-perf');

	window.startPerf = function () {
		perf.start();
		console.log('Started');
	};

	window.endPerf = function () {
		console.log('Stopping');
		perf.stop();
		console.log('Inclusive:');
		perf.printInclusive(); // Prints the overall time taken.
		console.log('Exclusive:');
		perf.printExclusive(); // Time excluding mounting
		console.log('Wasted');
		perf.printWasted(); // Time spent on components that
		//		console.log('DOM:');
		//		perf.printOperations();
	};
}

window.TOPIFY_VERSION = "3.7.0";

console.log('Topify version', "3.7.0");

/* Prepare topifyConsole */
/**
 * Adding to the querystring: 'topify_debug=<log_level>'
 * We'll have more or less levels on console when "topifyConsole" in used,
 * this setting doesn't interfere in anyway with other loggers in console
 *
 * We have 5 levels going from 0 to 4:
 *   0 - no logs   * => default on production
 *   1 - only errors
 *   2 - warning, error and timing
 *   3 - info, warning, error and timings
 *   4 - all logs  * => default on development
 *
 */
var _debugMode = function _debugMode() {
	var locRe = /[?&]topify_debug=([^&]+)/i,
	    location = locRe.exec(window.location.search) || locRe.exec(window.location.hash),
	    query_location = location && location.length > 0 ? { topify_debug: parseInt(location[1]) } : false;

	return Number.isInteger(parseInt(query_location['topify_debug'])) ? parseInt(query_location['topify_debug']) : false;
};

var _debug = function _debug() {
	var debugMode = _debugMode(),
	    validMode = Number.isInteger(debugMode) === true && debugMode <= 4 && debugMode >= 0,
	    defaultMode =  true ? 0 : 4;

	return validMode ? debugMode : defaultMode;
};

window.topifyConsole = new utils_topifyConsole(_debug());
/* topifyConsole done */

// Render the main component into the dom
react_dom_default.a.render(react_default.a.createElement(Containers_Root, null), document.getElementById('appContainer'));

/***/ }),

/***/ 563:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 564:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 64:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/normalizr/dist/src/index.js
var src = __webpack_require__(218);
var src_default = /*#__PURE__*/__webpack_require__.n(src);

// EXTERNAL MODULE: ./common/actions/UstateActions.js
var UstateActions = __webpack_require__(220);

// CONCATENATED MODULE: ./common/actions/responseNormalizer.js




var theRequestedPage = { type: '', page: 0 };

function responseNormalizer(json, requestPage) {
	var other = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

	/* Schemas */
	var user = new src["schema"].Entity('users', { lastActivityList: [post] });
	var forum = new src["schema"].Entity('forums');
	var topic = new src["schema"].Entity('topics', { forumUser: user, forum: forum });
	var sticky = new src["schema"].Entity('sticky', { forumUser: user, forum: forum });
	var announcement = new src["schema"].Entity('announcements');
	var pollOption = new src["schema"].Entity('pollOptions');
	var pollVote = new src["schema"].Entity('pollVotes');
	var poll = new src["schema"].Entity('polls', { pollOption: pollOption, pollVote: pollVote });
	var post = new src["schema"].Entity('posts', { forumUser: user, topic: topic });
	var attachment = new src["schema"].Entity('attachments', { forumUser: user, post: post });
	var pmfolder = new src["schema"].Entity('pmfolders');
	var pm = new src["schema"].Entity('pms', { pmfolder: pmfolder, forumUser: user, toUser: [user] });
	var online = new src["schema"].Entity('online');
	var page = new src["schema"].Entity('page');
	var notice = new src["schema"].Entity('notices');

	// Pre-normalizing: getting the data
	var preNormalized = {
		users: (json.forumUser || { data: [] }).data,
		forums: addPagination(requestPage, json, 'forum'),
		topics: addPagination(requestPage, json, 'topic'),
		sticky: (json.sticky || { data: [] }).data,
		announcements: (json.announcement || { data: [] }).data,
		posts: addPagination(requestPage, json, 'post'),
		polls: (json.poll || { data: [] }).data,
		pollOptions: (json.pollOption || { data: [] }).data,
		pollVotes: (json.pollVote || { data: [] }).data,
		attachments: (json.attachments || { data: [] }).data,
		pmfolders: (json.pmfolder || { data: [] }).data,
		pms: addPagination(requestPage, json, 'pm'),
		online: addPagination(requestPage, json, 'online'),
		portalpage: (json.portal || { data: [] }).data,
		notices: (json.notices || { data: [] }).data
	};

	// clean
	theRequestedPage = { type: '', page: 0 };

	// Building the result with normalizr
	return Object.assign({}, other, Object(src["normalize"])(preNormalized, {
		users: [user],
		forums: [forum],
		topics: [topic],
		sticky: [sticky],
		announcements: [announcement],
		posts: [post],
		polls: [poll],
		pollOptions: [pollOption],
		pollVotes: [pollVote],
		attachments: [attachment],
		pmfolders: [pmfolder],
		pms: [pm],
		online: [online],
		portalpage: [page],
		notices: [notice]
	}));
}

function updateUstate(json, result) {
	return function (dispatch) {
		if (json.ustate) {
			// Do we have notifications? update counter
			if (json.notifications && json.notifications.data) {
				json.ustate.notifications = {
					pms: json.notifications.data[0].pms || 0
				};
			}

			var new_ustate = json.ustate;
			// Get the current user info if we have it or null the fields
			try {
				var currentUser = result.entities.users[new_ustate.id];
				new_ustate = Object.assign({}, new_ustate, {
					userName: currentUser.userName,
					avatar: currentUser.avatar,
					online: currentUser.online,
					lastActivity: currentUser.lastActivity
				});
			} catch (e) {
				new_ustate = Object.assign({}, new_ustate, {
					userName: null,
					avatar: null,
					online: null,
					lastActivity: null
				});
			}

			// Update the state
			dispatch(Object(UstateActions["b" /* receiveCurrentUser */])(new_ustate));
		}
	};
}

/**
 * Add to all elements the page it belongs to
 *
 * @param requestPage
 * @param elements
 * @param type
 * @returns {Array}
 */
function addPagination(requestPage, elements, type) {
	if (!type || !elements[type] || !elements[type].data) {
		return [];
	}

	// Adding requested page to all those elements
	// that potentially can be paginated
	return elements[type].data.map(function (e) {
		return Object.assign(e, { page: checkRequestedPage(requestPage, elements, type).page || 1 });
	});
}

/**
 * When we ask for an unknown page (last read pos., postID...)
 * we'll get the page on the meta object in teh response
 * Let's find out or fallback to 1
 *
 * @param requestPage
 * @param elements
 * @param type
 * @returns {{type: string, page: number}}
 */
function checkRequestedPage(requestPage, elements, type) {
	if (theRequestedPage.type === type && theRequestedPage.page) {
		return theRequestedPage;
	}

	// If we are on a search, following or userprofile we'll use this meta
	var meta = elements[type].meta; // default to type meta
	switch (true) {
		case !!(elements.following && elements.following.meta):
			// are we on following
			meta = elements.following.meta;
			break;

		case !!(elements.search && elements.search.meta):
			// are we on search
			meta = elements.search.meta;
			break;

		case !!(elements.forumUser && elements.forumUser.meta):
			// are we on user profile
			meta = elements.forumUser.meta;
			break;
	}

	try {
		requestPage = (meta ? parseInt(meta.page) : false) || 1;
	} catch (e) {
		requestPage = 1;
	}

	// Let's check if the requested page is bigger than totalPages
	try {
		var maxPage = (meta ? parseInt(meta.totalPages) : false) || 1;
		requestPage = maxPage >= requestPage ? requestPage : maxPage;
	} catch (e) {}

	// Save it
	theRequestedPage = { type: type, page: requestPage || 1 };

	return theRequestedPage;
}
// CONCATENATED MODULE: ./src/actions/responseNormalizer.js
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "a", function() { return responseNormalizer; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "b", function() { return updateUstate; });


/***/ }),

/***/ 65:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["d"] = fetchMessages;
/* harmony export (immutable) */ __webpack_exports__["c"] = deletePms;
/* harmony export (immutable) */ __webpack_exports__["e"] = markAsReadPM;
/* harmony export (immutable) */ __webpack_exports__["f"] = movePMs;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_router_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_Actions_InfiniteScrollActions__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_Actions_MetaActions__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_Actions_GlobalMetaActions__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_Actions_UiActions__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_Actions_UserSettingsActions__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_Actions_adsActions__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_Actions_responseNormalizer__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_Common_actions_MessagesviewActions__ = __webpack_require__(223);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_9_Common_actions_MessagesviewActions__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_9_Common_actions_MessagesviewActions__["d"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_9_Common_actions_MessagesviewActions__["j"]; });
















function fetchMessages(messagesRequest) {

	return function (dispatch, getState) {

		messagesRequest.loadingBehavior = Object(__WEBPACK_IMPORTED_MODULE_2_Actions_InfiniteScrollActions__["e" /* getLoadingBehavior */])(getState, messagesRequest.id, messagesRequest.pmroute, messagesRequest.page, messagesRequest.forceRefresh);

		if (messagesRequest.pmroute === 'pmfolder' && Object(__WEBPACK_IMPORTED_MODULE_2_Actions_InfiniteScrollActions__["g" /* shouldNotUpdateState */])(getState, messagesRequest)) {
			dispatch(Object(__WEBPACK_IMPORTED_MODULE_2_Actions_InfiniteScrollActions__["i" /* updatePagesResult */])(messagesRequest.page || 1));
			return null;
		}

		dispatch(Object(__WEBPACK_IMPORTED_MODULE_9_Common_actions_MessagesviewActions__["i" /* requestMessage */])(messagesRequest));

		var state = getState();
		var url = state.topifyPresets.forumSite.url;

		var fetchConfig = dispatch(Object(__WEBPACK_IMPORTED_MODULE_4_Actions_GlobalMetaActions__["e" /* getFetchConfig */])(true));

		var userID = state.ustate.id ? state.ustate.id : 0,
		    page_size = dispatch(Object(__WEBPACK_IMPORTED_MODULE_6_Actions_UserSettingsActions__["d" /* getPageSize */])());

		var url_params = '';
		switch (messagesRequest.pmroute) {
			case 'pmfolder':
				url_params = messagesRequest.id + '&folder=true&pagesize=' + page_size + (messagesRequest.page ? '&page=' + messagesRequest.page : '') + '&lb=1';
				break;
			case 'pm':
				url_params = '' + messagesRequest.id;
				break;
		}

		// Avoid Cache independently from cacheBust
		var cacheBustQueryString = '&_=' + new Date().getTime();

		return fetch(url + ('?v=3.0&ajax=1&uid=' + userID + '&req=pm&id=' + url_params + cacheBustQueryString), fetchConfig).then(function (response) {
			if (!response.ok) {
				try {
					// if we are going back and already have an error, keep going skipping message
					if (state.messagesview.lastError === '') {
						response.json().then(function (json) {
							Object(__WEBPACK_IMPORTED_MODULE_4_Actions_GlobalMetaActions__["j" /* setGlobalNotification */])(dispatch, json, response);
						}).catch(function () {
							Object(__WEBPACK_IMPORTED_MODULE_4_Actions_GlobalMetaActions__["j" /* setGlobalNotification */])(dispatch, {}, response);
						});
					}
				} catch (e) {
					Object(__WEBPACK_IMPORTED_MODULE_4_Actions_GlobalMetaActions__["j" /* setGlobalNotification */])(dispatch, {}, response);
				}

				dispatch(Object(__WEBPACK_IMPORTED_MODULE_9_Common_actions_MessagesviewActions__["g" /* failedMessages */])(messagesRequest, messagesRequest.id, 'Bad response from server'));

				// If we have a non authorized let's redirect to landing page
				if (response.status === 401) {
					var landingPage = dispatch(Object(__WEBPACK_IMPORTED_MODULE_6_Actions_UserSettingsActions__["c" /* getLandingPage */])());
					dispatch(Object(__WEBPACK_IMPORTED_MODULE_1_react_router_redux__["replace"])(landingPage));
				} else {
					dispatch(Object(__WEBPACK_IMPORTED_MODULE_4_Actions_GlobalMetaActions__["b" /* backInHistory */])());
				}
			} else {
				response.json().then(function (json) {
					Object(__WEBPACK_IMPORTED_MODULE_4_Actions_GlobalMetaActions__["j" /* setGlobalNotification */])(dispatch, json, { ok: true });

					if (messagesRequest.pmroute === 'pm') {
						// Record the Google Analytics event and for the forum.
						dispatch(Object(__WEBPACK_IMPORTED_MODULE_7_Actions_adsActions__["A" /* trackGAEvent */])(true, 'pmRead', 'userAction', 'consumption'));
					}

					var other = Object.assign({}, { page: messagesRequest.page || 1 }, json.pm ? json.pm.meta : {}, messagesRequest.pmroute === 'pmfolder' ? json.pm.meta : json.pmfolder.meta || {});

					var result = Object(__WEBPACK_IMPORTED_MODULE_8_Actions_responseNormalizer__["a" /* responseNormalizer */])(json, messagesRequest.page, other);

					var forumTitle = 'Messages';
					switch (messagesRequest.pmroute) {
						case 'pmfolder':
							forumTitle += ': ' + result.entities.pmfolders[messagesRequest.id].name;
							break;
						case 'pm':
							var folderId = result.entities.pms[messagesRequest.id].folder;
							forumTitle += ': ' + result.entities.pmfolders[folderId].name;
							break;
					}
					dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_Actions_MetaActions__["b" /* receiveGlobalMeta */])(null, forumTitle, state.topifyPresets.forumSite.f_title));

					dispatch(Object(__WEBPACK_IMPORTED_MODULE_8_Actions_responseNormalizer__["b" /* updateUstate */])(json, result));

					var messagesview = state.messagesview;

					if (messagesview.earliestLoadedPage === null || result.page < messagesview.earliestLoadedPage) {
						result.earliestLoadedPage = result.page;
					}

					if (messagesview.latestLoadedPage === null || result.page > messagesview.latestLoadedPage) {
						result.latestLoadedPage = result.page;
					}

					dispatch(Object(__WEBPACK_IMPORTED_MODULE_2_Actions_InfiniteScrollActions__["d" /* fetchSuccess */])(messagesRequest.id, messagesRequest.pmroute, messagesRequest.page, result.totalPages, messagesRequest.loadingBehavior));
					dispatch(Object(__WEBPACK_IMPORTED_MODULE_9_Common_actions_MessagesviewActions__["h" /* receiveMessages */])(messagesRequest.pmroute, messagesRequest.id, result, messagesRequest.loadingBehavior));
				});
			}
		}).then(function () {
			Object(__WEBPACK_IMPORTED_MODULE_4_Actions_GlobalMetaActions__["k" /* setLastGlobalAction */])('messages_' + messagesRequest.pmroute, messagesRequest);
		}).catch(function (error) {
			Object(__WEBPACK_IMPORTED_MODULE_4_Actions_GlobalMetaActions__["j" /* setGlobalNotification */])(dispatch, {}, error);
			dispatch(Object(__WEBPACK_IMPORTED_MODULE_9_Common_actions_MessagesviewActions__["g" /* failedMessages */])(messagesRequest, 'Bad response from server'));
			dispatch(Object(__WEBPACK_IMPORTED_MODULE_4_Actions_GlobalMetaActions__["b" /* backInHistory */])());
		});
	};
}

function deletePms(pmIds, isFolder) {
	return function (dispatch, getState) {
		topifyConsole.log('Delete PMs', pmIds);
		var state = getState(),
		    url = state.topifyPresets.forumSite.url,
		    userID = state.ustate.id ? state.ustate.id : 0;

		var pmids = [];
		pmIds.forEach(function (pmid) {
			pmids.push('pmid[]=' + pmid);
		});
		pmids = pmids.join('&');

		var fetchConfig = dispatch(Object(__WEBPACK_IMPORTED_MODULE_4_Actions_GlobalMetaActions__["e" /* getFetchConfig */])(false, 'POST', pmids));

		dispatch(Object(__WEBPACK_IMPORTED_MODULE_5_Actions_UiActions__["O" /* showGlobalLoading */])('Processing'));

		return fetch(url + ('?v=3.0&ajax=1&uid=' + userID + '&req=post&type=deletepm'), fetchConfig).then(function (response) {
			if (!response.ok) {
				try {
					response.json().then(function (json) {
						Object(__WEBPACK_IMPORTED_MODULE_4_Actions_GlobalMetaActions__["j" /* setGlobalNotification */])(dispatch, json, response);
					});
				} catch (e) {
					Object(__WEBPACK_IMPORTED_MODULE_4_Actions_GlobalMetaActions__["j" /* setGlobalNotification */])(dispatch, {}, response);
				}
			} else {
				response.json().then(function (json) {
					Object(__WEBPACK_IMPORTED_MODULE_4_Actions_GlobalMetaActions__["j" /* setGlobalNotification */])(dispatch, json, { ok: true });
					// Record the Google Analytics event.
					dispatch(Object(__WEBPACK_IMPORTED_MODULE_7_Actions_adsActions__["A" /* trackGAEvent */])(false, 'deleteMessage', 'userAction', 'creation'));
					if (isFolder) {
						dispatch(Object(__WEBPACK_IMPORTED_MODULE_4_Actions_GlobalMetaActions__["h" /* refreshPage */])());
					} else {
						dispatch(Object(__WEBPACK_IMPORTED_MODULE_4_Actions_GlobalMetaActions__["b" /* backInHistory */])());
					}
					dispatch(Object(__WEBPACK_IMPORTED_MODULE_5_Actions_UiActions__["D" /* hideGlobalLoading */])());
				});
			}
		}).catch(function (error) {
			dispatch(Object(__WEBPACK_IMPORTED_MODULE_5_Actions_UiActions__["D" /* hideGlobalLoading */])());
			Object(__WEBPACK_IMPORTED_MODULE_4_Actions_GlobalMetaActions__["j" /* setGlobalNotification */])(dispatch, {}, error);
			dispatch(Object(__WEBPACK_IMPORTED_MODULE_9_Common_actions_MessagesviewActions__["g" /* failedMessages */])('deletePms', null, 'Bad response from server'));
		});
	};
}

function markAsReadPM(pmIds, read) {
	var isFolder = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

	return function (dispatch, getState) {
		var state = getState(),
		    url = state.topifyPresets.forumSite.url,
		    userID = state.ustate.id ? state.ustate.id : 0;
		var pmids = null;

		topifyConsole.log('Mark as un/read', read, pmIds);

		if (isFolder) {
			pmids = 'pmfolder=' + pmIds;
		} else {
			pmids = [];
			pmIds.forEach(function (pmid) {
				pmids.push('pmid[]=' + pmid);
			});
			pmids = pmids.join('&');
		}

		var body = pmids + '&state=' + (read ? 1 : 0);

		var fetchConfig = dispatch(Object(__WEBPACK_IMPORTED_MODULE_4_Actions_GlobalMetaActions__["e" /* getFetchConfig */])(false, 'POST', body));

		dispatch(Object(__WEBPACK_IMPORTED_MODULE_5_Actions_UiActions__["O" /* showGlobalLoading */])('Processing'));

		return fetch(url + ('?v=3.0&ajax=1&uid=' + userID + '&req=post&type=markreadpm'), fetchConfig).then(function (response) {
			if (!response.ok) {
				try {
					response.json().then(function (json) {
						Object(__WEBPACK_IMPORTED_MODULE_4_Actions_GlobalMetaActions__["j" /* setGlobalNotification */])(dispatch, json, response);
					});
				} catch (e) {
					Object(__WEBPACK_IMPORTED_MODULE_4_Actions_GlobalMetaActions__["j" /* setGlobalNotification */])(dispatch, {}, response);
				}
			} else {
				response.json().then(function (json) {
					Object(__WEBPACK_IMPORTED_MODULE_4_Actions_GlobalMetaActions__["j" /* setGlobalNotification */])(dispatch, json, { ok: true });
					// Record the Google Analytics event and for the forum.
					dispatch(Object(__WEBPACK_IMPORTED_MODULE_7_Actions_adsActions__["A" /* trackGAEvent */])(true, 'pmRead', 'userAction', 'consumption'));

					dispatch(Object(__WEBPACK_IMPORTED_MODULE_4_Actions_GlobalMetaActions__["h" /* refreshPage */])());
					dispatch(Object(__WEBPACK_IMPORTED_MODULE_5_Actions_UiActions__["D" /* hideGlobalLoading */])());
				});
			}
		}).catch(function (error) {
			dispatch(Object(__WEBPACK_IMPORTED_MODULE_5_Actions_UiActions__["D" /* hideGlobalLoading */])());
			Object(__WEBPACK_IMPORTED_MODULE_4_Actions_GlobalMetaActions__["j" /* setGlobalNotification */])(dispatch, {}, error);
			dispatch(Object(__WEBPACK_IMPORTED_MODULE_9_Common_actions_MessagesviewActions__["g" /* failedMessages */])('markreadPM', null, 'Bad response from server'));
		});
	};
}

function movePMs(messages, folder) {
	return function (dispatch, getState) {
		var state = getState(),
		    url = state.topifyPresets.forumSite.url,
		    userID = state.ustate.id ? state.ustate.id : 0;

		topifyConsole.log('Move PMS to folder', messages, folder);
		if (!messages || !messages.length || folder === null) {
			Object(__WEBPACK_IMPORTED_MODULE_5_Actions_UiActions__["B" /* displayNotification */])('info', 'No messages selected or folder provided');
			return false;
		}

		var pmids = [];
		messages.forEach(function (pmid) {
			pmids.push('pmid[]=' + pmid);
		});
		pmids = pmids.join('&');

		var body = pmids + '&folder=' + folder;

		var fetchConfig = dispatch(Object(__WEBPACK_IMPORTED_MODULE_4_Actions_GlobalMetaActions__["e" /* getFetchConfig */])(false, 'POST', body));

		dispatch(Object(__WEBPACK_IMPORTED_MODULE_5_Actions_UiActions__["O" /* showGlobalLoading */])('Processing'));

		return fetch(url + ('?v=3.0&ajax=1&uid=' + userID + '&req=post&type=movepm'), fetchConfig).then(function (response) {
			if (!response.ok) {
				try {
					response.json().then(function (json) {
						Object(__WEBPACK_IMPORTED_MODULE_4_Actions_GlobalMetaActions__["j" /* setGlobalNotification */])(dispatch, json, response);
					});
				} catch (e) {
					Object(__WEBPACK_IMPORTED_MODULE_4_Actions_GlobalMetaActions__["j" /* setGlobalNotification */])(dispatch, {}, response);
				}
			} else {
				response.json().then(function (json) {
					Object(__WEBPACK_IMPORTED_MODULE_4_Actions_GlobalMetaActions__["j" /* setGlobalNotification */])(dispatch, json, { ok: true });
					// Record the Google Analytics event and for the forum.
					dispatch(Object(__WEBPACK_IMPORTED_MODULE_7_Actions_adsActions__["A" /* trackGAEvent */])(false, 'pmMoved', 'userAction', 'consumption'));

					dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_Actions_MetaActions__["c" /* resetSelectedItem */])());
					dispatch(Object(__WEBPACK_IMPORTED_MODULE_4_Actions_GlobalMetaActions__["h" /* refreshPage */])());
					dispatch(Object(__WEBPACK_IMPORTED_MODULE_5_Actions_UiActions__["D" /* hideGlobalLoading */])());
				});
			}
		}).catch(function (error) {
			dispatch(Object(__WEBPACK_IMPORTED_MODULE_5_Actions_UiActions__["D" /* hideGlobalLoading */])());
			Object(__WEBPACK_IMPORTED_MODULE_4_Actions_GlobalMetaActions__["j" /* setGlobalNotification */])(dispatch, {}, error);
			dispatch(Object(__WEBPACK_IMPORTED_MODULE_9_Common_actions_MessagesviewActions__["g" /* failedMessages */])('movePMs', null, 'Bad response from server'));
		});
	};
}

/***/ }),

/***/ 669:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 688:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 72:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FETCH_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return UPDATE_PAGE_NUMBER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return UPDATE_PAGES_RESULT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return RESET_INFINITE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return RESET_AND_SAVE_INFINITE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return RESTORE_INFINITE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return LOADING_BEHAVIOR; });
/* harmony export (immutable) */ __webpack_exports__["k"] = getLoadingBehavior;
/* harmony export (immutable) */ __webpack_exports__["i"] = fetchSuccess;
/* harmony export (immutable) */ __webpack_exports__["l"] = resetInfinite;
/* harmony export (immutable) */ __webpack_exports__["n"] = updatePagesResult;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return FRAME_SIZE; });
/* harmony export (immutable) */ __webpack_exports__["j"] = filterPageResult;
/* harmony export (immutable) */ __webpack_exports__["m"] = shouldNotUpdateState;
/* unused harmony export resetAndSaveInfinite */
/* unused harmony export restoreInfinite */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_range__ = __webpack_require__(676);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_range___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_range__);


var FETCH_SUCCESS = 'FETCH_SUCCESS';
var UPDATE_PAGE_NUMBER = 'UPDATE_PAGE_NUMBER';
var UPDATE_PAGES_RESULT = 'UPDATE_PAGES_RESULT';
var RESET_INFINITE = 'RESET_INFINITE';
var RESET_AND_SAVE_INFINITE = 'RESET_AND_SAVE_INFINITE';
var RESTORE_INFINITE = 'RESTORE_INFINITE';

var LOADING_BEHAVIOR = {
	PREPEND: 'PREPEND',
	APPEND: 'APPEND',
	REFRESH: 'REFRESH',
	NONE: 'NONE'
};

function getLoadingBehavior(getState, id, type, page) {
	var forceRefresh = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

	var result = void 0;
	var state = getState().infiniteScroll;

	if (state.earliestLoadedPage === null || state.latestLoadedPage === null || type !== state.loadType || id !== state.id || forceRefresh) {
		// This is the initial load
		result = LOADING_BEHAVIOR.REFRESH;
	} else {
		if (page === state.earliestLoadedPage - 1) {
			// Scrolling up
			result = LOADING_BEHAVIOR.PREPEND;
		} else if (page === state.latestLoadedPage + 1) {
			// Scrolling down
			result = LOADING_BEHAVIOR.APPEND;
		} else if (state.earliestLoadedPage <= page && state.latestLoadedPage >= page) {
			// Scrolling to edges
			result = LOADING_BEHAVIOR.NONE;
		} else {
			// Jumped to a page
			result = LOADING_BEHAVIOR.REFRESH;
		}
	}

	return result;
}

function fetchSuccess(id, type, page, totalPages, loadingBehavior) {
	return {
		type: FETCH_SUCCESS,
		id: id,
		loadType: type,
		page: parseInt(page),
		totalPages: parseInt(totalPages),
		loadingBehavior: loadingBehavior
	};
}

function resetInfinite() {
	return {
		type: RESET_INFINITE
	};
}

function updatePagesResult() {
	var newPage = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;

	return {
		type: UPDATE_PAGES_RESULT,
		page: parseInt(newPage)
	};
}

var FRAME_SIZE = 1;

function filterPageResult(currentPage, earliestLoadedPage, latestLoadedPage) {
	var payload = __WEBPACK_IMPORTED_MODULE_0_lodash_range___default()(earliestLoadedPage, latestLoadedPage + 1);
	if (payload.length > 2) {
		var index = payload.indexOf(currentPage);
		if (index === 0) {
			return payload.slice(index, index + FRAME_SIZE + 2);
		} else {
			return payload.slice(index - FRAME_SIZE, index + FRAME_SIZE + 1);
		}
	} else {
		return payload;
	}
}

function shouldNotUpdateState(getState, request) {
	var state = getState().infiniteScroll,
	    page = request.page || 1;

	return !request.forceRefresh && parseInt(state.earliestLoadedPage) !== parseInt(state.latestLoadedPage) && parseInt(page) >= parseInt(state.earliestLoadedPage) && parseInt(page) <= parseInt(state.latestLoadedPage) && !request.postid;
}

var resetAndSaveInfinite = function resetAndSaveInfinite() {
	return {
		type: RESET_AND_SAVE_INFINITE
	};
};

var restoreInfinite = function restoreInfinite() {
	return {
		type: RESTORE_INFINITE
	};
};

/***/ }),

/***/ 73:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./common/actions/ContextInfoActions.js

function getUSerPermissions() {
	return function (dispatch, getState) {
		try {
			var state = getState(),
			    isUserLoggedIn = !!state.ustate.id;

			return isUserLoggedIn && state.ustate.perms ? state.ustate.perms : {};
		} catch (e) {
			return null;
		}
	};
}

function getSubForumPermissions() {
	return function (dispatch, getState) {
		try {
			var state = getState(),
			    forumid = parseInt(state.forumview.forumId),
			    forum = forumid ? state.forumview.entities.forums[forumid] : null;

			return {
				cancreate: forum.cancreate,
				isForum: forum.isForum
			};
		} catch (e) {
			return null;
		}
	};
}

function getThreadPermissions() {
	return function (dispatch, getState) {
		try {
			var state = getState(),
			    threadid = parseInt(state.threadview.threadid),
			    thread = threadid ? state.threadview.entities.topics[threadid] : null;

			return {
				canreply: thread.canreply,
				canopenclose: thread.canopenclose,
				candelete: thread.candelete,
				canreport: thread.canreport,
				isOpen: thread.isOpen,
				isDeleted: thread.isDeleted
			};
		} catch (e) {
			return null;
		}
	};
}

function isSubscribedForum() {
	return function (dispatch, getState) {
		try {
			var state = getState(),
			    forumid = parseInt(state.forumview.forumId),
			    forum = forumid ? state.forumview.entities.forums[forumid] : null;

			return forum.isSubscribed;
		} catch (e) {
			return null;
		}
	};
}

function isSubscribedThread() {
	return function (dispatch, getState) {
		try {
			var state = getState(),
			    threadid = parseInt(state.threadview.threadid),
			    thread = threadid ? state.threadview.entities.topics[threadid] : null;

			return thread.isSubscribed;
		} catch (e) {
			return null;
		}
	};
}

function canCreateThread() {
	return function (dispatch, getState) {
		var isUserLoggedIn = !!getState().ustate.id,
		    forumPerms = dispatch(getSubForumPermissions());

		return forumPerms ? isUserLoggedIn && forumPerms.cancreate && forumPerms.isForum : false;
	};
}

function canReplyThread() {
	return function (dispatch, getState) {
		var isUserLoggedIn = !!getState().ustate.id,
		    threadPerms = dispatch(getThreadPermissions());

		return threadPerms ? isUserLoggedIn && threadPerms.canreply && threadPerms.isOpen && !threadPerms.isDeleted : false;
	};
}

function canOpenCloseThread() {
	return function (dispatch, getState) {
		var isUserLoggedIn = !!getState().ustate.id,
		    threadPerms = dispatch(getThreadPermissions());

		return threadPerms && isUserLoggedIn && threadPerms.canopenclose && !threadPerms.isDeleted ? threadPerms.isOpen : null;
	};
}

function canDeleteThread() {
	return function (dispatch, getState) {
		var isUserLoggedIn = !!getState().ustate.id,
		    threadPerms = dispatch(getThreadPermissions());

		return threadPerms && isUserLoggedIn && threadPerms.candelete ? !threadPerms.isDeleted : null;
	};
}

function canEditPost() {
	var postId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

	if (!postId) {
		return false;
	}

	return function (dispatch, getState) {
		var state = getState(),
		    isUserLoggedIn = !!state.ustate.id,
		    id = parseInt(postId),
		    post = id ? state.threadview.entities.posts[id] : null;

		return post && isUserLoggedIn ? post.canEdit : false;
	};
}

// Check if we can delete or restore deleted posts
function canDeletePosts() {
	var areDeleted = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

	return function (dispatch, getState) {
		var state = getState(),
		    isUserLoggedIn = !!state.ustate.id,
		    threadPerms = dispatch(getThreadPermissions()),
		    modDelete = !!(state.meta.permissions && state.meta.permissions.candeleteposts),
		    selectedElements = Object.keys(state.meta.selectedElements);

		if (selectedElements.length <= 0 || !isUserLoggedIn || !threadPerms) {
			return false;
		}

		if (threadPerms.isOpen) {
			return selectedElements.every(function (item) {
				var post = state.threadview.entities.posts ? state.threadview.entities.posts[item] : false,
				    ownPost = post ? post.canEdit && state.ustate.id && parseInt(post.forumUser) === parseInt(state.ustate.id) : false;
				return (ownPost || threadPerms.candelete || modDelete) && post.isDeleted === areDeleted;
			});
		}

		return false;
	};
}

function canReportPost() {
	return function (dispatch, getState) {
		var isUserLoggedIn = !!getState().ustate.id,
		    threadPerms = dispatch(getThreadPermissions());

		return threadPerms && isUserLoggedIn ? threadPerms.canreport : null;
	};
}

var getTopic = function getTopic(getState, topicId) {
	var topics = getState().threadview.entities.topics;
	if (topics && topics[topicId]) {
		return topics[topicId];
	} else {
		return null;
	}
};

function topicForumId(topicId) {
	return function (dispatch, getState) {
		var topic = getTopic(getState, topicId);
		return topic ? topic.forum : '';
	};
}

var topicForumTitle = function topicForumTitle(topicId) {
	return function (dispatch, getState) {
		return getTopic(getState, topicId).title;
	};
};

var getForumTitle = function getForumTitle(forumId) {
	return function (dispatch, getState) {
		return getState().forumview.entities.forums[forumId].title;
	};
};

function topicTitle(topicId) {
	return function (dispatch, getState) {
		var topic = getTopic(getState, topicId);
		return topic ? topic.title : '';
	};
}

function topicHref(topicId) {
	return function (dispatch, getState) {
		var topic = getTopic(getState, topicId);
		return topic ? topic.href : '';
	};
}

var getForum = function getForum(getState, forumId) {
	if (forumId > 0) {
		var forums = getState().forumview.entities.forums;
		if (forums && forums[forumId]) {
			return forums[forumId];
		} else {
			return null;
		}
	} else {
		return null;
	}
};

function forumHref(forumId) {
	return function (dispatch, getState) {
		var forum = getForum(getState, forumId);
		return forum ? forum.href : getState().topifyPresets.forumSite.f_url;
	};
}

function messageTitle(messageId) {
	return function (dispatch, getState) {
		var pms = getState().messagesview.entities.pms;
		if (!!pms[messageId]) {
			return pms[messageId].title;
		} else {
			throw new Error('Title not found for message');
		}
	};
}

function messageTo(messageId) {
	return function (dispatch, getState) {
		var entities = getState().messagesview.entities,
		    pms = entities.pms,
		    users = entities.users,
		    user = users[pms[messageId].fromUser];

		return { id: user.id, username: user.userName };
	};
}

function getPmFolders() {
	return function (dispatch, getState) {
		var entities = getState().messagesview.entities;

		return entities.pmfolders || [];
	};
}

function currentPMFolder(pmid) {
	return function (dispatch, getState) {
		var state = getState(),
		    entities = state.messagesview.entities;

		try {
			var pmFolder = entities.pms[pmid].folder;
			return entities.pmfolders[pmFolder];
		} catch (e) {
			return false;
		}
	};
}

function messageContent() {
	return function (dispatch, getState) {
		var state = getState(),
		    selectedElements = state.meta.selectedElements,
		    posts = state.threadview.entities.posts;
		return Object.keys(selectedElements).map(function (postId) {
			var post = posts[postId];
			return '' + post.message;
		}).join('');
	};
}

function replyQuote() {
	var isPM = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

	return function (dispatch, getState) {
		var state = getState(),
		    selectedElements = !isPM ? state.meta.selectedElements : isPM,
		    items = !isPM ? state.threadview.entities.posts : state.messagesview.entities.pms;

		if (!isPM) {
			return Object.keys(selectedElements).map(function (postId) {
				var post = items[postId];
				return '[QUOTE=' + post.forumUserName + ';' + postId + ']' + post.message + '[/QUOTE]';
			}).join('\n');
		} else {
			return selectedElements.map(function (pmId) {
				var pm = items[pmId],
				    userName = state.messagesview.entities.users[pm.fromUser];

				return '[QUOTE=' + (userName ? userName.userName : '') + ';]' + pm.message + '[/QUOTE]';
			}).join('\n');
		}
	};
}

function uploadLimits() {
	return function (dispatch, getState) {
		return getState().ustate.upload;
	};
}

function postSelected() {
	return function (dispatch, getState) {
		var selectedElements = getState().meta.selectedElements;
		return Object.keys(selectedElements)[0];
	};
}

function selectedPMsUnread() {
	var every = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

	return function (dispatch, getState) {
		var state = getState(),
		    selectedElements = Object.keys(state.meta.selectedElements);
		if (state.messagesview.entities.pms && selectedElements.length > 0) {
			if (every) {
				return selectedElements.every(function (pmId) {
					return state.messagesview.entities.pms[pmId] && state.messagesview.entities.pms[pmId].unread === true;
				});
			} else {
				return selectedElements.some(function (pmId) {
					return state.messagesview.entities.pms[pmId] && state.messagesview.entities.pms[pmId].unread === true;
				});
			}
		}
	};
}

function selectedItemsUnread() {
	return function (dispatch, getState) {
		var state = getState(),
		    entity = void 0,
		    unread = void 0,
		    value = true,
		    searchresult = state.searchresult || state.search;

		switch (true) {
			case searchresult.result.forums && searchresult.result.forums.length > 0:
				entity = 'forums';
				unread = 'isRead';
				value = false;
				break;

			case searchresult.result.topics && searchresult.result.topics.length > 0:
				entity = 'topics';
				unread = 'unread';
				break;
		}

		if (entity && searchresult.entities[entity]) {
			var entities = searchresult.entities[entity],
			    unreadItems = searchresult.result[entity].filter(function (itemid) {
				return entities[itemid] && entities[itemid][unread] === value;
			});

			return {
				entity: entity,
				unreadItems: unreadItems
			};
		}

		return false;
	};
}
// CONCATENATED MODULE: ./src/actions/ContextInfoActions.js
/* harmony export (immutable) */ __webpack_exports__["m"] = getUserInfo;
/* harmony export (immutable) */ __webpack_exports__["i"] = currentUser;
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "l", function() { return getUSerPermissions; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return getSubForumPermissions; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return getThreadPermissions; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "n", function() { return isSubscribedForum; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "o", function() { return isSubscribedThread; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "a", function() { return canCreateThread; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "f", function() { return canReplyThread; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "e", function() { return canOpenCloseThread; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "c", function() { return canDeleteThread; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "d", function() { return canEditPost; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "b", function() { return canDeletePosts; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "g", function() { return canReportPost; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "w", function() { return topicForumId; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return topicForumTitle; });
/* unused concated harmony import null */
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, false, function() { return getForumTitle; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "y", function() { return topicTitle; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "x", function() { return topicHref; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "j", function() { return forumHref; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "q", function() { return messageTitle; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "r", function() { return messageTo; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "k", function() { return getPmFolders; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "h", function() { return currentPMFolder; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "p", function() { return messageContent; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "t", function() { return replyQuote; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "z", function() { return uploadLimits; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "s", function() { return postSelected; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "v", function() { return selectedPMsUnread; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "u", function() { return selectedItemsUnread; });
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function getUserInfo() {
	var userId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

	return function (dispatch, getState) {
		if (userId === null) {
			return {};
		}

		var state = getState();
		var defaultUser = {
			id: 0,
			userName: 'Guest',
			avatar: ('https:' === document.location.protocol ? 'https://' : 'http://') + 'staticimages.topify.com/default_avatar.png'
		},
		    user = void 0;

		// Let find the users array
		for (var view in state) {
			if (state[view].entities && state[view].entities.users && state[view].entities.users[userId]) {
				user = _extends({}, defaultUser, state[view].entities.users[userId]);
				break;
			}
		}

		if (user && !user.avatar) {
			user.avatar = defaultUser.avatar;
		}

		return user || defaultUser;
	};
}

function currentUser() {
	return function (dispatch, getState) {
		var state = getState();
		var userId = state.ustate.id || 0,
		    user = dispatch(getUserInfo(userId));

		user = {
			id: parseInt(userId),
			userName: state.ustate.userName || user.userName,
			avatar: state.ustate.avatar || user.avatar
		};

		return user;
	};
}



/***/ }),

/***/ 762:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 763:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 764:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 765:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 766:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 769:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 770:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 771:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 772:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 773:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 774:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 775:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 776:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 777:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 778:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 779:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 780:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 790:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 819:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 821:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 822:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 823:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 825:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/*
 * JavaScript Canvas to Blob
 * https://github.com/blueimp/JavaScript-Canvas-to-Blob
 *
 * Copyright 2012, Sebastian Tschan
 * https://blueimp.net
 *
 * Licensed under the MIT license:
 * http://www.opensource.org/licenses/MIT
 *
 * Based on stackoverflow user Stoive's code snippet:
 * http://stackoverflow.com/q/4998908
 */

/* global atob, Blob, define */

;(function (window) {
	'use strict';

	var CanvasPrototype = window.HTMLCanvasElement && window.HTMLCanvasElement.prototype;
	var hasBlobConstructor = window.Blob && function () {
		try {
			return Boolean(new Blob());
		} catch (e) {
			return false;
		}
	}();
	var hasArrayBufferViewSupport = hasBlobConstructor && window.Uint8Array && function () {
		try {
			return new Blob([new Uint8Array(100)]).size === 100;
		} catch (e) {
			return false;
		}
	}();
	var BlobBuilder = window.BlobBuilder || window.WebKitBlobBuilder || window.MozBlobBuilder || window.MSBlobBuilder;
	var dataURIPattern = /^data:((.*?)(;charset=.*?)?)(;base64)?,/;
	var dataURLtoBlob = (hasBlobConstructor || BlobBuilder) && window.atob && window.ArrayBuffer && window.Uint8Array && function (dataURI) {
		var matches, mediaType, isBase64, dataString, byteString, arrayBuffer, intArray, i, bb;
		// Parse the dataURI components as per RFC 2397
		matches = dataURI.match(dataURIPattern);
		if (!matches) {
			throw new Error('invalid data URI');
		}
		// Default to text/plain;charset=US-ASCII
		mediaType = matches[2] ? matches[1] : 'text/plain' + (matches[3] || ';charset=US-ASCII');
		isBase64 = !!matches[4];
		dataString = dataURI.slice(matches[0].length);
		if (isBase64) {
			// Convert base64 to raw binary data held in a string:
			byteString = atob(dataString);
		} else {
			// Convert base64/URLEncoded data component to raw binary:
			byteString = decodeURIComponent(dataString);
		}
		// Write the bytes of the string to an ArrayBuffer:
		arrayBuffer = new ArrayBuffer(byteString.length);
		intArray = new Uint8Array(arrayBuffer);
		for (i = 0; i < byteString.length; i += 1) {
			intArray[i] = byteString.charCodeAt(i);
		}
		// Write the ArrayBuffer (or ArrayBufferView) to a blob:
		if (hasBlobConstructor) {
			return new Blob([hasArrayBufferViewSupport ? intArray : arrayBuffer], { type: mediaType });
		}
		bb = new BlobBuilder();
		bb.append(arrayBuffer);
		return bb.getBlob(mediaType);
	};
	if (window.HTMLCanvasElement && !CanvasPrototype.toBlob) {
		if (CanvasPrototype.mozGetAsFile) {
			CanvasPrototype.toBlob = function (callback, type, quality) {
				if (quality && CanvasPrototype.toDataURL && dataURLtoBlob) {
					callback(dataURLtoBlob(this.toDataURL(type, quality)));
				} else {
					callback(this.mozGetAsFile('blob', type));
				}
			};
		} else if (CanvasPrototype.toDataURL && dataURLtoBlob) {
			CanvasPrototype.toBlob = function (callback, type, quality) {
				callback(dataURLtoBlob(this.toDataURL(type, quality)));
			};
		}
	}
	if (true) {
		!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return dataURLtoBlob;
		}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else if ((typeof module === 'undefined' ? 'undefined' : _typeof(module)) === 'object' && module.exports) {
		module.exports = dataURLtoBlob;
	} else {
		window.dataURLtoBlob = dataURLtoBlob;
	}
})(window);

/***/ }),

/***/ 826:
/***/ (function(module, exports, __webpack_require__) {

if (false) {
	module.exports = require('./configureStore.dev.js');
} else {
	module.exports = __webpack_require__(827);
}

/***/ }),

/***/ 827:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/redux/es/index.js + 6 modules
var es = __webpack_require__(208);

// EXTERNAL MODULE: ./node_modules/react-router-redux/lib/index.js
var lib = __webpack_require__(6);
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);

// EXTERNAL MODULE: ./node_modules/react-router/es/index.js + 32 modules
var react_router_es = __webpack_require__(115);

// EXTERNAL MODULE: ./node_modules/redux-thunk/lib/index.js
var redux_thunk_lib = __webpack_require__(828);
var redux_thunk_lib_default = /*#__PURE__*/__webpack_require__.n(redux_thunk_lib);

// EXTERNAL MODULE: ./src/actions/adsActions.js
var adsActions = __webpack_require__(4);

// EXTERNAL MODULE: ./src/actions/InfiniteScrollActions.js
var InfiniteScrollActions = __webpack_require__(16);

// CONCATENATED MODULE: ./src/reducers/ads.js
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var ads_initialState = {
	geoLocation: {
		allow: true,
		error: false,
		latitude: '',
		longitude: '',
		timestamp: 0
	},
	adSlots: [],
	showInterstitial: false,
	noAdsPermissions: false,
	secondaryAds: false,
	resetHiddenAds: 0,
	documentVisible: false,
	analytics: 0
};

function ads() {
	var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ads_initialState;
	var action = arguments[1];

	var adSlots = void 0;

	switch (action.type) {
		case adsActions["d" /* GEOLOCATION */]:
			return Object.assign({}, state, { geoLocation: action.location });

		case adsActions["k" /* SHOW_INTERSTITIAL */]:
			return _extends({}, state, {
				showInterstitial: true
			});

		case adsActions["f" /* HIDE_INTERSTITIAL */]:
			return _extends({}, state, {
				showInterstitial: false
			});

		case adsActions["h" /* SAVE_AD_SLOT */]:
			adSlots = Object.assign({}, state.adSlots);
			adSlots[action.slotName] = false; // by default is hidden

			return Object.assign({}, state, { adSlots: adSlots });

		case adsActions["b" /* DELETE_AD_SLOT */]:
			adSlots = Object.assign({}, state.adSlots);
			delete adSlots[action.slotName];

			return Object.assign({}, state, { adSlots: adSlots });

		case adsActions["j" /* SHOW_AD_SLOT */]:
			adSlots = Object.assign({}, state.adSlots);
			adSlots[action.slotName] = true;

			return Object.assign({}, state, { adSlots: adSlots });

		case adsActions["e" /* HIDE_AD_SLOT */]:
			adSlots = Object.assign({}, state.adSlots);
			adSlots[action.slotName] = false;

			return Object.assign({}, state, { adSlots: adSlots });

		case adsActions["a" /* ADS_PERMISSIONS */]:
			return _extends({}, state, {
				noAdsPermissions: typeof action.values.noAdsPermissions !== 'undefined' ? action.values.noAdsPermissions : state.noAdsPermissions,
				secondaryAds: typeof action.values.secondaryAds !== 'undefined' ? action.values.secondaryAds : state.secondaryAds
			});

		case adsActions["g" /* RESET_HIDDEN_ADS */]:
			return _extends({}, state, {
				resetHiddenAds: new Date().getTime()
			});

		case adsActions["i" /* SET_GPTCORRELATOR */]:
			return _extends({}, state, {
				changeGPTCorrelator: action.refresh
			});

		case adsActions["c" /* DOCUMENT_VISIBLE */]:
			return _extends({}, state, {
				documentVisible: action.visible
			});

		case InfiniteScrollActions["c" /* UPDATE_PAGE_NUMBER */]:
		case '@@router/LOCATION_CHANGE':
			// We use this to trigger location change events
			return _extends({}, state, {
				analytics: new Date().getTime()
			});

		default:
			return state;
	}
}
// EXTERNAL MODULE: ./common/actions/ForumviewActions.js
var ForumviewActions = __webpack_require__(117);

// EXTERNAL MODULE: ./common/actions/InfiniteScrollActions.js
var actions_InfiniteScrollActions = __webpack_require__(72);

// EXTERNAL MODULE: ./node_modules/lodash/merge.js
var merge = __webpack_require__(91);
var merge_default = /*#__PURE__*/__webpack_require__.n(merge);

// EXTERNAL MODULE: ./node_modules/lodash/union.js
var union = __webpack_require__(123);
var union_default = /*#__PURE__*/__webpack_require__.n(union);

// CONCATENATED MODULE: ./common/reducers/forumview.js
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }







var forumview_initialState = {
	isFetching: false,
	loaded: false,
	lastError: '',
	entities: {},
	pages: [],
	result: {
		forums: [],
		topics: [],
		users: [],
		sticky: [],
		announcements: []
	},
	forumId: null,
	page: null,
	totalPages: 0
};

function forumview() {
	var prevState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : forumview_initialState;
	var action = arguments[1];

	switch (action.type) {
		case ForumviewActions["b" /* FORUM_FETCH */]:
			return Object.assign({}, prevState, {
				isFetching: true,
				// Only set loaded to false if we are doing a full refresh
				loaded: !(action.forum.loadingBehavior === actions_InfiniteScrollActions["c" /* LOADING_BEHAVIOR */].REFRESH)
			});

		case ForumviewActions["e" /* FORUM_SUCCESS */]:
			if (prevState.forumId !== action.forum.id || action.forum.loadingBehavior === actions_InfiniteScrollActions["c" /* LOADING_BEHAVIOR */].REFRESH) {
				return merge_default()({}, action.data, {
					isFetching: false,
					loaded: true,
					forumId: action.forum.id,
					pages: [action.data.page]
				});
			} else {
				var topicsResult = void 0,
				    usersResult = void 0,
				    pages = void 0;
				if (action.forum.loadingBehavior === actions_InfiniteScrollActions["c" /* LOADING_BEHAVIOR */].PREPEND) {
					topicsResult = [].concat(_toConsumableArray(action.data.result.topics), _toConsumableArray(prevState.result.topics));
					usersResult = union_default()(action.data.result.users, prevState.result.users);
					pages = [action.data.page].concat(_toConsumableArray(prevState.pages));
				} else if (action.forum.loadingBehavior === actions_InfiniteScrollActions["c" /* LOADING_BEHAVIOR */].APPEND) {
					topicsResult = [].concat(_toConsumableArray(prevState.result.topics), _toConsumableArray(action.data.result.topics));
					usersResult = union_default()(prevState.result.users, action.data.result.users);
					pages = [].concat(_toConsumableArray(prevState.pages), [action.data.page]);
				}

				return merge_default()({}, prevState, action.data, {
					isFetching: false,
					loaded: true
				}, {
					pages: pages,
					result: {
						topics: topicsResult,
						users: usersResult
					}
				});
			}

		case ForumviewActions["a" /* FORUM_FAILURE */]:
			return Object.assign({}, prevState, {
				lastError: action.error
			});

		case ForumviewActions["d" /* FORUM_RESET */]:
			return forumview_initialState;

		case ForumviewActions["c" /* FORUM_FOLLOWING */]:
			// used only in src
			if (prevState.entities.forums) {
				var prevEntitiesForum = prevState.entities.forums,
				    forum = prevState.entities.forums[action.forumId];

				forum.isSubscribed = action.follow;
				var entitiesForum = {
					forums: Object.assign({}, prevEntitiesForum, _defineProperty({}, action.forumId, forum))
				};
				return Object.assign({}, prevState, entitiesForum);
			}
			return prevState;

		case ForumviewActions["f" /* THREAD_FOLLOWING */]:
			var prevEntitiesThread = {},
			    thread = {},
			    entities = '';
			if (prevState.entities.topics && prevState.entities.topics[action.threadId]) {
				entities = 'topics';
			} else if (prevState.entities.sticky && prevState.entities.sticky[action.threadId]) {
				entities = 'sticky';
			} else {
				return prevState;
			}

			prevEntitiesThread = prevState.entities[entities];
			thread = prevState.entities[entities][action.threadId];

			thread.isSubscribed = action.follow;
			var entitiesThreads = _defineProperty({}, entities, Object.assign({}, prevEntitiesThread, _defineProperty({}, action.threadId, thread)));
			return Object.assign({}, prevState, entitiesThreads);

		default:
			return prevState;
	}
}
// CONCATENATED MODULE: ./src/reducers/forumview.js

// CONCATENATED MODULE: ./common/reducers/infinitescroll.js
var infinitescroll__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



var infinitescroll_state = {
	id: null,
	loadType: null,
	path: null,
	page: 1,
	totalPages: 1,
	earliestLoadedPage: 1,
	latestLoadedPage: 1,
	pages: [],
	scrollDirection: null
};

var infinitescroll_initialState = infinitescroll__extends({}, infinitescroll_state, {
	prevState: infinitescroll_state
});

function infiniteScroll() {
	var prevState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : infinitescroll_initialState;
	var action = arguments[1];


	var scrollDirection = null;

	if (parseInt(prevState.page) > parseInt(action.page)) {
		scrollDirection = "up";
	} else if (parseInt(prevState.page) < parseInt(action.page)) {
		scrollDirection = "down";
	}

	switch (action.type) {
		case actions_InfiniteScrollActions["a" /* FETCH_SUCCESS */]:
			if (action.loadingBehavior === actions_InfiniteScrollActions["c" /* LOADING_BEHAVIOR */].REFRESH) {
				return infinitescroll__extends({}, prevState, {
					id: action.id,
					loadType: action.loadType,
					page: action.page,
					earliestLoadedPage: action.page,
					latestLoadedPage: action.page,
					pages: [action.page],
					totalPages: action.totalPages,
					scrollDirection: null
				});
			} else {
				var earliestLoadedPage = prevState.earliestLoadedPage;
				var latestLoadedPage = prevState.latestLoadedPage;

				if (action.loadingBehavior === actions_InfiniteScrollActions["c" /* LOADING_BEHAVIOR */].PREPEND && action.page < earliestLoadedPage) {
					earliestLoadedPage -= 1;
				} else if (action.loadingBehavior === actions_InfiniteScrollActions["c" /* LOADING_BEHAVIOR */].APPEND && action.page > latestLoadedPage && action.page <= prevState.totalPages) {
					latestLoadedPage += 1;
				}

				return infinitescroll__extends({}, prevState, {
					id: action.id,
					loadType: action.loadType,
					page: prevState.page, // Don't update since this is infinite scrolling and we may not have actually scrolled all the way to that page yet
					pages: Object(actions_InfiniteScrollActions["j" /* filterPageResult */])(prevState.page, earliestLoadedPage, latestLoadedPage),
					earliestLoadedPage: earliestLoadedPage,
					latestLoadedPage: latestLoadedPage,
					scrollDirection: scrollDirection
				});
			}

		case actions_InfiniteScrollActions["h" /* UPDATE_PAGE_NUMBER */]:
			return infinitescroll__extends({}, prevState, {
				page: action.page,
				scrollDirection: scrollDirection
			});

		case actions_InfiniteScrollActions["g" /* UPDATE_PAGES_RESULT */]:
			var pages = Object(actions_InfiniteScrollActions["j" /* filterPageResult */])(prevState.page, prevState.earliestLoadedPage, prevState.latestLoadedPage);
			return infinitescroll__extends({}, prevState, {
				pages: pages,
				scrollDirection: scrollDirection
			});

		case actions_InfiniteScrollActions["e" /* RESET_INFINITE */]:
			return infinitescroll_initialState;

		case actions_InfiniteScrollActions["d" /* RESET_AND_SAVE_INFINITE */]:
			return infinitescroll__extends({}, infinitescroll_initialState, {
				prevState: prevState
			});

		case actions_InfiniteScrollActions["f" /* RESTORE_INFINITE */]:
			return prevState.prevState || infinitescroll_initialState;

		default:
			return prevState;
	}
}
// CONCATENATED MODULE: ./src/reducers/infinitescroll.js

// EXTERNAL MODULE: ./common/actions/MetaActions.js
var MetaActions = __webpack_require__(312);

// EXTERNAL MODULE: ./src/actions/ForumviewActions.js
var actions_ForumviewActions = __webpack_require__(30);

// EXTERNAL MODULE: ./src/actions/MessagesviewActions.js
var MessagesviewActions = __webpack_require__(65);

// EXTERNAL MODULE: ./src/actions/OnlineUsersActions.js
var OnlineUsersActions = __webpack_require__(154);

// EXTERNAL MODULE: ./src/actions/PortalPageActions.js
var PortalPageActions = __webpack_require__(118);

// EXTERNAL MODULE: ./src/actions/SearchResultActions.js
var SearchResultActions = __webpack_require__(104);

// EXTERNAL MODULE: ./src/actions/ThreadviewActions.js
var ThreadviewActions = __webpack_require__(40);

// EXTERNAL MODULE: ./src/actions/UserprofileActions.js
var UserprofileActions = __webpack_require__(87);

// EXTERNAL MODULE: ./src/actions/WidgetActions.js
var WidgetActions = __webpack_require__(105);

// EXTERNAL MODULE: ./src/actions/ReleaseNotesActions.js
var ReleaseNotesActions = __webpack_require__(155);

// CONCATENATED MODULE: ./common/reducers/meta.js
var meta__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };













var meta_state = {
	cacheBust: null,
	path: [],
	title: 'Loading...',
	subTitle: null,
	selectedElements: {},
	isLoading: false,
	isFetchingAny: false
};

var meta_initialState = meta__extends({}, meta_state, {
	prevState: {}
});

var pathName = '';

function meta() {
	var prevState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : meta_initialState;
	var action = arguments[1];

	switch (action.type) {
		case MetaActions["f" /* TOGGLE_SELECTED_ITEM */]:
			var seletedItem = prevState.selectedElements;

			if (seletedItem[action.id]) {
				// delete it if it's already there
				delete seletedItem[action.id];
			} else {
				// add it if it is not
				seletedItem[action.id] = true;
			}

			return meta__extends({}, prevState, {
				selectedElements: seletedItem
			});

		case MetaActions["a" /* RESET_SELECTED_ITEM */]:
			return meta__extends({}, prevState, {
				selectedElements: {}
			});

		case MetaActions["e" /* SET_GLOBAL_META */]:
			return meta__extends({}, prevState, action.meta, {
				title: action.title,
				subTitle: action.subTitle,
				isLoading: false
			});

		case MetaActions["d" /* SET_CACHE_BUST */]:
			return meta__extends({}, prevState, {
				cacheBust: action.cacheBust
			});

		case '@@router/LOCATION_CHANGE':
			// We use this to trigger location change events
			var isLoading = prevState.isLoading ? true : pathName !== action.payload.pathname && action.payload.action !== 'REPLACE';
			pathName = action.payload.pathname;

			return meta__extends({}, prevState, {
				isLoading: isLoading
			});

		case 'react-native-navigation-redux-helpers/PUSH_ROUTE':
		case 'react-native-navigation-redux-helpers/REPLACE_AT_INDEX':
			return meta__extends({}, prevState, {
				isLoading: true
			});

		case MetaActions["c" /* SAVE_META */]:
			return meta__extends({}, prevState, {
				prevState: meta__extends({}, prevState, {
					isLoading: false
				})
			});

		case actions_ForumviewActions["a" /* FORUM_FETCH */]:
		case MessagesviewActions["a" /* MESSAGES_FETCH */]:
		case OnlineUsersActions["a" /* FETCH_ONLINE_USERS */]:
		case PortalPageActions["b" /* PORTALPAGE_FETCH */]:
		case SearchResultActions["a" /* SEARCH_FETCH */]:
		case ThreadviewActions["a" /* THREAD_FETCH */]:
		case UserprofileActions["c" /* USERPROFILE_FETCH */]:
		case WidgetActions["c" /* WIDGET_FETCH */]:
		case ReleaseNotesActions["a" /* FETCH_RELEASE_NOTES */]:
			return meta__extends({}, prevState, {
				isFetchingAny: true
			});

		case actions_ForumviewActions["c" /* FORUM_SUCCESS */]:
		case MessagesviewActions["b" /* MESSAGES_SUCCESS */]:
		case OnlineUsersActions["b" /* FETCH_ONLINE_USERS_SUCCESS */]:
		case PortalPageActions["d" /* PORTALPAGE_SUCCESS */]:
		case SearchResultActions["b" /* SEARCH_SUCCESS */]:
		case ThreadviewActions["b" /* THREAD_SUCCESS */]:
		case UserprofileActions["d" /* USERPROFILE_SUCCESS */]:
		case WidgetActions["f" /* WIDGET_SUCCESS */]:
		case ReleaseNotesActions["b" /* FETCH_RELEASE_NOTES_SUCCESS */]:
			return meta__extends({}, prevState, {
				isFetchingAny: false
			});

		case MetaActions["b" /* RESTORE_META */]:
			return prevState.prevState || meta_initialState;

		default:
			return prevState;
	}
}
// CONCATENATED MODULE: ./src/reducers/meta.js

// EXTERNAL MODULE: ./common/actions/UstateActions.js
var UstateActions = __webpack_require__(220);

// CONCATENATED MODULE: ./common/reducers/ustate.js
var ustate__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function ustate() {
	var prevState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { id: 0 };
	var action = arguments[1];

	switch (action.type) {
		case UstateActions["a" /* SET_CURRENT_USER */]:
			return ustate__extends({}, prevState, action.ustate);

		default:
			return prevState;
	}
}
// CONCATENATED MODULE: ./src/reducers/ustate.js

// EXTERNAL MODULE: ./common/actions/ThreadviewActions.js
var actions_ThreadviewActions = __webpack_require__(221);

// CONCATENATED MODULE: ./common/reducers/threadview.js
function threadview__defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function threadview__toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }







var threadview_initialState = {
	isFetching: false,
	loaded: false,
	lastError: '',
	entities: {},
	pages: [],
	result: {
		posts: [],
		topics: [],
		users: [],
		polls: [],
		pollOptions: [],
		poleVotes: []
	},
	threadId: null,
	postid: null
};

function threadview() {
	var prevState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : threadview_initialState;
	var action = arguments[1];

	switch (action.type) {
		case actions_ThreadviewActions["b" /* THREAD_FETCH */]:
			return Object.assign({}, prevState, {
				isFetching: true,
				// Only set loaded to false if we are doing a full refresh
				loaded: !(action.thread.loadingBehavior === actions_InfiniteScrollActions["c" /* LOADING_BEHAVIOR */].REFRESH)
			});

		case actions_ThreadviewActions["d" /* THREAD_SUCCESS */]:
			var pageId = action.data.page === null ? 1 : parseInt(action.data.page);

			if (prevState.threadId !== action.thread.id || action.thread.loadingBehavior === actions_InfiniteScrollActions["c" /* LOADING_BEHAVIOR */].REFRESH) {
				return merge_default()({}, action.data, {
					isFetching: false,
					loaded: true,
					threadId: action.thread.id,
					pages: [parseInt(action.data.page)]
				});
			} else {
				var postsResult = void 0,
				    usersResult = void 0,
				    pages = void 0;

				if (action.thread.loadingBehavior === actions_InfiniteScrollActions["c" /* LOADING_BEHAVIOR */].PREPEND) {
					postsResult = [].concat(threadview__toConsumableArray(action.data.result.posts), threadview__toConsumableArray(prevState.result.posts));
					usersResult = union_default()(action.data.result.users, prevState.result.users);
					pages = [pageId].concat(threadview__toConsumableArray(prevState.pages));
				} else if (action.thread.loadingBehavior === actions_InfiniteScrollActions["c" /* LOADING_BEHAVIOR */].APPEND) {
					postsResult = [].concat(threadview__toConsumableArray(prevState.result.posts), threadview__toConsumableArray(action.data.result.posts));
					usersResult = union_default()(prevState.result.users, action.data.result.users);
					pages = [].concat(threadview__toConsumableArray(prevState.pages), [pageId]);
				}

				return merge_default()({}, prevState, { postid: null }, // note: this line can be removed when vb 1.8.04 is released
				action.data, {
					isFetching: false,
					loaded: true
				}, {
					pages: pages,
					result: {
						posts: postsResult,
						users: usersResult
					}
				});
			}

		case actions_ThreadviewActions["a" /* THREAD_FAILURE */]:
			return Object.assign({}, prevState, {
				lastError: action.error
			});

		case actions_ThreadviewActions["c" /* THREAD_RESET */]:
			return threadview_initialState;

		case ForumviewActions["f" /* THREAD_FOLLOWING */]:
			var prevEntitiesThread = {},
			    thread = {},
			    entities = '';
			if (prevState.entities.topics && prevState.entities.topics[action.threadId]) {
				entities = 'topics';
			} else if (prevState.entities.sticky && prevState.entities.sticky[action.threadId]) {
				entities = 'sticky';
			} else {
				return prevState;
			}

			prevEntitiesThread = prevState.entities[entities];
			thread = prevState.entities[entities][action.threadId];

			thread.isSubscribed = action.follow;
			var entitiesThreads = threadview__defineProperty({}, entities, Object.assign({}, prevEntitiesThread, threadview__defineProperty({}, action.threadId, thread)));
			return Object.assign({}, prevState, entitiesThreads);

		default:
			return prevState;
	}
}
// CONCATENATED MODULE: ./src/reducers/threadview.js

// EXTERNAL MODULE: ./common/actions/MessagesviewActions.js
var actions_MessagesviewActions = __webpack_require__(223);

// CONCATENATED MODULE: ./common/reducers/messagesview.js
var messagesview__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function messagesview__toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }






var messagesview_initialState = {
	isFetching: false,
	loaded: false,
	lastError: '',
	entities: {},
	pages: [],
	result: {
		pms: [],
		pmfolders: [],
		users: []
	},
	pmroute: '',
	id: null
};

function messagesview() {
	var prevState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : messagesview_initialState;
	var action = arguments[1];


	switch (action.type) {
		case actions_MessagesviewActions["b" /* MESSAGES_FETCH */]:
			return Object.assign({}, prevState, {
				isFetching: true,
				// Only set loaded to false if we are doing a full refresh
				loaded: !(action.loadingBehavior === actions_InfiniteScrollActions["c" /* LOADING_BEHAVIOR */].REFRESH)
			});

		case actions_MessagesviewActions["d" /* MESSAGES_SUCCESS */]:
			if (prevState.pmroute !== action.pmroute || prevState.id !== action.id || action.loadingBehavior === actions_InfiniteScrollActions["c" /* LOADING_BEHAVIOR */].REFRESH) {
				return merge_default()({}, action.data, {
					lastError: '',
					isFetching: false,
					loaded: true,
					id: action.id,
					pmroute: action.pmroute,
					pages: [parseInt(action.data.page)]
				}, {
					prevState: prevState.prevState
				});
			} else {
				var pmsResult = void 0,
				    usersResult = void 0,
				    pages = void 0;

				if (action.loadingBehavior === actions_InfiniteScrollActions["c" /* LOADING_BEHAVIOR */].PREPEND) {
					pmsResult = [].concat(messagesview__toConsumableArray(action.data.result.pms), messagesview__toConsumableArray(prevState.result.pms));
					usersResult = union_default()(action.data.result.users, prevState.result.users);
					pages = [parseInt(action.data.page)].concat(messagesview__toConsumableArray(prevState.pages));
				} else if (action.loadingBehavior === actions_InfiniteScrollActions["c" /* LOADING_BEHAVIOR */].APPEND) {
					pmsResult = [].concat(messagesview__toConsumableArray(prevState.result.pms), messagesview__toConsumableArray(action.data.result.pms));
					usersResult = union_default()(prevState.result.users, action.data.result.users);
					pages = [].concat(messagesview__toConsumableArray(prevState.pages), [parseInt(action.data.page)]);
				}

				return merge_default()({}, prevState, action.data, {
					lastError: '',
					isFetching: false,
					loaded: true
				}, {
					pages: pages,
					result: {
						pms: pmsResult,
						users: usersResult
					}
				});
			}

		case actions_MessagesviewActions["a" /* MESSAGES_FAILURE */]:
			return Object.assign({}, prevState, {
				lastError: action.error,
				isFetching: false,
				loaded: false
			});

		case actions_MessagesviewActions["c" /* MESSAGES_RESET */]:
			return messagesview_initialState;

		case actions_MessagesviewActions["f" /* SAVE_MESSAGES */]:
			return messagesview__extends({}, prevState, {
				prevState: prevState
			});

		case actions_MessagesviewActions["e" /* RESTORE_MESSAGES */]:
			return prevState.prevState || messagesview_initialState;

		default:
			return prevState;
	}
}
// CONCATENATED MODULE: ./src/reducers/messagesview.js

// EXTERNAL MODULE: ./src/actions/NoticesActions.js
var NoticesActions = __webpack_require__(238);

// CONCATENATED MODULE: ./src/reducers/notices.js











var notices_initialState = {
	lastError: '',
	entities: {},
	result: [],
	shown: {}
};

function notices() {
	var prevState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : notices_initialState;
	var action = arguments[1];

	switch (action.type) {
		case actions_ForumviewActions["c" /* FORUM_SUCCESS */]:
		case MessagesviewActions["b" /* MESSAGES_SUCCESS */]:
		case OnlineUsersActions["b" /* FETCH_ONLINE_USERS_SUCCESS */]:
		case PortalPageActions["d" /* PORTALPAGE_SUCCESS */]:
		case SearchResultActions["b" /* SEARCH_SUCCESS */]:
		case ThreadviewActions["b" /* THREAD_SUCCESS */]:
		case UserprofileActions["d" /* USERPROFILE_SUCCESS */]:
		case WidgetActions["f" /* WIDGET_SUCCESS */]:
			if (action.data.entities === undefined) {
				return prevState;
			}

			var _notices = {
				entities: action.data.entities.notices || {},
				result: action.data.result.notices || []
			};
			return Object.assign({}, prevState, _notices);

		case NoticesActions["a" /* SHOWN_NOTICE */]:
			var newShownState = Object.assign({}, prevState.shown);
			if (action.notices.length) {
				action.notices.map(function (nid) {
					newShownState[nid] = true;
				});
			}
			return Object.assign({}, prevState, { shown: newShownState });

		default:
			return prevState;
	}
}
// EXTERNAL MODULE: ./src/actions/GlobalMetaActions.js
var GlobalMetaActions = __webpack_require__(14);

// CONCATENATED MODULE: ./src/reducers/topifypresets.js
var topifypresets__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



// Fix protocols in URLs
TopifyPresets.forumData.forumSite[0].f_url = fixUrlProtocol(TopifyPresets.forumData.forumSite[0].f_url);
TopifyPresets.forumData.forumSite[0].url = fixUrlProtocol(TopifyPresets.forumData.forumSite[0].url);

var topifypresets_initialState = {
	firstLoad: true,
	forumSite: TopifyPresets.forumData.forumSite[0],
	forumInfo: TopifyPresets.forumData.forumInfo[0],
	initialRoute: TopifyPresets.embedRoute,
	initialId: TopifyPresets.embedId,
	secondayId: TopifyPresets.secondayId,
	userInfo: TopifyPresets.userInfo,
	ffUrl: fixUrlProtocol(TopifyPresets.ffUrl)
};

function topifyPresets() {
	var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : topifypresets_initialState;
	var action = arguments[1];

	switch (action.type) {
		case GlobalMetaActions["a" /* CLEAR_FIRST_LOAD */]:
			return topifypresets__extends({}, state, {
				firstLoad: false,
				initialRoute: null,
				initialId: null,
				secondayId: null,
				userInfo: null
			});

		default:
			return state;
	}
}

function fixUrlProtocol(url) {
	return url.replace(/^http[s]*:[/]{2}/i, 'https:' === document.location.protocol ? 'https://' : 'http://');
}
// EXTERNAL MODULE: ./common/actions/SearchResultActions.js
var actions_SearchResultActions = __webpack_require__(222);

// CONCATENATED MODULE: ./common/reducers/searchresult.js
function searchresult__defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function searchresult__toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }










var searchresult_initialState = {
	isFetching: false,
	loaded: false,
	lastError: '',
	entities: {},
	pages: [],
	result: {
		forums: [],
		posts: [],
		topics: [],
		users: []
	},
	searchId: 0,
	commonwords: [],
	query: {
		searchQuery: '',
		showposts: 0,
		showtopics: 1,
		forumId: '',
		action: ''
	},
	page: 1
};

function searchresult() {
	var prevState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : searchresult_initialState;
	var action = arguments[1];

	switch (action.type) {
		case actions_SearchResultActions["c" /* SEARCH_FETCH */]:
			return Object.assign({}, prevState, {
				isFetching: true,
				// Only set loaded to false if we are doing a full refresh
				loaded: !(action.query.loadingBehavior === actions_InfiniteScrollActions["c" /* LOADING_BEHAVIOR */].REFRESH)
			});

		case actions_SearchResultActions["d" /* SEARCH_SUCCESS */]:
			if (prevState.query.searchQuery !== action.data.query.searchQuery || prevState.query.showposts != action.data.query.showposts || prevState.query.showtopics != action.data.query.showtopics || action.query.loadingBehavior === actions_InfiniteScrollActions["c" /* LOADING_BEHAVIOR */].REFRESH) {
				return merge_default()({}, action.data, {
					isFetching: false,
					loaded: true,
					query: action.data.query,
					pages: [parseInt(action.data.page)]
				});
			} else {
				var postsResult = void 0,
				    topicsResult = void 0,
				    forumsResult = void 0,
				    usersResult = void 0,
				    pages = void 0;

				if (action.query.loadingBehavior === actions_InfiniteScrollActions["c" /* LOADING_BEHAVIOR */].PREPEND) {
					postsResult = [].concat(searchresult__toConsumableArray(action.data.result.posts), searchresult__toConsumableArray(prevState.result.posts));
					topicsResult = [].concat(searchresult__toConsumableArray(action.data.result.topics), searchresult__toConsumableArray(prevState.result.topics));
					forumsResult = [].concat(searchresult__toConsumableArray(action.data.result.forums), searchresult__toConsumableArray(prevState.result.forums));
					usersResult = union_default()(action.data.result.users, prevState.result.users);
					pages = [parseInt(action.data.page)].concat(searchresult__toConsumableArray(prevState.pages));
				} else if (action.query.loadingBehavior === actions_InfiniteScrollActions["c" /* LOADING_BEHAVIOR */].APPEND) {
					postsResult = [].concat(searchresult__toConsumableArray(prevState.result.posts), searchresult__toConsumableArray(action.data.result.posts));
					topicsResult = [].concat(searchresult__toConsumableArray(prevState.result.topics), searchresult__toConsumableArray(action.data.result.topics));
					forumsResult = [].concat(searchresult__toConsumableArray(prevState.result.forums), searchresult__toConsumableArray(action.data.result.forums));
					usersResult = union_default()(prevState.result.users, action.data.result.users);
					pages = [].concat(searchresult__toConsumableArray(prevState.pages), [parseInt(action.data.page)]);
				}

				return merge_default()({}, prevState, action.data, {
					isFetching: false,
					loaded: true,
					query: action.query
				}, {
					pages: pages,
					result: {
						posts: postsResult,
						topics: topicsResult,
						forums: forumsResult,
						users: usersResult
					}
				});
			}

		case actions_SearchResultActions["a" /* RESET_SEARCH */]:
			return searchresult_initialState;

		case actions_SearchResultActions["b" /* SEARCH_FAILURE */]:
			return Object.assign({}, prevState, {
				lastError: action.error
			});

		case ForumviewActions["c" /* FORUM_FOLLOWING */]:
			if (prevState.entities.forums) {
				var prevEntitiesForum = prevState.entities.forums,
				    forum = prevState.entities.forums[action.forumId];

				forum.isSubscribed = action.follow;
				var entitiesForum = {
					forums: Object.assign({}, prevEntitiesForum, searchresult__defineProperty({}, action.forumId, forum))
				};
				return Object.assign({}, prevState, entitiesForum);
			}
			return prevState;

		case ForumviewActions["f" /* THREAD_FOLLOWING */]:
			var prevEntitiesThread = {},
			    thread = {},
			    entities = '';
			if (prevState.entities.topics && prevState.entities.topics[action.threadId]) {
				entities = 'topics';
			} else if (prevState.entities.sticky && prevState.entities.sticky[action.threadId]) {
				entities = 'sticky';
			} else {
				return prevState;
			}

			prevEntitiesThread = prevState.entities[entities];
			thread = prevState.entities[entities][action.threadId];

			thread.isSubscribed = action.follow;
			var entitiesThreads = searchresult__defineProperty({}, entities, Object.assign({}, prevEntitiesThread, searchresult__defineProperty({}, action.threadId, thread)));
			return Object.assign({}, prevState, entitiesThreads);

		default:
			return prevState;
	}
}
// CONCATENATED MODULE: ./src/reducers/searchresult.js

// EXTERNAL MODULE: ./src/actions/UiActions.js
var UiActions = __webpack_require__(10);

// EXTERNAL MODULE: ./src/actions/AttachmentsActions.js
var AttachmentsActions = __webpack_require__(237);

// EXTERNAL MODULE: ./src/actions/UserSettingsActions.js
var UserSettingsActions = __webpack_require__(26);

// CONCATENATED MODULE: ./src/reducers/ui.js
var ui__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function ui__toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }









var currentSettings = Object(UserSettingsActions["e" /* getSavedUserSettings */])();

var ui_initialState = {
	sidebarOpened: false,
	searchBarOpened: false,
	headerOverflowOpened: false,
	loginModalOpened: false,
	confirmModalOpened: false,
	confirmModalOptions: {
		header: "",
		text: "",
		action: null,
		onCancel: null
	},
	globalLoading: "",
	replyModal: {
		opened: false,
		loading: false,
		options: {},
		responseHash: {},
		attachments: [],
		attachmentLoading: false
	},
	userModal: {
		opened: false,
		path: [],
		user: {}
	},
	shareModal: {
		opened: false
	},
	userSettings: {
		showAttachmentsPreview: currentSettings && currentSettings.showAttachmentsPreview !== null ? currentSettings.showAttachmentsPreview : true,
		styleTheme: currentSettings && currentSettings.styleTheme ? currentSettings.styleTheme : 'light',
		loadingBehavior: currentSettings && currentSettings.loadingBehavior ? currentSettings.loadingBehavior : 'oldest',
		onlineUsersLoadingBehavior: currentSettings && currentSettings.onlineUsersLoadingBehavior ? currentSettings.onlineUsersLoadingBehavior : 'az',
		fontSize: currentSettings && currentSettings.fontSize ? currentSettings.fontSize : 'normal',
		pageSize: currentSettings && currentSettings.pageSize ? currentSettings.pageSize : 10,
		landingPage: Object(UserSettingsActions["b" /* fixLandingPage */])(currentSettings && currentSettings.landingPage ? currentSettings.landingPage : 'index'),
		timestamp: currentSettings && currentSettings.timestamp ? currentSettings.timestamp : 0
	},
	iOSkeyBoardOpen: false,
	announcementsOpen: false
};

function ui() {
	var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ui_initialState;
	var action = arguments[1];

	switch (action.type) {
		case UiActions["m" /* RESET_OVERLAY */]:
			return ui__extends({}, state, {
				sidebarOpened: false,
				searchBarOpened: false,
				headerOverflowOpened: false
			});

		case UiActions["y" /* TOGGLE_SIDEBAR_ON */]:
			return ui__extends({}, state, {
				sidebarOpened: true,
				searchBarOpened: false,
				headerOverflowOpened: false
			});

		case UiActions["x" /* TOGGLE_SIDEBAR_OFF */]:
			return ui__extends({}, state, {
				sidebarOpened: false,
				searchBarOpened: false,
				headerOverflowOpened: false
			});

		case UiActions["w" /* TOGGLE_SEARCHBAR */]:
			return ui__extends({}, state, {
				searchBarOpened: !state.searchBarOpened,
				sidebarOpened: false,
				headerOverflowOpened: false
			});

		case UiActions["v" /* TOGGLE_HEADER_OVERFLOW */]:
			return ui__extends({}, state, {
				headerOverflowOpened: !state.headerOverflowOpened,
				sidebarOpened: false,
				searchBarOpened: false
			});

		case UiActions["p" /* SHOW_LOGIN_MODAL */]:
			return ui__extends({}, state, {
				loginModalOpened: true,
				sidebarOpened: false,
				searchBarOpened: false,
				headerOverflowOpened: false
			});

		case UiActions["e" /* HIDE_LOGIN_MODAL */]:
			return ui__extends({}, state, {
				loginModalOpened: false
			});

		case UiActions["n" /* SHOW_CONFIRM_MODAL */]:
			return ui__extends({}, state, {
				confirmModalOpened: true,
				confirmModalOptions: {
					header: action.header,
					text: action.text,
					action: action.action
				}
			});

		case UiActions["c" /* HIDE_CONFIRM_MODAL */]:
			return ui__extends({}, state, {
				confirmModalOpened: false,
				confirmModalOptions: {
					header: "",
					text: "",
					action: null,
					onCancel: null
				}
			});

		case UiActions["o" /* SHOW_GLOBAL_LOADING */]:
			return ui__extends({}, state, {
				headerOverflowOpened: false,
				globalLoading: action.text || 'Loading'
			});

		case UiActions["d" /* HIDE_GLOBAL_LOADING */]:
			return ui__extends({}, state, {
				globalLoading: ""
			});

		case UiActions["q" /* SHOW_REPLY_MODAL */]:
			return ui__extends({}, state, {
				replyModal: ui__extends({}, state.replyModal, {
					opened: true,
					loading: false,
					options: action.options
				})
			});

		case UiActions["f" /* HIDE_REPLY_MODAL */]:
			return ui__extends({}, state, {
				replyModal: ui__extends({}, state.replyModal, {
					opened: false,
					loading: false,
					options: {},
					responseHash: {},
					attachments: [],
					attachmentLoading: false
				})
			});
		case UiActions["s" /* SHOW_REPLY_MODAL_LOADER */]:
			return ui__extends({}, state, {
				replyModal: ui__extends({}, state.replyModal, {
					loading: true
				})
			});

		case UiActions["h" /* HIDE_REPLY_MODAL_LOADER */]:
			return ui__extends({}, state, {
				replyModal: ui__extends({}, state.replyModal, {
					loading: false
				})
			});

		case AttachmentsActions["c" /* SET_POST_HASH */]:
			return ui__extends({}, state, {
				replyModal: ui__extends({}, state.replyModal, {
					responseHash: action.responseHash
				})
			});

		case AttachmentsActions["b" /* SET_POST_ATTACHMENT */]:
			return ui__extends({}, state, {
				replyModal: ui__extends({}, state.replyModal, {
					attachments: [].concat(ui__toConsumableArray(state.replyModal.attachments), ui__toConsumableArray(action.attachments))
				})
			});

		case AttachmentsActions["a" /* REMOVE_POST_ATTACHMENT */]:
			var attachments = state.replyModal.attachments.filter(function (attachment) {
				return attachment.id !== parseInt(action.id);
			});
			var responseHash = void 0;
			if (attachments.length === 0) {
				responseHash = {};
			} else {
				responseHash = state.replyModal.responseHash;
			}
			return ui__extends({}, state, {
				replyModal: ui__extends({}, state.replyModal, {
					responseHash: responseHash,
					attachments: attachments
				})
			});

		case UiActions["r" /* SHOW_REPLY_MODAL_ATTACHMENT_LOADER */]:
			return ui__extends({}, state, {
				replyModal: ui__extends({}, state.replyModal, {
					attachmentLoading: true
				})
			});

		case UiActions["g" /* HIDE_REPLY_MODAL_ATTACHMENT_LOADER */]:
			return ui__extends({}, state, {
				replyModal: ui__extends({}, state.replyModal, {
					attachmentLoading: false
				})
			});

		case UiActions["u" /* SHOW_USER_MODAL */]:
			return ui__extends({}, state, {
				userModal: ui__extends({}, state.userModal, {
					opened: true,
					path: action.path,
					user: action.user
				})
			});

		case UiActions["j" /* HIDE_USER_MODAL */]:
			return ui__extends({}, state, {
				userModal: ui__extends({}, state.userModal, {
					opened: false
				})
			});

		case UserSettingsActions["a" /* CHANGE_USER_SETTINGS */]:
			return ui__extends({}, state, {
				userSettings: ui__extends({}, state.userSettings, action.userSettings)
			});

		case UiActions["t" /* SHOW_SHARE_MODAL */]:
			return ui__extends({}, state, {
				shareModal: {
					opened: true
				}
			});

		case UiActions["i" /* HIDE_SHARE_MODAL */]:
			return ui__extends({}, state, {
				shareModal: {
					opened: false
				}
			});

		case UiActions["l" /* OPEN_IOS_KEYBOARD */]:
			return ui__extends({}, state, {
				iOSkeyBoardOpen: true
			});

		case UiActions["b" /* CLOSE_IOS_KEYBOARD */]:
			return ui__extends({}, state, {
				iOSkeyBoardOpen: false
			});

		case UiActions["k" /* OPEN_ANNOUNCEMENTS */]:
			return ui__extends({}, state, {
				announcementsOpen: true
			});

		case UiActions["a" /* CLOSE_ANNOUNCEMENTS */]:
			return ui__extends({}, state, {
				announcementsOpen: false
			});

		default:
			return state;
	}
}
// CONCATENATED MODULE: ./src/reducers/userprofile.js
function userprofile__toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }






var userprofile_initialState = {
	isFetching: false,
	loaded: false,
	lastError: '',
	entities: {},
	pages: [],
	user: {
		id: null,
		avatar: ''
	},
	result: {
		posts: [],
		topics: []
	},
	page: 1
};

function userprofileview() {
	var prevState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : userprofile_initialState;
	var action = arguments[1];

	switch (action.type) {
		case UserprofileActions["c" /* USERPROFILE_FETCH */]:
			return Object.assign({}, prevState, {
				isFetching: true,
				// Only set loaded to false if we are doing a full refresh
				loaded: !(action.user.loadingBehavior === InfiniteScrollActions["b" /* LOADING_BEHAVIOR */].REFRESH)
			});

		case UserprofileActions["d" /* USERPROFILE_SUCCESS */]:
			var user = action.user.id ? action.data.entities.users[parseInt(action.user.id)] : prevState.user;

			if (parseInt(prevState.user.id) !== parseInt(action.user.id) || action.user.loadingBehavior === InfiniteScrollActions["b" /* LOADING_BEHAVIOR */].REFRESH) {
				return merge_default()({}, action.data, { user: user }, {
					isFetching: false,
					loaded: true,
					firstLoad: true,
					pages: [parseInt(action.data.page)]
				});
			} else {
				var postsResult = void 0,
				    topicsResult = void 0,
				    usersResult = void 0,
				    pages = void 0;

				if (action.user.loadingBehavior === InfiniteScrollActions["b" /* LOADING_BEHAVIOR */].PREPEND) {
					postsResult = union_default()(action.data.result.posts, prevState.result.posts);
					topicsResult = union_default()(action.data.result.topics, prevState.result.topics);
					usersResult = union_default()(action.data.result.users, prevState.result.users);
					pages = [parseInt(action.data.page)].concat(userprofile__toConsumableArray(prevState.pages));
				} else if (action.user.loadingBehavior === InfiniteScrollActions["b" /* LOADING_BEHAVIOR */].APPEND) {
					postsResult = union_default()(prevState.result.posts, action.data.result.posts);
					topicsResult = union_default()(prevState.result.topics, action.data.result.topics);
					usersResult = union_default()(prevState.result.users, action.data.result.users);
					pages = [].concat(userprofile__toConsumableArray(prevState.pages), [parseInt(action.data.page)]);
				}

				return merge_default()({}, prevState, action.data, { user: user }, {
					isFetching: false,
					loaded: true,
					firstLoad: false
				}, {
					pages: pages,
					result: {
						posts: postsResult,
						topics: topicsResult,
						users: usersResult
					}
				});
			}

		case UserprofileActions["a" /* RESET_USERPROFILE */]:
			return userprofile_initialState;

		case UserprofileActions["b" /* USERPROFILE_FAILURE */]:
			return Object.assign({}, prevState, {
				lastError: action.error
			});

		default:
			return prevState;
	}
}
// EXTERNAL MODULE: ./src/actions/PhotoGalleryActions.js
var PhotoGalleryActions = __webpack_require__(86);

// EXTERNAL MODULE: ./node_modules/lodash/last.js
var last = __webpack_require__(863);
var last_default = /*#__PURE__*/__webpack_require__.n(last);

// CONCATENATED MODULE: ./src/reducers/photogallery.js
var photogallery__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function photogallery__toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function photogallery__defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




var photogallery_initialState = {
	items: {},
	postId: null,
	isOpen: false,
	options: {
		shareButtons: [{ id: 'facebook', label: 'Share on Facebook', url: 'https://www.facebook.com/sharer/sharer.php?u={{url}}' }, { id: 'twitter', label: 'Tweet', url: 'https://twitter.com/intent/tweet?text={{text}}&url={{url}}' }, { id: 'download', label: 'Download image', url: '{{raw_image_url}}', download: true }],
		closeOnScroll: true,
		closeOnVerticalDrag: true
	}
};

function photogallery() {
	var prevState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : photogallery_initialState;
	var action = arguments[1];

	var prevStateItems = prevState.items,
	    items = {};
	switch (action.type) {
		case PhotoGalleryActions["a" /* ADD_PHOTO */]:
			var prevItems = prevStateItems[action.item.postId];

			if (prevItems === undefined) {
				items = Object.assign({}, prevStateItems, photogallery__defineProperty({}, action.item.postId, [photogallery__extends({}, action.item, {
					index: 0
				})]));
			} else if (prevItems.find(function (item) {
				return item.id === action.item.id;
			})) {
				// skip duplicates
				return prevState;
			} else {
				var lastItem = last_default()(prevItems),
				    lastIndex = lastItem.index;
				items = Object.assign({}, prevStateItems, photogallery__defineProperty({}, action.item.postId, [].concat(photogallery__toConsumableArray(prevItems), [photogallery__extends({}, action.item, {
					index: lastIndex + 1
				})])));
			}
			return photogallery__extends({}, prevState, {
				items: items
			});

		case PhotoGalleryActions["c" /* REMOVE_PHOTO */]:
			items = prevStateItems;
			delete items[action.item.postId];
			return photogallery__extends({}, prevState, {
				items: items
			});

		case PhotoGalleryActions["e" /* SHOW_GALLERY */]:
			return photogallery__extends({}, prevState, {
				postId: action.postId,
				options: Object.assign(prevState.options, action.options),
				isOpen: true
			});

		case PhotoGalleryActions["b" /* HIDE_GALLERY */]:
			return photogallery__extends({}, prevState, {
				postId: null,
				isOpen: false
			});

		case PhotoGalleryActions["d" /* RESET_GALLERY */]:
			return photogallery_initialState;

		default:
			return prevState;
	}
}
// EXTERNAL MODULE: ./common/actions/OnlineUsersActions.js
var actions_OnlineUsersActions = __webpack_require__(224);

// CONCATENATED MODULE: ./common/reducers/onlineUsers.js
var onlineUsers__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function onlineUsers__toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }






var onlineUsers_initialState = {
	entities: {},
	result: {
		users: [],
		online: []
	},
	page: 0,
	totals: {
		members: 0,
		guests: 0
	},
	isFetching: false,
	loaded: false,
	pages: []
};

function onlineUsers() {
	var prevState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : onlineUsers_initialState;
	var action = arguments[1];


	switch (action.type) {
		case actions_OnlineUsersActions["a" /* FETCH_ONLINE_USERS */]:
			return onlineUsers__extends({}, prevState, {
				isFetching: true,
				loaded: !(action.loadingBehavior === actions_InfiniteScrollActions["c" /* LOADING_BEHAVIOR */].REFRESH)
			});

		case actions_OnlineUsersActions["b" /* FETCH_ONLINE_USERS_SUCCESS */]:
			if (action.loadingBehavior === actions_InfiniteScrollActions["c" /* LOADING_BEHAVIOR */].REFRESH) {
				return onlineUsers__extends({}, prevState, action.data, {
					isFetching: false,
					loaded: true,
					pages: [action.data.page]
				});
			} else {
				var pages = void 0,
				    online = void 0;
				if (action.loadingBehavior === actions_InfiniteScrollActions["c" /* LOADING_BEHAVIOR */].PREPEND) {
					online = [].concat(onlineUsers__toConsumableArray(action.data.result.online), onlineUsers__toConsumableArray(prevState.result.online));
					pages = [action.data.page].concat(onlineUsers__toConsumableArray(prevState.pages));
				} else {
					online = [].concat(onlineUsers__toConsumableArray(prevState.result.online), onlineUsers__toConsumableArray(action.data.result.online));
					pages = [].concat(onlineUsers__toConsumableArray(prevState.pages), [action.data.page]);
				}
				return merge_default()({}, prevState, action.data, {
					result: {
						users: prevState.users,
						online: online
					},
					isFetching: false,
					loaded: true,
					pages: pages
				});
			}

		case actions_OnlineUsersActions["c" /* RESET_ONLINE_USERS */]:
			return onlineUsers_initialState;

		default:
			return prevState;
	}
};
// CONCATENATED MODULE: ./src/reducers/onlineUsers.js

// CONCATENATED MODULE: ./src/reducers/releaseNotes.js
var releaseNotes__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function releaseNotes__toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }






var releaseNotes_initialState = {
	entities: {},
	result: {
		notes: []
	},
	page: 0,
	isFetching: false,
	loaded: false,
	pages: []
};

var releaseNotes_releaseNotes = function releaseNotes() {
	var prevState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : releaseNotes_initialState;
	var action = arguments[1];


	switch (action.type) {
		case ReleaseNotesActions["a" /* FETCH_RELEASE_NOTES */]:
			return releaseNotes__extends({}, prevState, {
				isFetching: true,
				loaded: !(action.loadingBehavior === InfiniteScrollActions["b" /* LOADING_BEHAVIOR */].REFRESH)
			});

		case ReleaseNotesActions["b" /* FETCH_RELEASE_NOTES_SUCCESS */]:
			if (action.loadingBehavior === InfiniteScrollActions["b" /* LOADING_BEHAVIOR */].REFRESH) {
				return releaseNotes__extends({}, prevState, action.data, {
					isFetching: false,
					loaded: true,
					pages: [parseInt(action.data.page)]
				});
			} else {
				var pages = void 0,
				    notes = void 0;
				if (action.loadingBehavior === InfiniteScrollActions["b" /* LOADING_BEHAVIOR */].PREPEND) {
					notes = [].concat(releaseNotes__toConsumableArray(action.data.result.notes), releaseNotes__toConsumableArray(prevState.result.notes));
					pages = [action.data.page].concat(releaseNotes__toConsumableArray(prevState.pages));
				} else {
					notes = [].concat(releaseNotes__toConsumableArray(prevState.result.notes), releaseNotes__toConsumableArray(action.data.result.notes));
					pages = [].concat(releaseNotes__toConsumableArray(prevState.pages), [action.data.page]);
				}
				return merge_default()({}, prevState, action.data, {
					result: {
						notes: notes
					},
					isFetching: false,
					loaded: true,
					pages: pages
				});
			}

		case ReleaseNotesActions["c" /* RESET_RELEASE_NOTES */]:
			return releaseNotes_initialState;

		default:
			return prevState;
	}
};
// CONCATENATED MODULE: ./src/reducers/portalpage.js


var portalpage_initialState = {
	isFetching: false,
	loaded: false,
	lastError: '',
	entities: {},
	result: {}
};

function portalpage() {
	var prevState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : portalpage_initialState;
	var action = arguments[1];

	switch (action.type) {
		case PortalPageActions["b" /* PORTALPAGE_FETCH */]:
			return Object.assign({}, prevState, {
				isFetching: true,
				// Only set loaded to false if we are doing a full refresh
				loaded: false
			});

		case PortalPageActions["d" /* PORTALPAGE_SUCCESS */]:
			return Object.assign({}, action.data, {
				isFetching: false,
				loaded: true
			});
		case PortalPageActions["a" /* PORTALPAGE_FAILURE */]:
			return Object.assign({}, prevState, {
				lastError: action.error
			});

		case PortalPageActions["c" /* PORTALPAGE_RESET */]:
			return portalpage_initialState;

		default:
			return prevState;
	}
}
// CONCATENATED MODULE: ./src/reducers/widgetReducer.js
function widgetReducer__defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





var widgetReducer_initialState = {
	widgets: {}
},
    widgetInitialState = {
	name: 'w1',
	isFetching: false,
	loaded: false,
	refresh: 0, // Triggers widget refresh
	beenUpdated: 0, // Indicates update in data
	lastError: '',
	itemId: 0,
	entities: {},
	result: {
		forums: [],
		posts: [],
		topics: [],
		users: [],
		pms: [],
		pmfolders: [],
		attachments: []
	},
	otherParams: {}
};

function widgetState() {
	var prevState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : widgetReducer_initialState;
	var action = arguments[1];

	var newState = prevState,
	    newWidgets = Object.assign({}, prevState.widgets),
	    widget = {},
	    newUpdate = new Date().getTime();

	switch (action.type) {
		case WidgetActions["c" /* WIDGET_FETCH */]:
			widget = Object.assign({}, widgetInitialState, {
				name: action.name,
				loaded: false,
				isFetching: true
			});

			if (newWidgets[action.name]) {
				widget = Object.assign({}, newWidgets[action.name], {
					loaded: true,
					isFetching: true,
					lastError: ''
				});
			}

			newWidgets[action.name] = widget;
			return Object.assign({}, prevState, { widgets: newWidgets });

		case WidgetActions["f" /* WIDGET_SUCCESS */]:
			newWidgets[action.name] = Object.assign({}, widgetInitialState, action.data, {
				name: action.name,
				loaded: true,
				isFetching: false
			});

			return Object.assign({}, prevState, { widgets: newWidgets });

		case WidgetActions["a" /* WIDGET_DELETE */]:
			// delete the widget if it's in the state
			if (newWidgets[action.name]) {
				delete newWidgets[action.name];
				newState = Object.assign({}, prevState, { widgets: newWidgets });
			}

			return newState;

		case WidgetActions["d" /* WIDGET_REFRESH */]:
			if (action.name === '') {
				// refresh all
				Object.keys(newWidgets).forEach(function (w) {
					if (newWidgets[w].isFetching === false) {
						// skip if we are fetching
						newWidgets[w] = Object.assign({}, newWidgets[w], {
							refresh: newUpdate,
							isFetching: true
						});
					}
				});

				return Object.assign({}, prevState, { widgets: newWidgets });
			} else if (action.name && newWidgets[action.name]) {
				// refresh passed widget by name
				if (newWidgets[action.name].isFetching === false) {
					// skip if we are fetching
					newWidgets[action.name] = Object.assign({}, newWidgets[action.name], {
						refresh: newUpdate,
						isFetching: true
					});
				}

				return Object.assign({}, prevState, { widgets: newWidgets });
			}

			return prevState;

		case WidgetActions["e" /* WIDGET_RESET_ALL */]:
			return widgetReducer_initialState;

		case WidgetActions["b" /* WIDGET_FAILURE */]:
			newWidgets[action.name] = Object.assign({}, widgetInitialState, action.data, {
				name: action.name,
				loaded: false,
				isFetching: false,
				lastError: action.error
			});

			return Object.assign({}, prevState, { widgets: newWidgets });

		//Supporting Follow/UnFollow threads and forums
		case actions_ForumviewActions["b" /* FORUM_FOLLOWING */]:
			Object.keys(newWidgets).forEach(function (w) {
				var prevEntitiesForum = newWidgets[w].entities.forums,
				    forum = newWidgets[w].entities.forums[action.forumId];

				forum.isSubscribed = action.follow;
				var entitiesForum = {
					forums: Object.assign({}, prevEntitiesForum, widgetReducer__defineProperty({}, action.forumId, forum)),
					beenUpdated: newUpdate
				};
				newWidgets[w] = Object.assign({}, newWidgets[w], entitiesForum);
			});

			return Object.assign({}, prevState, { widgets: newWidgets });

		case actions_ForumviewActions["d" /* THREAD_FOLLOWING */]:
			var prevEntitiesThread = {},
			    thread = {},
			    entities = true;
			Object.keys(newWidgets).forEach(function (w) {
				entities = true;
				if (newWidgets[w].entities.topics && newWidgets[w].entities.topics[action.threadId]) {
					entities = 'topics';
				} else if (newWidgets[w].entities.sticky && newWidgets[w].entities.sticky[action.threadId]) {
					entities = 'sticky';
				} else {
					entities = false;
				}
				if (entities) {
					var _entitiesThreads;

					prevEntitiesThread = newWidgets[w].entities[entities];
					thread = newWidgets[w].entities[entities][action.threadId];
					thread.isSubscribed = action.follow;

					var entitiesThreads = (_entitiesThreads = {}, widgetReducer__defineProperty(_entitiesThreads, entities, Object.assign({}, prevEntitiesThread, widgetReducer__defineProperty({}, action.threadId, thread))), widgetReducer__defineProperty(_entitiesThreads, 'beenUpdated', newUpdate), _entitiesThreads);
					newWidgets[w] = Object.assign({}, newWidgets[w], entitiesThreads);
				}
			});

			return Object.assign({}, prevState, { widgets: newWidgets });

		default:
			return prevState;
	}
}
// CONCATENATED MODULE: ./src/reducers/index.js





















var rootReducer = Object(es["c" /* combineReducers */])({
	ads: ads,
	forumview: forumview,
	infiniteScroll: infiniteScroll,
	meta: meta,
	ustate: ustate,
	threadview: threadview,
	messagesview: messagesview,
	notices: notices,
	topifyPresets: topifyPresets,
	routing: lib["routerReducer"],
	searchresult: searchresult,
	ui: ui,
	userprofileview: userprofileview,
	photogallery: photogallery,
	onlineUsers: onlineUsers,
	releaseNotes: releaseNotes_releaseNotes,
	portalpage: portalpage,
	widgetState: widgetState
});

/* harmony default export */ var reducers = (rootReducer);
// CONCATENATED MODULE: ./src/store/configureStore.dist.js
/* harmony export (immutable) */ __webpack_exports__["default"] = configureStore;






var finalCreateStore = Object(es["d" /* compose */])(Object(es["a" /* applyMiddleware */])(redux_thunk_lib_default.a), Object(es["a" /* applyMiddleware */])(Object(lib["routerMiddleware"])(react_router_es["f" /* hashHistory */])))(es["e" /* createStore */]);

function configureStore(initialState) {
	return finalCreateStore(reducers, initialState);
}

/***/ }),

/***/ 86:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ADD_PHOTO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return SHOW_GALLERY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return HIDE_GALLERY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return REMOVE_PHOTO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return RESET_GALLERY; });
/* harmony export (immutable) */ __webpack_exports__["f"] = addPhoto;
/* unused harmony export removePhoto */
/* harmony export (immutable) */ __webpack_exports__["i"] = showGallery;
/* harmony export (immutable) */ __webpack_exports__["g"] = hideGallery;
/* harmony export (immutable) */ __webpack_exports__["h"] = resetGallery;
var ADD_PHOTO = 'ADD_PHOTO';
var SHOW_GALLERY = 'SHOW_GALLERY';
var HIDE_GALLERY = 'HIDE_GALLERY';
var REMOVE_PHOTO = 'REMOVE_PHOTO';
var RESET_GALLERY = 'RESET_GALLERY';

function addPhoto(item) {
	return {
		type: ADD_PHOTO,
		item: item
	};
}

function removePhoto(item) {
	return {
		type: REMOVE_PHOTO,
		item: item
	};
}

function showGallery(options, postId) {
	return {
		type: SHOW_GALLERY,
		postId: postId,
		options: options
	};
}

function hideGallery() {
	return {
		type: HIDE_GALLERY
	};
}

function resetGallery() {
	return {
		type: RESET_GALLERY
	};
}

/***/ }),

/***/ 87:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return USERPROFILE_FETCH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return USERPROFILE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return USERPROFILE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RESET_USERPROFILE; });
/* unused harmony export requestUserProfile */
/* unused harmony export receiveUserProfile */
/* unused harmony export failedUserProfile */
/* harmony export (immutable) */ __webpack_exports__["f"] = resetUserProfile;
/* harmony export (immutable) */ __webpack_exports__["e"] = fetchUserProfile;
/* harmony export (immutable) */ __webpack_exports__["h"] = uploadAvatar;
/* harmony export (immutable) */ __webpack_exports__["g"] = saveUserCP;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_Actions_UstateActions__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_Actions_MetaActions__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_Actions_GlobalMetaActions__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_Actions_InfiniteScrollActions__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_Actions_UiActions__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_Actions_UserSettingsActions__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_Actions_adsActions__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_Actions_responseNormalizer__ = __webpack_require__(64);











var USERPROFILE_FETCH = 'USERPROFILE_FETCH';
var USERPROFILE_SUCCESS = 'USERPROFILE_SUCCESS';
var USERPROFILE_FAILURE = 'USERPROFILE_FAILURE';
var RESET_USERPROFILE = 'RESET_USERPROFILE';

function requestUserProfile(user) {
	return {
		type: USERPROFILE_FETCH,
		user: user
	};
}

function receiveUserProfile(user, data) {
	return {
		type: USERPROFILE_SUCCESS,
		user: user,
		data: data
	};
}

function failedUserProfile(user, error) {
	return {
		type: USERPROFILE_FAILURE,
		user: user,
		error: error
	};
}

function resetUserProfile() {
	return {
		type: RESET_USERPROFILE
	};
}

function fetchUserProfile(userRequest) {
	var cacheBust = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;


	return function (dispatch, getState) {

		userRequest.loadingBehavior = Object(__WEBPACK_IMPORTED_MODULE_4_Actions_InfiniteScrollActions__["e" /* getLoadingBehavior */])(getState, userRequest.id, "userprofile", userRequest.page, userRequest.forceRefresh);

		if (Object(__WEBPACK_IMPORTED_MODULE_4_Actions_InfiniteScrollActions__["g" /* shouldNotUpdateState */])(getState, userRequest)) {
			dispatch(Object(__WEBPACK_IMPORTED_MODULE_4_Actions_InfiniteScrollActions__["i" /* updatePagesResult */])(userRequest.page || 1));
			return null;
		}

		dispatch(requestUserProfile(userRequest));
		var state = getState();
		var url = state.topifyPresets.forumSite.url;

		var id = userRequest.id ? '&id=' + userRequest.id : '',
		    userID = state.ustate.id ? state.ustate.id : 0;

		// Avoid Cache if cacheBust is required
		var fetchConfig = dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_Actions_GlobalMetaActions__["e" /* getFetchConfig */])(cacheBust)),
		    cacheBustQueryString = '&_=' + (cacheBust ? cacheBust : Object(__WEBPACK_IMPORTED_MODULE_2_Actions_MetaActions__["a" /* getCacheBuster */])(getState) || 0),
		    lb = Object(__WEBPACK_IMPORTED_MODULE_6_Actions_UserSettingsActions__["f" /* mapLoadingBehaviour */])(state.ui.userSettings.loadingBehavior),
		    page_size = dispatch(Object(__WEBPACK_IMPORTED_MODULE_6_Actions_UserSettingsActions__["d" /* getPageSize */])());

		return fetch(url + ('?v=3.0&ajax=1&uid=' + userID + '&req=userprofile' + id + '&pagesize=' + page_size + '&page=' + userRequest.page + '&lb=' + lb + cacheBustQueryString), fetchConfig).then(function (response) {
			if (!response.ok) {
				try {
					response.json().then(function (json) {
						Object(__WEBPACK_IMPORTED_MODULE_3_Actions_GlobalMetaActions__["j" /* setGlobalNotification */])(dispatch, json, response);
					});
				} catch (e) {
					Object(__WEBPACK_IMPORTED_MODULE_3_Actions_GlobalMetaActions__["j" /* setGlobalNotification */])(dispatch, {}, response);
				}

				dispatch(failedUserProfile(userRequest, 'Bad response from server'));
				dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_Actions_GlobalMetaActions__["b" /* backInHistory */])());
			} else {
				response.json().then(function (json) {

					Object(__WEBPACK_IMPORTED_MODULE_3_Actions_GlobalMetaActions__["j" /* setGlobalNotification */])(dispatch, json, { ok: true });

					var other = Object.assign({}, { page: userRequest.page }, json.forumUser ? json.forumUser.meta : {});

					var result = Object(__WEBPACK_IMPORTED_MODULE_8_Actions_responseNormalizer__["a" /* responseNormalizer */])(json, userRequest.page, other);

					var forumTitle = state.topifyPresets.forumSite.f_title;

					var title = userRequest.cp === true ? 'User Control Panel' : (json.ustate && json.ustate.id && parseInt(userRequest.id) === parseInt(json.ustate.id) ? "My" : "User") + " Profile";

					dispatch(Object(__WEBPACK_IMPORTED_MODULE_2_Actions_MetaActions__["b" /* receiveGlobalMeta */])(json.forumUser.meta, title, forumTitle));

					dispatch(Object(__WEBPACK_IMPORTED_MODULE_8_Actions_responseNormalizer__["b" /* updateUstate */])(json, result));

					// If we searched by userName instead of id
					if (typeof userRequest.id === 'string') {
						for (var user in result.entities.users) {
							if (result.entities.users[user].userName === userRequest.id) {
								userRequest.id = user;
								break;
							}
						}
					}

					dispatch(Object(__WEBPACK_IMPORTED_MODULE_4_Actions_InfiniteScrollActions__["d" /* fetchSuccess */])(userRequest.id, "userprofile", userRequest.page, result.totalPages, userRequest.loadingBehavior));
					dispatch(receiveUserProfile(userRequest, result));
				});
			}
		}).then(function () {
			Object(__WEBPACK_IMPORTED_MODULE_3_Actions_GlobalMetaActions__["k" /* setLastGlobalAction */])('userprofile', userRequest);
		}).catch(function (error) {
			Object(__WEBPACK_IMPORTED_MODULE_3_Actions_GlobalMetaActions__["j" /* setGlobalNotification */])(dispatch, {}, error);
			dispatch(resetUserProfile(userRequest, 'Bad response from server'));
			dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_Actions_GlobalMetaActions__["b" /* backInHistory */])());
		});
	};
}

function uploadAvatar(data) {
	return function (dispatch, getState) {
		dispatch(Object(__WEBPACK_IMPORTED_MODULE_5_Actions_UiActions__["O" /* showGlobalLoading */])('Saving avatar'));

		var state = getState(),
		    url = state.topifyPresets.forumSite.url,
		    userID = state.ustate.id ? state.ustate.id : 0,
		    config = dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_Actions_GlobalMetaActions__["e" /* getFetchConfig */])(true, 'POST', data, false));

		return new Promise(function (resolve, reject) {
			return fetch(url + '?v=3.0&ajax=1&uid=' + userID + '&req=post&type=uploadavatar', config).then(function (response) {

				dispatch(Object(__WEBPACK_IMPORTED_MODULE_5_Actions_UiActions__["D" /* hideGlobalLoading */])());

				if (!response.ok) {
					response.json().then(function (json) {
						// Record the Google Analytics event.
						dispatch(Object(__WEBPACK_IMPORTED_MODULE_7_Actions_adsActions__["A" /* trackGAEvent */])(false, 'avatarUploadFailed', 'error', 'system'));

						Object(__WEBPACK_IMPORTED_MODULE_3_Actions_GlobalMetaActions__["j" /* setGlobalNotification */])(dispatch, json, response);
						resolve(function () {
							return {};
						});
					});
				} else {
					response.json().then(function (json) {
						Object(__WEBPACK_IMPORTED_MODULE_5_Actions_UiActions__["B" /* displayNotification */])('success', 'The avatar was successfully uploaded', { timeout: 1000 });
						dispatch(Object(__WEBPACK_IMPORTED_MODULE_2_Actions_MetaActions__["d" /* setCacheBuster */])(new Date().getTime()));

						if (json.forumUser.data[0]) {
							var currentUser = json.forumUser.data[0],
							    new_ustate = Object.assign({}, json.ustate, { userName: currentUser.userName, avatar: currentUser.avatar, online: currentUser.online, lastActivity: currentUser.lastActivity });

							dispatch(Object(__WEBPACK_IMPORTED_MODULE_1_Actions_UstateActions__["a" /* receiveCurrentUser */])(new_ustate));

							// Record the Google Analytics event.
							dispatch(Object(__WEBPACK_IMPORTED_MODULE_7_Actions_adsActions__["A" /* trackGAEvent */])(false, 'uploadAvatar', 'userAction', 'userCP'));

							return resolve(function () {
								return {
									result: true,
									avatar: json.forumUser.data[0].avatar
								};
							});
						} else {
							return resolve(function () {
								return {
									result: false
								};
							});
						}
					});
				}
			});
		});
	};
}

function saveUserCP(settings) {
	return function (dispatch, getState) {
		var state = getState(),
		    url = state.topifyPresets.forumSite.url,
		    userID = state.ustate.id ? state.ustate.id : 0;

		var fields = [],
		    body = null;

		// Create the body with the fields passed
		if (Array.isArray(settings) && settings.length) {
			settings.forEach(function (el) {
				fields.push(el.join('='));
			});

			if (fields.length) {
				body = fields.join('&');
			}
		}

		var config = dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_Actions_GlobalMetaActions__["e" /* getFetchConfig */])(true, 'POST', body));

		return new Promise(function (resolve, reject) {
			return fetch(url + '?v=3.0&ajax=1&uid=' + userID + '&req=post&type=saveusercp', config).then(function (response) {

				if (!response.ok) {
					response.json().then(function (json) {
						// Record the Google Analytics event.
						dispatch(Object(__WEBPACK_IMPORTED_MODULE_7_Actions_adsActions__["A" /* trackGAEvent */])(false, 'saveUserCP_' + settings.field, 'error', 'system'));

						Object(__WEBPACK_IMPORTED_MODULE_3_Actions_GlobalMetaActions__["j" /* setGlobalNotification */])(dispatch, json, response);
						return resolve(function () {
							return { result: false };
						});
					});
				} else {
					response.json().then(function (json) {
						if (json.result === false) {
							Object(__WEBPACK_IMPORTED_MODULE_3_Actions_GlobalMetaActions__["j" /* setGlobalNotification */])(dispatch, json, response);
						} else {
							Object(__WEBPACK_IMPORTED_MODULE_5_Actions_UiActions__["B" /* displayNotification */])('success', 'Setting successfully updated', { force: true, timeout: 1000 });
							dispatch(Object(__WEBPACK_IMPORTED_MODULE_2_Actions_MetaActions__["d" /* setCacheBuster */])(new Date().getTime()));
						}

						// Record the Google Analytics event.
						settings.forEach(function (field) {
							if (field[0] === 'field' && field[1]) {
								json.result === false ? dispatch(Object(__WEBPACK_IMPORTED_MODULE_7_Actions_adsActions__["A" /* trackGAEvent */])(false, 'saveUserCP_' + field[1], 'error', 'user')) : dispatch(Object(__WEBPACK_IMPORTED_MODULE_7_Actions_adsActions__["A" /* trackGAEvent */])(false, 'saveUserCP_' + field[1], 'userAction', 'userCP'));
							}
						});

						if (json.forumUser.data[0]) {
							var currentUser = json.forumUser.data[0],
							    new_ustate = Object.assign({}, json.ustate, { userName: currentUser.userName, avatar: currentUser.avatar, online: currentUser.online, lastActivity: currentUser.lastActivity });

							dispatch(Object(__WEBPACK_IMPORTED_MODULE_1_Actions_UstateActions__["a" /* receiveCurrentUser */])(new_ustate));

							return resolve(function () {
								return {
									result: true
								};
							});
						} else {
							return resolve(function () {
								return {
									result: false
								};
							});
						}
					});
				}
			});
		});
	};
}

/***/ })

},[356]);


// WEBPACK FOOTER //
// app.js